
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("f6FZF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $075445744fba52e5$export$2e2bcd8739ae039);
parcelRequire("3avtZ");

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $4f8Oj = parcelRequire("4f8Oj");

var $ebyGx = parcelRequire("ebyGx");

var $eTXmK = parcelRequire("eTXmK");

var $dGrdR = parcelRequire("dGrdR");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $9Nvh7 = parcelRequire("9Nvh7");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $3mYHL = parcelRequire("3mYHL");

var $g5X3G = parcelRequire("g5X3G");

var $hXXhf = parcelRequire("hXXhf");

var $h2eGN = parcelRequire("h2eGN");

var $4dRjY = parcelRequire("4dRjY");

var $l8ruj = parcelRequire("l8ruj");

var $5y0F0 = parcelRequire("5y0F0");
var $jDDFr = parcelRequire("jDDFr");

var $cSD7y = parcelRequire("cSD7y");

var $383Br = parcelRequire("383Br");

var $4XBWz = parcelRequire("4XBWz");
const $075445744fba52e5$var$BROWSER_METRICS_INTERACTION_APP_KEY = 'jira.project-issue-navigator';
const $075445744fba52e5$var$initInteractions = ()=>({
        pagination: {
            metrics: (0, $dGrdR.metrics).interaction({
                key: `${$075445744fba52e5$var$BROWSER_METRICS_INTERACTION_APP_KEY}.pagination.start-end.diff`
            }),
            properties: {}
        },
        refinement: {
            metrics: (0, $dGrdR.metrics).interaction({
                key: `${$075445744fba52e5$var$BROWSER_METRICS_INTERACTION_APP_KEY}.refinement.start-end.diff`
            }),
            properties: {}
        },
        filter: {
            metrics: (0, $dGrdR.metrics).interaction({
                key: `${$075445744fba52e5$var$BROWSER_METRICS_INTERACTION_APP_KEY}.filter.start-end.diff`
            }),
            properties: {}
        },
        'list-view': {
            metrics: (0, $dGrdR.metrics).interaction({
                key: `${$075445744fba52e5$var$BROWSER_METRICS_INTERACTION_APP_KEY}.list-view.start-end.diff`
            }),
            properties: {}
        },
        'split-view': {
            metrics: (0, $dGrdR.metrics).interaction({
                key: `${$075445744fba52e5$var$BROWSER_METRICS_INTERACTION_APP_KEY}.split-view.start-end.diff`
            }),
            properties: {}
        },
        'column-configuration': {
            metrics: (0, $dGrdR.metrics).interaction({
                key: `${$075445744fba52e5$var$BROWSER_METRICS_INTERACTION_APP_KEY}.column-configuration.start-end.diff`
            }),
            properties: {}
        }
    });
const $075445744fba52e5$var$MaybeNinErrorBoundary = (0, $cSD7y.componentWithFG)('improve_nin_slo_events', (0, $383Br.NinErrorBoundary), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
// eslint-disable-next-line jira/react/no-class-components
class $075445744fba52e5$var$ProjectIssueNavigatorSPAWrapper extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.view = undefined, /**
   * Update the currently selected issue in the URL.
   *
   * @param issueKey Issue key to update in the URL
   * @param isSelectedByUserInteraction True if this issue was selected by a user interaction, e.g. clicking an issue
   * in the list. This will be false if an issue was automatically selected by the app, e.g. automatically selecting
   * the first issue once the issue list has loaded.
   * @param viewActivity True to indicate the issue app should scroll to the activity feed section after opening.
   */ this.onChangeIssue = (issueKey, isSelectedByUserInteraction, viewActivity)=>{
            // Replace the history entry when an issue is auto selected by the app so we're not pushing redundant entries to
            // the history stack
            this.push({
                issueKey: issueKey,
                ...(0, $4R6GH.fg)('jsc_inline_editing_field_refactor') ? {
                    viewActivity: viewActivity
                } : {}
            }, !isSelectedByUserInteraction);
        }, /**
   * Set the currently selected view and update the selected issue in the URL if provided.
   *
   * @param newView View to update
   * @param issueKey Issue key to update in the URL
   */ this.onSetView = (newView, issueKey)=>{
            this.startInteraction((0, $eJ0Zs.convertToView)(newView));
            (0, $4R6GH.fg)('add_nin_press_interactions') && (0, $eTXmK.default)(`issue-navigator.${(0, $eJ0Zs.convertToView)(newView)}`);
            this.view = newView;
            if (issueKey !== undefined) this.push({
                issueKey: issueKey
            }, true);
        }, this.onRefinement = ()=>{
            this.startInteraction('refinement');
            (0, $4R6GH.fg)('add_nin_press_interactions') && (0, $eTXmK.default)('issue-navigator.refinement');
        }, /**
   * Callback function called when internal changes are made to PIN's state which generates new JQL.
   *
   * @param jql string The new JQL string
   * @param clearFilter boolean When true we clear the filter from url params
   */ this.onChangeJql = (jql, clearFilter = false)=>{
            this.push({
                ...clearFilter ? {
                    filter: undefined
                } : {},
                jql: jql,
                // Clear issue key from URL whenever JQL changes
                issueKey: (0, $g5X3G.toIssueKey)('')
            });
        }, this.onPageDataLoad = (selectedView)=>{
            if (selectedView !== undefined) this.view = selectedView;
            if (!this.state.initialised) this.setState({
                initialised: true
            });
            this.endInteractions();
        }, this.onStartFilterChangeInteractionIfAny = (filter)=>{
            if (this.lastFilter !== filter) {
                this.lastFilter = filter;
                if (filter != null && ((0, $9Nvh7.isFilterId)(filter) || (0, $h2eGN.isFilterKey)(filter))) {
                    this.startInteraction('filter', {
                        filterId: filter
                    });
                    (0, $4R6GH.fg)('add_nin_press_interactions') && (0, $eTXmK.default)('issue-navigator.filter');
                }
            }
        }, this.onChangeFilter = (filter)=>{
            this.push({
                ...filter ? {
                    filter: filter,
                    jql: undefined
                } : {
                    jql: undefined
                }
            }, true);
        }, this.onChangeColumnConfiguration = ()=>{
            this.startInteraction('column-configuration');
            (0, $4R6GH.fg)('add_nin_press_interactions') && (0, $eTXmK.default)('issue-navigator.column-configuration');
        }, this.startInteraction = (key, properties)=>{
            if (!this.activeInteractions.includes(key)) this.activeInteractions.push(key);
            const interaction = this.interactions[key];
            if (interaction) {
                interaction.properties = properties || {};
                interaction.metrics.start();
            }
        }, this.endInteractions = ()=>{
            this.activeInteractions.forEach((key)=>{
                this.interactions[key]?.metrics.stop({
                    customData: this.interactions[key]?.properties
                });
            });
            this.activeInteractions = [];
        }, this.getQueryStringParams = ()=>{
            const { location: location } = this.props;
            const { filter: filter, jql: jql } = (0, $ebyGx.parse)(location.search, {
                // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
                arrayFormat: 'comma'
            });
            return {
                filter: filter,
                jql: jql
            };
        };
        const { location: location } = props;
        this.locationSearchStr = location.search;
        this.activeInteractions = [];
        this.interactions = $075445744fba52e5$var$initInteractions();
        if ((0, $4R6GH.fg)('add_nin_press_interactions')) {
            // Ensure filter change event does not fire on initial loads & transitions because it
            // will cause the page load interaction to be aborted
            const { filter: filter } = this.getQueryStringParams();
            this.lastFilter = filter;
        }
        this.state = {
            initialised: false,
            issueKey: (0, $4R6GH.fg)('slv-4_migrate_nin_selected_issue_route') ? props.match?.query.selectedIssue ?? '' : props.match?.params.issueKey ?? ''
        };
    }
    componentDidUpdate(prevProps) {
        const prevIssueKey = (0, $4R6GH.fg)('slv-4_migrate_nin_selected_issue_route') ? prevProps.match?.query.selectedIssue ?? '' : prevProps.match?.params.issueKey ?? '';
        const issueKey = (0, $4R6GH.fg)('slv-4_migrate_nin_selected_issue_route') ? this.props.match?.query.selectedIssue ?? '' : this.props.match?.params.issueKey ?? '';
        // If issue key has changed from the router and does not match our internal key then update our state
        if (issueKey !== prevIssueKey && issueKey !== this.state.issueKey) this.setState({
            issueKey: issueKey
        });
    }
    push(newParams, shouldReplace = false) {
        const { match: match, push: push, location: location, replace: replace } = this.props;
        const historyAction = shouldReplace ? replace : push;
        const oldIssueKey = this.state.issueKey;
        const { projectKey: projectKey = match?.params.projectKey ?? '', issueKey: issueKey = oldIssueKey ?? '', ...params } = newParams;
        const newProjectKey = newParams.projectKey;
        const oldProjectKey = match?.params.projectKey;
        const projectKeyChanged = typeof newProjectKey !== 'undefined' && newProjectKey !== oldProjectKey;
        const newIssueKey = newParams.issueKey;
        const issueKeyParamsAreDefined = !!(newIssueKey || oldIssueKey);
        const issueKeyChanged = issueKeyParamsAreDefined && newIssueKey !== oldIssueKey;
        // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
        const query = (0, $ebyGx.parse)(location.search, {
            arrayFormat: 'comma'
        });
        const queryParamsChanged = Object.keys(params).length !== 0 && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))((0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(params, (param)=>param != null), query);
        if (projectKeyChanged || issueKeyChanged || queryParamsChanged) {
            if ((0, $4R6GH.fg)('slv-4_migrate_nin_selected_issue_route')) {
                const queryParams = {
                    ...query,
                    ...params,
                    selectedIssue: newIssueKey
                };
                if (newIssueKey == null || newIssueKey === '') delete queryParams.selectedIssue;
                // @ts-expect-error - React-resource-router's external type interface claims push/replace only accept "string", however the underlying code works with the `Location` object we're using
                historyAction({
                    pathname: `${(match && (0, $h2eGN.getUrlPrefix)(match.url)) ?? ''}/projects/${projectKey}/issues/`,
                    search: (0, $ebyGx.stringify)(queryParams, // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
                    {
                        arrayFormat: 'comma'
                    })
                });
            } else // @ts-expect-error - React-resource-router's external type interface claims push/replace only accept "string", however the underlying code works with the `Location` object we're using
            historyAction({
                pathname: `${(match && (0, $h2eGN.getUrlPrefix)(match.url)) ?? ''}/projects/${projectKey}/issues/${issueKey ?? ''}`,
                // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
                search: (0, $ebyGx.stringify)({
                    ...query,
                    ...params
                }, {
                    arrayFormat: 'comma'
                })
            });
        }
        if (issueKeyChanged) // We explicitly set this into state instead of being purely prop driven as browser history actions are not
        // re-rendered synchronously. Setting into state makes our render order more reliable.
        this.setState({
            issueKey: issueKey ?? ''
        });
        return true;
    }
    render() {
        const { match: match, location: location } = this.props;
        const { projectKey: projectKey } = match?.params ?? {};
        const params = (0, $4R6GH.fg)('add_nin_press_interactions') ? this.getQueryStringParams() : // @ts-expect-error - The "comma" option requires query-string v6.4.0 or newer. JFE currently uses v5.1.1.
        (0, $ebyGx.parse)(location.search, {
            arrayFormat: 'comma'
        });
        const { filter: filter, jql: jql } = params;
        this.onStartFilterChangeInteractionIfAny(filter);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($075445744fba52e5$var$MaybeNinErrorBoundary, {
            id: "unhandled",
            packageName: "jiraSpaAppsProjectIssueNavigator"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hXXhf.ProjectSubProductUpdater), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.default), {
            projectKey: projectKey ?? null
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4XBWz.default), {
            showNav3Header: this.props.showNav3Header,
            projectKey: (0, $g5X3G.toProjectKey)(projectKey ?? ''),
            issueKey: (0, $g5X3G.toIssueKey)(this.state.issueKey),
            jql: jql,
            onChangeIssue: this.onChangeIssue,
            onPageDataLoad: this.onPageDataLoad,
            onChangeColumnConfiguration: this.onChangeColumnConfiguration,
            onChangeJql: this.onChangeJql,
            initialised: this.state.initialised,
            onRefinement: this.onRefinement,
            onSetView: this.onSetView,
            view: this.view ? (0, $eJ0Zs.convertToView)(this.view) : undefined,
            filter: filter,
            onChangeFilter: this.onChangeFilter,
            preloadedEntryPoints: this.props.preloadedEntryPoints,
            preloadedQueries: this.props.preloadedQueries
        })));
    }
}
const $075445744fba52e5$var$ProjectIssueNavigatorSPA = ({ entryPoints: entryPoints, queries: queries })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "project-issue-navigator"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ push: push, replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDDFr.RouterSubscriber), null, ({ location: location, match: match, route: route })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($075445744fba52e5$var$ProjectIssueNavigatorSPAWrapper, {
                push: push,
                location: location,
                match: match,
                replace: replace,
                showNav3Header: route.name === 'servicedesk-issues',
                preloadedEntryPoints: entryPoints,
                preloadedQueries: (0, $6s1PB.expVal)('conditional_formatting_in_new_list', 'isEnabled', false) ? queries : undefined
            }))));
var $075445744fba52e5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($075445744fba52e5$var$ProjectIssueNavigatorSPA);

});
parcelRegister("3mYHL", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $90d8776d2c89f4bd$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $90d8776d2c89f4bd$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $90d8776d2c89f4bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $7tQej = parcelRequire("7tQej");

const $90d8776d2c89f4bd$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $90d8776d2c89f4bd$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, (projectContext)=>$90d8776d2c89f4bd$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
        }) : null);
};
const $90d8776d2c89f4bd$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
    });
var $90d8776d2c89f4bd$export$2e2bcd8739ae039 = $90d8776d2c89f4bd$var$RedirectIfProjectArchived;

});
const $a9bebd574fd66055$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("hXXhf", function(module, exports) {

$parcel$export(module.exports, "ProjectSubProductUpdater", () => $46da65acff6e2839$export$bfbf80c212b0dcb9);

var $5uXOq = parcelRequire("5uXOq");

var $4DPZY = parcelRequire("4DPZY");

var $gSBIZ = parcelRequire("gSBIZ");

var $16v4H = parcelRequire("16v4H");

var $9dbF6 = parcelRequire("9dbF6");
const $46da65acff6e2839$export$bfbf80c212b0dcb9 = ({ allowMonolithDeferral: allowMonolithDeferral = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4DPZY.ContainerContextSubscriber), null, ({ data: data })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, data && (0, $gSBIZ.isProjectContext)(data) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
            subProduct: (0, $16v4H.subProductFromProjectTypeForAnalytics)(data.project.type),
            allowMonolithDeferral: allowMonolithDeferral
        })));

});
parcelRegister("gSBIZ", function(module, exports) {

$parcel$export(module.exports, "isProjectContext", () => $3bb86183071b9984$export$d46e75e464bf2407);
$parcel$export(module.exports, "isUserContext", () => $3bb86183071b9984$export$8d1083037a4a6250);
const $3bb86183071b9984$export$d46e75e464bf2407 = (containerContext)=>containerContext.project !== undefined;
const $3bb86183071b9984$export$8d1083037a4a6250 = (containerContext)=>containerContext.user !== undefined;

});

parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $16v4H = parcelRequire("16v4H");

var $3iTiR = parcelRequire("3iTiR");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $16v4H.subProductFromProjectTypeForAnalytics)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});



parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("383Br", function(module, exports) {

$parcel$export(module.exports, "NinErrorBoundary", () => $21969641ec14a234$export$b63c3d14be9f8b13);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $dAfqg = parcelRequire("dAfqg");

var $efvDm = parcelRequire("efvDm");

var $kaHBi = parcelRequire("kaHBi");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $4R6GH = parcelRequire("4R6GH");

var $2e4p8 = parcelRequire("2e4p8");

var $6UAdF = parcelRequire("6UAdF");
const $21969641ec14a234$var$ANALYTICS_SOURCE = 'issue-navigator';
const $21969641ec14a234$export$b63c3d14be9f8b13 = ({ children: children, id: id, packageName: packageName })=>{
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $6UAdF.EXPERIENCE_NAME),
        experienceId: undefined,
        analyticsSource: $21969641ec14a234$var$ANALYTICS_SOURCE
    });
    const appEditions = (0, $k9JTq.useAppEditions)();
    const application = project?.projectType ? (0, $efvDm.getApplicationForProject)(project.projectType) : null;
    const edition = application ? (0, $ldyPw.getEdition)(application, appEditions) : null;
    let analyticsAttributes = {
        application: application,
        edition: edition
    };
    if ((0, $4R6GH.fg)('jira_nin_smart_link')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const isEmbed = (0, $2e4p8.useIsEmbedMode)();
        analyticsAttributes = {
            ...analyticsAttributes,
            isEmbed: isEmbed
        };
    }
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $6UAdF.EXPERIENCE_NAME),
        attributes: analyticsAttributes
    });
    const onError = (0, $5uXOq.useCallback)((location, error)=>{
        onExperienceStart();
        onExperienceFail(location, error);
    }, [
        onExperienceFail,
        onExperienceStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        onError: onError,
        sendToPrivacyUnsafeSplunk: true
    }, children);
};

});

parcelRegister("4XBWz", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c4881164356cb39$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $gcl1l = parcelRequire("gcl1l");

var $7iJwP = parcelRequire("7iJwP");

var $6s1PB = parcelRequire("6s1PB");

var $9Nvh7 = parcelRequire("9Nvh7");

var $VILOn = parcelRequire("VILOn");

var $a8lIB = parcelRequire("a8lIB");

var $ay8sY = parcelRequire("ay8sY");

var $lfTZh = parcelRequire("lfTZh");

var $iXVV6 = parcelRequire("iXVV6");

var $ddpSK = parcelRequire("ddpSK");

var $8PRuf = parcelRequire("8PRuf");

var $5rqex = parcelRequire("5rqex");

var $ao2h1 = parcelRequire("ao2h1");

var $bATyw = parcelRequire("bATyw");

var $89kiv = parcelRequire("89kiv");

var $dxCvy = parcelRequire("dxCvy");

var $lHYIV = parcelRequire("lHYIV");

var $h2eGN = parcelRequire("h2eGN");

var $dZw8H = parcelRequire("dZw8H");

var $2YP9W = parcelRequire("2YP9W");

var $cSD7y = parcelRequire("cSD7y");
const $1c4881164356cb39$var$getSearchInput = (projectKey, jql, filter)=>{
    const filterInput = (0, $9Nvh7.isFilterId)(filter) ? filter : (0, $h2eGN.mapFilterToJql)(projectKey, filter);
    return (0, $ay8sY.getSearchInput)(jql, filterInput);
};
const $1c4881164356cb39$var$getFilterForAnalytics = (filter)=>{
    return filter && ((0, $9Nvh7.isFilterId)(filter) || (0, $h2eGN.isFilterKey)(filter)) ? filter : 'default';
};
const $1c4881164356cb39$var$useProjectAttributes = ()=>{
    const { data: projectContext } = (0, $2YP9W.useResource)((0, $dxCvy.projectContextResource));
    let resolvedProjectConfig;
    switch(projectContext?.simplified){
        case true:
            resolvedProjectConfig = (0, $2vSU6.ProjectStyle).NEXT_GEN;
            break;
        case false:
            resolvedProjectConfig = (0, $2vSU6.ProjectStyle).CLASSIC;
            break;
        default:
            resolvedProjectConfig = '';
    }
    const resolvedProjectType = projectContext?.projectType || '';
    return (0, $5uXOq.useMemo)(()=>({
            projectConfig: resolvedProjectConfig,
            projectType: resolvedProjectType
        }), [
        resolvedProjectConfig,
        resolvedProjectType
    ]);
};
const $1c4881164356cb39$var$useIssueTableProps = (projectKey, preloadedEntryPoints, preloadedQueries)=>{
    return (0, $5uXOq.useMemo)(()=>({
            projectContext: projectKey,
            isGroupingSupported: (0, $6s1PB.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) && (0, $6s1PB.expVal)('jira_spreadsheet_component_grouping', 'isGroupingEnabled', false),
            preloadedEntryPoints: preloadedEntryPoints,
            preloadedQueries: (0, $6s1PB.expVal)('conditional_formatting_in_new_list', 'isEnabled', false) ? preloadedQueries : undefined
        }), [
        projectKey,
        preloadedEntryPoints,
        preloadedQueries
    ]);
};
const $1c4881164356cb39$var$useGlobalScopeEnrolment = ()=>{
    const { data: globalEnrolmentData } = (0, $2YP9W.useResource)((0, $bATyw.isNinGlobalScopeEnrolmentEnabledResource));
    if (globalEnrolmentData !== null && globalEnrolmentData !== undefined) (0, $VILOn.setIsGlobalScopeEnrolmentEnabledInLocalStorage)(globalEnrolmentData);
};
const $1c4881164356cb39$var$MaybeReportErrors = (0, $cSD7y.componentWithFG)('improve_nin_slo_events', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children), (0, $7iJwP.default));
const $1c4881164356cb39$var$AsyncProjectIssueNavigatorWrapper = ({ filter: filter, jql: jqlParam, initialised: initialised, view: view, projectKey: projectKey, showNav3Header: showNav3Header = false, ...props })=>{
    const onMutateJqlParam = (0, $ay8sY.useUpdateUrlQueryParamCallback)('jql');
    const defaultJql = (0, $h2eGN.getDefaultJql)(projectKey);
    const jql = (0, $ay8sY.getJqlFromParamValues)(defaultJql, jqlParam, filter, (0, $h2eGN.mapFilterToJql).bind(undefined, projectKey), onMutateJqlParam);
    const issueTableProps = $1c4881164356cb39$var$useIssueTableProps(projectKey, props.preloadedEntryPoints, props.preloadedQueries);
    const searchInput = (0, $5uXOq.useMemo)(()=>$1c4881164356cb39$var$getSearchInput(projectKey, jql, filter), [
        projectKey,
        jql,
        filter
    ]);
    const projectAttributes = $1c4881164356cb39$var$useProjectAttributes();
    $1c4881164356cb39$var$useGlobalScopeEnrolment();
    const response = (0, $ao2h1.useRelayResource)((0, $89kiv.issueNavigatorRelayResource));
    const { queryReference: queryReference } = response;
    const filterResponse = (0, $ao2h1.useRelayResource)((0, $89kiv.issueNavigatorFilterRelayResource));
    const filterQueryReference = filterResponse.queryReference;
    const issueNavigatorHydrationRelayResource = (0, $4R6GH.fg)('render_jql_builder_in_ssr') ? (0, $89kiv.issueNavigatorHydrationRelayResource) : (0, $89kiv.issueNavigatorHydrationRelayResourceBrowserOnly);
    const hydrationResponse = (0, $ao2h1.useRelayResource)(issueNavigatorHydrationRelayResource);
    const hydrationQueryReference = hydrationResponse.queryReference;
    // During SSR our issueNavigatorRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (queryReference == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lHYIV.ProjectIssueNavigatorSkeleton), null);
    // During SSR our issueNavigatorFilterRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (filterQueryReference == null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lHYIV.ProjectIssueNavigatorSkeleton), null);
    // During SSR our issueNavigatorHydrationRelayResource must wait until the query finishes before returning the
    // queryReference as SSR does not support Suspense. We return the page skeleton as an intermediary state until
    // the query has resolved (or SSR times out and the query is loaded on the client).
    if (hydrationQueryReference == null && (0, $4R6GH.fg)('render_jql_builder_in_ssr')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lHYIV.ProjectIssueNavigatorSkeleton), null);
    const filterForAnalytics = $1c4881164356cb39$var$getFilterForAnalytics(filter);
    const attributes = {
        navigatorScope: 'project',
        viewLayout: view || '',
        jql: !!jqlParam,
        filter: filterForAnalytics,
        ...projectAttributes
    };
    const extraInfo = {
        scope: 'project',
        filterId: filterForAnalytics,
        isJqlParamPresent: !!jqlParam,
        ...attributes
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes,
        ...filter !== null && filter !== undefined && ((0, $9Nvh7.isFilterId)(filter) || (0, $h2eGN.isFilterKey)(filter)) && {
            containers: {
                issueFilter: {
                    id: filter
                }
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1c4881164356cb39$var$MaybeReportErrors, {
        id: "unhandled",
        packageName: "jiraSpaAppsProjectIssueNavigator",
        teamName: "empanada",
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $gcl1l.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-issue-navigator-app",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lHYIV.ProjectIssueNavigatorSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ddpSK.default), {
        ...props,
        showNav3Header: showNav3Header,
        projectKey: projectKey,
        defaultJql: defaultJql,
        queryReference: queryReference || undefined,
        filterQueryReference: filterQueryReference,
        searchInput: searchInput,
        issueTableProps: issueTableProps,
        isIssueHierarchySupportEnabled: (0, $6s1PB.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false),
        isHideDoneSupportEnabled: (0, $6s1PB.expVal)('jira_list_hide_done_items', 'isEnabled', false),
        isIssueRankingSupportEnabled: (0, $4R6GH.fg)('jsc_list_reranking_gate'),
        jqlBuilderProps: {
            maybeHydrationQueryReference: hydrationQueryReference || undefined
        },
        isMergedColumnSupportEnabled: (0, $6s1PB.expVal)('jira_list_merged_column', 'isEnabled', false),
        isConditionalFormattingEnabled: (0, $6s1PB.expVal)('conditional_formatting_in_new_list', 'isEnabled', false)
    }))), initialised && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        appName: "project-issue-navigator",
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $8PRuf.appBundleReadyMark),
            (0, $8PRuf.prefetchApiReadyMark)
        ],
        ttrSlo: 3000,
        ttiSlo: 4000,
        extra: extraInfo,
        metric: (0, $a8lIB.NINPageLoad)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null)));
};
var $1c4881164356cb39$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($1c4881164356cb39$var$AsyncProjectIssueNavigatorWrapper);

});
parcelRegister("gcl1l", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $ecfe970d67067a10$export$c7209ce2e0d060ea);

var $bCf8q = parcelRequire("bCf8q");
const $ecfe970d67067a10$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $bCf8q.isLoaderError)(error)
    });

});

parcelRegister("VILOn", function(module, exports) {

$parcel$export(module.exports, "getIsGlobalScopeEnrolmentEnabledFromLocalStorage", () => $5dc42c779a970b72$export$55632339cd4dae9c);
$parcel$export(module.exports, "getIsGlobalScopeForcedOptOutGinFlagDisabledLocalStorage", () => $5dc42c779a970b72$export$7b78bfe0a111cecf);
$parcel$export(module.exports, "setIsGlobalScopeEnrolmentEnabledInLocalStorage", () => $5dc42c779a970b72$export$82b2633cf7498c5e);
$parcel$export(module.exports, "setGlobalScopeForcedOptOutGinFlagEnabledInLocalStorage", () => $5dc42c779a970b72$export$458eda2352a1e223);

var $bSSG7 = parcelRequire("bSSG7");

var $2YZCu = parcelRequire("2YZCu");
const $5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY = 'jira.nin.global.scope.enrolment';
const $5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY = 'jira.user.nin.global.scope.enrolment.flag.disabled';
const $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage = (0, $bSSG7.createLocalStorageProvider)('nin-changeboarding');
const $5dc42c779a970b72$export$34434fbbe40a8047 = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.remove($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$55632339cd4dae9c = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$7b78bfe0a111cecf = ()=>$5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.get($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY);
const $5dc42c779a970b72$export$82b2633cf7498c5e = (isNINEnrolmentEnabled)=>{
    // In practice this is very unlikely to fail, as our local storage library checks that local storage is working
    // during initialisation. However in order to be robust we will catch any errors and recover by simply deleting the
    // existing local storage value (it's just a cache, so deleting it and delegating to the server will work fine)
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$NIN_GLOBAL_SCOPE_ENROLMENT_ENABLED_STORAGE_KEY, isNINEnrolmentEnabled);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage value, removing instead');
        $5dc42c779a970b72$export$34434fbbe40a8047();
    }
};
const $5dc42c779a970b72$export$458eda2352a1e223 = ()=>{
    try {
        $5dc42c779a970b72$var$ninGlobalScopeEnrolmentLocalStorage.set($5dc42c779a970b72$var$GLOBAL_SCOPE_FORCED_OPT_OUT_GIN_FLAG_DISABLED_STORAGE_KEY, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeWarnWithoutCustomerData('nin.global.scope.enrolment', 'Failed to set local storage flag value');
    }
};

});

parcelRegister("a8lIB", function(module, exports) {

$parcel$export(module.exports, "marks", () => $9dd1b22816aa1595$export$3a8025f2f3e0c64);
$parcel$export(module.exports, "NINJqlBuilderAsyncLoad", () => $9dd1b22816aa1595$export$8ba5b9245ec3f6f9);
$parcel$export(module.exports, "NINPageLoad", () => $9dd1b22816aa1595$export$248c6c208e271182);
$parcel$export(module.exports, "NINEmbedPageLoad", () => $9dd1b22816aa1595$export$48368cea8238c302);
$parcel$export(module.exports, "markOnce", () => $9dd1b22816aa1595$export$243d158112bae094);

var $dGrdR = parcelRequire("dGrdR");

var $8vNru = parcelRequire("8vNru");

var $4R6GH = parcelRequire("4R6GH");
const $9dd1b22816aa1595$export$3a8025f2f3e0c64 = {
    ISSUE_NAVIGATOR_START: 'ISSUE_NAVIGATOR_START',
    ISSUE_NAVIGATOR_END: 'ISSUE_NAVIGATOR_END',
    ISSUE_NAVIGATOR_UI_START: 'ISSUE_NAVIGATOR_UI_START',
    ISSUE_NAVIGATOR_UI_END: 'ISSUE_NAVIGATOR_UI_END',
    PAGE_ACTIONS_START: 'PAGE_ACTIONS_START',
    PAGE_ACTIONS_END: 'PAGE_ACTIONS_END',
    PAGE_ACTIONS_VIEW_SWITCHER_START: 'PAGE_ACTIONS_VIEW_SWITCHER_START',
    PAGE_ACTIONS_VIEW_SWITCHER_END: 'PAGE_ACTIONS_VIEW_SWITCHER_END',
    REFINEMENT_START: 'REFINEMENT_START',
    REFINEMENT_END: 'REFINEMENT_END',
    ISSUE_RESULTS_START: 'ISSUE_RESULTS_START',
    ISSUE_RESULTS_END: 'ISSUE_RESULTS_END',
    ISSUE_RESULTS_DETAIL_VIEW_START: 'ISSUE_RESULTS_DETAIL_VIEW_START',
    ISSUE_RESULTS_DETAIL_VIEW_END: 'ISSUE_RESULTS_DETAIL_VIEW_END',
    ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START: 'ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START',
    ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END: 'ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END',
    ISSUE_RESULTS_LIST_VIEW_START: 'ISSUE_RESULTS_LIST_VIEW_START',
    ISSUE_RESULTS_LIST_VIEW_END: 'ISSUE_RESULTS_LIST_VIEW_END',
    ISSUE_RESULTS_LIST_VIEW_FOOTER_START: 'ISSUE_RESULTS_LIST_VIEW_FOOTER_START',
    ISSUE_RESULTS_LIST_VIEW_FOOTER_END: 'ISSUE_RESULTS_LIST_VIEW_FOOTER_END',
    ISSUE_APP_START: 'ISSUE_APP_START',
    ISSUE_APP_END: 'ISSUE_APP_END',
    ...(0, $8vNru.JQL_BUILDER_PERFORMANCE_MARKS)
};
const $9dd1b22816aa1595$export$8ba5b9245ec3f6f9 = (0, $dGrdR.metrics).pageSegmentLoad({
    key: 'new-issue-navigator-jql-builder',
    timings: [
        {
            key: 'product/issue-navigator/ui/jql-builder',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/hydrate',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_HYDRATE_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_HYDRATE_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-basic',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-basic/js',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_JS_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_BASIC_JS_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-advanced',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_END
        },
        {
            key: 'product/issue-navigator/ui/jql-builder/jql-builder-advanced/js',
            startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_JS_START,
            endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.JQL_BUILDER_ADVANCED_JS_END
        }
    ],
    histogram: {
        initial: {
            fmp: '100_200_500_1000_2500_3000_4000_5000_10000',
            tti: '100_200_500_1000_2500_3000_4000_5000_10000'
        },
        transition: {
            fmp: '100_200_500_1000_2500_3000_4000_5000_10000',
            tti: '100_200_500_1000_2500_3000_4000_5000_10000'
        }
    },
    featureFlags: []
});
const $9dd1b22816aa1595$export$8c9c137679bb68c8 = (key)=>(0, $dGrdR.metrics).pageLoad({
        key: key,
        slo: {
            fmp: {
                initial: {
                    threshold: 3000
                },
                transition: {
                    threshold: 3000
                }
            },
            tti: {
                initial: {
                    threshold: 4000
                },
                transition: {
                    threshold: 4000
                }
            }
        },
        ssr: {
            doneAsFmp: true
        },
        timings: [
            {
                key: 'product/issue-navigator',
                startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_START,
                endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_END
            },
            {
                key: 'product/issue-navigator/ui',
                startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_UI_START,
                endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_NAVIGATOR_UI_END
            },
            {
                key: 'product/issue-navigator/ui/page-actions',
                startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.PAGE_ACTIONS_START,
                endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.PAGE_ACTIONS_END
            },
            {
                key: 'product/issue-navigator/ui/page-actions/view-switcher',
                startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.PAGE_ACTIONS_VIEW_SWITCHER_START,
                endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.PAGE_ACTIONS_VIEW_SWITCHER_END
            },
            {
                key: 'product/issue-navigator/ui/refinement',
                startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.REFINEMENT_START,
                endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.REFINEMENT_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results',
                startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_START,
                endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results/detail-view',
                startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_START,
                endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results/detail-view/card-list',
                startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START,
                endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results/list-view',
                startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_START,
                endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_END
            },
            {
                key: 'product/issue-navigator/ui/issue-results/list-view/footer',
                startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_FOOTER_START,
                endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_RESULTS_LIST_VIEW_FOOTER_END
            },
            {
                key: 'product/issue-navigator/ui/issue-app',
                startMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_APP_START,
                endMark: $9dd1b22816aa1595$export$3a8025f2f3e0c64.ISSUE_APP_END
            }
        ],
        featureFlags: []
    });
const $9dd1b22816aa1595$export$248c6c208e271182 = $9dd1b22816aa1595$export$8c9c137679bb68c8('new-issue-navigator');
const $9dd1b22816aa1595$export$48368cea8238c302 = $9dd1b22816aa1595$export$8c9c137679bb68c8('new-issue-navigator-embed');
const $9dd1b22816aa1595$var$consumedMarks = [];
const $9dd1b22816aa1595$export$243d158112bae094 = (mark)=>{
    if (!$9dd1b22816aa1595$var$consumedMarks.includes(mark)) {
        $9dd1b22816aa1595$var$consumedMarks.push(mark);
        $9dd1b22816aa1595$export$248c6c208e271182.mark(mark);
        (0, $4R6GH.fg)('jira_nin_smart_link') && $9dd1b22816aa1595$export$48368cea8238c302.mark(mark);
        $9dd1b22816aa1595$export$8ba5b9245ec3f6f9.mark(mark);
    }
};

});
parcelRegister("8vNru", function(module, exports) {

$parcel$export(module.exports, "JQL_BUILDER_PERFORMANCE_MARKS", () => $491ce87882605bf7$export$5fd6d8ece357700d);
// Performance marks
const $491ce87882605bf7$var$JQL_BUILDER_START = 'JQL_BUILDER_START';
const $491ce87882605bf7$var$JQL_BUILDER_END = 'JQL_BUILDER_END';
const $491ce87882605bf7$var$JQL_BUILDER_HYDRATE_START = 'JQL_BUILDER_HYDRATE_START';
const $491ce87882605bf7$var$JQL_BUILDER_HYDRATE_END = 'JQL_BUILDER_HYDRATE_END';
const $491ce87882605bf7$var$JQL_BUILDER_BASIC_START = 'JQL_BUILDER_BASIC_START';
const $491ce87882605bf7$var$JQL_BUILDER_BASIC_END = 'JQL_BUILDER_BASIC_END';
const $491ce87882605bf7$var$JQL_BUILDER_BASIC_JS_START = 'JQL_BUILDER_BASIC_JS_START';
const $491ce87882605bf7$var$JQL_BUILDER_BASIC_JS_END = 'JQL_BUILDER_BASIC_JS_END';
const $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_START = 'JQL_BUILDER_ADVANCED_START';
const $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_END = 'JQL_BUILDER_ADVANCED_END';
const $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_JS_START = 'JQL_BUILDER_ADVANCED_JS_START';
const $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_JS_END = 'JQL_BUILDER_ADVANCED_JS_END';
const $491ce87882605bf7$export$5fd6d8ece357700d = {
    JQL_BUILDER_START: /**
	 * JQL_BUILDER
	 * Count how long it takes to load the JQL Builder,
	 * from first render of async component to ready to use
	 */ $491ce87882605bf7$var$JQL_BUILDER_START,
    JQL_BUILDER_END: $491ce87882605bf7$var$JQL_BUILDER_END,
    JQL_BUILDER_HYDRATE_START: /**
	 * JQL_BUILDER_HYDRATE
	 * Count how long it takes from first try to use hydrated data
	 * to the momento is actually ready to use
	 */ $491ce87882605bf7$var$JQL_BUILDER_HYDRATE_START,
    JQL_BUILDER_HYDRATE_END: $491ce87882605bf7$var$JQL_BUILDER_HYDRATE_END,
    JQL_BUILDER_BASIC_JS_START: /**
	 * JQL_BUILDER_BASIC_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Basic js package
	 */ $491ce87882605bf7$var$JQL_BUILDER_BASIC_JS_START,
    JQL_BUILDER_BASIC_JS_END: $491ce87882605bf7$var$JQL_BUILDER_BASIC_JS_END,
    JQL_BUILDER_BASIC_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Basic,
	 * from first render of async basic component to ready to use
	 */ $491ce87882605bf7$var$JQL_BUILDER_BASIC_START,
    JQL_BUILDER_BASIC_END: $491ce87882605bf7$var$JQL_BUILDER_BASIC_END,
    JQL_BUILDER_ADVANCED_JS_START: /**
	 * JQL_BUILDER_ADVANCED_JS
	 * Count how long it takes from FE perspective to load the basic JQL Builder Advanced js package
	 */ $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_JS_START,
    JQL_BUILDER_ADVANCED_JS_END: $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_JS_END,
    JQL_BUILDER_ADVANCED_START: /**
	 * JQL_BUILDER_BASIC
	 * Count how long it takes to load the JQL Builder Advnaced,
	 * from first render of async advanced component to ready to use
	 */ $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_START,
    JQL_BUILDER_ADVANCED_END: $491ce87882605bf7$var$JQL_BUILDER_ADVANCED_END
};

});


parcelRegister("ay8sY", function(module, exports) {

$parcel$export(module.exports, "getJqlFromParamValues", () => $fac2feff71c61553$export$52de656da34011c3);
$parcel$export(module.exports, "getSearchInput", () => $fac2feff71c61553$export$2fa22ca814667ff4);
$parcel$export(module.exports, "useUpdateUrlQueryParamCallback", () => $fac2feff71c61553$export$f6b4f46bd8314b51);

var $5uXOq = parcelRequire("5uXOq");

var $9Nvh7 = parcelRequire("9Nvh7");

var $ieDtd = parcelRequire("ieDtd");

var $6UAdF = parcelRequire("6UAdF");
const $fac2feff71c61553$export$52de656da34011c3 = (defaultJql, jqlParam, filter, /**
	 * when `filter` has a value that is not a standard numeric filter ID, consumers can provide a
	 * customMapper function to transform the filter value to a jql string. For example this is used
	 * by Project Issue Navigator to map filter query params such as '?filter=myopenissues into jql
	 * strings without calling the backend API
	 */ customMapper, /**
	 * callback in the event of jql being returned is different to the jqlParam value, such as when
	 * it is undefined and the default jql is being returned. This allows the caller to sync the new
	 * jql value with the `?jql=...` url query param
	 */ onMutateJqlParam)=>{
    let jql = jqlParam;
    if (typeof jql === 'string') return jql;
    if ((0, $9Nvh7.isFilterId)(filter)) return undefined;
    if (typeof filter === 'string' && customMapper) jql = customMapper(filter);
    if (jql === undefined) jql = defaultJql;
    if (jql !== jqlParam) onMutateJqlParam?.(jql);
    return jql;
};
const $fac2feff71c61553$var$getFilter = (filterInput)=>(0, $9Nvh7.isFilterId)(filterInput) ? {
        value: filterInput,
        type: (0, $6UAdF.FilterTypes).ID
    } : {
        value: filterInput,
        type: (0, $6UAdF.FilterTypes).JQL
    };
const $fac2feff71c61553$export$2fa22ca814667ff4 = (jqlInput, filterInput)=>{
    const filter = filterInput !== undefined ? $fac2feff71c61553$var$getFilter(filterInput) : undefined;
    if (jqlInput === undefined) {
        if (filter === undefined) throw new Error('filter is missing for search input');
        return filter;
    }
    if (filter === undefined) return {
        jql: jqlInput,
        type: (0, $6UAdF.SearchInputTypes).JQL
    };
    return {
        jql: jqlInput,
        filter: filter,
        type: (0, $6UAdF.SearchInputTypes).FILTER_AND_JQL
    };
};
const $fac2feff71c61553$export$f6b4f46bd8314b51 = (queryParamKey)=>{
    const [_, setQueryParam] = (0, $ieDtd.useQueryParam)(queryParamKey);
    const setJqlQueryParamCallback = (0, $5uXOq.useCallback)((value)=>setQueryParam(value, 'replace'), [
        setQueryParam
    ]);
    return setJqlQueryParamCallback;
};

});

parcelRegister("ddpSK", function(module, exports) {

$parcel$export(module.exports, "default", () => $142dbb64313592e3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $ctjgZ = parcelRequire("ctjgZ");

var $4m2yJ = parcelRequire("4m2yJ");

var $3HwlS = parcelRequire("3HwlS");

var $cf7yQ = parcelRequire("cf7yQ");

var $jev6s = parcelRequire("jev6s");

var $kZqgk = parcelRequire("kZqgk");

var $koeKL = parcelRequire("koeKL");

var $id7K0 = parcelRequire("id7K0");

var $4R6GH = parcelRequire("4R6GH");

var $k0YyU = parcelRequire("k0YyU");

var $c1eQZ = parcelRequire("c1eQZ");

var $byGGJ = parcelRequire("byGGJ");
const $142dbb64313592e3$var$ActionMenu = (customHeaderProps)=>{
    const { jql: jql, filterId: filterId, filterDetails: filterDetails, searchResultPageData: searchResultPageData, HierarchyToggle: HierarchyToggle, GroupByDropdown: GroupByDropdown, HideDoneToggle: HideDoneToggle, SaveResetViewSettingsButton: SaveResetViewSettingsButton, isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled, onChangeFilter: onChangeFilter } = customHeaderProps;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $byGGJ.default), {
        jql: jql,
        filterId: filterId,
        isModifiedFilter: filterDetails?.jql !== jql,
        searchResultPageData: searchResultPageData,
        HierarchyToggle: HierarchyToggle,
        GroupByDropdown: GroupByDropdown,
        HideDoneToggle: HideDoneToggle,
        SaveResetViewSettingsButton: SaveResetViewSettingsButton,
        isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled,
        onChangeFilter: onChangeFilter
    });
};
const $142dbb64313592e3$var$actionMenuWithHideDoneSupport = (isHideDoneSupportEnabled)=>{
    return (customHeaderProps)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $byGGJ.default), {
            ...customHeaderProps,
            isHideDoneSupportEnabled: isHideDoneSupportEnabled
        });
    };
};
const $142dbb64313592e3$var$ProjectIssueNavigator = ({ projectKey: projectKey, showNav3Header: showNav3Header = false, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isHideDoneSupportEnabled: isHideDoneSupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled, ...rest })=>{
    const CustomHeader = (0, $5uXOq.useCallback)((customHeaderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k0YyU.default), {
            projectKey: projectKey,
            ...customHeaderProps,
            isQuickFiltersDisabled: showNav3Header,
            isHideDoneSupportEnabled: isHideDoneSupportEnabled,
            isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled
        }), [
        isHideDoneSupportEnabled,
        isIssueHierarchySupportEnabled,
        projectKey,
        showNav3Header
    ]);
    const showNewNav = (0, $3HwlS.getWillShowNav4)() && !showNav3Header;
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $kZqgk.default));
    const cloudId = (0, $koeKL.useCloudId)();
    (0, $5uXOq.useEffect)(()=>{
        loadQuery({
            projectKey: projectKey,
            cloudId: cloudId
        });
    }, [
        loadQuery,
        projectKey,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showNewNav && (queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1eQZ.default), {
        queryReference: queryReference
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4m2yJ.default), {
        ...!showNewNav && {
            CustomHeader: CustomHeader
        },
        ...showNewNav && {
            ActionMenu: (0, $4R6GH.fg)('jsc_bulk_edit_hide_done_work_items') ? $142dbb64313592e3$var$actionMenuWithHideDoneSupport(isHideDoneSupportEnabled) : $142dbb64313592e3$var$ActionMenu
        },
        HeaderSkeletonImage: (0, $jev6s.ProjectIssueNavigatorHeaderSkeleton),
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        isIssueRankingSupportEnabled: isIssueRankingSupportEnabled,
        isMergedColumnSupportEnabled: isMergedColumnSupportEnabled,
        ...rest
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctjgZ.default), {
        hasServiceDeskAccess: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cf7yQ.JsdGettingStartedPanelShouldRender), null)));
};
const $142dbb64313592e3$export$b008d460035de468 = ({ projectKey: projectKey, showNewNav: showNewNav })=>{
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $kZqgk.default));
    const cloudId = (0, $koeKL.useCloudId)();
    (0, $5uXOq.useEffect)(()=>{
        loadQuery({
            projectKey: projectKey,
            cloudId: cloudId
        });
    }, [
        loadQuery,
        projectKey,
        cloudId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showNewNav && (queryReference ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1eQZ.default), {
        queryReference: queryReference
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctjgZ.default), {
        hasServiceDeskAccess: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cf7yQ.JsdGettingStartedPanelShouldRender), null)));
};
var $142dbb64313592e3$export$2e2bcd8739ae039 = $142dbb64313592e3$var$ProjectIssueNavigator;

});
parcelRegister("4m2yJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $36b09ac9b73a27e7$export$2e2bcd8739ae039);

var $7u5Tm = parcelRequire("7u5Tm");

var $1nibn = parcelRequire("1nibn");

var $7uwEc = parcelRequire("7uwEc");

var $31TiE = parcelRequire("31TiE");

var $4hr2P = parcelRequire("4hr2P");

var $9hXMi = parcelRequire("9hXMi");

var $68sKr = parcelRequire("68sKr");

var $l5FbD = parcelRequire("l5FbD");

var $hTvlq = parcelRequire("hTvlq");

var $kvekU = parcelRequire("kvekU");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $f98ZZ = parcelRequire("f98ZZ");

var $8YUiu = parcelRequire("8YUiu");

var $6UAdF = parcelRequire("6UAdF");

var $a8lIB = parcelRequire("a8lIB");

var $1z7Yr = parcelRequire("1z7Yr");

var $gwtSG = parcelRequire("gwtSG");

var $cKK2E = parcelRequire("cKK2E");

var $a5eZM = parcelRequire("a5eZM");

var $en3WN = parcelRequire("en3WN");

var $9BgIv = parcelRequire("9BgIv");

var $k4pU6 = parcelRequire("k4pU6");

var $kj1di = parcelRequire("kj1di");

var $gM6H8 = parcelRequire("gM6H8");
const $36b09ac9b73a27e7$export$e111e6466962b82b = (0, $kvekU.default);
// We memo as an optimisation to reduce forced re-renders when the immediate parent renders. In this case it's
// AppContextualAnalytics which will re-render when interacting with the JQL builder, e.g. opening picker.
const $36b09ac9b73a27e7$var$FilterAndJqlProvider = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, jql: jql, refetch: refetch, filterId: filterId, isFilterEditable: isFilterEditable, filterJql: filterJql })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKK2E.FilterQueryProvider), {
        query: $36b09ac9b73a27e7$export$e111e6466962b82b,
        refetch: refetch,
        filterId: filterId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gwtSG.ActiveJqlProvider), {
        filterId: filterId,
        filterJql: filterJql,
        jql: jql,
        isFilterEditable: isFilterEditable
    }, children)));
const $36b09ac9b73a27e7$var$getFilter = (searchParam)=>{
    if (searchParam?.type === (0, $6UAdF.SearchInputTypes).JQL) return undefined;
    return searchParam.type === (0, $6UAdF.SearchInputTypes).FILTER_AND_JQL ? searchParam.filter : searchParam;
};
const $36b09ac9b73a27e7$var$IssueNavigator = ({ issueKey: issueKey, queryReference: queryReference, filterQueryReference: filterQueryReference, CustomHeader: CustomHeader, ActionMenu: ActionMenu, HeaderSkeletonImage: HeaderSkeletonImage, onChangeIssue: onChangeIssue, onChangeFilter: onChangeFilter, onRefinement: onRefinement, onPageDataLoad: onPageDataLoadProp, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onSetView: onSetView, defaultJql: defaultJql, searchInput: searchInput, jqlBuilderProps: jqlBuilderProps, issueTableProps: issueTableProps, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_NAVIGATOR_START);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_NAVIGATOR_END);
    }, []);
    const [isInitialized, setIsInitialized] = (0, $5uXOq.useState)(false);
    const onPageDataLoad = (0, $5uXOq.useCallback)((...props)=>{
        if (!isInitialized) setIsInitialized(true);
        return onPageDataLoadProp?.(...props);
    }, [
        isInitialized,
        onPageDataLoadProp
    ]);
    const filterInput = searchInput ? $36b09ac9b73a27e7$var$getFilter(searchInput) : undefined;
    const issueQuery = (0, $8Uumt.usePreloadedQuery)((0, $hTvlq.default), queryReference);
    const refetchQuery = (0, $8Uumt.useFragment)((0, $l5FbD.default), issueQuery);
    const [issueNavigatorRefetchDataNew, issueNavigatorRefetchNew] = (0, $8Uumt.useRefetchableFragment)((0, $68sKr.default), refetchQuery);
    const jiraViewData = issueNavigatorRefetchDataNew?.jira?.jiraIssueSearchView ?? null;
    const detailedViewPaginationFragment = (0, $8Uumt.usePaginationFragment)((0, $9hXMi.default), jiraViewData?.__typename === 'JiraDetailedView' ? jiraViewData : null);
    const groupedListViewPaginationFragment = (0, $8Uumt.usePaginationFragment)((0, $4hr2P.default), jiraViewData?.__typename === 'JiraGroupedListView' ? jiraViewData : null);
    const listViewPaginationFragment = (0, $8Uumt.usePaginationFragment)((0, $31TiE.default), jiraViewData?.__typename === 'JiraListView' ? jiraViewData : null);
    const userPreferencesData = (0, $8Uumt.useFragment)((0, $7uwEc.default), issueQuery.jira?.userPreferences ?? null);
    const jqlBuilderWithAiData = (0, $8Uumt.useFragment)((0, $1nibn.default), issueQuery.jira);
    let activePaginationFragment = listViewPaginationFragment;
    let groupResultsData = null;
    let issueResultsData = listViewPaginationFragment?.data?.issues ?? null;
    if (detailedViewPaginationFragment.data) {
        activePaginationFragment = detailedViewPaginationFragment;
        issueResultsData = detailedViewPaginationFragment?.data?.issues ?? null;
    } else if (groupedListViewPaginationFragment.data) {
        activePaginationFragment = groupedListViewPaginationFragment;
        groupResultsData = groupedListViewPaginationFragment?.data?.groups ?? null;
    }
    const filterQuery = (0, $8Uumt.usePreloadedQuery)($36b09ac9b73a27e7$export$e111e6466962b82b, filterQueryReference);
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const [filterData, refetchFilter] = (0, $8Uumt.useRefetchableFragment)((0, $7u5Tm.default), filterQuery);
    /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ /**
   * initialQueryAsJql remembers the initial query on mount
   */ const [initialQueryAsJql] = (0, $5uXOq.useState)(()=>{
        if (!(0, $4R6GH.fg)('jracloud_85520_hydration_ref_only_on_page_load')) return undefined;
        // Use base input for plain JQL input OR
        // If both filter and JQL are present, JQL takes precedence
        if (searchInput.type === (0, $6UAdF.SearchInputTypes).JQL || searchInput.type === (0, $6UAdF.SearchInputTypes).FILTER_AND_JQL) return searchInput.jql;
        // Use filter JQL for manually-mapped filters like we use in Project Scope
        if (filterInput?.type === (0, $6UAdF.FilterTypes).JQL) return filterInput.value;
        // Otherwise, use the saved filter JQL as returned by the backend
        return filterData?.jira?.filter?.jql;
    });
    let setFlatListIssues = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ setFlatListIssues: setFlatListIssues } = (0, $gM6H8.useFlatListIssuesActions)());
    const handleIssueFlatListUpdated = // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') && (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useCallback)((newFlatKeyList)=>{
        setFlatListIssues(newFlatKeyList);
    }, [
        setFlatListIssues
    ]) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1z7Yr.AppContextualAnalytics), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8YUiu.ConditionalFormatting), {
        isEnabled: isConditionalFormattingEnabled,
        project: issueQuery.jira?.jiraProjectByKey ?? null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f98ZZ.SidebarContainer), {
        scope: (0, $6UAdF.NIN_SIDEBAR_SCOPE),
        sidebarId: (0, $6UAdF.ISSUE_NAVIGATOR_SIDEBAR_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36b09ac9b73a27e7$var$FilterAndJqlProvider, {
        refetch: refetchFilter,
        filterId: filterInput?.type === (0, $6UAdF.FilterTypes).ID ? filterInput?.value : undefined,
        filterJql: filterInput?.type === (0, $6UAdF.FilterTypes).JQL ? filterInput?.value : filterData?.jira?.filter?.jql,
        isFilterEditable: filterData.jira?.filter?.isEditable !== null ? filterData.jira?.filter?.isEditable : undefined,
        jql: searchInput?.type === (0, $6UAdF.SearchInputTypes).FILTER_AND_JQL || searchInput?.type === (0, $6UAdF.SearchInputTypes).JQL ? searchInput?.jql : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a5eZM.IssueSearch), {
        onPageDataLoad: onPageDataLoad,
        jiraView: jiraViewData,
        refetch: issueNavigatorRefetchNew,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        project: issueQuery.jira?.jiraProjectByKey ?? null,
        ...((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') || (0, $4R6GH.fg)('jira_list_group_shadow_requests') || (0, $4R6GH.fg)('jira_list_hierarchy_shadow_requests')) && {
            issueTableProps: issueTableProps
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kj1di.InfiniteScrollProvider), {
        onLoadNext: activePaginationFragment.loadNext,
        onLoadPrevious: activePaginationFragment.loadPrevious,
        isLoadingNext: activePaginationFragment.isLoadingNext,
        isLoadingPrevious: activePaginationFragment.isLoadingPrevious,
        hasNext: activePaginationFragment.hasNext,
        hasPrevious: activePaginationFragment.hasPrevious
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4pU6.SelectedViewContainer), {
        onSetView: onSetView,
        jiraView: jiraViewData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9BgIv.SelectedIssue), {
        selectedIssueKey: issueKey,
        onChange: onChangeIssue,
        issues: issueResultsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $en3WN.default), {
        CustomHeader: CustomHeader,
        ActionMenu: ActionMenu,
        HeaderSkeletonImage: HeaderSkeletonImage,
        filter: filterData?.jira?.filter ?? null,
        onChangeIssue: onChangeIssue,
        onChangeFilter: onChangeFilter,
        onPageDataLoad: onPageDataLoad,
        onChangeColumnConfiguration: onChangeColumnConfiguration,
        onChangeJql: onChangeJql,
        onRefinement: onRefinement,
        defaultJql: defaultJql,
        issueResults: issueResultsData,
        groupResults: groupResultsData,
        project: issueQuery.jira?.jiraProjectByKey ?? null,
        userPreferences: userPreferencesData ?? null,
        jqlBuilderProps: jqlBuilderProps,
        jqlBuilderWithAiKey: jqlBuilderWithAiData ?? null,
        issueTableProps: issueTableProps,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        jiraView: jiraViewData,
        onIssueFlatListUpdatedOld: setFlatListIssues,
        onIssueFlatListUpdated: handleIssueFlatListUpdated,
        initialQueryAsJql: initialQueryAsJql,
        isInitialized: isInitialized,
        isIssueRankingSupportEnabled: isIssueRankingSupportEnabled,
        isMergedColumnSupportEnabled: isMergedColumnSupportEnabled
    })))))))));
};
const $36b09ac9b73a27e7$var$WithFlatListIssuesContainer = (Component)=>{
    const IssueNavigatorWithFlatListIssuesContainer = (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gM6H8.FlatListIssuesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props));
    };
    return IssueNavigatorWithFlatListIssuesContainer;
};
const $36b09ac9b73a27e7$var$ConditionalIssueNavigator = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes'), $36b09ac9b73a27e7$var$WithFlatListIssuesContainer($36b09ac9b73a27e7$var$IssueNavigator), $36b09ac9b73a27e7$var$IssueNavigator);
var $36b09ac9b73a27e7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($36b09ac9b73a27e7$var$ConditionalIssueNavigator);

});
parcelRegister("7u5Tm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9610eaebf63e0bf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<50c8e9868b3e511de3ea4f420144c717>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $2JKPT = parcelRequire("2JKPT");
const $f9610eaebf63e0bf$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "filterAri"
        },
        {
            "kind": "RootArgument",
            "name": "includeFilter"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $2JKPT.default)
        }
    },
    "name": "main_issueNavigator_IssueNavigator_filterQuery",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "condition": "includeFilter",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "id",
                                    "variableName": "filterAri"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "filter",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "jql"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditable"
                                        }
                                    ],
                                    "type": "JiraCustomFilter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_Header_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "topBar_issueNavigator_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_filter"
                                },
                                {
                                    "kind": "FragmentSpread",
                                    "name": "main_issueNavigator_ListView_filter"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$f9610eaebf63e0bf$var$node.hash = "26da718314f181d4824f62928229af2b";
var $f9610eaebf63e0bf$export$2e2bcd8739ae039 = $f9610eaebf63e0bf$var$node;

});
parcelRegister("2JKPT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4685b2a0e7385ab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0913b38543a4ac835cf7eeb194420fa3>>
 * @relayHash d4259e050915cf8816f8c8a4884d4afb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fa55db43feb181a2ea2d08440aa1fca705fd8ddbbea5388f6c28457a3933a61e
const $a4685b2a0e7385ab$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "includeFilter"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "FilterRefetchQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_filterQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "FilterRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "includeFilter",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "filterAri"
                                        }
                                    ],
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isJiraFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isEditable"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isFavourite"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "fa55db43feb181a2ea2d08440aa1fca705fd8ddbbea5388f6c28457a3933a61e",
            "metadata": {},
            "name": "FilterRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$a4685b2a0e7385ab$var$node.hash = "26da718314f181d4824f62928229af2b";
var $a4685b2a0e7385ab$export$2e2bcd8739ae039 = $a4685b2a0e7385ab$var$node;

});


parcelRegister("1nibn", function(module, exports) {

$parcel$export(module.exports, "default", () => $81d0842de2b1cb5f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9b849f64e4a61be907eaec3accbf05bb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $81d0842de2b1cb5f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_jira",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey"
        }
    ],
    "type": "JiraQuery"
};
$81d0842de2b1cb5f$var$node.hash = "e871bd0eb341a6573bd1df76ea8e5df1";
var $81d0842de2b1cb5f$export$2e2bcd8739ae039 = $81d0842de2b1cb5f$var$node;

});

parcelRegister("7uwEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4652f62216686f4e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1ecec124bc87c6002f2c45127804b4c1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4652f62216686f4e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_userPreferences",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigatorUI_userPreferences"
        }
    ],
    "type": "JiraUserPreferences"
};
$4652f62216686f4e$var$node.hash = "1143e00ad7112d3bc319370b0e0a4b27";
var $4652f62216686f4e$export$2e2bcd8739ae039 = $4652f62216686f4e$var$node;

});

parcelRegister("31TiE", function(module, exports) {

$parcel$export(module.exports, "default", () => $baad11fc9e4ceaea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e54099876df2af6e18ab3cef3fd16503>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $at7Ef = parcelRequire("at7Ef");
const $baad11fc9e4ceaea$var$node = function() {
    var v0 = [
        "issues"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsContext"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "shouldQueryHasChildren"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $at7Ef.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_listViewData",
        "selections": [
            {
                "alias": "issues",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorListViewPagination__issues_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "selectedIssue_issueNavigator"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Variable",
                                "name": "shouldQueryHasChildren",
                                "variableName": "shouldQueryHasChildren"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraListView"
    };
}();
$baad11fc9e4ceaea$var$node.hash = "6fd17d4b441f85305e759e82f963bd19";
var $baad11fc9e4ceaea$export$2e2bcd8739ae039 = $baad11fc9e4ceaea$var$node;

});
parcelRegister("at7Ef", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7dcbb616d0e1e8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3f34cecbfa899abe0cdf91f0af1512ea>>
 * @relayHash ecdc7bf3f97306f96c366deb6276f7bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6addc8805f5413513007f0734ff0c676feb82e9ea4b8b877b19736ab66dbb00e

var $bqIzm = parcelRequire("bqIzm");

var $fjldt = parcelRequire("fjldt");

var $5oQtH = parcelRequire("5oQtH");

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $k3PJZ = parcelRequire("k3PJZ");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $da7dcbb616d0e1e8$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v20 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v21 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v22 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v23 = {
        "kind": "ScalarField",
        "name": "id"
    }, v24 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        },
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ], v25 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v26 = {
        "kind": "ScalarField",
        "name": "key"
    }, v27 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v29 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v30 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v29 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            v28 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v32 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v33 = {
        "kind": "ScalarField",
        "name": "name"
    }, v34 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v35 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v36 = {
        "kind": "ScalarField",
        "name": "type"
    }, v37 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v38 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v39 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v33 /*: any*/ ,
                                    v23 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v40 = {
        "kind": "ScalarField",
        "name": "value"
    }, v41 = [
        v40 /*: any*/ ,
        v23 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v42 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v43 = {
        "kind": "ClientExtension",
        "selections": [
            v42 /*: any*/ 
        ]
    }, v44 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v45 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v46 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v47 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v48 = {
        "kind": "ScalarField",
        "name": "text"
    }, v49 = {
        "kind": "InlineFragment",
        "selections": [
            v48 /*: any*/ ,
            v33 /*: any*/ ,
            v43 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v50 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v51 = [
        v50 /*: any*/ 
    ], v52 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v23 /*: any*/ 
        ]
    }, v53 = [
        v52 /*: any*/ 
    ], v54 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v55 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v23 /*: any*/ ,
            v40 /*: any*/ 
        ]
    }, v56 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v57 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v58 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v59 = {
        "kind": "ClientExtension",
        "selections": [
            v34 /*: any*/ 
        ]
    }, v60 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "concreteType": "JiraCascadingOption",
                        "kind": "LinkedField",
                        "name": "cascadingOption",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "parentOptionValue",
                                "plural": false,
                                "selections": v41 /*: any*/ 
                            },
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "childOptionValue",
                                "plural": false,
                                "selections": v41 /*: any*/ 
                            }
                        ]
                    },
                    v43 /*: any*/ 
                ],
                "type": "JiraCascadingSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "args": v44 /*: any*/ ,
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v45 /*: any*/ ,
                                            v46 /*: any*/ ,
                                            v23 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedComponentsConnection(first:1000)"
                    },
                    v43 /*: any*/ 
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v47 /*: any*/ ,
                    v33 /*: any*/ ,
                    v43 /*: any*/ 
                ],
                "type": "JiraDateTimePickerField"
            },
            v49 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraCommentSummary",
                        "kind": "LinkedField",
                        "name": "commentSummary",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "canAddComment"
                            },
                            v50 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraCommentSummaryField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "uri"
                    },
                    v43 /*: any*/ 
                ],
                "type": "JiraUrlField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "fieldOptions",
                        "plural": false,
                        "selections": v51 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "fieldOption",
                        "plural": false,
                        "selections": [
                            v40 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v53 /*: any*/ 
                            },
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v53 /*: any*/ 
                            },
                            v23 /*: any*/ ,
                            v54 /*: any*/ 
                        ]
                    },
                    v43 /*: any*/ 
                ],
                "type": "JiraSingleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v23 /*: any*/ ,
                                            v40 /*: any*/ ,
                                            v54 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v43 /*: any*/ 
                ],
                "type": "JiraMultipleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    v55 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v43 /*: any*/ 
                ],
                "type": "JiraCheckboxesField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "concreteType": "JiraUserConnection",
                        "kind": "LinkedField",
                        "name": "selectedUsersConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v22 /*: any*/ ,
                                            v56 /*: any*/ ,
                                            v33 /*: any*/ ,
                                            v57 /*: any*/ ,
                                            v23 /*: any*/ ,
                                            v58 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "email"
                                                    }
                                                ],
                                                "type": "AtlassianAccountUser"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v43 /*: any*/ 
                ],
                "type": "JiraMultipleSelectUserPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "concreteType": "JiraTeamView",
                        "kind": "LinkedField",
                        "name": "selectedTeam",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedName"
                            }
                        ]
                    },
                    v43 /*: any*/ 
                ],
                "type": "JiraTeamViewField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v23 /*: any*/ ,
                                    {
                                        "concreteType": "JiraEstimate",
                                        "kind": "LinkedField",
                                        "name": "originalEstimate",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "timeInSeconds"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraTimeTrackingSettings",
                                        "kind": "LinkedField",
                                        "name": "timeTrackingSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingHoursPerDay"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingDaysPerWeek"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultFormat"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultUnit"
                                            }
                                        ]
                                    },
                                    v28 /*: any*/ ,
                                    v33 /*: any*/ ,
                                    v36 /*: any*/ ,
                                    v43 /*: any*/ 
                                ]
                            },
                            v23 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraOriginalTimeEstimateField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "selectedOption",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "label",
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            v23 /*: any*/ ,
                            v45 /*: any*/ 
                        ]
                    },
                    v43 /*: any*/ 
                ],
                "type": "JiraRadioSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "args": v44 /*: any*/ ,
                        "concreteType": "JiraVersionConnection",
                        "kind": "LinkedField",
                        "name": "selectedVersionsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraVersionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v23 /*: any*/ ,
                                            v33 /*: any*/ ,
                                            v45 /*: any*/ ,
                                            v46 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "versionId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedVersionsConnection(first:1000)"
                    },
                    v43 /*: any*/ 
                ],
                "type": "JiraMultipleVersionPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            v23 /*: any*/ 
                        ]
                    },
                    {
                        "args": v44 /*: any*/ ,
                        "concreteType": "JiraGoalConnection",
                        "kind": "LinkedField",
                        "name": "selectedGoals",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v23 /*: any*/ ,
                                            v26 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            v59 /*: any*/ 
                        ],
                        "storageKey": "selectedGoals(first:1000)"
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            v34 /*: any*/ ,
                            v42 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraGoalsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "args": v44 /*: any*/ ,
                        "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                        "kind": "LinkedField",
                        "name": "confluenceRemoteIssueLinks",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v23 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "href"
                                            }
                                        ]
                                    }
                                ]
                            },
                            v50 /*: any*/ 
                        ],
                        "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                    },
                    v43 /*: any*/ 
                ],
                "type": "JiraConfluenceRemoteIssueLinksField"
            }
        ]
    }, v61 = {
        "kind": "ScalarField",
        "name": "message"
    }, v62 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v61 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v63 = [
        v33 /*: any*/ ,
        v23 /*: any*/ 
    ], v64 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "componentsOld",
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": v63 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v48 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v65 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v66 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v33 /*: any*/ ,
            v65 /*: any*/ ,
            v43 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v67 = {
        "kind": "InlineFragment",
        "selections": [
            v47 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v68 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v69 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v26 /*: any*/ ,
                    v68 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v70 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v71 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v33 /*: any*/ ,
                    v29 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v72 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v30 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v73 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v44 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v33 /*: any*/ ,
                                    v52 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v50 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v33 /*: any*/ ,
            v43 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v74 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v75 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v74 /*: any*/ ,
                    v33 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v76 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v48 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v77 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v52 /*: any*/ ,
            v23 /*: any*/ 
        ]
    }, v78 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v79 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v78 /*: any*/ ,
                    v33 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            },
            v23 /*: any*/ 
        ]
    }, v80 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v81 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v26 /*: any*/ ,
                    v76 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v26 /*: any*/ ,
                            v77 /*: any*/ ,
                            v79 /*: any*/ ,
                            v76 /*: any*/ ,
                            v23 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v26 /*: any*/ ,
                            v77 /*: any*/ ,
                            v79 /*: any*/ ,
                            v76 /*: any*/ ,
                            v23 /*: any*/ ,
                            v27 /*: any*/ ,
                            v80 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "summary",
                                            "issuetype",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v22 /*: any*/ ,
                                                    v23 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v28 /*: any*/ ,
                                                            v48 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v28 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    },
                                                                    v33 /*: any*/ ,
                                                                    v78 /*: any*/ ,
                                                                    v32 /*: any*/ ,
                                                                    v23 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v31 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                            }
                        ]
                    },
                    v33 /*: any*/ ,
                    v43 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v82 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    v23 /*: any*/ 
                ]
            },
            v33 /*: any*/ ,
            v43 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v83 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v33 /*: any*/ ,
                    v26 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v84 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v63 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v85 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v23 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v33 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v33 /*: any*/ ,
            v43 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v86 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v22 /*: any*/ ,
                    v56 /*: any*/ ,
                    v57 /*: any*/ ,
                    v33 /*: any*/ ,
                    v23 /*: any*/ ,
                    v58 /*: any*/ 
                ]
            },
            v33 /*: any*/ ,
            v65 /*: any*/ ,
            v43 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v87 = {
        "kind": "InlineFragment",
        "selections": [
            v33 /*: any*/ ,
            {
                "args": v44 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v63 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v88 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v89 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v33 /*: any*/ ,
                    v78 /*: any*/ ,
                    v23 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v90 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v50 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v80 /*: any*/ ,
                                            v26 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v22 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v30 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v23 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v23 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v23 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v91 = {
        "kind": "ScalarField",
        "name": "number"
    }, v92 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v93 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v91 /*: any*/ ,
            v33 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    v91 /*: any*/ ,
                    v92 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v91 /*: any*/ ,
                    v33 /*: any*/ ,
                    v92 /*: any*/ ,
                    v43 /*: any*/ 
                ]
            },
            v43 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v94 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v33 /*: any*/ ,
                    {
                        "concreteType": "JiraGroupConnection",
                        "kind": "LinkedField",
                        "name": "selectedGroupsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGroupEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGroup",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v23 /*: any*/ ,
                                            v33 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "groupId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v43 /*: any*/ 
                ],
                "type": "JiraMultipleGroupPickerField"
            }
        ]
    }, v95 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraFlag",
                        "kind": "LinkedField",
                        "name": "flag",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFlagged"
                            }
                        ]
                    }
                ],
                "type": "JiraFlagField"
            }
        ]
    }, v96 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraWatch",
                        "kind": "LinkedField",
                        "name": "watch",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isWatching"
                            }
                        ]
                    }
                ],
                "type": "JiraWatchesField"
            }
        ]
    }, v97 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v51 /*: any*/ 
    }, v98 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v36 /*: any*/ ,
                        v37 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                v28 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v38 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                v60 /*: any*/ ,
                                                v62 /*: any*/ ,
                                                v64 /*: any*/ ,
                                                v66 /*: any*/ ,
                                                v67 /*: any*/ ,
                                                v69 /*: any*/ ,
                                                v70 /*: any*/ ,
                                                v49 /*: any*/ ,
                                                v71 /*: any*/ ,
                                                v72 /*: any*/ ,
                                                v73 /*: any*/ ,
                                                v75 /*: any*/ ,
                                                v81 /*: any*/ ,
                                                v82 /*: any*/ ,
                                                v83 /*: any*/ ,
                                                v84 /*: any*/ ,
                                                v85 /*: any*/ ,
                                                v86 /*: any*/ ,
                                                v87 /*: any*/ ,
                                                v88 /*: any*/ ,
                                                v89 /*: any*/ ,
                                                v90 /*: any*/ ,
                                                v93 /*: any*/ ,
                                                v94 /*: any*/ ,
                                                v95 /*: any*/ ,
                                                v96 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v97 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ], v99 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v100 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v101 = [
        v99 /*: any*/ ,
        v25 /*: any*/ ,
        v100 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorListViewPaginationQuery",
            "selections": [
                {
                    "args": v20 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v21 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "shouldQueryHasChildren",
                                    "variableName": "shouldQueryHasChildren"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_listViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorListViewPaginationQuery",
            "selections": [
                {
                    "args": v20 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v24 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v25 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isResolved"
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v22 /*: any*/ ,
                                                                                v31 /*: any*/ ,
                                                                                v23 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v32 /*: any*/ ,
                                                                        v23 /*: any*/ 
                                                                    ]
                                                                },
                                                                v23 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v33 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                v34 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isHighlightedIssueRow"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "condition": "shouldQueryFieldSetsById",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "fieldSetIds",
                                                                                    "variableName": "fieldSetIds"
                                                                                },
                                                                                v35 /*: any*/ 
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetsById",
                                                                            "plural": false,
                                                                            "selections": v98 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldQueryFieldSetsById",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "context",
                                                                                    "variableName": "fieldSetsContext"
                                                                                },
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "filterId",
                                                                                    "variableName": "filterId"
                                                                                },
                                                                                v35 /*: any*/ ,
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "namespace",
                                                                                    "variableName": "namespace"
                                                                                },
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "viewId",
                                                                                    "variableName": "viewId"
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetsForIssueSearchView",
                                                                            "plural": false,
                                                                            "selections": v98 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v68 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v74 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v22 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 500
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v36 /*: any*/ ,
                                                                        v37 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v22 /*: any*/ ,
                                                                                                v28 /*: any*/ ,
                                                                                                v36 /*: any*/ ,
                                                                                                v38 /*: any*/ ,
                                                                                                v23 /*: any*/ ,
                                                                                                v39 /*: any*/ ,
                                                                                                v60 /*: any*/ ,
                                                                                                v62 /*: any*/ ,
                                                                                                v64 /*: any*/ ,
                                                                                                v66 /*: any*/ ,
                                                                                                v67 /*: any*/ ,
                                                                                                v69 /*: any*/ ,
                                                                                                v70 /*: any*/ ,
                                                                                                v49 /*: any*/ ,
                                                                                                v71 /*: any*/ ,
                                                                                                v72 /*: any*/ ,
                                                                                                v73 /*: any*/ ,
                                                                                                v75 /*: any*/ ,
                                                                                                v81 /*: any*/ ,
                                                                                                v82 /*: any*/ ,
                                                                                                v83 /*: any*/ ,
                                                                                                v84 /*: any*/ ,
                                                                                                v85 /*: any*/ ,
                                                                                                v86 /*: any*/ ,
                                                                                                v87 /*: any*/ ,
                                                                                                v88 /*: any*/ ,
                                                                                                v89 /*: any*/ ,
                                                                                                v90 /*: any*/ ,
                                                                                                v93 /*: any*/ ,
                                                                                                v94 /*: any*/ ,
                                                                                                v95 /*: any*/ ,
                                                                                                v96 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v55 /*: any*/ ,
                                                                                                                        v59 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v54 /*: any*/ ,
                                                                                                                v23 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                v59 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v97 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v59 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                {
                                                    "condition": "shouldQueryHasChildren",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Variable",
                                                                    "name": "filterByProjectKeys",
                                                                    "variableName": "projectKeys"
                                                                }
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "hasChildren"
                                                        },
                                                        {
                                                            "args": [
                                                                v21 /*: any*/ 
                                                            ],
                                                            "kind": "ScalarField",
                                                            "name": "canHaveChildIssues"
                                                        }
                                                    ]
                                                },
                                                v59 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "firstIssuePosition"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastIssuePosition"
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "maxCursors",
                                                    "value": 7
                                                }
                                            ],
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": v101 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "last",
                                                    "plural": false,
                                                    "selections": v101 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "first",
                                                    "plural": false,
                                                    "selections": [
                                                        v25 /*: any*/ ,
                                                        v99 /*: any*/ ,
                                                        v100 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "pageCursors(maxCursors:7)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalIssueSearchResultCount"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "issueSearchError",
                                            "plural": false,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "messages"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidJqlError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v61 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "errorType"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidSyntaxError"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCappingIssueSearchResult"
                                        },
                                        v59 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v24 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorListViewPagination__issues",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                }
                            ],
                            "type": "JiraListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6addc8805f5413513007f0734ff0c676feb82e9ea4b8b877b19736ab66dbb00e",
            "metadata": {},
            "name": "IssueNavigatorListViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": (0, $bqIzm.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $fjldt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$da7dcbb616d0e1e8$var$node.hash = "6fd17d4b441f85305e759e82f963bd19";
var $da7dcbb616d0e1e8$export$2e2bcd8739ae039 = $da7dcbb616d0e1e8$var$node;

});


parcelRegister("4hr2P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3be423d0774ab04$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<038d52b681a72d58f8f533420cf580f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $h5DJ3 = parcelRequire("h5DJ3");
const $e3be423d0774ab04$var$node = function() {
    var v0 = [
        "groups"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsContext"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "kind": "RootArgument",
                "name": "isPaginating"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $h5DJ3.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_groupedListViewData",
        "selections": [
            {
                "alias": "groups",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "concreteType": "JiraSpreadsheetGroupConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorGroupedListViewPagination__groups_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSpreadsheetGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraSpreadsheetGroup",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_groupResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraGroupedListView"
    };
}();
$e3be423d0774ab04$var$node.hash = "899edbd4ab306cc11af57fd78c9fef95";
var $e3be423d0774ab04$export$2e2bcd8739ae039 = $e3be423d0774ab04$var$node;

});
parcelRegister("h5DJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d572787bd96388ee$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<452573b1b7514b08e94eed2e79c6a778>>
 * @relayHash a7218d67e8b463f12961b85f31999a63
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c9e279d81242bfd5db48698b41ba8628d4656639b7c6c3f9e72ea090ea6111d7

var $cNAof = parcelRequire("cNAof");

var $bqIzm = parcelRequire("bqIzm");

var $fjldt = parcelRequire("fjldt");

var $5oQtH = parcelRequire("5oQtH");

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $d572787bd96388ee$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v19 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v20 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v21 = {
        "kind": "ScalarField",
        "name": "id"
    }, v22 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "groupBy",
            "variableName": "groupBy"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        }
    ], v23 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v24 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v25 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v27 = {
        "kind": "ScalarField",
        "name": "name"
    }, v28 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v21 /*: any*/ 
        ]
    }, v29 = [
        v27 /*: any*/ ,
        v28 /*: any*/ 
    ], v30 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v31 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v32 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v33 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v34 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v35 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v34 /*: any*/ ,
            v21 /*: any*/ 
        ]
    }, v36 = {
        "kind": "ScalarField",
        "name": "number"
    }, v37 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v38 = {
        "kind": "ScalarField",
        "name": "value"
    }, v39 = [
        v21 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "sprintId"
        },
        v27 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "state"
        },
        {
            "kind": "ScalarField",
            "name": "endDate"
        }
    ], v40 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jqlTerm"
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "label",
                                "plural": false,
                                "selections": v29 /*: any*/ 
                            }
                        ],
                        "type": "JiraJqlLabelFieldValue"
                    }
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            v21 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "priorityId"
                            },
                            v27 /*: any*/ ,
                            v30 /*: any*/ 
                        ]
                    },
                    v31 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v20 /*: any*/ ,
                            v21 /*: any*/ ,
                            v32 /*: any*/ ,
                            v27 /*: any*/ ,
                            v33 /*: any*/ 
                        ]
                    },
                    v31 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v21 /*: any*/ ,
                            v27 /*: any*/ ,
                            {
                                "concreteType": "JiraStatusCategory",
                                "kind": "LinkedField",
                                "name": "statusCategory",
                                "plural": false,
                                "selections": [
                                    v21 /*: any*/ ,
                                    v34 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v31 /*: any*/ ,
                    v35 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v36 /*: any*/ 
                ],
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v21 /*: any*/ ,
                            v37 /*: any*/ ,
                            v38 /*: any*/ ,
                            v28 /*: any*/ 
                        ]
                    },
                    v31 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": v39 /*: any*/ 
                    },
                    v31 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v21 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            }
                        ]
                    },
                    v31 /*: any*/ 
                ],
                "type": "JiraJqlGoalsFieldValue"
            }
        ]
    }, v41 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v42 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v43 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v44 = {
        "kind": "ScalarField",
        "name": "message"
    }, v45 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v46 = {
        "kind": "ScalarField",
        "name": "key"
    }, v47 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v48 = {
        "kind": "InlineFragment",
        "selections": [
            v25 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v35 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v49 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v50 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v51 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v52 = {
        "kind": "ScalarField",
        "name": "type"
    }, v53 = [
        v38 /*: any*/ ,
        v21 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v54 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v55 = {
        "kind": "ClientExtension",
        "selections": [
            v54 /*: any*/ 
        ]
    }, v56 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v57 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v58 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v59 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v60 = {
        "kind": "ScalarField",
        "name": "text"
    }, v61 = {
        "kind": "InlineFragment",
        "selections": [
            v60 /*: any*/ ,
            v27 /*: any*/ ,
            v55 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v62 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v63 = [
        v62 /*: any*/ 
    ], v64 = [
        v28 /*: any*/ 
    ], v65 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v66 = {
        "kind": "ClientExtension",
        "selections": [
            v50 /*: any*/ 
        ]
    }, v67 = [
        v27 /*: any*/ ,
        v21 /*: any*/ 
    ], v68 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v69 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v60 /*: any*/ ,
            v21 /*: any*/ 
        ]
    }, v70 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v28 /*: any*/ ,
            v21 /*: any*/ 
        ]
    }, v71 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v72 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v71 /*: any*/ ,
                    v27 /*: any*/ ,
                    v21 /*: any*/ 
                ]
            },
            v21 /*: any*/ 
        ]
    }, v73 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v74 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v75 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v52 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "fieldSetId"
                        },
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v20 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                v52 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isJiraIssueField"
                                                },
                                                v21 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraAffectedServiceConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedAffectedServicesConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAffectedService",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "serviceId"
                                                                                },
                                                                                v27 /*: any*/ ,
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraAffectedServicesField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraCascadingOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "cascadingOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "parentOptionValue",
                                                                            "plural": false,
                                                                            "selections": v53 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraOption",
                                                                            "kind": "LinkedField",
                                                                            "name": "childOptionValue",
                                                                            "plural": false,
                                                                            "selections": v53 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v55 /*: any*/ 
                                                            ],
                                                            "type": "JiraCascadingSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "args": v56 /*: any*/ ,
                                                                    "concreteType": "JiraComponentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedComponentsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraComponent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v57 /*: any*/ ,
                                                                                        v58 /*: any*/ ,
                                                                                        v21 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                },
                                                                v55 /*: any*/ 
                                                            ],
                                                            "type": "JiraComponentsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v59 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v55 /*: any*/ 
                                                            ],
                                                            "type": "JiraDateTimePickerField"
                                                        },
                                                        v61 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCommentSummary",
                                                                    "kind": "LinkedField",
                                                                    "name": "commentSummary",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canAddComment"
                                                                        },
                                                                        v62 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraCommentSummaryField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "uri"
                                                                },
                                                                v55 /*: any*/ 
                                                            ],
                                                            "type": "JiraUrlField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOptions",
                                                                    "plural": false,
                                                                    "selections": v63 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "fieldOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v38 /*: any*/ ,
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v64 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": v64 /*: any*/ 
                                                                        },
                                                                        v21 /*: any*/ ,
                                                                        v37 /*: any*/ 
                                                                    ]
                                                                },
                                                                v55 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        v38 /*: any*/ ,
                                                                                        v37 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v55 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOptionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOptions",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraOptionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraOption",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        v38 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v55 /*: any*/ 
                                                            ],
                                                            "type": "JiraCheckboxesField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraUserConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedUsersConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraUserEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v20 /*: any*/ ,
                                                                                        v32 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        v33 /*: any*/ ,
                                                                                        v21 /*: any*/ ,
                                                                                        v65 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "email"
                                                                                                }
                                                                                            ],
                                                                                            "type": "AtlassianAccountUser"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v55 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleSelectUserPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraTeamView",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedTeam",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraSuppliedId"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jiraSuppliedName"
                                                                        }
                                                                    ]
                                                                },
                                                                v55 /*: any*/ 
                                                            ],
                                                            "type": "JiraTeamViewField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraTimeTrackingField",
                                                                            "kind": "LinkedField",
                                                                            "name": "timeTrackingField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v21 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraEstimate",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "originalEstimate",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "timeInSeconds"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "timeTrackingSettings",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "workingHoursPerDay"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "workingDaysPerWeek"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultFormat"
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "defaultUnit"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v25 /*: any*/ ,
                                                                                v27 /*: any*/ ,
                                                                                v52 /*: any*/ ,
                                                                                v55 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraOriginalTimeEstimateField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraOption",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedOption",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": "label",
                                                                            "kind": "ScalarField",
                                                                            "name": "value"
                                                                        },
                                                                        v21 /*: any*/ ,
                                                                        v57 /*: any*/ 
                                                                    ]
                                                                },
                                                                v55 /*: any*/ 
                                                            ],
                                                            "type": "JiraRadioSelectField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "args": v56 /*: any*/ ,
                                                                    "concreteType": "JiraVersionConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedVersionsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersionEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraVersion",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        v57 /*: any*/ ,
                                                                                        v58 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "versionId"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                },
                                                                v55 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleVersionPickerField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "issue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": v56 /*: any*/ ,
                                                                    "concreteType": "JiraGoalConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedGoals",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraGoalEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraGoal",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        v46 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v66 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                },
                                                                {
                                                                    "kind": "ClientExtension",
                                                                    "selections": [
                                                                        v50 /*: any*/ ,
                                                                        v54 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraGoalsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "args": v56 /*: any*/ ,
                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "confluenceRemoteIssueLinks",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "href"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        v62 /*: any*/ 
                                                                    ],
                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                },
                                                                v55 /*: any*/ 
                                                            ],
                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraCmdbObjectConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedCmdbObjectsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraCmdbObject",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "objectId"
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "label"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "avatar",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "mediaClientConfig",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "clientId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "fileId"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaBaseUrl"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "mediaJwtToken"
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "url48"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "QueryError",
                                                                    "kind": "LinkedField",
                                                                    "name": "errors",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v44 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraCMDBField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": "componentsOld",
                                                                    "concreteType": "JiraComponentConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedComponentsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraComponentEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraComponent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": v67 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraComponentsField"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v60 /*: any*/ 
                                                            ],
                                                            "type": "JiraSingleLineTextField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "date"
                                                        },
                                                        v27 /*: any*/ ,
                                                        v68 /*: any*/ ,
                                                        v55 /*: any*/ 
                                                    ],
                                                    "type": "JiraDatePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v59 /*: any*/ 
                                                    ],
                                                    "type": "JiraDateTimePickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraEpic",
                                                            "kind": "LinkedField",
                                                            "name": "epic",
                                                            "plural": false,
                                                            "selections": [
                                                                v46 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "summary"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "color"
                                                                },
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraEpicLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "renderedFieldHtml"
                                                        }
                                                    ],
                                                    "type": "JiraFallbackField"
                                                },
                                                v61 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatusCategory",
                                                            "kind": "LinkedField",
                                                            "name": "statusCategory",
                                                            "plural": false,
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                v34 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusCategoryField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "statusId"
                                                                },
                                                                v35 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraStatusField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v56 /*: any*/ ,
                                                            "concreteType": "JiraLabelConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedLabelsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraLabelEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraLabel",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v29 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v62 /*: any*/ 
                                                            ],
                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                        },
                                                        v27 /*: any*/ ,
                                                        v55 /*: any*/ 
                                                    ],
                                                    "type": "JiraLabelsField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueType",
                                                            "kind": "LinkedField",
                                                            "name": "issueType",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "small"
                                                                        }
                                                                    ]
                                                                },
                                                                v27 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraIssueTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "parentIssue",
                                                            "plural": false,
                                                            "selections": [
                                                                v46 /*: any*/ ,
                                                                v69 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        v70 /*: any*/ ,
                                                                        v72 /*: any*/ ,
                                                                        v69 /*: any*/ ,
                                                                        v21 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssue",
                                                                    "kind": "LinkedField",
                                                                    "name": "parentIssue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        v70 /*: any*/ ,
                                                                        v72 /*: any*/ ,
                                                                        v69 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v47 /*: any*/ ,
                                                                        v73 /*: any*/ ,
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                        "summary",
                                                                                        "issuetype",
                                                                                        "status"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v20 /*: any*/ ,
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        v60 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v25 /*: any*/ ,
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "issueTypeId"
                                                                                                                },
                                                                                                                v27 /*: any*/ ,
                                                                                                                v71 /*: any*/ ,
                                                                                                                v49 /*: any*/ ,
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                v48 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                                        }
                                                                    ]
                                                                },
                                                                v27 /*: any*/ ,
                                                                v55 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraParentIssueField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraPriority",
                                                            "kind": "LinkedField",
                                                            "name": "priority",
                                                            "plural": false,
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                v30 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        },
                                                        v27 /*: any*/ ,
                                                        v55 /*: any*/ 
                                                    ],
                                                    "type": "JiraPriorityField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                v46 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraAvatar",
                                                                    "kind": "LinkedField",
                                                                    "name": "avatar",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "large"
                                                                        }
                                                                    ]
                                                                },
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraProjectField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraResolution",
                                                            "kind": "LinkedField",
                                                            "name": "resolution",
                                                            "plural": false,
                                                            "selections": v67 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "JiraResolutionField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSprintConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedSprintsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraSprintEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraSprint",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v39 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v27 /*: any*/ ,
                                                        v55 /*: any*/ 
                                                    ],
                                                    "type": "JiraSprintField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "user",
                                                            "plural": false,
                                                            "selections": [
                                                                v20 /*: any*/ ,
                                                                v32 /*: any*/ ,
                                                                v33 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v21 /*: any*/ ,
                                                                v65 /*: any*/ 
                                                            ]
                                                        },
                                                        v27 /*: any*/ ,
                                                        v68 /*: any*/ ,
                                                        v55 /*: any*/ 
                                                    ],
                                                    "type": "JiraSingleSelectUserPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v27 /*: any*/ ,
                                                        {
                                                            "args": v56 /*: any*/ ,
                                                            "concreteType": "JiraVersionConnection",
                                                            "kind": "LinkedField",
                                                            "name": "selectedVersionsConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraVersionEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraVersion",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": v67 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                        }
                                                    ],
                                                    "type": "JiraMultipleVersionPickerField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraRichText",
                                                            "kind": "LinkedField",
                                                            "name": "richText",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraADF",
                                                                    "kind": "LinkedField",
                                                                    "name": "adfValue",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                            "kind": "LinkedField",
                                                                            "name": "convertedPlainText",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "plainText"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraRichTextField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraServiceManagementRequestType",
                                                            "kind": "LinkedField",
                                                            "name": "requestType",
                                                            "plural": false,
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                v71 /*: any*/ ,
                                                                v21 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraServiceManagementRequestTypeField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "first",
                                                                    "value": 1
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueLinkConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issueLinkConnection",
                                                            "plural": false,
                                                            "selections": [
                                                                v62 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueLink",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v73 /*: any*/ ,
                                                                                        v46 /*: any*/ ,
                                                                                        {
                                                                                            "args": [
                                                                                                {
                                                                                                    "kind": "Literal",
                                                                                                    "name": "ids",
                                                                                                    "value": [
                                                                                                        "statusCategory"
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "fieldsById",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "edges",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "node",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v20 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "InlineFragment",
                                                                                                                    "selections": [
                                                                                                                        v35 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                },
                                                                                                                v21 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                        },
                                                                                        v21 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "relationName"
                                                                                },
                                                                                v21 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "issueLinkConnection(first:1)"
                                                        }
                                                    ],
                                                    "type": "JiraIssueLinkField"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isStoryPointField"
                                                        },
                                                        v36 /*: any*/ ,
                                                        v27 /*: any*/ ,
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                v74 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v36 /*: any*/ ,
                                                                v27 /*: any*/ ,
                                                                v74 /*: any*/ ,
                                                                v55 /*: any*/ 
                                                            ]
                                                        },
                                                        v55 /*: any*/ 
                                                    ],
                                                    "type": "JiraNumberField"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraGroupConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "selectedGroupsConnection",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraGroupEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraGroup",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v21 /*: any*/ ,
                                                                                        v27 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "groupId"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v55 /*: any*/ 
                                                            ],
                                                            "type": "JiraMultipleGroupPickerField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFlag",
                                                                    "kind": "LinkedField",
                                                                    "name": "flag",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isFlagged"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraFlagField"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraWatch",
                                                                    "kind": "LinkedField",
                                                                    "name": "watch",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "count"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isWatching"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraWatchesField"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": v63 /*: any*/ 
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorGroupedListViewPaginationQuery",
            "selections": [
                {
                    "args": v19 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "projectKey",
                                    "variableName": "projectKey"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_groupedListViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v9 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorGroupedListViewPaginationQuery",
            "selections": [
                {
                    "args": v19 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v20 /*: any*/ ,
                        v21 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v22 /*: any*/ ,
                                    "concreteType": "JiraSpreadsheetGroupConnection",
                                    "kind": "LinkedField",
                                    "name": "groups",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSpreadsheetGroupEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v23 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraSpreadsheetGroup",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        v41 /*: any*/ 
                                                    ]
                                                },
                                                v20 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                v42 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                v43 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "groupByField"
                                        },
                                        v24 /*: any*/ ,
                                        {
                                            "concreteType": "QueryError",
                                            "kind": "LinkedField",
                                            "name": "errors",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "extensions",
                                                    "plural": true,
                                                    "selections": [
                                                        v20 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "statusCode"
                                                        }
                                                    ]
                                                },
                                                v44 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "isPaginating",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSpreadsheetGroup",
                                                    "kind": "LinkedField",
                                                    "name": "firstGroup",
                                                    "plural": false,
                                                    "selections": [
                                                        v21 /*: any*/ ,
                                                        {
                                                            "args": v45 /*: any*/ ,
                                                            "concreteType": "JiraIssueConnection",
                                                            "kind": "LinkedField",
                                                            "name": "issues",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssue",
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v20 /*: any*/ ,
                                                                                v21 /*: any*/ ,
                                                                                v46 /*: any*/ ,
                                                                                v47 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isResolved"
                                                                                },
                                                                                {
                                                                                    "args": [
                                                                                        {
                                                                                            "kind": "Literal",
                                                                                            "name": "ids",
                                                                                            "value": [
                                                                                                "status"
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "concreteType": "JiraIssueFieldConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldsById",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueFieldEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v20 /*: any*/ ,
                                                                                                        v48 /*: any*/ ,
                                                                                                        v21 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": "fieldsById(ids:[\"status\"])"
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraIssueTypeField",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueTypeField",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v49 /*: any*/ ,
                                                                                                v21 /*: any*/ 
                                                                                            ]
                                                                                        },
                                                                                        v21 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueTypeField",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueTypeField",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueType",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v27 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "kind": "ClientExtension",
                                                                                    "selections": [
                                                                                        v50 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "isHighlightedIssueRow"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "condition": "shouldQueryFieldSetsById",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "fieldSetIds",
                                                                                                            "variableName": "fieldSetIds"
                                                                                                        },
                                                                                                        v51 /*: any*/ 
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldSetsById",
                                                                                                    "plural": false,
                                                                                                    "selections": v75 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        },
                                                                                        {
                                                                                            "condition": "shouldQueryFieldSetsById",
                                                                                            "kind": "Condition",
                                                                                            "passingValue": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "args": [
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "context",
                                                                                                            "variableName": "fieldSetsContext"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "filterId",
                                                                                                            "variableName": "filterId"
                                                                                                        },
                                                                                                        v51 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "namespace",
                                                                                                            "variableName": "namespace"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "Variable",
                                                                                                            "name": "viewId",
                                                                                                            "variableName": "viewId"
                                                                                                        }
                                                                                                    ],
                                                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "fieldSetsForIssueSearchView",
                                                                                                    "plural": false,
                                                                                                    "selections": v75 /*: any*/ 
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "first",
                                                                                    "value": 500
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSets",
                                                                            "plural": false,
                                                                            "selections": v75 /*: any*/ ,
                                                                            "storageKey": "fieldSets(first:500)"
                                                                        },
                                                                        v66 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "PageInfo",
                                                                    "kind": "LinkedField",
                                                                    "name": "pageInfo",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v42 /*: any*/ ,
                                                                        v43 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "totalIssueSearchResultCount"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isCappingIssueSearchResult"
                                                                },
                                                                v66 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v45 /*: any*/ ,
                                                            "filters": [
                                                                "fieldSetsInput"
                                                            ],
                                                            "handle": "connection",
                                                            "key": "firstGroupSection_nativeIssueTable__issues",
                                                            "kind": "LinkedHandle",
                                                            "name": "issues"
                                                        },
                                                        v24 /*: any*/ ,
                                                        v25 /*: any*/ ,
                                                        v26 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        v41 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v66 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v22 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorGroupedListViewPagination__groups",
                                    "kind": "LinkedHandle",
                                    "name": "groups"
                                }
                            ],
                            "type": "JiraGroupedListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "c9e279d81242bfd5db48698b41ba8628d4656639b7c6c3f9e72ea090ea6111d7",
            "metadata": {},
            "name": "IssueNavigatorGroupedListViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": (0, $bqIzm.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider": (0, $cNAof.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $fjldt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$d572787bd96388ee$var$node.hash = "899edbd4ab306cc11af57fd78c9fef95";
var $d572787bd96388ee$export$2e2bcd8739ae039 = $d572787bd96388ee$var$node;

});


parcelRegister("9hXMi", function(module, exports) {

$parcel$export(module.exports, "default", () => $544fce572f6eb084$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<af35b869f8ae49feedd50c4b0116f492>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $4wBJE = parcelRequire("4wBJE");
const $544fce572f6eb084$var$node = function() {
    var v0 = [
        "issues"
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsContext"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": null,
                    "direction": "bidirectional",
                    "path": v0 /*: any*/ 
                }
            ],
            "refetch": {
                "connection": {
                    "forward": {
                        "count": "first",
                        "cursor": "after"
                    },
                    "backward": {
                        "count": "last",
                        "cursor": "before"
                    },
                    "path": v0 /*: any*/ 
                },
                "fragmentPathInResult": [
                    "node"
                ],
                "operation": (0, $4wBJE.default),
                "identifierInfo": {
                    "identifierField": "id",
                    "identifierQueryVariableName": "id"
                }
            }
        },
        "name": "main_issueNavigator_IssueNavigator_detailedViewData",
        "selections": [
            {
                "alias": "issues",
                "args": [
                    {
                        "kind": "Variable",
                        "name": "issueSearchInput",
                        "variableName": "issueSearchInput"
                    }
                ],
                "concreteType": "JiraIssueConnection",
                "kind": "LinkedField",
                "name": "__IssueNavigatorDetailedViewPagination__issues_connection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "cursor"
                            },
                            {
                                "concreteType": "JiraIssue",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "__typename"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "endCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "startCursor"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasNextPage"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "hasPreviousPage"
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "selectedIssue_issueNavigator"
                    },
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "projectKey",
                                "variableName": "projectKey"
                            },
                            {
                                "kind": "Variable",
                                "name": "projectKeys",
                                "variableName": "projectKeys"
                            },
                            {
                                "kind": "Literal",
                                "name": "shouldQueryHasChildren",
                                "value": false
                            }
                        ],
                        "kind": "FragmentSpread",
                        "name": "main_issueNavigator_IssueNavigatorUI_issueResults"
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "name": "id"
            }
        ],
        "type": "JiraDetailedView"
    };
}();
$544fce572f6eb084$var$node.hash = "b55231f2326f70fb819ca3062e0201a6";
var $544fce572f6eb084$export$2e2bcd8739ae039 = $544fce572f6eb084$var$node;

});
parcelRegister("4wBJE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a71ac203dea02c63$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ce22f711cdd12f81b3d5474f418e6de3>>
 * @relayHash 94920c01d4a95c4ecbac8b38cc190a04
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e716748403578a037a5c375e279dcf577e5beac12ece64ae4b0e49c3abcf029

var $bqIzm = parcelRequire("bqIzm");

var $fjldt = parcelRequire("fjldt");

var $5oQtH = parcelRequire("5oQtH");

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $k3PJZ = parcelRequire("k3PJZ");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $a71ac203dea02c63$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v18 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v19 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v20 = {
        "kind": "ScalarField",
        "name": "id"
    }, v21 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "before",
            "variableName": "before"
        },
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        },
        {
            "kind": "Variable",
            "name": "last",
            "variableName": "last"
        },
        {
            "kind": "Variable",
            "name": "options",
            "variableName": "options"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "scope"
        }
    ], v22 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v23 = {
        "kind": "ScalarField",
        "name": "key"
    }, v24 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v25 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v26 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v27 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v26 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            v25 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v27 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v29 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v30 = {
        "kind": "ScalarField",
        "name": "name"
    }, v31 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v32 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v33 = {
        "kind": "ScalarField",
        "name": "type"
    }, v34 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v35 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v36 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v30 /*: any*/ ,
                                    v20 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v37 = {
        "kind": "ScalarField",
        "name": "value"
    }, v38 = [
        v37 /*: any*/ ,
        v20 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v39 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v40 = {
        "kind": "ClientExtension",
        "selections": [
            v39 /*: any*/ 
        ]
    }, v41 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v42 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v43 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v44 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v45 = {
        "kind": "ScalarField",
        "name": "text"
    }, v46 = {
        "kind": "InlineFragment",
        "selections": [
            v45 /*: any*/ ,
            v30 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v47 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v48 = [
        v47 /*: any*/ 
    ], v49 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v20 /*: any*/ 
        ]
    }, v50 = [
        v49 /*: any*/ 
    ], v51 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v52 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v37 /*: any*/ 
        ]
    }, v53 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v54 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v55 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v56 = {
        "kind": "ClientExtension",
        "selections": [
            v31 /*: any*/ 
        ]
    }, v57 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraCascadingOption",
                        "kind": "LinkedField",
                        "name": "cascadingOption",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "parentOptionValue",
                                "plural": false,
                                "selections": v38 /*: any*/ 
                            },
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "childOptionValue",
                                "plural": false,
                                "selections": v38 /*: any*/ 
                            }
                        ]
                    },
                    v40 /*: any*/ 
                ],
                "type": "JiraCascadingSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "args": v41 /*: any*/ ,
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v42 /*: any*/ ,
                                            v43 /*: any*/ ,
                                            v20 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedComponentsConnection(first:1000)"
                    },
                    v40 /*: any*/ 
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v44 /*: any*/ ,
                    v30 /*: any*/ ,
                    v40 /*: any*/ 
                ],
                "type": "JiraDateTimePickerField"
            },
            v46 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraCommentSummary",
                        "kind": "LinkedField",
                        "name": "commentSummary",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "canAddComment"
                            },
                            v47 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraCommentSummaryField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "uri"
                    },
                    v40 /*: any*/ 
                ],
                "type": "JiraUrlField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "fieldOptions",
                        "plural": false,
                        "selections": v48 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "fieldOption",
                        "plural": false,
                        "selections": [
                            v37 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v50 /*: any*/ 
                            },
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v50 /*: any*/ 
                            },
                            v20 /*: any*/ ,
                            v51 /*: any*/ 
                        ]
                    },
                    v40 /*: any*/ 
                ],
                "type": "JiraSingleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v20 /*: any*/ ,
                                            v37 /*: any*/ ,
                                            v51 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v40 /*: any*/ 
                ],
                "type": "JiraMultipleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    v52 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v40 /*: any*/ 
                ],
                "type": "JiraCheckboxesField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraUserConnection",
                        "kind": "LinkedField",
                        "name": "selectedUsersConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v19 /*: any*/ ,
                                            v53 /*: any*/ ,
                                            v30 /*: any*/ ,
                                            v54 /*: any*/ ,
                                            v20 /*: any*/ ,
                                            v55 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "email"
                                                    }
                                                ],
                                                "type": "AtlassianAccountUser"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v40 /*: any*/ 
                ],
                "type": "JiraMultipleSelectUserPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraTeamView",
                        "kind": "LinkedField",
                        "name": "selectedTeam",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedName"
                            }
                        ]
                    },
                    v40 /*: any*/ 
                ],
                "type": "JiraTeamViewField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v20 /*: any*/ ,
                                    {
                                        "concreteType": "JiraEstimate",
                                        "kind": "LinkedField",
                                        "name": "originalEstimate",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "timeInSeconds"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraTimeTrackingSettings",
                                        "kind": "LinkedField",
                                        "name": "timeTrackingSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingHoursPerDay"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingDaysPerWeek"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultFormat"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultUnit"
                                            }
                                        ]
                                    },
                                    v25 /*: any*/ ,
                                    v30 /*: any*/ ,
                                    v33 /*: any*/ ,
                                    v40 /*: any*/ 
                                ]
                            },
                            v20 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraOriginalTimeEstimateField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "selectedOption",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "label",
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            v20 /*: any*/ ,
                            v42 /*: any*/ 
                        ]
                    },
                    v40 /*: any*/ 
                ],
                "type": "JiraRadioSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "args": v41 /*: any*/ ,
                        "concreteType": "JiraVersionConnection",
                        "kind": "LinkedField",
                        "name": "selectedVersionsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraVersionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v20 /*: any*/ ,
                                            v30 /*: any*/ ,
                                            v42 /*: any*/ ,
                                            v43 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "versionId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedVersionsConnection(first:1000)"
                    },
                    v40 /*: any*/ 
                ],
                "type": "JiraMultipleVersionPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            v20 /*: any*/ 
                        ]
                    },
                    {
                        "args": v41 /*: any*/ ,
                        "concreteType": "JiraGoalConnection",
                        "kind": "LinkedField",
                        "name": "selectedGoals",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v20 /*: any*/ ,
                                            v23 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            v56 /*: any*/ 
                        ],
                        "storageKey": "selectedGoals(first:1000)"
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            v31 /*: any*/ ,
                            v39 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraGoalsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "args": v41 /*: any*/ ,
                        "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                        "kind": "LinkedField",
                        "name": "confluenceRemoteIssueLinks",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v20 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "href"
                                            }
                                        ]
                                    }
                                ]
                            },
                            v47 /*: any*/ 
                        ],
                        "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                    },
                    v40 /*: any*/ 
                ],
                "type": "JiraConfluenceRemoteIssueLinksField"
            }
        ]
    }, v58 = {
        "kind": "ScalarField",
        "name": "message"
    }, v59 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v58 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v60 = [
        v30 /*: any*/ ,
        v20 /*: any*/ 
    ], v61 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "componentsOld",
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": v60 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v45 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v62 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v30 /*: any*/ ,
            v62 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v64 = {
        "kind": "InlineFragment",
        "selections": [
            v44 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v65 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v66 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v65 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v67 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v68 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v26 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v69 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v27 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v70 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v41 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v30 /*: any*/ ,
                                    v49 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v47 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v30 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v71 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v72 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v71 /*: any*/ ,
                    v30 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v73 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v45 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v74 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v49 /*: any*/ ,
            v20 /*: any*/ 
        ]
    }, v75 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v76 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v75 /*: any*/ ,
                    v30 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            },
            v20 /*: any*/ 
        ]
    }, v77 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v78 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v23 /*: any*/ ,
                    v73 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v23 /*: any*/ ,
                            v74 /*: any*/ ,
                            v76 /*: any*/ ,
                            v73 /*: any*/ ,
                            v20 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v23 /*: any*/ ,
                            v74 /*: any*/ ,
                            v76 /*: any*/ ,
                            v73 /*: any*/ ,
                            v20 /*: any*/ ,
                            v24 /*: any*/ ,
                            v77 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "summary",
                                            "issuetype",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v19 /*: any*/ ,
                                                    v20 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v25 /*: any*/ ,
                                                            v45 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v25 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    },
                                                                    v30 /*: any*/ ,
                                                                    v75 /*: any*/ ,
                                                                    v29 /*: any*/ ,
                                                                    v20 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v28 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                            }
                        ]
                    },
                    v30 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v79 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "iconUrl"
                    },
                    v20 /*: any*/ 
                ]
            },
            v30 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v80 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v23 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v81 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v60 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v82 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v20 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "sprintId"
                                    },
                                    v30 /*: any*/ ,
                                    {
                                        "kind": "ScalarField",
                                        "name": "state"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "endDate"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            v30 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v83 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v19 /*: any*/ ,
                    v53 /*: any*/ ,
                    v54 /*: any*/ ,
                    v30 /*: any*/ ,
                    v20 /*: any*/ ,
                    v55 /*: any*/ 
                ]
            },
            v30 /*: any*/ ,
            v62 /*: any*/ ,
            v40 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v84 = {
        "kind": "InlineFragment",
        "selections": [
            v30 /*: any*/ ,
            {
                "args": v41 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v60 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v85 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v86 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v75 /*: any*/ ,
                    v20 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v87 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v47 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v77 /*: any*/ ,
                                            v23 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v19 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v27 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v20 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v20 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v20 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v88 = {
        "kind": "ScalarField",
        "name": "number"
    }, v89 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v90 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v88 /*: any*/ ,
            v30 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    v88 /*: any*/ ,
                    v89 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v88 /*: any*/ ,
                    v30 /*: any*/ ,
                    v89 /*: any*/ ,
                    v40 /*: any*/ 
                ]
            },
            v40 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v91 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v30 /*: any*/ ,
                    {
                        "concreteType": "JiraGroupConnection",
                        "kind": "LinkedField",
                        "name": "selectedGroupsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGroupEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGroup",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v20 /*: any*/ ,
                                            v30 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "groupId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v40 /*: any*/ 
                ],
                "type": "JiraMultipleGroupPickerField"
            }
        ]
    }, v92 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraFlag",
                        "kind": "LinkedField",
                        "name": "flag",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFlagged"
                            }
                        ]
                    }
                ],
                "type": "JiraFlagField"
            }
        ]
    }, v93 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraWatch",
                        "kind": "LinkedField",
                        "name": "watch",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isWatching"
                            }
                        ]
                    }
                ],
                "type": "JiraWatchesField"
            }
        ]
    }, v94 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v48 /*: any*/ 
    }, v95 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v33 /*: any*/ ,
                        v34 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v35 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v36 /*: any*/ ,
                                                v57 /*: any*/ ,
                                                v59 /*: any*/ ,
                                                v61 /*: any*/ ,
                                                v63 /*: any*/ ,
                                                v64 /*: any*/ ,
                                                v66 /*: any*/ ,
                                                v67 /*: any*/ ,
                                                v46 /*: any*/ ,
                                                v68 /*: any*/ ,
                                                v69 /*: any*/ ,
                                                v70 /*: any*/ ,
                                                v72 /*: any*/ ,
                                                v78 /*: any*/ ,
                                                v79 /*: any*/ ,
                                                v80 /*: any*/ ,
                                                v81 /*: any*/ ,
                                                v82 /*: any*/ ,
                                                v83 /*: any*/ ,
                                                v84 /*: any*/ ,
                                                v85 /*: any*/ ,
                                                v86 /*: any*/ ,
                                                v87 /*: any*/ ,
                                                v90 /*: any*/ ,
                                                v91 /*: any*/ ,
                                                v92 /*: any*/ ,
                                                v93 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v94 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ], v96 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v97 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v98 = [
        v96 /*: any*/ ,
        v22 /*: any*/ ,
        v97 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorDetailedViewPaginationQuery",
            "selections": [
                {
                    "args": v18 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "projectKey",
                                    "variableName": "projectKey"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "projectKeys",
                                    "variableName": "projectKeys"
                                }
                            ],
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_IssueNavigator_detailedViewData"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v8 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorDetailedViewPaginationQuery",
            "selections": [
                {
                    "args": v18 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v19 /*: any*/ ,
                        v20 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v21 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "issues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                v22 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v23 /*: any*/ ,
                                                        v24 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isResolved"
                                                        },
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "ids",
                                                                    "value": [
                                                                        "status"
                                                                    ]
                                                                }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v19 /*: any*/ ,
                                                                                v28 /*: any*/ ,
                                                                                v20 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"status\"])"
                                                        },
                                                        {
                                                            "concreteType": "JiraIssueTypeField",
                                                            "kind": "LinkedField",
                                                            "name": "issueTypeField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v29 /*: any*/ ,
                                                                        v20 /*: any*/ 
                                                                    ]
                                                                },
                                                                v20 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v30 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ClientExtension",
                                                            "selections": [
                                                                v31 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isHighlightedIssueRow"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": false,
                                                            "selections": [
                                                                {
                                                                    "condition": "shouldQueryFieldSetsById",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "fieldSetIds",
                                                                                    "variableName": "fieldSetIds"
                                                                                },
                                                                                v32 /*: any*/ 
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetsById",
                                                                            "plural": false,
                                                                            "selections": v95 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "shouldQueryFieldSetsById",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "context",
                                                                                    "variableName": "fieldSetsContext"
                                                                                },
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "filterId",
                                                                                    "variableName": "filterId"
                                                                                },
                                                                                v32 /*: any*/ ,
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "namespace",
                                                                                    "variableName": "namespace"
                                                                                },
                                                                                {
                                                                                    "kind": "Variable",
                                                                                    "name": "viewId",
                                                                                    "variableName": "viewId"
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldSetConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetsForIssueSearchView",
                                                                            "plural": false,
                                                                            "selections": v95 /*: any*/ 
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                v65 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueTypeField",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueTypeField",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v71 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v19 /*: any*/ ,
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "first",
                                                            "value": 500
                                                        }
                                                    ],
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v33 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v19 /*: any*/ ,
                                                                                                v25 /*: any*/ ,
                                                                                                v33 /*: any*/ ,
                                                                                                v35 /*: any*/ ,
                                                                                                v20 /*: any*/ ,
                                                                                                v36 /*: any*/ ,
                                                                                                v57 /*: any*/ ,
                                                                                                v59 /*: any*/ ,
                                                                                                v61 /*: any*/ ,
                                                                                                v63 /*: any*/ ,
                                                                                                v64 /*: any*/ ,
                                                                                                v66 /*: any*/ ,
                                                                                                v67 /*: any*/ ,
                                                                                                v46 /*: any*/ ,
                                                                                                v68 /*: any*/ ,
                                                                                                v69 /*: any*/ ,
                                                                                                v70 /*: any*/ ,
                                                                                                v72 /*: any*/ ,
                                                                                                v78 /*: any*/ ,
                                                                                                v79 /*: any*/ ,
                                                                                                v80 /*: any*/ ,
                                                                                                v81 /*: any*/ ,
                                                                                                v82 /*: any*/ ,
                                                                                                v83 /*: any*/ ,
                                                                                                v84 /*: any*/ ,
                                                                                                v85 /*: any*/ ,
                                                                                                v86 /*: any*/ ,
                                                                                                v87 /*: any*/ ,
                                                                                                v90 /*: any*/ ,
                                                                                                v91 /*: any*/ ,
                                                                                                v92 /*: any*/ ,
                                                                                                v93 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOptionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedOptions",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        v52 /*: any*/ ,
                                                                                                                        v56 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCheckboxesField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraOption",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "fieldOption",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v51 /*: any*/ ,
                                                                                                                v20 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectField"
                                                                                                },
                                                                                                v56 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v94 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v56 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "fieldSets(first:500)"
                                                },
                                                v56 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "endCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "startCursor"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasPreviousPage"
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraIssueNavigatorPageInfo",
                                            "kind": "LinkedField",
                                            "name": "issueNavigatorPageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "firstIssuePosition"
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "lastIssuePosition"
                                                }
                                            ]
                                        },
                                        {
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "maxCursors",
                                                    "value": 7
                                                }
                                            ],
                                            "concreteType": "JiraPageCursors",
                                            "kind": "LinkedField",
                                            "name": "pageCursors",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "around",
                                                    "plural": true,
                                                    "selections": v98 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "last",
                                                    "plural": false,
                                                    "selections": v98 /*: any*/ 
                                                },
                                                {
                                                    "concreteType": "JiraPageCursor",
                                                    "kind": "LinkedField",
                                                    "name": "first",
                                                    "plural": false,
                                                    "selections": [
                                                        v22 /*: any*/ ,
                                                        v96 /*: any*/ ,
                                                        v97 /*: any*/ 
                                                    ]
                                                }
                                            ],
                                            "storageKey": "pageCursors(maxCursors:7)"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "totalIssueSearchResultCount"
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "issueSearchError",
                                            "plural": false,
                                            "selections": [
                                                v19 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "messages"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidJqlError"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v58 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "errorType"
                                                        }
                                                    ],
                                                    "type": "JiraInvalidSyntaxError"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isCappingIssueSearchResult"
                                        },
                                        v56 /*: any*/ 
                                    ]
                                },
                                {
                                    "args": v21 /*: any*/ ,
                                    "filters": [
                                        "issueSearchInput"
                                    ],
                                    "handle": "connection",
                                    "key": "IssueNavigatorDetailedViewPagination__issues",
                                    "kind": "LinkedHandle",
                                    "name": "issues"
                                }
                            ],
                            "type": "JiraDetailedView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8e716748403578a037a5c375e279dcf577e5beac12ece64ae4b0e49c3abcf029",
            "metadata": {},
            "name": "IssueNavigatorDetailedViewPaginationQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": (0, $bqIzm.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $fjldt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$a71ac203dea02c63$var$node.hash = "b55231f2326f70fb819ca3062e0201a6";
var $a71ac203dea02c63$export$2e2bcd8739ae039 = $a71ac203dea02c63$var$node;

});


parcelRegister("68sKr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f0c9b2fabe2d04$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9948addb4ffb4b8090093e1aabc29e42>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $kF1V3 = parcelRequire("kF1V3");
const $f4f0c9b2fabe2d04$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v1 = {
        "kind": "Variable",
        "name": "projectKeys",
        "variableName": "projectKeys"
    }, v2 = [
        v0 /*: any*/ ,
        v1 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after"
            },
            {
                "kind": "RootArgument",
                "name": "amountOfColumns"
            },
            {
                "kind": "RootArgument",
                "name": "before"
            },
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetIds"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsContext"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsInput"
            },
            {
                "kind": "RootArgument",
                "name": "fieldSetsScope"
            },
            {
                "kind": "RootArgument",
                "name": "filterId"
            },
            {
                "kind": "RootArgument",
                "name": "first"
            },
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "kind": "RootArgument",
                "name": "isPaginating"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "kind": "RootArgument",
                "name": "last"
            },
            {
                "kind": "RootArgument",
                "name": "namespace"
            },
            {
                "kind": "RootArgument",
                "name": "options"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKey"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "projectKeys"
            },
            {
                "kind": "RootArgument",
                "name": "scope"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryFieldSetsById"
            },
            {
                "kind": "RootArgument",
                "name": "shouldQueryHasChildren"
            },
            {
                "kind": "RootArgument",
                "name": "staticViewInput"
            },
            {
                "kind": "RootArgument",
                "name": "viewConfigInput"
            },
            {
                "kind": "RootArgument",
                "name": "viewId"
            },
            {
                "kind": "RootArgument",
                "name": "viewQueryInput"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $kF1V3.default)
            }
        },
        "name": "main_issueNavigator_IssueNavigator_refetchQuery",
        "selections": [
            {
                "concreteType": "JiraQuery",
                "kind": "LinkedField",
                "name": "jira",
                "plural": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "cloudId",
                                "variableName": "cloudId"
                            },
                            {
                                "kind": "Variable",
                                "name": "filterId",
                                "variableName": "filterId"
                            },
                            {
                                "kind": "Variable",
                                "name": "issueSearchInput",
                                "variableName": "issueSearchInput"
                            },
                            {
                                "kind": "Variable",
                                "name": "namespace",
                                "variableName": "namespace"
                            },
                            {
                                "kind": "Variable",
                                "name": "viewConfigInput",
                                "variableName": "staticViewInput"
                            },
                            {
                                "kind": "Variable",
                                "name": "viewId",
                                "variableName": "viewId"
                            },
                            {
                                "kind": "Variable",
                                "name": "viewQueryInput",
                                "variableName": "viewQueryInput"
                            }
                        ],
                        "kind": "LinkedField",
                        "name": "jiraIssueSearchView",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__typename"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "issueSearch_issueNavigatorGrouping"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "main_issueNavigator_IssueNavigatorUI_jiraView"
                            },
                            {
                                "kind": "FragmentSpread",
                                "name": "selectedView_issueNavigator_SelectedViewContainer"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "main_issueNavigator_IssueNavigator_detailedViewData"
                                    }
                                ],
                                "type": "JiraDetailedView"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": v2 /*: any*/ ,
                                        "kind": "FragmentSpread",
                                        "name": "main_issueNavigator_IssueNavigator_groupedListViewData"
                                    }
                                ],
                                "type": "JiraGroupedListView"
                            },
                            {
                                "kind": "InlineFragment",
                                "selections": [
                                    {
                                        "args": [
                                            v0 /*: any*/ ,
                                            v1 /*: any*/ ,
                                            {
                                                "kind": "Variable",
                                                "name": "shouldQueryHasChildren",
                                                "variableName": "shouldQueryHasChildren"
                                            }
                                        ],
                                        "kind": "FragmentSpread",
                                        "name": "main_issueNavigator_IssueNavigator_listViewData"
                                    }
                                ],
                                "type": "JiraListView"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$f4f0c9b2fabe2d04$var$node.hash = "7e15a890bdac614549da044270ad4a2b";
var $f4f0c9b2fabe2d04$export$2e2bcd8739ae039 = $f4f0c9b2fabe2d04$var$node;

});
parcelRegister("kF1V3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2b7fdc33d59789a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a590040a565fa155a5eafee02a89ab8e>>
 * @relayHash 116b5b073183fd6f153a6e2ac50f37b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 96da8a128ec89a8d280000feae0e0986c2f5434d34f0fd839b809c980f25b388

var $cNAof = parcelRequire("cNAof");

var $bqIzm = parcelRequire("bqIzm");

var $fjldt = parcelRequire("fjldt");

var $gY76A = parcelRequire("gY76A");

var $5oQtH = parcelRequire("5oQtH");

var $5ykrX = parcelRequire("5ykrX");

var $1xxk0 = parcelRequire("1xxk0");

var $c5npJ = parcelRequire("c5npJ");

var $ggSVP = parcelRequire("ggSVP");

var $k3PJZ = parcelRequire("k3PJZ");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $5wdbf = parcelRequire("5wdbf");

var $dttgK = parcelRequire("dttgK");

var $adKYy = parcelRequire("adKYy");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $a2b7fdc33d59789a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "before"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsContext"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterId"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "groupBy"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPaginating"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "last"
    }, v14 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v15 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "options"
    }, v16 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v17 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKeys"
    }, v18 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "scope"
    }, v19 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryFieldSetsById"
    }, v20 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shouldQueryHasChildren"
    }, v21 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "staticViewInput"
    }, v22 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewConfigInput"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewQueryInput"
    }, v25 = {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
    }, v26 = {
        "kind": "Variable",
        "name": "filterId",
        "variableName": "filterId"
    }, v27 = {
        "kind": "Variable",
        "name": "issueSearchInput",
        "variableName": "issueSearchInput"
    }, v28 = {
        "kind": "Variable",
        "name": "namespace",
        "variableName": "namespace"
    }, v29 = {
        "kind": "Variable",
        "name": "viewId",
        "variableName": "viewId"
    }, v30 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v31 = {
        "kind": "ScalarField",
        "name": "message"
    }, v32 = [
        {
            "kind": "LinkedField",
            "name": "extensions",
            "plural": true,
            "selections": [
                v30 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                }
            ]
        },
        v31 /*: any*/ 
    ], v33 = {
        "kind": "ScalarField",
        "name": "id"
    }, v34 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "amountOfColumns"
    }, v35 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        v34 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "fieldSetsScope"
        }
    ], v36 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v37 = {
        "kind": "Variable",
        "name": "groupBy",
        "variableName": "groupBy"
    }, v38 = [
        v37 /*: any*/ ,
        v27 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "staticViewInput",
            "variableName": "staticViewInput"
        }
    ], v39 = {
        "kind": "ScalarField",
        "name": "isGroupingEnabled"
    }, v40 = {
        "kind": "ScalarField",
        "name": "canEnableGrouping"
    }, v41 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v42 = {
        "kind": "ScalarField",
        "name": "name"
    }, v43 = {
        "kind": "ScalarField",
        "name": "isHierarchyEnabled"
    }, v44 = {
        "kind": "ScalarField",
        "name": "hideDone"
    }, v45 = {
        "kind": "ScalarField",
        "name": "jql"
    }, v46 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v47 = {
        "kind": "ScalarField",
        "name": "type"
    }, v48 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v49 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v50 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v51 = {
        "kind": "ClientExtension",
        "selections": [
            v50 /*: any*/ 
        ]
    }, v52 = {
        "kind": "ScalarField",
        "name": "canEnableHierarchy"
    }, v53 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v54 = {
        "kind": "Variable",
        "name": "before",
        "variableName": "before"
    }, v55 = {
        "kind": "Variable",
        "name": "fieldSetsInput",
        "variableName": "fieldSetsInput"
    }, v56 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v57 = {
        "kind": "Variable",
        "name": "last",
        "variableName": "last"
    }, v58 = {
        "kind": "Variable",
        "name": "options",
        "variableName": "options"
    }, v59 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v60 = [
        v53 /*: any*/ ,
        v54 /*: any*/ ,
        v55 /*: any*/ ,
        v56 /*: any*/ ,
        v27 /*: any*/ ,
        v57 /*: any*/ ,
        v58 /*: any*/ ,
        v59 /*: any*/ 
    ], v61 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v62 = {
        "kind": "ScalarField",
        "name": "key"
    }, v63 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v64 = {
        "kind": "ScalarField",
        "name": "isResolved"
    }, v65 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v66 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v65 /*: any*/ ,
            v33 /*: any*/ 
        ]
    }, v67 = {
        "kind": "InlineFragment",
        "selections": [
            v41 /*: any*/ ,
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v66 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v68 = {
        "args": [
            {
                "kind": "Literal",
                "name": "ids",
                "value": [
                    "status"
                ]
            }
        ],
        "concreteType": "JiraIssueFieldConnection",
        "kind": "LinkedField",
        "name": "fieldsById",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v30 /*: any*/ ,
                            v67 /*: any*/ ,
                            v33 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldsById(ids:[\"status\"])"
    }, v69 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v70 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v69 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            },
            v33 /*: any*/ 
        ]
    }, v71 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraIssueTypeField",
                "kind": "LinkedField",
                "name": "issueTypeField",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "issueType",
                        "plural": false,
                        "selections": [
                            v42 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v72 = {
        "kind": "ClientExtension",
        "selections": [
            v50 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "isHighlightedIssueRow"
            }
        ]
    }, v73 = {
        "kind": "TypeDiscriminator",
        "abstractKey": "__isJiraIssueField"
    }, v74 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraAffectedServiceConnection",
                "kind": "LinkedField",
                "name": "selectedAffectedServicesConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraAffectedServiceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraAffectedService",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "serviceId"
                                    },
                                    v42 /*: any*/ ,
                                    v33 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraAffectedServicesField"
    }, v75 = {
        "kind": "ScalarField",
        "name": "value"
    }, v76 = [
        v75 /*: any*/ ,
        v33 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v77 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v78 = {
        "kind": "ClientExtension",
        "selections": [
            v77 /*: any*/ 
        ]
    }, v79 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v80 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v81 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v82 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v83 = {
        "kind": "ScalarField",
        "name": "text"
    }, v84 = {
        "kind": "InlineFragment",
        "selections": [
            v83 /*: any*/ ,
            v42 /*: any*/ ,
            v78 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v85 = [
        v46 /*: any*/ 
    ], v86 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v33 /*: any*/ 
        ]
    }, v87 = [
        v86 /*: any*/ 
    ], v88 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v89 = {
        "concreteType": "JiraOption",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v33 /*: any*/ ,
            v75 /*: any*/ 
        ]
    }, v90 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v91 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v92 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v93 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraCascadingOption",
                        "kind": "LinkedField",
                        "name": "cascadingOption",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "parentOptionValue",
                                "plural": false,
                                "selections": v76 /*: any*/ 
                            },
                            {
                                "concreteType": "JiraOption",
                                "kind": "LinkedField",
                                "name": "childOptionValue",
                                "plural": false,
                                "selections": v76 /*: any*/ 
                            }
                        ]
                    },
                    v78 /*: any*/ 
                ],
                "type": "JiraCascadingSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "args": v79 /*: any*/ ,
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v80 /*: any*/ ,
                                            v81 /*: any*/ ,
                                            v33 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedComponentsConnection(first:1000)"
                    },
                    v78 /*: any*/ 
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v82 /*: any*/ ,
                    v42 /*: any*/ ,
                    v78 /*: any*/ 
                ],
                "type": "JiraDateTimePickerField"
            },
            v84 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraCommentSummary",
                        "kind": "LinkedField",
                        "name": "commentSummary",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "canAddComment"
                            },
                            v46 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraCommentSummaryField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "uri"
                    },
                    v78 /*: any*/ 
                ],
                "type": "JiraUrlField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "fieldOptions",
                        "plural": false,
                        "selections": v85 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "fieldOption",
                        "plural": false,
                        "selections": [
                            v75 /*: any*/ ,
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v87 /*: any*/ 
                            },
                            {
                                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": v87 /*: any*/ 
                            },
                            v33 /*: any*/ ,
                            v88 /*: any*/ 
                        ]
                    },
                    v78 /*: any*/ 
                ],
                "type": "JiraSingleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraOption",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v75 /*: any*/ ,
                                            v88 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v78 /*: any*/ 
                ],
                "type": "JiraMultipleSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraOptionConnection",
                        "kind": "LinkedField",
                        "name": "selectedOptions",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraOptionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    v89 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v78 /*: any*/ 
                ],
                "type": "JiraCheckboxesField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraUserConnection",
                        "kind": "LinkedField",
                        "name": "selectedUsersConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraUserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v30 /*: any*/ ,
                                            v90 /*: any*/ ,
                                            v42 /*: any*/ ,
                                            v91 /*: any*/ ,
                                            v33 /*: any*/ ,
                                            v92 /*: any*/ ,
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "email"
                                                    }
                                                ],
                                                "type": "AtlassianAccountUser"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v78 /*: any*/ 
                ],
                "type": "JiraMultipleSelectUserPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraTeamView",
                        "kind": "LinkedField",
                        "name": "selectedTeam",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "jiraSuppliedName"
                            }
                        ]
                    },
                    v78 /*: any*/ 
                ],
                "type": "JiraTeamViewField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraTimeTrackingField",
                                "kind": "LinkedField",
                                "name": "timeTrackingField",
                                "plural": false,
                                "selections": [
                                    v33 /*: any*/ ,
                                    {
                                        "concreteType": "JiraEstimate",
                                        "kind": "LinkedField",
                                        "name": "originalEstimate",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "timeInSeconds"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraTimeTrackingSettings",
                                        "kind": "LinkedField",
                                        "name": "timeTrackingSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingHoursPerDay"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "workingDaysPerWeek"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultFormat"
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "defaultUnit"
                                            }
                                        ]
                                    },
                                    v41 /*: any*/ ,
                                    v42 /*: any*/ ,
                                    v47 /*: any*/ ,
                                    v78 /*: any*/ 
                                ]
                            },
                            v33 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraOriginalTimeEstimateField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "selectedOption",
                        "plural": false,
                        "selections": [
                            {
                                "alias": "label",
                                "kind": "ScalarField",
                                "name": "value"
                            },
                            v33 /*: any*/ ,
                            v80 /*: any*/ 
                        ]
                    },
                    v78 /*: any*/ 
                ],
                "type": "JiraRadioSelectField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "args": v79 /*: any*/ ,
                        "concreteType": "JiraVersionConnection",
                        "kind": "LinkedField",
                        "name": "selectedVersionsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraVersionEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraVersion",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v42 /*: any*/ ,
                                            v80 /*: any*/ ,
                                            v81 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "versionId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "selectedVersionsConnection(first:1000)"
                    },
                    v78 /*: any*/ 
                ],
                "type": "JiraMultipleVersionPickerField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "issue",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ 
                        ]
                    },
                    {
                        "args": v79 /*: any*/ ,
                        "concreteType": "JiraGoalConnection",
                        "kind": "LinkedField",
                        "name": "selectedGoals",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGoal",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v62 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            v51 /*: any*/ 
                        ],
                        "storageKey": "selectedGoals(first:1000)"
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            v50 /*: any*/ ,
                            v77 /*: any*/ 
                        ]
                    }
                ],
                "type": "JiraGoalsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "args": v79 /*: any*/ ,
                        "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                        "kind": "LinkedField",
                        "name": "confluenceRemoteIssueLinks",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v33 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "href"
                                            }
                                        ]
                                    }
                                ]
                            },
                            v46 /*: any*/ 
                        ],
                        "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                    },
                    v78 /*: any*/ 
                ],
                "type": "JiraConfluenceRemoteIssueLinksField"
            }
        ]
    }, v94 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraCmdbObjectConnection",
                "kind": "LinkedField",
                "name": "selectedCmdbObjectsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraCmdbObjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraCmdbObject",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "objectId"
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "label"
                                    },
                                    {
                                        "concreteType": "JiraCmdbAvatar",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraCmdbMediaClientConfig",
                                                "kind": "LinkedField",
                                                "name": "mediaClientConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "clientId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "fileId"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaBaseUrl"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "mediaJwtToken"
                                                    }
                                                ]
                                            },
                                            {
                                                "kind": "ScalarField",
                                                "name": "url48"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": [
                            v31 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCMDBField"
    }, v95 = [
        v42 /*: any*/ ,
        v33 /*: any*/ 
    ], v96 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "componentsOld",
                        "concreteType": "JiraComponentConnection",
                        "kind": "LinkedField",
                        "name": "selectedComponentsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraComponentEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraComponent",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": v95 /*: any*/ 
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "type": "JiraComponentsField"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v83 /*: any*/ 
                ],
                "type": "JiraSingleLineTextField"
            }
        ]
    }, v97 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v98 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "date"
            },
            v42 /*: any*/ ,
            v97 /*: any*/ ,
            v78 /*: any*/ 
        ],
        "type": "JiraDatePickerField"
    }, v99 = {
        "kind": "InlineFragment",
        "selections": [
            v82 /*: any*/ 
        ],
        "type": "JiraDateTimePickerField"
    }, v100 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v101 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraEpic",
                "kind": "LinkedField",
                "name": "epic",
                "plural": false,
                "selections": [
                    v62 /*: any*/ ,
                    v100 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "color"
                    },
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraEpicLinkField"
    }, v102 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "renderedFieldHtml"
            }
        ],
        "type": "JiraFallbackField"
    }, v103 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatusCategory",
                "kind": "LinkedField",
                "name": "statusCategory",
                "plural": false,
                "selections": [
                    v42 /*: any*/ ,
                    v65 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusCategoryField"
    }, v104 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraStatus",
                "kind": "LinkedField",
                "name": "status",
                "plural": false,
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "statusId"
                    },
                    v66 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraStatusField"
    }, v105 = [
        v42 /*: any*/ ,
        v86 /*: any*/ 
    ], v106 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": v79 /*: any*/ ,
                "concreteType": "JiraLabelConnection",
                "kind": "LinkedField",
                "name": "selectedLabelsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraLabelEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v105 /*: any*/ 
                            }
                        ]
                    },
                    v46 /*: any*/ 
                ],
                "storageKey": "selectedLabelsConnection(first:1000)"
            },
            v42 /*: any*/ ,
            v78 /*: any*/ 
        ],
        "type": "JiraLabelsField"
    }, v107 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v108 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v107 /*: any*/ ,
                    v42 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraIssueTypeField"
    }, v109 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v83 /*: any*/ ,
            v33 /*: any*/ 
        ]
    }, v110 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v86 /*: any*/ ,
            v33 /*: any*/ 
        ]
    }, v111 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v112 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v111 /*: any*/ ,
                    v42 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            },
            v33 /*: any*/ 
        ]
    }, v113 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v114 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "parentIssue",
                "plural": false,
                "selections": [
                    v62 /*: any*/ ,
                    v109 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v62 /*: any*/ ,
                            v110 /*: any*/ ,
                            v112 /*: any*/ ,
                            v109 /*: any*/ ,
                            v33 /*: any*/ 
                        ]
                    }
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "JiraIssue",
                        "kind": "LinkedField",
                        "name": "parentIssue",
                        "plural": false,
                        "selections": [
                            v62 /*: any*/ ,
                            v110 /*: any*/ ,
                            v112 /*: any*/ ,
                            v109 /*: any*/ ,
                            v33 /*: any*/ ,
                            v63 /*: any*/ ,
                            v113 /*: any*/ ,
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "ids",
                                        "value": [
                                            "summary",
                                            "issuetype",
                                            "status"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fieldsById",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v30 /*: any*/ ,
                                                    v33 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v41 /*: any*/ ,
                                                            v83 /*: any*/ 
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v41 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                    },
                                                                    v42 /*: any*/ ,
                                                                    v111 /*: any*/ ,
                                                                    v69 /*: any*/ ,
                                                                    v33 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    v67 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    }
                                ],
                                "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                            }
                        ]
                    },
                    v42 /*: any*/ ,
                    v78 /*: any*/ 
                ]
            }
        ],
        "type": "JiraParentIssueField"
    }, v115 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v116 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraPriority",
                "kind": "LinkedField",
                "name": "priority",
                "plural": false,
                "selections": [
                    v42 /*: any*/ ,
                    v115 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            },
            v42 /*: any*/ ,
            v78 /*: any*/ 
        ],
        "type": "JiraPriorityField"
    }, v117 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraProject",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": [
                    v42 /*: any*/ ,
                    v62 /*: any*/ ,
                    {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "large"
                            }
                        ]
                    },
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraProjectField"
    }, v118 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraResolution",
                "kind": "LinkedField",
                "name": "resolution",
                "plural": false,
                "selections": v95 /*: any*/ 
            }
        ],
        "type": "JiraResolutionField"
    }, v119 = [
        v33 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "sprintId"
        },
        v42 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "state"
        },
        {
            "kind": "ScalarField",
            "name": "endDate"
        }
    ], v120 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraSprintConnection",
                "kind": "LinkedField",
                "name": "selectedSprintsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraSprintEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraSprint",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v119 /*: any*/ 
                            }
                        ]
                    }
                ]
            },
            v42 /*: any*/ ,
            v78 /*: any*/ 
        ],
        "type": "JiraSprintField"
    }, v121 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v30 /*: any*/ ,
                    v90 /*: any*/ ,
                    v91 /*: any*/ ,
                    v42 /*: any*/ ,
                    v33 /*: any*/ ,
                    v92 /*: any*/ 
                ]
            },
            v42 /*: any*/ ,
            v97 /*: any*/ ,
            v78 /*: any*/ 
        ],
        "type": "JiraSingleSelectUserPickerField"
    }, v122 = {
        "kind": "InlineFragment",
        "selections": [
            v42 /*: any*/ ,
            {
                "args": v79 /*: any*/ ,
                "concreteType": "JiraVersionConnection",
                "kind": "LinkedField",
                "name": "selectedVersionsConnection",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraVersionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraVersion",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": v95 /*: any*/ 
                            }
                        ]
                    }
                ],
                "storageKey": "selectedVersionsConnection(first:1000)"
            }
        ],
        "type": "JiraMultipleVersionPickerField"
    }, v123 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraRichText",
                "kind": "LinkedField",
                "name": "richText",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraADF",
                        "kind": "LinkedField",
                        "name": "adfValue",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraAdfToConvertedPlainText",
                                "kind": "LinkedField",
                                "name": "convertedPlainText",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "plainText"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraRichTextField"
    }, v124 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "JiraServiceManagementRequestType",
                "kind": "LinkedField",
                "name": "requestType",
                "plural": false,
                "selections": [
                    v42 /*: any*/ ,
                    v111 /*: any*/ ,
                    v33 /*: any*/ 
                ]
            }
        ],
        "type": "JiraServiceManagementRequestTypeField"
    }, v125 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                    }
                ],
                "concreteType": "JiraIssueLinkConnection",
                "kind": "LinkedField",
                "name": "issueLinkConnection",
                "plural": false,
                "selections": [
                    v46 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueLinkEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueLink",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssue",
                                        "kind": "LinkedField",
                                        "name": "issue",
                                        "plural": false,
                                        "selections": [
                                            v113 /*: any*/ ,
                                            v62 /*: any*/ ,
                                            {
                                                "args": [
                                                    {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                            "statusCategory"
                                                        ]
                                                    }
                                                ],
                                                "concreteType": "JiraIssueFieldConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldsById",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "node",
                                                                "plural": false,
                                                                "selections": [
                                                                    v30 /*: any*/ ,
                                                                    {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                            v66 /*: any*/ 
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                    },
                                                                    v33 /*: any*/ 
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ],
                                                "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                            },
                                            v33 /*: any*/ 
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "relationName"
                                    },
                                    v33 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "issueLinkConnection(first:1)"
            }
        ],
        "type": "JiraIssueLinkField"
    }, v126 = {
        "kind": "ScalarField",
        "name": "number"
    }, v127 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    }, v128 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isStoryPointField"
            },
            v126 /*: any*/ ,
            v42 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    v126 /*: any*/ ,
                    v127 /*: any*/ 
                ]
            },
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v126 /*: any*/ ,
                    v42 /*: any*/ ,
                    v127 /*: any*/ ,
                    v78 /*: any*/ 
                ]
            },
            v78 /*: any*/ 
        ],
        "type": "JiraNumberField"
    }, v129 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    v42 /*: any*/ ,
                    {
                        "concreteType": "JiraGroupConnection",
                        "kind": "LinkedField",
                        "name": "selectedGroupsConnection",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraGroupEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                    {
                                        "concreteType": "JiraGroup",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                            v33 /*: any*/ ,
                                            v42 /*: any*/ ,
                                            {
                                                "kind": "ScalarField",
                                                "name": "groupId"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    v78 /*: any*/ 
                ],
                "type": "JiraMultipleGroupPickerField"
            }
        ]
    }, v130 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraFlag",
                        "kind": "LinkedField",
                        "name": "flag",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isFlagged"
                            }
                        ]
                    }
                ],
                "type": "JiraFlagField"
            }
        ]
    }, v131 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraWatch",
                        "kind": "LinkedField",
                        "name": "watch",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "isWatching"
                            }
                        ]
                    }
                ],
                "type": "JiraWatchesField"
            }
        ]
    }, v132 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": v85 /*: any*/ 
    }, v133 = [
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v47 /*: any*/ ,
                        v36 /*: any*/ ,
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v30 /*: any*/ ,
                                                v41 /*: any*/ ,
                                                v47 /*: any*/ ,
                                                v73 /*: any*/ ,
                                                v33 /*: any*/ ,
                                                v74 /*: any*/ ,
                                                v93 /*: any*/ ,
                                                v94 /*: any*/ ,
                                                v96 /*: any*/ ,
                                                v98 /*: any*/ ,
                                                v99 /*: any*/ ,
                                                v101 /*: any*/ ,
                                                v102 /*: any*/ ,
                                                v84 /*: any*/ ,
                                                v103 /*: any*/ ,
                                                v104 /*: any*/ ,
                                                v106 /*: any*/ ,
                                                v108 /*: any*/ ,
                                                v114 /*: any*/ ,
                                                v116 /*: any*/ ,
                                                v117 /*: any*/ ,
                                                v118 /*: any*/ ,
                                                v120 /*: any*/ ,
                                                v121 /*: any*/ ,
                                                v122 /*: any*/ ,
                                                v123 /*: any*/ ,
                                                v124 /*: any*/ ,
                                                v125 /*: any*/ ,
                                                v128 /*: any*/ ,
                                                v129 /*: any*/ ,
                                                v130 /*: any*/ ,
                                                v131 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v132 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ], v134 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
            {
                "condition": "shouldQueryFieldSetsById",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "fieldSetIds",
                                "variableName": "fieldSetIds"
                            },
                            v34 /*: any*/ 
                        ],
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSetsById",
                        "plural": false,
                        "selections": v133 /*: any*/ 
                    }
                ]
            },
            {
                "condition": "shouldQueryFieldSetsById",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "context",
                                "variableName": "fieldSetsContext"
                            },
                            v26 /*: any*/ ,
                            v34 /*: any*/ ,
                            v28 /*: any*/ ,
                            v29 /*: any*/ 
                        ],
                        "concreteType": "JiraIssueFieldSetConnection",
                        "kind": "LinkedField",
                        "name": "fieldSetsForIssueSearchView",
                        "plural": false,
                        "selections": v133 /*: any*/ 
                    }
                ]
            }
        ]
    }, v135 = {
        "concreteType": "JiraIssue",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            v33 /*: any*/ ,
            v62 /*: any*/ ,
            v63 /*: any*/ ,
            v64 /*: any*/ ,
            v68 /*: any*/ ,
            v70 /*: any*/ ,
            v71 /*: any*/ ,
            v72 /*: any*/ ,
            v134 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v100 /*: any*/ ,
                    {
                        "concreteType": "JiraIssueTypeField",
                        "kind": "LinkedField",
                        "name": "issueTypeField",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueType",
                                "kind": "LinkedField",
                                "name": "issueType",
                                "plural": false,
                                "selections": [
                                    v107 /*: any*/ 
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }, v136 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 500
        }
    ], v137 = {
        "args": v136 /*: any*/ ,
        "concreteType": "JiraIssueFieldSetConnection",
        "kind": "LinkedField",
        "name": "fieldSets",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            v47 /*: any*/ ,
                            v36 /*: any*/ ,
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    v30 /*: any*/ ,
                                                    v41 /*: any*/ ,
                                                    v47 /*: any*/ ,
                                                    v73 /*: any*/ ,
                                                    v33 /*: any*/ ,
                                                    v74 /*: any*/ ,
                                                    v93 /*: any*/ ,
                                                    v94 /*: any*/ ,
                                                    v96 /*: any*/ ,
                                                    v98 /*: any*/ ,
                                                    v99 /*: any*/ ,
                                                    v101 /*: any*/ ,
                                                    v102 /*: any*/ ,
                                                    v84 /*: any*/ ,
                                                    v103 /*: any*/ ,
                                                    v104 /*: any*/ ,
                                                    v106 /*: any*/ ,
                                                    v108 /*: any*/ ,
                                                    v114 /*: any*/ ,
                                                    v116 /*: any*/ ,
                                                    v117 /*: any*/ ,
                                                    v118 /*: any*/ ,
                                                    v120 /*: any*/ ,
                                                    v121 /*: any*/ ,
                                                    v122 /*: any*/ ,
                                                    v123 /*: any*/ ,
                                                    v124 /*: any*/ ,
                                                    v125 /*: any*/ ,
                                                    v128 /*: any*/ ,
                                                    v129 /*: any*/ ,
                                                    v130 /*: any*/ ,
                                                    v131 /*: any*/ ,
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOptionConnection",
                                                                "kind": "LinkedField",
                                                                "name": "selectedOptions",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "concreteType": "JiraOptionEdge",
                                                                        "kind": "LinkedField",
                                                                        "name": "edges",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            v89 /*: any*/ ,
                                                                            v51 /*: any*/ 
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraCheckboxesField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "concreteType": "JiraOption",
                                                                "kind": "LinkedField",
                                                                "name": "fieldOption",
                                                                "plural": false,
                                                                "selections": [
                                                                    v88 /*: any*/ ,
                                                                    v33 /*: any*/ 
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectField"
                                                    },
                                                    v51 /*: any*/ 
                                                ]
                                            }
                                        ]
                                    },
                                    v132 /*: any*/ 
                                ]
                            },
                            v51 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "storageKey": "fieldSets(first:500)"
    }, v138 = {
        "kind": "ScalarField",
        "name": "endCursor"
    }, v139 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v140 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            v138 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "startCursor"
            },
            v139 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
            }
        ]
    }, v141 = {
        "concreteType": "JiraIssueNavigatorPageInfo",
        "kind": "LinkedField",
        "name": "issueNavigatorPageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "firstIssuePosition"
            },
            {
                "kind": "ScalarField",
                "name": "lastIssuePosition"
            }
        ]
    }, v142 = {
        "kind": "ScalarField",
        "name": "pageNumber"
    }, v143 = {
        "kind": "ScalarField",
        "name": "isCurrent"
    }, v144 = [
        v142 /*: any*/ ,
        v61 /*: any*/ ,
        v143 /*: any*/ 
    ], v145 = {
        "args": [
            {
                "kind": "Literal",
                "name": "maxCursors",
                "value": 7
            }
        ],
        "concreteType": "JiraPageCursors",
        "kind": "LinkedField",
        "name": "pageCursors",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "around",
                "plural": true,
                "selections": v144 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "last",
                "plural": false,
                "selections": v144 /*: any*/ 
            },
            {
                "concreteType": "JiraPageCursor",
                "kind": "LinkedField",
                "name": "first",
                "plural": false,
                "selections": [
                    v61 /*: any*/ ,
                    v142 /*: any*/ ,
                    v143 /*: any*/ 
                ]
            }
        ],
        "storageKey": "pageCursors(maxCursors:7)"
    }, v146 = {
        "kind": "ScalarField",
        "name": "totalIssueSearchResultCount"
    }, v147 = {
        "kind": "LinkedField",
        "name": "issueSearchError",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "messages"
                    }
                ],
                "type": "JiraInvalidJqlError"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v31 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "errorType"
                    }
                ],
                "type": "JiraInvalidSyntaxError"
            }
        ]
    }, v148 = {
        "kind": "ScalarField",
        "name": "isCappingIssueSearchResult"
    }, v149 = [
        "issueSearchInput"
    ], v150 = [
        v53 /*: any*/ ,
        v54 /*: any*/ ,
        v56 /*: any*/ ,
        v37 /*: any*/ ,
        v27 /*: any*/ ,
        v57 /*: any*/ ,
        v59 /*: any*/ 
    ], v151 = {
        "kind": "ScalarField",
        "name": "fieldType"
    }, v152 = {
        "kind": "LinkedField",
        "name": "fieldValue",
        "plural": false,
        "selections": [
            v30 /*: any*/ ,
            {
                "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    v49 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "concreteType": "JiraLabel",
                                "kind": "LinkedField",
                                "name": "label",
                                "plural": false,
                                "selections": v105 /*: any*/ 
                            }
                        ],
                        "type": "JiraJqlLabelFieldValue"
                    }
                ]
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "priority",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "priorityId"
                            },
                            v42 /*: any*/ ,
                            v115 /*: any*/ 
                        ]
                    },
                    v48 /*: any*/ 
                ],
                "type": "JiraJqlPriorityFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                            v30 /*: any*/ ,
                            v33 /*: any*/ ,
                            v90 /*: any*/ ,
                            v42 /*: any*/ ,
                            v91 /*: any*/ 
                        ]
                    },
                    v48 /*: any*/ 
                ],
                "type": "JiraJqlUserFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraStatus",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ ,
                            v42 /*: any*/ ,
                            {
                                "concreteType": "JiraStatusCategory",
                                "kind": "LinkedField",
                                "name": "statusCategory",
                                "plural": false,
                                "selections": [
                                    v33 /*: any*/ ,
                                    v65 /*: any*/ 
                                ]
                            }
                        ]
                    },
                    v48 /*: any*/ ,
                    v66 /*: any*/ 
                ],
                "type": "JiraJqlStatusFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v126 /*: any*/ 
                ],
                "type": "JiraJqlNumberFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraOption",
                        "kind": "LinkedField",
                        "name": "option",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ ,
                            v88 /*: any*/ ,
                            v75 /*: any*/ ,
                            v86 /*: any*/ 
                        ]
                    },
                    v48 /*: any*/ 
                ],
                "type": "JiraJqlOptionFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraSprint",
                        "kind": "LinkedField",
                        "name": "sprint",
                        "plural": false,
                        "selections": v119 /*: any*/ 
                    },
                    v48 /*: any*/ 
                ],
                "type": "JiraJqlSprintFieldValue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "JiraGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                            v33 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "status"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "score"
                            }
                        ]
                    },
                    v48 /*: any*/ 
                ],
                "type": "JiraJqlGoalsFieldValue"
            }
        ]
    }, v153 = {
        "kind": "ScalarField",
        "name": "issueCount"
    }, v154 = [
        v55 /*: any*/ ,
        {
            "kind": "Literal",
            "name": "first",
            "value": 50
        }
    ], v155 = [
        v53 /*: any*/ ,
        v54 /*: any*/ ,
        v55 /*: any*/ ,
        v56 /*: any*/ ,
        v27 /*: any*/ ,
        v57 /*: any*/ ,
        v58 /*: any*/ ,
        v59 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "viewConfigInput",
            "variableName": "viewConfigInput"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "selections": [
                {
                    "args": [
                        v25 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "projectKeys",
                            "variableName": "projectKeys"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_IssueNavigator_refetchQuery"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ ,
                                v28 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "viewConfigInput",
                                    "variableName": "staticViewInput"
                                },
                                v29 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "viewQueryInput",
                                    "variableName": "viewQueryInput"
                                }
                            ],
                            "kind": "LinkedField",
                            "name": "jiraIssueSearchView",
                            "plural": false,
                            "selections": [
                                v30 /*: any*/ ,
                                {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isJiraView"
                                },
                                {
                                    "concreteType": "QueryError",
                                    "kind": "LinkedField",
                                    "name": "error",
                                    "plural": false,
                                    "selections": v32 /*: any*/ 
                                },
                                v33 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "viewId"
                                        },
                                        {
                                            "args": v35 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v36 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraIssueSearchViewMetadata",
                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v38 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                            "kind": "LinkedField",
                                            "name": "viewSettings",
                                            "plural": false,
                                            "selections": [
                                                v39 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraSpreadsheetGroupByConfig",
                                                    "kind": "LinkedField",
                                                    "name": "groupByConfig",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraField",
                                                            "kind": "LinkedField",
                                                            "name": "groupByField",
                                                            "plural": false,
                                                            "selections": [
                                                                v41 /*: any*/ ,
                                                                v33 /*: any*/ ,
                                                                v42 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "typeKey"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v43 /*: any*/ ,
                                                v44 /*: any*/ 
                                            ]
                                        },
                                        v45 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "filterId"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "hasDefaultFieldSets"
                                                },
                                                {
                                                    "args": v35 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v46 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v47 /*: any*/ ,
                                                                        v48 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v48 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldsMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueSearchMetadataField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canBeConfigured"
                                                                                                        },
                                                                                                        v41 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v51 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v38 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "viewSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v43 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v39 /*: any*/ ,
                                                                        v40 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSpreadsheetView",
                                                            "abstractKey": "__isJiraSpreadsheetView"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "args": v38 /*: any*/ ,
                                                            "concreteType": "JiraIssueSearchViewConfigSettings",
                                                            "kind": "LinkedField",
                                                            "name": "viewSettings",
                                                            "plural": false,
                                                            "selections": [
                                                                v44 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                },
                                                                v52 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraSpreadsheetGroupByConfig",
                                                                    "kind": "LinkedField",
                                                                    "name": "groupByConfig",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraField",
                                                                            "kind": "LinkedField",
                                                                            "name": "groupByField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v41 /*: any*/ ,
                                                                                v33 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v43 /*: any*/ ,
                                                                {
                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canEnableReranking"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "JiraSpreadsheetView",
                                                    "abstractKey": "__isJiraSpreadsheetView"
                                                },
                                                v51 /*: any*/ 
                                            ],
                                            "type": "JiraIssueSearchViewMetadata",
                                            "abstractKey": "__isJiraIssueSearchViewMetadata"
                                        },
                                        {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "args": v38 /*: any*/ ,
                                                                    "concreteType": "JiraIssueSearchViewConfigSettings",
                                                                    "kind": "LinkedField",
                                                                    "name": "viewSettings",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "canPublishViewConfig"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isViewConfigModified"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraSpreadsheetView",
                                                            "abstractKey": "__isJiraSpreadsheetView"
                                                        }
                                                    ],
                                                    "type": "JiraIssueSearchViewMetadata",
                                                    "abstractKey": "__isJiraIssueSearchViewMetadata"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraSpreadsheetView",
                                    "abstractKey": "__isJiraSpreadsheetView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v60 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v61 /*: any*/ ,
                                                        v135 /*: any*/ ,
                                                        v30 /*: any*/ ,
                                                        v137 /*: any*/ ,
                                                        v51 /*: any*/ 
                                                    ]
                                                },
                                                v140 /*: any*/ ,
                                                v141 /*: any*/ ,
                                                v145 /*: any*/ ,
                                                v146 /*: any*/ ,
                                                v147 /*: any*/ ,
                                                v45 /*: any*/ ,
                                                v148 /*: any*/ ,
                                                v51 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v60 /*: any*/ ,
                                            "filters": v149 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorDetailedViewPagination__issues",
                                            "kind": "LinkedHandle",
                                            "name": "issues"
                                        }
                                    ],
                                    "type": "JiraDetailedView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v150 /*: any*/ ,
                                            "concreteType": "JiraSpreadsheetGroupConnection",
                                            "kind": "LinkedField",
                                            "name": "groups",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraSpreadsheetGroupEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v61 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroup",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v30 /*: any*/ ,
                                                                v33 /*: any*/ ,
                                                                v45 /*: any*/ ,
                                                                v41 /*: any*/ ,
                                                                v151 /*: any*/ ,
                                                                v152 /*: any*/ ,
                                                                v153 /*: any*/ 
                                                            ]
                                                        },
                                                        v30 /*: any*/ 
                                                    ]
                                                },
                                                v140 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "groupByField"
                                                },
                                                v45 /*: any*/ ,
                                                {
                                                    "concreteType": "QueryError",
                                                    "kind": "LinkedField",
                                                    "name": "errors",
                                                    "plural": true,
                                                    "selections": v32 /*: any*/ 
                                                },
                                                {
                                                    "condition": "isPaginating",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraSpreadsheetGroup",
                                                            "kind": "LinkedField",
                                                            "name": "firstGroup",
                                                            "plural": false,
                                                            "selections": [
                                                                v33 /*: any*/ ,
                                                                {
                                                                    "args": v154 /*: any*/ ,
                                                                    "concreteType": "JiraIssueConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "issues",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v30 /*: any*/ ,
                                                                                v61 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraIssue",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v30 /*: any*/ ,
                                                                                        v33 /*: any*/ ,
                                                                                        v62 /*: any*/ ,
                                                                                        v63 /*: any*/ ,
                                                                                        v64 /*: any*/ ,
                                                                                        v68 /*: any*/ ,
                                                                                        v70 /*: any*/ ,
                                                                                        v71 /*: any*/ ,
                                                                                        v72 /*: any*/ ,
                                                                                        v134 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "args": v136 /*: any*/ ,
                                                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldSets",
                                                                                    "plural": false,
                                                                                    "selections": v133 /*: any*/ ,
                                                                                    "storageKey": "fieldSets(first:500)"
                                                                                },
                                                                                v51 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "PageInfo",
                                                                            "kind": "LinkedField",
                                                                            "name": "pageInfo",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v138 /*: any*/ ,
                                                                                v139 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v146 /*: any*/ ,
                                                                        v148 /*: any*/ ,
                                                                        v51 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "args": v154 /*: any*/ ,
                                                                    "filters": [
                                                                        "fieldSetsInput"
                                                                    ],
                                                                    "handle": "connection",
                                                                    "key": "firstGroupSection_nativeIssueTable__issues",
                                                                    "kind": "LinkedHandle",
                                                                    "name": "issues"
                                                                },
                                                                v45 /*: any*/ ,
                                                                v41 /*: any*/ ,
                                                                v151 /*: any*/ ,
                                                                v152 /*: any*/ ,
                                                                v153 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v51 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v150 /*: any*/ ,
                                            "filters": v149 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorGroupedListViewPagination__groups",
                                            "kind": "LinkedHandle",
                                            "name": "groups"
                                        }
                                    ],
                                    "type": "JiraGroupedListView"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "args": v155 /*: any*/ ,
                                            "concreteType": "JiraIssueConnection",
                                            "kind": "LinkedField",
                                            "name": "issues",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v61 /*: any*/ ,
                                                        v135 /*: any*/ ,
                                                        v30 /*: any*/ ,
                                                        v137 /*: any*/ ,
                                                        {
                                                            "condition": "shouldQueryHasChildren",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "args": [
                                                                        {
                                                                            "kind": "Variable",
                                                                            "name": "filterByProjectKeys",
                                                                            "variableName": "projectKeys"
                                                                        }
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "hasChildren"
                                                                },
                                                                {
                                                                    "args": [
                                                                        v25 /*: any*/ 
                                                                    ],
                                                                    "kind": "ScalarField",
                                                                    "name": "canHaveChildIssues"
                                                                }
                                                            ]
                                                        },
                                                        v51 /*: any*/ 
                                                    ]
                                                },
                                                v140 /*: any*/ ,
                                                v141 /*: any*/ ,
                                                v145 /*: any*/ ,
                                                v146 /*: any*/ ,
                                                v147 /*: any*/ ,
                                                v45 /*: any*/ ,
                                                v148 /*: any*/ ,
                                                v51 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "args": v155 /*: any*/ ,
                                            "filters": v149 /*: any*/ ,
                                            "handle": "connection",
                                            "key": "IssueNavigatorListViewPagination__issues",
                                            "kind": "LinkedHandle",
                                            "name": "issues"
                                        }
                                    ],
                                    "type": "JiraListView"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "96da8a128ec89a8d280000feae0e0986c2f5434d34f0fd839b809c980f25b388",
            "metadata": {},
            "name": "IssueNavigatorIssueSearchRefetchQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider": (0, $1xxk0.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": (0, $dttgK.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": (0, $c5npJ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider": (0, $5wdbf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $gY76A.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider": (0, $bqIzm.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": (0, $k3PJZ.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider": (0, $5oQtH.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": (0, $adKYy.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": (0, $fjldt.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider": (0, $cNAof.default)
            }
        }
    };
}();
$a2b7fdc33d59789a$var$node.hash = "7e15a890bdac614549da044270ad4a2b";
var $a2b7fdc33d59789a$export$2e2bcd8739ae039 = $a2b7fdc33d59789a$var$node;

});


parcelRegister("l5FbD", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c45b6cdf0660508$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<51e50d89ca6274fe76b97223173d5012>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5c45b6cdf0660508$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigator_issueQuery",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueNavigator_refetchQuery"
        }
    ],
    "type": "Query"
};
$5c45b6cdf0660508$var$node.hash = "0d7fcc97aacf311fd208eded7f35a34c";
var $5c45b6cdf0660508$export$2e2bcd8739ae039 = $5c45b6cdf0660508$var$node;

});

parcelRegister("f98ZZ", function(module, exports) {

$parcel$export(module.exports, "SidebarContainer", () => $3536899865974e25$export$f39f3f768bc98e3d);
$parcel$export(module.exports, "useSidebar", () => $3536899865974e25$export$54c70f22f548bff8);
$parcel$export(module.exports, "useSidebarActions", () => $3536899865974e25$export$685a45ff9d61633f);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $2NMNM = parcelRequire("2NMNM");


var $bLhPU = parcelRequire("bLhPU");
const $3536899865974e25$export$dbc37fcbd226eb52 = (0, $gg7kZ.createContainer)();
const $3536899865974e25$export$f39f3f768bc98e3d = ({ children: children, scope: scope, sidebarId: sidebarId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3536899865974e25$export$dbc37fcbd226eb52, {
        scope: scope,
        sidebarId: sidebarId,
        createAnalyticsEvent: createAnalyticsEvent
    }, children);
};
const $3536899865974e25$var$Store = (0, $iXqE5.createStore)({
    name: (0, $82deb0810ac24613$export$cd79d01fb3d2f506),
    containedBy: $3536899865974e25$export$dbc37fcbd226eb52,
    initialState: {
        id: null,
        content: null
    },
    actions: $bLhPU.actions
});
const $3536899865974e25$export$54c70f22f548bff8 = (0, $3sQ5x.createHook)($3536899865974e25$var$Store);
const $3536899865974e25$export$685a45ff9d61633f = (0, $3sQ5x.createActionsHook)($3536899865974e25$var$Store);

});
const $82deb0810ac24613$export$cd79d01fb3d2f506 = 'JiraPlatformSidebarStore';
const $82deb0810ac24613$export$b8b9d90f9e5bd72b = 'jiraPlatformSidebar';

parcelRegister("bLhPU", function(module, exports) {

$parcel$export(module.exports, "actions", () => $b5da470da8dd158d$export$e324594224ef24da);

var $8zOmE = parcelRequire("8zOmE");

var $2YZCu = parcelRequire("2YZCu");
const $b5da470da8dd158d$var$fireSidebarAnalytics = (experienceId, analyticsProps, eventType)=>{
    const { sidebarId: sidebarId, createAnalyticsEvent: createAnalyticsEvent } = analyticsProps;
    const sidebarLocationId = `jira${sidebarId}SidebarExperience`;
    try {
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), `${sidebarLocationId} ${eventType}`, {
            experienceId: experienceId
        });
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jiraPlatformSidebar', error instanceof Error ? error.message : `Error firing analytics event for sidebar with id ${sidebarId}`);
    }
};
const $b5da470da8dd158d$var$fireStartSidebarAnalytics = (experienceId, analyticsProps)=>{
    $b5da470da8dd158d$var$fireSidebarAnalytics(experienceId, analyticsProps, 'started');
};
const $b5da470da8dd158d$var$fireCloseSidebarAnalytics = (experienceId, analyticsProps)=>{
    $b5da470da8dd158d$var$fireSidebarAnalytics(experienceId, analyticsProps, 'ended');
};
const $b5da470da8dd158d$var$setExperienceId = (id)=>({ setState: setState, getState: getState }, analyticsProps)=>{
        const state = getState();
        const newState = {
            id: id,
            content: null
        };
        const newId = newState.id;
        const previousId = state.id;
        if (analyticsProps.sidebarId) {
            $b5da470da8dd158d$var$fireStartSidebarAnalytics(newId, analyticsProps);
            if (previousId != null) $b5da470da8dd158d$var$fireCloseSidebarAnalytics(previousId, analyticsProps);
        }
        setState({
            ...state,
            ...newState
        });
    };
const $b5da470da8dd158d$var$closeSidebar = ()=>({ setState: setState, getState: getState }, analyticsProps)=>{
        const state = getState();
        const newState = {
            id: null,
            content: null
        };
        if (analyticsProps.sidebarId && state.id) $b5da470da8dd158d$var$fireCloseSidebarAnalytics(state.id, analyticsProps);
        setState({
            ...state,
            ...newState
        });
    };
const $b5da470da8dd158d$var$setStaticSidebarContent = (id, content)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        setState({
            ...state,
            content: content,
            id: id
        });
    };
const $b5da470da8dd158d$export$e324594224ef24da = {
    setExperienceId: $b5da470da8dd158d$var$setExperienceId,
    closeSidebar: $b5da470da8dd158d$var$closeSidebar,
    setStaticSidebarContent: $b5da470da8dd158d$var$setStaticSidebarContent
};

});


parcelRegister("8YUiu", function(module, exports) {

$parcel$export(module.exports, "ConditionalFormatting", () => $9fce16797614c1bf$export$6d44d4a22d5bca7a);

var $kxvU4 = parcelRequire("kxvU4");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $hug5L = parcelRequire("hug5L");

var $57r8q = parcelRequire("57r8q");

var $4R6GH = parcelRequire("4R6GH");

var $7XYc4 = parcelRequire("7XYc4");

var $5YBrl = parcelRequire("5YBrl");
const $9fce16797614c1bf$export$e0edc1ee012e4c7e = ({ project: project, isEnabled: isEnabled, children: children })=>{
    const projectData = (0, $8Uumt.useFragment)((0, $kxvU4.default), project);
    if (isEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hug5L.FormatRulesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5YBrl.JqlProvider), {
        jqlContext: projectData ? `project = '${projectData.key}'` : ''
    }, children), projectData != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57r8q.FormatRulesFragment), {
        project: projectData
    }));
    return children;
};
const $9fce16797614c1bf$export$6d44d4a22d5bca7a = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('conditional-formatting-new-list-targeting-gate'), $9fce16797614c1bf$export$e0edc1ee012e4c7e, ({ children: children })=>children);

});
parcelRegister("kxvU4", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ea8fc5ca01e9a6f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<edd9a412b538d4703909a8fded929c62>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1ea8fc5ca01e9a6f$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "first"
        }
    ],
    "kind": "Fragment",
    "name": "container_issueNavigatorActionConditionalFormatting_ConditionalFormattingInner",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "first"
                }
            ],
            "kind": "FragmentSpread",
            "name": "formatRules_businessConditionalFormattingSidebar_FormatRulesFragment"
        }
    ],
    "type": "JiraProject"
};
$1ea8fc5ca01e9a6f$var$node.hash = "4893d87b377f4acd3e41cdfec3e94ad7";
var $1ea8fc5ca01e9a6f$export$2e2bcd8739ae039 = $1ea8fc5ca01e9a6f$var$node;

});

parcelRegister("hug5L", function(module, exports) {

$parcel$export(module.exports, "FormatRulesContainer", () => $7cf99983147e2a90$export$2022a9665c731c36);
$parcel$export(module.exports, "useFormatRulesStore", () => $7cf99983147e2a90$export$2fe3fe2e87aa2741);
$parcel$export(module.exports, "useFormatRulesSerialisedJql", () => $7cf99983147e2a90$export$3b2286d9a476f9a1);

var $1tESh = parcelRequire("1tESh");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");
const $7cf99983147e2a90$var$initialState = {
    rowRules: [],
    cellRulesByFieldId: {},
    issueIdRowRuleMatched: {},
    rulesJqlInput: {}
};
const $7cf99983147e2a90$var$actions = {
    setFormatRules: (rules)=>({ setState: setState })=>{
            const newState = {
                ...rules
            };
            setState(newState);
        },
    setRulesForJqlInput: (input)=>({ setState: setState })=>{
            const newState = {
                rulesJqlInput: input
            };
            setState(newState);
        },
    setMatchedRowRule: ({ rule: rule, issueId: issueId })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const newState = {
                issueIdRowRuleMatched: {
                    ...currentState.issueIdRowRuleMatched,
                    [issueId]: rule
                }
            };
            setState(newState);
        },
    removeMatchedRowRule: ({ ruleId: ruleId })=>({ setState: setState, getState: getState })=>{
            const { issueIdRowRuleMatched: issueIdRowRuleMatched } = getState();
            const rowRuleMatched = Object.entries(issueIdRowRuleMatched).filter(([, value])=>value.id !== ruleId);
            const newIssueIdRowRuleMatched = Object.fromEntries(rowRuleMatched);
            setState({
                issueIdRowRuleMatched: newIssueIdRowRuleMatched
            });
        }
};
const $7cf99983147e2a90$var$oldStore = (0, $iXqE5.createStore)({
    initialState: $7cf99983147e2a90$var$initialState,
    actions: $7cf99983147e2a90$var$actions,
    name: 'JWMFormatRulesOld'
});
const $7cf99983147e2a90$export$2022a9665c731c36 = (0, $gg7kZ.createContainer)();
const $7cf99983147e2a90$var$Store = (0, $iXqE5.createStore)({
    initialState: $7cf99983147e2a90$var$initialState,
    actions: $7cf99983147e2a90$var$actions,
    name: 'JWMFormatRules',
    containedBy: $7cf99983147e2a90$export$2022a9665c731c36
});
const $7cf99983147e2a90$var$useFormatRulesStoreOld = (0, $3sQ5x.createHook)($7cf99983147e2a90$var$oldStore);
const $7cf99983147e2a90$var$useFormatRulesStoreNew = (0, $3sQ5x.createHook)($7cf99983147e2a90$var$Store);
const $7cf99983147e2a90$export$2fe3fe2e87aa2741 = ()=>(0, $4R6GH.fg)('conditional-formatting-new-list-targeting-gate') ? $7cf99983147e2a90$var$useFormatRulesStoreNew() : $7cf99983147e2a90$var$useFormatRulesStoreOld();
const $7cf99983147e2a90$var$getSerialisedJql = (state)=>(0, $1tESh.serialiseJql)(state.rulesJqlInput);
const $7cf99983147e2a90$var$useFormatRulesSerialisedJqlOld = (0, $3sQ5x.createHook)($7cf99983147e2a90$var$oldStore, {
    selector: $7cf99983147e2a90$var$getSerialisedJql
});
const $7cf99983147e2a90$var$useFormatRulesSerialisedJqlNew = (0, $3sQ5x.createHook)($7cf99983147e2a90$var$Store, {
    selector: $7cf99983147e2a90$var$getSerialisedJql
});
const $7cf99983147e2a90$export$3b2286d9a476f9a1 = ()=>(0, $4R6GH.fg)('conditional-formatting-new-list-targeting-gate') ? $7cf99983147e2a90$var$useFormatRulesSerialisedJqlNew() : $7cf99983147e2a90$var$useFormatRulesSerialisedJqlOld();

});
parcelRegister("1tESh", function(module, exports) {

$parcel$export(module.exports, "serialiseJql", () => $1e9d101255159a24$export$e1718e1e441cb0f6);
$parcel$export(module.exports, "extractAnalyticsFilterDataFromJQL", () => $1e9d101255159a24$export$9ee6085825c9cbfa);

var $gccSB = parcelRequire("gccSB");

var $2nvJN = parcelRequire("2nvJN");

var $gwejS = parcelRequire("gwejS");

var $f9ece = parcelRequire("f9ece");

var $iEIQF = parcelRequire("iEIQF");
var $bzbto = parcelRequire("bzbto");
var $l0V05 = parcelRequire("l0V05");

var $7htvz = parcelRequire("7htvz");
const $1e9d101255159a24$var$START_DATE_JQL = 'Start date[Date]';
const $1e9d101255159a24$var$EMPTY = 'EMPTY';
const $1e9d101255159a24$var$getQuotedFieldName = (fieldName)=>`"${fieldName}"`;
const $1e9d101255159a24$var$getFieldNameForJqlRaw = (fieldName)=>{
    // custom fields are indexed by their ids and only work with JQL when referenced as such `cf[id]`.
    if (fieldName.indexOf('customfield_') === 0) {
        const customFieldId = fieldName.split('customfield_')[1];
        return `cf[${customFieldId}]`;
    }
    // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
    // the "to" fieldName for the date range will be transformed to "due" in the "serialiseJql" function
    // where "const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;"
    if (fieldName === 'dateRange') return $1e9d101255159a24$var$START_DATE_JQL;
    return fieldName;
};
const $1e9d101255159a24$var$getFieldNameForJql = (fieldName)=>$1e9d101255159a24$var$getQuotedFieldName($1e9d101255159a24$var$getFieldNameForJqlRaw(fieldName));
const $1e9d101255159a24$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
    const fieldName = (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(rawFieldName, '"');
    const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
    // `cf[id]` -> `customfield_${id}`.
    if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
        const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
        if (!extraction) return fieldName;
        const fieldId = extraction[1];
        return `customfield_${fieldId}`;
    }
    const startDateJql = $1e9d101255159a24$var$START_DATE_JQL;
    // update this if we add a start date or due date filter
    if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
    return fieldName;
};
const $1e9d101255159a24$var$sanitizeWord = (word)=>word.replace(/(["\\])/g, '\\$1');
const $1e9d101255159a24$var$sanitizeWordOld = (word)=>word.replace(/'/g, "\\'");
const $1e9d101255159a24$export$e1718e1e441cb0f6 = (filters)=>{
    const jqlQuery = (0, $iEIQF.default).query();
    Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(options.value)))).forEach(([fieldId, options])=>{
        const fieldName = $1e9d101255159a24$var$getFieldNameForJqlRaw(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;
            if (options.value.to != null) {
                const toDate = (0, $f9ece.default)((0, $gwejS.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                jqlQuery.appendClause((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field(toFieldName), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_LT)), (0, $iEIQF.default).valueOperand(toDate)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            }
            if (options.value.from != null) jqlQuery.appendClause((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field(fieldName), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_GT_EQUALS)), (0, $iEIQF.default).valueOperand(options.value.from)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            return;
        }
        if (Array.isArray(options)) {
            const operands = options.map((option)=>{
                if (option.isEmptyOption) return (0, $iEIQF.default).valueOperand((0, $49b29ef7baa2a152$export$1c46dca02aac24dd));
                if (option.value) // Currently, the AST does not sanatize all values correctly (no \ or JQL keywords), so we need to manually wrap in quotes
                // We can remove this once https://jplat.jira.atlassian.cloud/browse/EM-6563 is implemented
                return (0, $iEIQF.default).byText.valueOperand(`"${$1e9d101255159a24$var$sanitizeWord(option.value)}"`);
                return null;
            }).filter((operand)=>operand != null);
            if (operands.length === 1) jqlQuery.appendClause((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field(fieldName), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_EQUALS)), operands[0]), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            else if (operands.length > 1) jqlQuery.appendClause((0, $iEIQF.default).terminalClause((0, $iEIQF.default).field(fieldName), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_IN)), (0, $iEIQF.default).listOperand(operands)), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
        }
    });
    const jast = (0, $iEIQF.default).jast(jqlQuery);
    return (0, $l0V05.print)(jast, {
        operatorCase: 'upper',
        printWidth: null
    });
};
const $1e9d101255159a24$export$5bd6a523f48a18cd = (filters)=>{
    const pairs = Object.entries(filters).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(options.value)))) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([fieldId, options])=>{
        const fieldName = $1e9d101255159a24$var$getFieldNameForJql(fieldId);
        if (!Array.isArray(options) && typeof options === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(options?.value)) {
            // one additional day will be added to jql 'to' date based on selected date, e.g. when due date is "2021-12-30"
            // date range jql will be formatted to e.g. "Start date[Date]" >= "2021-12-01" AND due < "2021-12-31"
            const toFieldName = fieldId === 'dateRange' ? $1e9d101255159a24$var$getQuotedFieldName('due') : fieldName;
            let toDate;
            if (options.value.to) toDate = (0, $f9ece.default)((0, $gwejS.default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
            else toDate = options.value.to;
            if (options.value.from != null && options.value.to != null) return `${fieldName} >= ${options.value.from} AND ${toFieldName} < ${toDate}`;
            if (options.value.from != null) return `${fieldName} >= ${options.value.from}`;
            return `${toFieldName} < ${toDate}`;
        }
        if (Array.isArray(options)) {
            const values = options.map((option)=>// make sure we don't wrap EMPTY with quotation marks
                option.value === (0, $7htvz.EMPTY_FILTER_VALUE) ? $1e9d101255159a24$var$EMPTY : `'${$1e9d101255159a24$var$sanitizeWordOld(option.value)}'`).join(',');
            if (options.length > 1) return `${fieldName} in (${values})`;
            if (options.length === 1) return `${fieldName} = ${values}`;
        }
        return null;
    });
    return pairs.join(' AND ');
};
const $1e9d101255159a24$var$extractField = (statement)=>{
    let fieldId;
    const dateOperatorRegex = />=|</;
    if (dateOperatorRegex.test(statement)) {
        const operator = statement.includes('>=') ? ' >= ' : ' < ';
        [fieldId] = statement.split(operator);
    }
    if (statement.includes(' = ')) [fieldId] = statement.split(/ = /);
    if (statement.includes(' in ')) [fieldId] = statement.split(' in ');
    if (fieldId) return $1e9d101255159a24$var$getFieldIdFromJql(fieldId);
};
const $1e9d101255159a24$export$9ee6085825c9cbfa = (jql)=>{
    if (!jql) return {};
    return jql.split(/ AND | OR /).map($1e9d101255159a24$var$extractField).reduce((acc, curr)=>{
        if (curr) acc[curr] = true;
        return acc;
    }, {});
};

});
parcelRegister("2nvJN", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");

var $6wH7T = parcelRequire("6wH7T");

var $gvFfr = parcelRequire("gvFfr");

var $4TR1Q = parcelRequire("4TR1Q");

var $c2mKc = parcelRequire("c2mKc");

var $jx6Tp = parcelRequire("jx6Tp");

var $jJVtR = parcelRequire("jJVtR");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $1bb6592c97235e03$var$trim(string, chars, guard) {
    string = $jJVtR(string);
    if (string && (guard || chars === undefined)) return $6wH7T(string);
    if (!string || !(chars = $kHBB0(chars))) return string;
    var strSymbols = $jx6Tp(string), chrSymbols = $jx6Tp(chars), start = $c2mKc(strSymbols, chrSymbols), end = $4TR1Q(strSymbols, chrSymbols) + 1;
    return $gvFfr(strSymbols, start, end).join('');
}
module.exports = $1bb6592c97235e03$var$trim;

});
parcelRegister("4TR1Q", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $39156edc40ecb497$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $39156edc40ecb497$var$charsEndIndex;

});

parcelRegister("c2mKc", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $8c37507367fba30b$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $8c37507367fba30b$var$charsStartIndex;

});


const $3cef51f82b2cbe1d$export$6d6d48d210d3ca97 = 'and';
const $3cef51f82b2cbe1d$export$7b8f0a728d79a753 = 'or';

const $49b29ef7baa2a152$export$38accfc5a5d1c113 = 'value';
const $49b29ef7baa2a152$export$f6049126fd97001f = 'keyword';
const $49b29ef7baa2a152$export$19c7c729db381f9d = 'function';
const $49b29ef7baa2a152$export$fabec4aebba3f4df = 'list';
const $49b29ef7baa2a152$export$1c46dca02aac24dd = 'empty';

parcelRegister("7htvz", function(module, exports) {

$parcel$export(module.exports, "OPTIMISTIC_ID", () => $d5b40c70d7e37442$export$6e40821019289c70);
$parcel$export(module.exports, "CREATE_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$d6ceedee35ae2c19);
$parcel$export(module.exports, "UPDATE_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$ca3691ea47eec823);
$parcel$export(module.exports, "DELETE_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$2a5fce320f18ac6c);
$parcel$export(module.exports, "STAR_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$b0ec8deb6068dc3b);
$parcel$export(module.exports, "SAVED_FILTER_EXPERIENCE", () => $d5b40c70d7e37442$export$6c99c87a0ac0052a);
$parcel$export(module.exports, "EMPTY_FILTER_VALUE", () => $d5b40c70d7e37442$export$9ebaf9fe814731d3);
$parcel$export(module.exports, "SIMPLE_SEARCH_PARAM", () => $d5b40c70d7e37442$export$9b72011e2eb8d7d0);
const $d5b40c70d7e37442$export$b8b9d90f9e5bd72b = 'jiraBusinessFilters';
const $d5b40c70d7e37442$export$6e40821019289c70 = 'optimistic-filter-id';
const $d5b40c70d7e37442$export$d6ceedee35ae2c19 = {
    experience: 'filtersCreateSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$ca3691ea47eec823 = {
    experience: 'filtersUpdateSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$2a5fce320f18ac6c = {
    experience: 'filtersDeleteSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$b0ec8deb6068dc3b = {
    experience: 'filtersStarSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$6c99c87a0ac0052a = {
    experience: 'filtersLoadSavedFilters',
    packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
    teamName: 'wanjel'
};
const $d5b40c70d7e37442$export$9ebaf9fe814731d3 = null;
const $d5b40c70d7e37442$export$9b72011e2eb8d7d0 = 'text';

});



parcelRegister("57r8q", function(module, exports) {

$parcel$export(module.exports, "FormatRulesFragment", () => $846afdd27dc3631b$export$cf415232d9027c0b);
$parcel$export(module.exports, "FormatRules", () => $846afdd27dc3631b$export$85cc1c447494ea9e);

var $ejcnh = parcelRequire("ejcnh");

var $go8Rc = parcelRequire("go8Rc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $llMZa = parcelRequire("llMZa");

var $hug5L = parcelRequire("hug5L");
const $846afdd27dc3631b$export$cf415232d9027c0b = ({ project: project })=>{
    const [, { setFormatRules: setFormatRules, setRulesForJqlInput: setRulesForJqlInput }] = (0, $hug5L.useFormatRulesStore)();
    const projectData = (0, $8Uumt.useFragment)((0, $go8Rc.default), project);
    (0, $5uXOq.useEffect)(()=>{
        const formattingRulesByProject = projectData?.conditionalFormattingRules;
        if (!formattingRulesByProject) return;
        /* rowRules and cellRulesByFieldId - data to be able to format per rows and per field cell */ let rowRules = [];
        const cellRulesByFieldId = {};
        const rulesJqlInput = {};
        formattingRulesByProject.edges?.forEach((edge, index)=>{
            const rule = edge?.node;
            if (rule) {
                const { formattingArea: formattingArea, formattingColor: formattingColor } = rule;
                let fieldId = null;
                let operator = 'IS';
                let value;
                switch(rule.expression.__typename){
                    case 'JiraFormattingSingleValueOperand':
                        operator = rule.expression.singleValueOperator;
                        ({ value: value, fieldId: fieldId } = rule.expression);
                        break;
                    case 'JiraFormattingMultipleValueOperand':
                        operator = rule.expression.multipleValueOperator;
                        value = rule.expression.values;
                        fieldId = rule.expression.fieldId;
                        break;
                    case 'JiraFormattingNoValueOperand':
                        operator = rule.expression.noValueOperator;
                        fieldId = rule.expression.fieldId;
                        break;
                    default:
                        break;
                }
                const color = (0, $llMZa.formattingColors)[formattingColor.colorKey || ''];
                const mappedRule = {
                    id: rule.id,
                    fieldId: fieldId,
                    operator: operator,
                    value: value,
                    color: color?.value,
                    formattingArea: formattingArea,
                    index: index,
                    hoverColor: color?.hoverValue
                };
                if (mappedRule.fieldId) {
                    if (mappedRule.formattingArea === 'ROW') rowRules = [
                        ...rowRules,
                        mappedRule
                    ];
                    else cellRulesByFieldId[mappedRule.fieldId] = [
                        ...cellRulesByFieldId[mappedRule.fieldId] || [],
                        mappedRule
                    ];
                    // input to serialise jql input
                    const DUMMY_VALUE = '-';
                    const values = Array.isArray(mappedRule.value) ? mappedRule.value : [
                        mappedRule.value
                    ];
                    if (!rulesJqlInput[mappedRule.fieldId]) rulesJqlInput[mappedRule.fieldId] = [];
                    values.forEach((ruleValue)=>{
                        if (mappedRule.fieldId) rulesJqlInput[mappedRule.fieldId]?.push({
                            value: ruleValue ?? DUMMY_VALUE,
                            label: ruleValue ?? DUMMY_VALUE
                        });
                    });
                }
            }
        });
        setFormatRules({
            rowRules: rowRules,
            cellRulesByFieldId: cellRulesByFieldId
        });
        setRulesForJqlInput(rulesJqlInput);
    }, [
        projectData?.conditionalFormattingRules,
        setFormatRules,
        setRulesForJqlInput
    ]);
    return null;
};
const $846afdd27dc3631b$export$85cc1c447494ea9e = ({ query: query })=>{
    const [, { setFormatRules: setFormatRules, setRulesForJqlInput: setRulesForJqlInput }] = (0, $hug5L.useFormatRulesStore)();
    const { jira: jira } = (0, $8Uumt.usePreloadedQuery)((0, $ejcnh.default), query);
    if ((0, $4R6GH.fg)('conditional-formatting-new-list-targeting-gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($846afdd27dc3631b$export$cf415232d9027c0b, {
        project: jira?.jiraProjectByKey ?? null
    });
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        const formattingRulesByProject = jira?.jiraProjectByKey?.conditionalFormattingRules;
        if (!formattingRulesByProject) return;
        /* rowRules and cellRulesByFieldId - data to be able to format per rows and per field cell */ let rowRules = [];
        const cellRulesByFieldId = {};
        const rulesJqlInput = {};
        formattingRulesByProject.edges?.forEach((edge, index)=>{
            const rule = edge?.node;
            if (rule) {
                const { formattingArea: formattingArea, formattingColor: formattingColor } = rule;
                let fieldId = null;
                let operator = 'IS';
                let value;
                switch(rule.expression.__typename){
                    case 'JiraFormattingSingleValueOperand':
                        operator = rule.expression.singleValueOperator;
                        ({ value: value, fieldId: fieldId } = rule.expression);
                        break;
                    case 'JiraFormattingMultipleValueOperand':
                        operator = rule.expression.multipleValueOperator;
                        value = rule.expression.values;
                        fieldId = rule.expression.fieldId;
                        break;
                    case 'JiraFormattingNoValueOperand':
                        operator = rule.expression.noValueOperator;
                        fieldId = rule.expression.fieldId;
                        break;
                    default:
                        break;
                }
                const color = (0, $llMZa.formattingColors)[formattingColor.colorKey || ''];
                const mappedRule = {
                    id: rule.id,
                    fieldId: fieldId,
                    operator: operator,
                    value: value,
                    color: color?.value,
                    formattingArea: formattingArea,
                    index: index,
                    hoverColor: color?.hoverValue
                };
                if (mappedRule.fieldId) {
                    if (mappedRule.formattingArea === 'ROW') rowRules = [
                        ...rowRules,
                        mappedRule
                    ];
                    else cellRulesByFieldId[mappedRule.fieldId] = [
                        ...cellRulesByFieldId[mappedRule.fieldId] || [],
                        mappedRule
                    ];
                    // input to serialise jql input
                    const DUMMY_VALUE = '-';
                    const values = Array.isArray(mappedRule.value) ? mappedRule.value : [
                        mappedRule.value
                    ];
                    if (!rulesJqlInput[mappedRule.fieldId]) rulesJqlInput[mappedRule.fieldId] = [];
                    values.forEach((ruleValue)=>{
                        if (mappedRule.fieldId) rulesJqlInput[mappedRule.fieldId]?.push({
                            value: ruleValue ?? DUMMY_VALUE,
                            label: ruleValue ?? DUMMY_VALUE
                        });
                    });
                }
            }
        });
        setFormatRules({
            rowRules: rowRules,
            cellRulesByFieldId: cellRulesByFieldId
        });
        setRulesForJqlInput(rulesJqlInput);
    }, [
        jira?.jiraProjectByKey?.conditionalFormattingRules,
        setFormatRules,
        setRulesForJqlInput
    ]);
    return null;
};

});
parcelRegister("ejcnh", function(module, exports) {

$parcel$export(module.exports, "default", () => $653ec3882dd047d6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<95d4abafcfb290f631a217330c0a3956>>
 * @relayHash 59527960279493483dc426741a94e942
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 27842af21d3c4a1c89e9cf81f5d797dbb89b3da4ac6cc54f90271e8a38b37e39

var $eiowN = parcelRequire("eiowN");
const $653ec3882dd047d6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v7 = {
        "kind": "ScalarField",
        "name": "formattingArea"
    }, v8 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v9 = {
        "kind": "LinkedField",
        "name": "expression",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "singleValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    }
                ],
                "type": "JiraFormattingSingleValueOperand"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "multipleValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "values"
                    }
                ],
                "type": "JiraFormattingMultipleValueOperand"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    v8 /*: any*/ ,
                    {
                        "alias": "noValueOperator",
                        "kind": "ScalarField",
                        "name": "operator"
                    }
                ],
                "type": "JiraFormattingNoValueOperand"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "formatRulesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "kind": "FragmentSpread",
                                    "name": "formatRules_businessConditionalFormattingSidebar_FormatRulesFragment"
                                },
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ 
                                                            ]
                                                        },
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "formatRulesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v4 /*: any*/ ,
                                    "concreteType": "JiraFormattingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "conditionalFormattingRules",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraFormattingRuleEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraFormattingRule",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColor",
                                                            "kind": "LinkedField",
                                                            "name": "formattingColor",
                                                            "plural": false,
                                                            "selections": [
                                                                v6 /*: any*/ ,
                                                                v5 /*: any*/ 
                                                            ]
                                                        },
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "27842af21d3c4a1c89e9cf81f5d797dbb89b3da4ac6cc54f90271e8a38b37e39",
            "metadata": {},
            "name": "formatRulesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$653ec3882dd047d6$var$node.hash = "b2def96ee17b5bfd7a5b577bd4301147";
(0, $eiowN.PreloadableQueryRegistry).set($653ec3882dd047d6$var$node.params.id, $653ec3882dd047d6$var$node);
var $653ec3882dd047d6$export$2e2bcd8739ae039 = $653ec3882dd047d6$var$node;

});

parcelRegister("go8Rc", function(module, exports) {

$parcel$export(module.exports, "default", () => $58b89e1736caa005$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<839413db397c95fa8604c3b01b6bfa04>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $58b89e1736caa005$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "first"
            }
        ],
        "kind": "Fragment",
        "name": "formatRules_businessConditionalFormattingSidebar_FormatRulesFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "first"
                    }
                ],
                "concreteType": "JiraFormattingRuleConnection",
                "kind": "LinkedField",
                "name": "conditionalFormattingRules",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraFormattingRule",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    {
                                        "concreteType": "JiraColor",
                                        "kind": "LinkedField",
                                        "name": "formattingColor",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "colorKey"
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "name": "formattingArea"
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "name": "expression",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "__typename"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "singleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "value"
                                                    }
                                                ],
                                                "type": "JiraFormattingSingleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "multipleValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "values"
                                                    }
                                                ],
                                                "type": "JiraFormattingMultipleValueOperand"
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "selections": [
                                                    v0 /*: any*/ ,
                                                    {
                                                        "alias": "noValueOperator",
                                                        "kind": "ScalarField",
                                                        "name": "operator"
                                                    }
                                                ],
                                                "type": "JiraFormattingNoValueOperand"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraProject"
    };
}();
$58b89e1736caa005$var$node.hash = "e4aafb5aefdb03989117bf28ddf60a06";
var $58b89e1736caa005$export$2e2bcd8739ae039 = $58b89e1736caa005$var$node;

});

parcelRegister("llMZa", function(module, exports) {

$parcel$export(module.exports, "formattingColors", () => $b066db4218a81ff1$export$2fedf4ac4eb04087);
$parcel$export(module.exports, "getColorKeyFromValue", () => $b066db4218a81ff1$export$ae7e938b8bdf2df5);

var $8QpSo = parcelRequire("8QpSo");

var $deuYz = parcelRequire("deuYz");
const $b066db4218a81ff1$export$2fedf4ac4eb04087 = {
    lightPurple: {
        label: (0, $deuYz.default).lightPurple,
        value: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
        hoverValue: "var(--ds-background-accent-purple-subtlest-hovered, #DFD8FD)"
    },
    lightBlue: {
        label: (0, $deuYz.default).lightBlue,
        value: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
        hoverValue: "var(--ds-background-accent-blue-subtlest-hovered, #CCE0FF)"
    },
    lightGreen: {
        label: (0, $deuYz.default).lightGreen,
        value: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
        hoverValue: "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)"
    },
    lightTeal: {
        label: (0, $deuYz.default).lightTeal,
        value: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
        hoverValue: "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)"
    },
    lightYellow: {
        label: (0, $deuYz.default).lightYellow,
        value: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        hoverValue: "var(--ds-background-accent-yellow-subtlest-hovered, #F8E6A0)"
    },
    lightRed: {
        label: (0, $deuYz.default).lightRed,
        value: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        hoverValue: "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)"
    },
    lightGray: {
        label: (0, $deuYz.default).lightGray,
        value: "var(--ds-background-accent-gray-subtlest, #F1F2F4)",
        hoverValue: "var(--ds-background-accent-gray-subtlest-hovered, #DCDFE4)"
    },
    purple: {
        label: (0, $deuYz.default).purple,
        value: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hoverValue: "var(--ds-background-accent-purple-subtler-hovered, #B8ACF6)"
    },
    blue: {
        label: (0, $deuYz.default).blue,
        value: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hoverValue: "var(--ds-background-accent-blue-subtler-hovered, #85B8FF)"
    },
    green: {
        label: (0, $deuYz.default).green,
        value: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hoverValue: "var(--ds-background-accent-green-subtler-hovered, #7EE2B8)"
    },
    teal: {
        label: (0, $deuYz.default).teal,
        value: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hoverValue: "var(--ds-background-accent-teal-subtler-hovered, #9DD9EE)"
    },
    yellow: {
        label: (0, $deuYz.default).yellow,
        value: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hoverValue: "var(--ds-background-accent-yellow-subtler-hovered, #F5CD47)"
    },
    red: {
        label: (0, $deuYz.default).red,
        value: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hoverValue: "var(--ds-background-accent-red-subtler-hovered, #FD9891)"
    },
    gray: {
        label: (0, $deuYz.default).gray,
        value: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hoverValue: "var(--ds-background-accent-gray-subtler-hovered, #B3B9C4)"
    }
};
const $b066db4218a81ff1$export$ae7e938b8bdf2df5 = (0, $8QpSo.default)((value)=>{
    const selectedColor = Object.entries($b066db4218a81ff1$export$2fedf4ac4eb04087).find(([_, color])=>color.value === value);
    return selectedColor?.[0];
});

});
parcelRegister("deuYz", function(module, exports) {

$parcel$export(module.exports, "default", () => $431e5d2eb706d069$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $431e5d2eb706d069$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    lightPurple: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-purple",
        "defaultMessage": "Subtle purple"
    },
    lightBlue: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-blue",
        "defaultMessage": "Subtle blue"
    },
    lightGreen: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-green",
        "defaultMessage": "Subtle green"
    },
    lightTeal: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-teal",
        "defaultMessage": "Subtle teal"
    },
    lightYellow: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-yellow",
        "defaultMessage": "Subtle yellow"
    },
    lightRed: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-red",
        "defaultMessage": "Subtle red"
    },
    lightGray: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.light-gray",
        "defaultMessage": "Subtle gray"
    },
    purple: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.purple",
        "defaultMessage": "Bold purple"
    },
    blue: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.blue",
        "defaultMessage": "Bold blue"
    },
    green: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.green",
        "defaultMessage": "Bold green"
    },
    teal: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.teal",
        "defaultMessage": "Bold teal"
    },
    yellow: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.yellow",
        "defaultMessage": "Bold yellow"
    },
    red: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.red",
        "defaultMessage": "Bold red"
    },
    gray: {
        "id": "business-conditional-formatting-sidebar.common.utils.formatting-colors.gray",
        "defaultMessage": "Bold gray"
    }
});

});



parcelRegister("5YBrl", function(module, exports) {

$parcel$export(module.exports, "JqlProvider", () => $81e54c5b62a4ab4d$export$fdc879e2ba0da048);
$parcel$export(module.exports, "useJqlContext", () => $81e54c5b62a4ab4d$export$f32e2f688fc08561);

var $5uXOq = parcelRequire("5uXOq");
const $81e54c5b62a4ab4d$var$JqlContext = /*#__PURE__*/ (0, $5uXOq.createContext)('');
const $81e54c5b62a4ab4d$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($81e54c5b62a4ab4d$var$JqlContext.Provider, {
        value: jqlContext
    }, children);
const $81e54c5b62a4ab4d$export$f32e2f688fc08561 = ()=>(0, $5uXOq.useContext)($81e54c5b62a4ab4d$var$JqlContext);

});


parcelRegister("1z7Yr", function(module, exports) {

$parcel$export(module.exports, "useAppContextualAnalyticsActions", () => $48ac6de4ef0bf23b$export$8aad1a4e4d637906);
$parcel$export(module.exports, "AppContextualAnalytics", () => $48ac6de4ef0bf23b$export$2942dddca20a92ac);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $iXVV6 = parcelRequire("iXVV6");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $48ac6de4ef0bf23b$var$Container = (0, $gg7kZ.createContainer)();
const $48ac6de4ef0bf23b$var$Store = (0, $iXqE5.createStore)({
    name: 'AppContextualAnalyticsStore',
    containedBy: $48ac6de4ef0bf23b$var$Container,
    initialState: {
        issueNavigatorSearchSessionId: undefined
    },
    actions: {
        onJourneyStart: ()=>({ setState: setState })=>{
                const issueNavigatorSearchSessionId = (0, $7Jxgt.v4)();
                setState({
                    issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
                });
                return {
                    issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
                };
            }
    }
});
const $48ac6de4ef0bf23b$export$e1e7a4797df1a656 = (0, $3sQ5x.createHook)($48ac6de4ef0bf23b$var$Store, {
    selector: (state)=>state.issueNavigatorSearchSessionId
});
const $48ac6de4ef0bf23b$export$8aad1a4e4d637906 = (0, $3sQ5x.createActionsHook)($48ac6de4ef0bf23b$var$Store);
const $48ac6de4ef0bf23b$var$AppContextualAnalyticsData = ({ children: children })=>{
    const [issueNavigatorSearchSessionId] = $48ac6de4ef0bf23b$export$e1e7a4797df1a656();
    const attributes = (0, $5uXOq.useMemo)(()=>({
            issueNavigatorSearchSessionId: issueNavigatorSearchSessionId
        }), [
        issueNavigatorSearchSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "issueNavigator",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: attributes
    }, children);
};
const $48ac6de4ef0bf23b$export$2942dddca20a92ac = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48ac6de4ef0bf23b$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48ac6de4ef0bf23b$var$AppContextualAnalyticsData, null, children));

});
// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("gwtSG", function(module, exports) {

$parcel$export(module.exports, "useActiveJql", () => $403641b131a496d8$export$caeaf867313163e4);
$parcel$export(module.exports, "ActiveJqlProvider", () => $403641b131a496d8$export$c69a9a3114157ae7);
$parcel$export(module.exports, "useResolvedJql", () => $403641b131a496d8$export$23e17984875d36b4);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $9Nvh7 = parcelRequire("9Nvh7");
const $403641b131a496d8$var$ActiveJqlContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    jql: ''
});
$403641b131a496d8$var$ActiveJqlContext.displayName = 'ActiveJqlContext';
const $403641b131a496d8$export$caeaf867313163e4 = ()=>(0, $5uXOq.useContext)($403641b131a496d8$var$ActiveJqlContext);
const $403641b131a496d8$export$c69a9a3114157ae7 = ({ jql: jql, filterId: filterId, isFilterEditable: isFilterEditable, filterJql: filterJql, children: children })=>{
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            jql: jql,
            filterId: filterId,
            isFilterEditable: isFilterEditable,
            filterJql: filterJql
        }), [
        jql,
        filterId,
        isFilterEditable,
        filterJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($403641b131a496d8$var$ActiveJqlContext.Provider, {
        value: contextValue
    }, children);
};
const $403641b131a496d8$export$23e17984875d36b4 = ()=>{
    const { jql: jql, filterJql: filterJql } = $403641b131a496d8$export$caeaf867313163e4();
    const filter = filterJql !== undefined ? filterJql : '';
    return jql !== undefined ? jql : filter;
};
const $403641b131a496d8$export$5d3c8489d1ae8bee = ()=>{
    const { filterId: filterId, jql: jql } = $403641b131a496d8$export$caeaf867313163e4();
    return `/issues/?${(0, $ebyGx.stringify)({
        jql: jql,
        ...(0, $9Nvh7.isFilterId)(filterId) ? {
            filter: filterId
        } : {}
    })}`;
};

});

parcelRegister("cKK2E", function(module, exports) {

$parcel$export(module.exports, "useFilterQuery", () => $964d8c42bd13cd02$export$5576614cd48b552);
$parcel$export(module.exports, "FilterQueryProvider", () => $964d8c42bd13cd02$export$78b7af8c530bd7a4);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9Nvh7 = parcelRequire("9Nvh7");

var $qXt2q = parcelRequire("qXt2q");

var $dXq4S = parcelRequire("dXq4S");

var $2NMNM = parcelRequire("2NMNM");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");
const $964d8c42bd13cd02$var$FilterQueryContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    filterQueryIsFetching: false,
    filterQueryIsNetworkError: false
});
$964d8c42bd13cd02$var$FilterQueryContext.displayName = 'FilterQueryContext';
const $964d8c42bd13cd02$export$5576614cd48b552 = ()=>(0, $5uXOq.useContext)($964d8c42bd13cd02$var$FilterQueryContext);
const $964d8c42bd13cd02$export$78b7af8c530bd7a4 = ({ refetch: refetch, query: query, children: children, filterId: filterId })=>{
    const [filterQueryIsFetching, setFilterQueryIsFetching] = (0, $5uXOq.useState)(false);
    const [filterQueryIsNetworkError, setFilterQueryNetworkError] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const activationId = (0, $fY39E.useActivationId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const inFlightRequest = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        if (filterId !== undefined && (0, $9Nvh7.isFilterId)(filterId)) {
            // Prevent race condition from multiple requests in progress
            // (ex. if user clicks quickly on different filters)
            inFlightRequest.current?.unsubscribe();
            const variables = {
                filterAri: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }),
                includeFilter: true
            };
            setFilterQueryIsFetching(true);
            setFilterQueryNetworkError(false);
            inFlightRequest.current = (0, $8Uumt.fetchQuery)(environment, query, variables, {
                fetchPolicy: 'store-or-network'
            }).subscribe({
                complete: ()=>{
                    refetch(variables, {
                        fetchPolicy: 'store-only'
                    });
                    setFilterQueryIsFetching(false);
                },
                error: ()=>{
                    setFilterQueryIsFetching(false);
                    setFilterQueryNetworkError(true);
                }
            });
        } else // Need to refetch when filter is undefined so it reset filterData to empty
        refetch({
            includeFilter: false,
            filterAri: ''
        }, {
            fetchPolicy: 'store-or-network'
        });
    }, [
        activationId,
        cloudId,
        environment,
        filterId,
        query,
        refetch,
        setFilterQueryIsFetching,
        setFilterQueryNetworkError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (filterId !== undefined && (0, $9Nvh7.isFilterId)(filterId)) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $qXt2q.addFilterToRecent)(filterId, analyticsEvent);
        }
    }, [
        filterId,
        createAnalyticsEvent
    ]);
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            filterQueryIsFetching: filterQueryIsFetching,
            filterQueryIsNetworkError: filterQueryIsNetworkError
        }), [
        filterQueryIsFetching,
        filterQueryIsNetworkError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($964d8c42bd13cd02$var$FilterQueryContext.Provider, {
        value: contextValue
    }, children);
};

});
parcelRegister("qXt2q", function(module, exports) {

$parcel$export(module.exports, "addFilterToRecent", () => $d3ebef4b85856e17$export$1f166118234b128e);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

const $d3ebef4b85856e17$export$1f166118234b128e = async (filterId, analyticsEvent)=>{
    try {
        await (0, $eusud.performPostRequest)((0, $530a97584bf6c339$export$3fdeac1311ebf841) + filterId);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            event: analyticsEvent,
            meta: {
                id: 'addFilterToRecent',
                packageName: 'jiraIssueNavigatorCustomFilters'
            }
        });
    }
};

});
const $530a97584bf6c339$export$3fdeac1311ebf841 = '/rest/issueNav/1/history/saveFilter/';



parcelRegister("a5eZM", function(module, exports) {

$parcel$export(module.exports, "IssueSearch", () => $b919584441152507$export$ce2913cefc6e57dc);

var $gn5Up = parcelRequire("gn5Up");

var $gaK4T = parcelRequire("gaK4T");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $4R6GH = parcelRequire("4R6GH");

var $9Nvh7 = parcelRequire("9Nvh7");

var $koeKL = parcelRequire("koeKL");

var $5eRaS = parcelRequire("5eRaS");

var $fY39E = parcelRequire("fY39E");

var $lODMY = parcelRequire("lODMY");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $gwtSG = parcelRequire("gwtSG");

var $1GlUV = parcelRequire("1GlUV");

var $foucT = parcelRequire("foucT");

var $1PJ7c = parcelRequire("1PJ7c");

var $cHftd = parcelRequire("cHftd");

var $hkDYg = parcelRequire("hkDYg");
const $b919584441152507$var$useViewItemId = (0, $lODMY.createRouterSelector)((state)=>state.match?.params?.itemId);
const $b919584441152507$var$searchErrorFlagId = (0, $7HGHK.toFlagId)('ISSUE_NAVIGATOR_SEARCH_ERROR_FLAG');
const $b919584441152507$var$searchErrorFlag = {
    id: $b919584441152507$var$searchErrorFlagId,
    type: 'error',
    title: (0, $hkDYg.default).searchFailedTitle,
    description: (0, $hkDYg.default).searchFailedDescription,
    messageId: `issue-navigator.ui.issue-search.searchErrorFlag.${$b919584441152507$var$searchErrorFlagId}`,
    messageType: 'transactional'
};
const $b919584441152507$export$ce2913cefc6e57dc = ({ children: children, onPageDataLoad: onPageDataLoad, refetch: refetch, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, jiraView: jiraView, issueTableProps: issueTableProps, project: project })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const { jql: jql, filterId: filterId } = (0, $gwtSG.useActiveJql)();
    const issueSearchInput = (0, $5uXOq.useMemo)(()=>jql === undefined && (0, $9Nvh7.isFilterId)(filterId) ? {
            filterId: filterId
        } : {
            jql: jql
        }, [
        filterId,
        jql
    ]);
    const setSelectedView = (0, $cHftd.useSelectedViewMutation)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const viewItemId = (0, $4R6GH.fg)('saved_list_view_technical_changes') ? $b919584441152507$var$useViewItemId() : undefined;
    const jiraViewData = (0, $8Uumt.useFragment)((0, $gaK4T.default), jiraView);
    const projectData = (0, $8Uumt.useFragment)((0, $gn5Up.default), project);
    const groupedByField = jiraViewData?.viewSettings?.groupByConfig?.groupByField?.fieldId ?? null;
    const isGroupingEnabled = Boolean(issueTableProps?.isGroupingSupported) && Boolean(jiraViewData?.viewSettings?.isGroupingEnabled) && Boolean(jiraViewData?.viewSettings?.canEnableGrouping);
    const isHierarchyEnabled = Boolean(isIssueHierarchySupportEnabled && jiraViewData?.viewSettings?.isHierarchyEnabled);
    const isHideDoneEnabled = Boolean(jiraViewData?.viewSettings?.hideDone);
    const maybeViewId = jiraViewData?.viewId;
    const onRefetchStart = (0, $5uXOq.useCallback)(()=>{
        // Hide any search error flags currently visible
        dismissFlag($b919584441152507$var$searchErrorFlagId);
    }, [
        dismissFlag
    ]);
    const viewId = (0, $eJ0Zs.parseIssueNavigatorViewIdOrDefault)(maybeViewId);
    const isBifrost = (0, $4R6GH.fg)('split_showpinissuelist_by_bifrost_ssr') ? !!(0, $5eRaS.ssr).getFeatureFlags()?.ssrViaBifrost : undefined;
    const { onIssueSearchFail: onIssueSearchFail } = (0, $1GlUV.useExperienceAnalytics)(onPageDataLoad, {
        ...isGroupingEnabled ? {
            experienceId: (0, $6UAdF.GROUPED_LIST_EXPERIENCE_ID)
        } : {},
        ...(0, $4R6GH.fg)('split_showpinissuelist_by_bifrost_ssr') ? {
            isBifrost: isBifrost
        } : {}
    });
    const onRefetchError = (0, $5uXOq.useCallback)((error, refetchView)=>{
        onIssueSearchFail(`${(0, $6UAdF.PACKAGE_NAME)}.issue-search-refetch`, error, refetchView);
        showFlag($b919584441152507$var$searchErrorFlag);
    }, [
        onIssueSearchFail,
        showFlag
    ]);
    const projectContext = issueTableProps?.projectContext;
    (0, $foucT.useMainIssueNavigatorQueryShadowRequest)({
        first: 50,
        amountOfColumns: 500,
        fieldSetIds: [],
        shouldQueryFieldSetsById: false,
        cloudId: cloudId,
        issueSearchInput: issueSearchInput,
        atlassianIntelligenceProductFeature: 'NATURAL_LANGUAGE_TO_JQL',
        projectKey: projectContext ?? '',
        shouldQueryProject: false,
        shouldQueryConditionalFormatting: false,
        filterId: filterId ?? null,
        viewConfigInput: {
            viewInput: {
                namespace: 'ISSUE_NAVIGATOR'
            }
        },
        fieldSetsInput: {
            viewInput: {
                namespace: 'ISSUE_NAVIGATOR',
                filterId: filterId ?? null
            }
        },
        shouldQueryHasChildren: true
    }, viewId);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PJ7c.IssueSearchServiceContainer), {
        cloudId: cloudId,
        environment: environment,
        issueSearchInput: issueSearchInput,
        viewId: viewId,
        filterId: filterId,
        onPageDataLoad: onPageDataLoad,
        onRefetchStart: onRefetchStart,
        onRefetchError: onRefetchError,
        onSelectedViewMutation: setSelectedView,
        refetch: refetch,
        projectContext: projectContext,
        isHierarchyEnabled: isHierarchyEnabled,
        isHideDoneEnabled: isHideDoneEnabled,
        groupedByField: groupedByField,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        activationId: activationId,
        projectId: projectData?.projectId,
        viewItemId: viewItemId
    }, children);
};

});
parcelRegister("gn5Up", function(module, exports) {

$parcel$export(module.exports, "default", () => $a29d5f52ef3d41c6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d09b203bad6f239e73db022b952a1b41>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a29d5f52ef3d41c6$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "issueSearch_issueNavigatorProject",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "projectId"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$a29d5f52ef3d41c6$var$node.hash = "e90757060ed6001de993039f99771972";
var $a29d5f52ef3d41c6$export$2e2bcd8739ae039 = $a29d5f52ef3d41c6$var$node;

});

parcelRegister("gaK4T", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59cfac77de15fb0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ea21710515089caa04ab2a009d3b4e54>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f59cfac77de15fb0$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "issueSearch_issueNavigatorGrouping",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "viewId"
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isGroupingEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEnableGrouping"
                        },
                        {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "groupByField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isHierarchyEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$f59cfac77de15fb0$var$node.hash = "94322c7d4a10c641a16cca59cc5dc927";
var $f59cfac77de15fb0$export$2e2bcd8739ae039 = $f59cfac77de15fb0$var$node;

});

parcelRegister("1GlUV", function(module, exports) {

$parcel$export(module.exports, "useExperienceAnalytics", () => $5bd41227ba98547a$export$523b242362f30838);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dAfqg = parcelRequire("dAfqg");

var $efvDm = parcelRequire("efvDm");

var $4R6GH = parcelRequire("4R6GH");

var $k9JTq = parcelRequire("k9JTq");

var $ldyPw = parcelRequire("ldyPw");

var $2e4p8 = parcelRequire("2e4p8");

var $6UAdF = parcelRequire("6UAdF");
/**
 * This debouncer is shared between both the success and fail calls so that the last one called in the current event
 * loop tick is the one that gets logged. This helps us overcome weaknesses in the Relay-based rendering where an error
 * being thrown taks an additional render cycle to reach the component managing the analytics.
 */ const $5bd41227ba98547a$var$sharedDebouncer = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((action)=>action(), 0);
const $5bd41227ba98547a$export$523b242362f30838 = (/**
	 * Event emitted when page data has loaded and the key experience is interactive.
	 */ onPageDataLoad, /**
	 * Analytics attributes to be emitted as part of success/fail experience events.
	 */ attributes)=>{
    let analyticsAttributes = attributes;
    if ((0, $4R6GH.fg)('jira_nin_smart_link')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const isEmbed = (0, $2e4p8.useIsEmbedMode)();
        analyticsAttributes = {
            ...analyticsAttributes,
            isEmbed: isEmbed
        };
    }
    if ((0, $4R6GH.fg)('improve_nin_slo_events')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: project } = (0, $dAfqg.useProjectContext)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const appEditions = (0, $k9JTq.useAppEditions)();
        const application = project?.projectType ? (0, $efvDm.getApplicationForProject)(project.projectType) : null;
        const edition = application ? (0, $ldyPw.getEdition)(application, appEditions) : null;
        analyticsAttributes = {
            ...analyticsAttributes,
            application: application,
            edition: edition
        };
    }
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $6UAdF.EXPERIENCE_NAME),
        experienceId: undefined,
        analyticsSource: (0, $6UAdF.ANALYTICS_SOURCE)
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $6UAdF.EXPERIENCE_NAME),
        attributes: analyticsAttributes
    });
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $6UAdF.EXPERIENCE_NAME),
        attributes: analyticsAttributes
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onFireUIAnalyticsEvent = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'screen'
        });
        (0, $8zOmE.fireUIAnalytics)(event, 'issueSearchResults', attributes ?? {});
    }, [
        attributes,
        createAnalyticsEvent
    ]);
    const onIssueSearchSuccess = (0, $5uXOq.useCallback)((view)=>{
        $5bd41227ba98547a$var$sharedDebouncer(()=>{
            onExperienceStart();
            onExperienceSuccess();
            onFireUIAnalyticsEvent();
        });
        onPageDataLoad && onPageDataLoad(view);
    }, [
        onExperienceStart,
        onExperienceSuccess,
        onFireUIAnalyticsEvent,
        onPageDataLoad
    ]);
    const onIssueSearchFail = (0, $5uXOq.useCallback)((location, error, view)=>{
        $5bd41227ba98547a$var$sharedDebouncer(()=>{
            onExperienceStart();
            onExperienceFail(location, error);
        });
        onPageDataLoad && onPageDataLoad(view);
    }, [
        onExperienceFail,
        onExperienceStart,
        onPageDataLoad
    ]);
    return {
        onIssueSearchSuccess: onIssueSearchSuccess,
        onIssueSearchFail: onIssueSearchFail
    };
};

});

parcelRegister("foucT", function(module, exports) {

$parcel$export(module.exports, "fetchIssueNavigatorIssueSearchRefetchQueryShadow", () => $137529bbca2f4f2b$export$460584db8358ab3e);
$parcel$export(module.exports, "useMainIssueNavigatorQueryShadowRequest", () => $137529bbca2f4f2b$export$d0a69cc9f9c06a41);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $6UAdF = parcelRequire("6UAdF");
const $137529bbca2f4f2b$export$a5981df6f2a66c20 = async (variables, query, operationName)=>{
    try {
        await (0, $7f4tk.default)('/gateway/api/graphql', {
            method: 'POST',
            headers: {
                'X-ExperimentalApi': 'JiraIssueSearch, JiraProject'
            },
            body: JSON.stringify({
                operationName: operationName,
                query: query,
                variables: {
                    ...variables,
                    namespace: 'ISSUE_NAVIGATOR',
                    amountOfColumns: 500,
                    scope: {
                        operationScope: (0, $6UAdF.NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE)
                    },
                    __relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider: (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false),
                    __relay_internal__pv__atlassianjirarelayprovidersrcisjscinfinitescrollenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissuelinkscountrelayprovider: 1,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissuelinksentrypointrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcnikechinstorypointsinlineeditrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiralistinlineeditingrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider: (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider: (0, $4R6GH.fg)('frontier-currency-field-formatconfig-query'),
                    __relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider: true,
                    __relay_internal__pv__atlassianjirarelayprovidersrcgroupbyanyfieldstechnicalrelayprovider: true
                }
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            attributes: {
                message: `Shadow request for nin issue search ${operationName} failed`
            },
            meta: {
                id: 'shadow-request-for-nin-issue-search',
                packageName: 'jiraIssueNavigator',
                teamName: 'empanada'
            }
        });
    }
};

const $137529bbca2f4f2b$var$getIssueNavigatorIssueSearchRefetchQueryShadowOperation = (isGrouping = false)=>{
    const operation = (parcelRequire("96f30")).then((module)=>{
        const operationName = `IssueNavigatorIssueSearchRefetch${isGrouping ? 'Grouping' : ''}QueryShadow`;
        return {
            operationName: operationName,
            operation: module.operation.replace('IssueNavigatorIssueSearchRefetchQuery', operationName)
        };
    });
    return operation;
};

const $137529bbca2f4f2b$var$getMainIssueNavigatorQueryShadowOperation = (isGrouping = false)=>{
    const operation = (parcelRequire("6fnIe")).then((module)=>{
        const operationName = `main_IssueNavigator${isGrouping ? 'Grouping' : ''}QueryShadow`;
        return {
            operationName: operationName,
            operation: module.operation.replace('main_IssueNavigatorQuery', operationName)
        };
    });
    return operation;
};
const $137529bbca2f4f2b$var$catchedCallback = (cb)=>{
    return (...args)=>{
        try {
            cb(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                attributes: {
                    message: 'Queue shadow request for nin issue search failed'
                },
                meta: {
                    id: 'queue-shadow-request-for-nin-issue-search',
                    packageName: 'jiraIssueNavigator',
                    teamName: 'empanada'
                }
            });
        }
    };
};
const $137529bbca2f4f2b$var$catchedCallbackAsync = (cb)=>{
    return async (...args)=>{
        try {
            await cb(...args);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                attributes: {
                    message: 'Queue shadow request for nin issue search failed'
                },
                meta: {
                    id: 'queue-shadow-request-for-nin-issue-search',
                    packageName: 'jiraIssueNavigator',
                    teamName: 'empanada'
                }
            });
        }
    };
};
const $137529bbca2f4f2b$export$8ca28e57c08b20c8 = $137529bbca2f4f2b$var$catchedCallback((getOperation, variables)=>{
    if (false) return;
    // requestIdleCallback is not supported in Safari, so we need a workaround.
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback !== 'undefined') window.requestIdleCallback($137529bbca2f4f2b$var$catchedCallback(()=>setTimeout($137529bbca2f4f2b$var$catchedCallback(()=>{
            window.requestIdleCallback($137529bbca2f4f2b$var$catchedCallbackAsync(async ()=>{
                const query = await getOperation();
                $137529bbca2f4f2b$export$a5981df6f2a66c20(variables, query.operation, query.operationName);
            }));
        }), 5000)));
});
const $137529bbca2f4f2b$export$460584db8358ab3e = (variables, isGrouping)=>{
    $137529bbca2f4f2b$export$8ca28e57c08b20c8(()=>$137529bbca2f4f2b$var$getIssueNavigatorIssueSearchRefetchQueryShadowOperation(isGrouping), variables);
};
const $137529bbca2f4f2b$export$d0a69cc9f9c06a41 = (variables, viewId)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (variables.projectKey && viewId !== 'detail') {
            if ((0, $4R6GH.fg)('jira_list_hierarchy_shadow_requests')) $137529bbca2f4f2b$export$8ca28e57c08b20c8($137529bbca2f4f2b$var$getMainIssueNavigatorQueryShadowOperation, variables);
            else if ((0, $4R6GH.fg)('jira_list_group_shadow_requests')) {
                const groupByFields = [
                    'status',
                    'assignee',
                    'priority',
                    'com.atlassian.jira.plugin.system.customfieldtypes:float',
                    'com.pyxis.greenhopper.jira:jsw-story-points',
                    'com.pyxis.greenhopper.jira:gh-sprint',
                    'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category'
                ];
                // Switch between the main query with refactor enabled and with group by overrides
                const variableOverrides = (0, $4R6GH.fg)('jira_list_main_shadow_query_group_overrides') ? {
                    staticViewInput: {
                        isHierarchyEnabled: false,
                        isGroupingEnabled: true
                    },
                    viewConfigInput: {
                        staticViewInput: {
                            isHierarchyEnabled: false,
                            isGroupingEnabled: true
                        }
                    },
                    // Randomly select a groupBy field to test the shadow request
                    groupBy: groupByFields[Math.floor(Math.random() * groupByFields.length)]
                } : {};
                $137529bbca2f4f2b$export$8ca28e57c08b20c8(()=>$137529bbca2f4f2b$var$getMainIssueNavigatorQueryShadowOperation(true), {
                    ...variables,
                    ...variableOverrides
                });
            } else if ((0, $4R6GH.fg)('jsc_shadow_requests_for_project_column_config')) {
                const operationScope = (0, $6UAdF.NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE);
                const variableOverrides = {
                    fieldSetsScope: {
                        operationScope: operationScope,
                        projectKey: variables.projectKey
                    }
                };
                $137529bbca2f4f2b$export$8ca28e57c08b20c8($137529bbca2f4f2b$var$getMainIssueNavigatorQueryShadowOperation, {
                    ...variables,
                    ...variableOverrides
                });
            }
        }
    // We only want to fetch the main query once, so we don't need to add any dependencies here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("96f30", function(module, exports) {

let $6a0058b83511a39c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6a0058b83511a39c$var$load("kLHDj").then(()=>parcelRequire('8Ip33'));

});

parcelRegister("6fnIe", function(module, exports) {

let $48c68992bfa26c5b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $48c68992bfa26c5b$var$load("6s7py").then(()=>parcelRequire('hd4f0'));

});


parcelRegister("1PJ7c", function(module, exports) {

$parcel$export(module.exports, "IssueSearchServiceContainer", () => $4a9e937233ca8a4b$export$3744f0b7d0dd1936);
$parcel$export(module.exports, "Store", () => $4a9e937233ca8a4b$export$390f32400eaf98c9);

var $7Jxgt = parcelRequire("7Jxgt");

var $6Z846 = parcelRequire("6Z846");

var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $012Fv = parcelRequire("012Fv");
const $4a9e937233ca8a4b$var$initialState = {
    disposables: [],
    isFetching: false,
    isFetchingView: false,
    isRefreshing: false,
    isNetworkError: false,
    searchKey: '',
    totalIssueCount: null,
    totalIssueCountIsFetching: false,
    totalIssueCountIsError: false
};
const $4a9e937233ca8a4b$export$3744f0b7d0dd1936 = (0, $gg7kZ.createContainer)();
const $4a9e937233ca8a4b$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'IssueSearchServiceStore',
    initialState: $4a9e937233ca8a4b$var$initialState,
    actions: $012Fv.actions,
    containedBy: $4a9e937233ca8a4b$export$3744f0b7d0dd1936,
    handlers: {
        onInit: ()=>({ setState: setState })=>{
                setState({
                    searchKey: (0, $7Jxgt.v4)()
                });
            },
        onContainerUpdate: (nextProps, prevProps)=>({ dispatch: dispatch })=>{
                if (!(0, $6Z846.isShallowEqual)(nextProps.issueSearchInput, prevProps.issueSearchInput)) dispatch((0, $012Fv.onSearchInputUpdate)());
            },
        onDestroy: ()=>({ getState: getState })=>{
                const { disposables: disposables } = getState();
                // Dispose of any manually retained operations when the container is unmounted
                disposables.forEach((disposable)=>disposable.dispose());
            }
    }
});

});
parcelRegister("012Fv", function(module, exports) {

$parcel$export(module.exports, "onSearchInputUpdate", () => $a4a2e9f3a0dcbb02$export$61bc3f1fa2f74c3c);
$parcel$export(module.exports, "actions", () => $a4a2e9f3a0dcbb02$export$e324594224ef24da);

var $eANr0 = parcelRequire("eANr0");

var $7nsd3 = parcelRequire("7nsd3");

var $eiowN = parcelRequire("eiowN");

var $7Jxgt = parcelRequire("7Jxgt");

var $4R6GH = parcelRequire("4R6GH");

var $9Nvh7 = parcelRequire("9Nvh7");

var $kF1V3 = parcelRequire("kF1V3");

var $c1haS = parcelRequire("c1haS");

var $5cSAN = parcelRequire("5cSAN");

var $6s1PB = parcelRequire("6s1PB");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $foucT = parcelRequire("foucT");
const $a4a2e9f3a0dcbb02$export$61bc3f1fa2f74c3c = ()=>({ dispatch: dispatch }, { issueSearchInput: issueSearchInput, filterId: filterId, viewId: viewId })=>{
        const shouldLoadWithFilterViewId = viewId !== 'detail' && issueSearchInput.filterId && (0, $9Nvh7.isCustomFilter)(issueSearchInput.filterId);
        const isCurrentViewIdInvalid = (0, $eJ0Zs.isFilterViewId)(viewId) && viewId !== `list_filter_${filterId}`;
        let variables = {};
        if (issueSearchInput.filterId && shouldLoadWithFilterViewId) {
            const issueNavigatorViewId = (0, $eJ0Zs.convertFilterIdToIssueNavigatorId)(issueSearchInput.filterId);
            variables = {
                viewId: issueNavigatorViewId,
                fieldSetsInput: {
                    viewInput: {
                        namespace: 'ISSUE_NAVIGATOR',
                        viewId: issueNavigatorViewId
                    }
                }
            };
        } else if (isCurrentViewIdInvalid) variables = {
            viewId: (0, $6UAdF.DEFAULT_VIEW_ID),
            fieldSetsInput: {
                viewInput: {
                    namespace: 'ISSUE_NAVIGATOR',
                    viewId: (0, $6UAdF.DEFAULT_VIEW_ID)
                }
            }
        };
        dispatch($a4a2e9f3a0dcbb02$export$e324594224ef24da.onRefetch(variables));
    };
const $a4a2e9f3a0dcbb02$export$9eb6b63e55022ba0 = ()=>({ setState: setState })=>{
        setState({
            totalIssueCount: null,
            totalIssueCountIsFetching: false,
            totalIssueCountIsError: false
        });
    };
const $a4a2e9f3a0dcbb02$export$e324594224ef24da = {
    onChangeView: (viewId)=>({ dispatch: dispatch }, { onSelectedViewMutation: onSelectedViewMutation, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, activationId: activationId, cloudId: cloudId, projectId: projectId, viewItemId: viewItemId })=>{
            let viewARI = '';
            if ((0, $4R6GH.fg)('saved_list_view_technical_changes')) {
                const layout = viewId === 'detail' ? 'detail' : 'list';
                viewARI = (0, $5cSAN.createViewAri)({
                    activationId: activationId,
                    cloudId: cloudId,
                    layout: layout,
                    projectId: projectId,
                    viewItemId: viewItemId
                });
            }
            onSelectedViewMutation(viewId, viewARI);
            dispatch($a4a2e9f3a0dcbb02$export$e324594224ef24da.onRefetch({
                viewId: viewId,
                fieldSetsInput: {
                    viewInput: {
                        namespace: 'ISSUE_NAVIGATOR',
                        viewId: viewId
                    }
                },
                ...isIssueHierarchySupportEnabled && {
                    viewConfigInput: {
                        viewInput: {
                            namespace: 'ISSUE_NAVIGATOR',
                            viewId: viewId
                        }
                    },
                    shouldQueryHasChildren: viewId !== 'detail',
                    staticViewInput: null
                }
            }));
        },
    onChangeHierarchy: (nextIsHierarchyEnabled)=>({ dispatch: dispatch }, { isHierarchyEnabled: isHierarchyEnabled, groupedByField: groupedByField, isHideDoneEnabled: isHideDoneEnabled })=>{
            if (nextIsHierarchyEnabled !== isHierarchyEnabled) {
                const staticViewInput = {
                    isHierarchyEnabled: nextIsHierarchyEnabled,
                    isGroupingEnabled: !!groupedByField,
                    ...(0, $4R6GH.fg)('jsc_list_hide_done_items') ? {
                        isHideDoneEnabled: isHideDoneEnabled
                    } : {}
                };
                dispatch($a4a2e9f3a0dcbb02$export$e324594224ef24da.onRefetch({
                    staticViewInput: staticViewInput,
                    viewConfigInput: {
                        staticViewInput: staticViewInput
                    },
                    shouldQueryHasChildren: Boolean(nextIsHierarchyEnabled)
                }));
            }
        },
    onChangeGroupedByField: (nextGroupedByField)=>({ dispatch: dispatch }, { isHierarchyEnabled: isHierarchyEnabled, isHideDoneEnabled: isHideDoneEnabled })=>{
            const staticViewInput = {
                isHierarchyEnabled: isHierarchyEnabled,
                isGroupingEnabled: !!nextGroupedByField,
                ...(0, $4R6GH.fg)('jsc_list_hide_done_items') ? {
                    isHideDoneEnabled: isHideDoneEnabled
                } : {}
            };
            dispatch($a4a2e9f3a0dcbb02$export$e324594224ef24da.onRefetch({
                groupBy: nextGroupedByField,
                staticViewInput: staticViewInput,
                viewConfigInput: {
                    staticViewInput: staticViewInput
                }
            }));
        },
    onChangeHideDone: (nextIsHideDoneEnabled)=>({ dispatch: dispatch }, { isHierarchyEnabled: isHierarchyEnabled, groupedByField: groupedByField, isHideDoneEnabled: isHideDoneEnabled })=>{
            if (nextIsHideDoneEnabled !== isHideDoneEnabled) {
                const staticViewInput = {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isGroupingEnabled: !!groupedByField,
                    isHideDoneEnabled: nextIsHideDoneEnabled
                };
                dispatch($a4a2e9f3a0dcbb02$export$e324594224ef24da.onRefetch({
                    staticViewInput: staticViewInput,
                    viewConfigInput: {
                        staticViewInput: staticViewInput
                    },
                    shouldQueryHasChildren: Boolean(isHierarchyEnabled)
                }));
            }
        },
    onRefetch: (variables = {}, options = {})=>({ dispatch: dispatch, getState: getState, setState: setState }, { cloudId: cloudId, environment: environment, issueSearchInput: issueSearchInput, onRefetchStart: onRefetchStart, onRefetchError: onRefetchError, refetch: refetch, viewId: viewId, isHierarchyEnabled: isHierarchyEnabled, projectContext: projectContext, groupedByField: groupedByField, isHideDoneEnabled: isHideDoneEnabled, activationId: activationId, projectId: projectId, viewItemId: viewItemId })=>{
            let { inFlightRequest: inFlightRequest } = getState();
            // Some consumers may fire refetch queries before in-flight query
            // has been completed (e.g. while user is toggling columns on and off in
            // the column picker). In these situations, we always want to fetch latest
            // data from the API as column configuration may have changed for the user.
            // To do that, we disable Relay's automatic de-deduping of requests.
            inFlightRequest?.unsubscribe();
            const staticViewInput = {
                isHierarchyEnabled: isHierarchyEnabled,
                isGroupingEnabled: !!groupedByField,
                isHideDoneEnabled: isHideDoneEnabled
            };
            let operationScope;
            if (projectContext) operationScope = (0, $6UAdF.NIN_PROJECT_OPERATION_SCOPE);
            else operationScope = (0, $6UAdF.NIN_GLOBAL_OPERATION_SCOPE);
            const finalVariables = {
                cloudId: cloudId,
                issueSearchInput: issueSearchInput,
                first: (0, $6UAdF.MAX_ISSUES_PER_PAGE),
                after: null,
                namespace: 'ISSUE_NAVIGATOR',
                viewId: viewId,
                options: null,
                fieldSetIds: [],
                shouldQueryFieldSetsById: false,
                shouldQueryHasChildren: isHierarchyEnabled || false,
                fieldSetsInput: {
                    viewInput: {
                        namespace: 'ISSUE_NAVIGATOR',
                        viewId: viewId
                    }
                },
                amountOfColumns: (0, $6UAdF.MAX_AMOUNT_OF_COLUMNS),
                ...(0, $4R6GH.fg)('jsc_nin_operation_scope_fe') && {
                    scope: {
                        operationScope: operationScope,
                        ...projectContext && (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false) ? {
                            projectKey: projectContext ?? null
                        } : {}
                    }
                },
                filterId: null,
                staticViewInput: staticViewInput,
                viewConfigInput: {
                    staticViewInput: staticViewInput
                },
                groupBy: groupedByField,
                isPaginating: false,
                projectKeys: projectContext ? [
                    projectContext
                ] : null,
                projectKey: projectContext ?? null,
                ...projectContext && (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false) && {
                    fieldSetsScope: {
                        operationScope: operationScope,
                        projectKey: projectContext
                    }
                },
                ...variables
            };
            if ((0, $4R6GH.fg)('saved_list_view_technical_changes')) {
                let layout = 'list';
                if (finalVariables.viewId === 'detail') layout = 'detail';
                else if (finalVariables.groupBy != null) layout = 'grouped';
                finalVariables.viewQueryInput = {
                    viewAri: (0, $5cSAN.createViewAri)({
                        activationId: activationId,
                        cloudId: cloudId,
                        layout: layout,
                        projectId: projectId,
                        viewItemId: viewItemId
                    })
                };
            }
            inFlightRequest = (0, $eiowN.fetchQuery)(environment, (0, $kF1V3.default), finalVariables, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                complete: ()=>{
                    /**
         * fetchQuery will NOT retain the data for the query, meaning that it is not guaranteed that the
         * data will remain saved in the Relay store at any point after the request completes.
         * We need to explicitly retain the operation to ensure it doesn't get deleted.
         * See https://relay.dev/docs/api-reference/fetch-query/#behavior
         */ const operation = (0, $eiowN.createOperationDescriptor)((0, $eiowN.getRequest)((0, $kF1V3.default)), finalVariables);
                    const { disposables: disposables } = getState();
                    setState({
                        disposables: disposables.concat([
                            environment.retain(operation)
                        ])
                    });
                    let hasStoreRefetchCompleted = false;
                    const storeRefetch = ()=>{
                        refetch(finalVariables, {
                            fetchPolicy: 'store-only',
                            onComplete: ()=>{
                                /**
               * Relay will dispose the cached operation after a 5m timeout, in which case it will
               * refetch the query from the store and retrigger the onComplete callback. We need to
               * ensure this callback is invoked strictly once to prevent unexpected side effects,
               * e.g. https://jira.atlassian.com/browse/JRACLOUD-84106.
               */ if (hasStoreRefetchCompleted) return;
                                hasStoreRefetchCompleted = true;
                                /**
               * A very difficult to debug race condition emerges when setState is called in the same
               * update cycle as our refetch function. It appears to be related to useSyncExternalStore
               * (used internally by RSS) internal state becoming out of sync which prevents it from
               * correctly notifying listeners (i.e. hooks consumers) when an update is made. Scheduling
               * the update at the end of the event loop is the simplest way of mitigating the bug,
               * but we should revisit this once React concurrent rendering is enabled.
               *
               * Bug this fixes: When clicking "refresh" button multiple times, the shaded loading
               * state on the table will only appear the first time.
               */ queueMicrotask(()=>{
                                    setState({
                                        isFetching: false,
                                        isFetchingView: false,
                                        searchKey: (0, $7Jxgt.v4)()
                                    });
                                    dispatch($a4a2e9f3a0dcbb02$export$9eb6b63e55022ba0());
                                    options.onComplete?.();
                                });
                            }
                        });
                    };
                    if ((0, $c1haS.getIsConcurrentEnabled)()) /**
           * Delaying the store refetch until the next tick in order to avoid a race condition that occurs
           * when react concurrent mode is enabled. In the future (once concurrent mode rollout is
           * complete), we should replace this suspenseless refetch pattern with transitions.
           *
           * Bug this fixes: Features that perform state updates shortly after the refetch (like toggling
           * hierarchy or grouping) can result in a flicker between old results an new results.
           */ setTimeout(storeRefetch, 0);
                    else /**
           * We need to batch these updates as without it, Relay will cause multiple renders and invoke the
           * onComplete callback multiple times. This causes our success/fail analytics events to become
           * unreliable.
           * We introduced a similar fix for fetchQuery (see src/packages/platform/graphql/relay-scheduler/src/index.js)
           * and in React 18 will be able to remove this in favour of the startTransition/useTransition APIs.
           */ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unstable_batchedUpdates(storeRefetch);
                    if (projectContext && viewId !== 'detail') {
                        if ((0, $4R6GH.fg)('jira_list_hierarchy_shadow_requests')) (0, $foucT.fetchIssueNavigatorIssueSearchRefetchQueryShadow)({
                            ...finalVariables,
                            staticViewInput: {
                                ...(0, $4R6GH.fg)('jsc_list_hide_done_items') ? finalVariables.staticViewInput : {},
                                isHierarchyEnabled: true
                            },
                            viewConfigInput: {
                                staticViewInput: {
                                    ...finalVariables.viewConfigInput && (0, $4R6GH.fg)('jsc_list_hide_done_items') ? finalVariables.viewConfigInput.staticViewInput : {},
                                    isHierarchyEnabled: true
                                }
                            },
                            shouldQueryHasChildren: true
                        }, false);
                        else if ((0, $4R6GH.fg)('jira_list_group_shadow_requests')) {
                            const groupByFields = (0, $4R6GH.fg)('jira_list_main_shadow_query_group_overrides') ? [
                                'status',
                                'assignee',
                                'priority',
                                'com.atlassian.jira.plugin.system.customfieldtypes:float',
                                'com.pyxis.greenhopper.jira:jsw-story-points',
                                'com.pyxis.greenhopper.jira:gh-sprint',
                                'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category'
                            ] : [
                                'status',
                                'assignee',
                                'priority'
                            ];
                            (0, $foucT.fetchIssueNavigatorIssueSearchRefetchQueryShadow)({
                                ...finalVariables,
                                staticViewInput: {
                                    ...(0, $4R6GH.fg)('jsc_list_hide_done_items') ? finalVariables.staticViewInput : {},
                                    isHierarchyEnabled: false,
                                    isGroupingEnabled: true
                                },
                                viewConfigInput: {
                                    staticViewInput: {
                                        ...finalVariables.viewConfigInput && (0, $4R6GH.fg)('jsc_list_hide_done_items') ? finalVariables.viewConfigInput.staticViewInput : {},
                                        isHierarchyEnabled: false,
                                        isGroupingEnabled: true
                                    }
                                },
                                // Randomly select a groupBy field to test the shadow request
                                groupBy: groupByFields[Math.floor(Math.random() * groupByFields.length)]
                            }, true);
                        } else if ((0, $4R6GH.fg)('jsc_shadow_requests_for_project_column_config')) {
                            const fsOperationScope = (0, $6UAdF.NIN_PROJECT_SHADOW_REQUEST_OPERATION_SCOPE);
                            const variableOverrides = {
                                fieldSetsScope: {
                                    operationScope: fsOperationScope,
                                    projectKey: projectContext
                                }
                            };
                            (0, $foucT.fetchIssueNavigatorIssueSearchRefetchQueryShadow)({
                                ...finalVariables,
                                ...variableOverrides
                            }, false);
                        }
                    }
                },
                error: (error)=>{
                    setState({
                        isFetching: false,
                        isFetchingView: false,
                        isNetworkError: true
                    });
                    options.onError?.();
                    onRefetchError?.(error, (0, $eJ0Zs.parseIssueNavigatorViewIdOrDefault)(finalVariables.viewId));
                },
                unsubscribe: ()=>{
                    options.onUnsubscribe?.();
                }
            });
            onRefetchStart?.();
            setState({
                inFlightRequest: inFlightRequest,
                isFetching: true,
                isFetchingView: viewId !== finalVariables.viewId,
                isNetworkError: false
            });
        },
    onRefresh: ()=>({ setState: setState, dispatch: dispatch })=>{
            setState({
                isRefreshing: true
            });
            const onFinish = ()=>{
                setState({
                    isRefreshing: false
                });
            };
            dispatch($a4a2e9f3a0dcbb02$export$e324594224ef24da.onRefetch({}, {
                onComplete: onFinish,
                onError: onFinish,
                onUnsubscribe: onFinish
            }));
        },
    onFetchTotalIssueCount: ()=>({ setState: setState }, { environment: environment, cloudId: cloudId, issueSearchInput: issueSearchInput, isHierarchyEnabled: isHierarchyEnabled, isHideDoneEnabled: isHideDoneEnabled, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled })=>{
            setState({
                totalIssueCount: null,
                totalIssueCountIsFetching: true,
                totalIssueCountIsError: false
            });
            const viewConfigInput = isIssueHierarchySupportEnabled || isHideDoneEnabled && (0, $4R6GH.fg)('jsc_list_hide_done_items') ? {
                staticViewInput: {
                    isHierarchyEnabled: isHierarchyEnabled,
                    isHideDoneEnabled: isHideDoneEnabled
                }
            } : null;
            (0, $eiowN.fetchQuery)(environment, (0, $eANr0.default), {
                cloudId: cloudId,
                issueSearchInput: issueSearchInput,
                viewConfigInput: viewConfigInput
            }, {
                fetchPolicy: 'network-only',
                networkCacheConfig: {
                    metadata: {
                        META_SLOW_ENDPOINT: true
                    }
                }
            }).subscribe({
                next: (data)=>{
                    const totalIssueCount = data?.jira?.issueSearchTotalCount ?? null;
                    const totalIssueCountIsError = totalIssueCount === null;
                    setState({
                        totalIssueCount: totalIssueCount,
                        totalIssueCountIsFetching: false,
                        totalIssueCountIsError: totalIssueCountIsError
                    });
                },
                error: ()=>{
                    setState({
                        totalIssueCount: null,
                        totalIssueCountIsFetching: false,
                        totalIssueCountIsError: true
                    });
                }
            });
        }
};

});
parcelRegister("eANr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bed1c47c19db2e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1f49d250c4b8366e370da7204a234835>>
 * @relayHash de122fab1f76e33de979655b8a8c56c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2f9cc42e6580b3f106e3737ff40b96eca4407846844604fe1c42ce16bba8fc5d
const $6bed1c47c19db2e0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "viewConfigInput"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewConfigInput",
                            "variableName": "viewConfigInput"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "issueSearchTotalCount"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "actions_issueSearchTotalCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "actions_issueSearchTotalCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2f9cc42e6580b3f106e3737ff40b96eca4407846844604fe1c42ce16bba8fc5d",
            "metadata": {},
            "name": "actions_issueSearchTotalCountQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$6bed1c47c19db2e0$var$node.hash = "82fd57c594d13d97ce59735d9e84149d";
var $6bed1c47c19db2e0$export$2e2bcd8739ae039 = $6bed1c47c19db2e0$var$node;

});



parcelRegister("cHftd", function(module, exports) {

$parcel$export(module.exports, "useSelectedViewMutation", () => $47846a3b756fc5a2$export$765f658bb8bac50f);

var $gJ56i = parcelRequire("gJ56i");

var $cYjGn = parcelRequire("cYjGn");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $jcw0u = parcelRequire("jcw0u");

var $koeKL = parcelRequire("koeKL");

var $6UAdF = parcelRequire("6UAdF");
const $47846a3b756fc5a2$export$5786a571e562003d = (view)=>view.startsWith('list_') ? 'LIST' : 'DETAIL';
const $47846a3b756fc5a2$export$765f658bb8bac50f = ()=>{
    const userCloudId = (0, $koeKL.useCloudId)();
    const [commitMutation] = (0, $8Uumt.useMutation)((0, $cYjGn.default));
    const [commit] = (0, $8Uumt.useMutation)((0, $gJ56i.default));
    return (0, $5uXOq.useCallback)((view, viewARI)=>{
        if ((0, $4R6GH.fg)('saved_list_view_technical_changes')) commit({
            variables: {
                input: {
                    viewId: viewARI,
                    viewLayout: $47846a3b756fc5a2$export$5786a571e562003d(view)
                }
            },
            onError: (error)=>{
                (0, $jcw0u.default)({
                    sendToPrivacyUnsafeSplunk: true,
                    error: error,
                    meta: {
                        id: 'mainSelectedViewMutation',
                        packageName: (0, $6UAdF.PACKAGE_NAME),
                        teamName: (0, $6UAdF.TEAM_NAME)
                    }
                });
            },
            optimisticResponse: {
                jira_setIssueSearchViewLayout: {
                    success: true,
                    errors: []
                }
            }
        });
        else commitMutation({
            variables: {
                cloudId: userCloudId,
                searchLayout: $47846a3b756fc5a2$export$5786a571e562003d(view)
            },
            onError: (error)=>{
                (0, $jcw0u.default)({
                    sendToPrivacyUnsafeSplunk: true,
                    error: error,
                    meta: {
                        id: 'mainSelectedViewMutation',
                        packageName: (0, $6UAdF.PACKAGE_NAME),
                        teamName: (0, $6UAdF.TEAM_NAME)
                    }
                });
            },
            optimisticResponse: {
                jira: {
                    userPreferences: {
                        setIssueNavigatorSearchLayout: {
                            success: true,
                            errors: [],
                            issueNavigatorSearchLayout: $47846a3b756fc5a2$export$5786a571e562003d(view)
                        }
                    }
                }
            }
        });
    }, [
        commit,
        commitMutation,
        userCloudId
    ]);
};

});
parcelRegister("gJ56i", function(module, exports) {

$parcel$export(module.exports, "default", () => $36b4b3b3d23ee541$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e7189ca0884fb6a2778f8230b6eb5c66>>
 * @relayHash 741cb5df6adfcaa4c4e00bf870fcc0c7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5f332c502a8d6c3f21250ad8d9e08058c42cb19c588d63f4ea5818ad100a18f9
const $36b4b3b3d23ee541$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "JiraSetIssueSearchViewLayoutPayload",
            "kind": "LinkedField",
            "name": "jira_setIssueSearchViewLayout",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSelectedViewMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSelectedViewMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "5f332c502a8d6c3f21250ad8d9e08058c42cb19c588d63f4ea5818ad100a18f9",
            "metadata": {},
            "name": "useSelectedViewMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$36b4b3b3d23ee541$var$node.hash = "65b41e477de41628cbbb17392e93350d";
var $36b4b3b3d23ee541$export$2e2bcd8739ae039 = $36b4b3b3d23ee541$var$node;

});

parcelRegister("cYjGn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f94f392a0e79b4b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5a3bc6510292ce94117d6582f5f11dc6>>
 * @relayHash a9f32b8a40e62d50ea93109e8a20f2cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb739b5da2438ed07259ec682dabb897bf77f788cc0ef58a85897005e02467e5
const $2f94f392a0e79b4b$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "searchLayout"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraUserPreferencesMutation",
                    "kind": "LinkedField",
                    "name": "userPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "searchLayout",
                                    "variableName": "searchLayout"
                                }
                            ],
                            "concreteType": "JiraIssueNavigatorSearchLayoutMutationPayload",
                            "kind": "LinkedField",
                            "name": "setIssueNavigatorSearchLayout",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "issueNavigatorSearchLayout"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSelectedViewMutationOldMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSelectedViewMutationOldMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "fb739b5da2438ed07259ec682dabb897bf77f788cc0ef58a85897005e02467e5",
            "metadata": {},
            "name": "useSelectedViewMutationOldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$2f94f392a0e79b4b$var$node.hash = "fc5879cd5e3ff3110514f54a88b6d958";
var $2f94f392a0e79b4b$export$2e2bcd8739ae039 = $2f94f392a0e79b4b$var$node;

});


parcelRegister("hkDYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc996088b4c53457$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cc996088b4c53457$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchFailedTitle: {
        "id": "issue-navigator.issue-search.search-failed-title",
        "defaultMessage": "We couldn't load your search results"
    },
    searchFailedDescription: {
        "id": "issue-navigator.issue-search.search-failed-description",
        "defaultMessage": "Refresh and try again."
    }
});

});


parcelRegister("en3WN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0c308f64e79b7ea$export$2e2bcd8739ae039);

var $1lc8w = parcelRequire("1lc8w");

var $gYyDI = parcelRequire("gYyDI");

var $9wiT5 = parcelRequire("9wiT5");

var $dTj8L = parcelRequire("dTj8L");

var $gWLDR = parcelRequire("gWLDR");

var $lxams = parcelRequire("lxams");

var $hlPjo = parcelRequire("hlPjo");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $dG0IQ = parcelRequire("dG0IQ");

var $SpDot = parcelRequire("SpDot");

var $cRyQg = parcelRequire("cRyQg");

var $fraBZ = parcelRequire("fraBZ");

var $5eRaS = parcelRequire("5eRaS");

var $fvbIR = parcelRequire("fvbIR");

var $4mO32 = parcelRequire("4mO32");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $koVbs = parcelRequire("koVbs");

var $9Nvh7 = parcelRequire("9Nvh7");

var $5Czte = parcelRequire("5Czte");

var $ffdpA = parcelRequire("ffdpA");

var $48rMm = parcelRequire("48rMm");

var $f7PHy = parcelRequire("f7PHy");

var $1XJ20 = parcelRequire("1XJ20");

var $5oFIy = parcelRequire("5oFIy");

var $5d1oN = parcelRequire("5d1oN");

var $6UAdF = parcelRequire("6UAdF");

var $bbbXL = parcelRequire("bbbXL");

var $a8lIB = parcelRequire("a8lIB");

var $kMfdg = parcelRequire("kMfdg");

var $7OTah = parcelRequire("7OTah");

var $ih9zY = parcelRequire("ih9zY");

var $gwtSG = parcelRequire("gwtSG");

var $cKK2E = parcelRequire("cKK2E");

var $38r5c = parcelRequire("38r5c");

var $gM6H8 = parcelRequire("gM6H8");

var $jfQeI = parcelRequire("jfQeI");

var $7jipW = parcelRequire("7jipW");

var $jKHs3 = parcelRequire("jKHs3");

var $hWyif = parcelRequire("hWyif");

var $aTDVl = parcelRequire("aTDVl");

var $gOpmP = parcelRequire("gOpmP");

var $7Cqtr = parcelRequire("7Cqtr");

var $5RTlC = parcelRequire("5RTlC");

var $6tXCF = parcelRequire("6tXCF");

var $dqObP = parcelRequire("dqObP");

var $cWY4u = parcelRequire("cWY4u");

var $887Eo = parcelRequire("887Eo");
const $a0c308f64e79b7ea$var$SidebarLayout = ({ children: children, project: project })=>{
    const projectData = (0, $8Uumt.useFragment)((0, $hlPjo.default), project);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5d1oN.SidebarLayout), {
        defaultRatio: 0.3,
        minWidth: 360,
        maxRatio: 0.75,
        teamName: "empanada",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $887Eo.SidebarExperienceRegistryWithErrorBoundary), {
            project: projectData ?? null
        })
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cWY4u.SidebarCloserController), null));
};
const $a0c308f64e79b7ea$var$staticEntrypointParams = {
    cloudId: undefined,
    projectKey: undefined
};
const $a0c308f64e79b7ea$var$staticUseEntryPointFGOff = {
    entryPointActions: {
        load: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    },
    entryPointReferenceSubject: undefined
};
const $a0c308f64e79b7ea$var$IssueFieldStatisticsEntrypointProvider = (props)=>{
    if ((0, $6s1PB.expVal)('helios_list_view_statistics_nin_migration', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $SpDot.IssueFieldStatisticsEntrypointProvider), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
};
const $a0c308f64e79b7ea$var$ConditionalIssueTableSelectedIssuesContainer = ({ children: children, onIssueSelected: onIssueSelected })=>{
    if (!(0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false)) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $48rMm.IssueTableSelectedIssuesContainer), {
        onIssueSelected: onIssueSelected
    }, children);
};
const $a0c308f64e79b7ea$export$397fa57fff06920f = ({ CustomHeader: CustomHeader, ActionMenu: ActionMenu, HeaderSkeletonImage: HeaderSkeletonImage, filter: filter, onPageDataLoad: onPageDataLoad, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onChangeIssue: onChangeIssue, onChangeFilter: onChangeFilter, defaultJql: defaultJql, onRefinement: onRefinement, onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld, onIssueFlatListUpdated: onIssueFlatListUpdated, issueResults: issueResults, groupResults: groupResults, project: project, userPreferences: userPreferences, jqlBuilderProps: jqlBuilderProps, jqlBuilderWithAiKey: jqlBuilderWithAiKey, issueTableProps: issueTableProps, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled, jiraView: jiraView, initialQueryAsJql: initialQueryAsJql, isInitialized: isInitialized })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_NAVIGATOR_UI_START);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_NAVIGATOR_UI_END);
    }, []);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [caughtIssueSearchError, setCaughtIssueSearchError] = (0, $5uXOq.useState)();
    const { filterId: filterId } = (0, $gwtSG.useActiveJql)();
    const resolvedJql = (0, $gwtSG.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $cKK2E.useFilterQuery)();
    const handleReset = (0, $5uXOq.useCallback)((isResetToFilter = false)=>{
        if (isResetToFilter) onChangeFilter && onChangeFilter();
        else onChangeJql && onChangeJql(defaultJql, true);
    }, [
        onChangeFilter,
        onChangeJql,
        defaultJql
    ]);
    const onChange = (0, $5uXOq.useCallback)((jql)=>{
        onRefinement && onRefinement();
        onChangeJql && onChangeJql(jql, !filterQueryIsFetching && filter === null && (0, $9Nvh7.isFilterId)(filterId));
    }, [
        filter,
        filterId,
        filterQueryIsFetching,
        onChangeJql,
        onRefinement
    ]);
    const searchKey = (0, $38r5c.useSearchKey)();
    const previousData = (0, $1XJ20.usePrevious)(searchKey);
    const hasSearchChanged = Boolean(searchKey && searchKey !== previousData);
    const [{ view: selectedView }] = (0, $ih9zY.useSelectedViewState)();
    const issueResultsData = (0, $8Uumt.useFragment)((0, $lxams.default), issueResults);
    const groupResultsData = (0, $8Uumt.useFragment)((0, $gWLDR.default), groupResults);
    const jiraViewData = (0, $8Uumt.useFragment)((0, $dTj8L.default), jiraView);
    const viewResultError = (0, $5uXOq.useMemo)(()=>{
        if (!jiraViewData) return undefined;
        const message = jiraViewData.error?.message ?? '';
        const statusCode = jiraViewData.error?.extensions?.[0].statusCode;
        if (typeof statusCode !== 'number') return;
        return new (0, $jJZqs.default)(statusCode, message);
    }, [
        jiraViewData
    ]);
    const userPreferencesData = (0, $8Uumt.useFragment)((0, $9wiT5.default), userPreferences);
    const jqlBuilderWithAiData = (0, $8Uumt.useFragment)((0, $gYyDI.default), jqlBuilderWithAiKey);
    const projectData = (0, $8Uumt.useFragment)((0, $1lc8w.default), project);
    const isGrouping = (0, $5uXOq.useMemo)(()=>issueTableProps?.isGroupingSupported && jiraViewData?.viewSettings?.isGroupingEnabled && jiraViewData?.viewSettings?.canEnableGrouping, [
        issueTableProps?.isGroupingSupported,
        jiraViewData?.viewSettings?.canEnableGrouping,
        jiraViewData?.viewSettings?.isGroupingEnabled
    ]);
    const shouldAnnounceInfo = (0, $5uXOq.useMemo)(()=>hasSearchChanged && (isGrouping ? groupResultsData !== null : issueResultsData !== null && typeof issueResultsData?.totalIssueSearchResultCount === 'number'), [
        hasSearchChanged,
        isGrouping,
        groupResultsData,
        issueResultsData
    ]);
    const [isAiEnabled, setIsAiEnabled] = (0, $5uXOq.useState)(false);
    const onToggleAi = (0, $5uXOq.useCallback)((isEnabled)=>{
        setIsAiEnabled(isEnabled);
    }, []);
    const hasServerError = issueResultsData?.issueSearchError?.__typename === 'JiraServerError' || (groupResultsData?.errors ?? []).some(({ extensions: extensions })=>!extensions?.some(({ statusCode: statusCode })=>typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500));
    const hasViewNotFoundError = !!viewResultError && viewResultError.statusCode === 404;
    const noFilterReason = (0, $5uXOq.useMemo)(()=>{
        if (!filterQueryIsFetching && filter === null && (0, $9Nvh7.isFilterId)(filterId)) return 'Filter query mismatch';
        if (hasViewNotFoundError) return 'Filter not found in view result';
        return undefined;
    }, [
        filter,
        filterId,
        filterQueryIsFetching,
        hasViewNotFoundError
    ]);
    const IssueNavigatorTopBar = (0, $5uXOq.useMemo)(()=>{
        const jqlBuilder = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gOpmP.default), {
            onChangeJql: onChange,
            defaultJql: defaultJql,
            filter: filter,
            onReset: handleReset,
            onFilterSave: onChangeFilter,
            groupResults: groupResultsData ?? null,
            issueResults: issueResultsData ?? null,
            onToggleAi: onToggleAi,
            jqlBuilderWithAiKey: jqlBuilderWithAiData ?? null,
            jqlBuilderProps: jqlBuilderProps,
            initialQueryAsJql: initialQueryAsJql
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, ActionMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqObP.default), {
            ActionMenu: ActionMenu,
            isGroupingSupported: issueTableProps?.isGroupingSupported,
            filter: filter,
            issueResults: issueResultsData ?? null,
            HeaderSkeletonImage: HeaderSkeletonImage,
            jqlBuilder: jqlBuilder,
            jiraViewResult: jiraViewData ?? null,
            onChangeFilter: onChangeFilter,
            project: projectData ?? null
        }), CustomHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWyif.default), {
            CustomHeader: CustomHeader,
            filter: filter,
            issueResults: issueResultsData ?? null,
            HeaderSkeletonImage: HeaderSkeletonImage,
            jiraViewResult: jiraViewData ?? null,
            isGroupingSupported: issueTableProps?.isGroupingSupported,
            onChangeFilter: onChangeFilter,
            project: projectData ?? null
        }), jqlBuilder));
    }, [
        onChange,
        defaultJql,
        filter,
        handleReset,
        onChangeFilter,
        groupResultsData,
        issueResultsData,
        onToggleAi,
        jqlBuilderWithAiData,
        jqlBuilderProps,
        initialQueryAsJql,
        ActionMenu,
        issueTableProps?.isGroupingSupported,
        HeaderSkeletonImage,
        jiraViewData,
        projectData,
        CustomHeader
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $4mO32.useEntryPoint)((0, $fvbIR.asyncBulkOpsCoreEntryPoint), $a0c308f64e79b7ea$var$staticEntrypointParams) : $a0c308f64e79b7ea$var$staticUseEntryPointFGOff;
    let setFlatListIssueIds = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') && (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false)) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ setFlatListIssueIds: setFlatListIssueIds } = (0, $gM6H8.useFlatListIssuesActions)());
    const handleIssueFlatListUpdated = (0, $5uXOq.useCallback)((newFlatKeyList, newFlatIdList)=>{
        setFlatListIssueIds(newFlatIdList);
        if (onIssueFlatListUpdated) onIssueFlatListUpdated(newFlatKeyList, newFlatIdList);
    }, [
        setFlatListIssueIds,
        onIssueFlatListUpdated
    ]);
    let IssueNavigatorContent = (0, $5uXOq.useMemo)(()=>{
        const getAnnouncerMessage = ()=>{
            if (isGrouping) return formatMessage((0, $7Cqtr.default).screenReaderGroupResultInfo);
            let message;
            if (issueResultsData?.isCappingIssueSearchResult) message = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7Cqtr.default).screenReaderSearchResultMoreInfoIssueTermRefresh : (0, $7Cqtr.default).screenReaderSearchResultMoreInfo;
            else message = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7Cqtr.default).screenReaderSearchResultInfoIssueTermRefresh : (0, $7Cqtr.default).screenReaderSearchResultInfo;
            return formatMessage(message, {
                total: issueResultsData?.totalIssueSearchResultCount
            });
        };
        const HierarchyOnboardingProviderComponent = (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? (0, $f7PHy.HierarchyOnboardingProvider) : (0, $5uXOq.Fragment);
        const HideDoneOnboardingProviderComponent = (0, $4R6GH.fg)('jsc_list_hide_done_items') ? (0, $dG0IQ.HideDoneOnboardingProvider) : (0, $5uXOq.Fragment);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0c308f64e79b7ea$var$ConditionalIssueTableSelectedIssuesContainer, {
            onIssueSelected: entryPointActions.load
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0c308f64e79b7ea$var$IssueFieldStatisticsEntrypointProvider, {
            jql: resolvedJql,
            view: selectedView
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cRyQg.MaybeConditionalFormattingEntryPointProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0c308f64e79b7ea$var$SidebarLayout, {
            project: projectData ?? null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7jipW.BulkOperationsWrapper // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        ), {
            // @ts-ignore - error TS2322: - type mismatch
            bulkOpsCoreEntryPointReference: entryPointReferenceSubject,
            fragmentRef: issueResultsData ?? null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HierarchyOnboardingProviderComponent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jfQeI.InlineFieldConfigProviderComponent), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a0c308f64e79b7ea$var$IssueNavigatorContentContainer, {
            selectedView: selectedView,
            "data-vc": `issue-navigator-content${false ? '-ssr' : ''}`,
            ...false && {
                'data-ssr-placeholder': 'issue-navigator-content-placeholder'
            },
            ...!false && {
                'data-ssr-placeholder-replace': 'issue-navigator-content-placeholder'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HideDoneOnboardingProviderComponent, null, IssueNavigatorTopBar), (0, $6s1PB.expVal)('gravityai-1783_jql_debugger', 'jql_debugger_enabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ffdpA.JQLDebuggerRenderSlot), null) : null, !filterQueryIsFetching && filter === null && (0, $9Nvh7.isFilterId)(filterId) || hasViewNotFoundError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bbbXL.NoFilter), {
            reason: noFilterReason
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
            message: getAnnouncerMessage(),
            shouldAnnounce: shouldAnnounceInfo,
            testId: "issue-navigator.ui.search-announcer"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTDVl.default), {
            hasServerError: hasServerError,
            onChangeColumnConfiguration: onChangeColumnConfiguration,
            onChangeJql: onChangeJql,
            onCaughtIssueSearchError: setCaughtIssueSearchError,
            issueResults: issueResultsData ?? null,
            jiraView: jiraViewData ?? null,
            project: projectData ?? null,
            rankField: jqlBuilderWithAiData ?? null,
            groupResults: groupResultsData ?? null,
            issueTableProps: issueTableProps,
            isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
            isIssueRankingSupportEnabled: isIssueRankingSupportEnabled,
            isMergedColumnSupportEnabled: isMergedColumnSupportEnabled,
            onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld,
            onIssueFlatListUpdated: handleIssueFlatListUpdated,
            filter: filter
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6tXCF.default), {
            hasIssueResults: !!issueResultsData?.totalIssueSearchResultCount,
            userPreferences: userPreferencesData ?? null,
            isAiEnabled: isAiEnabled
        })))))))));
    }, [
        entryPointActions.load,
        resolvedJql,
        selectedView,
        entryPointReferenceSubject,
        issueResultsData,
        IssueNavigatorTopBar,
        filterQueryIsFetching,
        filter,
        filterId,
        hasViewNotFoundError,
        noFilterReason,
        shouldAnnounceInfo,
        hasServerError,
        onChangeColumnConfiguration,
        onChangeJql,
        jiraViewData,
        projectData,
        jqlBuilderWithAiData,
        groupResultsData,
        issueTableProps,
        isIssueHierarchySupportEnabled,
        isIssueRankingSupportEnabled,
        isMergedColumnSupportEnabled,
        onIssueFlatListUpdatedOld,
        handleIssueFlatListUpdated,
        userPreferencesData,
        isAiEnabled,
        isGrouping,
        formatMessage
    ]);
    const isFullPageIssueAppMode = (0, $7OTah.useIsFullPageIssueAppMode)();
    if (isFullPageIssueAppMode) {
        const view = jiraViewData && (0, $6UAdF.isJiraIssueSearchViewMetadata)(jiraViewData) ? jiraViewData : null;
        IssueNavigatorContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKHs3.default), {
            onChangeIssue: onChangeIssue,
            issueResults: issueResultsData ?? null,
            view: view,
            ...(0, $4R6GH.fg)('add-attribute-required-for-colorful-labels-expe') ? {
                projectType: projectData?.projectType
            } : {}
        });
    }
    (0, $5Czte.useGlobalScopeOptInFlag)();
    const hasSearchError = hasServerError || !!caughtIssueSearchError;
    const hasSearchResults = !!issueResultsData || !!groupResultsData;
    const isFailedIssueSearch = !hasSearchResults || hasSearchError || !jiraViewData || !!viewResultError && viewResultError.statusCode !== 404;
    const isBifrost = (0, $4R6GH.fg)('split_showpinissuelist_by_bifrost_ssr') ? !!(0, $5eRaS.ssr).getFeatureFlags()?.ssrViaBifrost : undefined;
    return (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, IssueNavigatorContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5RTlC.default), null), isInitialized && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), isFailedIssueSearch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kMfdg.IssueSearchFail), {
            location: `${(0, $6UAdF.PACKAGE_NAME)}.ui`,
            error: caughtIssueSearchError || viewResultError || new Error('There was an error searching for issues'),
            onPageDataLoad: onPageDataLoad,
            attributes: {
                isAiEnabled: isAiEnabled,
                ...isGrouping ? {
                    experienceId: (0, $6UAdF.GROUPED_LIST_EXPERIENCE_ID)
                } : {},
                ...(0, $4R6GH.fg)('split_showpinissuelist_by_bifrost_ssr') ? {
                    isBifrost: isBifrost
                } : {}
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kMfdg.IssueSearchSuccess), {
            onPageDataLoad: onPageDataLoad,
            attributes: {
                isAiEnabled: isAiEnabled,
                ...isGrouping ? {
                    experienceId: (0, $6UAdF.GROUPED_LIST_EXPERIENCE_ID)
                } : {},
                ...(0, $4R6GH.fg)('split_showpinissuelist_by_bifrost_ssr') ? {
                    isBifrost: isBifrost
                } : {}
            }
        })), [
        IssueNavigatorContent,
        isFailedIssueSearch,
        caughtIssueSearchError,
        viewResultError,
        onPageDataLoad,
        isAiEnabled,
        isGrouping,
        isBifrost,
        isInitialized
    ]);
};
// re-render regression detection
$a0c308f64e79b7ea$export$397fa57fff06920f.whyDidYouRender = true;
var $a0c308f64e79b7ea$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($a0c308f64e79b7ea$export$397fa57fff06920f);
const $a0c308f64e79b7ea$var$IssueNavigatorContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedView: selectedView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4t3i1osq _19pkidpf _2hwxxy5q _otyridpf _18u0xy5q",
            __cmplp.selectedView !== 'detail' && "_n3tdv47k _vchhusvi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1lc8w", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d058da013b06c2d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fd7798b4a1cafcce430bba89f1e4054e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7d058da013b06c2d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_project"
        },
        {
            "kind": "FragmentSpread",
            "name": "topBar_issueNavigator_project"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Header_project"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_SidebarLayout_project"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$7d058da013b06c2d$var$node.hash = "87d8aa4e5a499e57a60ece1c4bbab9b7";
var $7d058da013b06c2d$export$2e2bcd8739ae039 = $7d058da013b06c2d$var$node;

});

parcelRegister("gYyDI", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaeb5527acfb0176$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3785c8aa73a3094fbd32da405a0fb86d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $aaeb5527acfb0176$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_jqlBuilderWithAiKey",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_rankField"
        }
    ],
    "type": "JiraQuery"
};
$aaeb5527acfb0176$var$node.hash = "fc51caf86d12b11398947bb77ddb49ca";
var $aaeb5527acfb0176$export$2e2bcd8739ae039 = $aaeb5527acfb0176$var$node;

});

parcelRegister("9wiT5", function(module, exports) {

$parcel$export(module.exports, "default", () => $98d194ce17a15e42$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1da52f0913815b9fe1e6847953ff7bea>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $98d194ce17a15e42$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_userPreferences",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "spotlight_issueNavigator_IssueNavigatorSpotlight"
        }
    ],
    "type": "JiraUserPreferences"
};
$98d194ce17a15e42$var$node.hash = "aa84b2b1589fd8e695aa782c018fd60c";
var $98d194ce17a15e42$export$2e2bcd8739ae039 = $98d194ce17a15e42$var$node;

});

parcelRegister("dTj8L", function(module, exports) {

$parcel$export(module.exports, "default", () => $196e83c66a3d5847$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ee084f452ff2b0b656c712f239d84c39>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $196e83c66a3d5847$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_jiraView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "error",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Header_jiraViewResult"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_jiraView"
        },
        {
            "kind": "FragmentSpread",
            "name": "topBar_issueNavigator_jiraViewResult"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_FullPageIssueApp_view"
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isGroupingEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEnableGrouping"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$196e83c66a3d5847$var$node.hash = "516c1a5874a4fcc568615f6d3afee330";
var $196e83c66a3d5847$export$2e2bcd8739ae039 = $196e83c66a3d5847$var$node;

});

parcelRegister("gWLDR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe56e9af641ec4ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bccaea827099599c35efdd1a65270e81>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $fe56e9af641ec4ca$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_groupResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_groupResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults"
        },
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$fe56e9af641ec4ca$var$node.hash = "5d6a696ce62196724f5906b5a505895e";
var $fe56e9af641ec4ca$export$2e2bcd8739ae039 = $fe56e9af641ec4ca$var$node;

});

parcelRegister("lxams", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d22552440100cae$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<58f0caa04f54df88b02dd1066d15c43f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $6d22552440100cae$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueNavigatorUI_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "topBar_issueNavigator_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Header_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueResults_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_FullPageIssueApp_issueResults"
        },
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "bulkOperationsWrapper_issueNavigator_LoadBulkOpsCore"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$6d22552440100cae$var$node.hash = "ac60e0f31f3a7da92f2e220df7713938";
var $6d22552440100cae$export$2e2bcd8739ae039 = $6d22552440100cae$var$node;

});

parcelRegister("hlPjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $65333ac178e78fa7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63b8d7e9436af36fcb82590d1e8e9bf4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $65333ac178e78fa7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_SidebarLayout_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project"
        }
    ],
    "type": "JiraProject"
};
$65333ac178e78fa7$var$node.hash = "81031ed0c3f17c27b9c7422bd922c6e2";
var $65333ac178e78fa7$export$2e2bcd8739ae039 = $65333ac178e78fa7$var$node;

});

parcelRegister("dG0IQ", function(module, exports) {

$parcel$export(module.exports, "HideDoneOnboardingProvider", () => $afb4196e3ab0f9dd$export$a84c251717c39a3e);
$parcel$export(module.exports, "useHideDoneOnboarding", () => $afb4196e3ab0f9dd$export$df78f68a5cea98eb);
$parcel$export(module.exports, "HideDoneOnboarding", () => $afb4196e3ab0f9dd$export$48041c15f880aebf);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $kbqIt = parcelRequire("kbqIt");

var $2NMNM = parcelRequire("2NMNM");

var $ioD1B = parcelRequire("ioD1B");

var $8zOmE = parcelRequire("8zOmE");

var $eGLgs = parcelRequire("eGLgs");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");


var $hNjGG = parcelRequire("hNjGG");
const $afb4196e3ab0f9dd$export$a611c8ca1952c1b5 = 'jira-nin-hide-done-onboarding-stg';
const $afb4196e3ab0f9dd$export$3d8a20f97116832b = 'jira-nin-hide-done-onboarding';
const $afb4196e3ab0f9dd$var$ENV_STAGING = 'staging';
const $afb4196e3ab0f9dd$var$STARGATE_URL = '/gateway/api';
const $afb4196e3ab0f9dd$var$HideDoneOnboardingContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $afb4196e3ab0f9dd$export$a84c251717c39a3e = ({ children: children })=>{
    const [showHideDoneOnboarding, setShowHideDoneOnboarding] = (0, $5uXOq.useState)(false);
    const value = (0, $5uXOq.useMemo)(()=>({
            showHideDoneOnboarding: showHideDoneOnboarding,
            setShowHideDoneOnboarding: setShowHideDoneOnboarding
        }), [
        showHideDoneOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($afb4196e3ab0f9dd$var$HideDoneOnboardingContext.Provider, {
        value: value
    }, children);
};
const $afb4196e3ab0f9dd$export$51d637936c6abe6f = ()=>{
    const hierarchyContext = (0, $5uXOq.useContext)($afb4196e3ab0f9dd$var$HideDoneOnboardingContext);
    if (!hierarchyContext) {
        (0, $jcw0u.default)({
            meta: {
                id: 'issueTableHideDoneOnboarding',
                packageName: (0, $60ea362de9a3f71f$export$b8b9d90f9e5bd72b),
                teamName: (0, $60ea362de9a3f71f$export$d57b6b390e78d90f)
            },
            error: new Error('useHideDoneOnboardingContext must be used within a HideDoneOnboardingProvider'),
            sendToPrivacyUnsafeSplunk: true
        });
        return {
            showHideDoneOnboarding: false,
            setShowHideDoneOnboarding: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    return hierarchyContext;
};
const $afb4196e3ab0f9dd$export$df78f68a5cea98eb = ({ isHideDoneSupportEnabled: isHideDoneSupportEnabled })=>{
    const { showHideDoneOnboarding: showHideDoneOnboarding, setShowHideDoneOnboarding: setShowHideDoneOnboarding } = $afb4196e3ab0f9dd$export$51d637936c6abe6f();
    const ONBOARDING_ENGAGEMENT_ID = (0, $2tT7R.useEnvironment)() === $afb4196e3ab0f9dd$var$ENV_STAGING ? $afb4196e3ab0f9dd$export$a611c8ca1952c1b5 : $afb4196e3ab0f9dd$export$3d8a20f97116832b;
    const cloudId = (0, $koeKL.useCloudId)();
    /*
   * Onboarding Experience is loaded manually on page load via EP's CoordinationClient class
   * Once loaded, if the message is active for this particular context, only then the HideDone_ONBOARDING will be loaded and displayed
   */ const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, $afb4196e3ab0f9dd$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isEnrolled, stopEnrolment] = (0, $kbqIt.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    (0, $5uXOq.useEffect)(()=>{
        if (isEnrolled && isHideDoneSupportEnabled) {
            stopEnrolment(false);
            setShowHideDoneOnboarding(true);
        }
    }, [
        isEnrolled,
        isHideDoneSupportEnabled,
        setShowHideDoneOnboarding,
        stopEnrolment
    ]);
    return {
        showHideDoneOnboarding: showHideDoneOnboarding,
        setShowHideDoneOnboarding: setShowHideDoneOnboarding
    };
};
const $afb4196e3ab0f9dd$export$48041c15f880aebf = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    const { showHideDoneOnboarding: showHideDoneOnboarding, setShowHideDoneOnboarding: setShowHideDoneOnboarding } = $afb4196e3ab0f9dd$export$51d637936c6abe6f();
    const onCloseSpotlight = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'hideDoneOnboardingButton');
        setIsSpotlightActive(false);
        setShowHideDoneOnboarding(false);
    }, [
        createAnalyticsEvent,
        setShowHideDoneOnboarding
    ]);
    if (!showHideDoneOnboarding || !isSpotlightActive) return;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        messageId: "issue-table-hide-done-toggle.ui.onboarding.jira-spotlight.nin-hide-done-toggle-spotlight",
        messageType: "engagement",
        dialogPlacement: "left top",
        actions: [
            {
                onClick: onCloseSpotlight,
                text: formatMessage((0, $hNjGG.default).ok)
            }
        ],
        dialogWidth: 270,
        heading: formatMessage((0, $hNjGG.default).onboardingHeading),
        target: "nin-hide-done-toggle-spotlight",
        key: "nin-hide-done-toggle-spotlight",
        targetRadius: 3,
        targetBgColor: "var(--ds-surface, #FFFFFF)"
    }, formatMessage((0, $hNjGG.default).onboardingDescription)));
};

});
const $60ea362de9a3f71f$export$b8b9d90f9e5bd72b = 'jiraIssueTableHideDoneToggle';
const $60ea362de9a3f71f$export$d57b6b390e78d90f = 'keystone';
const $60ea362de9a3f71f$export$6a7d6ab86cfdfcdc = 'hideDoneToggle';
const $60ea362de9a3f71f$export$f7109619a5e9e0d6 = 'jira-native-issue-table';

parcelRegister("hNjGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f1d92c562e73bfa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f1d92c562e73bfa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    onboardingHeading: {
        "id": "jira-issue-table-hide-done-toggle.onboarding.onboarding-heading",
        "defaultMessage": "Hide done work items"
    },
    onboardingDescription: {
        "id": "jira-issue-table-hide-done-toggle.onboarding.onboarding-description",
        "defaultMessage": "Quickly hide work that's done without adding a filter."
    },
    ok: {
        "id": "jira-issue-table-hide-done-toggle.onboarding.done",
        "defaultMessage": "OK"
    }
});

});


parcelRegister("SpDot", function(module, exports) {

$parcel$export(module.exports, "IssueFieldStatisticsEntrypointProvider", () => $0f9a73f89502d9ff$export$2043a5b19c8c0e7f);
$parcel$export(module.exports, "useIssueFieldStatisticsEntryPoint", () => $0f9a73f89502d9ff$export$8e48443ccac1a85f);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $koeKL = parcelRequire("koeKL");

var $l37qh = parcelRequire("l37qh");

var $6gWfU = parcelRequire("6gWfU");

var $h8Scx = parcelRequire("h8Scx");
const $0f9a73f89502d9ff$var$IssueFieldStatisticsEntrypointContext = (0, $l37qh.createUseEntryPointContext)();
const $0f9a73f89502d9ff$export$2043a5b19c8c0e7f = ({ children: children, jql: jql, view: view })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            jql: jql,
            view: view,
            namespace: (0, $6gWfU.ISSUE_SEARCH_NAMESPACE)
        }), [
        cloudId,
        jql,
        view
    ]);
    const createObjectEntryPoint = (0, $4mO32.useEntryPoint)((0, $h8Scx.issueFieldStatisticsStatisticsSidebarEntryPoint), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f9a73f89502d9ff$var$IssueFieldStatisticsEntrypointContext.Provider, {
        value: createObjectEntryPoint
    }, children);
};
const $0f9a73f89502d9ff$export$8e48443ccac1a85f = ()=>(0, $5uXOq.useContext)($0f9a73f89502d9ff$var$IssueFieldStatisticsEntrypointContext);

});
parcelRegister("l37qh", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $6e7e19c2d291c94c$export$41bce2223126846b);

var $5uXOq = parcelRequire("5uXOq");
const $6e7e19c2d291c94c$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $5uXOq.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});

parcelRegister("6gWfU", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_EXPERIENCE_NAME", () => $73aec7ab50e32fac$export$716d68d214fad041);
$parcel$export(module.exports, "ISSUE_SEARCH_NAMESPACE", () => $73aec7ab50e32fac$export$de2495608df10495);

var $e4eHl = parcelRequire("e4eHl");
const $73aec7ab50e32fac$export$716d68d214fad041 = 'issue-field-statistics';
const $73aec7ab50e32fac$export$6d9ce65a72493aac = 'statistics';
const $73aec7ab50e32fac$export$de2495608df10495 = 'ISSUE_NAVIGATOR';
const $73aec7ab50e32fac$var$AUTO_OPEN_SIDEBAR_KEY = 'sidebar';
const $73aec7ab50e32fac$export$b229a6bf782d77e7 = 'statistics-field';
const $73aec7ab50e32fac$export$c4ec2849fcb32515 = 'statistics-chart';
const $73aec7ab50e32fac$export$70a91e824238865d = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))($73aec7ab50e32fac$export$b229a6bf782d77e7);
const $73aec7ab50e32fac$export$60179bff81db3578 = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))($73aec7ab50e32fac$export$c4ec2849fcb32515);
const $73aec7ab50e32fac$export$1816113812ed602d = Object.freeze({
    [$73aec7ab50e32fac$var$AUTO_OPEN_SIDEBAR_KEY]: undefined,
    [$73aec7ab50e32fac$export$70a91e824238865d]: undefined,
    [$73aec7ab50e32fac$export$60179bff81db3578]: undefined
});

});

parcelRegister("h8Scx", function(module, exports) {

$parcel$export(module.exports, "issueFieldStatisticsStatisticsSidebarEntryPoint", () => $f4920e5a5ac1e1fb$export$89d0b9a4111dd3ef);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $9MMMd = parcelRequire("9MMMd");

const $f4920e5a5ac1e1fb$export$89d0b9a4111dd3ef = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("hr9rJ")), {
        moduleId: "4940af1a",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId, jql: jql, view: view, namespace: namespace })=>({
            queries: {
                issueFieldStatistics: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $9MMMd.default,
                    variables: {
                        cloudId: cloudId,
                        jql: jql,
                        view: view,
                        namespace: namespace
                    }
                }
            }
        })
});

});
parcelRegister("9MMMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $59215f0e9ec7314d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2a8004fa45eb0b812b77be54fd002799>>
 * @relayHash f30148119addea651a9b8860c7c557f6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7b33dff432f340c6c68b9ae784353feca7ff3fcc20bd2bcdf7edabe537ad1a7b
const $59215f0e9ec7314d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7b33dff432f340c6c68b9ae784353feca7ff3fcc20bd2bcdf7edabe537ad1a7b",
        "metadata": {},
        "name": "ui_StatisticsSidebarQuery",
        "operationKind": "query",
        "text": null
    }
};
var $59215f0e9ec7314d$export$2e2bcd8739ae039 = $59215f0e9ec7314d$var$node;

});

parcelRegister("hr9rJ", function(module, exports) {

let $cb1c492200d0a680$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cb1c492200d0a680$var$load("4eCRP").then(()=>parcelRequire('lyMZX'));

});



parcelRegister("cRyQg", function(module, exports) {

$parcel$export(module.exports, "MaybeConditionalFormattingEntryPointProvider", () => $d471a7a94f9ffc46$export$249a676416be0fe1);
$parcel$export(module.exports, "useConditionalFormattingEntryPoint", () => $d471a7a94f9ffc46$export$4dc7c6c366f5d2ba);

var $5uXOq = parcelRequire("5uXOq");

var $7XYc4 = parcelRequire("7XYc4");

var $4mO32 = parcelRequire("4mO32");

var $l37qh = parcelRequire("l37qh");

var $4R6GH = parcelRequire("4R6GH");

var $ha1lt = parcelRequire("ha1lt");
const $d471a7a94f9ffc46$var$ConditionalFormattingEntryPointContext = (0, $l37qh.createUseEntryPointContext)();
const $d471a7a94f9ffc46$export$ea15b2e6192c5d4b = ({ children: children })=>{
    const entryPointProps = {
        message: 'Hello world!'
    };
    const createObjectEntryPoint = (0, $4mO32.useEntryPoint)((0, $ha1lt.conditionalFormattingSidebarEntryPoint), entryPointProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d471a7a94f9ffc46$var$ConditionalFormattingEntryPointContext.Provider, {
        value: createObjectEntryPoint
    }, children);
};
const $d471a7a94f9ffc46$export$249a676416be0fe1 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('conditional-formatting-new-list-targeting-gate'), $d471a7a94f9ffc46$export$ea15b2e6192c5d4b, ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
const $d471a7a94f9ffc46$export$4dc7c6c366f5d2ba = ()=>(0, $5uXOq.useContext)($d471a7a94f9ffc46$var$ConditionalFormattingEntryPointContext);

});
parcelRegister("ha1lt", function(module, exports) {

$parcel$export(module.exports, "conditionalFormattingSidebarEntryPoint", () => $670c981801696451$export$99130db9e4ffd320);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $670c981801696451$export$99130db9e4ffd320 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("gr6ed")), {
        moduleId: "f9996dd0",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("gr6ed", function(module, exports) {

let $bf73ffc39b1b0ff1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bf73ffc39b1b0ff1$var$load("fbAMm").then(()=>parcelRequire('eyKC3'));

});



parcelRegister("fvbIR", function(module, exports) {

$parcel$export(module.exports, "asyncBulkOpsCoreEntryPoint", () => $187b82d9aad4ec6a$export$d90d57132636bb1);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $187b82d9aad4ec6a$export$d90d57132636bb1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("cliXS")), {
        moduleId: "f81933b6",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("cliXS", function(module, exports) {

let $8fc628381702f5c0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $8fc628381702f5c0$var$load("3bwa5").then(()=>parcelRequire('k9wdm'));

});


parcelRegister("5Czte", function(module, exports) {

$parcel$export(module.exports, "NinChangeboardingContext", () => $56f2750f0b6ae1db$export$b349f970aff316d8);
$parcel$export(module.exports, "EnableNinChangeboardingProvider", () => $56f2750f0b6ae1db$export$dd1deacfc61c978a);
$parcel$export(module.exports, "NinChangeboardingTourTarget", () => $56f2750f0b6ae1db$export$eb95770b90ecc1f3);
$parcel$export(module.exports, "NinChangeboardingTourCard", () => $56f2750f0b6ae1db$export$7c27d65549066b5);
$parcel$export(module.exports, "useGlobalScopeOptInFlag", () => $56f2750f0b6ae1db$export$9e9f507adee88e58);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $5Zxxp = parcelRequire("5Zxxp");

var $eNf8a = parcelRequire("eNf8a");

var $4R6GH = parcelRequire("4R6GH");

var $1oOi0 = parcelRequire("1oOi0");

var $fB2N8 = parcelRequire("fB2N8");

var $6s4Eg = parcelRequire("6s4Eg");

var $eiUE8 = parcelRequire("eiUE8");
const $56f2750f0b6ae1db$var$sessionStorageProvider = (0, $eNf8a.createSessionStorageProvider)('', false);
const $56f2750f0b6ae1db$export$b349f970aff316d8 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $56f2750f0b6ae1db$export$dd1deacfc61c978a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($56f2750f0b6ae1db$export$b349f970aff316d8.Provider, {
        value: true
    }, children);
const $56f2750f0b6ae1db$export$eb95770b90ecc1f3 = ({ children: children, engagementId: engagementId })=>{
    const isTourEnabled = (0, $5uXOq.useContext)($56f2750f0b6ae1db$export$b349f970aff316d8);
    if (!isTourEnabled) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6s4Eg.default), {
        engagementId: engagementId
    }, children);
};
const $56f2750f0b6ae1db$export$7c27d65549066b5 = ({ mode: mode, view: view, hasIssueResults: hasIssueResults, isAiEnabled: isAiEnabled })=>{
    const isTourEnabled = (0, $5uXOq.useContext)($56f2750f0b6ae1db$export$b349f970aff316d8);
    if (!isTourEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fB2N8.AsyncSpotlightCard), {
        mode: mode,
        view: view,
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
const $56f2750f0b6ae1db$export$9e9f507adee88e58 = ()=>{
    const isFlagEnabled = (0, $5uXOq.useContext)($56f2750f0b6ae1db$export$b349f970aff316d8);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const onOpenInProductHelpArticle = (0, $5Zxxp.useHelpPanelLink)();
    const onLearnMore = (0, $5uXOq.useCallback)(()=>{
        onOpenInProductHelpArticle((0, $1oOi0.LEARN_MORE_IPH_ARTICLE_ID));
    }, [
        onOpenInProductHelpArticle
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const shouldShowOptInFlag = (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $56f2750f0b6ae1db$var$sessionStorageProvider.get('showNinOptInFlag') : sessionStorage.getItem('showNinOptInFlag');
        if (isFlagEnabled && shouldShowOptInFlag === 'true') {
            showFlag({
                type: 'success',
                title: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eiUE8.default).successOptInTitleIssueTermRefresh : (0, $eiUE8.default).successOptInTitle,
                description: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eiUE8.default).successOptInDescIssueTermRefresh : (0, $eiUE8.default).successOptInDesc,
                messageId: 'issue-navigator-changeboarding.controllers.enable-nin-changeboarding.show-flag.success',
                messageType: 'transactional',
                actions: [
                    {
                        content: (0, $eiUE8.default).successActionLearnMoreLink,
                        onClick: onLearnMore
                    }
                ],
                isAutoDismiss: false,
                testId: 'issue-navigator-changeboarding.optin-success-flag'
            });
            (0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $56f2750f0b6ae1db$var$sessionStorageProvider.remove('showNinOptInFlag') : sessionStorage.removeItem('showNinOptInFlag');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});
parcelRegister("5Zxxp", function(module, exports) {

$parcel$export(module.exports, "useHelpPanelLink", () => $b0d1b3c2fea05784$export$dc5c3cc39ce0d138);
$parcel$export(module.exports, "HelpPanelLink", () => $b0d1b3c2fea05784$export$5a09250ffddd7fd1);
$parcel$export(module.exports, "default", () => $b0d1b3c2fea05784$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $e4yMr = parcelRequire("e4yMr");

var $4R6GH = parcelRequire("4R6GH");

var $6BNJk = parcelRequire("6BNJk");

var $kspz4 = parcelRequire("kspz4");

var $hsmeR = parcelRequire("hsmeR");

var $6s1PB = parcelRequire("6s1PB");
const $b0d1b3c2fea05784$export$dc5c3cc39ce0d138 = (resetHistory = false)=>{
    const { openRightSidebar: openRightSidebar } = (0, $hsmeR.useRightSidebarController)();
    const [, { setNavigationData: setNavigationData }] = (0, $kspz4.useHelpPanelActions)();
    const handleOnClick = (id, type = 'HELP_ARTICLE')=>{
        openRightSidebar((0, $6BNJk.HELP_PANEL_ID), (0, $6BNJk.HELP_PANEL_WIDTH), false, true);
        if (resetHistory) setNavigationData({
            articleId: {
                id: id,
                type: type
            },
            history: []
        });
        else setNavigationData({
            articleId: {
                id: id,
                type: type
            }
        });
    };
    return handleOnClick;
};
const $b0d1b3c2fea05784$export$5a09250ffddd7fd1 = ({ articleId: articleId = '', type: type = 'HELP_ARTICLE', children: children, onClick: onClick, href: href, fallbackComponent: fallbackComponent, // unused, but needs to be here so it's not passed to Link/Button in the ...props splat
...props })=>{
    const onOpenInProductHelpArticle = $b0d1b3c2fea05784$export$dc5c3cc39ce0d138();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnClick = (event, analyticsEvent)=>{
        if ((0, $4R6GH.fg)('help_panel_as_link')) event.preventDefault();
        onClick?.(event, analyticsEvent);
        onOpenInProductHelpArticle(articleId, type);
    };
    if ((0, $4R6GH.fg)('help_panel_as_link')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        ...props,
        onClick: handleOnClick,
        href: href ?? 'https://support.atlassian.com',
        appearance: "default",
        testId: props.testId
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        appearance: props.appearance === 'subtle-link' && (0, $6s1PB.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') ? 'link' : props.appearance,
        onClick: handleOnClick,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $bwpsq.default)([
            props.appearance === 'link' && "_4bfu18uv _1hms8stv _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            props.appearance === 'subtle-link' && (0, $6s1PB.expValEquals)('m1_features_page_experiment', 'cohort', 'variation') && "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnx8stv _jf4cnqa1"
        ])
    }, children);
};
var /**
 * @deprecated Use named export instead.
 */ $b0d1b3c2fea05784$export$2e2bcd8739ae039 = $b0d1b3c2fea05784$export$5a09250ffddd7fd1;
const $b0d1b3c2fea05784$var$buttonWrapperStyles = null;
const $b0d1b3c2fea05784$var$buttonWrapperSubtleStyles = null;

});

parcelRegister("1oOi0", function(module, exports) {

$parcel$export(module.exports, "FALLBACK_SUPPORT_ARTICLE", () => $43fa307c6841ead5$export$ff66aa7a4971d979);
$parcel$export(module.exports, "LEARN_MORE_IPH_ARTICLE_ID", () => $43fa307c6841ead5$export$88d16e35389ab3c6);
$parcel$export(module.exports, "getEngagementPlatformlMessageId", () => $43fa307c6841ead5$export$91074f0ada4f4533);
$parcel$export(module.exports, "TOUR_MESSAGE_ID", () => $43fa307c6841ead5$export$4ac775bda929f47);
$parcel$export(module.exports, "views", () => $43fa307c6841ead5$export$d0079916fe6800ac);
const $43fa307c6841ead5$export$ff66aa7a4971d979 = 'https://support.atlassian.com/jira-software-cloud/docs/search-for-issues-in-jira/';
const $43fa307c6841ead5$export$88d16e35389ab3c6 = '3FGQv6n7fB93yWWTYqY0hq';
const $43fa307c6841ead5$export$91074f0ada4f4533 = (id)=>`${id}-march2024`;
const $43fa307c6841ead5$export$4ac775bda929f47 = 'nin-changeboarding-start';
const $43fa307c6841ead5$export$6c69c3d1b5f6fe55 = {
    basic: 'basic',
    advanced: 'advanced'
};
const $43fa307c6841ead5$export$d0079916fe6800ac = {
    list: 'list-view',
    detail: 'split-view'
};

});

parcelRegister("fB2N8", function(module, exports) {

$parcel$export(module.exports, "AsyncSpotlightCard", () => $a20090c0d2e5eb6a$export$40e85aa59c198f98);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $a20090c0d2e5eb6a$var$SpotlightCard = (0, $kxZPA.lazy)(// we want both these types of spotlights to be within the same webpack chunk
()=>(parcelRequire("9toTf")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/common/ui/spotlight/spotlight-card/index.tsx"
});
const $a20090c0d2e5eb6a$export$40e85aa59c198f98 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-spotlight-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-spotlight-card",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a20090c0d2e5eb6a$var$SpotlightCard, props)));

});
parcelRegister("9toTf", function(module, exports) {

let $6e5a2124c2619be1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $6e5a2124c2619be1$var$load("jdSNM").then(()=>parcelRequire('dqR1S'));

});


parcelRegister("6s4Eg", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c5b26aae55f177$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $60c5b26aae55f177$var$EngagementSpotlightAsync = (0, $kxZPA.lazy)(()=>(parcelRequire("dbkIQ")).then(({ EngagementSpotlight: EngagementSpotlight })=>EngagementSpotlight), {
    ssr: false,
    moduleId: "../platform/packages/personalization/engagekit-ts/src/index.ts"
});
const $60c5b26aae55f177$var$SpotlightTourTarget = ({ children: children, engagementId: engagementId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: engagementId
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-engagement-spotlight",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-engagement-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60c5b26aae55f177$var$EngagementSpotlightAsync, {
        engagementId: engagementId
    }))));
var $60c5b26aae55f177$export$2e2bcd8739ae039 = $60c5b26aae55f177$var$SpotlightTourTarget;

});
parcelRegister("dbkIQ", function(module, exports) {

let $998c607ac0621db6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $998c607ac0621db6$var$load("ffQaD"),
    $998c607ac0621db6$var$load("kvRbA"),
    $998c607ac0621db6$var$load("76n7a"),
    $998c607ac0621db6$var$load("l253H"),
    $998c607ac0621db6$var$load("8yO1J")
]).then(()=>parcelRequire('k4MwF'));

});


parcelRegister("eiUE8", function(module, exports) {

$parcel$export(module.exports, "default", () => $172614e7cfb99d43$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $172614e7cfb99d43$var$messages = (0, $7VHMR.defineMessages)({
    successOptInTitle: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title",
        "defaultMessage": "You've switched to the new issue search"
    },
    successOptInDesc: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for issues across Jira."
    },
    successActionLearnMoreLink: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-action-learn-more-link",
        "defaultMessage": "Learn more"
    },
    successOptInTitleIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-title-issue-term-refresh",
        "defaultMessage": "You've switched to the new search"
    },
    successOptInDescIssueTermRefresh: {
        "id": "issue-navigator-changeboarding.controllers.enable-nin-changeboarding.success-opt-in-desc-issue-term-refresh",
        "defaultMessage": "Say hello to a faster, cleaner, and more intuitive experience while searching for work across Jira."
    }
});
var $172614e7cfb99d43$export$2e2bcd8739ae039 = $172614e7cfb99d43$var$messages;

});


parcelRegister("ffdpA", function(module, exports) {

$parcel$export(module.exports, "JQLDebuggerRenderSlotAsync", () => $31ef2c0ef7cee43c$export$222c67ffe33f4fa4);
$parcel$export(module.exports, "JQLDebuggerRenderSlot", () => $31ef2c0ef7cee43c$export$a3144a6f75ce69fe);

var $5uXOq = parcelRequire("5uXOq");

var $kxZPA = parcelRequire("kxZPA");
var $7hSN4 = parcelRequire("7hSN4");

var $7CMCs = parcelRequire("7CMCs");

var $cSD7y = parcelRequire("cSD7y");

var $512eM = parcelRequire("512eM");

var $6eDsT = parcelRequire("6eDsT");

var $6OxoL = parcelRequire("6OxoL");

const $31ef2c0ef7cee43c$export$222c67ffe33f4fa4 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("j6mz7")), {
    moduleId: "./src/packages/jql-builder/jql-debugger/src/ui/index.tsx"
});
function $31ef2c0ef7cee43c$export$e8398d4933a4ab21() {
    const [debuggerState] = (0, $512eM.useDebuggerStatus)();
    const debuggerActions = (0, $512eM.useJqlDebuggerStoreActions)();
    const [isAiEnabled] = (0, $512eM.useIsAiEnabled)();
    // Don't render the render slot when AI is not enabled
    if (!isAiEnabled) return null;
    // Don't render the render slot when the feature is at initial state
    if (debuggerState === 'INIT') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: (0, $6eDsT.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $6eDsT.ERROR_BOUNDARY_IDS).FIX_WITH_AI_MODAL,
        teamName: (0, $6eDsT.TEAM_NAME),
        fallback: "unmount",
        onError: ()=>{
            // On error, set the feature state to be JS_ERROR, so that such scenarios can be handled without
            // interfering with the feature initial state nor with the AI event instrumentation
            debuggerActions.setStatus('JS_ERROR');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hSN4.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($31ef2c0ef7cee43c$export$222c67ffe33f4fa4, null)));
}
const $31ef2c0ef7cee43c$export$a3144a6f75ce69fe = (0, $cSD7y.componentWithFG)('gravityai-2283-jql-debugger-rll-to-entrypoints', (0, $6OxoL.JQLPanelRenderSlotForIssueView), $31ef2c0ef7cee43c$export$e8398d4933a4ab21);

});
parcelRegister("512eM", function(module, exports) {

$parcel$export(module.exports, "useJqlDebuggerStoreActions", () => $0785fbdbf1edc211$export$661ee98a2d30a450);
$parcel$export(module.exports, "useStoreData", () => $0785fbdbf1edc211$export$544efe5ac05fc17);
$parcel$export(module.exports, "useDebuggerStatus", () => $0785fbdbf1edc211$export$e4c2322c66a3dea5);
$parcel$export(module.exports, "useJqlErrors", () => $0785fbdbf1edc211$export$d959fd60596bfa67);
$parcel$export(module.exports, "useJqlEditorOnSearch", () => $0785fbdbf1edc211$export$ba3a4678e5df092c);
$parcel$export(module.exports, "useJqlQuery", () => $0785fbdbf1edc211$export$ec027c329b94fe67);
$parcel$export(module.exports, "useIsAiEnabled", () => $0785fbdbf1edc211$export$742ce7b41314d513);
$parcel$export(module.exports, "useErrorComponentTestId", () => $0785fbdbf1edc211$export$afd1b99522ddeae9);
$parcel$export(module.exports, "useErrorComponentValidationId", () => $0785fbdbf1edc211$export$9c84149290836e7);
$parcel$export(module.exports, "useIsReadyForProactive", () => $0785fbdbf1edc211$export$1da2ac60b06e42d1);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");
const $0785fbdbf1edc211$var$initialState = {
    jqlQuery: '',
    userQueryError: [],
    onSearch: ()=>undefined,
    status: 'INIT',
    jqlDiffTokens: [],
    isAiEnabled: false,
    syntaxCorrectionAttemptErrors: [],
    singleInstrumentationID: '',
    errorSectionTestId: '',
    onAiInteractionDismissed () {
    // do nothing
    },
    exitNaturalLanguageMode () {
    // do nothing
    },
    onJsError () {
    // do nothing
    },
    jqlErrors: [],
    errorComponentValidationId: '',
    errorComponentTestId: '',
    isReadyForProactive: false
};
const $0785fbdbf1edc211$var$Store = (0, $iXqE5.createStore)({
    initialState: $0785fbdbf1edc211$var$initialState,
    // actions that trigger store mutation
    actions: {
        setJqlQuery: (jqlQuery)=>({ setState: setState })=>{
                setState({
                    jqlQuery: jqlQuery
                });
            },
        setOnSearch: (onSearch)=>({ setState: setState })=>{
                setState({
                    onSearch: onSearch
                });
            },
        setStatus: (status)=>({ setState: setState, getState: getState })=>{
                if (status === 'JS_ERROR') getState().onJsError();
                setState({
                    status: status
                });
            },
        setIssueNavigatorSearchMode: (issueNavigatorSearchMode)=>({ setState: setState })=>{
                setState({
                    issueNavigatorSearchMode: issueNavigatorSearchMode
                });
            },
        resetStatus: (source, newJqlQuery)=>({ setState: setState, getState: getState })=>{
                if (source === 'ON_ENTER_NL_MODE') setState({
                    issueNavigatorSearchMode: 'NL2JQL'
                });
                if (getState().status !== 'INIT') {
                    if ((0, $4R6GH.fg)('gravityai-2571-jql-debugger-close-button')) // AI modal gets dismissed when we accept a suggestion
                    // However, we don't want to fire the `aiInteraction Dismissed` event in that case
                    // We pass the status in as if we are viewing a result and close the panel, it should be a discarded event, not a dismissed event
                    {
                        if (source !== 'ACCEPT_FIX') {
                            if ((0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) // On a new JQL search, we do not dismiss the AI interaction if the JQL query hasn't changed
                            {
                                if (!(source === 'ON_NEW_JQL_SEARCH' && getState().jqlQuery === newJqlQuery)) getState().onAiInteractionDismissed(source, getState().status);
                            } else getState().onAiInteractionDismissed(source, getState().status);
                        }
                    } else if (source !== 'ACCEPT_FIX') {
                        // AI modal gets dismissed when we accept a suggestion
                        // However, we don't want to fire the `aiInteraction Dismissed` event in that case
                        if ((0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) // On a new JQL search, we do not dismiss the AI interaction if the JQL query hasn't changed
                        {
                            if (!(source === 'ON_NEW_JQL_SEARCH' && getState().jqlQuery === newJqlQuery)) getState().onAiInteractionDismissed(source);
                        } else getState().onAiInteractionDismissed(source);
                    }
                    // Reset the status and aiInteractionDismissed handler so that duplicate events won't be fired
                    setState({
                        status: 'INIT',
                        onAiInteractionDismissed: $0785fbdbf1edc211$var$initialState.onAiInteractionDismissed
                    });
                }
            },
        setStateOnFeatureInvoke: (initialDataOnInvoke)=>({ setState: setState })=>{
                setState({
                    ...initialDataOnInvoke,
                    status: 'LOADING_RESULT'
                });
            },
        setJqlErorCorrectionData: (data)=>({ setState: setState })=>{
                setState({
                    ...data,
                    status: 'VIEW_RESULT'
                });
            },
        setIsAiEnabled: (isAiEnabled)=>({ setState: setState })=>{
                setState({
                    isAiEnabled: isAiEnabled
                });
            },
        setOnAiInteractionDismissed: (onAiInteractionDismissed)=>({ setState: setState })=>{
                setState({
                    onAiInteractionDismissed: onAiInteractionDismissed
                });
            },
        setOnJsError: (onJsError)=>({ setState: setState })=>{
                setState({
                    onJsError: onJsError
                });
            },
        exitNaturalLanguageMode: ()=>({ getState: getState })=>{
                getState().exitNaturalLanguageMode?.();
            },
        setExitNaturalLanguageMode: (exitNaturalLanguageMode)=>({ setState: setState })=>{
                setState({
                    exitNaturalLanguageMode: exitNaturalLanguageMode
                });
            },
        setJqlErrors: (jqlErrors)=>({ setState: setState })=>setState({
                    jqlErrors: jqlErrors
                }),
        setErrorComponentValidationId: (errorComponentValidationId)=>({ setState: setState })=>setState({
                    errorComponentValidationId: errorComponentValidationId
                }),
        setErrorComponentTestId: (errorComponentValidationId)=>({ setState: setState })=>setState({
                    errorComponentValidationId: errorComponentValidationId
                }),
        setIsReadyForProactive: (isReadyForProactive)=>({ setState: setState })=>{
                setState({
                    isReadyForProactive: isReadyForProactive
                });
            }
    }
});
const $0785fbdbf1edc211$export$661ee98a2d30a450 = (0, $3sQ5x.createActionsHook)($0785fbdbf1edc211$var$Store);
const $0785fbdbf1edc211$export$544efe5ac05fc17 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store);
const $0785fbdbf1edc211$export$e4c2322c66a3dea5 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.status
});
const $0785fbdbf1edc211$export$d959fd60596bfa67 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.jqlErrors
});
const $0785fbdbf1edc211$export$ba3a4678e5df092c = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.onSearch
});
const $0785fbdbf1edc211$export$ec027c329b94fe67 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.jqlQuery
});
const $0785fbdbf1edc211$export$742ce7b41314d513 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.isAiEnabled
});
const $0785fbdbf1edc211$export$afd1b99522ddeae9 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.errorComponentTestId
});
const $0785fbdbf1edc211$export$9c84149290836e7 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.errorComponentValidationId
});
const $0785fbdbf1edc211$export$1da2ac60b06e42d1 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.isReadyForProactive && state.issueNavigatorSearchMode !== 'NL2JQL'
});
const $0785fbdbf1edc211$export$a416100e9df4f9b1 = (0, $3sQ5x.createHook)($0785fbdbf1edc211$var$Store, {
    selector: (state)=>state.syntaxCorrectionAttemptErrors
});

});

parcelRegister("6eDsT", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME_JQL_DEBUGGER", () => $1f38f116a0aa50f1$export$efcb4634ee5c0cb9);
$parcel$export(module.exports, "TEAM_NAME", () => $1f38f116a0aa50f1$export$d57b6b390e78d90f);
$parcel$export(module.exports, "ERROR_BOUNDARY_IDS", () => $1f38f116a0aa50f1$export$2d2d5df8a192a41a);
$parcel$export(module.exports, "CLOSED_AI_MODAL_ABORT_REASON_MESSAGE", () => $1f38f116a0aa50f1$export$8714ae84b437fe97);
$parcel$export(module.exports, "CLOSED_AI_MODAL_ABORT_REASON_NAME", () => $1f38f116a0aa50f1$export$1e71032fcb7b8730);
$parcel$export(module.exports, "JS_ERROR_ABORT_REASON_NAME", () => $1f38f116a0aa50f1$export$64c672172b01336);
$parcel$export(module.exports, "AI_RESULT_ERROR_CATEGORIES", () => $1f38f116a0aa50f1$export$ad3b2223714b1ed9);
const $1f38f116a0aa50f1$export$efcb4634ee5c0cb9 = 'jira-jql-debugger';
const $1f38f116a0aa50f1$export$d57b6b390e78d90f = 'jira-ai-gravity';
const $1f38f116a0aa50f1$export$2d2d5df8a192a41a = {
    TRIGGER_BUTTON: 'jira-jql-debugger-trigger-button',
    FIX_WITH_AI_MODAL: 'jira-jql-debugger-fix-with-ai-modal',
    COMMON_ENTRY_JQL_BUILDER: 'jira-jql-debugger-common-entry-jql-builder',
    COMMON_ENTRY_ISSUE_VIEW: 'jira-jql-debugger-common-entry-issue-view'
};
const $1f38f116a0aa50f1$export$8714ae84b437fe97 = 'AI Modal was closed before the fetch completed';
const $1f38f116a0aa50f1$export$1e71032fcb7b8730 = 'AI_MODAL_CLOSED';
const $1f38f116a0aa50f1$export$64c672172b01336 = 'JS_ERROR';
const $1f38f116a0aa50f1$export$ad3b2223714b1ed9 = {
    FIXED_JQL_HAS_ERRORS: 'fixed-jql-has-errors',
    SERVER_ERROR: 'server-error'
};

});

parcelRegister("6OxoL", function(module, exports) {

$parcel$export(module.exports, "JQLPanelRenderSlotForJQLEditor", () => $ed9cf04088525714$export$79179285687e80ca);
$parcel$export(module.exports, "JQLPanelRenderSlotForIssueView", () => $ed9cf04088525714$export$1efeb13e93a829bf);

var $5uXOq = parcelRequire("5uXOq");

var $8CUq3 = parcelRequire("8CUq3");

var $1kVqg = parcelRequire("1kVqg");

var $4ErVz = parcelRequire("4ErVz");

var $7CMCs = parcelRequire("7CMCs");

var $512eM = parcelRequire("512eM");

var $5XPwp = parcelRequire("5XPwp");

var $7E33q = parcelRequire("7E33q");

var $6eDsT = parcelRequire("6eDsT");

var $90soo = parcelRequire("90soo");
function $ed9cf04088525714$var$JqlDebuggerLayoutSwitcher(props) {
    const layoutQuery = props.fullWidthLayout ? 'below.lg' : 'above.lg';
    const showProp = (0, $5uXOq.useMemo)(()=>props.fullWidthLayout ? {
            below: 'lg'
        } : {
            above: 'lg'
        }, [
        props.fullWidthLayout
    ]);
    const [matches, setMatches] = (0, $5uXOq.useState)(null);
    const mq = (0, $4ErVz.UNSAFE_useMediaQuery)(layoutQuery, (e)=>{
        setMatches(e.matches);
    });
    return matches ?? mq?.matches ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        ...showProp,
        xcss: props.xcss ? [
            $ed9cf04088525714$var$showContainerStyles,
            props.xcss
        ] : $ed9cf04088525714$var$showContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7E33q.JQLDebuggerCommonEntry), null)) : null;
}
const $ed9cf04088525714$export$793a24421ebe4e74 = (props)=>{
    const { errorMessages: errorMessages, testId: testId, validationId: validationId } = props;
    const jqlDebuggerStoreActions = (0, $512eM.useJqlDebuggerStoreActions)();
    const [isReady] = (0, $5XPwp.useIsContextReady)();
    const renderSyncActions = (0, $5XPwp.useRenderSynchronizerStoreActions)();
    const [isAiEnabled] = (0, $512eM.useIsAiEnabled)();
    const [status] = (0, $512eM.useDebuggerStatus)();
    /**
	 * When the JQL Editor unmounts for whatever reason, we want to mark jql editor as not ready
	 * So that JQLPanelRenderSlotForIssueView doesn't try to accidentally render any error messages
	 *
	 * For example, this happens when we enter NL-to-JQL AI mode while the regular JQL editor has an error
	 */ (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            renderSyncActions.setJqlEditorReady(false);
        };
    }, [
        renderSyncActions
    ]);
    if (!errorMessages?.length || !isReady || !isAiEnabled || status === 'UNRECOVERABLE_ERROR') {
        renderSyncActions.setJqlEditorReady(false);
        return props.children;
    }
    jqlDebuggerStoreActions.setJqlErrors(errorMessages.map((0, $90soo.extractTextFromReactElement)));
    jqlDebuggerStoreActions.setErrorComponentTestId(testId);
    jqlDebuggerStoreActions.setErrorComponentValidationId(validationId);
    renderSyncActions.setJqlEditorReady(true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed9cf04088525714$var$JqlDebuggerLayoutSwitcher, {
        fullWidthLayout: false,
        xcss: $ed9cf04088525714$var$jqlBuilderContainerStyles
    });
};
const $ed9cf04088525714$export$79179285687e80ca = (props)=>{
    const { children: children } = props;
    const ChildrenFallback = (0, $5uXOq.useCallback)(()=>children, [
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: (0, $6eDsT.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $6eDsT.ERROR_BOUNDARY_IDS).COMMON_ENTRY_JQL_BUILDER,
        teamName: (0, $6eDsT.TEAM_NAME),
        fallback: ChildrenFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed9cf04088525714$export$793a24421ebe4e74, props));
};
const $ed9cf04088525714$export$1efeb13e93a829bf = ()=>{
    const [isReady] = (0, $5XPwp.useIsContextReady)();
    const [isJqlEditorReady] = (0, $5XPwp.useIsJqlEditorReady)();
    const storeActions = (0, $512eM.useJqlDebuggerStoreActions)();
    if (!isReady || !isJqlEditorReady) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: (0, $6eDsT.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $6eDsT.ERROR_BOUNDARY_IDS).COMMON_ENTRY_ISSUE_VIEW,
        teamName: (0, $6eDsT.TEAM_NAME),
        fallback: ()=>null,
        onError: ()=>{
            storeActions.setStatus('UNRECOVERABLE_ERROR');
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed9cf04088525714$var$JqlDebuggerLayoutSwitcher, {
        fullWidthLayout: true,
        xcss: $ed9cf04088525714$var$issueViewContainerStyles
    }));
};
const $ed9cf04088525714$var$jqlBuilderContainerStyles = (0, $8CUq3.xcss)({
    // When we are rendering in JQL builder, we want to add the space between the editor and panel
    // This space is already present in the issue view
    marginTop: 'space.100'
});
const $ed9cf04088525714$var$issueViewContainerStyles = (0, $8CUq3.xcss)({
    // When we are rendering in JQL builder, we want to add the space between the editor and panel
    // This space is already present in the issue view
    marginTop: 'space.negative.100'
});
const $ed9cf04088525714$var$showContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    marginBottom: 'space.100'
});

});
parcelRegister("1kVqg", function(module, exports) {

$parcel$export(module.exports, "Show", () => $7b5b5f6fd54f1de9$export$f6a3d19be20f5819);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8CUq3 = parcelRequire("8CUq3");

var $2pf2j = parcelRequire("2pf2j");
function $7b5b5f6fd54f1de9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b5b5f6fd54f1de9$var$showAboveQueries = (0, $2pf2j.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $7b5b5f6fd54f1de9$var$showBelowQueries = (0, $2pf2j.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $7b5b5f6fd54f1de9$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7b5b5f6fd54f1de9$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $7b5b5f6fd54f1de9$var$defaultHiddenStyles,
            above && $7b5b5f6fd54f1de9$var$showAboveQueries[above],
            below && $7b5b5f6fd54f1de9$var$showBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});
parcelRegister("2pf2j", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $f32e5b846e53517d$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $f32e5b846e53517d$export$b2a4e2b0c6417297);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $eXt4g = parcelRequire("eXt4g");

var $h9kUS = parcelRequire("h9kUS");
const $f32e5b846e53517d$export$918f8818cfbbeb2c = (input)=>{
    return (0, $eXt4g.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $h9kUS.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $f32e5b846e53517d$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $eXt4g.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $h9kUS.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("eXt4g", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $3f07a1aff81e4a42$export$2d293d9871c38e91);
const $3f07a1aff81e4a42$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $3f07a1aff81e4a42$export$2d293d9871c38e91 = Object.keys($3f07a1aff81e4a42$export$e5ee4fe8b989fd09);
const $3f07a1aff81e4a42$export$b7ed752a57b4177b = $3f07a1aff81e4a42$export$2d293d9871c38e91[0];

});



parcelRegister("5XPwp", function(module, exports) {

$parcel$export(module.exports, "useRenderSynchronizerStoreActions", () => $83997a3e2fc09962$export$60f8cec0dff6824c);
$parcel$export(module.exports, "useIsContextReady", () => $83997a3e2fc09962$export$7668b8e8d8c22896);
$parcel$export(module.exports, "useIsJqlEditorReady", () => $83997a3e2fc09962$export$7f34a2b12380537d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $83997a3e2fc09962$var$initialState = {
    isContextReady: false,
    isJqlEditorReady: false
};
const $83997a3e2fc09962$var$Store = (0, $iXqE5.createStore)({
    initialState: $83997a3e2fc09962$var$initialState,
    actions: {
        setIsContextReady: (isContextReady)=>({ setState: setState })=>{
                setState({
                    isContextReady: isContextReady
                });
            },
        setJqlEditorReady: (isJqlEditorReady)=>({ setState: setState })=>{
                setState({
                    isJqlEditorReady: isJqlEditorReady
                });
            }
    }
});
const $83997a3e2fc09962$export$60f8cec0dff6824c = (0, $3sQ5x.createActionsHook)($83997a3e2fc09962$var$Store);
const $83997a3e2fc09962$export$7668b8e8d8c22896 = (0, $3sQ5x.createHook)($83997a3e2fc09962$var$Store, {
    selector: (state)=>state.isContextReady
});
const $83997a3e2fc09962$export$7f34a2b12380537d = (0, $3sQ5x.createHook)($83997a3e2fc09962$var$Store, {
    selector: (state)=>state.isJqlEditorReady
});

});

parcelRegister("7E33q", function(module, exports) {

$parcel$export(module.exports, "JQLDebuggerCommonEntry", () => $184151cc31dcaed7$export$61b6653f41aa971b);

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $94cfG = parcelRequire("94cfG");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $2NMNM = parcelRequire("2NMNM");

var $6s1PB = parcelRequire("6s1PB");

var $512eM = parcelRequire("512eM");

var $cPrGR = parcelRequire("cPrGR");

var $7CEWb = parcelRequire("7CEWb");

var $6eDsT = parcelRequire("6eDsT");

var $a2znj = parcelRequire("a2znj");
function $184151cc31dcaed7$var$OnError() {
    const debuggerActions = (0, $512eM.useJqlDebuggerStoreActions)();
    (0, $5uXOq.useEffect)(()=>{
        // On error, set the feature state to be JS_ERROR, so that such scenarios can be handled without
        // interfering with the feature initial state nor with the AI event instrumentation
        debuggerActions.setStatus('JS_ERROR');
    }, [
        debuggerActions
    ]);
    return null;
}
const $184151cc31dcaed7$export$61b6653f41aa971b = ()=>{
    const [status] = (0, $512eM.useDebuggerStatus)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const debuggerStoreActions = (0, $512eM.useJqlDebuggerStoreActions)();
    const [query] = (0, $512eM.useJqlQuery)();
    const [jqlErrors] = (0, $512eM.useJqlErrors)();
    const [onSearch] = (0, $512eM.useJqlEditorOnSearch)();
    const [isReadyForProactive] = (0, $512eM.useIsReadyForProactive)();
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $4mO32.useEntryPoint)((0, $7CEWb.SuggestedFixContentEntrypoint), {});
    // For the proactive experience, we call the API through a useEffect for each applicable render
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) {
            if (status === 'INIT') {
                if (!isReadyForProactive) (0, $a2znj.preloadApiCall)(query, jqlErrors);
                else (0, $a2znj.onClick)({
                    testId: 'jql-debugger-common-entry',
                    createAnalyticsEvent: createAnalyticsEvent,
                    debuggerStoreActions: debuggerStoreActions,
                    query: query,
                    jqlErrors: jqlErrors,
                    onSearch: onSearch,
                    isReadyForProactive: isReadyForProactive
                });
            }
        }
    }, [
        isReadyForProactive,
        status,
        createAnalyticsEvent,
        debuggerStoreActions,
        jqlErrors,
        onSearch,
        query
    ]);
    /*
		We load the entrypoint conditionally here as the JQL debugger panel is rendered underneath the JQL builder for large screen sizes,
		and across the issue view for smaller screen sizes - their visibilty is controlled by a <Show>, but they are two separately
		rendered components. As a result, if we are switching from one screen size or issue view to another, the newly rendered version of the
		JQL debugger will not have a loaded entry point, so we load it here to ensure the content is still visible across different views.

		Example of behaviour without this conditional:
		https://www.loom.com/share/725438e2ea16481591bbe510815e9ca3?sid=b3dc286e-9c37-4cf9-a2c9-f55d3561a166
	*/ if (status !== 'INIT') entryPointActions?.load();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $94cfG.default), {
        spacing: "none",
        hasNewBorderExperience: true,
        shouldFitContainer: true,
        isLoading: status === 'LOADING_RESULT'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        padding: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPrGR.ErrorSection), {
        entryPointActions: entryPointActions
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {},
        packageName: (0, $6eDsT.PACKAGE_NAME_JQL_DEBUGGER),
        id: (0, $6eDsT.ERROR_BOUNDARY_IDS).FIX_WITH_AI_MODAL,
        teamName: (0, $6eDsT.TEAM_NAME),
        fallback: null,
        errorFallback: $184151cc31dcaed7$var$OnError
    }));
};

});
parcelRegister("94cfG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1249caed30269ff$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $hxoiH = parcelRequire("hxoiH");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");
let $d1249caed30269ff$var$namespaceUUID = 0;
const $d1249caed30269ff$var$newPalette = {
    dark: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    },
    light: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    }
};
const $d1249caed30269ff$var$AFTER_LOAD_DURATION = 3000;
const $d1249caed30269ff$var$AnimatedSvgContainer = ({ isLoading: isLoading, isBlurred: isBlurred, isShadow: isShadow, isBorderGrey: isBorderGrey, hasNewBorderExperience: hasNewBorderExperience })=>{
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    const svgRef = (0, $5uXOq.useRef)(null);
    const namespaceId = (0, $5uXOq.useRef)();
    const [showRainbowBorder, setShowRainbowBorder] = (0, $5uXOq.useState)(false);
    const paletteForTheme = colorMode === 'dark' ? $d1249caed30269ff$var$newPalette.dark : $d1249caed30269ff$var$newPalette.light;
    if (namespaceId.current === undefined) {
        namespaceId.current = $d1249caed30269ff$var$namespaceUUID;
        $d1249caed30269ff$var$namespaceUUID += 1;
    }
    (0, $5uXOq.useEffect)(()=>{
        if (isLoading) {
            const svg = svgRef.current;
            hasNewBorderExperience && setShowRainbowBorder(true); // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isLoading,
        hasNewBorderExperience
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // we keep the rainbow border without animations for at 3 seconds after load. After that we show the grey border
        if (hasNewBorderExperience && !isLoading && showRainbowBorder) {
            const timeoutId = setTimeout(()=>setShowRainbowBorder(false), $d1249caed30269ff$var$AFTER_LOAD_DURATION);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        hasNewBorderExperience,
        showRainbowBorder,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d1249caed30269ff$var$SvgContainer, {
        isBlurred: isBlurred,
        isShadow: isShadow,
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), isBorderGrey || hasNewBorderExperience && !showRainbowBorder && !isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        d: "M0 0h24v24H0Z",
        vectorEffect: "non-scaling-stroke"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    }))));
};
const $d1249caed30269ff$var$AIContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isLoading: isLoading, isShadow: isShadow = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', testId: testId, isBorderGrey: isBorderGrey, components: { ContainerComponent: ContainerComponent = $d1249caed30269ff$var$Container, ContentComponent: ContentComponent = $d1249caed30269ff$var$Content } = {}, hasNewBorderExperience: hasNewBorderExperience = false, borderless: borderless = false, zIndex: zIndex = (0, $gwIPs.layers).card }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContainerComponent, {
        "data-testid": testId,
        shouldFitContainer: shouldFitContainer,
        zIndex: zIndex
    }, (!(0, $4R6GH.fg)('similar_items_in_gic_ui_fixes') || !borderless) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d1249caed30269ff$var$AnimatedSvgContainer, {
        isShadow: isShadow,
        isLoading: isLoading,
        isBorderGrey: isBorderGrey,
        hasNewBorderExperience: hasNewBorderExperience
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d1249caed30269ff$var$AnimatedSvgContainer, {
        isLoading: isLoading,
        isBlurred: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ContentComponent, {
        ref: ref,
        spacing: spacing
    }, children));
});
var $d1249caed30269ff$export$2e2bcd8739ae039 = $d1249caed30269ff$var$AIContainer;
$d1249caed30269ff$var$AIContainer.displayName = 'AIContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d1249caed30269ff$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainer: shouldFitContainer, zIndex: zIndex, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w1vr8s": (0, $lD23V.default)(__cmplp.zIndex || (0, $gwIPs.layers).card)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _1pbypt6a",
            __cmplp.shouldFitContainer ? "_1bsb1wug" : "_1bsb1ns9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d1249caed30269ff$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { zIndex: zIndex, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_w1vr8s": (0, $lD23V.default)(__cmplp.zIndex || (0, $gwIPs.layers).card)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoi2wt _bfhkvuon _16jlkb7n _1pbypt6a _1bsb1osq",
            __cmplp.spacing === 'default' && "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $d1249caed30269ff$export$71abc632aa29e6fe = {
    ContainerComponent: $d1249caed30269ff$var$Container,
    ContentComponent: $d1249caed30269ff$var$Content
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d1249caed30269ff$var$SvgContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isShadow: isShadow, isBlurred: isBlurred, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoftgi _kqswstnw",
            __cmplp.isShadow ? "_16qs9g9j" : "_16qsglyw",
            __cmplp.isBlurred ? "_1bsb5cnj _4t3i5cnj _154iu2gc _1ltvu2gc _kdam7b89" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cPrGR", function(module, exports) {

$parcel$export(module.exports, "ErrorSection", () => $75b2c572f25d51cd$export$b0bceea2ea86179a);

var $5uXOq = parcelRequire("5uXOq");

var $i28qQ = parcelRequire("i28qQ");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $hMVoD = parcelRequire("hMVoD");

var $aYAc3 = parcelRequire("aYAc3");

var $42CjB = parcelRequire("42CjB");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $8F23c = parcelRequire("8F23c");

var $azxjR = parcelRequire("azxjR");

var $512eM = parcelRequire("512eM");

var $6XQU0 = parcelRequire("6XQU0");

var $cCZdl = parcelRequire("cCZdl");
function $75b2c572f25d51cd$export$b0bceea2ea86179a(props) {
    const { entryPointActions: entryPointActions } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [query] = (0, $512eM.useJqlQuery)();
    const [status] = (0, $512eM.useDebuggerStatus)();
    const [jqlErrors] = (0, $512eM.useJqlErrors)();
    const [onSearch] = (0, $512eM.useJqlEditorOnSearch)();
    const [errorComponentTestId] = (0, $512eM.useErrorComponentTestId)();
    const [errorComponentValidationId] = (0, $512eM.useErrorComponentValidationId)();
    const jqlDebuggerStoreActions = (0, $512eM.useJqlDebuggerStoreActions)();
    const [{ syntaxCorrectionAttemptErrors: syntaxCorrectionAttemptErrors, singleInstrumentationID: singleInstrumentationID }] = (0, $512eM.useStoreData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isReadyForProactive] = (0, $512eM.useIsReadyForProactive)();
    const showDiscardButton = status === 'VIEW_RESULT' || status === 'RESULT_ERROR';
    // The Fix error button should be shown when:
    // The user has not invoked any action to make the experience ready for proactive, or
    // the user returns from dismissing a proactive AI result
    const showFixErrorButton = status === 'RESULT_DISCARDED' || status === 'INIT' && !isReadyForProactive;
    const onDiscardClick = ()=>{
        // The close button can be clicked from either a succesful result view, or an error view (server error or JQL couldn't be corrected)
        const closedFromSource = status === 'RESULT_ERROR' || status === 'VIEW_RESULT' && syntaxCorrectionAttemptErrors.length > 0 ? 'error_view' : 'result_view';
        // Fire `aiResult discarded` event when the close button is clicked in a successful result view
        // https://atlassian.slack.com/archives/C07B7SJR0CT/p1744736278862629?thread_ts=1744328109.644489&cid=C07B7SJR0CT
        if (status === 'VIEW_RESULT' && syntaxCorrectionAttemptErrors.length === 0) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult discarded', {
            ...(0, $8F23c.getAiAttributes)({
                singleInstrumentationID: singleInstrumentationID,
                ...(0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                    isReadyForProactive: isReadyForProactive
                } : {}
            })
        });
        // Fire an event for the close button being clicked in all cases
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'closeButton clicked', 'jqlDebugger', {
            closedFromSource: closedFromSource
        });
        if ((0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) jqlDebuggerStoreActions.setStatus('RESULT_DISCARDED');
        else jqlDebuggerStoreActions.setStatus('INIT');
    };
    if ((0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.200",
        xcss: $75b2c572f25d51cd$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "start",
        spread: "space-between",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "h5",
        xcss: $75b2c572f25d51cd$var$jqlErrorHeadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
        color: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold"
    }, formatMessage(jqlErrors?.length > 1 ? (0, $cCZdl.default).jqlDebuggerHeadingPluralNonFinal : (0, $cCZdl.default).jqlDebuggerHeadingNonFinal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: errorComponentTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "alert",
        id: errorComponentValidationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "ul",
        xcss: $75b2c572f25d51cd$var$errorBoxStyles,
        testId: "jql-debugger.ui.error-section.error-list"
    }, jqlErrors.map((error)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "li",
            key: error,
            xcss: $75b2c572f25d51cd$var$listItemStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            color: "color.text.accent.red"
        }, error))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: (0, $4R6GH.fg)('gravityai-2571-jql-debugger-close-button') ? $75b2c572f25d51cd$var$headerEndStylesWithCross : $75b2c572f25d51cd$var$headerEndStyles
    }, status === 'VIEW_RESULT' && !(0, $4R6GH.fg)('gravityai-3165-jql-fixer-ga') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $cCZdl.default).betaLozenge)) : null, showFixErrorButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azxjR.FixErrorButton), {
        testId: "jql-debugger.ui.error-section.trigger-button",
        jqlErrors: jqlErrors,
        onSearch: onSearch,
        query: query,
        entryPointActions: entryPointActions
    }), (0, $4R6GH.fg)('gravityai-2571-jql-debugger-close-button') ? showDiscardButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        testId: "jql-debugger.ui.error-section.close-button",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $cCZdl.default).discardSuggestionNonFinal),
        onClick: onDiscardClick,
        isTooltipDisabled: false
    }) : null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        spread: "space-between",
        space: "space.200",
        xcss: $75b2c572f25d51cd$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "start",
        spread: "space-between",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "h5",
        xcss: $75b2c572f25d51cd$var$jqlErrorHeadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
        color: "var(--ds-icon, #44546F)",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold"
    }, formatMessage(jqlErrors?.length > 1 ? (0, $cCZdl.default).jqlDebuggerHeadingPluralNonFinal : (0, $cCZdl.default).jqlDebuggerHeadingNonFinal))), status === 'LOADING_RESULT' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6XQU0.GeneratingAnimation), {
        alt: formatMessage((0, $cCZdl.default).jqlDebuggerLoadingNonFinal)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $cCZdl.default).jqlDebuggerLoadingNonFinal))) : // The wrappers around the ul element try to closely resemble the same structure as the default error message in the platform package
    // See: platform/packages/jql/jql-editor/src/ui/jql-editor-footer-content/jql-messages/errors/index.tsx
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: errorComponentTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "alert",
        id: errorComponentValidationId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "ul",
        xcss: $75b2c572f25d51cd$var$errorBoxStyles,
        testId: "jql-debugger.ui.error-section.error-list"
    }, jqlErrors.map((error)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            as: "li",
            key: error,
            xcss: $75b2c572f25d51cd$var$listItemStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            color: "color.text.accent.red"
        }, error))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: (0, $4R6GH.fg)('gravityai-2571-jql-debugger-close-button') ? $75b2c572f25d51cd$var$headerEndStylesWithCross : $75b2c572f25d51cd$var$headerEndStyles
    }, status === 'VIEW_RESULT' && !(0, $4R6GH.fg)('gravityai-3165-jql-fixer-ga') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aYAc3.default), {
        appearance: "new"
    }, formatMessage((0, $cCZdl.default).betaLozenge)) : null, status === 'INIT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $azxjR.FixErrorButton), {
        testId: "jql-debugger.ui.error-section.trigger-button",
        jqlErrors: jqlErrors,
        onSearch: onSearch,
        query: query,
        entryPointActions: entryPointActions
    }), (0, $4R6GH.fg)('gravityai-2571-jql-debugger-close-button') ? showDiscardButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        testId: "jql-debugger.ui.error-section.close-button",
        appearance: "subtle",
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $cCZdl.default).discardSuggestionNonFinal),
        onClick: onDiscardClick,
        isTooltipDisabled: false
    }) : null));
}
const $75b2c572f25d51cd$var$containerStyles = (0, $8CUq3.xcss)({
    minHeight: "var(--ds-space-400, 32px)"
});
const $75b2c572f25d51cd$var$errorBoxStyles = (0, $8CUq3.xcss)({
    flex: 1,
    marginBlockStart: '0',
    paddingInlineStart: 'space.025'
});
const $75b2c572f25d51cd$var$headerEndStyles = (0, $8CUq3.xcss)({
    alignSelf: 'flex-start'
});
const $75b2c572f25d51cd$var$headerEndStylesWithCross = (0, $8CUq3.xcss)({
    alignSelf: 'flex-start',
    display: 'flex',
    gap: 'space.075',
    alignItems: 'center'
});
const $75b2c572f25d51cd$var$listItemStyle = (0, $8CUq3.xcss)({
    listStyle: 'none'
});
const $75b2c572f25d51cd$var$jqlErrorHeadingStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    gap: 'space.075'
});

});
parcelRegister("8F23c", function(module, exports) {

$parcel$export(module.exports, "getAiAttributes", () => $b362f3ec776c9dcc$export$1dc69577c8d8f632);
function $b362f3ec776c9dcc$export$1dc69577c8d8f632({ singleInstrumentationID: singleInstrumentationID, isReadyForProactive: isReadyForProactive = false }) {
    const userGeneratedAI = isReadyForProactive ? 0 : 1;
    const proactiveAIGenerated = isReadyForProactive ? 1 : 0;
    return {
        aiFeatureName: 'JQL_Debugger',
        userGeneratedAI: userGeneratedAI,
        proactiveAIGenerated: proactiveAIGenerated,
        isAIFeature: 1,
        singleInstrumentationID: singleInstrumentationID
    };
}

});

parcelRegister("azxjR", function(module, exports) {

$parcel$export(module.exports, "FixErrorButton", () => $eae5972d05fa16fa$export$94f98890cd333316);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $41hx5 = parcelRequire("41hx5");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $512eM = parcelRequire("512eM");

var $eA4t7 = parcelRequire("eA4t7");

function $eae5972d05fa16fa$var$useImportOnClickHandler() {
    const importer = (0, $5uXOq.useCallback)(()=>{
        return Promise.resolve((parcelRequire("a2znj")));
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        importer();
    }, [
        importer
    ]);
    return importer;
}
function $eae5972d05fa16fa$export$94f98890cd333316(props) {
    const { testId: testId, jqlErrors: jqlErrors, onSearch: onSearch, query: query, entryPointActions: entryPointActions } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const debuggerStoreActions = (0, $512eM.useJqlDebuggerStoreActions)();
    const importer = $eae5972d05fa16fa$var$useImportOnClickHandler();
    const [isReadyForProactive] = (0, $512eM.useIsReadyForProactive)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fixWithAiButton viewed', {
            debuggerPanel: true
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($41hx5))),
        onMouseOver: ()=>{
            entryPointActions?.preload();
        },
        testId: "jql-debugger.ui.fix-error-button.button",
        onClick: async ()=>{
            entryPointActions?.load();
            const { onClick: onClick } = await importer();
            onClick({
                testId: testId,
                query: query || '',
                jqlErrors: jqlErrors,
                onSearch: onSearch,
                createAnalyticsEvent: createAnalyticsEvent,
                debuggerStoreActions: debuggerStoreActions,
                isReadyForProactive: isReadyForProactive
            });
        }
    }, formatMessage((0, $eA4t7.default).fixErrorWithAiNonFinal));
}

});
parcelRegister("eA4t7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3227887775647894$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3227887775647894$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fixErrorWithAiNonFinal: {
        "id": "jql-debugger.trigger-button.fix-error-with-ai-non-final",
        "defaultMessage": "Fix error"
    },
    jsErrorNonFinal: {
        "id": "jql-debugger.trigger-button.js-error-non-final",
        "defaultMessage": "Something went wrong"
    },
    errorIconLabelNonFinal: {
        "id": "jql-debugger.trigger-button.error-icon-label-non-final",
        "defaultMessage": "Error Icon"
    }
});

});

parcelRegister("a2znj", function(module, exports) {

$parcel$export(module.exports, "endpoint", () => $034d5bdc22e266f1$export$125e2b775860041f);
$parcel$export(module.exports, "apiCache", () => $034d5bdc22e266f1$export$fd9779c86130d7b0);
$parcel$export(module.exports, "preloadApiCall", () => $034d5bdc22e266f1$export$2797ffd2e0fc155);
$parcel$export(module.exports, "onClick", () => $034d5bdc22e266f1$export$1d5a917feb871989);

var $7Jxgt = parcelRequire("7Jxgt");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $8F23c = parcelRequire("8F23c");

var $6eDsT = parcelRequire("6eDsT");

var $9VWpw = parcelRequire("9VWpw");

var $iVgaU = parcelRequire("iVgaU");
const $034d5bdc22e266f1$export$125e2b775860041f = (0, $9VWpw.createConvoAiEndpoint)({
    url: '/gateway/api/assist/api/v1/plugin/execute',
    method: 'POST',
    experienceId: 'jira-nl-to-jql-errors',
    product: 'jira'
});
const $034d5bdc22e266f1$export$fd9779c86130d7b0 = (0, $iVgaU.LruCache)();
const $034d5bdc22e266f1$export$2797ffd2e0fc155 = (query, jqlErrors, abortController = new AbortController())=>{
    const promise = $034d5bdc22e266f1$export$fd9779c86130d7b0.get(query)?.value || $034d5bdc22e266f1$export$125e2b775860041f({
        name: 'jirajqldebug',
        schema: {
            type: 'jirajqldebug',
            userQuery: query,
            userQueryError: jqlErrors?.join('. \n') || ''
        }
    }, {
        abortControllerSignal: abortController.signal
    });
    $034d5bdc22e266f1$export$fd9779c86130d7b0.set(query, promise);
    return promise;
};
async function $034d5bdc22e266f1$export$1d5a917feb871989({ testId: testId, createAnalyticsEvent: createAnalyticsEvent, query: query, debuggerStoreActions: debuggerStoreActions, jqlErrors: jqlErrors, onSearch: onSearch, isReadyForProactive: isReadyForProactive = false }) {
    const singleInstrumentationID = (0, $7Jxgt.v4)();
    try {
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction initiated', (0, $8F23c.getAiAttributes)({
            singleInstrumentationID: singleInstrumentationID,
            ...(0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                isReadyForProactive: isReadyForProactive
            } : {}
        }));
        const abortController = new AbortController();
        // When we trigger the JQL Debugger within NL-to-JQL, we want to exit the natural language mode
        // This is because two AI features cannot be nested within each other
        // Attempting to show two AI features at once also interferes with non functional aspects such as loading states, analytics and feedback collector
        debuggerStoreActions.exitNaturalLanguageMode();
        debuggerStoreActions.setStateOnFeatureInvoke({
            jqlQuery: query,
            singleInstrumentationID: singleInstrumentationID,
            errorSectionTestId: testId
        });
        // Register callback to be called when there is a javascript error
        // Currently all it does is aborting any pending API calls
        debuggerStoreActions.setOnJsError(()=>{
            abortController?.abort(new DOMException((0, $6eDsT.CLOSED_AI_MODAL_ABORT_REASON_MESSAGE), (0, $6eDsT.JS_ERROR_ABORT_REASON_NAME)));
        });
        // Register callback to be used when the AI modal is dismissed
        debuggerStoreActions.setOnAiInteractionDismissed((dismissReason, status)=>{
            // Abort any pending API calls
            abortController?.abort(new DOMException((0, $6eDsT.CLOSED_AI_MODAL_ABORT_REASON_MESSAGE), (0, $6eDsT.CLOSED_AI_MODAL_ABORT_REASON_NAME)));
            if ((0, $4R6GH.fg)('gravityai-2571-jql-debugger-close-button')) {
                // When a successful result is shown, the AI result is discarded, not dismissed by definition on
                // single instrumentation docs: https://hello.atlassian.net/wiki/x/gqTA4
                if (status === 'VIEW_RESULT') (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult discarded', {
                    ...(0, $8F23c.getAiAttributes)({
                        singleInstrumentationID: singleInstrumentationID,
                        ...(0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                            isReadyForProactive: isReadyForProactive
                        } : {}
                    })
                });
                else // Fire the singleInstrumentation event
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction dismissed', {
                    ...(0, $8F23c.getAiAttributes)({
                        singleInstrumentationID: singleInstrumentationID,
                        ...(0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                            isReadyForProactive: isReadyForProactive
                        } : {}
                    }),
                    dismissReason: dismissReason
                });
            } else // Fire the singleInstrumentation event
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiInteraction dismissed', {
                ...(0, $8F23c.getAiAttributes)({
                    singleInstrumentationID: singleInstrumentationID,
                    ...(0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                        isReadyForProactive: isReadyForProactive
                    } : {}
                }),
                dismissReason: dismissReason
            });
        });
        let response = null;
        if ((0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) {
            const promise = $034d5bdc22e266f1$export$2797ffd2e0fc155(query, jqlErrors, abortController);
            response = await promise;
        } else response = await $034d5bdc22e266f1$export$125e2b775860041f({
            name: 'jirajqldebug',
            schema: {
                type: 'jirajqldebug',
                userQuery: query,
                userQueryError: jqlErrors?.join('. \n') || ''
            }
        }, {
            abortControllerSignal: abortController?.signal
        });
        /**
		 * Set the API response data on the store, so that the data can be consumed by the JQLDebuggerRenderSlot
		 *
		 * This is because the trigger and the render slot are used in two different packages
		 *  - Trigger is rendered inside the JQL Builder
		 *  - Render slot is in Issue Navigator
		 *
		 * By keeping these two components loosely coupled, we can style them independent of each other
		 * Yet they are highly cohesive, so that one can be controlled by the other by updating data on the store
		 *
		 * This approach also allows us to minimise the javascript bundles loaded for each component in their specific circumstances
		 * For example, the render-slot chunk is not loaded until the users hover over the trigger button
		 * Similarly the trigger-button chunk is not loaded unless there are errors in the jql-editor
		 */ const syntaxCorrectionAttemptErrors = response?.metadata?.value?.errors || [];
        if (syntaxCorrectionAttemptErrors.length) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', {
            ...(0, $8F23c.getAiAttributes)({
                singleInstrumentationID: singleInstrumentationID,
                ...(0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                    isReadyForProactive: isReadyForProactive
                } : {}
            }),
            aiResultErrorCategory: (0, $6eDsT.AI_RESULT_ERROR_CATEGORIES).FIXED_JQL_HAS_ERRORS
        });
        debuggerStoreActions.setJqlErorCorrectionData({
            userQueryError: jqlErrors || [],
            onSearch: onSearch || (()=>undefined),
            jqlDiffTokens: response?.metadata?.value?.diff || [],
            syntaxCorrectionAttemptErrors: syntaxCorrectionAttemptErrors
        });
    } catch (e) {
        if ((0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false)) $034d5bdc22e266f1$export$fd9779c86130d7b0.delete(query);
        const isNetworkCallAbort = e instanceof DOMException;
        (0, $jcw0u.default)({
            event: createAnalyticsEvent({}),
            meta: {
                id: 'JQL_Debugger',
                packageName: '@atlassian/jira-jql-debugger',
                teamName: 'Gravity'
            },
            attributes: {
                ...(0, $8F23c.getAiAttributes)({
                    singleInstrumentationID: singleInstrumentationID,
                    ...(0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                        isReadyForProactive: isReadyForProactive
                    } : {}
                }),
                isNetworkCallAbort: isNetworkCallAbort
            },
            error: e instanceof Error ? e : undefined
        });
        if (isNetworkCallAbort) {
            // When network call is aborted due to a javascript error, then don't change the feature state
            if (e.name === (0, $6eDsT.JS_ERROR_ABORT_REASON_NAME)) return;
            // When network call is aborted due to dismissing the modal, then we reset the feature state to initial state
            if (e.name === (0, $6eDsT.CLOSED_AI_MODAL_ABORT_REASON_NAME)) {
                debuggerStoreActions.resetStatus('NETWORK_CALL_ABORT');
                return;
            }
        }
        // Do not fire the unified ai anlytics event for aiResult error when the API call is aborted
        // i.e. the interaction was dismissed, but not necessarily resulted in an error
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'aiResult error', {
            ...(0, $8F23c.getAiAttributes)({
                singleInstrumentationID: singleInstrumentationID,
                ...(0, $6s1PB.expVal)('gravityai-2607-proactive-jql-debugger', 'isEnabled', false) ? {
                    isReadyForProactive: isReadyForProactive
                } : {}
            }),
            aiResultErrorCategory: (0, $6eDsT.AI_RESULT_ERROR_CATEGORIES).SERVER_ERROR
        });
        // Explicitly update the status to be RESULT_ERROR in the fallthrough case
        debuggerStoreActions.setStatus('RESULT_ERROR');
    }
}

});
parcelRegister("9VWpw", function(module, exports) {

$parcel$export(module.exports, "createConvoAiEndpoint", () => $7ba9cb0be2f2c151$export$f8ba6757167c2aba);
const $7ba9cb0be2f2c151$export$f8ba6757167c2aba = (initArgs)=>async (body, options)=>{
        const response = await fetch(initArgs.url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Product': initArgs.product,
                'X-Experience-Id': initArgs.experienceId
            },
            body: JSON.stringify(body),
            signal: options.abortControllerSignal
        });
        if (!response.ok) throw new Error(`API call failed: ${response.status}`);
        const result = await response.json();
        return result;
    };

});

parcelRegister("iVgaU", function(module, exports) {

$parcel$export(module.exports, "LruCache", () => $b2b4ba3b9f7ae5d9$export$ec63a4108685a0aa);
function $b2b4ba3b9f7ae5d9$export$ec63a4108685a0aa(limit = 5) {
    const cache = new Map();
    return {
        get: (key)=>cache.get(key),
        set: (key, value)=>{
            cache.set(key, {
                lastAccessed: Date.now(),
                value: value
            });
            if (cache.size <= limit) return;
            // limit the cache size based on the oldest entry based on lastAccessed time
            let oldestKey = null;
            let oldestLastAccessed = null;
            for (const [key_, value_] of cache.entries())if (oldestLastAccessed === null || value_.lastAccessed < oldestLastAccessed) {
                oldestKey = key_;
                oldestLastAccessed = value_.lastAccessed;
            }
            if (oldestKey) cache.delete(oldestKey);
        },
        delete: (key)=>{
            cache.delete(key);
        },
        clear: ()=>{
            cache.clear();
        }
    };
}

});



parcelRegister("6XQU0", function(module, exports) {

$parcel$export(module.exports, "GeneratingAnimation", () => $2a8a6a1f71ee5df7$export$483f53d5a0354a30);

var $5uXOq = parcelRequire("5uXOq");
const $2a8a6a1f71ee5df7$export$483f53d5a0354a30 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "20",
        viewBox: "0 2 24 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("title", null, props.alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: "#0C66E4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: "#1D7AFC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: "#388BFF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));

});

parcelRegister("cCZdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d9705e8c7e7fe3d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7d9705e8c7e7fe3d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jqlDebuggerHeadingNonFinal: {
        "id": "jql-debugger-panel.header.text-non-final",
        "defaultMessage": "JQL error"
    },
    jqlDebuggerHeadingPluralNonFinal: {
        "id": "jql-debugger-panel.header.plural-text-non-final",
        "defaultMessage": "JQL errors"
    },
    jqlDebuggerLoadingNonFinal: {
        "id": "jql-debugger-panel.header.loading-non-final",
        "defaultMessage": "Generating query fixes"
    },
    betaLozenge: {
        "id": "jql-debugger-panel.header.beta-lozenge",
        "defaultMessage": "Beta"
    },
    discardSuggestionNonFinal: {
        "id": "jql-debugger-panel.error-section.discard-suggestion-non-final",
        "defaultMessage": "Discard and close"
    }
});

});


parcelRegister("7CEWb", function(module, exports) {

$parcel$export(module.exports, "SuggestedFixContentEntrypoint", () => $2277cf36e1c1c6d6$export$9b2c3d0b37e41ae9);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $2277cf36e1c1c6d6$export$9b2c3d0b37e41ae9 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("6ReO7")), {
        moduleId: "2d263a55",
        priority: "interaction"
    }),
    getPreloadProps: ()=>{
        return {};
    }
});

});
parcelRegister("6ReO7", function(module, exports) {

let $4fe32db9539d5b6e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $4fe32db9539d5b6e$var$load("57CQP").then(()=>parcelRequire('jH0B9'));

});



parcelRegister("90soo", function(module, exports) {

$parcel$export(module.exports, "extractTextFromReactElement", () => $49febd27912ae309$export$98ee087174ba8894);

var $5uXOq = parcelRequire("5uXOq");
function $49febd27912ae309$export$98ee087174ba8894(element) {
    let result = '';
    function traverse(node) {
        if (typeof node === 'string' || typeof node === 'number') result += node.toString();
        else if (/*#__PURE__*/ (0, $5uXOq.isValidElement)(node)) (0, $5uXOq.Children).forEach(node.props.children, (child)=>{
            traverse(child);
        });
    }
    traverse(element);
    return result;
}

});


parcelRegister("j6mz7", function(module, exports) {

let $de8014e089281d84$var$load = (parcelRequire("28QjX"))(4);
module.exports = $de8014e089281d84$var$load("f6Ath").then(()=>parcelRequire('hKkvZ'));

});


parcelRegister("48rMm", function(module, exports) {

$parcel$export(module.exports, "IssueTableSelectedIssuesContainer", () => $c785af315de8dae0$export$b11112517798dbed);
$parcel$export(module.exports, "useIssueTableSelectedIssuesActions", () => $c785af315de8dae0$export$b4602482fdfd31ed);
$parcel$export(module.exports, "useIssueTableSelectedIssues", () => $c785af315de8dae0$export$ad5f97924b14314b);
$parcel$export(module.exports, "useIsIssueSelected", () => $c785af315de8dae0$export$cfefd69fc8a5ac52);
$parcel$export(module.exports, "useAreAllIssuesSelected", () => $c785af315de8dae0$export$949e47631f4a60a5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $es90k = parcelRequire("es90k");
const $c785af315de8dae0$export$b11112517798dbed = (0, $gg7kZ.createContainer)();
const $c785af315de8dae0$var$Store = (0, $iXqE5.createStore)({
    initialState: $es90k.initialState,
    actions: $es90k.actions,
    name: 'jira-native-issue-table-selected-issues-state',
    containedBy: $c785af315de8dae0$export$b11112517798dbed
});
const $c785af315de8dae0$export$b4602482fdfd31ed = (0, $3sQ5x.createActionsHook)($c785af315de8dae0$var$Store);
const $c785af315de8dae0$var$getSelectedIssueIdsSelector = (state)=>{
    return Array.from(state.selectedIssueIds);
};
const $c785af315de8dae0$export$ad5f97924b14314b = (0, $3sQ5x.createStateHook)($c785af315de8dae0$var$Store, {
    selector: $c785af315de8dae0$var$getSelectedIssueIdsSelector
});
const $c785af315de8dae0$var$getIsIssueIdSelectedSelector = (state, issueId)=>{
    return state.selectedIssueIds.has(issueId);
};
const $c785af315de8dae0$export$cfefd69fc8a5ac52 = (0, $3sQ5x.createStateHook)($c785af315de8dae0$var$Store, {
    selector: $c785af315de8dae0$var$getIsIssueIdSelectedSelector
});
const $c785af315de8dae0$var$getAreAllIssuesSelectedSelector = (state, issueIds)=>{
    const selectedIssueIds = $c785af315de8dae0$var$getSelectedIssueIdsSelector(state);
    return issueIds.length > 0 && issueIds.every((issueId)=>selectedIssueIds.includes(issueId));
};
const $c785af315de8dae0$export$949e47631f4a60a5 = (0, $3sQ5x.createStateHook)($c785af315de8dae0$var$Store, {
    selector: $c785af315de8dae0$var$getAreAllIssuesSelectedSelector
});

});
parcelRegister("es90k", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $75d6ff2ec2275c29$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "actions", () => $75d6ff2ec2275c29$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $75d6ff2ec2275c29$export$d4c72bab9d6cc13a = {
    selectedIssueIds: new Set([]),
    lastSelectedRowIndex: null
};
const $75d6ff2ec2275c29$export$e324594224ef24da = {
    insertSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            onIssueSelected?.(selectedIssueIds);
            setState({
                selectedIssueIds: new Set([
                    ...currentState.selectedIssueIds,
                    ...selectedIssueIds
                ])
            });
        },
    removeSelectedIssueIds: (selectedIssueIds)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            selectedIssueIds.forEach((selectedIssueId)=>{
                updatedSelectedIssueIds.delete(selectedIssueId);
            });
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    insertSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState }, { onIssueSelected: onIssueSelected })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.add(selectedIssueId);
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    removeSelectedIssueId: (selectedIssueId)=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const updatedSelectedIssueIds = new Set(currentState.selectedIssueIds);
            updatedSelectedIssueIds.delete(selectedIssueId);
            setState({
                selectedIssueIds: updatedSelectedIssueIds
            });
        },
    selectedOnlyIssueId: (selectedIssueId)=>({ setState: setState }, { onIssueSelected: onIssueSelected })=>{
            onIssueSelected?.([
                selectedIssueId
            ]);
            setState({
                selectedIssueIds: new Set([
                    selectedIssueId
                ])
            });
        },
    updateLastSelectedRowIndex: (lastSelectedRowIndex)=>({ setState: setState })=>{
            setState({
                lastSelectedRowIndex: lastSelectedRowIndex
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState($75d6ff2ec2275c29$export$d4c72bab9d6cc13a);
        },
    checkIssueRow: (issueId, isChecked, isShiftPressed, flatList)=>({ dispatch: dispatch, getState: getState })=>{
            const selectedIssueIds = [
                issueId
            ];
            const currentState = getState();
            const currentCheckedIndex = flatList.findIndex((id)=>id === issueId);
            if (isShiftPressed && currentState.lastSelectedRowIndex !== null) {
                const start = Math.min(currentState.lastSelectedRowIndex, currentCheckedIndex);
                const end = Math.max(currentState.lastSelectedRowIndex, currentCheckedIndex);
                selectedIssueIds.push(...flatList.slice(start, end + 1).filter((id)=>id !== issueId));
            }
            dispatch($75d6ff2ec2275c29$export$e324594224ef24da.updateLastSelectedRowIndex(currentCheckedIndex));
            if (isChecked) dispatch($75d6ff2ec2275c29$export$e324594224ef24da.insertSelectedIssueIds(selectedIssueIds));
            else dispatch($75d6ff2ec2275c29$export$e324594224ef24da.removeSelectedIssueIds(selectedIssueIds));
        }
};

});


parcelRegister("f7PHy", function(module, exports) {

$parcel$export(module.exports, "HierarchyOnboardingProvider", () => $2c829909fdbc1ce5$export$61ea399940cf79d6);
$parcel$export(module.exports, "useHierarchyOnboardingContext", () => $2c829909fdbc1ce5$export$34916c588fba606d);
$parcel$export(module.exports, "HierarchyOnboarding", () => $2c829909fdbc1ce5$export$19eb9bdb0cf578f5);
$parcel$export(module.exports, "HierarchyToggleOnboarding", () => $2c829909fdbc1ce5$export$e350c43a524c2f15);

var $5uXOq = parcelRequire("5uXOq");

var $kbqIt = parcelRequire("kbqIt");

var $1QiBP = parcelRequire("1QiBP");

var $ioD1B = parcelRequire("ioD1B");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $6s1PB = parcelRequire("6s1PB");

var $jA4v5 = parcelRequire("jA4v5");
const $2c829909fdbc1ce5$export$2d29273a16589c02 = 'jira-nin-hierarchy-onboarding-stg';
const $2c829909fdbc1ce5$export$e7deeb52c7c3e7a9 = 'jira-list-nin-hierarchy-onboarding';
const $2c829909fdbc1ce5$var$ENV_STAGING = 'staging';
const $2c829909fdbc1ce5$var$STARGATE_URL = '/gateway/api';
const $2c829909fdbc1ce5$var$HierarchyOnboardingContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $2c829909fdbc1ce5$export$61ea399940cf79d6 = ({ children: children })=>{
    const [showToggleOnboarding, setShowToggleOnboarding] = (0, $5uXOq.useState)(false);
    const value = (0, $5uXOq.useMemo)(()=>({
            showToggleOnboarding: showToggleOnboarding,
            setShowToggleOnboarding: setShowToggleOnboarding
        }), [
        showToggleOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2c829909fdbc1ce5$var$HierarchyOnboardingContext.Provider, {
        value: value
    }, children);
};
const $2c829909fdbc1ce5$export$34916c588fba606d = ()=>{
    const hierarchyContext = (0, $5uXOq.useContext)($2c829909fdbc1ce5$var$HierarchyOnboardingContext);
    if (!hierarchyContext) throw new Error('useHierarchyOnboardingContext must be used within a HierarchyOnboardingProvider');
    return hierarchyContext;
};
const $2c829909fdbc1ce5$export$19eb9bdb0cf578f5 = ()=>{
    const ONBOARDING_ENGAGEMENT_ID = (0, $2tT7R.useEnvironment)() === $2c829909fdbc1ce5$var$ENV_STAGING ? $2c829909fdbc1ce5$export$2d29273a16589c02 : $2c829909fdbc1ce5$export$e7deeb52c7c3e7a9;
    const { setShowToggleOnboarding: setShowToggleOnboarding } = $2c829909fdbc1ce5$export$34916c588fba606d();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    /**
   * Onboarding Experience is loaded manually on page load via EP's CoordinationClient class
   * Once loaded, if the message is active for this particular context, only then the HIERARCHY_ONBOARDING will be loaded and displayed
   */ const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, $2c829909fdbc1ce5$var$STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(false);
    const [isEnrolled, stopEnrolment] = (0, $kbqIt.useCoordination)(coordinationClient, ONBOARDING_ENGAGEMENT_ID);
    (0, $5uXOq.useEffect)(()=>{
        if (isEnrolled) {
            stopEnrolment(false);
            setIsSpotlightActive(true);
        }
    }, [
        isEnrolled,
        stopEnrolment
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isEnrolled && isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        messageId: "issue-table-hierarchy.ui.hierarchy-onboarding.jira-spotlight.expand-column-header",
        messageType: "engagement",
        actionsBeforeElement: "1/2",
        actions: [
            {
                onClick: ()=>{
                    setIsSpotlightActive(false);
                    setShowToggleOnboarding(true);
                },
                text: formatMessage((0, $jA4v5.default).next)
            },
            {
                appearance: 'subtle',
                onClick: ()=>setIsSpotlightActive(false),
                text: formatMessage((0, $jA4v5.default).dismiss)
            }
        ],
        dialogWidth: 320,
        heading: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jA4v5.default).onboardingHeadingIssueTermRefresh : (0, $jA4v5.default).onboardingHeading),
        target: "expand-column-header",
        key: "expand-column-header",
        targetRadius: 3
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jA4v5.default).onboardingDescriptionIssueTermRefresh : (0, $jA4v5.default).onboardingDescription))));
};
const $2c829909fdbc1ce5$export$e350c43a524c2f15 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showToggleOnboarding: showToggleOnboarding, setShowToggleOnboarding: setShowToggleOnboarding } = $2c829909fdbc1ce5$export$34916c588fba606d();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $5uXOq.useState)(true);
    if (!isSpotlightActive || !showToggleOnboarding) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        messageId: "issue-table-hierarchy.ui.hierarchy-onboarding.jira-spotlight.hierarchy-feature-toggle",
        messageType: "engagement",
        actionsBeforeElement: "2/2",
        actions: [
            {
                onClick: ()=>{
                    setShowToggleOnboarding(false);
                    setIsSpotlightActive(false);
                },
                text: formatMessage((0, $jA4v5.default).ok)
            }
        ],
        dialogWidth: 320,
        target: "hierarchy-feature-toggle",
        key: "hierarchy-feature-toggle",
        targetRadius: 3
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jA4v5.default).toggleOnboardingIssueTermRefresh : (0, $jA4v5.default).toggleOnboarding)));
};

});
parcelRegister("jA4v5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac913e97fbfbe408$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ac913e97fbfbe408$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    onboardingHeading: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading",
        "defaultMessage": "View issue hierarchy"
    },
    onboardingHeadingIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-heading-issue-term-refresh",
        "defaultMessage": "View hierarchy"
    },
    onboardingDescription: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description",
        "defaultMessage": "Collapse or expand the hierarchy to see parent and child issues."
    },
    onboardingDescriptionIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.onboarding-description-issue-term-refresh",
        "defaultMessage": "Collapse or expand the hierarchy to see parent and child work items."
    },
    next: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.next",
        "defaultMessage": "Next"
    },
    toggleOnboarding: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding",
        "defaultMessage": "Use the toggle to show or hide the issue hierarchy."
    },
    toggleOnboardingIssueTermRefresh: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.rules-order-onboarding-issue-term-refresh",
        "defaultMessage": "Use the toggle to show or hide the hierarchy."
    },
    ok: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.done",
        "defaultMessage": "Ok"
    },
    dismiss: {
        "id": "business-conditional-formatting-sidebar.format-rules-sidebar.sidebar.onboarding.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("5d1oN", function(module, exports) {

$parcel$export(module.exports, "SidebarLayout", () => $f718399f9a5c6176$export$8295a33ab8a36876);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");

var $evhhl = parcelRequire("evhhl");

var $7CMCs = parcelRequire("7CMCs");

var $f98ZZ = parcelRequire("f98ZZ");

const $f718399f9a5c6176$export$8295a33ab8a36876 = ({ children: children, content: content, teamName: teamName, defaultRatio: defaultRatio, minWidth: minWidth, minRatio: minRatio, maxRatio: maxRatio })=>{
    const [{ id: id }, { closeSidebar: closeSidebar }] = (0, $f98ZZ.useSidebar)();
    // reset sidebar content on view unmount
    (0, $5uXOq.useEffect)(()=>()=>{
            closeSidebar();
        }, [
        closeSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        testId: "platform-sidebar.ui.sidebar-layout",
        xcss: $f718399f9a5c6176$var$styles.wrapper,
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $f718399f9a5c6176$var$styles.childContentContainer
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "sidebarWrapper",
        packageName: (0, $82deb0810ac24613$export$b8b9d90f9e5bd72b),
        teamName: teamName,
        fallback: "flag",
        attributes: {
            sidebarExperienceId: id
        }
    }, id ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $evhhl.default), {
        defaultRatio: defaultRatio,
        minWidth: minWidth,
        minRatio: minRatio,
        maxRatio: maxRatio
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ...props,
            className: (0, $bwpsq.default)([
                $f718399f9a5c6176$var$styles.sidebarContentContainer
            ])
        }, content)) : null));
};
const $f718399f9a5c6176$var$styles = {
    wrapper: "_4t3i1osq _18m91wug",
    sidebarContentContainer: "_16qs1cd0 _18u0xmi2",
    childContentContainer: "_16jlkb7n _1o9zkb7n _i0dlidpf _18m91wug"
};

});
parcelRegister("evhhl", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed706472ac6afb2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "resizerStyleOverrides", () => $fed706472ac6afb2$export$70af81d424c0709);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eygxC = parcelRequire("eygxC");

var $jgytl = parcelRequire("jgytl");

var $f65qx = parcelRequire("f65qx");
var $fed706472ac6afb2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { children: children, ...resizerProps } = props;
    const { minRatio: minRatio = 0, maxRatio: maxRatio = 1, minWidth: minWidth, maxWidth: maxWidth, initialRatio: initialRatio, defaultRatio: defaultRatio, extraWidth: extraWidth, position: position = 'left', resizeHandleAsOverlay: resizeHandleAsOverlay, collapsed: collapsed, additionalStyles: additionalStyles } = resizerProps;
    // Ensure the ratio which is initially set to the flex-basis style is bounded between the min/max ratios
    // The css properties handles max-width and min-width
    const ratio = (0, $5uXOq.useRef)((0, $jgytl.clampValue)({
        value: initialRatio ?? defaultRatio,
        minValue: minRatio,
        maxValue: maxRatio
    }));
    /** If resizer is expanded and the ratio is 0, set the ratio to the initial ratio.
   *  This logic would need to change if we allow users to "uncollapse" the resizer manually, because currently this code will reset the ratio to the initial ratio.
   */ if (!collapsed && ratio.current === 0) ratio.current = (0, $jgytl.clampValue)({
        value: initialRatio ?? defaultRatio,
        minValue: minRatio,
        maxValue: maxRatio
    });
    const container = (0, $5uXOq.useRef)(null);
    const renderHandle = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f65qx.default), {
            additionalStyles: additionalStyles,
            ...resizerProps,
            ...initialRatio !== undefined ? {
                initialRatio: ratio.current,
                defaultRatio: (0, $jgytl.clampValue)({
                    value: defaultRatio,
                    minValue: minRatio,
                    maxValue: maxRatio
                })
            } : {
                defaultRatio: ratio.current
            },
            childrenContainerRef: container
        });
    const renderResizer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, position === 'left' && renderHandle(), typeof children === 'function' ? children({
            ref: (r)=>{
                container.current = r;
            },
            style: (0, $jgytl.getChildrenStyle)(ratio.current, minWidth, maxWidth, extraWidth, collapsed)
        }) : children, position === 'right' && renderHandle());
    return resizeHandleAsOverlay ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fed706472ac6afb2$export$c7990a6594835e51, {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $jgytl.getChildrenStyle)(ratio.current, minWidth, maxWidth, extraWidth, collapsed),
        ref: container,
        "data-testid": "flex-resizer.ui.resize-wrapper"
    }, renderResizer()) : renderResizer();
});
const $fed706472ac6afb2$export$c7990a6594835e51 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c1txw _lcxv1wug _q0u0kb7n _2e98kb7n _12rof1ug",
            __cmplp.className
        ])
    });
});
const $fed706472ac6afb2$export$70af81d424c0709 = (0, $eygxC.resizerStyleOverrides);

});
parcelRegister("eygxC", function(module, exports) {

$parcel$export(module.exports, "resizerStyleOverrides", () => $361c03a737fc18e2$export$70af81d424c0709);
const $361c03a737fc18e2$export$70af81d424c0709 = {
    ISSUE_VIEW_MARGIN_OFFSET: 'issue-view-margin-offset'
};

});

parcelRegister("jgytl", function(module, exports) {

$parcel$export(module.exports, "RESIZE_HANDLE_WIDTH", () => $242c5845cb693839$export$45f504201feb6ea6);
$parcel$export(module.exports, "useAnimationFrameThrottle", () => $242c5845cb693839$export$9d3ed311e5db6a6f);
$parcel$export(module.exports, "useDoubleClick", () => $242c5845cb693839$export$b1d0a5c81935127f);
$parcel$export(module.exports, "clampValue", () => $242c5845cb693839$export$31ee16100cde6ce2);
$parcel$export(module.exports, "calculateNewRatio", () => $242c5845cb693839$export$58e1996e98bfba9e);
$parcel$export(module.exports, "getChildrenStyle", () => $242c5845cb693839$export$f2a5e228fabed40b);

var $5uXOq = parcelRequire("5uXOq");

var $gwIPs = parcelRequire("gwIPs");
const $242c5845cb693839$export$45f504201feb6ea6 = 3 * (0, $gwIPs.gridSize) + 2;
const $242c5845cb693839$export$9d3ed311e5db6a6f = (callback)=>{
    const token = (0, $5uXOq.useRef)(null);
    const lastArgs = (0, $5uXOq.useRef)(null);
    const hasTriggered = (0, $5uXOq.useRef)(false);
    const handleFrame = (0, $5uXOq.useCallback)(()=>{
        lastArgs.current = null;
        hasTriggered.current = false;
    }, []);
    const throttle = (0, $5uXOq.useCallback)((...args)=>{
        lastArgs.current = args;
        if (hasTriggered.current) return;
        callback(...args);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        token.current = window.requestAnimationFrame(handleFrame);
        hasTriggered.current = true;
    }, [
        handleFrame,
        callback
    ]);
    const cancel = (0, $5uXOq.useCallback)(()=>{
        if (token.current) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.cancelAnimationFrame(token.current);
        if (!hasTriggered.current && lastArgs.current !== null) callback(...lastArgs.current);
        token.current = null;
        lastArgs.current = null;
        hasTriggered.current = false;
    }, [
        callback
    ]);
    (0, $5uXOq.useEffect)(()=>()=>cancel(), [
        callback,
        cancel
    ]);
    return [
        throttle,
        cancel
    ];
};
const $242c5845cb693839$export$b1d0a5c81935127f = (callback)=>{
    const lastClickTime = (0, $5uXOq.useRef)(0);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const now = Date.now();
        if (now - lastClickTime.current < 500) {
            lastClickTime.current = 0;
            callback();
            return true;
        }
        lastClickTime.current = now;
        return false;
    }, [
        callback
    ]);
    return handleClick;
};
const $242c5845cb693839$export$29ae71364f84a225 = (element)=>{
    const style = getComputedStyle(element);
    const paddingX = parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    return paddingX;
};
const $242c5845cb693839$export$31ee16100cde6ce2 = ({ value: value, minValue: minValue, maxValue: maxValue })=>Math.min(Math.max(value, minValue), maxValue);
const $242c5845cb693839$export$58e1996e98bfba9e = ({ parentWidth: parentWidth, currentWidth: currentWidth, deltaX: deltaX, minWidth: minWidth, minRatio: minRatio, maxWidth: maxWidth, maxRatio: maxRatio, baseWidth: baseWidth, position: position })=>{
    const targetWidth = Math.min(Math.max(currentWidth - baseWidth + (position === 'left' ? deltaX : deltaX * -1), minWidth), maxWidth);
    return $242c5845cb693839$export$31ee16100cde6ce2({
        value: targetWidth / parentWidth,
        minValue: minRatio,
        maxValue: maxRatio
    });
};
const $242c5845cb693839$export$f2a5e228fabed40b = (ratio, minWidth, maxWidth, extraWidth = 0, collapsed = false)=>({
        boxSizing: 'border-box',
        flexGrow: 0,
        flexShrink: 1,
        flexBasis: (()=>{
            if (collapsed) return '0%';
            return extraWidth > 0 ? `calc(${ratio * 100}% + ${extraWidth}px)` : `${ratio * 100}%`;
        })(),
        minWidth: (()=>{
            if (collapsed) return 0;
            return minWidth !== undefined ? minWidth : null;
        })(),
        maxWidth: (()=>{
            if (collapsed) return 0;
            return maxWidth !== undefined ? maxWidth : null;
        })()
    });

});

parcelRegister("f65qx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e21000af4826614$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $cay7e = parcelRequire("cay7e");

var $dOj0C = parcelRequire("dOj0C");
var $6e21000af4826614$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.issue.view.resizer",
        packageName: "async.issue.view.resizer",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOj0C.ResizeHandle), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cay7e.default), props)));

});
parcelRegister("cay7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e1b555b6155529f$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $22Gxp = parcelRequire("22Gxp");

var $3uzfU = parcelRequire("3uzfU");

var $48WUR = parcelRequire("48WUR");

var $3bDjY = parcelRequire("3bDjY");

var $jldZL = parcelRequire("jldZL");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $1XJ20 = parcelRequire("1XJ20");

var $jgytl = parcelRequire("jgytl");

var $gxE4O = parcelRequire("gxE4O");

var $aydCa = parcelRequire("aydCa");

var $2rgs5 = parcelRequire("2rgs5");

var $dOj0C = parcelRequire("dOj0C");
const $8e1b555b6155529f$var$RESIZE_ICON_TEST_ID = 'flex-resizer.ui.handle.resize-icon';
const $8e1b555b6155529f$var$RESIZE_CHEVRON_ICON = 'flex-resizer.ui.handle.chevron-';
const $8e1b555b6155529f$var$resizeCursorCollapsed = null;
const $8e1b555b6155529f$var$resizeCursor = null;
const $8e1b555b6155529f$var$grabAreaStyles = {
    root: "_1bsbo7ao _4t3i1osq _kqswstnw _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _syaz3acm _bfhk18uv _k8m01ylx _1oec1yx9 _1lww5cps _vp7g1p6i _30l31p6i _1dr21ylx _1s5z1ylx _1cg4fnf5 _le1bfnf5 _1gglglyw _9h8h1p6i"
};
const $8e1b555b6155529f$var$lineStyles = {
    root: "_kqswstnw _1e0c1ule _1bsbyh40 _4t3i1osq _syaz1kw7 _bfhk1r31 _1e02cy7w"
};
const $8e1b555b6155529f$var$TooltipWrapper = ({ toolTipContent: toolTipContent, children: children })=>{
    if (toolTipContent !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: toolTipContent,
        hideTooltipOnClick: true
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $8e1b555b6155529f$var$Resizer = ({ childrenContainerRef: childrenContainerRef, initialRatio: initialRatio, defaultRatio: defaultRatio, minWidth: minWidth, minRatio: minRatio = 0, maxWidth: maxWidth, maxRatio: maxRatio = 1, extraWidth: extraWidth = 0, position: position = 'left', resizeHandleAsOverlay: resizeHandleAsOverlay, resizeHandleZIndex: resizeHandleZIndex, onRatioChange: onRatioChange, onRatioReset: onRatioReset, onResizeStart: onResizeStart, chevronDirection: chevronDirection, persistResizeIcon: persistResizeIcon, onResizeHandleClick: onResizeHandleClick, collapsed: collapsed, minWidthLeftContainer: minWidthLeftContainer, minWidthRightContainer: minWidthRightContainer, toolTipContent: toolTipContent, additionalStyles: additionalStyles })=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startWidth = (0, $5uXOq.useRef)(0);
    const parentWidth = (0, $5uXOq.useRef)(0);
    const onResizeStartStableRef = (0, $5uXOq.useRef)(onResizeStart);
    const onResizeEndStableRef = (0, $5uXOq.useRef)(onRatioChange);
    const [rangeInputValue, setRangeInputValue] = (0, $5uXOq.useState)(maxRatio - (initialRatio ?? defaultRatio));
    const [inputRange, setInputRange] = (0, $5uXOq.useState)({
        min: 0,
        max: 1
    }); /*
           onRatioChange calls setFlexBasisProp from the parent component. Even if the slider value changes to 0 there are
        chances the line splitter can min go upto 0.2. If, user performs keyboard navigation the user will not see any movement
        if the value was 0 unless it reaches to 0.2 lets say
      	  To avoid this, lineSplitterRef.current.getBoundingClientRect -> returns width giving the exact position of the line and we
        can thus update the ratio which we are doing on handleSliderFocus
      */ 
    const lineSplitterRef = (0, $5uXOq.useRef)(null);
    const [keyboardResizeManager] = (0, $5uXOq.useState)(()=>(0, $2rgs5.createKeyboardResizeManager)({
            onResizeStart: ()=>onResizeStartStableRef.current?.(),
            onResizeEnd: (...args)=>{
                return onResizeEndStableRef.current?.(...args);
            }
        }));
    const prevChevronDirection = (0, $1XJ20.usePreviousWithInitial)(chevronDirection);
    const nextRatio = (0, $5uXOq.useRef)(initialRatio ?? defaultRatio);
    const styleElement = (0, $5uXOq.useRef)(null);
    const labelId = (0, $22Gxp.useUID)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        /*
    initialRatio is 0 means Panel splitter is completely closed
          When it is collapsed and initialRatio is 0, next time when we expand,
    range should take defaultRatio
           Else
           If initialRatio is > 0, when we collapse the panel and expand, range should take initialRatio.
          */ if (collapsed && (0, $4R6GH.fg)('jira_a11y_pannel_splitter_navigations')) setRangeInputValue(maxRatio - (initialRatio && initialRatio !== 0 ? initialRatio : defaultRatio));
    }, [
        collapsed,
        initialRatio,
        defaultRatio,
        maxRatio
    ]);
    const setFlexBasisProp = (0, $5uXOq.useCallback)((ratio, setNextRatio)=>{
        // This will force-fix any in consistencies in the ratio value if ratio is set from parent components
        if (setNextRatio !== undefined) nextRatio.current = setNextRatio;
        if (childrenContainerRef.current) childrenContainerRef.current.style.setProperty('flex-basis', extraWidth > 0 ? `calc(${ratio * 100}% + ${extraWidth}px)` : `${ratio * 100}%`);
    }, [
        childrenContainerRef,
        extraWidth
    ]);
    const resetDetector = (0, $jgytl.useDoubleClick)((0, $5uXOq.useCallback)(()=>{
        const targetRatio = (0, $jgytl.clampValue)({
            value: defaultRatio * parentWidth.current,
            minValue: Math.max(minWidth ?? 0, minRatio * parentWidth.current),
            maxValue: Math.min(maxWidth ?? Infinity, maxRatio * parentWidth.current)
        }) / parentWidth.current;
        nextRatio.current = targetRatio;
        setFlexBasisProp(targetRatio);
        onRatioReset?.(targetRatio);
    }, [
        defaultRatio,
        minWidth,
        minRatio,
        maxWidth,
        maxRatio,
        setFlexBasisProp,
        onRatioReset
    ]));
    const [onPointerMoveThrottled, cancelPointerMove] = (0, $jgytl.useAnimationFrameThrottle)((0, $5uXOq.useCallback)((e)=>{
        const r = (0, $jgytl.calculateNewRatio)({
            parentWidth: parentWidth.current,
            currentWidth: startWidth.current,
            deltaX: startX.current - e.pageX,
            minWidth: minWidth ?? 0,
            minRatio: minRatio,
            maxWidth: maxWidth ?? Infinity,
            maxRatio: maxRatio,
            baseWidth: extraWidth,
            position: position
        });
        nextRatio.current = r;
        setFlexBasisProp(r);
    }, [
        extraWidth,
        maxRatio,
        maxWidth,
        minRatio,
        minWidth,
        position,
        setFlexBasisProp
    ]));
    const onPointerMove = (0, $5uXOq.useCallback)((e)=>{
        e.preventDefault();
        onPointerMoveThrottled(e);
    }, [
        onPointerMoveThrottled
    ]);
    const onPointerUp = (0, $5uXOq.useCallback)(()=>{
        const r = nextRatio.current;
        const resetTriggered = resetDetector();
        if (!resetTriggered) onRatioChange?.(r, nextRatio.current * parentWidth.current, setFlexBasisProp);
         // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('pointermove', onPointerMove, {
            capture: true
        }); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('pointerup', onPointerUp, {
            capture: true
        });
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            stylesheet.deleteRule(1);
            stylesheet.deleteRule(0);
        }
        cancelPointerMove();
        if ((0, $4R6GH.fg)('jira_a11y_pannel_splitter_navigations')) setRangeInputValue(maxRatio - r);
    }, [
        cancelPointerMove,
        onPointerMove,
        onRatioChange,
        resetDetector,
        setFlexBasisProp,
        maxRatio
    ]);
    const onPointerDown = (0, $5uXOq.useCallback)((e)=>{
        // Check if the chevron icon was clicked and prevent dragging
        if (onResizeHandleClick && e.target instanceof HTMLElement) {
            const target = (e.target.getAttribute('data-testid') || '').indexOf($8e1b555b6155529f$var$RESIZE_CHEVRON_ICON) > -1 ? 'chevron' : 'resizer';
            if (!onResizeHandleClick?.(target, setFlexBasisProp, e)) {
                e.preventDefault();
                return;
            }
        } // Prevent resize when the resizer is collapsed
        if (collapsed) return; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('pointermove', onPointerMove, {
            capture: true
        }); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('pointerup', onPointerUp, {
            capture: true
        });
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            // There is a chromium bug which forces all scrollbars to be visible when 'pointer-events: none' is added.
            // Chromium bug: https://bugs.chromium.org/p/chromium/issues/detail?id=1280013&q=pointer-events%20scrollbar&can=2
            // The previously implemented workarounds for this issue didn't solve all use cases, i.e., horizontal scrollbars,
            // thus, 'user-select: none' is used to prevent text-highlighting but allows hover events, unlike 'pointer-events'.
            stylesheet.insertRule('body { user-select: none; }', 0); // Set the dragging cursor (higher than disabled pointer events)
            stylesheet.insertRule('#jira { cursor: ew-resize; }', 1);
        }
        const currentContainer = childrenContainerRef.current;
        const parentContainer = currentContainer?.parentElement;
        if (!currentContainer || !parentContainer) return;
        startWidth.current = currentContainer.getBoundingClientRect().width;
        parentWidth.current = parentContainer.getBoundingClientRect().width ?? 0;
        onResizeStart?.();
        startX.current = e.pageX; // This is preventing popups from closing when the resize handle is dragged
        if (!onResizeHandleClick) e.preventDefault();
    }, [
        onPointerMove,
        onPointerUp,
        childrenContainerRef,
        onResizeStart,
        onResizeHandleClick,
        collapsed,
        setFlexBasisProp
    ]);
    const handleSliderFocus = (0, $5uXOq.useCallback)(()=>{
        const stylesheet = styleElement.current?.sheet;
        if (stylesheet) {
            // There is a chromium bug which forces all scrollbars to be visible when 'pointer-events: none' is added.
            // Chromium bug: https://bugs.chromium.org/p/chromium/issues/detail?id=1280013&q=pointer-events%20scrollbar&can=2
            // The previously implemented workarounds for this issue didn't solve all use cases, i.e., horizontal scrollbars,
            // thus, 'user-select: none' is used to prevent text-highlighting but allows hover events, unlike 'pointer-events'.
            stylesheet.insertRule('body { user-select: none; }', 0); // Set the dragging cursor (higher than disabled pointer events)
            stylesheet.insertRule('#jira { cursor: ew-resize; }', 1);
        }
        const currentContainer = childrenContainerRef.current;
        const parentContainer = currentContainer?.parentElement;
        if (!currentContainer || !parentContainer) return;
        startWidth.current = currentContainer.getBoundingClientRect().width;
        parentWidth.current = parentContainer.getBoundingClientRect().width ?? 0; /*
                                                                                    calculate the range only when the user actually wants navigate via
                                                                                    keyboard and save the computation at initial render
                                                                                    */ 
        setInputRange((prev)=>({
                ...prev,
                min: minWidthLeftContainer ? minWidthLeftContainer / parentWidth.current : minRatio,
                max: minWidthRightContainer ? maxRatio - minWidthRightContainer / parentWidth.current : maxRatio
            }));
        onResizeStart?.();
    }, [
        onResizeStart,
        childrenContainerRef,
        maxRatio,
        minRatio,
        minWidthLeftContainer,
        minWidthRightContainer
    ]);
    const handleSliderInputChange = (0, $5uXOq.useCallback)((e)=>{
        const value = parseFloat(e.target.value);
        setRangeInputValue(value); // doing this maxRatio - value because current drag has left as 100% and right as 0% alternative to input range
        nextRatio.current = maxRatio - value;
        setFlexBasisProp(maxRatio - value);
        keyboardResizeManager.onResize({
            ratio: maxRatio - value,
            width: (maxRatio - value) * parentWidth.current,
            flexBasis: setFlexBasisProp
        });
    }, [
        setFlexBasisProp,
        maxRatio,
        keyboardResizeManager
    ]);
    const ariaValueText = (0, $5uXOq.useMemo)(()=>`${(0, $aydCa.getPercentageWithinPixelBounds)({
            currentWidth: collapsed ? maxRatio : rangeInputValue,
            minRatio: minRatio,
            maxRatio: maxRatio
        })}% width`, [
        rangeInputValue,
        minRatio,
        maxRatio,
        collapsed
    ]);
    const ResizeBar = (0, $5uXOq.useCallback)(()=>{
        const directionDidChange = chevronDirection !== prevChevronDirection;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOj0C.ResizeHandle), {
            tabIndex: 0,
            role: "separator",
            "aria-orientation": "vertical",
            "data-testid": "flex-resizer.ui.handle.resizer",
            onPointerDown: onPointerDown,
            position: position,
            resizeHandleZIndex: resizeHandleZIndex,
            resizeHandleAsOverlay: resizeHandleAsOverlay,
            "aria-valuenow": Math.floor(nextRatio.current * 100),
            collapsed: collapsed,
            customStyles: additionalStyles?.resizeHandleStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOj0C.ResizeBorder), {
            triggerAnimation: directionDidChange,
            collapsed: collapsed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e1b555b6155529f$var$TooltipWrapper, {
            toolTipContent: toolTipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOj0C.ResizeIcon), {
            triggerAnimation: directionDidChange,
            "data-testid": $8e1b555b6155529f$var$RESIZE_ICON_TEST_ID,
            persistResizeIcon: persistResizeIcon,
            onResizeHandleClick: onResizeHandleClick
        }, chevronDirection === 'LEFT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($48WUR))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            testId: `${$8e1b555b6155529f$var$RESIZE_CHEVRON_ICON}left`,
            size: "small"
        }), chevronDirection === 'RIGHT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            testId: `${$8e1b555b6155529f$var$RESIZE_CHEVRON_ICON}right`,
            size: "small"
        })))));
    }, [
        onPointerDown,
        position,
        resizeHandleZIndex,
        resizeHandleAsOverlay,
        collapsed,
        chevronDirection,
        prevChevronDirection,
        persistResizeIcon,
        onResizeHandleClick,
        toolTipContent,
        additionalStyles
    ]);
    const renderKeyboardNavigation = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: lineSplitterRef,
            className: (0, $bwpsq.default)([
                $8e1b555b6155529f$var$grabAreaStyles.root,
                collapsed ? "_1gavfnf5" : "_d0aluf7j _1gavfnf5"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
            id: labelId,
            type: "range",
            value: rangeInputValue,
            step: "0.01",
            min: inputRange.min,
            max: inputRange.max,
            "aria-valuetext": ariaValueText,
            onChange: handleSliderInputChange,
            onFocus: handleSliderFocus
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
            htmlFor: labelId
        }, formatMessage((0, $gxE4O.default).resizer))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, $bwpsq.default)([
                $8e1b555b6155529f$var$lineStyles.root
            ])
        }));
    }, [
        ariaValueText,
        formatMessage,
        handleSliderFocus,
        handleSliderInputChange,
        labelId,
        rangeInputValue,
        inputRange.max,
        inputRange.min,
        collapsed
    ]);
    const renderResizeBar = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOj0C.ResizeHandle), {
            "data-testid": "flex-resizer.ui.handle.resizer",
            onPointerDown: onPointerDown,
            position: position,
            resizeHandleZIndex: resizeHandleZIndex,
            resizeHandleAsOverlay: resizeHandleAsOverlay,
            collapsed: collapsed,
            customStyles: additionalStyles?.resizeHandleStyles
        }, renderKeyboardNavigation(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOj0C.ResizeBorder), {
            triggerAnimation: chevronDirection !== prevChevronDirection,
            collapsed: collapsed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e1b555b6155529f$var$TooltipWrapper, {
            toolTipContent: toolTipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dOj0C.ResizeIcon), {
            triggerAnimation: chevronDirection !== prevChevronDirection,
            "data-testid": $8e1b555b6155529f$var$RESIZE_ICON_TEST_ID,
            persistResizeIcon: persistResizeIcon,
            onResizeHandleClick: onResizeHandleClick
        }, chevronDirection === 'LEFT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($48WUR))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            testId: `${$8e1b555b6155529f$var$RESIZE_CHEVRON_ICON}left`,
            size: "small"
        }), chevronDirection === 'RIGHT' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3uzfU))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: "",
            testId: `${$8e1b555b6155529f$var$RESIZE_CHEVRON_ICON}right`,
            size: "small"
        })))));
    }, [
        onPointerDown,
        position,
        resizeHandleZIndex,
        resizeHandleAsOverlay,
        persistResizeIcon,
        onResizeHandleClick,
        collapsed,
        renderKeyboardNavigation,
        chevronDirection,
        prevChevronDirection,
        toolTipContent,
        additionalStyles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $4R6GH.fg)('jira_a11y_pannel_splitter_navigations') ? renderResizeBar() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ResizeBar, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        ref: styleElement
    }));
};
var $8e1b555b6155529f$export$2e2bcd8739ae039 = $8e1b555b6155529f$var$Resizer;

});
parcelRegister("48WUR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e11ccb97e0d586e61a9d73f9190646>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $30459c48f41f9156$var$_react = $30459c48f41f9156$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $30459c48f41f9156$var$_chevronLeft = $30459c48f41f9156$var$_interopRequireDefault((parcelRequire("ks8FD")));

var $30459c48f41f9156$var$_chevronLeft2 = $30459c48f41f9156$var$_interopRequireDefault((parcelRequire("nHhrH")));
function $30459c48f41f9156$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $30459c48f41f9156$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $30459c48f41f9156$var$_react.default.createElement($30459c48f41f9156$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $30459c48f41f9156$var$_chevronLeft2.default
    }, props));
$30459c48f41f9156$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $30459c48f41f9156$var$_default = module.exports.default = $30459c48f41f9156$var$ChevronLeftIcon;

});
parcelRegister("ks8FD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4b851fec559156e1edca3c5f214f4a7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee3d25fb52825f26$var$_react = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ee3d25fb52825f26$var$_baseNew = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ee3d25fb52825f26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee3d25fb52825f26$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $ee3d25fb52825f26$var$_react.default.createElement($ee3d25fb52825f26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$ee3d25fb52825f26$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $ee3d25fb52825f26$var$_default = module.exports.default = $ee3d25fb52825f26$var$ChevronLeftIcon;

});

parcelRegister("nHhrH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0473b8ae11c957a6$var$_react = $0473b8ae11c957a6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $0473b8ae11c957a6$var$_chevronLeft = $0473b8ae11c957a6$var$_interopRequireDefault((parcelRequire("ks8FD")));
function $0473b8ae11c957a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0473b8ae11c957a6$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $0473b8ae11c957a6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $0473b8ae11c957a6$var$_chevronLeft.default
    }));
$0473b8ae11c957a6$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $0473b8ae11c957a6$var$_default = module.exports.default = $0473b8ae11c957a6$var$ChevronLeftIcon;

});


parcelRegister("gxE4O", function(module, exports) {

$parcel$export(module.exports, "default", () => $f78ef77eaa788dc2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f78ef77eaa788dc2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    resizer: {
        "id": "flex-resizer.handle.resizer",
        "defaultMessage": "Resize issue view side panel"
    }
});

});

parcelRegister("aydCa", function(module, exports) {

$parcel$export(module.exports, "getPercentageWithinPixelBounds", () => $b44a35b1fb9125cb$export$b5423678cdf09f5);
function $b44a35b1fb9125cb$export$b5423678cdf09f5({ currentWidth: currentWidth, minRatio: minRatio, maxRatio: maxRatio }) {
    const resizeRange = maxRatio - minRatio;
    const widthAsPercentage = (currentWidth - minRatio) / resizeRange * 100;
    if (widthAsPercentage < 0) return 0;
    if (widthAsPercentage > 100) return 100;
    return Math.floor(widthAsPercentage);
}

});

parcelRegister("2rgs5", function(module, exports) {

$parcel$export(module.exports, "createKeyboardResizeManager", () => $0375140776397e94$export$f7d3d5dae65f74aa);
/**
 * The debounce time for the PanelSplitter resize callback functions.
 *
 * - For `onResizeStart`, it will call the callback immediately, but not
 * again until the user stops resizing and this wait time has passed.
 * - For `onResizeEnd`, it will call the callback only after this time has
 * passed since the last resize event.
 */ const $0375140776397e94$var$resizeCallbackDebounceTimeMs = 500;
function $0375140776397e94$export$f7d3d5dae65f74aa({ onResizeStart: onResizeStart, onResizeEnd: onResizeEnd }) {
    let resizingState = {
        type: 'idle'
    };
    /**
	 * Starts a timer to reset the state to idle and call `onResizeEnd` after a wait time.
	 */ function startResizeEndTimer({ ratio: ratio, width: width, flexBasis: flexBasis }) {
        const markResizeAsEndedTimeout = setTimeout(()=>{
            onResizeEnd?.(ratio, width, flexBasis);
            resizingState = {
                type: 'idle'
            };
        }, $0375140776397e94$var$resizeCallbackDebounceTimeMs);
        resizingState = {
            type: 'resizing',
            initialWidth: width,
            abort () {
                clearTimeout(markResizeAsEndedTimeout);
            }
        };
    }
    function onResize({ ratio: ratio, width: width, flexBasis: flexBasis }) {
        if (resizingState.type === 'idle') {
            // If the state was idle, this counts as a resize start event.
            onResizeStart();
            startResizeEndTimer({
                ratio: ratio,
                width: width,
                flexBasis: flexBasis
            });
            return;
        }
        if (resizingState.type === 'resizing') {
            // If the state was already resizing, clear the existing timeout and start a new one.
            resizingState.abort();
            startResizeEndTimer({
                ratio: ratio,
                width: width,
                flexBasis: flexBasis
            });
        }
    }
    return {
        onResize: onResize
    };
}

});

parcelRegister("dOj0C", function(module, exports) {

$parcel$export(module.exports, "ResizeHandle", () => $d209db24df180fbf$export$33f2411a0ad35be7);
$parcel$export(module.exports, "ResizeIcon", () => $d209db24df180fbf$export$8a1e762806b47a07);
$parcel$export(module.exports, "ResizeBorder", () => $d209db24df180fbf$export$a6c16750034505be);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $eygxC = parcelRequire("eygxC");
const $d209db24df180fbf$var$resizeHandleSelectorName = 'jira-issue-view-common-component-resize-handle';
const $d209db24df180fbf$export$3cd44ff7e3089142 = `[data-component-selector="${$d209db24df180fbf$var$resizeHandleSelectorName}"]`;
const $d209db24df180fbf$var$marginOffset = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d209db24df180fbf$var$ResizeHandleComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { collapsed: collapsed, isOptimised: isOptimised, resizeHandleZIndex: resizeHandleZIndex, position: position, resizeHandleAsOverlay: resizeHandleAsOverlay, customStyles: customStyles, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_9xglw1": (0, $lD23V.default)(__cmplp.collapsed && __cmplp.isOptimised && "var(--ds-space-300, 24px)"),
            "--_1ravlqm": (0, $lD23V.default)(__cmplp.resizeHandleZIndex),
            "--_1o4cubd": (0, $lD23V.default)(__cmplp.position === 'left' ? 'translate3d(-50%, 0, 0)' : 'translate3d(50%, 0, 0)')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _1bsb1ejb _1wpz1fhb _1e0c1txw _1bah1h6o _2hwx1o7r _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.collapsed ? "_80omtlke" : "_80omuf7j",
            __cmplp.resizeHandleZIndex && "_1pby7mzf",
            __cmplp.position === 'left' ? "_1ltvidpf" : "_1xi2idpf",
            __cmplp.resizeHandleAsOverlay && "_154iidpf _kqswstnw _4t3i1osq _t9ec1jw3",
            __cmplp.isOptimised !== true && __cmplp.customStyles === (0, $eygxC.resizerStyleOverrides).ISSUE_VIEW_MARGIN_OFFSET && "_2hwx1ejb",
            __cmplp.className
        ])
    });
});
const $d209db24df180fbf$export$86f12edbaf8a60d3 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d209db24df180fbf$var$ResizeHandleComponent, {
        "data-component-selector": $d209db24df180fbf$var$resizeHandleSelectorName,
        isOptimised: true,
        ...props
    }));
const $d209db24df180fbf$export$be9da3111ad61150 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d209db24df180fbf$var$ResizeHandleComponent, {
        "data-component-selector": $d209db24df180fbf$var$resizeHandleSelectorName,
        isOptimised: false,
        ...props
    });
const $d209db24df180fbf$export$33f2411a0ad35be7 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('memo_resize_handle_in_issue_view_vc90_top_offender'), $d209db24df180fbf$export$86f12edbaf8a60d3, $d209db24df180fbf$export$be9da3111ad61150);
const $d209db24df180fbf$var$appearAnimationBorder = null;
const $d209db24df180fbf$var$appearAnimationIcon = null;
const $d209db24df180fbf$var$ResizeIconBaseStyles = null;
const $d209db24df180fbf$var$ResizeIconRefreshStyles = null;
const $d209db24df180fbf$var$PointerStyle = null;
const $d209db24df180fbf$var$OpacityStyle1 = null;
const $d209db24df180fbf$var$OpacityStyle0 = null;
const $d209db24df180fbf$var$AnimationDuration1S = null;
const $d209db24df180fbf$var$AnimationDuration0S = null;
const $d209db24df180fbf$var$ResizeIconCompiled = ({ isRefreshVariant: isRefreshVariant = false, triggerAnimation: triggerAnimation, persistResizeIcon: persistResizeIcon, children: children, onResizeHandleClick: onResizeHandleClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_2rko1ssb _kqswstnw _154ixy5q _4t3i1tcg _1bsb1tcg _1ltvxmi2 _16qs1cd0 _j7hq1s2f _1pgl1ytf _bfhkvuon _irr3108i",
            isRefreshVariant && "_1e0c1txw _4cvr1h6o _1bah1h6o",
            triggerAnimation && "_5sag9cwz",
            !triggerAnimation && "_5sagru3m",
            persistResizeIcon && "_tzy4kb7n",
            !persistResizeIcon && "_tzy4idpf",
            !!onResizeHandleClick && "_80omtlke"
        ])
    }, children);
};
const $d209db24df180fbf$export$8a1e762806b47a07 = (0, $7XYc4.componentWithCondition)(()=>(0, $dCm1o.isVisualRefreshEnabled)(), (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d209db24df180fbf$var$ResizeIconCompiled, {
        isRefreshVariant: true,
        ...props
    }), $d209db24df180fbf$var$ResizeIconCompiled);
const $d209db24df180fbf$export$a6c16750034505be = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { triggerAnimation: triggerAnimation, collapsed: collapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v56419xe _1bsbyh40 _1wpz1fhb _j7hq1f9b _1pgl1ytf _kqswh2mm _17cdkb7n _vhr0kb7n _1sankb7n _lew41p6i _1ld91p6i _18fi1p6i",
            __cmplp.triggerAnimation ? "_5sag9cwz" : "_5sagru3m",
            __cmplp.collapsed ? "_bfhkmuej" : "_bfhk1p6i",
            __cmplp.collapsed ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});





parcelRegister("bbbXL", function(module, exports) {

$parcel$export(module.exports, "NoFilter", () => $4564153678e1805d$export$fba2cdeecf4e314d);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $kjIEI = parcelRequire("kjIEI");

var $c7i3D = parcelRequire("c7i3D");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $dCm1o = parcelRequire("dCm1o");

var $6YP2a = parcelRequire("6YP2a");
const $4564153678e1805d$var$ANOTHER_FILTER_LINK = '/jira/filters';
const $4564153678e1805d$export$fba2cdeecf4e314d = ({ reason: reason })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "noFilter",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: reason ? {
            reason: reason
        } : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $6YP2a.default).weCouldntFindThisFilter),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $6YP2a.default).filterNoExistOrNoPermissions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6YP2a.default).tryAnotherFilterIssueTermRefresh : (0, $6YP2a.default).tryAnotherFilter))),
        secondaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            href: $4564153678e1805d$var$ANOTHER_FILTER_LINK
        }, formatMessage((0, $6YP2a.default).viewFilters)),
        primaryAction: // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            href: window.location.pathname
        }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6YP2a.default).searchIssuesIssueTermRefresh : (0, $6YP2a.default).searchIssues)),
        renderImage: ()=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $4564153678e1805d$var$ImageWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c7i3D.default), {
                alt: ""
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $4564153678e1805d$var$ImageWrapperStylesOld
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjIEI.default), {
                alt: ""
            }))
    }));
};
var $4564153678e1805d$export$2e2bcd8739ae039 = $4564153678e1805d$export$fba2cdeecf4e314d;
const $4564153678e1805d$var$ImageWrapperStylesOld = (0, $8CUq3.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});
const $4564153678e1805d$var$ImageWrapperStyles = (0, $8CUq3.xcss)({
    maxHeight: '165px',
    maxWidth: '150px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("kjIEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b511ca53b54ba8ce$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $dCLgq = parcelRequire("dCLgq");

var $aKIsO = parcelRequire("aKIsO");

var $47SnX = parcelRequire("47SnX");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $b511ca53b54ba8ce$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($47SnX)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($aKIsO))
});
var $b511ca53b54ba8ce$export$2e2bcd8739ae039 = $b511ca53b54ba8ce$var$Illustration;
// for advanced use only
const $b511ca53b54ba8ce$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("aKIsO", function(module, exports) {
module.exports = new URL("search-no-results-old-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("47SnX", function(module, exports) {
module.exports = new URL("search-no-results-old.10b14394.svg", import.meta.url).toString();

});


parcelRegister("c7i3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6eff2dc5f73fdbc$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $dCLgq = parcelRequire("dCLgq");

var $gXV7M = parcelRequire("gXV7M");

var $k0yDo = parcelRequire("k0yDo");
const $e6eff2dc5f73fdbc$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($k0yDo)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($gXV7M))
});
var $e6eff2dc5f73fdbc$export$2e2bcd8739ae039 = $e6eff2dc5f73fdbc$var$Illustration;
// for advanced use only
const $e6eff2dc5f73fdbc$export$a179c88182cb9d56 = [
    0,
    0,
    167,
    184
];

});
parcelRegister("gXV7M", function(module, exports) {
module.exports = new URL("search-no-results-darkmode.c66ae5fb.svg", import.meta.url).toString();

});

parcelRegister("k0yDo", function(module, exports) {
module.exports = new URL("search-no-results.1d478205.svg", import.meta.url).toString();

});


parcelRegister("6YP2a", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fe733e75fd165d2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3fe733e75fd165d2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    weCouldntFindThisFilter: {
        "id": "issue-navigator.common.no-filter.we-couldnt-find-this-filter",
        "defaultMessage": "We couldn't find this filter"
    },
    filterNoExistOrNoPermissions: {
        "id": "issue-navigator.common.no-filter.filter-no-exist-or-no-permissions",
        "defaultMessage": "This filter may not exist, or you don\u2019t have permissions to view it."
    },
    tryAnotherFilter: {
        "id": "issue-navigator.common.no-filter.try-another-filter",
        "defaultMessage": "Try searching for another filter, or start a new issue search."
    },
    viewFilters: {
        "id": "issue-navigator.common.no-filter.view-filters",
        "defaultMessage": "View filters"
    },
    searchIssues: {
        "id": "issue-navigator.common.no-filter.search-issues",
        "defaultMessage": "Search issues"
    },
    tryAnotherFilterIssueTermRefresh: {
        "id": "issue-navigator.common.no-filter.try-another-filter-issue-term-refresh",
        "defaultMessage": "Try searching for another filter, or start a new search."
    },
    searchIssuesIssueTermRefresh: {
        "id": "issue-navigator.common.no-filter.search-issues-issue-term-refresh",
        "defaultMessage": "Search work items"
    }
});

});


parcelRegister("kMfdg", function(module, exports) {

$parcel$export(module.exports, "IssueSearchSuccess", () => $b2794e71f9164ec7$export$3ee6d2830e5ead03);
$parcel$export(module.exports, "IssueSearchFail", () => $b2794e71f9164ec7$export$91886a55521e4fad);

var $5uXOq = parcelRequire("5uXOq");

var $1XJ20 = parcelRequire("1XJ20");

var $1GlUV = parcelRequire("1GlUV");

var $38r5c = parcelRequire("38r5c");

var $ih9zY = parcelRequire("ih9zY");
const $b2794e71f9164ec7$export$3ee6d2830e5ead03 = ({ attributes: attributes, onPageDataLoad: onPageDataLoad })=>{
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const { onIssueSearchSuccess: onIssueSearchSuccess } = (0, $1GlUV.useExperienceAnalytics)(onPageDataLoad, attributes);
    const isFetching = (0, $38r5c.useIsFetching)();
    const isNetworkError = (0, $38r5c.useIsNetworkError)();
    const prevIsFetching = (0, $1XJ20.usePrevious)(isFetching);
    (0, $5uXOq.useEffect)(()=>{
        if (prevIsFetching !== isFetching && !isFetching && !isNetworkError) onIssueSearchSuccess(view);
    }, [
        isFetching,
        isNetworkError,
        onIssueSearchSuccess,
        prevIsFetching,
        view
    ]);
    return null;
};
const $b2794e71f9164ec7$export$91886a55521e4fad = ({ attributes: attributes, location: location, error: error, onPageDataLoad: onPageDataLoad })=>{
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const { onIssueSearchFail: onIssueSearchFail } = (0, $1GlUV.useExperienceAnalytics)(onPageDataLoad, attributes);
    const isFetching = (0, $38r5c.useIsFetching)();
    const prevIsFetching = (0, $1XJ20.usePrevious)(isFetching);
    (0, $5uXOq.useEffect)(()=>{
        if (prevIsFetching !== isFetching && !isFetching) onIssueSearchFail(location, error, view);
    }, [
        error,
        isFetching,
        location,
        onIssueSearchFail,
        prevIsFetching,
        view
    ]);
    return null;
};

});
parcelRegister("38r5c", function(module, exports) {

$parcel$export(module.exports, "useSearchKey", () => $e1f660d76cb8d0f0$export$89b7d8d2a901e7f3);
$parcel$export(module.exports, "useIsFetching", () => $e1f660d76cb8d0f0$export$625b2ff71316bcd3);
$parcel$export(module.exports, "useIsFetchingView", () => $e1f660d76cb8d0f0$export$bb4d69b04e77d5fc);
$parcel$export(module.exports, "useIsNetworkError", () => $e1f660d76cb8d0f0$export$e42540e6c753cf0d);
$parcel$export(module.exports, "useIsRefreshing", () => $e1f660d76cb8d0f0$export$f0abaf46a1fbe05d);
$parcel$export(module.exports, "useTotalIssueCount", () => $e1f660d76cb8d0f0$export$2913c5459976c260);
$parcel$export(module.exports, "useTotalIssueCountIsFetching", () => $e1f660d76cb8d0f0$export$597fd4c2a21a6427);
$parcel$export(module.exports, "useTotalIssueCountIsError", () => $e1f660d76cb8d0f0$export$8ca94746675b8a5f);
$parcel$export(module.exports, "useIssueSearchActions", () => $e1f660d76cb8d0f0$export$77a801a298598c57);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $1PJ7c = parcelRequire("1PJ7c");
const $e1f660d76cb8d0f0$export$89b7d8d2a901e7f3 = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.searchKey
});
const $e1f660d76cb8d0f0$export$625b2ff71316bcd3 = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.isFetching
});
const $e1f660d76cb8d0f0$export$bb4d69b04e77d5fc = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.isFetchingView
});
const $e1f660d76cb8d0f0$export$e42540e6c753cf0d = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.isNetworkError
});
const $e1f660d76cb8d0f0$export$f0abaf46a1fbe05d = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.isRefreshing
});
const $e1f660d76cb8d0f0$export$2913c5459976c260 = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.totalIssueCount
});
const $e1f660d76cb8d0f0$export$597fd4c2a21a6427 = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.totalIssueCountIsFetching
});
const $e1f660d76cb8d0f0$export$8ca94746675b8a5f = (0, $3sQ5x.createStateHook)((0, $1PJ7c.Store), {
    selector: (state)=>state.totalIssueCountIsError
});
const $e1f660d76cb8d0f0$export$77a801a298598c57 = (0, $3sQ5x.createActionsHook)((0, $1PJ7c.Store));

});

parcelRegister("ih9zY", function(module, exports) {

$parcel$export(module.exports, "Container", () => $03e3ed82cee3c5c7$export$42a852a2b6b56249);
$parcel$export(module.exports, "useSelectedViewState", () => $03e3ed82cee3c5c7$export$b94206faaa871f9e);
$parcel$export(module.exports, "useSelectedView", () => $03e3ed82cee3c5c7$export$639584d6e9163827);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $6UAdF = parcelRequire("6UAdF");
const $03e3ed82cee3c5c7$export$42a852a2b6b56249 = (0, $gg7kZ.createContainer)();
const $03e3ed82cee3c5c7$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        view: (0, $6UAdF.DEFAULT_VIEW_ID)
    },
    containedBy: $03e3ed82cee3c5c7$export$42a852a2b6b56249,
    actions: {
        setView: (view, issueKey)=>({ setState: setState }, { onSetView: onSetView, onIssueSearchForView: onIssueSearchForView })=>{
                setState({
                    view: view
                });
                onSetView(view, issueKey);
                onIssueSearchForView && onIssueSearchForView(view);
            }
    },
    handlers: {
        onInit: ()=>({ setState: setState }, { view: view })=>{
                setState({
                    view: view
                });
            },
        onContainerUpdate: (nextProps, prevProps)=>({ setState: setState })=>{
                if (nextProps.view !== prevProps.view) setState({
                    view: nextProps.view
                });
            }
    },
    name: 'IssueNavigatorSelectedViewStateNew'
});
const $03e3ed82cee3c5c7$export$b94206faaa871f9e = (0, $3sQ5x.createHook)($03e3ed82cee3c5c7$var$Store);
const $03e3ed82cee3c5c7$export$639584d6e9163827 = (0, $3sQ5x.createStateHook)($03e3ed82cee3c5c7$var$Store, {
    selector: (state)=>state.view
});

});


parcelRegister("7OTah", function(module, exports) {

$parcel$export(module.exports, "useSelectedIssueIndex", () => $45ced29c2f763b85$export$a4b375f8f9b094ad);
$parcel$export(module.exports, "useNextIssueKey", () => $45ced29c2f763b85$export$a357f91232534409);
$parcel$export(module.exports, "usePreviousIssueKey", () => $45ced29c2f763b85$export$ee05f65713c12ae3);
$parcel$export(module.exports, "useIssuesCount", () => $45ced29c2f763b85$export$b8578d9ea1fc9bc);
$parcel$export(module.exports, "useSelectedIssueKey", () => $45ced29c2f763b85$export$7cedcbfb2da7e49d);
$parcel$export(module.exports, "useIsSelectedIssue", () => $45ced29c2f763b85$export$ccd07516e284d793);
$parcel$export(module.exports, "useSelectedIssueDebouncedState", () => $45ced29c2f763b85$export$ed5cb04ac9d88e95);
$parcel$export(module.exports, "useIsFullPageIssueAppMode", () => $45ced29c2f763b85$export$988cbddd89e853c0);
$parcel$export(module.exports, "useSelectedIssueActions", () => $45ced29c2f763b85$export$d1c4608e18de4f02);

var $3sQ5x = parcelRequire("3sQ5x");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $hnJJ3 = parcelRequire("hnJJ3");

var $gz4II = parcelRequire("gz4II");
const $45ced29c2f763b85$export$a4b375f8f9b094ad = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: (0, $gz4II.getSelectedIssueIndex)
});
const $45ced29c2f763b85$export$a357f91232534409 = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: (0, $gz4II.getNextIssueKey)
});
const $45ced29c2f763b85$export$ee05f65713c12ae3 = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: (0, $gz4II.getPreviousIssueKey)
});
const $45ced29c2f763b85$export$b8578d9ea1fc9bc = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: (0, $gz4II.getIssuesCount)
});
const $45ced29c2f763b85$export$7cedcbfb2da7e49d = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: ({ selectedIssueKey: selectedIssueKey })=>selectedIssueKey
});
const $45ced29c2f763b85$export$ccd07516e284d793 = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: ({ selectedIssueKey: selectedIssueKey }, issueKey)=>selectedIssueKey === issueKey
});
const $45ced29c2f763b85$export$ed5cb04ac9d88e95 = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: (0, $eJ0Zs.createRememoizeSelector)((state)=>state, ({ selectedIssueKey: selectedIssueKey })=>selectedIssueKey)
});
const $45ced29c2f763b85$export$988cbddd89e853c0 = (0, $3sQ5x.createStateHook)((0, $hnJJ3.Store), {
    selector: ({ isFullPageIssueAppMode: isFullPageIssueAppMode })=>isFullPageIssueAppMode
});
const $45ced29c2f763b85$export$d1c4608e18de4f02 = (0, $3sQ5x.createActionsHook)((0, $hnJJ3.Store));

});
parcelRegister("hnJJ3", function(module, exports) {

$parcel$export(module.exports, "SelectedIssueContainer", () => $2e98f8dbaf47ae14$export$8b7bb55917259a5d);
$parcel$export(module.exports, "Store", () => $2e98f8dbaf47ae14$export$390f32400eaf98c9);

var $g5X3G = parcelRequire("g5X3G");

var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $6UAdF = parcelRequire("6UAdF");

var $kyTMp = parcelRequire("kyTMp");
const $2e98f8dbaf47ae14$export$8b7bb55917259a5d = (0, $gg7kZ.createContainer)();
const $2e98f8dbaf47ae14$var$initialState = {
    _rememoize: Date.now(),
    selectedIssueKey: (0, $g5X3G.toIssueKey)(''),
    isFullPageIssueAppMode: false,
    issueKeys: []
};
const $2e98f8dbaf47ae14$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'SelectedIssueStore',
    containedBy: $2e98f8dbaf47ae14$export$8b7bb55917259a5d,
    initialState: $2e98f8dbaf47ae14$var$initialState,
    actions: $kyTMp.default,
    handlers: {
        onInit: ()=>({ setState: setState, dispatch: dispatch }, { selectedIssueKey: selectedIssueKey, view: view, issueKeys: issueKeys })=>{
                dispatch((0, $kyTMp.privateActions).onContainerUpdate());
                const isFullPageIssueAppMode = Boolean(selectedIssueKey) && view === (0, $6UAdF.views).list;
                const initialIssueKey = selectedIssueKey || issueKeys[0] || (0, $g5X3G.toIssueKey)('');
                setState({
                    _rememoize: Date.now(),
                    selectedIssueKey: initialIssueKey,
                    isFullPageIssueAppMode: isFullPageIssueAppMode
                });
            },
        onContainerUpdate: ({ searchKey: searchKey, selectedIssueKey: selectedIssueKey }, prevProps)=>({ dispatch: dispatch })=>{
                dispatch((0, $kyTMp.privateActions).onContainerUpdate());
                if (searchKey !== prevProps.searchKey) dispatch((0, $kyTMp.privateActions).resetSelectedIssue());
                else if (selectedIssueKey && selectedIssueKey !== prevProps.selectedIssueKey) {
                    dispatch($2e98f8dbaf47ae14$export$390f32400eaf98c9.actions.setSelectedIssueByKey(selectedIssueKey, {
                        shouldDebounce: false,
                        shouldNotifyOnChange: false,
                        isSelectedByUserInteraction: false
                    }));
                    // If an issue key has been specified while in list view then enter full page issue app mode.
                    if (dispatch((0, $kyTMp.privateActions).isListViewWithoutIssueApp())) dispatch($2e98f8dbaf47ae14$export$390f32400eaf98c9.actions.enterFullPageIssueAppMode());
                // TODO JSC-185 Fetch next/previous page when last/first issue is selected
                } else if (!selectedIssueKey && dispatch((0, $kyTMp.privateActions).isListViewWithIssueAppAndKey())) dispatch($2e98f8dbaf47ae14$export$390f32400eaf98c9.actions.exitFullPageIssueAppMode());
            }
    }
});

});
parcelRegister("kyTMp", function(module, exports) {

$parcel$export(module.exports, "privateActions", () => $ecb0ae8c94bab407$export$3f1be494d407b77a);
$parcel$export(module.exports, "default", () => $ecb0ae8c94bab407$export$2e2bcd8739ae039);

var $lFKmC = parcelRequire("lFKmC");

var $g5X3G = parcelRequire("g5X3G");

var $6UAdF = parcelRequire("6UAdF");

var $gz4II = parcelRequire("gz4II");
const $ecb0ae8c94bab407$var$doSideEffectUpdate = ({ getState: getState, setState: setState }, { onChange: onChange, shouldNotifyOnChange: shouldNotifyOnChange = true, isSelectedByUserInteraction: isSelectedByUserInteraction = true, viewActivity: viewActivity })=>{
    const { selectedIssueKey: selectedIssueKey } = getState();
    setState({
        _rememoize: Date.now()
    });
    shouldNotifyOnChange && onChange && onChange(selectedIssueKey, isSelectedByUserInteraction, viewActivity);
};
const $ecb0ae8c94bab407$var$doDebouncedSideEffectUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))($ecb0ae8c94bab407$var$doSideEffectUpdate, 600);
const $ecb0ae8c94bab407$var$doSideEffectUpdates = (actions, options)=>{
    options.shouldDebounce ? $ecb0ae8c94bab407$var$doDebouncedSideEffectUpdate(actions, options) : $ecb0ae8c94bab407$var$doSideEffectUpdate(actions, options);
};
const $ecb0ae8c94bab407$var$setSelectedIssueByKey = (selectedIssueKey, options = {})=>(actions, { onChange: onChange })=>{
        if (!selectedIssueKey.length) return false;
        actions.setState({
            selectedIssueKey: selectedIssueKey
        });
        $ecb0ae8c94bab407$var$doSideEffectUpdates(actions, {
            ...options,
            onChange: onChange
        });
        return true;
    };
const $ecb0ae8c94bab407$var$setSelectedIssueByIndex = (issueIndex, options)=>({ dispatch: dispatch }, { issueKeys: issueKeys })=>{
        return dispatch($ecb0ae8c94bab407$var$setSelectedIssueByKey(issueKeys[issueIndex] ?? (0, $g5X3G.toIssueKey)(''), options));
    };
/**
 * Select the next issue in the search results (if there is a valid selection). Returns `true` if an issue was selected,
 * otherwise `false`.
 */ const $ecb0ae8c94bab407$var$selectNextIssue = (shouldDebounce)=>({ dispatch: dispatch, getState: getState })=>{
        return dispatch($ecb0ae8c94bab407$var$setSelectedIssueByKey((0, $gz4II.getNextIssueKey)(getState()) ?? (0, $g5X3G.toIssueKey)(''), {
            shouldDebounce: shouldDebounce
        }));
    };
/**
 * Select the previous issue in the search results (if there is a valid selection). Returns `true` if an issue was
 * selected, otherwise `false`.
 */ const $ecb0ae8c94bab407$var$selectPreviousIssue = (shouldDebounce)=>({ dispatch: dispatch, getState: getState })=>{
        return dispatch($ecb0ae8c94bab407$var$setSelectedIssueByKey((0, $gz4II.getPreviousIssueKey)(getState()) ?? (0, $g5X3G.toIssueKey)(''), {
            shouldDebounce: shouldDebounce
        }));
    };
const $ecb0ae8c94bab407$var$deselectIssue = (options)=>(actions, { onChange: onChange })=>{
        actions.setState({
            selectedIssueKey: (0, $g5X3G.toIssueKey)('')
        });
        $ecb0ae8c94bab407$var$doSideEffectUpdates(actions, {
            ...options,
            onChange: onChange
        });
    };
const $ecb0ae8c94bab407$var$enterFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: true
        });
const $ecb0ae8c94bab407$var$exitFullPageIssueAppMode = ()=>({ setState: setState })=>setState({
            isFullPageIssueAppMode: false
        });
/**
 * Return true if we're in default list view mode without the full page issue app visible.
 */ const $ecb0ae8c94bab407$var$isListViewWithoutIssueApp = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode } = getState();
        return view === (0, $6UAdF.views).list && !isFullPageIssueAppMode;
    };
/**
 * Return true if we're in default list view mode with the full page issue app visible and a selected issue key.
 */ const $ecb0ae8c94bab407$var$isListViewWithIssueAppAndKey = ()=>({ getState: getState }, { view: view })=>{
        const { isFullPageIssueAppMode: isFullPageIssueAppMode, selectedIssueKey: selectedIssueKey } = getState();
        return view === (0, $6UAdF.views).list && isFullPageIssueAppMode && !!selectedIssueKey;
    };
/**
 * Reset the selected issue to the first issue in the connection.
 */ const $ecb0ae8c94bab407$var$resetSelectedIssue = ()=>({ dispatch: dispatch })=>{
        // We only want to update issue key in the URL if our view mode uses external issue key selection, i.e. detail
        // view or full page issue app in list view. For the default list view mode we want to keep the selected issue
        // state internal.
        const shouldNotifyOnChange = !dispatch($ecb0ae8c94bab407$var$isListViewWithoutIssueApp());
        dispatch($ecb0ae8c94bab407$var$setSelectedIssueByIndex(0, {
            shouldDebounce: false,
            shouldNotifyOnChange: shouldNotifyOnChange,
            isSelectedByUserInteraction: false
        }));
    };
const $ecb0ae8c94bab407$export$ab8f0de40a3a2d2d = ()=>({ setState: setState }, { issueKeys: issueKeys })=>{
        setState({
            issueKeys: issueKeys
        });
    };
const $ecb0ae8c94bab407$export$e324594224ef24da = {
    setSelectedIssueByKey: $ecb0ae8c94bab407$var$setSelectedIssueByKey,
    setSelectedIssueByIndex: $ecb0ae8c94bab407$var$setSelectedIssueByIndex,
    selectNextIssue: $ecb0ae8c94bab407$var$selectNextIssue,
    selectPreviousIssue: $ecb0ae8c94bab407$var$selectPreviousIssue,
    deselectIssue: $ecb0ae8c94bab407$var$deselectIssue,
    enterFullPageIssueAppMode: $ecb0ae8c94bab407$var$enterFullPageIssueAppMode,
    exitFullPageIssueAppMode: $ecb0ae8c94bab407$var$exitFullPageIssueAppMode
};
const $ecb0ae8c94bab407$export$3f1be494d407b77a = {
    isListViewWithoutIssueApp: $ecb0ae8c94bab407$var$isListViewWithoutIssueApp,
    isListViewWithIssueAppAndKey: $ecb0ae8c94bab407$var$isListViewWithIssueAppAndKey,
    resetSelectedIssue: $ecb0ae8c94bab407$var$resetSelectedIssue,
    onContainerUpdate: $ecb0ae8c94bab407$export$ab8f0de40a3a2d2d
};
var $ecb0ae8c94bab407$export$2e2bcd8739ae039 = $ecb0ae8c94bab407$export$e324594224ef24da;

});
parcelRegister("gz4II", function(module, exports) {

$parcel$export(module.exports, "getSelectedIssueIndex", () => $a1a1b31f57e99fe6$export$b5bba5025e9754c0);
$parcel$export(module.exports, "getNextIssueKey", () => $a1a1b31f57e99fe6$export$2a413bfa3aeed781);
$parcel$export(module.exports, "getPreviousIssueKey", () => $a1a1b31f57e99fe6$export$5e257a264fce89f7);
$parcel$export(module.exports, "getIssuesCount", () => $a1a1b31f57e99fe6$export$af7642e9bc434b70);

var $6dDSs = parcelRequire("6dDSs");
const $a1a1b31f57e99fe6$export$b5bba5025e9754c0 = (0, $6dDSs.createSelector)((state)=>state.selectedIssueKey, (state)=>state.issueKeys, (selectedIssueKey, issueKeys)=>issueKeys.indexOf(selectedIssueKey));
const $a1a1b31f57e99fe6$export$2a413bfa3aeed781 = (state)=>{
    const index = $a1a1b31f57e99fe6$export$b5bba5025e9754c0(state);
    const { issueKeys: issueKeys } = state;
    return index > -1 && index < issueKeys.length - 1 ? issueKeys[index + 1] : null;
};
const $a1a1b31f57e99fe6$export$5e257a264fce89f7 = (state)=>{
    const index = $a1a1b31f57e99fe6$export$b5bba5025e9754c0(state);
    const { issueKeys: issueKeys } = state;
    return index > 0 ? issueKeys[index - 1] : null;
};
const $a1a1b31f57e99fe6$export$af7642e9bc434b70 = (state)=>{
    return state.issueKeys.length;
};

});




parcelRegister("gM6H8", function(module, exports) {

$parcel$export(module.exports, "FlatListIssuesContainer", () => $fe56567ca6bbd596$export$60cae405c8bdaa87);
$parcel$export(module.exports, "useFlatListIssuesActions", () => $fe56567ca6bbd596$export$14d48bac80618630);
$parcel$export(module.exports, "useFlatListIssues", () => $fe56567ca6bbd596$export$a53e6810bcedfe4d);
$parcel$export(module.exports, "useFlatListIssueIds", () => $fe56567ca6bbd596$export$440fc5b87687d980);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $fe56567ca6bbd596$export$60cae405c8bdaa87 = (0, $gg7kZ.createContainer)();
const $fe56567ca6bbd596$var$initialState = {
    flatListIssues: [],
    flatListIssueIds: []
};
const $fe56567ca6bbd596$var$actions = {
    setFlatListIssueIds: (flatListIssueIds)=>({ setState: setState })=>{
            setState({
                flatListIssueIds: flatListIssueIds
            });
        },
    setFlatListIssues: (flatListIssues)=>({ setState: setState })=>{
            setState({
                flatListIssues: flatListIssues
            });
        }
};
const $fe56567ca6bbd596$var$Store = (0, $iXqE5.createStore)({
    containedBy: $fe56567ca6bbd596$export$60cae405c8bdaa87,
    initialState: $fe56567ca6bbd596$var$initialState,
    actions: $fe56567ca6bbd596$var$actions,
    name: 'jira-native-issue-table-flat-list-issues-store'
});
const $fe56567ca6bbd596$export$14d48bac80618630 = (0, $3sQ5x.createActionsHook)($fe56567ca6bbd596$var$Store);
const $fe56567ca6bbd596$export$2868636f0c1a29ec = (0, $3sQ5x.createHook)($fe56567ca6bbd596$var$Store);
const $fe56567ca6bbd596$var$getFlatListIssuesSelector = (state)=>state.flatListIssues;
const $fe56567ca6bbd596$export$a53e6810bcedfe4d = (0, $3sQ5x.createStateHook)($fe56567ca6bbd596$var$Store, {
    selector: $fe56567ca6bbd596$var$getFlatListIssuesSelector
});
const $fe56567ca6bbd596$var$getFlatListIssueIdsSelector = (state)=>state.flatListIssueIds;
const $fe56567ca6bbd596$export$440fc5b87687d980 = (0, $3sQ5x.createStateHook)($fe56567ca6bbd596$var$Store, {
    selector: $fe56567ca6bbd596$var$getFlatListIssueIdsSelector
});

});

parcelRegister("jfQeI", function(module, exports) {

$parcel$export(module.exports, "useIFCEntryPointContext", () => $38798637f24a8af2$export$caffdf0d268fddd7);
$parcel$export(module.exports, "InlineFieldConfigProviderComponent", () => $38798637f24a8af2$export$7b6238f7c058bb58);

var $5uXOq = parcelRequire("5uXOq");

var $l37qh = parcelRequire("l37qh");

var $4mO32 = parcelRequire("4mO32");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $7iHfG = parcelRequire("7iHfG");
const $38798637f24a8af2$export$ed5ff4845085aae5 = (0, $l37qh.createUseEntryPointContext)();
const $38798637f24a8af2$var$entryPointParams = {};
const $38798637f24a8af2$export$b1528524caf51b8b = ({ children: children })=>{
    const entryPointResult = (0, $4mO32.useEntryPoint)((0, $7iHfG.ifcEntryPoint), $38798637f24a8af2$var$entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($38798637f24a8af2$export$ed5ff4845085aae5.Provider, {
        value: entryPointResult
    }, children);
};
const $38798637f24a8af2$export$caffdf0d268fddd7 = ()=>{
    return (0, $5uXOq.useContext)($38798637f24a8af2$export$ed5ff4845085aae5);
};
const $38798637f24a8af2$export$7b6238f7c058bb58 = (0, $7XYc4.componentWithCondition)(()=>// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false) && (0, $4R6GH.fg)('jira_ifc_changes_for_pnin'), $38798637f24a8af2$export$b1528524caf51b8b, ({ children: children })=>children);

});
parcelRegister("7iHfG", function(module, exports) {

$parcel$export(module.exports, "ifcEntryPoint", () => $37e91c9742f05fff$export$26521842160defa7);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $37e91c9742f05fff$export$26521842160defa7 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("eVbe4")), {
        moduleId: "6c18a40d",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eVbe4", function(module, exports) {

let $adcf18d153bfffa9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $adcf18d153bfffa9$var$load("76n7a"),
    $adcf18d153bfffa9$var$load("l253H"),
    $adcf18d153bfffa9$var$load("kNFvF"),
    $adcf18d153bfffa9$var$load("ffQaD"),
    $adcf18d153bfffa9$var$load("kvRbA"),
    $adcf18d153bfffa9$var$load("6SJHf")
]).then(()=>parcelRequire('hjnsM'));

});



parcelRegister("7jipW", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsWrapper", () => $1689161e44158dbb$export$88a2a475d15f0a71);

var $hOOQf = parcelRequire("hOOQf");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $91LZJ = parcelRequire("91LZJ");

var $8RB1G = parcelRequire("8RB1G");

var $48rMm = parcelRequire("48rMm");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $1XJ20 = parcelRequire("1XJ20");

var $gM6H8 = parcelRequire("gM6H8");

var $ih9zY = parcelRequire("ih9zY");

var $gwtSG = parcelRequire("gwtSG");
const $1689161e44158dbb$var$EMPTY_ARRAY = [];
const $1689161e44158dbb$var$LoadBulkOpsCore = ({ bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference, fragmentRef: fragmentRef })=>{
    const selectedIssues = (0, $48rMm.useIssueTableSelectedIssues)();
    const { reset: reset, insertSelectedIssueIds: insertSelectedIssueIds } = (0, $48rMm.useIssueTableSelectedIssuesActions)();
    const view = (0, $ih9zY.useSelectedView)();
    const { jql: jql } = (0, $gwtSG.useActiveJql)();
    const previousJql = (0, $1XJ20.usePrevious)(jql);
    (0, $5uXOq.useEffect)(()=>{
        if (jql !== previousJql && previousJql !== undefined) reset();
    }, [
        jql,
        previousJql,
        reset
    ]);
    let issuesFlatListIds = $1689161e44158dbb$var$EMPTY_ARRAY;
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    issuesFlatListIds = (0, $gM6H8.useFlatListIssueIds)();
    const data = (0, $8Uumt.useFragment)((0, $hOOQf.default), fragmentRef);
    // we don't need to read issueIds for grouping from the query because we already have them in the flat list
    const issueIds = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) return {
            strings: issuesFlatListIds,
            numbers: issuesFlatListIds.map((issueId)=>Number(issueId))
        };
        const strings = data?.edges?.map((edge)=>edge?.node?.issueId).filter(Boolean) ?? [];
        return {
            strings: strings,
            numbers: strings.map((issueId)=>Number(issueId))
        };
    }, [
        data?.edges,
        issuesFlatListIds
    ]);
    const onSelectAll = (0, $5uXOq.useCallback)(()=>{
        insertSelectedIssueIds(issueIds.strings);
    }, [
        issueIds.strings,
        insertSelectedIssueIds
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8RB1G.AsyncBulkOpsCoreFull), {
        bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference,
        selectedIssueIds: selectedIssues.map((issue)=>Number(issue)),
        onClearAll: reset,
        onSelectAll: onSelectAll,
        selectableIssueIds: issueIds.numbers,
        onClearAllVisible: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        shouldHideToolbar: view === 'detail'
    });
};
const $1689161e44158dbb$export$88a2a475d15f0a71 = ({ children: children, bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference, fragmentRef: fragmentRef })=>{
    if (!(0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false)) return children;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isBulkOpsInProgress = (0, $91LZJ.useIsBulkOperationsInProgress)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $1689161e44158dbb$var$wrapperStyles,
        direction: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $1689161e44158dbb$var$childContainerStyles,
            isBulkOpsInProgress && $1689161e44158dbb$var$childContainerDisabledStyles
        ]
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1689161e44158dbb$var$LoadBulkOpsCore, {
        fragmentRef: fragmentRef,
        bulkOpsCoreEntryPointReference: bulkOpsCoreEntryPointReference
    }));
};
const $1689161e44158dbb$var$wrapperStyles = (0, $8CUq3.xcss)({
    height: '100%',
    overflowY: 'auto'
});
const $1689161e44158dbb$var$childContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    overflowY: 'auto'
});
const $1689161e44158dbb$var$childContainerDisabledStyles = (0, $8CUq3.xcss)({
    opacity: 0.5,
    pointerEvents: 'none'
});

});
parcelRegister("hOOQf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dbfbc599ad06ce9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9447c66ceb43590970549d094be1fa98>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7dbfbc599ad06ce9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "bulkOperationsWrapper_issueNavigator_LoadBulkOpsCore",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$7dbfbc599ad06ce9$var$node.hash = "3ef50a3a9b158093691740d555608365";
var $7dbfbc599ad06ce9$export$2e2bcd8739ae039 = $7dbfbc599ad06ce9$var$node;

});

parcelRegister("91LZJ", function(module, exports) {

$parcel$export(module.exports, "useBulkOperations", () => $655e95f3b81da53e$export$940587be18a93fc4);
$parcel$export(module.exports, "useBulkOperationsActions", () => $655e95f3b81da53e$export$355499dfde532d1a);
$parcel$export(module.exports, "useIsBulkOperationsInProgress", () => $655e95f3b81da53e$export$760458c2204457a1);
$parcel$export(module.exports, "useShouldRenderSpotlight", () => $655e95f3b81da53e$export$4a165cf2377f023a);
$parcel$export(module.exports, "useBulkTransitionsStage", () => $655e95f3b81da53e$export$b3afff39a0c663ad);
$parcel$export(module.exports, "useBulkOperationInForm", () => $655e95f3b81da53e$export$6794339387d6d562);
$parcel$export(module.exports, "useBulkOperationType", () => $655e95f3b81da53e$export$4289f82da677ffac);
$parcel$export(module.exports, "useCancelDialogTrigger", () => $655e95f3b81da53e$export$babceeeb2408337b);
$parcel$export(module.exports, "useCurrentView", () => $655e95f3b81da53e$export$8ce7af7b2f8c770);

var $8zOmE = parcelRequire("8zOmE");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5ltfA = parcelRequire("5ltfA");

var $liV8G = parcelRequire("liV8G");
const $655e95f3b81da53e$export$d4c72bab9d6cc13a = {
    operationType: null,
    isSidebarOpen: false,
    cancelDialogTrigger: undefined,
    currentView: 'edit',
    firstFieldId: undefined,
    operationStartTime: null
};
const $655e95f3b81da53e$var$actions = {
    setSummaryView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'summary'
            });
        },
    setFirstFieldId: (firstFieldId)=>({ setState: setState })=>{
            setState({
                firstFieldId: firstFieldId
            });
        },
    setEditView: ()=>({ setState: setState })=>{
            setState({
                currentView: 'edit'
            });
        },
    setCancelDialogTrigger: (newTrigger = 'user-triggered')=>({ setState: setState, getState: getState })=>{
            const { cancelDialogTrigger: currentTrigger } = getState();
            /* Sometimes both events can be fired (route change & onclick) in one loop
					We need to prioritise route-change event  */ if (currentTrigger === 'route-change' && newTrigger === 'user-triggered') return;
            setState({
                cancelDialogTrigger: newTrigger
            });
        },
    clearDialogTrigger: ()=>({ setState: setState })=>{
            setState({
                cancelDialogTrigger: undefined
            });
        },
    startEdit: (args)=>({ setState: setState })=>{
            const { shouldRenderSpotlight: shouldRenderSpotlight } = args || {
                shouldRenderSpotlight: false
            };
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_EDIT
                },
                shouldRenderSpotlight: shouldRenderSpotlight,
                isSidebarOpen: true,
                operationStartTime: performance.now()
            });
        },
    loadTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).LOAD_BULK_TRANSITIONS
                },
                isSidebarOpen: false
            });
        },
    startQuickTransitions: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_QUICK_TRANSITIONS
                },
                isSidebarOpen: false,
                operationStartTime: performance.now()
            });
        },
    startSidebarTransition: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_SIDEBAR_TRANSITION
                },
                isSidebarOpen: true,
                operationStartTime: performance.now()
            });
        },
    startTransitionScreen: ()=>({ setState: setState })=>{
            setState({
                operationType: {
                    type: (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION,
                    stage: (0, $liV8G.BulkTransitionsStage).START_TRANSITION_SCREEN
                },
                isSidebarOpen: true
            });
        },
    dismissBulkOperation: ({ createAnalyticsEvent: createAnalyticsEvent, dismissType: dismissType })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            const analyticsEvent = createAnalyticsEvent({});
            const operationEndTime = performance.now();
            const operationTimeTaken = currentState.operationStartTime ? operationEndTime - currentState.operationStartTime : null;
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'dismissed bulkOperations', {
                dismissType: dismissType,
                operationTimeTaken: operationTimeTaken
            });
            (0, $5ltfA.extraFormDataService).clear();
            setState($655e95f3b81da53e$export$d4c72bab9d6cc13a);
        }
};
const $655e95f3b81da53e$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $655e95f3b81da53e$export$d4c72bab9d6cc13a,
    actions: $655e95f3b81da53e$var$actions,
    name: 'bulk-operations-store'
});
const $655e95f3b81da53e$export$940587be18a93fc4 = (0, $3sQ5x.createHook)($655e95f3b81da53e$export$6f57813fe9f31bf9);
const $655e95f3b81da53e$export$355499dfde532d1a = (0, $3sQ5x.createActionsHook)($655e95f3b81da53e$export$6f57813fe9f31bf9);
const $655e95f3b81da53e$export$760458c2204457a1 = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.operationType !== null
});
const $655e95f3b81da53e$export$4a165cf2377f023a = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>!!state.shouldRenderSpotlight
});
const $655e95f3b81da53e$export$b3afff39a0c663ad = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        const { operationType: operationType } = state;
        if (operationType?.type === (0, $liV8G.BulkOperationsTypes).BULK_TRANSITION) return operationType.stage;
        return null;
    }
});
const $655e95f3b81da53e$export$6794339387d6d562 = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>{
        if (state.isSidebarOpen && state.operationType) return state.operationType.type;
        return null;
    }
});
const $655e95f3b81da53e$export$4289f82da677ffac = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.operationType
});
const $655e95f3b81da53e$export$babceeeb2408337b = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.cancelDialogTrigger
});
const $655e95f3b81da53e$export$8ce7af7b2f8c770 = (0, $3sQ5x.createStateHook)($655e95f3b81da53e$export$6f57813fe9f31bf9, {
    selector: (state)=>state.currentView
});

});
parcelRegister("5ltfA", function(module, exports) {

$parcel$export(module.exports, "extraFormDataService", () => $3546d70b36caa00c$export$3cd9d97d155e8e66);
class $3546d70b36caa00c$var$ExtraFormData {
    clear() {
        this.data = {};
    }
    addByKey(key, value) {
        this.data[key] = value;
    }
    getByKey(key) {
        return this.data[key];
    }
    getAll() {
        return this.data;
    }
    constructor(){
        this.data = {};
    }
}
const $3546d70b36caa00c$var$extraFormData = new $3546d70b36caa00c$var$ExtraFormData();
const $3546d70b36caa00c$var$addDataByKey = (key, value)=>{
    $3546d70b36caa00c$var$extraFormData.addByKey(key, value);
};
const $3546d70b36caa00c$var$clear = ()=>{
    $3546d70b36caa00c$var$extraFormData.clear();
};
const $3546d70b36caa00c$var$getDataByKey = (key)=>$3546d70b36caa00c$var$extraFormData.getByKey(key);
const $3546d70b36caa00c$var$getData = ()=>$3546d70b36caa00c$var$extraFormData.getAll();
const $3546d70b36caa00c$export$3cd9d97d155e8e66 = {
    addDataByKey: $3546d70b36caa00c$var$addDataByKey,
    getDataByKey: $3546d70b36caa00c$var$getDataByKey,
    clear: $3546d70b36caa00c$var$clear,
    getData: $3546d70b36caa00c$var$getData
};

});

parcelRegister("liV8G", function(module, exports) {

$parcel$export(module.exports, "BulkOperationsTypes", () => $41c61f309c49c414$export$7ec2782f56bb6e02);
$parcel$export(module.exports, "BulkTransitionsStage", () => $41c61f309c49c414$export$a6f51fa6c8971716);
const $41c61f309c49c414$export$7ec2782f56bb6e02 = {
    BULK_EDIT: 'BULK_EDIT',
    BULK_TRANSITION: 'BULK_TRANSITION',
    BULK_DELETE: 'BULK_DELETE',
    BULK_WATCH: 'BULK_WATCH',
    BULK_UNWATCH: 'BULK_UNWATCH'
};
const $41c61f309c49c414$export$a6f51fa6c8971716 = {
    LOAD_BULK_TRANSITIONS: 'LOAD_BULK_TRANSITIONS',
    START_QUICK_TRANSITIONS: 'START_QUICK_TRANSITIONS',
    START_SIDEBAR_TRANSITION: 'START_SIDEBAR_TRANSITION',
    START_TRANSITION_SCREEN: 'START_TRANSITION_SCREEN'
};
const $41c61f309c49c414$export$1550a2cc6d56ae33 = {
    // ERRORS //
    ERROR_BULK_EDIT: 'ERROR_BULK_EDIT',
    ERROR_BULK_TRANSITION: 'ERROR_BULK_TRANSITION',
    ERROR_BULK_TRANSITION_SCREEN_MOUNT: 'ERROR_BULK_TRANSITION_SCREEN_MOUNT',
    // BULK EDIT //
    EDIT_FORM_PRISTINE_CANCEL: 'EDIT_FORM_PRISTINE_CANCEL',
    EDIT_FORM_DIRTY_CANCEL: 'EDIT_FORM_DIRTY_CANCEL',
    EDIT_FORM_SUMMARY_CANCEL: 'EDIT_FORM_SUMMARY_CANCEL',
    EDIT_ATTEMPT_SUBMIT: 'EDIT_ATTEMPT_SUBMIT',
    // TRANSITION DIALOG //
    TRANSITION_DIALOG_PRISTINE_CANCEL: 'TRANSITION_DIALOG_PRISTINE_CANCEL',
    TRANSITION_DIALOG_DIRTY_CANCEL: 'TRANSITION_DIALOG_DIRTY_CANCEL',
    TRANSITION_DIALOG_CANT_CONTINUE_WARNING: 'TRANSITION_DIALOG_CANT_CONTINUE_WARNING',
    TRANSITION_DIALOG_ATTEMPT_SUBMIT: 'TRANSITION_DIALOG_ATTEMPT_SUBMIT',
    // TRANSITION FORM //
    TRANSITION_FORM_PRISTINE_CANCEL: 'TRANSITION_FORM_PRISTINE_CANCEL',
    TRANSITION_FORM_DIRTY_CANCEL: 'TRANSITION_FORM_DIRTY_CANCEL',
    TRANSITION_FORM_ATTEMPT_SUBMIT: 'TRANSITION_FORM_ATTEMPT_SUBMIT',
    // TRANSITION WITH SCREEN //
    TRANSITION_WITH_SCREEN_LEGACY_LINK: 'TRANSITION_WITH_SCREEN_LEGACY_LINK',
    TRANSITION_WITH_SCREEN_SUMMARY_CANCEL: 'TRANSITION_WITH_SCREEN_SUMMARY_CANCEL',
    TRANSITION_WITH_SCREEN_CANCEL: 'TRANSITION_WITH_SCREEN_CANCEL',
    // BULK DELETE //
    DELETE_ATTEMPT_SUBMIT: 'DELETE_ATTEMPT_SUBMIT',
    DELETE_ATTEMPT_CANCEL: 'DELETE_CANCEL',
    // BULK WATCH //
    WATCH_ATTEMPT_SUBMIT: 'WATCH_ATTEMPT_SUBMIT',
    // BULK UNWATCH //
    UNWATCH_ATTEMPT_SUBMIT: 'UNWATCH_ATTEMPT_SUBMIT',
    // OTHER //
    NAVIGATION: 'NAVIGATION',
    DESELECT_ALL_ISSUES: 'DESELECT_ALL_ISSUES'
};

});


parcelRegister("8RB1G", function(module, exports) {

$parcel$export(module.exports, "AsyncBulkOpsCoreFull", () => $0713926df1958104$export$5a522923c01d18f2);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koeKL = parcelRequire("koeKL");

var $52qhI = parcelRequire("52qhI");
const $0713926df1958104$export$5a522923c01d18f2 = (props)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId
        }), [
        cloudId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $52qhI.asyncBulkOpsCoreFullEntryPoint), entryPointParams);
    // This type conversion fixes the below CI build error
    // Type 'Omit<BulkOperationsCoreLoader<TEntryPoint>, "hasBulkEditPermission">' is not assignable to type 'Omit<BulkOperationsCoreLoader<AnyEntryPoint | undefined>, "hasBulkEditPermission">'
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fixedEntryPointReferenceSubject = entryPointReferenceSubject;
    // this is to reduce the load to NIN when adding bulk ops
    // we should revisit later to remove this and load bulk ops same as the way backlog loads
    // https://hello.jira.atlassian.cloud/browse/DEE-6353
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.backlog.bulk.operations.core.full",
        packageName: "jiraBulkOperationsCoreFull",
        entryPointReferenceSubject: fixedEntryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: props
    });
};

});
parcelRegister("52qhI", function(module, exports) {

$parcel$export(module.exports, "asyncBulkOpsCoreFullEntryPoint", () => $42e200e10d2ccac9$export$4586bee469e9f8fc);

var $61xJ7 = parcelRequire("61xJ7");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $42e200e10d2ccac9$export$4586bee469e9f8fc = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("akx4c")), {
        moduleId: "46b63f73",
        priority: "interaction"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                permissionsQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $61xJ7.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("61xJ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcabe91a5fb1367e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bb430c501ccce22cd8ca816174850f68>>
 * @relayHash da2409ae2bc56c51b0f8898e8ba8c588
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f80926256dac19536f6b2057ab2e6fe8c357e6ab85002583f57fdbb921f12d7
const $dcabe91a5fb1367e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "4f80926256dac19536f6b2057ab2e6fe8c357e6ab85002583f57fdbb921f12d7",
        "metadata": {},
        "name": "srcFullCoreQuery",
        "operationKind": "query",
        "text": null
    }
};
var $dcabe91a5fb1367e$export$2e2bcd8739ae039 = $dcabe91a5fb1367e$var$node;

});

parcelRegister("akx4c", function(module, exports) {

let $78556c02932fbb18$var$load = (parcelRequire("28QjX"))(4);
module.exports = $78556c02932fbb18$var$load("iaPGk").then(()=>parcelRequire('anh2a'));

});




parcelRegister("jKHs3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a32f27c74f4bd66c$export$2e2bcd8739ae039);

var $3mkkt = parcelRequire("3mkkt");

var $ragIq = parcelRequire("ragIq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $fVnbM = parcelRequire("fVnbM");

var $3Tty1 = parcelRequire("3Tty1");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $g5X3G = parcelRequire("g5X3G");

var $imS60 = parcelRequire("imS60");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $6UAdF = parcelRequire("6UAdF");

var $eojy4 = parcelRequire("eojy4");

var $7OTah = parcelRequire("7OTah");

var $kj1di = parcelRequire("kj1di");

var $38r5c = parcelRequire("38r5c");

var $5lE9L = parcelRequire("5lE9L");
const $a32f27c74f4bd66c$var$useAnalyticsAttributes = (type)=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!type) return;
        const projectType = (0, $2vSU6.toProjectType)(type.toLowerCase());
        if (!projectType) return;
        const edition = (0, $ldyPw.getEditionForProject)(projectType, appEditions);
        if (!edition) return;
        return {
            edition: edition
        };
    }, [
        appEditions,
        type
    ]);
};
const $a32f27c74f4bd66c$var$FullPageIssueApp = ({ onChangeIssue: onChangeIssue, issueResults: issueResults, view: view, projectType: projectType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isFetching = (0, $38r5c.useIsFetching)();
    const { exitFullPageIssueAppMode: exitFullPageIssueAppMode, selectNextIssue: selectNextIssue, selectPreviousIssue: selectPreviousIssue } = (0, $7OTah.useSelectedIssueActions)();
    const onBackToSearch = (0, $5uXOq.useCallback)(()=>{
        // Clear the selected issue key from the URL and return to normal view mode
        onChangeIssue((0, $g5X3G.toIssueKey)(''), true);
        exitFullPageIssueAppMode();
    }, [
        exitFullPageIssueAppMode,
        onChangeIssue
    ]);
    const onBackToSearchByButton = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent.clone(), 'returnToSearch');
        onBackToSearch();
    }, [
        onBackToSearch
    ]);
    const onBackToSearchByKeyboardShortcut = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'issue'
        }), 'returnToSearch', {
            keyPressed: 'z',
            keyboardShortcut: true
        });
        onBackToSearch();
    }, [
        onBackToSearch,
        createAnalyticsEvent
    ]);
    const onNextIssue = (0, $5uXOq.useCallback)(()=>{
        if (selectNextIssue()) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'nextIssue', {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        selectNextIssue
    ]);
    const onPreviousIssue = (0, $5uXOq.useCallback)(()=>{
        if (selectPreviousIssue()) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'previousIssue', {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        selectPreviousIssue
    ]);
    // If a new search is being run and we do not have forced issue selection (i.e. issue app pagination) then return to
    // normal view mode. This can happen when a filter is clicked in the sidebar or browser history navigation.
    (0, $5uXOq.useEffect)(()=>{
        if (isFetching) exitFullPageIssueAppMode();
    }, [
        exitFullPageIssueAppMode,
        isFetching
    ]);
    const backToSearch = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "issue-navigator.ui.full-page-issue-app.return-to-search",
        onClick: onBackToSearchByButton,
        interactionName: "issue-navigator-full-page-issue-app-return-to-search"
    }, formatMessage((0, $5lE9L.default).returnText));
    const issueResultsData = (0, $8Uumt.useFragment)((0, $ragIq.default), issueResults);
    const viewData = (0, $8Uumt.useFragment)((0, $3mkkt.default), view);
    const fieldSetIds = (0, $5uXOq.useMemo)(()=>viewData?.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData?.fieldSets?.edges
    ]);
    const { hasPrevious: hasPrevious, isLoadingPrevious: isLoadingPrevious, onLoadPrevious: onLoadPrevious, hasNext: hasNext, isLoadingNext: isLoadingNext, onLoadNext: onLoadNext } = (0, $kj1di.useInfiniteScroll)({
        fieldSetIds: fieldSetIds,
        view: null
    });
    const selectedIssueKey = (0, $7OTah.useSelectedIssueKey)();
    const edges = issueResultsData?.edges ?? [];
    const isFirstIssueSelected = edges[0]?.node?.key === selectedIssueKey;
    const isLastIssueSelected = edges[edges.length - 1]?.node?.key === selectedIssueKey;
    // Automatically fetch previous and next pages while navigating issues in full page mode
    (0, $5uXOq.useEffect)(()=>{
        if (isFirstIssueSelected && hasPrevious && !isLoadingPrevious) onLoadPrevious?.();
    }, [
        hasPrevious,
        isFirstIssueSelected,
        isLoadingPrevious,
        onLoadPrevious
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isLastIssueSelected && hasNext && !isLoadingNext) onLoadNext?.();
    }, [
        hasNext,
        isLastIssueSelected,
        isLoadingNext,
        onLoadNext
    ]);
    let attributes;
    if ((0, $4R6GH.fg)('add-attribute-required-for-colorful-labels-expe')) // eslint-disable-next-line react-hooks/rules-of-hooks
    attributes = $a32f27c74f4bd66c$var$useAnalyticsAttributes(projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "full-page-issue-app"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $6UAdF.ANALYTICS_LIST_VIEW_SOURCE_NAME),
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        ...attributes ? {
            attributes: attributes
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: {
            z: {
                callback: onBackToSearchByKeyboardShortcut
            },
            j: {
                callback: onNextIssue
            },
            k: {
                callback: onPreviousIssue
            }
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eojy4.default), {
        isEmbedView: false,
        extraHeaderActions: backToSearch,
        issueResults: issueResultsData ?? null,
        view: viewData ?? null
    })));
};
var $a32f27c74f4bd66c$export$2e2bcd8739ae039 = $a32f27c74f4bd66c$var$FullPageIssueApp;

});
parcelRegister("3mkkt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3361b148cbcd4cd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6ce74782ae0a54866642080a61a9fa9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d3361b148cbcd4cd$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsScope"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_FullPageIssueApp_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_view"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                },
                {
                    "kind": "Variable",
                    "name": "scope",
                    "variableName": "fieldSetsScope"
                }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$d3361b148cbcd4cd$var$node.hash = "064f112e625b1650c56fe569682b1195";
var $d3361b148cbcd4cd$export$2e2bcd8739ae039 = $d3361b148cbcd4cd$var$node;

});

parcelRegister("ragIq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e254396e0247514b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e191fe8f978a91a8364f661a75b25c8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e254396e0247514b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_FullPageIssueApp_issueResults",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_issueResults"
        }
    ],
    "type": "JiraIssueConnection"
};
$e254396e0247514b$var$node.hash = "c76ea1c159a6e1be56c13b6262324ca3";
var $e254396e0247514b$export$2e2bcd8739ae039 = $e254396e0247514b$var$node;

});

parcelRegister("3Tty1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ba57d5dc6c0de0a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $9IeM0 = parcelRequire("9IeM0");

var $4lkOX = parcelRequire("4lkOX");

var $h0GOb = parcelRequire("h0GOb");

var $k4r7E = parcelRequire("k4r7E");

var $9fuVs = parcelRequire("9fuVs");

var $kspvB = parcelRequire("kspvB");
let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
let $6ba57d5dc6c0de0a$var$subscription = null;
const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
    const parentRegistry = (0, $5uXOq.useContext)((0, $9fuVs.ShortcutRegistryContext)) || (0, $k4r7E.rootRegistry);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                keyMap: (0, $kspvB.bindKeyMapWithErrorHandling)(keyMap, location, createAnalyticsEvent({
                    action: 'pressed',
                    actionSubject: 'keyboardShortcut'
                })),
                label: label
            })), [
        parentRegistry,
        keyMap,
        location,
        createAnalyticsEvent,
        label
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
        const removeKeyMap = addKeyMap();
        return ()=>{
            removeKeyMap();
            $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
            if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                $6ba57d5dc6c0de0a$var$subscription = null;
            }
        };
    }, [
        addKeyMap
    ]);
    (0, $5uXOq.useEffect)(()=>{
        $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $h0GOb.default)().subscribe((0, $4lkOX.default));
    }, [
        parentRegistry,
        keyMap
    ]);
    return null;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, $9IeM0.useKeyboardShortcutsToggle), ...props })=>{
    const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
    return isEnabled && !false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
};

});
parcelRegister("9IeM0", function(module, exports) {

$parcel$export(module.exports, "useKeyboardShortcutsToggle", () => $dc712fc9bec05022$export$a33a81f1fc5458ad);

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $j8DrX = parcelRequire("j8DrX");

var $8zOmE = parcelRequire("8zOmE");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState().isEnabled;
        const status = currentState ? 'off' : 'on';
        const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
        try {
            await (0, $eusud.performPutRequest)(url);
            setState({
                isEnabled: !currentState,
                error: null
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                isEnabled: !currentState
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'keyboardShortcutToggleFailure',
                    packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                },
                error: err
            });
        }
    };
const $dc712fc9bec05022$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isEnabled: false ? false : !((0, $j8DrX.default)('ajs-keyboard-shortcuts-enabled') === 'false'),
        error: null
    },
    actions: {
        // @ts-expect-error - TS2322 - Type '( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>' is not assignable to type 'ActionThunk<{ isEnabled: boolean; error: null; }, { toggle: ( analyticsEvent: UIAnalyticsEventInterface) => ({ setState, getState }: StoreActionApi<State>) => Promise<void>; }>'.
        toggle: $dc712fc9bec05022$export$b62f67be35e65859
    }
});
const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, $3sQ5x.createHook)($dc712fc9bec05022$var$Store);

});

parcelRegister("4lkOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f11d50ddafbb6f85$export$2e2bcd8739ae039);

var $h0GOb = parcelRequire("h0GOb");

var $k4r7E = parcelRequire("k4r7E");
const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
var /**
 * Manages key sequence inputs to execute predefined actions or clear unmatched sequences. This function ensures efficient handling of user inputs by checking against existing sequences and preparing for potential future matches.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
    const { sequence: sequence, e: e } = keySequence || {};
    const activeKeyMap = (0, $k4r7E.rootRegistry).getActiveKeyMap();
    if (sequence !== undefined && activeKeyMap[sequence]) {
        activeKeyMap[sequence].callback(e);
        (0, $h0GOb.flush)();
    } else {
        // Are there any sequences that might be activated with more key presses?
        const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
        if (!isFutureMatchPossible) (0, $h0GOb.flush)();
    }
};

});
parcelRegister("h0GOb", function(module, exports) {

$parcel$export(module.exports, "default", () => $849cd54ac4017470$export$2e2bcd8739ae039);
$parcel$export(module.exports, "flush", () => $849cd54ac4017470$export$4909b86c8034bf73);
/**
 * An observable that emits key sequences as a string representation
 *
 * Examples:
 *
 * g i
 * shift+enter
 */ 
var $kVLXA = parcelRequire("kVLXA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("jG6Un");
parcelRequire("eSGL3");
parcelRequire("1oQta");
parcelRequire("4kRRr");
parcelRequire("d0pqD");
parcelRequire("iQCJJ");
parcelRequire("fjPtF");
parcelRequire("2R2to");

var $lIZQG = parcelRequire("lIZQG");
const $849cd54ac4017470$var$ignoredKeys = {
    Control: true,
    Meta: true,
    Shift: true,
    Alt: true,
    AltGraph: true,
    CapsLock: true,
    Fn: true,
    FnLock: true,
    Hyper: true,
    NumLock: true,
    OS: true,
    ScrollLock: true,
    Super: true,
    Symbol: true,
    SymbolLock: true
};
/**
 * Skipping few input types to allow keydown event propagation to it's parent element
 * inputMode - react-select or select or combo
 * type - skipping these inputtypes (checkbox, radio) to support shortcuts like
 *        e(EPIC panel) or v(VERSION panel) or n(board card selection) in board and backlog
 * This condition added as a part of https://a11y.atlassian.net/browse/JCA11Y-1317
 */ const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly Control: true; readonly Meta: true; readonly Shift: true; readonly Alt: true; readonly AltGraph: true; readonly CapsLock: true; readonly Fn: true; readonly FnLock: true; readonly Hyper: true; ... 5 more ...; readonly SymbolLock: true; }'.
    (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const elBlankets = document.querySelectorAll('.aui-blanket');
    if (elBlankets.length === 0) // no aui-blanket in DOM, so it means it's closed
    return true;
    const isAllHidden = Array.from(elBlankets || []).every((el)=>{
        if (el.getAttribute('aria-hidden') === 'true' || // when `el.getAttribute('hidden')` returns an empty string, it means the element has the `hidden` attribute and it's invisible.
        el.getAttribute('hidden') !== null) return true;
        return false;
    });
    return isAllHidden;
};
let $849cd54ac4017470$var$key$;
const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
    if (!$849cd54ac4017470$var$key$) {
        $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, $lIZQG.toKeyWithModifiers));
        const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
            if (!key || !seq) return undefined;
            return {
                sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                e: key.e
            };
        });
        $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
    }
    return $849cd54ac4017470$var$key$;
};
const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
    $849cd54ac4017470$var$flush$.next();
};

});


parcelRegister("kspvB", function(module, exports) {

$parcel$export(module.exports, "bindKeyMapWithErrorHandling", () => $f9e30ab2465f6f16$export$77477772a9b904da);

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");
const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common', analyticsEvent)=>(e)=>{
        try {
            if (analyticsEvent && (0, $4R6GH.fg)('log-hotkey-analytics')) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'keyboardShortcut pressed', {
                key: key
            });
            callback(e);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
        }
    };
const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location, analyticsEvent)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(keyMap).reduce((map, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...map,
            [key]: {
                ...keyMap[key],
                callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location, analyticsEvent)
            }
        }), {});

});


parcelRegister("eojy4", function(module, exports) {

$parcel$export(module.exports, "default", () => $757f42b291a6a665$export$2e2bcd8739ae039);

var $7loir = parcelRequire("7loir");

var $efKfR = parcelRequire("efKfR");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $cSD7y = parcelRequire("cSD7y");

var $b3DTW = parcelRequire("b3DTW");

var $FTaAj = parcelRequire("FTaAj");

var $7eqRV = parcelRequire("7eqRV");

var $5gJcp = parcelRequire("5gJcp");

var $iXVV6 = parcelRequire("iXVV6");

var $g5X3G = parcelRequire("g5X3G");

var $dZw8H = parcelRequire("dZw8H");

var $kxZPA = parcelRequire("kxZPA");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $2su1H = parcelRequire("2su1H");

var $7OTah = parcelRequire("7OTah");

var $cqgcE = parcelRequire("cqgcE");

var $6Hhfn = parcelRequire("6Hhfn");

var $6UAdF = parcelRequire("6UAdF");

var $a8lIB = parcelRequire("a8lIB");

var $9aomo = parcelRequire("9aomo");

var $ltUBN = parcelRequire("ltUBN");


const $757f42b291a6a665$var$AsyncIssueAppComponent = (0, $cSD7y.componentWithFG)('make_nins_issue_app_lazyforpaint', // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyForPaint)(()=>(parcelRequire("gG7bT")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
}), // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("gG7bT")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
}));
const $757f42b291a6a665$var$AsyncIssueAppUsingLoadingPhases = ({ isEmbedView: isEmbedView, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eqRV.IssueBoundary), {
        packageName: "issue-navigator",
        isEmbedView: isEmbedView,
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b3DTW.UnknownErrorView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($757f42b291a6a665$var$AsyncIssueAppComponent, rest));
const $757f42b291a6a665$var$issueCardChangeExcludedEventTypes = [
    (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_REQUESTED,
    (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_FAILED,
    (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED,
    (0, $FTaAj.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED
];
const $757f42b291a6a665$var$useJSCM1CompatibleActions = (connectionId, fieldSetIds)=>{
    const { deselectIssue: deselectIssue, exitFullPageIssueAppMode: exitFullPageIssueAppMode, setSelectedIssueByKey: setSelectedIssueByKey } = (0, $7OTah.useSelectedIssueActions)();
    const onDeleteIssue = (0, $cqgcE.useOnDeleteIssue)(connectionId);
    const onIssueByFieldsRefetch = (0, $6Hhfn.useIssueByFieldsRefetch)(fieldSetIds);
    return {
        deselectIssue: deselectIssue,
        exitFullPageIssueAppMode: exitFullPageIssueAppMode,
        setSelectedIssueByKey: setSelectedIssueByKey,
        onDeleteIssue: onDeleteIssue,
        onIssueByFieldsRefetch: onIssueByFieldsRefetch
    };
};
const $757f42b291a6a665$var$IssueAppWithData = ({ IssueApp: IssueApp = $757f42b291a6a665$var$AsyncIssueAppUsingLoadingPhases, extraHeaderActions: extraHeaderActions, isEmbedView: isEmbedView, issueResults: issueResults, view: view })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_APP_START);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_APP_END);
    }, []);
    const selectedIssueKey = (0, $7OTah.useSelectedIssueDebouncedState)();
    const issueResultsData = (0, $8Uumt.useFragment)((0, $efKfR.default), issueResults);
    const viewData = (0, $8Uumt.useFragment)((0, $7loir.default), view);
    const fieldSetIds = (0, $5uXOq.useMemo)(()=>viewData?.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData?.fieldSets?.edges
    ]);
    const { onInteractive: onInteractive } = (0, $2su1H.useStartNinIssueAppAnalytics)(selectedIssueKey);
    const issueAppMetrics = (0, $5uXOq.useMemo)(()=>({
            onInteractive: onInteractive
        }), [
        onInteractive
    ]);
    const { deselectIssue: deselectIssue, exitFullPageIssueAppMode: exitFullPageIssueAppMode, setSelectedIssueByKey: setSelectedIssueByKey, onDeleteIssue: onDeleteIssue, onIssueByFieldsRefetch: onIssueByFieldsRefetch } = $757f42b291a6a665$var$useJSCM1CompatibleActions(issueResultsData?.__id, fieldSetIds);
    const refetchCallback = (0, $5uXOq.useRef)(onIssueByFieldsRefetch);
    refetchCallback.current = onIssueByFieldsRefetch;
    const onIssueDeleteSuccess = (0, $5uXOq.useCallback)(({ issueKey: deletedIssueKey })=>{
        const issueKeyToSelect = onDeleteIssue(deletedIssueKey);
        if (!issueKeyToSelect.length) {
            deselectIssue(); // Return to list view if we were in full page mode
            exitFullPageIssueAppMode();
        } else setSelectedIssueByKey((0, $g5X3G.toIssueKey)(issueKeyToSelect));
    }, [
        deselectIssue,
        exitFullPageIssueAppMode,
        onDeleteIssue,
        setSelectedIssueByKey
    ]);
    const onIssueKeyChange = (0, $5uXOq.useCallback)((issueKeys)=>{
        setSelectedIssueByKey(issueKeys.toIssueKey);
    }, [
        setSelectedIssueByKey
    ]);
    const issueContainerMaxWidth = (0, $4R6GH.fg)('jracloud-75406-remove-excessive-padding-from-side') ? (0, $5gJcp.getIssueContainerIncreasedMaxWidth)() : (0, $5gJcp.getIssueContainerDefaultMaxWidth)(); // When we're in non-embedded view (i.e. full page) we need to define a max width to ensure correct full page
    // styling within the issue app.
    const maxWidth = !isEmbedView ? issueContainerMaxWidth : undefined;
    let isFullPageIssueAppMode = false;
    if ((0, $dCm1o.isVisualRefreshEnabled)()) // eslint-disable-next-line react-hooks/rules-of-hooks
    isFullPageIssueAppMode = (0, $7OTah.useIsFullPageIssueAppMode)();
    const shouldWrapMargin = !isFullPageIssueAppMode && (0, $dCm1o.isVisualRefreshEnabled)();
    if ((0, $4R6GH.fg)('jsc_inline_editing_field_refactor')) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $ltUBN.useScrollToActivityFeed)(selectedIssueKey);
    if (!selectedIssueKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageErrorReady), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($757f42b291a6a665$var$IssueAppContainer, {
        isEmbedView: isEmbedView,
        shouldWrapMargin: shouldWrapMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9aomo.default), {
        issueResults: issueResultsData ?? null,
        extraHeaderActions: extraHeaderActions,
        isEmbedView: isEmbedView,
        maxWidth: maxWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($757f42b291a6a665$var$IssueAppHeightAdjustment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "issueNavigatorEmbeddedIssueView",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueApp, {
        metrics: issueAppMetrics,
        key: selectedIssueKey,
        isEmbedView: isEmbedView,
        analyticsSource: (0, $6UAdF.ANALYTICS_SOURCE),
        issueKey: (0, $g5X3G.toIssueKey)(selectedIssueKey),
        issueMaxWidth: maxWidth,
        onIssueKeyChange: onIssueKeyChange,
        onChange: (event)=>{
            if (event && !$757f42b291a6a665$var$issueCardChangeExcludedEventTypes.includes(event.type)) refetchCallback.current(String(selectedIssueKey));
        },
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        shouldSetInitialFocus: false
    }))));
};
var $757f42b291a6a665$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $757f42b291a6a665$var$IssueAppWithData;
const $757f42b291a6a665$var$IssueAppContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldWrapMargin: shouldWrapMargin, isEmbedView: isEmbedView, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _16jlkb7n _4t3i1osq _1ul9idpf _1e0c1txw _2lx21bp4 _vchhusvi",
            __cmplp.shouldWrapMargin && "_2hwx10v4",
            !__cmplp.isEmbedView && "_ca0qxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $757f42b291a6a665$var$IssueAppHeightAdjustment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1tkeidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7loir", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cec674991979ea9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b57212afd88a65d6ab1b44dd40c60183>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5cec674991979ea9$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsScope"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueAppWithData_view",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                },
                {
                    "kind": "Variable",
                    "name": "scope",
                    "variableName": "fieldSetsScope"
                }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$5cec674991979ea9$var$node.hash = "741c31d0c1ebc1e3fdeb37896e791449";
var $5cec674991979ea9$export$2e2bcd8739ae039 = $5cec674991979ea9$var$node;

});

parcelRegister("efKfR", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e62e5ab28765e44$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1eb167471fb64a02bbc7a0985243c9bc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3e62e5ab28765e44$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueAppWithData_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "headerActions_issueNavigator"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$3e62e5ab28765e44$var$node.hash = "267fadd3844f360bfc7e5d9f255f3ee7";
var $3e62e5ab28765e44$export$2e2bcd8739ae039 = $3e62e5ab28765e44$var$node;

});

parcelRegister("b3DTW", function(module, exports) {

$parcel$export(module.exports, "UnknownErrorView", () => $37e65e4dbd5a0c18$export$f23f26771420affd);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $hTEpF = parcelRequire("hTEpF");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $bH03R = parcelRequire("bH03R");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $iEg2R = parcelRequire("iEg2R");

var $1HGxj = parcelRequire("1HGxj");
const $37e65e4dbd5a0c18$var$ErrorImage = ()=>{
    return (0, $4R6GH.fg)('replace_error_display_with_empty_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $37e65e4dbd5a0c18$var$imageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bH03R.default), {
        width: 90,
        height: 130,
        alt: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bH03R.default), {
        width: 90,
        height: 130,
        alt: ""
    });
};
const $37e65e4dbd5a0c18$export$f23f26771420affd = ()=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "unknownError",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            errorType: 'unknown',
            source: globalThis.window?.location?.pathname ?? '',
            referrer: globalThis.document?.referrer ?? '',
            timestamp: new Date().toISOString(),
            userAgent: globalThis.navigator?.userAgent ?? '',
            route: `${globalThis.window?.location?.pathname ?? ''}${globalThis.window?.location?.search ?? ''}`
        }
    }, (0, $4R6GH.fg)('replace_error_display_with_empty_state') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "issue-view-errors.ui.unknown-error-view.unknown-error-view",
        header: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1HGxj.messages).unknownErrorHeaderIssueTermRefresh : (0, $1HGxj.messages).unknownErrorHeader),
        description: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1HGxj.messages).unknownErrorDescriptionIssueTermRefresh : (0, $1HGxj.messages).unknownErrorDescription),
        renderImage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37e65e4dbd5a0c18$var$ErrorImage, null)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iEg2R.ErrorDisplay), {
        header: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1HGxj.messages).unknownErrorHeaderIssueTermRefresh : (0, $1HGxj.messages).unknownErrorHeader),
        description: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1HGxj.messages).unknownErrorDescriptionIssueTermRefresh : (0, $1HGxj.messages).unknownErrorDescription),
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($37e65e4dbd5a0c18$var$ErrorImage, null)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
const $37e65e4dbd5a0c18$var$imageWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

});
parcelRegister("bH03R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a8185200722e377$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $9YK03 = parcelRequire("9YK03");
const $2a8185200722e377$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($9YK03)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($9YK03))
});
var $2a8185200722e377$export$2e2bcd8739ae039 = $2a8185200722e377$var$Illustration;
// for advanced use only
const $2a8185200722e377$export$a179c88182cb9d56 = [
    0,
    0,
    104,
    140
];

});
parcelRegister("9YK03", function(module, exports) {
module.exports = new URL("empty-search-error-colour.f0aa9e5e.svg", import.meta.url).toString();

});


parcelRegister("iEg2R", function(module, exports) {

$parcel$export(module.exports, "ErrorDisplay", () => $42c3be45cf82ac6a$export$d56b0569bceb92ae);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $42c3be45cf82ac6a$export$d56b0569bceb92ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42c3be45cf82ac6a$var$Container, {
        "data-testid": "issue-view-errors.common.ui.error-display.permission-error-display"
    }, props.image, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42c3be45cf82ac6a$var$Heading, null, props.header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42c3be45cf82ac6a$var$Description, null, props.description), props.children);
$42c3be45cf82ac6a$export$d56b0569bceb92ae.defaultProps = {
    description: undefined,
    children: null
};
/**
 * Duplicated from `src/packages/issue/issue-view/src/views/issue-details/issue-modal/styled.tsx`
 *
 * TODO: Derive properly on `src/packages/issue/issue-view/src/views/issue-details/error` cleanup
 */ const $42c3be45cf82ac6a$var$modalDialogContainerSelectorName = 'jira.issue-view.issue-details.modal-dialog-container';
const $42c3be45cf82ac6a$var$MODAL_DIALOG_CONTAINER_COMPONENT_SELECTOR = `[data-component-selector="${$42c3be45cf82ac6a$var$modalDialogContainerSelectorName}"]`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $42c3be45cf82ac6a$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _2lx21bp4 _syaz1fxt _1e0c1txw _1bah1h6o _4cvr1h6o _ca0qxncg _17ipxncg _1ksgidpf",
            __cmplp.className
        ])
    });
});
const $42c3be45cf82ac6a$var$Heading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8lodh _19pkutpp _otyrutpp _p12f1osq",
            __cmplp.className
        ])
    });
});
const $42c3be45cf82ac6a$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1HGxj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5157af2738c78f52$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5157af2738c78f52$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    unknownErrorHeader: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-header",
        "defaultMessage": "We couldn't connect to that issue"
    },
    unknownErrorDescription: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-description",
        "defaultMessage": "Make sure that this issue actually exists in that project. If it does, try again in a few minutes. If you still can't link to the issue, contact your Jira admin."
    },
    unknownErrorHeaderIssueTermRefresh: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-header-issue-term-refresh",
        "defaultMessage": "We couldn't connect to that work item."
    },
    unknownErrorDescriptionIssueTermRefresh: {
        "id": "issue-view-errors.unknown-error-view.unknown-error-description-issue-term-refresh",
        "defaultMessage": "Make sure that this work item actually exists in that project. If it does, try again in a few minutes. If you still can't link to the work item, contact your Jira admin."
    }
});

});


parcelRegister("FTaAj", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $0a7f3a2a8450d0c8$export$8db21fc94823e1cc);
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $0a7f3a2a8450d0c8$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$export$8db21fc94823e1cc = {
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED]: $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED]: $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED]: $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED,
    [$0a7f3a2a8450d0c8$var$SUBTASK_ADDED]: $0a7f3a2a8450d0c8$var$SUBTASK_ADDED,
    [$0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED,
    [$0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("7eqRV", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $e3c8771effba3477$export$fbf48ede0cf52b5a);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $lb0Dk = parcelRequire("lb0Dk");
const $e3c8771effba3477$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $e3c8771effba3477$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("lb0Dk", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $bf9ca492e3d15685$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $iMqhh = parcelRequire("iMqhh");

var $4R6GH = parcelRequire("4R6GH");

var $hCy6k = parcelRequire("hCy6k");

var $3441h = parcelRequire("3441h");
const $bf9ca492e3d15685$var$fullpageStyles = null;
const $bf9ca492e3d15685$var$modalStyles = null;
const $bf9ca492e3d15685$var$customSpacingStylesWithIncreasedWidth = null;
const $bf9ca492e3d15685$var$customSpacingStylesWithDefaultWidth = null;
const $bf9ca492e3d15685$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        (0, $4R6GH.fg)('jracloud-75406-remove-excessive-padding-from-side') ? $bf9ca492e3d15685$var$customSpacingStylesWithIncreasedWidth : $bf9ca492e3d15685$var$customSpacingStylesWithDefaultWidth,
        isEmbedView !== true && isModalView !== true ? $bf9ca492e3d15685$var$fullpageStyles : null,
        isModalView === true ? $bf9ca492e3d15685$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMqhh.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3441h))),
        className: (0, $bwpsq.default)([
            (0, $4R6GH.fg)('jracloud-75406-remove-excessive-padding-from-side') ? "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi" : "_p12f1ypn _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("iMqhh", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $db79d17d45755de5$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $db79d17d45755de5$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $db79d17d45755de5$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eIGIx = parcelRequire("eIGIx");

var $4R6GH = parcelRequire("4R6GH");


var $8kj45 = parcelRequire("8kj45");

var $doZTA = parcelRequire("doZTA");

var $k1L82 = parcelRequire("k1L82");

var $hhMVP = parcelRequire("hhMVP");
const $db79d17d45755de5$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const { Provider: $db79d17d45755de5$var$Provider, Consumer: $db79d17d45755de5$var$Consumer } = $db79d17d45755de5$export$37eeac5cc5245b18;
const $db79d17d45755de5$export$55a90a8e865a39b5 = 700;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$db79d17d45755de5$export$55a90a8e865a39b5}px)`;
const $db79d17d45755de5$export$ddd398a95f85cd75 = 850;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL = `(max-width: ${$db79d17d45755de5$export$ddd398a95f85cd75}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $db79d17d45755de5$var$useRouteKey() {
    const [routeState] = (0, $doZTA.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $db79d17d45755de5$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $db79d17d45755de5$var$useRouteKey();
    (0, $hhMVP.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $hhMVP.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4);
        (0, $hhMVP.setCachedIsCompactValue)(defaultState, key);
    }
    const { isInDiscussionLayoutExperiment: isInDiscussionLayoutExperiment } = (0, $k1L82.useUserPreferredWorkItemLayout)();
    const query = isInDiscussionLayoutExperiment ? $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL : $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY;
    const [isCompact, setIsCompact] = (0, $5uXOq.useState)(defaultState);
    const onChange = (0, $eIGIx.useCallbackWithCondition)((state)=>{
        (0, $hhMVP.setCachedIsCompactValue)(state, key);
        setIsCompact(state);
    }, [
        key
    ], ()=>(0, $4R6GH.fg)('jfp_magma_issue-stability-phase1'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8kj45.ContainerQueryObserver), {
        query: query,
        onChange: onChange,
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$Provider, {
        value: isCompact
    }, children));
};
const $db79d17d45755de5$export$20feb77b5b617e44 = $db79d17d45755de5$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db79d17d45755de5$var$StyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $7093eea63dce9286$export$ee15e0cd1efafcb4 = false;

parcelRegister("8kj45", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $ed10e3c030ea0408$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $ed10e3c030ea0408$var$QueryContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
let $ed10e3c030ea0408$var$currentIdSeed = 0;
function $ed10e3c030ea0408$var$generateAttributeValue() {
    return `indicator-span-${$ed10e3c030ea0408$var$currentIdSeed++}`;
}
function $ed10e3c030ea0408$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $5uXOq.useState)(defaultState);
    const handleQueryStatusChange = (0, $5uXOq.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $ed10e3c030ea0408$export$b66a67697973e01() {
    const currentState = (0, $5uXOq.useContext)($ed10e3c030ea0408$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $ed10e3c030ea0408$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $5uXOq.useMemo)(()=>$ed10e3c030ea0408$var$generateAttributeValue(), []);
    const spanRef = (0, $5uXOq.useRef)(null);
    const containerRef = (0, $5uXOq.useRef)(null);
    const currentState = $ed10e3c030ea0408$export$b66a67697973e01();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed10e3c030ea0408$var$ContainerToBeQueried = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("k1L82", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainers", () => $725285d3420dc4d6$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $725285d3420dc4d6$export$5f49a43487b268);
$parcel$export(module.exports, "useLayoutContainerByTypeMemoised", () => $725285d3420dc4d6$export$ef5966e43b13b4a9);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $725285d3420dc4d6$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $725285d3420dc4d6$export$5962da0433486667);
$parcel$export(module.exports, "useUserPreferredWorkItemLayout", () => $725285d3420dc4d6$export$9889eea62fdfa091);
$parcel$export(module.exports, "useIssueLayoutActions", () => $725285d3420dc4d6$export$1e5e9fc877a47cd9);

var $5uXOq = parcelRequire("5uXOq");

var $eIGIx = parcelRequire("eIGIx");

var $egBua = parcelRequire("egBua");

var $6s1PB = parcelRequire("6s1PB");

var $eNNkf = parcelRequire("eNNkf");

var $2gCtH = parcelRequire("2gCtH");


var $93Yeu = parcelRequire("93Yeu");

var $4R6GH = parcelRequire("4R6GH");

var $2vSU6 = parcelRequire("2vSU6");

var $2YZCu = parcelRequire("2YZCu");

var $bCdIp = parcelRequire("bCdIp");

var $kI4MM = parcelRequire("kI4MM");

var $cNJ33 = parcelRequire("cNJ33");
const $725285d3420dc4d6$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $kI4MM.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $725285d3420dc4d6$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $kI4MM.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $egBua.useEnabledHiddenFields)();
    return (0, $eIGIx.useMemoWithCondition)(()=>[
            (0, $cNJ33.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
        ], [
        container?.items.nodes,
        fieldsHiddenByUim
    ], ()=>(0, $4R6GH.fg)('jfp_magma_issue-stability-phase1'));
};
const $725285d3420dc4d6$export$ef5966e43b13b4a9 = (issueKey, type)=>{
    const [containers] = (0, $kI4MM.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    const fieldsHiddenByUim = (0, $egBua.useEnabledHiddenFields)();
    const filteredItems = (0, $5uXOq.useMemo)(()=>{
        return (0, $cNJ33.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim);
    }, [
        container,
        fieldsHiddenByUim
    ]);
    return [
        filteredItems
    ];
};
const $725285d3420dc4d6$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $kI4MM.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $725285d3420dc4d6$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $kI4MM.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $725285d3420dc4d6$export$9889eea62fdfa091 = ()=>{
    try {
        if (!(0, $4R6GH.fg)('issue_view_layouts_kill_switch')) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        /* eslint-disable react-hooks/rules-of-hooks */ const issueKey = (0, $2gCtH.useIssueKey)();
        const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
        const projectType = (0, $93Yeu.useProjectType)(projectKey);
        const isFullIssueView = (0, $2gCtH.useIsFullPageIssueView)();
        const [deprecatedUserPreferredLayout] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$2cf981c493d79a21));
        const [userPreferredLayout] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$39aaf586c7ee5202));
        const isMobile = (0, $bCdIp.default)();
        const isSoftwareOrBusiness = projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT);
        const shouldBeInLayoutExperiment = !isMobile && isSoftwareOrBusiness && isFullIssueView;
        if (!shouldBeInLayoutExperiment) return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
        const isInWideLayoutExperiment = shouldBeInLayoutExperiment && (0, $6s1PB.expVal)('wide_issue_layout_in_issue_view', 'is_enabled', false);
        const isInDiscussionLayoutExperiment = shouldBeInLayoutExperiment && (0, $6s1PB.expVal)('issue-view-side-panel-activity', 'isActivityInSidePanel', false);
        const userLayoutType = isInWideLayoutExperiment && userPreferredLayout && typeof userPreferredLayout === 'string' ? JSON.parse(userPreferredLayout)?.layoutType : null;
        /* eslint-enable react-hooks/rules-of-hooks */ const userSelectedLayout = isInWideLayoutExperiment // Use new value if wide layout experiment is enabled
         ? userLayoutType : deprecatedUserPreferredLayout;
        // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
        // but we keep it to avoid making too many changes in the codebase
        const isActivityInVerticalSidePanel = isInDiscussionLayoutExperiment && (userSelectedLayout === 'VERTICAL' || userSelectedLayout === 'DISCUSSION');
        return {
            isInDiscussionLayoutExperiment: Boolean(isInDiscussionLayoutExperiment),
            isInWideLayoutExperiment: Boolean(isInWideLayoutExperiment),
            // isActivityInVerticalSidePanel is not needed and can be derived from userSelectedLayout
            // but we keep it to avoid making too many changes in the codebase
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            userPreferredLayout: userSelectedLayout
        };
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useUserPreferredWorkItemLayout : ${error}`);
        return {
            isInDiscussionLayoutExperiment: false,
            isInWideLayoutExperiment: false,
            isActivityInVerticalSidePanel: false,
            userPreferredLayout: null
        };
    }
};
const $725285d3420dc4d6$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $kI4MM.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $5uXOq.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $5uXOq.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $5uXOq.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};

});
parcelRegister("egBua", function(module, exports) {

$parcel$export(module.exports, "useEnabledHiddenFields", () => $ea65d07999c73532$export$bb6c2b9159c3f32b);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $jrwZp = parcelRequire("jrwZp");

var $eoznE = parcelRequire("eoznE");
const $ea65d07999c73532$export$bb6c2b9159c3f32b = ()=>{
    (0, $gKZoD.di)((0, $jrwZp.useAdjustmentsEnabled), (0, $eoznE.useHiddenFields));
    const adjustmentsAreEnabled = (0, $jrwZp.useAdjustmentsEnabled)();
    const hiddenFields = (0, $eoznE.useHiddenFields)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("jrwZp", function(module, exports) {

$parcel$export(module.exports, "store", () => $db4845f733e81d44$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $db4845f733e81d44$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $db4845f733e81d44$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $db4845f733e81d44$export$5eb9c167b683d125);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $db4845f733e81d44$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $db4845f733e81d44$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($db4845f733e81d44$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $db4845f733e81d44$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-adjustments-context',
    initialState: $db4845f733e81d44$var$initialState,
    actions: $db4845f733e81d44$export$e324594224ef24da
});
const $db4845f733e81d44$export$a12f82a132dee079 = (0, $3sQ5x.createHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$358ad850b2f6d6fe = (0, $3sQ5x.createStateHook)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $db4845f733e81d44$export$4f2729981f4b81d2 = (0, $3sQ5x.createActionsHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$5eb9c167b683d125 = (0, $gg7kZ.createContainer)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("eoznE", function(module, exports) {

$parcel$export(module.exports, "useHiddenFields", () => $8c7bafd209de1659$export$de6fdc67c945e596);

var $6dDSs = parcelRequire("6dDSs");
var $3sQ5x = parcelRequire("3sQ5x");

var $1YewZ = parcelRequire("1YewZ");
const $8c7bafd209de1659$var$selectHiddenFields = (0, $6dDSs.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $8c7bafd209de1659$export$de6fdc67c945e596 = (0, $3sQ5x.createStateHook)((0, $1YewZ.store), {
    selector: $8c7bafd209de1659$var$selectHiddenFields
});

});
parcelRegister("1YewZ", function(module, exports) {

$parcel$export(module.exports, "store", () => $cf6a6312e4141eb7$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $cf6a6312e4141eb7$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $cf6a6312e4141eb7$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $cf6a6312e4141eb7$export$677b3e34bd14c681);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $3whHg = parcelRequire("3whHg");

var $hyCnL = parcelRequire("hyCnL");

var $boEP0 = parcelRequire("boEP0");

var $2NMWZ = parcelRequire("2NMWZ");

var $d30F5 = parcelRequire("d30F5");

var $8e24q = parcelRequire("8e24q");

var $cTj8m = parcelRequire("cTj8m");

var $i4uue = parcelRequire("i4uue");

var $3iUv8 = parcelRequire("3iUv8");

var $b8ZsE = parcelRequire("b8ZsE");

var $jDMtG = parcelRequire("jDMtG");

var $l0b2q = parcelRequire("l0b2q");

var $4MJXd = parcelRequire("4MJXd");

var $gHQFd = parcelRequire("gHQFd");

var $7JtDe = parcelRequire("7JtDe");
const $cf6a6312e4141eb7$var$name = 'issue-adjustments';
const $cf6a6312e4141eb7$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $cf6a6312e4141eb7$var$triggerFieldInitializationKey, viewType: $cf6a6312e4141eb7$var$scopedViewType, numberOfSupportedFields: $cf6a6312e4141eb7$var$numberOfSupportedFields, ...$cf6a6312e4141eb7$var$stateForResetAllFields } = $cf6a6312e4141eb7$export$d4c72bab9d6cc13a;
const $cf6a6312e4141eb7$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $b8ZsE.processChange,
    setFieldValue: $l0b2q.setFieldValue,
    initializeField: $8e24q.initializeField,
    initializeFields: $8e24q.initializeFields,
    startFieldsInitialisationTimeout: $d30F5.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $d30F5.successFieldsInitalisation,
    registerFields: $jDMtG.registerFields,
    unregisterFields: $jDMtG.unregisterFields,
    updateFields: $gHQFd.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($cf6a6312e4141eb7$var$stateForResetAllFields);
        },
    setError: $2NMWZ.setError,
    resetError: $2NMWZ.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $3whHg.setAppErrors,
    resetAppErrors: $3whHg.resetAppErrors,
    addAppsErrors: $3whHg.addAppsErrors,
    initializeNoScreenTab: $cTj8m.initializeNoScreenTab,
    initializeScreenTabs: $i4uue.initializeScreenTabs,
    updateScreenTabs: $7JtDe.updateScreenTabs,
    updateActiveScreenTab: $4MJXd.updateActiveScreenTab,
    detectAppliedChangesConflicts: $hyCnL.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $boEP0.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $boEP0.collectFieldsAppliedChangesHistory,
    setNotification: $3iUv8.setNotification,
    resetNotification: $3iUv8.resetNotification
};
const $cf6a6312e4141eb7$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: $cf6a6312e4141eb7$var$name,
    initialState: $cf6a6312e4141eb7$export$d4c72bab9d6cc13a,
    actions: $cf6a6312e4141eb7$export$e324594224ef24da
});
const $cf6a6312e4141eb7$export$37792a602e748c08 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe = {};
const $cf6a6312e4141eb7$export$c76e674a29843e21 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $cf6a6312e4141eb7$export$df4b0714e8177e0e = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe
});
const $cf6a6312e4141eb7$export$cb9a014ec14556d8 = (0, $3sQ5x.createActionsHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$export$677b3e34bd14c681 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("3whHg", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $87bccf3deeafaa75$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $87bccf3deeafaa75$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $87bccf3deeafaa75$export$24c821207687a907);
const $87bccf3deeafaa75$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $87bccf3deeafaa75$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $87bccf3deeafaa75$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("hyCnL", function(module, exports) {

$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $4c0b86f075c0ff6b$export$90d94f20d157e756);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $3whHg = parcelRequire("3whHg");

var $3iUv8 = parcelRequire("3iUv8");

var $lLAXK = parcelRequire("lLAXK");
const $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $4c0b86f075c0ff6b$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $19ec31e354320eb2$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $lLAXK.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $3whHg.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $3iUv8.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("2jyqu", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $9253211b05747618$export$a1fb57756f0de62b);

var $gB4mS = parcelRequire("gB4mS");


const $9253211b05747618$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $gB4mS.default)((0, $aded369bac156944$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $6e65040b988c460f$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

const $aded369bac156944$export$8280e5c6104c5b40 = 'ui-modifications';


const $19ec31e354320eb2$export$415cc1afa6445f90 = 'onInitChangeId';
const $19ec31e354320eb2$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("3iUv8", function(module, exports) {

$parcel$export(module.exports, "setNotification", () => $547ed651019edc98$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $547ed651019edc98$export$caafa3945f199bc7);
const $547ed651019edc98$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $547ed651019edc98$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("lLAXK", function(module, exports) {

$parcel$export(module.exports, "collectConflicts", () => $5d47c6c300e4a9ca$export$a06103ec99e4e394);

var $fr1K2 = parcelRequire("fr1K2");


var $bCvSM = parcelRequire("bCvSM");

const $5d47c6c300e4a9ca$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $5d47c6c300e4a9ca$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $78805f0b93715186$export$f674b7a3bbd94b5)) return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $bCvSM.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $5d47c6c300e4a9ca$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $5d47c6c300e4a9ca$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $ca611ff348f89182$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $ca611ff348f89182$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $ca611ff348f89182$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $ca611ff348f89182$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $ca611ff348f89182$export$e4ac32edd5da2ee7 = 'FIELD';
const $ca611ff348f89182$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("bCvSM", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $b1dea33557091402$export$e1cc7da28a1c4bb7);
const $b1dea33557091402$var$SET_NAME_METHOD = 'setName';
const $b1dea33557091402$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $b1dea33557091402$var$SET_VISIBLE_METHOD = 'setVisible';
const $b1dea33557091402$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $b1dea33557091402$var$SET_VALUE_METHOD = 'setValue';
const $b1dea33557091402$var$SET_REQUIRED_METHOD = 'setRequired';
const $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $b1dea33557091402$export$8325709d137b2606 = {
    fieldName: $b1dea33557091402$var$SET_NAME_METHOD,
    description: $b1dea33557091402$var$SET_DESCRIPTION_METHOD,
    isVisible: $b1dea33557091402$var$SET_VISIBLE_METHOD,
    isReadOnly: $b1dea33557091402$var$SET_READ_ONLY_METHOD,
    value: $b1dea33557091402$var$SET_VALUE_METHOD,
    isRequired: $b1dea33557091402$var$SET_REQUIRED_METHOD,
    optionsVisibility: $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $b1dea33557091402$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $b1dea33557091402$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $78805f0b93715186$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $78805f0b93715186$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("boEP0", function(module, exports) {

$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$7d0f534e5b16dcc9);


var $3vp6H = parcelRequire("3vp6H");
const $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $f5288ff27f25fb7e$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $78805f0b93715186$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $f5288ff27f25fb7e$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $3vp6H.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("3vp6H", function(module, exports) {

$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $23bcfa1804fc8fad$export$8a23b3e9a1749620);

const $23bcfa1804fc8fad$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $78805f0b93715186$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $23bcfa1804fc8fad$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $23bcfa1804fc8fad$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("2NMWZ", function(module, exports) {

$parcel$export(module.exports, "setError", () => $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $13e2b126ca97f7fe$export$7e5930c6217b1d4e);
const $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $13e2b126ca97f7fe$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("d30F5", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $e08f4de833312075$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $e08f4de833312075$export$cf768a695e83eefa);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");

var $1FDIy = parcelRequire("1FDIy");

var $2NMWZ = parcelRequire("2NMWZ");
const $e08f4de833312075$var$getTimeout = ()=>50000;
const $e08f4de833312075$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $e08f4de833312075$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $e08f4de833312075$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($e08f4de833312075$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $e08f4de833312075$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $e08f4de833312075$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status) || (0, $1FDIy.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $2NMWZ.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $e08f4de833312075$var$getTimeout(),
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $e08f4de833312075$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("1FDIy", function(module, exports) {

$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $9ea7c26aba3c4975$export$4cadeedb8c3f31f7);

var $6dDSs = parcelRequire("6dDSs");
const $9ea7c26aba3c4975$export$4cadeedb8c3f31f7 = (0, $6dDSs.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("8e24q", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $c1b779e01c06a231$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $c1b779e01c06a231$export$4a6b4707110b0552);

var $iLSUx = parcelRequire("iLSUx");
const $c1b779e01c06a231$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $c1b779e01c06a231$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("iLSUx", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $4854c3676fce92c1$export$50806045b617d116);

var $gKZoD = parcelRequire("gKZoD");

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $4854c3676fce92c1$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gKZoD.di)((0, $cmmj3.fireErrorAnalytics), (0, $gL80q.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $cmmj3.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("cmmj3", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $1359a69054531aa4$export$a27c21aa3ed8f0f1);

var $1nF7O = parcelRequire("1nF7O");

var $z11xo = parcelRequire("z11xo");
const $1359a69054531aa4$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $1359a69054531aa4$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $z11xo.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $1nF7O.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $1359a69054531aa4$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("z11xo", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $df5192e881ed2750$export$e19f9f08a6d79fd2);

var $3HlI9 = parcelRequire("3HlI9");
const $df5192e881ed2750$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $df5192e881ed2750$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $df5192e881ed2750$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $df5192e881ed2750$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $df5192e881ed2750$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $df5192e881ed2750$export$89a175d4190df42e = 'Invoke value functions failed:';
const $df5192e881ed2750$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $df5192e881ed2750$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $df5192e881ed2750$var$BAD_REQUEST = 400;
const $df5192e881ed2750$var$REQUEST_TIMEOUT = 408;
const $df5192e881ed2750$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $df5192e881ed2750$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $df5192e881ed2750$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($df5192e881ed2750$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $df5192e881ed2750$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($df5192e881ed2750$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($df5192e881ed2750$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($df5192e881ed2750$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $3HlI9.isClientFetchError)(error)) return $df5192e881ed2750$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("3HlI9", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $cbf82ad04131c769$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cbf82ad04131c769$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cbf82ad04131c769$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cbf82ad04131c769$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cbf82ad04131c769$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cbf82ad04131c769$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.cause.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("gL80q", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $968cd36658e5c86e$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $968cd36658e5c86e$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $968cd36658e5c86e$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $968cd36658e5c86e$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $968cd36658e5c86e$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $968cd36658e5c86e$export$ef45e4471aa21b27);

var $cmmj3 = parcelRequire("cmmj3");

var $3OTqu = parcelRequire("3OTqu");
const $968cd36658e5c86e$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $968cd36658e5c86e$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $3OTqu.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $968cd36658e5c86e$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$968cd36658e5c86e$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $968cd36658e5c86e$export$e4330d77fd93d1de = (viewType)=>$968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $968cd36658e5c86e$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $968cd36658e5c86e$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $968cd36658e5c86e$export$20eabd2b3ada6bf3(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $968cd36658e5c86e$export$b768d6a95f7a930(context) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $968cd36658e5c86e$export$b0297573c90085aa(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $968cd36658e5c86e$export$c0728caa743a409e(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $968cd36658e5c86e$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $968cd36658e5c86e$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("3OTqu", function(module, exports) {

$parcel$export(module.exports, "getViewConfiguration", () => $b8beb3418915829f$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $b8beb3418915829f$export$f0022a21ccd1f6be);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");
const $b8beb3418915829f$var$VIEW_CONFIGURATIONS = new Map();
const $b8beb3418915829f$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$b8beb3418915829f$var$VIEW_CONFIGURATIONS.has(viewType)) $b8beb3418915829f$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $b8beb3418915829f$export$176b6e68da08ffa2 = (viewType)=>$b8beb3418915829f$var$VIEW_CONFIGURATIONS.get(viewType);
const $b8beb3418915829f$export$e8091eff40c4f16e = ()=>{
    $b8beb3418915829f$var$VIEW_CONFIGURATIONS.clear();
};
const $b8beb3418915829f$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gKZoD.di)($b8beb3418915829f$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $5uXOq.useState)(()=>{
        $b8beb3418915829f$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("cTj8m", function(module, exports) {

$parcel$export(module.exports, "initializeNoScreenTab", () => $b87f070d69e40149$export$93459ad9bfd6c380);
const $b87f070d69e40149$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("i4uue", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $559bbe3e01414de7$export$7f7be235f64f029b);
const $559bbe3e01414de7$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("b8ZsE", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $926b03f8c2e312a1$export$352dfcce04d66748);

var $3ZT8o = parcelRequire("3ZT8o");

var $gKZoD = parcelRequire("gKZoD");

var $gL80q = parcelRequire("gL80q");

var $l6AQO = parcelRequire("l6AQO");
const $926b03f8c2e312a1$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("3ZT8o", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/** Used to generate unique IDs. */ var $2e91d6202798e8a1$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $2e91d6202798e8a1$var$uniqueId(prefix) {
    var id = ++$2e91d6202798e8a1$var$idCounter;
    return $jJVtR(prefix) + id;
}
module.exports = $2e91d6202798e8a1$var$uniqueId;

});

parcelRegister("l6AQO", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $2b658e9f553d1ad3$export$25441a03bb8f1cb0);

var $ajpes = parcelRequire("ajpes");

var $iLSUx = parcelRequire("iLSUx");
const $2b658e9f553d1ad3$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("jDMtG", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $5e78d8ed1ee13321$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $5e78d8ed1ee13321$export$1ca69a85bb7273de);

var $fr1K2 = parcelRequire("fr1K2");

var $kGsr8 = parcelRequire("kGsr8");
const $5e78d8ed1ee13321$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $5e78d8ed1ee13321$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("l0b2q", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $da1080104d423ca2$export$6556d46d2662453c);

var $l6AQO = parcelRequire("l6AQO");
const $da1080104d423ca2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("4MJXd", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $104b1b4dd763f6ee$export$21363496760d39cd);
const $104b1b4dd763f6ee$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("gHQFd", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $069ce0e12537855c$export$cceae62fd4d1ef0a);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $ajglJ = parcelRequire("ajglJ");

var $dA2NP = parcelRequire("dA2NP");

var $fKje4 = parcelRequire("fKje4");

var $dwG9p = parcelRequire("dwG9p");

var $dRfi6 = parcelRequire("dRfi6");

var $3whHg = parcelRequire("3whHg");

var $boEP0 = parcelRequire("boEP0");

var $hzAKL = parcelRequire("hzAKL");
const $069ce0e12537855c$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $boEP0.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $dA2NP.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $3whHg.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $80e7f3d73b333b84$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $80e7f3d73b333b84$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $80e7f3d73b333b84$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $hzAKL.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $dRfi6.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $fKje4.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(errorsByField)) throw new (0, $ajglJ.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $dwG9p.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $boEP0.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $80e7f3d73b333b84$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $80e7f3d73b333b84$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $80e7f3d73b333b84$export$f5d5f6bb902f1027 = '-1';
const $80e7f3d73b333b84$export$106087dcfd4fb129 = 100;

parcelRegister("ajglJ", function(module, exports) {

$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $907938b0f57574ed$export$9e8b5e552e255163);

var $2jqAp = parcelRequire("2jqAp");
class $907938b0f57574ed$export$9e8b5e552e255163 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("2jqAp", function(module, exports) {

$parcel$export(module.exports, "UiModificationsValidationError", () => $b8ce6491bf34e535$export$6e8165c81a6a65df);
class $b8ce6491bf34e535$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("dA2NP", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegistered", () => $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b);
const $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("fKje4", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $620a721e65ec1dbe$export$460820f27643954e);

var $gL80q = parcelRequire("gL80q");
const $620a721e65ec1dbe$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("dwG9p", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $8d92968018d86237$export$e1fce51bc5be90b7);
const $8d92968018d86237$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("dRfi6", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $cc6b08557666e682$export$aa453854f74fab);

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $cc6b08557666e682$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("hzAKL", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $422557008e0dbc71$export$d14f85c01e334a1);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $7NDId = parcelRequire("7NDId");

var $gL80q = parcelRequire("gL80q");


var $bCvSM = parcelRequire("bCvSM");

var $2J6IF = parcelRequire("2J6IF");

var $hwDyF = parcelRequire("hwDyF");
const $422557008e0dbc71$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gKZoD.di)((0, $gL80q.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $2J6IF.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $2J6IF.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $7NDId.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $ca611ff348f89182$export$d1996cb46a690190),
                        method: (0, $bCvSM.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $hwDyF.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $hwDyF.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("7NDId", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $64626586c22c486e$export$73c2f0689b6c4a5a);
class $64626586c22c486e$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("2J6IF", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $5fbccb776f84792e$export$ee79e3ab53b8db79);
const $5fbccb776f84792e$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("hwDyF", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $e8aa8431ce8b786b$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $e8aa8431ce8b786b$export$ddd005554aecd409);
const $e8aa8431ce8b786b$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $e8aa8431ce8b786b$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("7JtDe", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $c6c7124cbfc0022b$export$131c67fd312b8a11);

var $gKZoD = parcelRequire("gKZoD");

var $iUvwD = parcelRequire("iUvwD");

var $50ech = parcelRequire("50ech");

var $boEP0 = parcelRequire("boEP0");

var $iiEdL = parcelRequire("iiEdL");
const $c6c7124cbfc0022b$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gKZoD.di)((0, $boEP0.collectScreenTabsAppliedChangesHistory), (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $iiEdL.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $iiEdL.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $boEP0.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $iUvwD.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $50ech.toScreenTabsValidationError))
        });
    };

});
parcelRegister("iUvwD", function(module, exports) {

$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $2febbf39fb2cebbc$export$faf1f1824ee0a136);

var $2jqAp = parcelRequire("2jqAp");
class $2febbf39fb2cebbc$export$faf1f1824ee0a136 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("50ech", function(module, exports) {

$parcel$export(module.exports, "toScreenTabsValidationError", () => $32af3bb8fe161d39$export$b2675440ade984fb);

const $32af3bb8fe161d39$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $ca611ff348f89182$export$fd26696d109785a0)
    });

});

parcelRegister("iiEdL", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $5d43d6affeb19d8a$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $5d43d6affeb19d8a$export$62d63af83dac7315);
const $5d43d6affeb19d8a$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $5d43d6affeb19d8a$var$isValidScreenTabId = (internalScreenTabs, id)=>$5d43d6affeb19d8a$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $5d43d6affeb19d8a$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$5d43d6affeb19d8a$var$isValidScreenTabId(internalScreenTabs, id) && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && $5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive);
const $5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $5d43d6affeb19d8a$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$5d43d6affeb19d8a$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $5d43d6affeb19d8a$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("eNNkf", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesValue", () => $5092328ed6a09c60$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $5092328ed6a09c60$export$eefe4b2985e8203e);

var $5uXOq = parcelRequire("5uXOq");

var $hLEug = parcelRequire("hLEug");

var $12pgs = parcelRequire("12pgs");
const $5092328ed6a09c60$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const baseUrl = '';
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $hLEug.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $5uXOq.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $12pgs.saveUserPreferenceValue)(baseUrl, userPreferenceKey, newValue);
    }, [
        baseUrl,
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $5uXOq.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $12pgs.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
    }, [
        baseUrl,
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    const setUserPreferences = (0, $5uXOq.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue
        }), [
        setValue,
        deleteValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $5092328ed6a09c60$export$eefe4b2985e8203e = ()=>{
    const baseUrl = '';
    const [, actions] = (0, $hLEug.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $5uXOq.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $12pgs.saveUserPreferenceValue)(baseUrl, userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $12pgs.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions,
        baseUrl
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("hLEug", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $f08ba98a3f2bdde2$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $f08ba98a3f2bdde2$export$4d156074562bac9a);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $djdK3 = parcelRequire("djdK3");
const $f08ba98a3f2bdde2$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $djdK3.actions
});
const $f08ba98a3f2bdde2$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $f08ba98a3f2bdde2$export$46e7eeb2fc34fab8 = (0, $3sQ5x.createHook)($f08ba98a3f2bdde2$export$6f57813fe9f31bf9, {
    selector: $f08ba98a3f2bdde2$var$getUserPreference
});
const $f08ba98a3f2bdde2$export$4d156074562bac9a = (0, $3sQ5x.createHook)($f08ba98a3f2bdde2$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("djdK3", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5c68f1b920b8984c$export$e324594224ef24da);
const $5c68f1b920b8984c$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $5c68f1b920b8984c$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $5c68f1b920b8984c$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $5c68f1b920b8984c$export$df0a4f67b9888111 = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $5c68f1b920b8984c$export$e324594224ef24da = {
    setUserPreferenceValue: $5c68f1b920b8984c$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $5c68f1b920b8984c$var$deleteUserPreferenceValue,
    setUserPreferences: $5c68f1b920b8984c$var$setUserPreferences,
    getUserPreferenceValue: $5c68f1b920b8984c$export$df0a4f67b9888111
};

});


parcelRegister("12pgs", function(module, exports) {

$parcel$export(module.exports, "saveUserPreferenceValue", () => $0dfd1081a7a72732$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $0dfd1081a7a72732$export$a60a810760d07867);

var $eusud = parcelRequire("eusud");
const $0dfd1081a7a72732$export$bebe1b9e9f4cbf16 = async (baseUrl, userPreferenceKey, value)=>(0, $eusud.performPutRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    });
const $0dfd1081a7a72732$export$a60a810760d07867 = async (baseUrl, userPreferenceKey)=>(0, $eusud.performDeleteRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`);

});


const $31848aa9a0db89de$export$a763454c55d057f2 = 'jira.user.issue.clickthrough-banner.lastinteracted';
const $31848aa9a0db89de$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $31848aa9a0db89de$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $31848aa9a0db89de$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $31848aa9a0db89de$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $31848aa9a0db89de$export$2cf981c493d79a21 = 'jira.user.issue.details.activity-layout-setting';
const $31848aa9a0db89de$export$39aaf586c7ee5202 = 'jira.user.issue.user-preferred-layouts';
const $31848aa9a0db89de$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $31848aa9a0db89de$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $31848aa9a0db89de$export$1a08240e14f65aa = 'jira.user.issue.collapsible-sections-state';
const $31848aa9a0db89de$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';

parcelRegister("kI4MM", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $189406269e224200$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $189406269e224200$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $189406269e224200$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $189406269e224200$export$5513f3c310d101f5);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $kjjoM = parcelRequire("kjjoM");
const $189406269e224200$var$STABLE_EMPTY_CONTAINER_ARRAY = [];
const $189406269e224200$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || $189406269e224200$var$STABLE_EMPTY_CONTAINER_ARRAY;
const $189406269e224200$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $189406269e224200$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
const $189406269e224200$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $kjjoM
});
const $189406269e224200$export$5c4a1f63cea7b5b3 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutContainers
});
const $189406269e224200$export$769bbe2bda9a43ce = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutGlance
});
const $189406269e224200$export$3aa9017e11451546 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutContextPanel
});
const $189406269e224200$export$5513f3c310d101f5 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("kjjoM", function(module, exports) {

$parcel$export(module.exports, "setIssueViewContainersLayout", () => $09c52f32f4231bd8$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $09c52f32f4231bd8$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $09c52f32f4231bd8$export$9a04e4b958ebc410);
const $09c52f32f4231bd8$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $09c52f32f4231bd8$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $09c52f32f4231bd8$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("cNJ33", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $0c6b6ff40aad7732$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $0c6b6ff40aad7732$export$355607dae809ec65);

var $41gqO = parcelRequire("41gqO");
const $0c6b6ff40aad7732$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $41gqO.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $41gqO.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $41gqO.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $0c6b6ff40aad7732$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($0c6b6ff40aad7732$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $41gqO.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $0c6b6ff40aad7732$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("41gqO", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $b08b2795aecf222d$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $b08b2795aecf222d$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $b08b2795aecf222d$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $b08b2795aecf222d$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $b08b2795aecf222d$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $b08b2795aecf222d$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $b08b2795aecf222d$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $b08b2795aecf222d$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $b08b2795aecf222d$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $b08b2795aecf222d$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $b08b2795aecf222d$export$ad3536b13febb432);
const $b08b2795aecf222d$export$99ad62164189f781 = 'ecosystemGlance';
const $b08b2795aecf222d$export$7719ef6e9283671 = 'forgeGlance';
const $b08b2795aecf222d$export$bfebea5ce2e1887a = 'ecosystemContext';
const $b08b2795aecf222d$export$be8e68fb1aed253e = 'forgeContext';
const $b08b2795aecf222d$export$7bf561e6ab380ea1 = 'context';
const $b08b2795aecf222d$export$f42c11634d75863e = 'content';
const $b08b2795aecf222d$export$b38842736b6dbc1d = 'content-request';
const $b08b2795aecf222d$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$FORGE_TYPE = 'FORGE';
const $b08b2795aecf222d$export$605c43f1b33ab69 = 'SUMMARY';
const $b08b2795aecf222d$export$e655b77b9efe622f = 'CustomItem';
const $b08b2795aecf222d$export$5cf403de05e9bea = 'FieldSectionItem';
const $b08b2795aecf222d$export$30f7f9a86f182492 = 'TabLayout';
const $b08b2795aecf222d$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $b08b2795aecf222d$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $b08b2795aecf222d$export$ad3536b13febb432 = (node)=>node.type === $b08b2795aecf222d$export$5507f31126c8b283.tab;

});



parcelRegister("hhMVP", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $cd61c7d28b4f2500$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $cd61c7d28b4f2500$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $cd61c7d28b4f2500$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $cd61c7d28b4f2500$var$cachedIsCompactValues = {};
let $cd61c7d28b4f2500$var$previousRouteKey;
function $cd61c7d28b4f2500$export$c47621d55d10906c(key) {
    return $cd61c7d28b4f2500$var$cachedIsCompactValues[key];
}
function $cd61c7d28b4f2500$export$568b2dd75c2027b4(isCompactValue, key) {
    $cd61c7d28b4f2500$var$cachedIsCompactValues[key] = isCompactValue;
}
function $cd61c7d28b4f2500$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $cd61c7d28b4f2500$var$previousRouteKey) {
        $cd61c7d28b4f2500$var$previousRouteKey = currentRouteKey;
        delete $cd61c7d28b4f2500$var$cachedIsCompactValues[$cd61c7d28b4f2500$var$previousRouteKey];
    }
}

});


parcelRegister("3441h", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});



parcelRegister("5gJcp", function(module, exports) {

$parcel$export(module.exports, "defaultRatioRightColumn", () => $0350c967e71738f5$export$7fec582ac43ca9da);
$parcel$export(module.exports, "largeScreenRatioRightColumn", () => $0350c967e71738f5$export$28d7967aa38f2f87);
$parcel$export(module.exports, "activitySidePanelRatio", () => $0350c967e71738f5$export$6695481d80b63521);
$parcel$export(module.exports, "getIssueContainerDefaultMaxWidth", () => $0350c967e71738f5$export$7fe9ac2b6449f553);
$parcel$export(module.exports, "getIssueContainerIncreasedMaxWidth", () => $0350c967e71738f5$export$9d883719bd435511);
$parcel$export(module.exports, "ACTIVITY_SIDE_PANEL_MIN_WIDTH", () => $0350c967e71738f5$export$dd2feff7666e1f68);
$parcel$export(module.exports, "FOUNDATION_CONTENT", () => $0350c967e71738f5$export$7bcdea276f4ac481);
$parcel$export(module.exports, "FOUNDATION_CONTEXT", () => $0350c967e71738f5$export$c38319160cd2937e);
$parcel$export(module.exports, "CONTEXT_ITEMS", () => $0350c967e71738f5$export$7f5a9695169a6da5);
$parcel$export(module.exports, "CONTEXT_ITEMS_EXT_ID", () => $0350c967e71738f5$export$68f17674e93281a4);
$parcel$export(module.exports, "META_CONTAINER", () => $0350c967e71738f5$export$b43fa3c8b66b1c94);
$parcel$export(module.exports, "CONTENT_ITEMS", () => $0350c967e71738f5$export$1ee33ca26b566d0e);
$parcel$export(module.exports, "FOOTNOTE_WRAPPER_KEY", () => $0350c967e71738f5$export$4001e6a77d93abe8);
$parcel$export(module.exports, "ACTIVITY_FEED", () => $0350c967e71738f5$export$712b9c1c9915e523);
$parcel$export(module.exports, "ACTIVITY_FEED_EXT_ID", () => $0350c967e71738f5$export$1c0b3c6e6d8046ea);
$parcel$export(module.exports, "CONFIGURE_FIELDS", () => $0350c967e71738f5$export$c26f2f0247dbba77);
const $0350c967e71738f5$export$7fec582ac43ca9da = 0.35;
const $0350c967e71738f5$export$28d7967aa38f2f87 = 0.4;
const $0350c967e71738f5$export$6695481d80b63521 = 0.4;
const $0350c967e71738f5$export$7fe9ac2b6449f553 = ()=>1680;
const $0350c967e71738f5$export$9d883719bd435511 = ()=>1920;
const $0350c967e71738f5$export$dd2feff7666e1f68 = 400;
const $0350c967e71738f5$export$7bcdea276f4ac481 = 'FOUNDATION_CONTENT';
const $0350c967e71738f5$export$c38319160cd2937e = 'FOUNDATION_CONTEXT';
const $0350c967e71738f5$export$7f4af5d0ba6f3e18 = 'QUICK_ADD_ITEMS';
const $0350c967e71738f5$export$7f5a9695169a6da5 = 'CONTEXT_ITEMS';
const $0350c967e71738f5$export$68f17674e93281a4 = 'issue.context-items';
const $0350c967e71738f5$export$b43fa3c8b66b1c94 = 'META_CONTAINER';
const $0350c967e71738f5$export$1ee33ca26b566d0e = 'CONTENT_ITEMS';
const $0350c967e71738f5$export$4001e6a77d93abe8 = 'FOOTNOTE_WRAPPER_KEY';
const $0350c967e71738f5$export$712b9c1c9915e523 = 'ACTIVITY_FEED';
const $0350c967e71738f5$export$1c0b3c6e6d8046ea = 'issue.activity-feed';
const $0350c967e71738f5$export$c26f2f0247dbba77 = 'CONFIGURE_FIELDS';

});

parcelRegister("2su1H", function(module, exports) {

$parcel$export(module.exports, "useStartNinIssueAppAnalytics", () => $58a286de31151ea6$export$39482b240f0b451f);

var $5uXOq = parcelRequire("5uXOq");

var $dGrdR = parcelRequire("dGrdR");

var $1XJ20 = parcelRequire("1XJ20");

var $ih9zY = parcelRequire("ih9zY");
const $58a286de31151ea6$export$b9b395b52bdc3f4a = (0, $dGrdR.metrics).pageSegmentLoad({
    key: 'new-issue-navigator.issue-app'
});
const $58a286de31151ea6$export$39482b240f0b451f = (issueKey)=>{
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const previousIssueKey = (0, $1XJ20.usePrevious)(issueKey);
    // We explicitly start during render instead of an effect hook as onInteractive can be fired before the effect hook
    // has run for cached issues.
    if (issueKey !== previousIssueKey) $58a286de31151ea6$export$b9b395b52bdc3f4a.start();
    const onInteractive = (0, $5uXOq.useCallback)(()=>{
        $58a286de31151ea6$export$b9b395b52bdc3f4a.stop({
            customData: {
                view: view
            }
        });
    }, [
        view
    ]);
    return {
        onInteractive: onInteractive
    };
};

});

parcelRegister("cqgcE", function(module, exports) {

$parcel$export(module.exports, "useOnDeleteIssue", () => $4b147560fdf5ea67$export$45e2b3c3de4980ed);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");
const $4b147560fdf5ea67$var$getKeyForEdge = (edge)=>{
    const { NODE: NODE } = (0, $eiowN.ConnectionInterface).get();
    return edge?.getLinkedRecord(NODE)?.getValue('key');
};
const $4b147560fdf5ea67$var$getFirstEdgeCursor = (connectionRecord)=>{
    const { CURSOR: CURSOR, EDGES: EDGES } = (0, $eiowN.ConnectionInterface).get();
    const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
    const cursor = edges[0]?.getValue(CURSOR);
    return cursor ? String(cursor) : null;
};
const $4b147560fdf5ea67$var$getLastEdgeCursor = (connectionRecord)=>{
    const { CURSOR: CURSOR, EDGES: EDGES } = (0, $eiowN.ConnectionInterface).get();
    const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
    const cursor = edges[edges.length - 1]?.getValue(CURSOR);
    return cursor ? String(cursor) : null;
};
const $4b147560fdf5ea67$var$updatePageInfoCursor = (pageInfo, pageInfoField, replacementCursor, edgeToDelete)=>{
    if (!pageInfo || !replacementCursor) return;
    const { CURSOR: CURSOR } = (0, $eiowN.ConnectionInterface).get();
    const pageInfoCursor = pageInfo.getValue(pageInfoField);
    if (pageInfoCursor && pageInfoCursor === edgeToDelete.getValue(CURSOR)) pageInfo.setValue(replacementCursor, pageInfoField);
};
const $4b147560fdf5ea67$var$updatePageInfo = (connectionRecord, edgeToDelete)=>{
    const { START_CURSOR: START_CURSOR, END_CURSOR: END_CURSOR, PAGE_INFO: PAGE_INFO } = (0, $eiowN.ConnectionInterface).get();
    const pageInfo = connectionRecord.getLinkedRecord(PAGE_INFO);
    $4b147560fdf5ea67$var$updatePageInfoCursor(pageInfo, START_CURSOR, $4b147560fdf5ea67$var$getFirstEdgeCursor(connectionRecord), edgeToDelete);
    $4b147560fdf5ea67$var$updatePageInfoCursor(pageInfo, END_CURSOR, $4b147560fdf5ea67$var$getLastEdgeCursor(connectionRecord), edgeToDelete);
};
const $4b147560fdf5ea67$export$45e2b3c3de4980ed = (connectionId)=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useCallback)((issueKeyToDelete)=>{
        let previousIssueKey;
        let nextIssueKey;
        (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const connectionRecord = connectionId ? store.get(connectionId) : undefined;
            if (!connectionRecord) return;
            const { EDGES: EDGES } = (0, $eiowN.ConnectionInterface).get();
            const edges = connectionRecord.getLinkedRecords(EDGES) ?? [];
            const index = edges.findIndex((edge)=>$4b147560fdf5ea67$var$getKeyForEdge(edge) === issueKeyToDelete);
            if (index > -1) {
                nextIssueKey = $4b147560fdf5ea67$var$getKeyForEdge(edges[index + 1]);
                previousIssueKey = $4b147560fdf5ea67$var$getKeyForEdge(edges[index - 1]);
                // Filter out deleted record from our connection
                connectionRecord.setLinkedRecords(edges.slice(0, index).concat(edges.slice(index + 1)), EDGES);
                // Update page start/end cursors if necessary following record delete
                $4b147560fdf5ea67$var$updatePageInfo(connectionRecord, edges[index]);
                // Decrement the total count
                const totalCount = connectionRecord.getValue('totalIssueSearchResultCount');
                if (typeof totalCount === 'number') connectionRecord.setValue(totalCount - 1, 'totalIssueSearchResultCount');
            }
        });
        // Return the next issue key to select. If there is no next issue key then return the previous key.
        return nextIssueKey ?? previousIssueKey ?? '';
    }, [
        environment,
        connectionId
    ]);
};

});

parcelRegister("6Hhfn", function(module, exports) {

$parcel$export(module.exports, "useIssueByFieldsRefetch", () => $49b7b4d37d56a65b$export$a3f7fddb3e08cea5);

var $8nnfc = parcelRequire("8nnfc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");

var $9OXo1 = parcelRequire("9OXo1");

var $6UAdF = parcelRequire("6UAdF");
const $49b7b4d37d56a65b$export$a3f7fddb3e08cea5 = (fieldSets)=>{
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useCallback)((issuekey)=>(0, $eiowN.fetchQuery)(environment, /* eslint-disable @atlassian/relay/unused-fields, @atlassian/relay/must-colocate-fragment-spreads */ (0, $8nnfc.default), /* eslint-enable @atlassian/relay/unused-fields, @atlassian/relay/must-colocate-fragment-spreads */ {
            cloudId: cloudId,
            issueSearchInput: {
                jql: `issueKey=${issuekey}`
            },
            fieldSetIds: fieldSets,
            amountOfColumns: (0, $6UAdF.MAX_AMOUNT_OF_COLUMNS)
        }, {
            fetchPolicy: 'network-only'
        }).toPromise(), [
        cloudId,
        environment,
        fieldSets
    ]);
};

});
parcelRegister("8nnfc", function(module, exports) {

$parcel$export(module.exports, "default", () => $70ed14087c56651a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0174bd2838926dee7dc2314067d328a8>>
 * @relayHash 618d79bcb9289fc39213af9bd4c9795b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID cd33ed179c6117a917e1c2f876633fe7b8ccfec3aec759ff4f5716ad03811396

var $5ykrX = parcelRequire("5ykrX");

var $ggSVP = parcelRequire("ggSVP");

var $knfEI = parcelRequire("knfEI");

var $5qm7M = parcelRequire("5qm7M");

var $l8ssf = parcelRequire("l8ssf");

var $iLxt4 = parcelRequire("iLxt4");

var $hBvdF = parcelRequire("hBvdF");
const $70ed14087c56651a$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetIds"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v4 = {
        "kind": "Literal",
        "name": "first",
        "value": 1
    }, v5 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        v4 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        }
    ], v6 = [
        {
            "kind": "Variable",
            "name": "fieldSetIds",
            "variableName": "fieldSetIds"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "type"
    }, v8 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v9 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "id"
    }, v11 = {
        "kind": "ScalarField",
        "name": "name"
    }, v12 = {
        "kind": "ScalarField",
        "name": "value"
    }, v13 = [
        v12 /*: any*/ ,
        v10 /*: any*/ ,
        {
            "kind": "ScalarField",
            "name": "isDisabled"
        }
    ], v14 = {
        "kind": "ScalarField",
        "name": "lazyIsEditableInIssueView"
    }, v15 = {
        "kind": "ClientExtension",
        "selections": [
            v14 /*: any*/ 
        ]
    }, v16 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 1000
        }
    ], v17 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v18 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v19 = {
        "kind": "ScalarField",
        "name": "dateTime"
    }, v20 = {
        "kind": "ScalarField",
        "name": "text"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            v20 /*: any*/ ,
            v11 /*: any*/ ,
            v15 /*: any*/ 
        ],
        "type": "JiraSingleLineTextField"
    }, v22 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v23 = [
        v22 /*: any*/ 
    ], v24 = {
        "concreteType": "JiraColor",
        "kind": "LinkedField",
        "name": "color",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "colorKey"
            },
            v10 /*: any*/ 
        ]
    }, v25 = [
        v24 /*: any*/ 
    ], v26 = {
        "kind": "ScalarField",
        "name": "optionId"
    }, v27 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v28 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v29 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v30 = {
        "kind": "ScalarField",
        "name": "key"
    }, v31 = {
        "kind": "ScalarField",
        "name": "__id"
    }, v32 = [
        v11 /*: any*/ ,
        v10 /*: any*/ 
    ], v33 = {
        "concreteType": "JiraFieldConfig",
        "kind": "LinkedField",
        "name": "fieldConfig",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isRequired"
            }
        ]
    }, v34 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v35 = {
        "concreteType": "JiraStatusCategory",
        "kind": "LinkedField",
        "name": "statusCategory",
        "plural": false,
        "selections": [
            v34 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v36 = {
        "concreteType": "JiraSingleLineTextField",
        "kind": "LinkedField",
        "name": "summaryField",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v37 = {
        "concreteType": "JiraColorField",
        "kind": "LinkedField",
        "name": "issueColorField",
        "plural": false,
        "selections": [
            v24 /*: any*/ ,
            v10 /*: any*/ 
        ]
    }, v38 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v39 = {
        "concreteType": "JiraIssueTypeField",
        "kind": "LinkedField",
        "name": "issueTypeField",
        "plural": false,
        "selections": [
            {
                "concreteType": "JiraIssueType",
                "kind": "LinkedField",
                "name": "issueType",
                "plural": false,
                "selections": [
                    v38 /*: any*/ ,
                    v11 /*: any*/ ,
                    v10 /*: any*/ 
                ]
            },
            v10 /*: any*/ 
        ]
    }, v40 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v41 = {
        "kind": "ScalarField",
        "name": "number"
    }, v42 = {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "concreteType": "JiraNumberFieldFormatConfig",
                "kind": "LinkedField",
                "name": "formatConfig",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "formatStyle"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "formatUnit"
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "refetchIssue_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isDensityFull",
                                                                    "value": false
                                                                },
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "isInlineEditingEnabled",
                                                                    "value": true
                                                                }
                                                            ],
                                                            "kind": "FragmentSpread",
                                                            "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "main_issueNavigator_Card_fieldSets"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "refetchIssue_IssueNavigatorQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issueSearchStable",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "concreteType": "JiraIssueFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSetsById",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraIssueFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "fieldSetId"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fields",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v8 /*: any*/ ,
                                                                                                v9 /*: any*/ ,
                                                                                                v7 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "TypeDiscriminator",
                                                                                                    "abstractKey": "__isJiraIssueField"
                                                                                                },
                                                                                                v10 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraAffectedServiceConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedAffectedServicesConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAffectedServiceEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAffectedService",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "serviceId"
                                                                                                                                },
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v10 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraAffectedServicesField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraCascadingOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "cascadingOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "parentOptionValue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v13 /*: any*/ 
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOption",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "childOptionValue",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v13 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraCascadingSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v16 /*: any*/ ,
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                        v10 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedComponentsConnection(first:1000)"
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v19 /*: any*/ ,
                                                                                                                v11 /*: any*/ ,
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraDateTimePickerField"
                                                                                                        },
                                                                                                        v21 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCommentSummary",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "commentSummary",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "canAddComment"
                                                                                                                        },
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraCommentSummaryField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "uri"
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraUrlField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v23 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "fieldOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v12 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": v25 /*: any*/ 
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                                                                                            "kind": "Condition",
                                                                                                                            "passingValue": true,
                                                                                                                            "selections": v25 /*: any*/ 
                                                                                                                        },
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v26 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v12 /*: any*/ ,
                                                                                                                                        v26 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOptionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOptions",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraOptionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraOption",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v12 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraCheckboxesField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraUserConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedUsersConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraUserEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v8 /*: any*/ ,
                                                                                                                                        v27 /*: any*/ ,
                                                                                                                                        v11 /*: any*/ ,
                                                                                                                                        v28 /*: any*/ ,
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v29 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "InlineFragment",
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "email"
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "type": "AtlassianAccountUser"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleSelectUserPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraTeamView",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedTeam",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "jiraSuppliedId"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "jiraSuppliedName"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraTeamViewField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraTimeTrackingField",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "timeTrackingField",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v10 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraEstimate",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "originalEstimate",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "timeInSeconds"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraTimeTrackingSettings",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "timeTrackingSettings",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "workingHoursPerDay"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "workingDaysPerWeek"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "defaultFormat"
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "defaultUnit"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                v9 /*: any*/ ,
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v7 /*: any*/ ,
                                                                                                                                v15 /*: any*/ 
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraOriginalTimeEstimateField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraOption",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedOption",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "alias": "label",
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "value"
                                                                                                                        },
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        v17 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraRadioSelectField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v16 /*: any*/ ,
                                                                                                                    "concreteType": "JiraVersionConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedVersionsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersionEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraVersion",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v11 /*: any*/ ,
                                                                                                                                        v17 /*: any*/ ,
                                                                                                                                        v18 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "versionId"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleVersionPickerField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "issue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "args": v16 /*: any*/ ,
                                                                                                                    "concreteType": "JiraGoalConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedGoals",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGoalEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraGoal",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v30 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ClientExtension",
                                                                                                                            "selections": [
                                                                                                                                v31 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ],
                                                                                                                    "storageKey": "selectedGoals(first:1000)"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ClientExtension",
                                                                                                                    "selections": [
                                                                                                                        v31 /*: any*/ ,
                                                                                                                        v14 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraGoalsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "args": v16 /*: any*/ ,
                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "confluenceRemoteIssueLinks",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraConfluenceRemoteIssueLink",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "href"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        },
                                                                                                                        v22 /*: any*/ 
                                                                                                                    ],
                                                                                                                    "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraCmdbObjectConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedCmdbObjectsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraCmdbObjectEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraCmdbObject",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "objectId"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "label"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraCmdbAvatar",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "avatar",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "mediaClientConfig",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "clientId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "fileId"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaBaseUrl"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                    "name": "mediaJwtToken"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "url48"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "QueryError",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "errors",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "message"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraCMDBField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": "componentsOld",
                                                                                                                    "concreteType": "JiraComponentConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedComponentsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraComponentEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraComponent",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": v32 /*: any*/ 
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraComponentsField"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v20 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraSingleLineTextField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "date"
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v15 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDatePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v19 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraDateTimePickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraEpic",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "epic",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v30 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "summary"
                                                                                                                },
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "color"
                                                                                                                },
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraEpicLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "renderedFieldHtml"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraFallbackField"
                                                                                                },
                                                                                                v21 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatusCategory",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "statusCategory",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                v34 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraStatus",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "status",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "statusId"
                                                                                                                },
                                                                                                                v35 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraStatusField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": v16 /*: any*/ ,
                                                                                                            "concreteType": "JiraLabelConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedLabelsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraLabelEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraLabel",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                v24 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v22 /*: any*/ 
                                                                                                            ],
                                                                                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        v15 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraLabelsField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssueType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "small"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v11 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraIssue",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "parentIssue",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v30 /*: any*/ ,
                                                                                                                v36 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v30 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v39 /*: any*/ ,
                                                                                                                        v36 /*: any*/ ,
                                                                                                                        v10 /*: any*/ 
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "parentIssue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        v30 /*: any*/ ,
                                                                                                                        v37 /*: any*/ ,
                                                                                                                        v39 /*: any*/ ,
                                                                                                                        v36 /*: any*/ ,
                                                                                                                        v10 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "issueId"
                                                                                                                        },
                                                                                                                        v40 /*: any*/ ,
                                                                                                                        {
                                                                                                                            "args": [
                                                                                                                                {
                                                                                                                                    "kind": "Literal",
                                                                                                                                    "name": "ids",
                                                                                                                                    "value": [
                                                                                                                                        "summary",
                                                                                                                                        "issuetype",
                                                                                                                                        "status"
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "fieldsById",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "edges",
                                                                                                                                    "plural": true,
                                                                                                                                    "selections": [
                                                                                                                                        {
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "node",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                v8 /*: any*/ ,
                                                                                                                                                v10 /*: any*/ ,
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v9 /*: any*/ ,
                                                                                                                                                        v20 /*: any*/ 
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraSingleLineTextField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v9 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraIssueType",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "issueType",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                {
                                                                                                                                                                    "kind": "ScalarField",
                                                                                                                                                                    "name": "issueTypeId"
                                                                                                                                                                },
                                                                                                                                                                v11 /*: any*/ ,
                                                                                                                                                                v38 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                                    "name": "hierarchy",
                                                                                                                                                                    "plural": false,
                                                                                                                                                                    "selections": [
                                                                                                                                                                        {
                                                                                                                                                                            "kind": "ScalarField",
                                                                                                                                                                            "name": "level"
                                                                                                                                                                        }
                                                                                                                                                                    ]
                                                                                                                                                                },
                                                                                                                                                                v10 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraIssueTypeField"
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                    "selections": [
                                                                                                                                                        v9 /*: any*/ ,
                                                                                                                                                        {
                                                                                                                                                            "concreteType": "JiraStatus",
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "status",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v35 /*: any*/ ,
                                                                                                                                                                v10 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ],
                                                                                                                                                    "type": "JiraStatusField"
                                                                                                                                                }
                                                                                                                                            ]
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ],
                                                                                                                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v11 /*: any*/ ,
                                                                                                                v15 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraParentIssueField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraPriority",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "priority",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "iconUrl"
                                                                                                                },
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        v15 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraPriorityField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraProject",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "project",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                v30 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraAvatar",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "avatar",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "large"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraResolution",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "resolution",
                                                                                                            "plural": false,
                                                                                                            "selections": v32 /*: any*/ 
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraResolutionField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraSprintConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedSprintsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraSprintEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraSprint",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                v10 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "sprintId"
                                                                                                                                },
                                                                                                                                v11 /*: any*/ ,
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "state"
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "endDate"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        v15 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSprintField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "user",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v8 /*: any*/ ,
                                                                                                                v27 /*: any*/ ,
                                                                                                                v28 /*: any*/ ,
                                                                                                                v11 /*: any*/ ,
                                                                                                                v10 /*: any*/ ,
                                                                                                                v29 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v11 /*: any*/ ,
                                                                                                        v33 /*: any*/ ,
                                                                                                        v15 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraSingleSelectUserPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v11 /*: any*/ ,
                                                                                                        {
                                                                                                            "args": v16 /*: any*/ ,
                                                                                                            "concreteType": "JiraVersionConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "selectedVersionsConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraVersionEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraVersion",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": v32 /*: any*/ 
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraMultipleVersionPickerField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraRichText",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "richText",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraADF",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "adfValue",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraAdfToConvertedPlainText",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "convertedPlainText",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "plainText"
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraRichTextField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "concreteType": "JiraServiceManagementRequestType",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "requestType",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                v38 /*: any*/ ,
                                                                                                                v10 /*: any*/ 
                                                                                                            ]
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraServiceManagementRequestTypeField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "args": [
                                                                                                                v4 /*: any*/ 
                                                                                                            ],
                                                                                                            "concreteType": "JiraIssueLinkConnection",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "issueLinkConnection",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                v22 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraIssueLinkEdge",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "edges",
                                                                                                                    "plural": true,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraIssueLink",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "node",
                                                                                                                            "plural": false,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraIssue",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "issue",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v40 /*: any*/ ,
                                                                                                                                        v30 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "args": [
                                                                                                                                                {
                                                                                                                                                    "kind": "Literal",
                                                                                                                                                    "name": "ids",
                                                                                                                                                    "value": [
                                                                                                                                                        "statusCategory"
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                                                                                            "kind": "LinkedField",
                                                                                                                                            "name": "fieldsById",
                                                                                                                                            "plural": false,
                                                                                                                                            "selections": [
                                                                                                                                                {
                                                                                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                                                                                    "kind": "LinkedField",
                                                                                                                                                    "name": "edges",
                                                                                                                                                    "plural": true,
                                                                                                                                                    "selections": [
                                                                                                                                                        {
                                                                                                                                                            "kind": "LinkedField",
                                                                                                                                                            "name": "node",
                                                                                                                                                            "plural": false,
                                                                                                                                                            "selections": [
                                                                                                                                                                v8 /*: any*/ ,
                                                                                                                                                                {
                                                                                                                                                                    "kind": "InlineFragment",
                                                                                                                                                                    "selections": [
                                                                                                                                                                        v35 /*: any*/ 
                                                                                                                                                                    ],
                                                                                                                                                                    "type": "JiraStatusCategoryField"
                                                                                                                                                                },
                                                                                                                                                                v10 /*: any*/ 
                                                                                                                                                            ]
                                                                                                                                                        }
                                                                                                                                                    ]
                                                                                                                                                }
                                                                                                                                            ],
                                                                                                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                                                                                                        },
                                                                                                                                        v10 /*: any*/ 
                                                                                                                                    ]
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    "kind": "ScalarField",
                                                                                                                                    "name": "relationName"
                                                                                                                                },
                                                                                                                                v10 /*: any*/ 
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": "issueLinkConnection(first:1)"
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "JiraIssueLinkField"
                                                                                                },
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isStoryPointField"
                                                                                                        },
                                                                                                        v41 /*: any*/ ,
                                                                                                        v11 /*: any*/ ,
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": false,
                                                                                                            "selections": [
                                                                                                                v41 /*: any*/ ,
                                                                                                                v42 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        {
                                                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                                                                            "kind": "Condition",
                                                                                                            "passingValue": true,
                                                                                                            "selections": [
                                                                                                                v41 /*: any*/ ,
                                                                                                                v11 /*: any*/ ,
                                                                                                                v42 /*: any*/ ,
                                                                                                                v15 /*: any*/ 
                                                                                                            ]
                                                                                                        },
                                                                                                        v15 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraNumberField"
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v11 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "JiraGroupConnection",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "selectedGroupsConnection",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "concreteType": "JiraGroupEdge",
                                                                                                                            "kind": "LinkedField",
                                                                                                                            "name": "edges",
                                                                                                                            "plural": true,
                                                                                                                            "selections": [
                                                                                                                                {
                                                                                                                                    "concreteType": "JiraGroup",
                                                                                                                                    "kind": "LinkedField",
                                                                                                                                    "name": "node",
                                                                                                                                    "plural": false,
                                                                                                                                    "selections": [
                                                                                                                                        v10 /*: any*/ ,
                                                                                                                                        v11 /*: any*/ ,
                                                                                                                                        {
                                                                                                                                            "kind": "ScalarField",
                                                                                                                                            "name": "groupId"
                                                                                                                                        }
                                                                                                                                    ]
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    ]
                                                                                                                },
                                                                                                                v15 /*: any*/ 
                                                                                                            ],
                                                                                                            "type": "JiraMultipleGroupPickerField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraFlag",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "flag",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "isFlagged"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraFlagField"
                                                                                                        }
                                                                                                    ]
                                                                                                },
                                                                                                {
                                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                                                                                    "kind": "Condition",
                                                                                                    "passingValue": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "concreteType": "JiraWatch",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "watch",
                                                                                                                    "plural": false,
                                                                                                                    "selections": [
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "count"
                                                                                                                        },
                                                                                                                        {
                                                                                                                            "kind": "ScalarField",
                                                                                                                            "name": "isWatching"
                                                                                                                        }
                                                                                                                    ]
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "JiraWatchesField"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": v23 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                v10 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "cd33ed179c6117a917e1c2f876633fe7b8ccfec3aec759ff4f5716ad03811396",
            "metadata": {},
            "name": "refetchIssue_IssueNavigatorQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": (0, $5qm7M.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": (0, $iLxt4.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": (0, $l8ssf.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": (0, $5ykrX.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": (0, $ggSVP.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": (0, $knfEI.default),
                "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": (0, $hBvdF.default)
            }
        }
    };
}();
$70ed14087c56651a$var$node.hash = "c4758e8f0c69bf48cf3f00e006767f21";
var $70ed14087c56651a$export$2e2bcd8739ae039 = $70ed14087c56651a$var$node;

});


parcelRegister("9aomo", function(module, exports) {

$parcel$export(module.exports, "default", () => $341a198b9adf9a7a$export$2e2bcd8739ae039);

var $bG6g7 = parcelRequire("bG6g7");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Uumt = parcelRequire("8Uumt");

var $81Uw2 = parcelRequire("81Uw2");

var $dCm1o = parcelRequire("dCm1o");

var $7OTah = parcelRequire("7OTah");

var $b9kNb = parcelRequire("b9kNb");
/**
 * Render extraHeaderActions if provided or otherwise return an empty render.
 */ const $341a198b9adf9a7a$var$HeaderActionsFallback = ({ extraHeaderActions: extraHeaderActions, isEmbedView: isEmbedView, maxWidth: maxWidth })=>extraHeaderActions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($341a198b9adf9a7a$var$HeaderActionsContainer, {
        maxWidth: maxWidth,
        isEmbedView: isEmbedView,
        isVREnabled: (0, $dCm1o.isVisualRefreshEnabled)()
    }, extraHeaderActions) : null;
/**
 * Render issue pagination controls and extraHeaderActions if provided.
 */ const $341a198b9adf9a7a$var$HeaderActions = (props)=>{
    const { extraHeaderActions: extraHeaderActions, issueResults: issueResults, maxWidth: maxWidth, isEmbedView: isEmbedView } = props;
    const issueResultsData = (0, $8Uumt.useFragment)((0, $bG6g7.default), issueResults);
    const issuesCount = (0, $7OTah.useIssuesCount)();
    const selectedIssueIndex = (0, $7OTah.useSelectedIssueIndex)(); // If selectedIssueIndex is negative then our selected issue key does not exist in the result set, so there
    // are no pagination controls to show.
    // If issueResultsData is null and issuesCount is not zero it means the grouping is enabled
    if (selectedIssueIndex === -1 || issueResultsData == null && issuesCount === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($341a198b9adf9a7a$var$HeaderActionsFallback, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($341a198b9adf9a7a$var$HeaderActionsContainer, {
        maxWidth: maxWidth,
        isEmbedView: isEmbedView,
        isVREnabled: (0, $dCm1o.isVisualRefreshEnabled)()
    }, extraHeaderActions ?? null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9kNb.default), {
        issueResults: issueResultsData ?? null
    }));
};
var $341a198b9adf9a7a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $81Uw2.withRecoverableErrorBoundary)($341a198b9adf9a7a$var$HeaderActions, {
    recoveryProp: 'issueResults',
    Fallback: $341a198b9adf9a7a$var$HeaderActionsFallback
});
const $341a198b9adf9a7a$var$HeaderActionsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isEmbedView: isEmbedView, maxWidth: maxWidth, isVREnabled: isVREnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $lD23V.default)(__cmplp.maxWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _4cvr1h6o _1bahesu3 _1e0c1txw _1bsb1osq _vchhusvi _10nju2gc",
            __cmplp.isEmbedView && "_n3tdu2gc",
            __cmplp.maxWidth && "_p12f1ayu",
            __cmplp.isVREnabled ? "_7zw61ejb" : "_7zw6v47k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bG6g7", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dfb9eb4249d2403$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0bc51f9494de5d6fa2940f677e3da0a2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0dfb9eb4249d2403$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "headerActions_issueNavigator",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "issuePagination_issueNavigator"
        }
    ],
    "type": "JiraIssueConnection"
};
$0dfb9eb4249d2403$var$node.hash = "701bdde8a1a96783e68d573053dd8362";
var $0dfb9eb4249d2403$export$2e2bcd8739ae039 = $0dfb9eb4249d2403$var$node;

});

parcelRegister("81Uw2", function(module, exports) {

$parcel$export(module.exports, "withRecoverableErrorBoundary", () => $8612eca041c6f5de$export$c25a1c850f00ce39);

var $5uXOq = parcelRequire("5uXOq");
function $8612eca041c6f5de$export$c25a1c850f00ce39(WrappedComponent, { recoveryProp: recoveryProp, Fallback: Fallback }) {
    class RecoverableErrorBoundary extends (0, $5uXOq.Component) {
        componentDidUpdate(prevProps) {
            if (this.state.errorProps && prevProps[recoveryProp] !== this.props[recoveryProp]) this.setState({
                errorProps: null
            });
        }
        componentDidCatch(error, errorInfo) {
            this.setState({
                errorProps: {
                    error: error,
                    errorInfo: errorInfo
                }
            });
        }
        render() {
            if (this.state.errorProps) return Fallback ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Fallback, {
                ...this.props,
                ...this.state.errorProps
            }) : null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, this.props);
        }
        constructor(...args){
            super(...args), this.state = {
                errorProps: null
            };
        }
    }
    return RecoverableErrorBoundary;
}

});

parcelRegister("b9kNb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc85153e8f22912$export$2e2bcd8739ae039);

var $cwNnY = parcelRequire("cwNnY");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $ldJSL = parcelRequire("ldJSL");

var $7OTah = parcelRequire("7OTah");

var $68wbI = parcelRequire("68wbI");

var $9psUt = parcelRequire("9psUt");
const $3dc85153e8f22912$var$IssuePagination = ({ issueResults: issueResults })=>{
    const issuesCount = (0, $7OTah.useIssuesCount)();
    const issueResultsData = (0, $8Uumt.useFragment)((0, $cwNnY.default), issueResults);
    const isCappingIssueSearchResult = issueResultsData?.isCappingIssueSearchResult ?? false;
    const totalIssueSearchResultCount = issueResultsData?.totalIssueSearchResultCount || issuesCount;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9psUt.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $68wbI.default), {
        totalResultCount: totalIssueSearchResultCount,
        isCappingIssueSearchResult: isCappingIssueSearchResult
    })));
};
var $3dc85153e8f22912$export$2e2bcd8739ae039 = $3dc85153e8f22912$var$IssuePagination;

});
parcelRegister("cwNnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $7240c8715a77c997$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cdeacb15335634351a83b6eeb614c997>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7240c8715a77c997$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "issuePagination_issueNavigator",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            },
            "action": "THROW",
            "path": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }
    ],
    "type": "JiraIssueConnection"
};
$7240c8715a77c997$var$node.hash = "252cad0134e2ce14b78595c597895b8f";
var $7240c8715a77c997$export$2e2bcd8739ae039 = $7240c8715a77c997$var$node;

});

parcelRegister("68wbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b717c6c97877d28$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $kEVMo = parcelRequire("kEVMo");

var $42CjB = parcelRequire("42CjB");

var $3bDjY = parcelRequire("3bDjY");

var $jQtKF = parcelRequire("jQtKF");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $7OTah = parcelRequire("7OTah");

var $2siHS = parcelRequire("2siHS");
const $5b717c6c97877d28$var$TooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5b717c6c97877d28$var$StyledTooltipTag, {
        ref: ref,
        ...props
    }));
const $5b717c6c97877d28$var$IssuePaginationNextButton = ({ totalResultCount: totalResultCount, isCappingIssueSearchResult: isCappingIssueSearchResult })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const actions = (0, $7OTah.useSelectedIssueActions)();
    const selectNextIssue = actions.selectNextIssue;
    const issueKey = (0, $7OTah.useNextIssueKey)();
    const isDisabled = !issueKey;
    const nextIssueMessage = issueKey ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2siHS.default).nextIssueTooltipIssueTermRefresh : (0, $2siHS.default).nextIssueTooltip, {
        issueKey: issueKey
    }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2siHS.default).nextIssueWithoutKeyTooltipIssueTermRefresh : (0, $2siHS.default).nextIssueWithoutKeyTooltip);
    const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        if (selectNextIssue()) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'nextIssue');
    }, [
        selectNextIssue
    ]);
    if (isDisabled && isCappingIssueSearchResult) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2siHS.default).disabledButtonTooltipIssueTermRefresh : (0, $2siHS.default).disabledButtonTooltip),
        tag: $5b717c6c97877d28$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jQtKF.default), {
        tabIndex: 0,
        isDisabled: true,
        "data-testid": "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button.next-disabled-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                ...iconProps,
                size: "small"
            }),
        label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2siHS.default).disabledButtonTooltipIssueTermRefresh : (0, $2siHS.default).disabledButtonTooltip),
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button",
        isDisabled: isDisabled,
        spacing: "compact"
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                ...iconProps,
                size: "small"
            }),
        label: isDisabled ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2siHS.default).disabledButtonLabelIssueTermRefresh : (0, $2siHS.default).disabledButtonLabel, {
            issueCount: totalResultCount
        }) : nextIssueMessage,
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.next-button",
        isDisabled: isDisabled,
        spacing: "compact",
        isTooltipDisabled: isDisabled
    });
};
var $5b717c6c97877d28$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5b717c6c97877d28$var$IssuePaginationNextButton;
const $5b717c6c97877d28$var$StyledTooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jQtKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dbfcf6b8255255f$export$2e2bcd8739ae039);

var $47bDC = parcelRequire("47bDC");
/**
 * When the @atlaskit/button component is disabled it prevents mouse events being fired for the button, which prevents
 * tooltips showing https://atlassian.design/components/button/usage#disabled-buttons.
 * When you require a disabled button to show a tooltip on hover then the button should be wrapped in this element.
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4dbfcf6b8255255f$var$DisabledButtonWithTooltip = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "yhjexx-0"
})({
    display: 'inline-flex'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>props.isDisabled ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $47bDC.css)({
        cursor: 'not-allowed',
        // Disable pointer events for the button element which means 'event.preventDefault()' will not be
        // called from AK. This allows pointer events to bubble from our wrapping span element.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> button': {
            pointerEvents: 'none'
        }
    }) : '');
var // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$4dbfcf6b8255255f$export$2e2bcd8739ae039 = $4dbfcf6b8255255f$var$DisabledButtonWithTooltip;

});

parcelRegister("2siHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5ef87bb8421fa8e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $b5ef87bb8421fa8e$var$messages = (0, $7VHMR.defineMessages)({
    nextIssueTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-tooltip",
        "defaultMessage": "Next issue ''{issueKey}'' (Type 'j')"
    },
    nextIssueWithoutKeyTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-without-key-tooltip",
        "defaultMessage": "Next issue (Type 'j')"
    },
    disabledButtonTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-tooltip",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more issues."
    },
    disabledButtonLabel: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-label",
        "defaultMessage": "{issueCount} of {issueCount} issues, select previous issues to go back"
    },
    disabledButtonLabelIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-label-issue-term-refresh",
        "defaultMessage": "{issueCount} of {issueCount} work items, select previous work items to go back"
    },
    nextIssueTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-tooltip-issue-term-refresh",
        "defaultMessage": "Next work item ''{issueKey}'' (Type 'j')"
    },
    nextIssueWithoutKeyTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.next-issue-without-key-tooltip-issue-term-refresh",
        "defaultMessage": "Next work item (Type 'j')"
    },
    disabledButtonTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.next-button.disabled-button-tooltip-issue-term-refresh",
        "defaultMessage": "We can\u2019t load more pages. Refine your search criteria to see more work items."
    }
});
var $b5ef87bb8421fa8e$export$2e2bcd8739ae039 = $b5ef87bb8421fa8e$var$messages;

});


parcelRegister("9psUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca6a8c917bf734bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $c9nft = parcelRequire("c9nft");

var $42CjB = parcelRequire("42CjB");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $7OTah = parcelRequire("7OTah");

var $iLFTD = parcelRequire("iLFTD");
const $ca6a8c917bf734bd$var$IssuePaginationPreviousButton = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const actions = (0, $7OTah.useSelectedIssueActions)();
    const selectPreviousIssue = actions.selectPreviousIssue;
    const issueKey = (0, $7OTah.usePreviousIssueKey)();
    const isDisabled = !issueKey;
    const previousIssueMessage = issueKey ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iLFTD.default).previousIssueTooltipIssueTermRefresh : (0, $iLFTD.default).previousIssueTooltip, {
        issueKey: issueKey
    }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iLFTD.default).previousIssueWithoutKeyTooltipIssueTermRefresh : (0, $iLFTD.default).previousIssueWithoutKeyTooltip);
    const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        if (selectPreviousIssue()) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'previousIssue');
    }, [
        selectPreviousIssue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c9nft))), {
                ...iconProps,
                size: "small"
            }),
        label: isDisabled ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iLFTD.default).disabledButtonLabelIssueTermRefresh : (0, $iLFTD.default).disabledButtonLabel) : previousIssueMessage,
        onClick: onClick,
        appearance: "subtle",
        testId: "issue-navigator.common.ui.issue-app.header-actions.issue-pagination.previous-button",
        isDisabled: isDisabled,
        spacing: "compact",
        isTooltipDisabled: isDisabled
    });
};
var $ca6a8c917bf734bd$export$2e2bcd8739ae039 = $ca6a8c917bf734bd$var$IssuePaginationPreviousButton;

});
parcelRegister("c9nft", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::636414aaf061bfcc39e7053bfa952962>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8d885bfbdbf100db$var$_react = $8d885bfbdbf100db$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8d885bfbdbf100db$var$_chevronUp = $8d885bfbdbf100db$var$_interopRequireDefault((parcelRequire("dVd7B")));

var $8d885bfbdbf100db$var$_chevronUp2 = $8d885bfbdbf100db$var$_interopRequireDefault((parcelRequire("6Pmud")));
function $8d885bfbdbf100db$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "ChevronUpIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Close dropdown menu
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8d885bfbdbf100db$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $8d885bfbdbf100db$var$_react.default.createElement($8d885bfbdbf100db$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $8d885bfbdbf100db$var$_chevronUp2.default
    }, props));
$8d885bfbdbf100db$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $8d885bfbdbf100db$var$_default = module.exports.default = $8d885bfbdbf100db$var$ChevronUpIcon;

});
parcelRegister("6Pmud", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4f88f2d3e506ed12$var$_react = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4f88f2d3e506ed12$var$_chevronUp = $4f88f2d3e506ed12$var$_interopRequireDefault((parcelRequire("dVd7B")));
function $4f88f2d3e506ed12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4f88f2d3e506ed12$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $4f88f2d3e506ed12$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $4f88f2d3e506ed12$var$_chevronUp.default
    }));
$4f88f2d3e506ed12$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $4f88f2d3e506ed12$var$_default = module.exports.default = $4f88f2d3e506ed12$var$ChevronUpIcon;

});


parcelRegister("iLFTD", function(module, exports) {

$parcel$export(module.exports, "default", () => $41497c8b4d0b6d68$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $41497c8b4d0b6d68$var$messages = (0, $7VHMR.defineMessages)({
    previousIssueTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-tooltip",
        "defaultMessage": "Previous issue ''{issueKey}'' (Type 'k')"
    },
    previousIssueWithoutKeyTooltip: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-without-key-tooltip",
        "defaultMessage": "Previous issue (Type 'k')"
    },
    disabledButtonLabel: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.disabled-button-label",
        "defaultMessage": "No previous issue, select next issue"
    },
    disabledButtonLabelIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.disabled-button-label-issue-term-refresh",
        "defaultMessage": "No previous work item, select next work item"
    },
    previousIssueTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-tooltip-issue-term-refresh",
        "defaultMessage": "Previous work item ''{issueKey}'' (Type 'k')"
    },
    previousIssueWithoutKeyTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.issue-app.header-actions.issue-pagination.previous-button.previous-issue-without-key-tooltip-issue-term-refresh",
        "defaultMessage": "Previous work item (Type 'k')"
    }
});
var $41497c8b4d0b6d68$export$2e2bcd8739ae039 = $41497c8b4d0b6d68$var$messages;

});




parcelRegister("ltUBN", function(module, exports) {

$parcel$export(module.exports, "useScrollToActivityFeed", () => $7bc9ecf5cf789e11$export$5322fd37f123913);

var $5uXOq = parcelRequire("5uXOq");

var $92wsG = parcelRequire("92wsG");

var $ieDtd = parcelRequire("ieDtd");
const $7bc9ecf5cf789e11$var$INTERVAL = 100;
const $7bc9ecf5cf789e11$var$TIMEOUT = 10000;
const $7bc9ecf5cf789e11$export$f0c653cfd7dea798 = ()=>{
    return globalThis.document.getElementById((0, $92wsG.ELID_ISSUE_ACTIVITY_FEED));
};
const $7bc9ecf5cf789e11$export$5322fd37f123913 = (issueKey)=>{
    const viewActivity = (0, $ieDtd.useQueryParam)('viewActivity')[0] === 'true';
    const intervalId = (0, $5uXOq.useRef)();
    const timeoutId = (0, $5uXOq.useRef)();
    const isTimeout = (0, $5uXOq.useRef)(false);
    const waitForElement = (0, $5uXOq.useCallback)(()=>{
        if (isTimeout.current) return;
        const ref = $7bc9ecf5cf789e11$export$f0c653cfd7dea798();
        if (ref) // sometimes the browser can't immediately scroll,
        // so we add a small timeout here to let it render Bento first
        setTimeout(()=>{
            ref.scrollIntoView({
                block: 'start',
                inline: 'nearest'
            });
        }, 300);
        else intervalId.current = setTimeout(waitForElement, $7bc9ecf5cf789e11$var$INTERVAL);
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!viewActivity) return;
        clearTimeout(intervalId.current);
        clearTimeout(timeoutId.current);
        isTimeout.current = false;
        // clear the interval in case comments section never shows up
        timeoutId.current = setTimeout(()=>{
            isTimeout.current = true;
        }, $7bc9ecf5cf789e11$var$TIMEOUT);
        // kick off the interval if issueKey changes + on mount
        intervalId.current = setTimeout(waitForElement, $7bc9ecf5cf789e11$var$INTERVAL);
        // clear interval on unmount
        return ()=>{
            clearTimeout(intervalId.current);
            clearTimeout(timeoutId.current);
        };
    }, [
        waitForElement,
        issueKey,
        viewActivity
    ]);
};

});
parcelRegister("92wsG", function(module, exports) {

$parcel$export(module.exports, "issueAppModalWrapperClassName", () => $fcc2b749aa610036$export$6bf7918be801e6c5);
$parcel$export(module.exports, "MODAL_DROPDOWN_PORTAL_CLASS_NAME", () => $fcc2b749aa610036$export$bab98b619b4558be);
$parcel$export(module.exports, "EDITOR_DROPDOWN_PORTAL_CLASS_NAME", () => $fcc2b749aa610036$export$2ec9dc4e52ec0b5d);
$parcel$export(module.exports, "EDITOR_END_CLASS_NAME", () => $fcc2b749aa610036$export$18cffbebfac64f6d);
$parcel$export(module.exports, "EDITOR_START_CLASS_NAME", () => $fcc2b749aa610036$export$ebb284f63692b8b2);
$parcel$export(module.exports, "ISSUE_DESCRIPTION_EDITOR_ID", () => $fcc2b749aa610036$export$b8a46c806f8a6ef3);
$parcel$export(module.exports, "GIC_ISSUE_DESCRIPTION_EDITOR_ID", () => $fcc2b749aa610036$export$96cae1d6f7d37701);
$parcel$export(module.exports, "ELID_ISSUE_HEADER", () => $fcc2b749aa610036$export$4ca9dd62cc85a6c6);
$parcel$export(module.exports, "ELID_ISSUE_HEADER_ACTIONS", () => $fcc2b749aa610036$export$23d48b936935fa57);
$parcel$export(module.exports, "ELID_ISSUE_ACTIVITY_FEED", () => $fcc2b749aa610036$export$f1f90756574f5f9b);
$parcel$export(module.exports, "AGG_ISSUE_ERROR_ANALYTICS", () => $fcc2b749aa610036$export$66553a9be1be2f7e);
$parcel$export(module.exports, "QUICK_ADD_ITEMS_ADD_BUTTON_REF_KEY", () => $fcc2b749aa610036$export$899103370186f1a1);
$parcel$export(module.exports, "DESIGN_PANEL_HEADING_ADD_DESIGN_REF_KEY", () => $fcc2b749aa610036$export$736b3d7f44d56d71);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $fmm8O = parcelRequire("fmm8O");

var $38bVB = parcelRequire("38bVB");











var $79RqQ = parcelRequire("79RqQ");

const $fcc2b749aa610036$export$6bf7918be801e6c5 = '_issue-app-modal-dialog-wrapper';
const $fcc2b749aa610036$export$bab98b619b4558be = 'issue-app-modal-ak-dropdown-portal';
const $fcc2b749aa610036$export$2ec9dc4e52ec0b5d = 'issue-app-modal-editor-dropdown-portal';
const $fcc2b749aa610036$export$18cffbebfac64f6d = 'issue-editor-end';
const $fcc2b749aa610036$export$ebb284f63692b8b2 = 'issue-editor-start';
const $fcc2b749aa610036$export$b8a46c806f8a6ef3 = 'issue-description-editor';
const $fcc2b749aa610036$export$96cae1d6f7d37701 = 'issue-create.common.ui.fields.description-field.wrapper';
const $fcc2b749aa610036$export$3ef7e400a3598524 = 'issue.error';
const $fcc2b749aa610036$export$4ca9dd62cc85a6c6 = 'jira-issue-header';
const $fcc2b749aa610036$export$23d48b936935fa57 = 'jira-issue-header-actions';
const $fcc2b749aa610036$export$f1f90756574f5f9b = 'jira-issue-activity-feed';
const $fcc2b749aa610036$export$66553a9be1be2f7e = 'issue.error.agg';
const $fcc2b749aa610036$export$899103370186f1a1 = 'quick-add-items.add-button';
const $fcc2b749aa610036$export$736b3d7f44d56d71 = 'design-panel.heading.add-design';

});
parcelRegister("fmm8O", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_WATCHING_ERROR", () => $99d43d51c2dfe210$export$ec8031e221d27341);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_GENERIC", () => $99d43d51c2dfe210$export$78f84210a13989cb);
$parcel$export(module.exports, "COMMENT_ADD_ERROR_INVALID", () => $99d43d51c2dfe210$export$10b0b01977598ffc);
$parcel$export(module.exports, "COMMENT_ACTION_ERROR_INVALID_PERMISSION", () => $99d43d51c2dfe210$export$8443c3b41d7f09d8);
$parcel$export(module.exports, "COMMENT_CONTENT_EXCEEDED_ERROR", () => $99d43d51c2dfe210$export$9b38ca770beaf3d0);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS_FLAG_MESSAGE", () => $99d43d51c2dfe210$export$eef81693e817e3a6);
$parcel$export(module.exports, "COMMENT_FUTURE_TIME_ERROR", () => $99d43d51c2dfe210$export$a0d4d86bde270ad6);
$parcel$export(module.exports, "COMMENT_DELETE_ERROR", () => $99d43d51c2dfe210$export$6b6cd1b99772a4a1);
$parcel$export(module.exports, "EDITOR_ERROR", () => $99d43d51c2dfe210$export$2e48be8618f1b4f8);
$parcel$export(module.exports, "ATTACHMENT_ADD_ERROR", () => $99d43d51c2dfe210$export$c060b7873ebc2eb3);
$parcel$export(module.exports, "ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR", () => $99d43d51c2dfe210$export$1f8e6f6f8d64a715);
$parcel$export(module.exports, "ATTACHMENT_ADD_SUCCESS", () => $99d43d51c2dfe210$export$1f92a25b34c4df93);
$parcel$export(module.exports, "DELETE_LINKED_ISSUE_ERROR", () => $99d43d51c2dfe210$export$d8750340852b965e);
$parcel$export(module.exports, "REMOTE_LINK_VALIDATION_ERROR", () => $99d43d51c2dfe210$export$f0962d071c2a358a);
$parcel$export(module.exports, "ATTACHMENT_DELETE_ERROR", () => $99d43d51c2dfe210$export$ef7767ceecf9097c);
$parcel$export(module.exports, "WATCH_TOGGLE_UPDATE_ERROR", () => $99d43d51c2dfe210$export$516af79f4e3b8794);
$parcel$export(module.exports, "FETCH_WATCHERS_ERROR", () => $99d43d51c2dfe210$export$cde4105f7711a10a);
$parcel$export(module.exports, "STOP_WATCHING_SUCCESS", () => $99d43d51c2dfe210$export$f674d1f44f57f99d);
$parcel$export(module.exports, "START_WATCHING_SUCCESS", () => $99d43d51c2dfe210$export$bff6b5ab70bcec53);
$parcel$export(module.exports, "REMOVE_WATCHER_ERROR", () => $99d43d51c2dfe210$export$37934e343a22c4e6);
$parcel$export(module.exports, "ADD_WATCHER_ERROR", () => $99d43d51c2dfe210$export$6a1827094c1ef6d8);
$parcel$export(module.exports, "SUBTASKS_REORDER_ERROR_GENERIC", () => $99d43d51c2dfe210$export$bb96d519395e5dcc);
$parcel$export(module.exports, "LOG_WORK_CONFIRM_ERROR", () => $99d43d51c2dfe210$export$18bd55ba676f8b6d);
$parcel$export(module.exports, "ASSIGN_TO_ME_SUCCESS", () => $99d43d51c2dfe210$export$1249a100986a9489);
$parcel$export(module.exports, "REMOVE_FROM_ME_SUCCESS", () => $99d43d51c2dfe210$export$6b737093486e5a4e);
$parcel$export(module.exports, "CREATE_CHILD_ISSUE_ERROR", () => $99d43d51c2dfe210$export$a2723f15441225d0);
$parcel$export(module.exports, "LINK_CHILD_ISSUE_ERROR", () => $99d43d51c2dfe210$export$569f7258d337be55);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_SUCCESS", () => $99d43d51c2dfe210$export$f92af4e9761d23b9);
$parcel$export(module.exports, "CHANGE_ISSUE_TYPE_ERROR", () => $99d43d51c2dfe210$export$16dc9ff6a8822a90);
$parcel$export(module.exports, "DELETE_ISSUE_ERROR", () => $99d43d51c2dfe210$export$d4030883b7b7a04);
$parcel$export(module.exports, "ADD_WORKLOG_SUCCESS", () => $99d43d51c2dfe210$export$2519b72aefd62ee3);
$parcel$export(module.exports, "ADD_WORKLOG_FAILURE", () => $99d43d51c2dfe210$export$190e4e4a6ee2a0a2);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$f1709ebef49207cc);
$parcel$export(module.exports, "UPDATE_TIME_REMAINING_FAILURE", () => $99d43d51c2dfe210$export$bde55584c7518e8d);
$parcel$export(module.exports, "EDIT_WORKLOG_SUCCESS", () => $99d43d51c2dfe210$export$cf8d549e537c67d3);
$parcel$export(module.exports, "EDIT_WORKLOG_FAILURE", () => $99d43d51c2dfe210$export$2d33e591258e36a8);
$parcel$export(module.exports, "DELETE_WORKLOG_SUCCESS", () => $99d43d51c2dfe210$export$b595535e9bb1a2a2);
$parcel$export(module.exports, "DELETE_WORKLOG_FAILURE", () => $99d43d51c2dfe210$export$c3739a68f63b7e09);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_CONFIRM_ERROR", () => $99d43d51c2dfe210$export$6ba6cb22d5a3c521);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR", () => $99d43d51c2dfe210$export$b1a41c9183097dc);
$parcel$export(module.exports, "RICH_CONTENT_FIELD_REQUIRED_ERROR", () => $99d43d51c2dfe210$export$67544887e2b37fbc);
$parcel$export(module.exports, "DELETE_CONFLUENCE_PAGE_LINK_FAILED", () => $99d43d51c2dfe210$export$67566c205c72838a);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_ERROR", () => $99d43d51c2dfe210$export$733fe45ab8c75209);
$parcel$export(module.exports, "SAVE_APPROVAL_ANSWER_SUCCESS", () => $99d43d51c2dfe210$export$9d1386a2d0651ca9);
$parcel$export(module.exports, "EDIT_EPIC_COLOUR_ERROR", () => $99d43d51c2dfe210$export$56094d7f6af14eac);
$parcel$export(module.exports, "EDIT_ISSUE_COLOUR_ERROR", () => $99d43d51c2dfe210$export$92d58445895900f9);
$parcel$export(module.exports, "FETCH_JIRA_APP_LINKS_ERROR", () => $99d43d51c2dfe210$export$75d850be4d27b98e);
$parcel$export(module.exports, "CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$9030bf81702823b8);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$a2a71fb6b193e549);
$parcel$export(module.exports, "ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$8c5e4d3dfe9a1c32);
$parcel$export(module.exports, "ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$49d11338d75de478);
$parcel$export(module.exports, "ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED", () => $99d43d51c2dfe210$export$3573d8ff428b4c8f);
$parcel$export(module.exports, "COMMENTS_LIMIT_EXCEEDED_FIELDS_LIST", () => $99d43d51c2dfe210$export$c0657c5ed1bbfed4);
const $99d43d51c2dfe210$export$ec8031e221d27341 = 'TOGGLE_WATCHING_ERROR';
const $99d43d51c2dfe210$export$78f84210a13989cb = 'COMMENT_ADD_ERROR_GENERIC';
const $99d43d51c2dfe210$export$10b0b01977598ffc = 'COMMENT_ADD_ERROR_INVALID';
const $99d43d51c2dfe210$export$8443c3b41d7f09d8 = 'COMMENT_ACTION_ERROR_INVALID_PERMISSION';
const $99d43d51c2dfe210$export$9b38ca770beaf3d0 = 'COMMENT_CONTENT_EXCEEDED_ERROR';
const $99d43d51c2dfe210$export$eef81693e817e3a6 = 'SAVE_COMMENT_SUCCESS_FLAG_MESSAGE';
const $99d43d51c2dfe210$export$a0d4d86bde270ad6 = 'COMMENT_FUTURE_TIME_ERROR';
const $99d43d51c2dfe210$export$6b6cd1b99772a4a1 = 'COMMENT_DELETE_ERROR';
const $99d43d51c2dfe210$export$2e48be8618f1b4f8 = 'EDITOR_ERROR';
const $99d43d51c2dfe210$export$c060b7873ebc2eb3 = 'ATTACHMENT_ADD_ERROR';
const $99d43d51c2dfe210$export$1f8e6f6f8d64a715 = 'ATTACHMENT_ADD_EXCEED_SIZE_LIMIT_ERROR';
const $99d43d51c2dfe210$export$1f92a25b34c4df93 = 'ATTACHMENT_ADD_SUCCESS';
const $99d43d51c2dfe210$export$d8750340852b965e = 'DELETE_LINKED_ISSUE_ERROR';
const $99d43d51c2dfe210$export$f0962d071c2a358a = 'REMOTE_LINK_VALIDATION_ERROR';
const $99d43d51c2dfe210$export$ef7767ceecf9097c = 'ATTACHMENT_DELETE_ERROR';
const $99d43d51c2dfe210$export$516af79f4e3b8794 = 'WATCH_TOGGLE_UPDATE_ERROR';
const $99d43d51c2dfe210$export$cde4105f7711a10a = 'FETCH_WATCHERS_ERROR';
const $99d43d51c2dfe210$export$f674d1f44f57f99d = 'STOP_WATCHING_SUCCESS';
const $99d43d51c2dfe210$export$bff6b5ab70bcec53 = 'START_WATCHING_SUCCESS';
const $99d43d51c2dfe210$export$37934e343a22c4e6 = 'REMOVE_WATCHER_ERROR';
const $99d43d51c2dfe210$export$6a1827094c1ef6d8 = 'ADD_WATCHER_ERROR';
const $99d43d51c2dfe210$export$bb96d519395e5dcc = 'SUBTASKS_REORDER_ERROR_GENERIC';
const $99d43d51c2dfe210$export$18bd55ba676f8b6d = 'LOG_WORK_CONFIRM_ERROR';
const $99d43d51c2dfe210$export$1249a100986a9489 = 'ASSIGN_TO_ME_SUCCESS';
const $99d43d51c2dfe210$export$6b737093486e5a4e = 'REMOVE_FROM_ME_SUCCESS';
const $99d43d51c2dfe210$export$a2723f15441225d0 = 'CREATE_CHILD_ISSUE_ERROR';
const $99d43d51c2dfe210$export$569f7258d337be55 = 'LINK_CHILD_ISSUE_ERROR';
const $99d43d51c2dfe210$export$f92af4e9761d23b9 = 'CHANGE_ISSUE_TYPE_SUCCESS';
const $99d43d51c2dfe210$export$16dc9ff6a8822a90 = 'CHANGE_ISSUE_TYPE_ERROR';
const $99d43d51c2dfe210$export$d4030883b7b7a04 = 'DELETE_ISSUE_ERROR';
const $99d43d51c2dfe210$export$2519b72aefd62ee3 = 'ADD_WORKLOG_SUCCESS';
const $99d43d51c2dfe210$export$190e4e4a6ee2a0a2 = 'ADD_WORKLOG_FAILURE';
const $99d43d51c2dfe210$export$f1709ebef49207cc = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$2357f9add92f1c9b = 'UPDATE_TIME_REMAINING_SUCCESS';
const $99d43d51c2dfe210$export$bde55584c7518e8d = 'UPDATE_TIME_REMAINING_FAILURE';
const $99d43d51c2dfe210$export$cf8d549e537c67d3 = 'EDIT_WORKLOG_SUCCESS';
const $99d43d51c2dfe210$export$2d33e591258e36a8 = 'EDIT_WORKLOG_FAILURE';
const $99d43d51c2dfe210$export$b595535e9bb1a2a2 = 'DELETE_WORKLOG_SUCCESS';
const $99d43d51c2dfe210$export$c3739a68f63b7e09 = 'DELETE_WORKLOG_FAILURE';
const $99d43d51c2dfe210$export$6ba6cb22d5a3c521 = 'RICH_CONTENT_FIELD_CONFIRM_ERROR';
const $99d43d51c2dfe210$export$b1a41c9183097dc = 'RICH_CONTENT_FIELD_MAXIMUM_LENGTH_EXCEEDED_ERROR';
const $99d43d51c2dfe210$export$67544887e2b37fbc = 'RICH_CONTENT_FIELD_REQUIRED_ERROR';
const $99d43d51c2dfe210$export$67566c205c72838a = 'DELETE_CONFLUENCE_PAGE_LINK_FAILED';
const $99d43d51c2dfe210$export$e3245a362f751a4a = 'DELETE_WEB_LINK_FAILED';
const $99d43d51c2dfe210$export$3408969e4d418350 = 'CLICKTHROUGH_BANNER_DISMISS_SUCCESS';
const $99d43d51c2dfe210$export$733fe45ab8c75209 = 'SAVE_APPROVAL_ANSWER_ERROR';
const $99d43d51c2dfe210$export$9d1386a2d0651ca9 = 'SAVE_APPROVAL_ANSWER_SUCCESS';
const $99d43d51c2dfe210$export$56094d7f6af14eac = 'EDIT_EPIC_COLOUR_ERROR';
const $99d43d51c2dfe210$export$92d58445895900f9 = 'EDIT_ISSUE_COLOUR_ERROR';
const $99d43d51c2dfe210$export$75d850be4d27b98e = 'FETCH_JIRA_APP_LINKS_ERROR';
const $99d43d51c2dfe210$export$9030bf81702823b8 = 'CONFLUENCE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$a2a71fb6b193e549 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$2dd786d54c8f9397 = 'COMMENTS_INTERNAL_SERVER_ERROR';
const $99d43d51c2dfe210$export$8c5e4d3dfe9a1c32 = 'ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$49d11338d75de478 = 'ISSUE_REMOTE_LINKS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$3573d8ff428b4c8f = 'ISSUE_ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED';
const $99d43d51c2dfe210$export$c0657c5ed1bbfed4 = [
    $99d43d51c2dfe210$export$a2a71fb6b193e549,
    $99d43d51c2dfe210$export$3573d8ff428b4c8f
];

});

parcelRegister("38bVB", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $393fc438b9efd4fd$export$89b6937a83edcaa6);
$parcel$export(module.exports, "EXCEEDED_LIMIT_INITIAL_LOAD", () => $393fc438b9efd4fd$export$763881dbba851043);
$parcel$export(module.exports, "EXCEEDED_LIMIT_AFTER_LOAD", () => $393fc438b9efd4fd$export$8a23145a6d5f95e3);
$parcel$export(module.exports, "WITHIN_LIMIT", () => $393fc438b9efd4fd$export$a7af19981a3e4baf);
$parcel$export(module.exports, "HREF", () => $393fc438b9efd4fd$export$74921a9774a80542);
$parcel$export(module.exports, "IN_PRODUCT_HELP", () => $393fc438b9efd4fd$export$cd480f5ec4739dab);
$parcel$export(module.exports, "WHAT_ARE_ISSUE_TYPES_URL", () => $393fc438b9efd4fd$export$470a531b30a8dea1);
$parcel$export(module.exports, "IN_PRODUCT_HELP_ARTICLE_IDS", () => $393fc438b9efd4fd$export$3691506c72823b65);
$parcel$export(module.exports, "DISMISSED", () => $393fc438b9efd4fd$export$6a4add537aaf5560);
$parcel$export(module.exports, "DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE", () => $393fc438b9efd4fd$export$6d6e3176028f2228);
$parcel$export(module.exports, "DEFAULT_ASSIGNEE_PERMISSION_ERROR_MESSAGE_FE", () => $393fc438b9efd4fd$export$17d19a319fd47c32);
$parcel$export(module.exports, "GIC_CALLBACK_PAYLOAD_INLINE_CREATE_ID", () => $393fc438b9efd4fd$export$9e448086914e060);
$parcel$export(module.exports, "GIC_CALLBACK_PAYLOAD_AI_BREAKDOWN_CREATE_ID", () => $393fc438b9efd4fd$export$2dd6afd9432dbc93);

var $2vSU6 = parcelRequire("2vSU6");
const $393fc438b9efd4fd$var$CHILD_ISSUES_LIMIT = 500;
const $393fc438b9efd4fd$export$89b6937a83edcaa6 = ()=>$393fc438b9efd4fd$var$CHILD_ISSUES_LIMIT;
const $393fc438b9efd4fd$export$763881dbba851043 = 'EXCEEDED_LIMIT_INITIAL_LOAD';
const $393fc438b9efd4fd$export$8a23145a6d5f95e3 = 'EXCEEDED_LIMIT_AFTER_LOAD';
const $393fc438b9efd4fd$export$a7af19981a3e4baf = 'WITHIN_LIMIT';
const $393fc438b9efd4fd$export$74921a9774a80542 = 'HREF';
const $393fc438b9efd4fd$export$cd480f5ec4739dab = 'IN_PRODUCT_HELP';
const $393fc438b9efd4fd$export$470a531b30a8dea1 = 'https://support.atlassian.com/jira-cloud-administration/docs/what-are-issue-types/';
const $393fc438b9efd4fd$export$3691506c72823b65 = {
    [(0, $2vSU6.CORE_PROJECT)]: '2uhc4ieBPinkLJlWbdhXkC',
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'z6BNb3cPucF3fi5UA85Ma',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: '6feRxZzkYUHez8TwHTjSut',
    [(0, $2vSU6.CUSTOMER_SERVICE_PROJECT)]: null,
    [(0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)]: null
};
const $393fc438b9efd4fd$export$6a4add537aaf5560 = 'dismissed';
const $393fc438b9efd4fd$export$6d6e3176028f2228 = 'The default assignee does NOT have ASSIGNABLE permission OR Unassigned issues are turned off.';
const $393fc438b9efd4fd$export$17d19a319fd47c32 = "The default assignee doesn\u2019t have the Assignable User permission, or unassigned issues are turned off.";
const $393fc438b9efd4fd$export$9e448086914e060 = 'issue-view-child-issues-panel-inline-create';
const $393fc438b9efd4fd$export$2dd6afd9432dbc93 = 'issue-view-child-issues-panel-ai-breakdown-create';

});

parcelRegister("79RqQ", function(module, exports) {

$parcel$export(module.exports, "ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$dd2d62bc7ec6ce51);
$parcel$export(module.exports, "COMMENTS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$db1ab2b83dc17aa9);
$parcel$export(module.exports, "WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$940ce115dba33e55);
$parcel$export(module.exports, "REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED_ERROR_MESSAGE", () => $5fa2842a51e11b84$export$4ec1f3604b85d553);
$parcel$export(module.exports, "GROUP_VISIBILITY_SETTING_NOT_ENABLED", () => $5fa2842a51e11b84$export$69483322ede4b803);
$parcel$export(module.exports, "ISSUE_LIMIT_FIELDS_ERROR_MESSAGE_LIST", () => $5fa2842a51e11b84$export$e65b95e776ce6f27);
const $5fa2842a51e11b84$export$dd2d62bc7ec6ce51 = 'ATTACHMENTS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $5fa2842a51e11b84$export$db1ab2b83dc17aa9 = 'COMMENTS_PER_ISSUE_LIMIT_EXCEEDED: 5000';
const $5fa2842a51e11b84$export$940ce115dba33e55 = 'WORKLOGS_PER_ISSUE_LIMIT_EXCEEDED: 10000';
const $5fa2842a51e11b84$export$4ec1f3604b85d553 = 'REMOTE_ISSUE_LINKS_PER_ISSUE_LIMIT_EXCEEDED: 2000';
const $5fa2842a51e11b84$export$69483322ede4b803 = 'GROUP_VISIBILITY_SETTING_NOT_ENABLED';
const $5fa2842a51e11b84$export$e65b95e776ce6f27 = [
    $5fa2842a51e11b84$export$dd2d62bc7ec6ce51,
    $5fa2842a51e11b84$export$db1ab2b83dc17aa9,
    $5fa2842a51e11b84$export$940ce115dba33e55,
    $5fa2842a51e11b84$export$4ec1f3604b85d553
];

});

const $7e58198413094512$export$bd6f44214f84c29a = 4102;
const $7e58198413094512$export$aa53f670803b96e = 3165;



parcelRegister("gG7bT", function(module, exports) {

let $c246258350de06aa$var$load = (parcelRequire("28QjX"))(4);































module.exports = Promise.all([
    (parcelRequire("avM1e"))('memo_fix_issue_field_remounts_2', function() {
        return Promise.all([
            $c246258350de06aa$var$load("1oP3P")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("9ev6R")
        ]);
    }),
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $c246258350de06aa$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('jirt-convert-class-to-functional-component', function() {
        return Promise.all([
            $c246258350de06aa$var$load("1ls92")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("kLeYK")
        ]);
    }),
    (parcelRequire("avM1e"))('redaction_onboarding_iv_llc', function() {
        return Promise.all([
            $c246258350de06aa$var$load("czPin")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("iGvP4")
        ]);
    }),
    (parcelRequire("avM1e"))('jiv-20591-renderer-rerenders-fix-refactor', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $c246258350de06aa$var$load("lh7CA"),
                    $c246258350de06aa$var$load("kNFvF"),
                    $c246258350de06aa$var$load("kvRbA"),
                    $c246258350de06aa$var$load("ffQaD"),
                    $c246258350de06aa$var$load("l253H"),
                    $c246258350de06aa$var$load("76n7a"),
                    $c246258350de06aa$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $c246258350de06aa$var$load("jrRVX")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $c246258350de06aa$var$load("d5z58"),
                    $c246258350de06aa$var$load("kvRbA"),
                    $c246258350de06aa$var$load("ffQaD"),
                    $c246258350de06aa$var$load("l253H"),
                    $c246258350de06aa$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $c246258350de06aa$var$load("f771T")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $c246258350de06aa$var$load("gXEyJ"),
                    $c246258350de06aa$var$load("kvRbA"),
                    $c246258350de06aa$var$load("ffQaD"),
                    $c246258350de06aa$var$load("l253H"),
                    $c246258350de06aa$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $c246258350de06aa$var$load("hy7ba")
                ]);
            }),
            $c246258350de06aa$var$load("gDexj")
        ]);
    }, function() {
        return Promise.all([
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-card-nodes', function() {
                return Promise.all([
                    $c246258350de06aa$var$load("lh7CA"),
                    $c246258350de06aa$var$load("kNFvF"),
                    $c246258350de06aa$var$load("kvRbA"),
                    $c246258350de06aa$var$load("ffQaD"),
                    $c246258350de06aa$var$load("l253H"),
                    $c246258350de06aa$var$load("76n7a"),
                    $c246258350de06aa$var$load("fliVL")
                ]);
            }, function() {
                return Promise.all([
                    $c246258350de06aa$var$load("jrRVX")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-small-nodes', function() {
                return Promise.all([
                    $c246258350de06aa$var$load("d5z58"),
                    $c246258350de06aa$var$load("kvRbA"),
                    $c246258350de06aa$var$load("ffQaD"),
                    $c246258350de06aa$var$load("l253H"),
                    $c246258350de06aa$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $c246258350de06aa$var$load("f771T")
                ]);
            }),
            (parcelRequire("avM1e"))('magma-3467-iv-renderer-sync-media-nodes', function() {
                return Promise.all([
                    $c246258350de06aa$var$load("gXEyJ"),
                    $c246258350de06aa$var$load("kvRbA"),
                    $c246258350de06aa$var$load("ffQaD"),
                    $c246258350de06aa$var$load("l253H"),
                    $c246258350de06aa$var$load("76n7a")
                ]);
            }, function() {
                return Promise.all([
                    $c246258350de06aa$var$load("hy7ba")
                ]);
            }),
            $c246258350de06aa$var$load("hyyp4")
        ]);
    }),
    (parcelRequire("avM1e"))('jira_amplitude_sr', function() {
        return Promise.all([
            $c246258350de06aa$var$load("8EtZR"),
            $c246258350de06aa$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("6jOz3")
        ]);
    }),
    (parcelRequire("avM1e"))('jiv-20455-dev-panel-to-sync', function() {
        return Promise.all([
            (parcelRequire("avM1e"))('jiv-20508-remove-height-animation-dev-panel', function() {
                return Promise.all([
                    $c246258350de06aa$var$load("hm756")
                ]);
            }, function() {
                return Promise.all([]);
            }),
            (parcelRequire("avM1e"))('create-branch-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $c246258350de06aa$var$load("46Z1D")
                ]);
            }, function() {
                return Promise.all([
                    $c246258350de06aa$var$load("3DKoG")
                ]);
            }),
            (parcelRequire("avM1e"))('create-commit-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $c246258350de06aa$var$load("cNRxo")
                ]);
            }, function() {
                return Promise.all([
                    $c246258350de06aa$var$load("i8oWy")
                ]);
            }),
            (parcelRequire("avM1e"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $c246258350de06aa$var$load("63C5i")
                ]);
            }, function() {
                return Promise.all([
                    $c246258350de06aa$var$load("lbT1q")
                ]);
            }),
            (parcelRequire("avM1e"))('create_pullrequest_dropdown_iv_llc_dev_panel', function() {
                return Promise.all([
                    $c246258350de06aa$var$load("63C5i")
                ]);
            }, function() {
                return Promise.all([
                    $c246258350de06aa$var$load("lbT1q")
                ]);
            }),
            (parcelRequire("avM1e"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
                return Promise.all([
                    $c246258350de06aa$var$load("lIp00")
                ]);
            }, function() {
                return Promise.all([
                    $c246258350de06aa$var$load("cZoU9")
                ]);
            }),
            (parcelRequire("avM1e"))('ff-action-dropdown-simple-iv-llc-dev-panel', function() {
                return Promise.all([
                    $c246258350de06aa$var$load("lIp00")
                ]);
            }, function() {
                return Promise.all([
                    $c246258350de06aa$var$load("cZoU9")
                ]);
            }),
            (parcelRequire("avM1e"))('vulnerability-dropdown-iv-llc-dev-panel', function() {
                return Promise.all([
                    $c246258350de06aa$var$load("dsjsy")
                ]);
            }, function() {
                return Promise.all([
                    $c246258350de06aa$var$load("QeZ1l")
                ]);
            }),
            $c246258350de06aa$var$load("ckYFZ"),
            $c246258350de06aa$var$load("kvRbA"),
            $c246258350de06aa$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("etgJj")
        ]);
    }),
    (parcelRequire("avM1e"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $c246258350de06aa$var$load("84z1X")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("eBkr0")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $c246258350de06aa$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $c246258350de06aa$var$load("cTJTG"),
            $c246258350de06aa$var$load("l253H"),
            $c246258350de06aa$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('fix_versions_component_perf_improvement_vc90', function() {
        return Promise.all([
            $c246258350de06aa$var$load("6TXdv")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("4t8fr")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-concurrent-status-field-fix', function() {
        return Promise.all([
            $c246258350de06aa$var$load("7lud2")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("7B2gt")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_automation_button_iv_llc', function() {
        return Promise.all([
            $c246258350de06aa$var$load("5VTmG")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("6mU2N"),
            $c246258350de06aa$var$load("kvRbA"),
            $c246258350de06aa$var$load("ffQaD")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_issue_view_comment_ai', function() {
        return Promise.all([
            $c246258350de06aa$var$load("egvYO")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("hkt2G")
        ]);
    }),
    (parcelRequire("avM1e"))('issue_comment_reply_list_sync_import', function() {
        return Promise.all([
            $c246258350de06aa$var$load("eZWUu")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("aWylw")
        ]);
    }),
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("7ClEP")
        ]);
    }),
    (parcelRequire("avM1e"))('jira-issue-view-child-issues-panel-entrypoint', function() {
        return Promise.all([
            $c246258350de06aa$var$load("fdfwb")
        ]);
    }, function() {
        return Promise.all([
            $c246258350de06aa$var$load("7TIhF")
        ]);
    }),
    $c246258350de06aa$var$load("5BNUw"),
    $c246258350de06aa$var$load("kGAgW"),
    $c246258350de06aa$var$load("3yAl4"),
    $c246258350de06aa$var$load("fliVL"),
    $c246258350de06aa$var$load("7mIf9"),
    $c246258350de06aa$var$load("jXweD"),
    $c246258350de06aa$var$load("jbxE1"),
    $c246258350de06aa$var$load("7imUH"),
    $c246258350de06aa$var$load("ffQaD"),
    $c246258350de06aa$var$load("kvRbA"),
    $c246258350de06aa$var$load("kVX56"),
    $c246258350de06aa$var$load("kNFvF"),
    $c246258350de06aa$var$load("76n7a"),
    $c246258350de06aa$var$load("l253H"),
    $c246258350de06aa$var$load("gaip1")
]).then(()=>parcelRequire('6qbjz'));

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});



parcelRegister("kj1di", function(module, exports) {

$parcel$export(module.exports, "InfiniteScrollProvider", () => $0de0172be9dbd684$export$f4ede5143c1d55e9);
$parcel$export(module.exports, "useInfiniteScroll", () => $0de0172be9dbd684$export$a973cef5093a8d22);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $eTXmK = parcelRequire("eTXmK");

var $4R6GH = parcelRequire("4R6GH");

var $czfFt = parcelRequire("czfFt");

var $6UAdF = parcelRequire("6UAdF");
const $0de0172be9dbd684$var$INFINITE_SCROLL_DEFAULT_OPTIONS = {
    pageSize: (0, $6UAdF.MAX_ISSUES_PER_PAGE),
    threshold: 5 * (0, $czfFt.ROW_HEIGHT)
};
const $0de0172be9dbd684$var$INFINITE_SCROLL_INTERACTION_NAME = 'issue-navigator.infinite-scroll';
const $0de0172be9dbd684$var$InfiniteScrollContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    onLoadNext: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onLoadPrevious: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    isLoadingNext: false,
    isLoadingPrevious: false,
    hasNext: false,
    hasPrevious: false
});
const $0de0172be9dbd684$export$f4ede5143c1d55e9 = ({ onLoadNext: onLoadNext, onLoadPrevious: onLoadPrevious, isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, children: children })=>{
    const value = (0, $5uXOq.useMemo)(()=>({
            onLoadNext: onLoadNext,
            onLoadPrevious: onLoadPrevious,
            isLoadingNext: isLoadingNext,
            isLoadingPrevious: isLoadingPrevious,
            hasNext: hasNext,
            hasPrevious: hasPrevious
        }), [
        onLoadNext,
        onLoadPrevious,
        isLoadingNext,
        isLoadingPrevious,
        hasNext,
        hasPrevious
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0de0172be9dbd684$var$InfiniteScrollContext.Provider, {
        value: value
    }, children);
};
function $0de0172be9dbd684$export$a973cef5093a8d22({ fieldSetIds: fieldSetIds, view: view, groupBy: groupBy, options: options, isHierarchyEnabled: isHierarchyEnabled, isHideDoneEnabled: isHideDoneEnabled, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled }) {
    const { pageSize: pageSize, threshold: threshold } = {
        ...$0de0172be9dbd684$var$INFINITE_SCROLL_DEFAULT_OPTIONS,
        ...options
    };
    const { onLoadNext: onLoadNextProp, onLoadPrevious: onLoadPreviousProp, ...rest } = (0, $5uXOq.useContext)($0de0172be9dbd684$var$InfiniteScrollContext);
    // Extra static variables to ensure consistent field set results are returned during pagination.
    const staticPaginationVariables = (0, $5uXOq.useMemo)(()=>({
            ...isIssueHierarchySupportEnabled && {
                viewConfigInput: {
                    staticViewInput: {
                        isHierarchyEnabled: isHierarchyEnabled || false,
                        ...(0, $4R6GH.fg)('jsc_list_hide_done_items') ? {
                            isHideDoneEnabled: isHideDoneEnabled
                        } : {}
                    }
                }
            },
            fieldSetsInput: {
                fieldSetIds: fieldSetIds
            },
            groupBy: groupBy,
            isPaginating: true
        }), [
        fieldSetIds,
        groupBy,
        isHideDoneEnabled,
        isHierarchyEnabled,
        isIssueHierarchySupportEnabled
    ]);
    const onLoadNext = (0, $5uXOq.useCallback)(()=>{
        if (view && (0, $4R6GH.fg)('add_nin_press_interactions')) (0, $eTXmK.default)(`${$0de0172be9dbd684$var$INFINITE_SCROLL_INTERACTION_NAME}.${view}`);
        return onLoadNextProp(pageSize, {
            UNSTABLE_extraVariables: staticPaginationVariables
        });
    }, [
        onLoadNextProp,
        pageSize,
        staticPaginationVariables,
        view
    ]);
    const onLoadPrevious = (0, $5uXOq.useCallback)(()=>{
        if (view && (0, $4R6GH.fg)('add_nin_press_interactions')) (0, $eTXmK.default)(`${$0de0172be9dbd684$var$INFINITE_SCROLL_INTERACTION_NAME}.${view}`);
        onLoadPreviousProp(pageSize, {
            UNSTABLE_extraVariables: staticPaginationVariables
        });
    }, [
        onLoadPreviousProp,
        pageSize,
        staticPaginationVariables,
        view
    ]);
    const infiniteScrollProps = (0, $5uXOq.useMemo)(()=>({
            onLoadNext: onLoadNext,
            onLoadPrevious: onLoadPrevious,
            activationThreshold: threshold,
            ...rest
        }), [
        onLoadNext,
        onLoadPrevious,
        threshold,
        rest
    ]);
    return infiniteScrollProps;
}

});

parcelRegister("5lE9L", function(module, exports) {

$parcel$export(module.exports, "default", () => $752b8206000afac8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $752b8206000afac8$var$messages = (0, $7VHMR.defineMessages)({
    returnText: {
        "id": "issue-navigator.full-page-issue-app.return-text",
        "defaultMessage": "Return to search"
    }
});
var $752b8206000afac8$export$2e2bcd8739ae039 = $752b8206000afac8$var$messages;

});


parcelRegister("hWyif", function(module, exports) {

$parcel$export(module.exports, "default", () => $eef80bc13fe78613$export$2e2bcd8739ae039);

var $gfaCM = parcelRequire("gfaCM");

var $8Oh73 = parcelRequire("8Oh73");

var $9bW4Y = parcelRequire("9bW4Y");

var $exNQa = parcelRequire("exNQa");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $gcl1l = parcelRequire("gcl1l");

var $hP2me = parcelRequire("hP2me");

var $imS60 = parcelRequire("imS60");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $iofGi = parcelRequire("iofGi");

var $48rMm = parcelRequire("48rMm");

var $7OUvL = parcelRequire("7OUvL");

var $6UAdF = parcelRequire("6UAdF");

var $jjbNu = parcelRequire("jjbNu");

var $1igGa = parcelRequire("1igGa");

var $ih9zY = parcelRequire("ih9zY");

var $gwtSG = parcelRequire("gwtSG");

var $cKK2E = parcelRequire("cKK2E");

var $38r5c = parcelRequire("38r5c");
const $eef80bc13fe78613$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $eef80bc13fe78613$var$Header = ({ CustomHeader: CustomHeader, filter: filter, issueResults: issueResults, HeaderSkeletonImage: HeaderSkeletonImage, jiraViewResult: jiraViewResult, isGroupingSupported: isGroupingSupported, onChangeFilter: onChangeFilter, project: project })=>{
    const issueResultsData = (0, $8Uumt.useFragment)((0, $exNQa.default), issueResults);
    // Compute page data for our search results which is needed when requesting items for the legacy meatball menu
    const offset = (issueResultsData?.issueNavigatorPageInfo?.firstIssuePosition ?? 1) - 1; // offset is 0 based so subtract 1
    const pages = $eef80bc13fe78613$var$getLastPage(issueResultsData?.pageCursors) ?? 0;
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const searchResultPageData = (0, $5uXOq.useMemo)(()=>({
            offset: offset,
            pages: pages,
            total: total
        }), [
        offset,
        pages,
        total
    ]);
    const { filterId: filterId } = (0, $gwtSG.useActiveJql)();
    const jql = (0, $gwtSG.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $cKK2E.useFilterQuery)();
    const filterData = (0, $8Uumt.useFragment)((0, $9bW4Y.default), filter);
    const jiraViewData = (0, $8Uumt.useFragment)((0, $8Oh73.default), jiraViewResult);
    const projectData = (0, $8Uumt.useFragment)((0, $gfaCM.default), project);
    const filterDetails = (0, $5uXOq.useMemo)(()=>filterData ? {
            filterId: filterData.filterId,
            name: filterData.name,
            jql: filterData.jql,
            isFavourite: Boolean(filterData.isFavourite)
        } : undefined, [
        filterData
    ]);
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const jiraViewResultData = jiraViewData;
    let onChangeHierarchy = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    let onChangeGroupedByField = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    let onChangeHideDone = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ onChangeHierarchy: onChangeHierarchy, onChangeGroupedByField: onChangeGroupedByField, onChangeHideDone: onChangeHideDone } = (0, $38r5c.useIssueSearchActions)());
    let hideDone = false;
    if ((0, $4R6GH.fg)('jsc_bulk_edit_hide_done_work_items')) hideDone = jiraViewData?.viewSettings?.hideDone ?? false;
    const HierarchyToggle = jiraViewResultData && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjbNu.HierarchyToggleItem), {
        isGroupingSupported: isGroupingSupported,
        viewResult: jiraViewResultData,
        onChangeHierarchy: onChangeHierarchy
    }) : null;
    let onResetSelectedIssues = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) && (0, $4R6GH.fg)('jsc_list_hide_done_items')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ reset: onResetSelectedIssues } = (0, $48rMm.useIssueTableSelectedIssuesActions)());
    const HideDoneToggle = jiraViewResultData && view !== 'detail' && (0, $4R6GH.fg)('jsc_list_hide_done_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iofGi.HideDoneItemsToggle), {
        viewResult: jiraViewResultData,
        onChangeHideDone: onChangeHideDone,
        onResetSelectedIssues: onResetSelectedIssues,
        project: projectData ?? null
    }) : null;
    const GroupByDropdown = isGroupingSupported && jiraViewData && (0, $6UAdF.isJiraSpreadsheetView)(jiraViewData) && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hP2me.GroupByDropdown), {
        onChangeGroupedByField: onChangeGroupedByField,
        spreadsheetView: jiraViewData
    }) : null;
    const saveResetViewSettingsButton = jiraViewResultData && (0, $6s1PB.expVal)('saved_list_view', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7OUvL.SaveResetViewSettingsButton), {
        viewFragment: jiraViewResultData
    });
    if (filterQueryIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderSkeletonImage, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomHeader, {
        jql: jql,
        filterId: filterId,
        filterDetails: filterDetails,
        searchResultPageData: searchResultPageData,
        HierarchyToggle: HierarchyToggle,
        GroupByDropdown: GroupByDropdown,
        HideDoneToggle: HideDoneToggle,
        SaveResetViewSettingsButton: saveResetViewSettingsButton,
        isHideDoneWorkItemsEnabled: hideDone,
        onChangeFilter: onChangeFilter
    }));
};
var $eef80bc13fe78613$export$2e2bcd8739ae039 = (0, $1igGa.withReportErrors)($eef80bc13fe78613$var$Header, {
    id: 'ui.header.unhandled',
    packageName: (0, $6UAdF.PACKAGE_NAME),
    teamName: (0, $6UAdF.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $gcl1l.isLoaderErrorAttributes)
});

});
parcelRegister("gfaCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $112d62497857acc9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<601963b15692064ea998e87ce3942734>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $112d62497857acc9$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Header_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle_project"
        }
    ],
    "type": "JiraProject"
};
$112d62497857acc9$var$node.hash = "3f3051226cf8fdc0cad41f59ebef9557";
var $112d62497857acc9$export$2e2bcd8739ae039 = $112d62497857acc9$var$node;

});

parcelRegister("8Oh73", function(module, exports) {

$parcel$export(module.exports, "default", () => $143f1a157427940a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f35d2ab7219eb16c241a39f35fefd1a8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $143f1a157427940a$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_Header_jiraViewResult",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueTableGroupByDropdown_GroupByDropdown"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult"
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SaveResetViewSettingsButton"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$143f1a157427940a$var$node.hash = "2b7d1425e1d7de83cd64354c45d0c34d";
var $143f1a157427940a$export$2e2bcd8739ae039 = $143f1a157427940a$var$node;

});

parcelRegister("9bW4Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $28f411246a53b131$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a59decce3d17ede33536b0b36f9eb2f1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $28f411246a53b131$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Header_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$28f411246a53b131$var$node.hash = "49ae72938f954e62114776575c662bd8";
var $28f411246a53b131$export$2e2bcd8739ae039 = $28f411246a53b131$var$node;

});

parcelRegister("exNQa", function(module, exports) {

$parcel$export(module.exports, "default", () => $049e4d6502bf1381$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<904e0d39da2e4e2100f94fcd59ddca44>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $049e4d6502bf1381$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "main_issueNavigator_Header_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$049e4d6502bf1381$var$node.hash = "a6845643ea9e8dc218ebb8df7988c3f7";
var $049e4d6502bf1381$export$2e2bcd8739ae039 = $049e4d6502bf1381$var$node;

});

parcelRegister("hP2me", function(module, exports) {

$parcel$export(module.exports, "GroupByDropdown", () => $d0d4705b9d2a197a$export$84685e583ac84574);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");


var $8Xv4x = parcelRequire("8Xv4x");
const $d0d4705b9d2a197a$export$84685e583ac84574 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-table-group-by-dropdown",
        packageName: (0, $c2be5dcb54fbd60e$export$b8b9d90f9e5bd72b),
        teamName: (0, $c2be5dcb54fbd60e$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Xv4x.GroupByDropdown), props)));

});
const $c2be5dcb54fbd60e$export$b8b9d90f9e5bd72b = 'jiraIssueTableGroupByDropdown';
const $c2be5dcb54fbd60e$export$d57b6b390e78d90f = 'jira-yurree';
const $c2be5dcb54fbd60e$export$5979c086684d2404 = 'loadGroupByOptions';
const $c2be5dcb54fbd60e$export$f7109619a5e9e0d6 = 'jira-native-issue-table';
const $c2be5dcb54fbd60e$export$4808ef77f47c3615 = 'issue-navigator-group-by-dropdown';
const $c2be5dcb54fbd60e$export$64d8bb86ca32b86 = 'changeGroupByField';

parcelRegister("8Xv4x", function(module, exports) {

$parcel$export(module.exports, "GroupByDropdown", () => $d136c8320b72cc56$export$84685e583ac84574);

var $jL3wY = parcelRequire("jL3wY");

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $jZ4fr = parcelRequire("jZ4fr");

var $8Uumt = parcelRequire("8Uumt");

var $bWn3s = parcelRequire("bWn3s");

var $kEVMo = parcelRequire("kEVMo");

var $eCeGD = parcelRequire("eCeGD");

var $BLPHT = parcelRequire("BLPHT");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $99gkn = parcelRequire("99gkn");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $epiY4 = parcelRequire("epiY4");

var $jcw0u = parcelRequire("jcw0u");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $8CVvd = parcelRequire("8CVvd");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");


var $aXE7i = parcelRequire("aXE7i");

var $i0YL5 = parcelRequire("i0YL5");

var $n6eOA = parcelRequire("n6eOA");

var $jvyZ4 = parcelRequire("jvyZ4");
const $d136c8320b72cc56$var$GroupByTriggerIconAfter = ()=>{
    if ((0, $8CVvd.getWillShowNav3)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $d136c8320b72cc56$var$iconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
        label: "",
        size: "small"
    }));
    return null;
};
const $d136c8320b72cc56$export$84685e583ac84574 = ({ spreadsheetView: spreadsheetView, onChangeGroupedByField: onChangeGroupedByField })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $c2be5dcb54fbd60e$export$5979c086684d2404),
        analyticsSource: (0, $c2be5dcb54fbd60e$export$f7109619a5e9e0d6)
    });
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $c2be5dcb54fbd60e$export$5979c086684d2404)
    });
    (0, $5uXOq.useEffect)(()=>{
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    const data = (0, $8Uumt.useFragment)((0, $jL3wY.default), spreadsheetView);
    const groupByFieldFromQuery = (0, $5uXOq.useMemo)(()=>data?.viewSettings?.groupByConfig?.groupByField ? {
            fieldId: data.viewSettings.groupByConfig.groupByField.fieldId,
            name: data.viewSettings.groupByConfig.groupByField.name
        } : null, [
        data?.viewSettings?.groupByConfig?.groupByField
    ]);
    const prevGroupByFieldFromQuery = (0, $5uXOq.useRef)(groupByFieldFromQuery);
    const [groupByField, setGroupByField] = (0, $5uXOq.useState)(groupByFieldFromQuery);
    // If group by field changes in the query response, update local state to keep it in sync
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(groupByFieldFromQuery, prevGroupByFieldFromQuery.current)) {
        prevGroupByFieldFromQuery.current = groupByFieldFromQuery;
        setGroupByField(groupByFieldFromQuery);
    }
    const onUpdateGroupByField = (0, $5uXOq.useCallback)((newGroupByField)=>{
        if (groupByField?.fieldId !== newGroupByField?.fieldId) {
            setGroupByField(newGroupByField ?? null);
            onChangeGroupedByField(newGroupByField?.fieldId);
        }
    }, [
        groupByField,
        onChangeGroupedByField
    ]);
    const issueSearchInput = data?.filterId && {
        filterId: data.filterId
    } || data?.jql && {
        jql: data.jql
    } || undefined;
    const groupByFieldId = groupByField?.fieldId;
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $i0YL5.groupByDropdownEntryPoint), {
        nodeId: data.id,
        selectedFieldId: groupByFieldId,
        issueSearchInput: issueSearchInput
    });
    const buttonTrigger = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    (0, $99gkn.addUFOCustomData)({
        groupByFieldId: data?.viewSettings?.groupByConfig?.groupByField?.typeKey,
        isGrouping: data?.viewSettings?.isGroupingEnabled
    });
    const errorFallback = (0, $5uXOq.useCallback)(({ error: error })=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'issue-table-group-by-dropdown',
                packageName: (0, $c2be5dcb54fbd60e$export$b8b9d90f9e5bd72b),
                teamName: (0, $c2be5dcb54fbd60e$export$d57b6b390e78d90f)
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        onExperienceFail((0, $c2be5dcb54fbd60e$export$b8b9d90f9e5bd72b), error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $d136c8320b72cc56$var$errorFallbackStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $jvyZ4.default).entrypointErrorContent)));
    }, [
        formatMessage,
        onExperienceFail
    ]);
    if (!data?.viewSettings?.canEnableGrouping) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, onClick: onClick, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                ...triggerProps,
                ref: triggerRef,
                iconAfter: $d136c8320b72cc56$var$GroupByTriggerIconAfter,
                onClick: (event, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'issueTableGroupByDropdownDisabledTrigger');
                    onClick && onClick(event);
                }
            }, formatMessage((0, $jvyZ4.default).groupByLabelWithoutSelection)),
        placement: "bottom-end",
        shouldRenderToParent: true,
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d136c8320b72cc56$var$cantGroupIssuesStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $jvyZ4.default).cantGroupIssuesContentIssueTermRefresh : (0, $jvyZ4.default).cantGroupIssuesContent))));
    if ((0, $6s1PB.expValEquals)('jira_list_group_by_all_fields', 'isEnabled', true, false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epiY4.PopupTrigger), {
        entryPoint: (0, $n6eOA.groupByDropdownWithSearchEntryPoint),
        entryPointParams: {
            nodeId: data.id
        },
        entryPointProps: {
            selectedFieldId: groupByFieldId,
            onUpdateGroupByField: onUpdateGroupByField
        },
        shouldRenderToParent: true,
        placement: "bottom-end",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aXE7i.LoadingContent), null),
        errorFallback: errorFallback,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                ...triggerProps,
                isSelected: Boolean(groupByField) || triggerProps['aria-expanded'],
                testId: "issue-table-group-by-dropdown.ui.group-by-dropdown",
                iconAfter: $d136c8320b72cc56$var$GroupByTriggerIconAfter,
                onClick: (_, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'issueTableGroupByDropdownTrigger');
                }
            }, groupByField?.name ? formatMessage((0, $jvyZ4.default).groupByLabelWithASelection, {
                groupByField: groupByField.name
            }) : formatMessage((0, $jvyZ4.default).groupByLabelWithoutSelection))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $c2be5dcb54fbd60e$export$4808ef77f47c3615)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, onClick: onClick, isSelected: isSelected, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                ...triggerProps,
                isSelected: Boolean(groupByField) || isSelected,
                testId: "issue-table-group-by-dropdown.ui.group-by-dropdown",
                ref: (0, $bWn3s.mergeRefs)([
                    triggerRef,
                    buttonTrigger
                ]),
                iconAfter: $d136c8320b72cc56$var$GroupByTriggerIconAfter,
                onClick: (event, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'issueTableGroupByDropdownTrigger');
                    onClick && onClick(event);
                }
            }, groupByField?.name ? formatMessage((0, $jvyZ4.default).groupByLabelWithASelection, {
                groupByField: groupByField.name
            }) : formatMessage((0, $jvyZ4.default).groupByLabelWithoutSelection)),
        placement: "bottom-end",
        shouldRenderToParent: true,
        spacing: "compact"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "async-jira-spreadsheet-group-by-dropdown",
        packageName: (0, $c2be5dcb54fbd60e$export$b8b9d90f9e5bd72b),
        teamName: (0, $c2be5dcb54fbd60e$export$d57b6b390e78d90f),
        errorFallback: errorFallback,
        runtimeProps: {
            onUpdateGroupByField: onUpdateGroupByField
        },
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aXE7i.LoadingContent), null)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: (0, $c2be5dcb54fbd60e$export$4808ef77f47c3615)
    }));
};
const $d136c8320b72cc56$var$cantGroupIssuesStyles = (0, $8CUq3.xcss)({
    marginInline: 'space.300',
    marginBlock: 'space.200',
    width: '250px',
    whiteSpace: 'initial'
});
const $d136c8320b72cc56$var$errorFallbackStyles = (0, $8CUq3.xcss)({
    padding: 'space.200',
    width: '250px'
});
const $d136c8320b72cc56$var$iconStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.negative.075'
});

});
parcelRegister("jL3wY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2194e6ac7335f4ec$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5eec9cb87961d4f938c8648d180bee8c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2194e6ac7335f4ec$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "ui_issueTableGroupByDropdown_GroupByDropdown",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        },
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "groupBy",
                    "variableName": "groupBy"
                },
                {
                    "kind": "Variable",
                    "name": "issueSearchInput",
                    "variableName": "issueSearchInput"
                },
                {
                    "kind": "Variable",
                    "name": "staticViewInput",
                    "variableName": "staticViewInput"
                }
            ],
            "concreteType": "JiraIssueSearchViewConfigSettings",
            "kind": "LinkedField",
            "name": "viewSettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "canEnableGrouping"
                },
                {
                    "kind": "ScalarField",
                    "name": "isGroupingEnabled"
                },
                {
                    "concreteType": "JiraSpreadsheetGroupByConfig",
                    "kind": "LinkedField",
                    "name": "groupByConfig",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraField",
                            "kind": "LinkedField",
                            "name": "groupByField",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldId"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "typeKey"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetView",
    "abstractKey": "__isJiraSpreadsheetView"
};
$2194e6ac7335f4ec$var$node.hash = "fb74039ef112118517cb2d8c0aacd6b0";
var $2194e6ac7335f4ec$export$2e2bcd8739ae039 = $2194e6ac7335f4ec$var$node;

});

parcelRegister("aXE7i", function(module, exports) {

$parcel$export(module.exports, "LoadingContent", () => $fe908327699611a2$export$4ab3512e4872e6ff);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");
const $fe908327699611a2$export$4ab3512e4872e6ff = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $fe908327699611a2$var$loadingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));
const $fe908327699611a2$var$loadingStyles = (0, $8CUq3.xcss)({
    width: '250px',
    paddingBlock: 'space.500'
});

});

parcelRegister("i0YL5", function(module, exports) {

$parcel$export(module.exports, "groupByDropdownEntryPoint", () => $3d764d6f218c7490$export$427ad501ef456b18);

var $fnLZy = parcelRequire("fnLZy");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $3d764d6f218c7490$export$427ad501ef456b18 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("lYg2J")), {
        moduleId: "9655b1ba",
        priority: "interaction"
    }),
    getPreloadProps: ({ nodeId: nodeId, selectedFieldId: selectedFieldId, issueSearchInput: issueSearchInput })=>({
            queries: {
                groupByDropdownQuery: {
                    parameters: (0, $fnLZy.default),
                    variables: {
                        nodeId: nodeId,
                        issueSearchInput: issueSearchInput
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            },
            extraProps: {
                selectedFieldId: selectedFieldId
            }
        })
});

});
parcelRegister("fnLZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $321c892c08f9b689$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4920aba0fdff5f250bb259e2a4bd33f1>>
 * @relayHash b606c8503ba13103558346bec184b2f7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 96ec47cc2b1ac76ade56418d9c4750d062d5fb519c0b910427f4eebfda415c10
const $321c892c08f9b689$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "issueSearchInput"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "nodeId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "nodeId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 10
        },
        {
            "kind": "Variable",
            "name": "issueSearchInput",
            "variableName": "issueSearchInput"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "typeKey"
    }, v9 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v10 = [
        {
            "kind": "RequiredField",
            "field": v4 /*: any*/ ,
            "action": "THROW",
            "path": "node.id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "concreteType": "JiraIssueSearchViewConfigSettings",
                "kind": "LinkedField",
                "name": "viewSettings",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "args": v5 /*: any*/ ,
                                        "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                                        "kind": "LinkedField",
                                        "name": "availableGroupByFieldOptions",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "JiraField",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v6 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v7 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node.fieldId"
                                                                },
                                                                v8 /*: any*/ ,
                                                                v9 /*: any*/ 
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions.edges.node"
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    "action": "THROW",
                                    "path": "node.viewSettings.groupByConfig.availableGroupByFieldOptions"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "node.viewSettings.groupByConfig"
                    }
                ]
            },
            "action": "THROW",
            "path": "node.viewSettings"
        }
    ], v11 = [
        {
            "concreteType": "JiraIssueSearchViewConfigSettings",
            "kind": "LinkedField",
            "name": "viewSettings",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraSpreadsheetGroupByConfig",
                    "kind": "LinkedField",
                    "name": "groupByConfig",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                            "kind": "LinkedField",
                            "name": "availableGroupByFieldOptions",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraField",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v9 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainGroupByDropdownContentQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v10 /*: any*/ ,
                            "type": "JiraGroupedListView"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v10 /*: any*/ ,
                            "type": "JiraListView"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainGroupByDropdownContentQuery",
            "selections": [
                {
                    "args": v2 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v11 /*: any*/ ,
                            "type": "JiraGroupedListView"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v11 /*: any*/ ,
                            "type": "JiraListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "96ec47cc2b1ac76ade56418d9c4750d062d5fb519c0b910427f4eebfda415c10",
            "metadata": {},
            "name": "mainGroupByDropdownContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$321c892c08f9b689$var$node.hash = "e11ca8bdcf47f14e64eabfb3a93eadb5";
var $321c892c08f9b689$export$2e2bcd8739ae039 = $321c892c08f9b689$var$node;

});

parcelRegister("lYg2J", function(module, exports) {

let $ffeba55d7dfbb33d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ffeba55d7dfbb33d$var$load("7EVOa").then(()=>parcelRequire('aDBI2'));

});


parcelRegister("n6eOA", function(module, exports) {

$parcel$export(module.exports, "groupByDropdownWithSearchEntryPoint", () => $c0e2ce884ce5767f$export$413fb55bbc4cc5ba);

var $aTupI = parcelRequire("aTupI");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $c0e2ce884ce5767f$export$413fb55bbc4cc5ba = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aIrY8")), {
        moduleId: "f78c7a64",
        priority: "interaction"
    }),
    getPreloadProps: ({ nodeId: nodeId })=>({
            queries: {
                groupByDropdownQuery: {
                    parameters: (0, $aTupI.default),
                    variables: {
                        nodeId: nodeId
                    },
                    options: {
                        fetchPolicy: 'store-or-network'
                    }
                }
            }
        })
});

});
parcelRegister("aTupI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0531d623ec8d7c2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<99a3f1a2e4b27cb7b867c6baf435b3c7>>
 * @relayHash 4c46b451e29ffee9860122b321a5f072
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46f44d1f66005349121c3d4be1d430a79ad00fe0a1c8188b4b14ca62df8fabf4
const $b0531d623ec8d7c2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "nodeId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "nodeId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = [
        {
            "kind": "FragmentSpread",
            "name": "main_issueTableGroupByDropdown_GroupByDropdownWithSearch"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = [
        {
            "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraField",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fieldId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "typeKey"
                        },
                        v4 /*: any*/ ,
                        {
                            "kind": "ClientExtension",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ], v6 = [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 10
                                        }
                                    ],
                                    "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "availableGroupByFieldOptions",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "availableGroupByFieldOptions(first:10)"
                                },
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 5
                                        }
                                    ],
                                    "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "recentlyUsed",
                                    "plural": false,
                                    "selections": v5 /*: any*/ ,
                                    "storageKey": "recentlyUsed(first:5)"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainGroupByDropdownWithSearchQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v3 /*: any*/ ,
                            "type": "JiraGroupedListView"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v3 /*: any*/ ,
                            "type": "JiraListView"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainGroupByDropdownWithSearchQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v4 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": v6 /*: any*/ ,
                            "type": "JiraGroupedListView"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": v6 /*: any*/ ,
                            "type": "JiraListView"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "46f44d1f66005349121c3d4be1d430a79ad00fe0a1c8188b4b14ca62df8fabf4",
            "metadata": {},
            "name": "mainGroupByDropdownWithSearchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b0531d623ec8d7c2$var$node.hash = "72bd98d33da4fadab310edafdc71d815";
var $b0531d623ec8d7c2$export$2e2bcd8739ae039 = $b0531d623ec8d7c2$var$node;

});

parcelRegister("aIrY8", function(module, exports) {

let $7cd3b57d1dd561fc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7cd3b57d1dd561fc$var$load("aGlLO").then(()=>parcelRequire('7bIgN'));

});


parcelRegister("jvyZ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b05ad221a39d9d95$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b05ad221a39d9d95$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    groupByLabelWithoutSelection: {
        "id": "issue-table-group-by-dropdown.group-by-label-without-selection",
        "defaultMessage": "Group"
    },
    groupByLabelWithASelection: {
        "id": "issue-table-group-by-dropdown.group-by-label-with-a-selection",
        "defaultMessage": "Group: {groupByField}"
    },
    cantGroupIssuesContent: {
        "id": "issue-table-group-by-dropdown.cant-group-issues-content",
        "defaultMessage": "We can only group issues when you filter issues from one project. Update your JQL filter and try again."
    },
    cantGroupIssuesContentIssueTermRefresh: {
        "id": "issue-table-group-by-dropdown.cant-group-issues-content-issue-term-refresh",
        "defaultMessage": "We can only group work items when you filter work items from one project. Update your JQL filter and try again."
    },
    entrypointErrorContent: {
        "id": "issue-table-group-by-dropdown.entrypoint-error-content",
        "defaultMessage": "Something went wrong. Try loading the content again."
    }
});

});



parcelRegister("iofGi", function(module, exports) {

$parcel$export(module.exports, "HideDoneItemsToggle", () => $5e76b62c74772851$export$b7b414a8403ed1a2);

var $5Xchj = parcelRequire("5Xchj");

var $fztU0 = parcelRequire("fztU0");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");

var $gqrUg = parcelRequire("gqrUg");

const $5e76b62c74772851$export$b7b414a8403ed1a2 = (props)=>{
    const viewResultData = (0, $8Uumt.useFragment)((0, $fztU0.default), props.viewResult);
    const projectData = (0, $8Uumt.useFragment)((0, $5Xchj.default), props.project);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-table-hide-done-toggle",
        packageName: (0, $60ea362de9a3f71f$export$b8b9d90f9e5bd72b),
        teamName: (0, $60ea362de9a3f71f$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gqrUg.HideDoneItemsToggle), {
        viewResult: viewResultData,
        onChangeHideDone: props.onChangeHideDone,
        onResetSelectedIssues: props.onResetSelectedIssues,
        project: projectData ?? null
    }));
};

});
parcelRegister("5Xchj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d69cbcd2017a588$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<44be54521ecf7a8ed52673e2660d20aa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5d69cbcd2017a588$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_issueTableHideDoneToggle_HideDoneItemsToggle_project"
        }
    ],
    "type": "JiraProject"
};
$5d69cbcd2017a588$var$node.hash = "986313360c57f0d08dd42d2ba59a9699";
var $5d69cbcd2017a588$export$2e2bcd8739ae039 = $5d69cbcd2017a588$var$node;

});

parcelRegister("fztU0", function(module, exports) {

$parcel$export(module.exports, "default", () => $62f213c10402c830$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cb1e59d33594693ab94cefb6ff89d960>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $62f213c10402c830$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "staticViewInput",
                    "variableName": "staticViewInput"
                }
            ],
            "kind": "FragmentSpread",
            "name": "ui_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$62f213c10402c830$var$node.hash = "726ada747eee2bce73de86cd027eeacc";
var $62f213c10402c830$export$2e2bcd8739ae039 = $62f213c10402c830$var$node;

});

parcelRegister("gqrUg", function(module, exports) {

$parcel$export(module.exports, "HideDoneItemsToggle", () => $5c84dcdbc913b15a$export$b7b414a8403ed1a2);

var $ka9nh = parcelRequire("ka9nh");

var $jx8T5 = parcelRequire("jx8T5");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $dTlW6 = parcelRequire("dTlW6");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5cSAN = parcelRequire("5cSAN");

var $44cHl = parcelRequire("44cHl");

var $gBRsl = parcelRequire("gBRsl");

var $dG0IQ = parcelRequire("dG0IQ");
const $5c84dcdbc913b15a$export$b7b414a8403ed1a2 = ({ viewResult: viewResult, onChangeHideDone: onChangeHideDone, onResetSelectedIssues: onResetSelectedIssues, project: project })=>{
    const viewResultData = (0, $8Uumt.useFragment)((0, $jx8T5.default), viewResult);
    const projectData = (0, $8Uumt.useFragment)((0, $ka9nh.default), project);
    const { viewSettings: viewSettings, id: id, viewId: viewId, __id: issueSearchViewId } = viewResultData;
    const { hideDone: hideDone } = viewSettings ?? {};
    const viewARI = (0, $4R6GH.fg)('saved_list_view_technical_changes') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5cSAN.useViewAri)({
        projectId: projectData?.projectId,
        layout: viewSettings?.isGroupingEnabled ? 'grouped' : 'list'
    }) : '';
    const [hideDoneIsChecked, setHideDoneIsChecked] = (0, $5uXOq.useState)(hideDone);
    const toggleIssueHideDone = (0, $44cHl.useUpdateHideDoneMutation)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onChange = (0, $5uXOq.useCallback)(()=>{
        if (id) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'toggle clicked', 'hideDoneItems', {
                hideDone: !hideDone
            });
            setHideDoneIsChecked(!hideDone);
            // toggle mutation here
            toggleIssueHideDone({
                issueSearchViewResultAri: id,
                isHideDoneEnabled: !hideDone,
                issueSearchViewId: issueSearchViewId,
                onChangeHideDone: onChangeHideDone,
                viewARI: viewARI
            });
            // reset the selected issue for the bulk operations when chaging the toggle
            onResetSelectedIssues && onResetSelectedIssues();
        }
    }, [
        createAnalyticsEvent,
        hideDone,
        id,
        issueSearchViewId,
        onChangeHideDone,
        onResetSelectedIssues,
        toggleIssueHideDone,
        viewARI
    ]);
    const toggleId = `${viewId}_hide_done_toggle`;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: toggleId
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $gBRsl.default).showHideDoneItems : (0, $gBRsl.default).showHideDoneItemsOldTerminology)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        size: "large",
        id: toggleId,
        onChange: onChange,
        isChecked: Boolean(hideDoneIsChecked)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dG0IQ.HideDoneOnboarding), null));
};

});
parcelRegister("ka9nh", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b12ff426c9c5879$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5706632d4fd40698bee305a200c930e2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1b12ff426c9c5879$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "ui_issueTableHideDoneToggle_HideDoneItemsToggle_project",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "projectId"
                }
            ]
        }
    ],
    "type": "JiraProject"
};
$1b12ff426c9c5879$var$node.hash = "c53493c6a77b920bde17eb0cc455b1bc";
var $1b12ff426c9c5879$export$2e2bcd8739ae039 = $1b12ff426c9c5879$var$node;

});

parcelRegister("jx8T5", function(module, exports) {

$parcel$export(module.exports, "default", () => $015bd33b3e26916e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6858f5bb9e5b1cab6dcca29e219bbebc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $015bd33b3e26916e$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "ui_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "viewId"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isGroupingEnabled"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$015bd33b3e26916e$var$node.hash = "c7044ad39d2e3c8927a6b87bb8d6edb8";
var $015bd33b3e26916e$export$2e2bcd8739ae039 = $015bd33b3e26916e$var$node;

});

parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $eJbwP = parcelRequire("eJbwP");

var $2jwCH = parcelRequire("2jwCH");

var $VSDnB = parcelRequire("VSDnB");

var $lahQ6 = parcelRequire("lahQ6");
const $3db77843cf29c460$var$basicStyles = null;
const $3db77843cf29c460$var$borderStyles = null;
const $3db77843cf29c460$var$iconStyles = null;
const $3db77843cf29c460$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $3db77843cf29c460$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eJbwP))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`,
                    size: "small"
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2jwCH))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`,
                    size: "small"
                })
            })
        ]
    });
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("eJbwP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::666ec8073f4584891951ab85e48975eb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab8e35fd94105dfe$var$_react = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ab8e35fd94105dfe$var$_checkMark = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ab8e35fd94105dfe$var$_done = $ab8e35fd94105dfe$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $ab8e35fd94105dfe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab8e35fd94105dfe$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ab8e35fd94105dfe$var$_react.default.createElement($ab8e35fd94105dfe$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ab8e35fd94105dfe$var$_done.default
    }, props));
$ab8e35fd94105dfe$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ab8e35fd94105dfe$var$_default = module.exports.default = $ab8e35fd94105dfe$var$CheckMarkIcon;

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});


parcelRegister("2jwCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e514a79fafb6c57d068e94d2350d1008>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1af6a969f6ce5e7d$var$_react = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1af6a969f6ce5e7d$var$_close = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("i28qQ")));

var $1af6a969f6ce5e7d$var$_close2 = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("2C7j9")));
function $1af6a969f6ce5e7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1af6a969f6ce5e7d$var$CloseIcon = (props)=>/*#__PURE__*/ $1af6a969f6ce5e7d$var$_react.default.createElement($1af6a969f6ce5e7d$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $1af6a969f6ce5e7d$var$_close2.default
    }, props));
$1af6a969f6ce5e7d$var$CloseIcon.Name = 'CloseIconMigration';
var $1af6a969f6ce5e7d$var$_default = module.exports.default = $1af6a969f6ce5e7d$var$CloseIcon;

});
parcelRegister("2C7j9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e74cc92a54dd799$var$_react = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1e74cc92a54dd799$var$_close = $1e74cc92a54dd799$var$_interopRequireDefault((parcelRequire("i28qQ")));
function $1e74cc92a54dd799$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1e74cc92a54dd799$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $1e74cc92a54dd799$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $1e74cc92a54dd799$var$_close.default
    }));
$1e74cc92a54dd799$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $1e74cc92a54dd799$var$_default = module.exports.default = $1e74cc92a54dd799$var$EditorCloseIcon;

});


parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ca1cdaa1eb34599d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: (0, $3JT92.cx)($ca1cdaa1eb34599d$var$styles.iconContainer, isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$styles.hidden, size === 'regular' && $ca1cdaa1eb34599d$var$styles.iconContainerRegular, size === 'large' && $ca1cdaa1eb34599d$var$styles.iconContainerLarge, position === 'left' && $ca1cdaa1eb34599d$var$styles.left, position === 'right' && $ca1cdaa1eb34599d$var$styles.right),
        children: children
    });
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});


parcelRegister("44cHl", function(module, exports) {

$parcel$export(module.exports, "useUpdateHideDoneMutation", () => $bf44987b76c2f50f$export$1d65880c4ddc0209);

var $kPt40 = parcelRequire("kPt40");

var $1FDxu = parcelRequire("1FDxu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eCBf9 = parcelRequire("eCBf9");

var $koVbs = parcelRequire("koVbs");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $kaHBi = parcelRequire("kaHBi");

var $93jKl = parcelRequire("93jKl");

var $3bQtK = parcelRequire("3bQtK");

var $cZpsT = parcelRequire("cZpsT");

var $4R6GH = parcelRequire("4R6GH");


var $edM9a = parcelRequire("edM9a");
const $bf44987b76c2f50f$export$1d65880c4ddc0209 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $60ea362de9a3f71f$export$6a7d6ab86cfdfcdc),
        analyticsSource: (0, $60ea362de9a3f71f$export$f7109619a5e9e0d6)
    });
    const onExperienceFail = (0, $93jKl.useExperienceFail)({
        experience: (0, $60ea362de9a3f71f$export$6a7d6ab86cfdfcdc)
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: (0, $60ea362de9a3f71f$export$6a7d6ab86cfdfcdc)
    });
    const [commitOld] = (0, $8Uumt.useMutation)((0, $1FDxu.default));
    const [commit] = (0, $8Uumt.useMutation)((0, $kPt40.default));
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleError = (0, $5uXOq.useCallback)((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'issue-table-hide-done-toggle',
                packageName: (0, $60ea362de9a3f71f$export$b8b9d90f9e5bd72b),
                teamName: (0, $60ea362de9a3f71f$export$d57b6b390e78d90f)
            },
            error: error
        });
        onExperienceFail((0, $60ea362de9a3f71f$export$b8b9d90f9e5bd72b), error);
        showFlag({
            messageId: 'issue-table-hide-done-toggle.services.update-hide-done-toggle.show-flag.error',
            messageType: 'transactional',
            id: 'hideDoneToggleError',
            title: formatMessage((0, $edM9a.default).hideDoneErrorFlagTitle),
            description: formatMessage((0, $edM9a.default).hideDoneErrorFlagDescription),
            isAutoDismiss: true,
            type: 'error'
        });
    }, [
        formatMessage,
        onExperienceFail,
        showFlag
    ]);
    const storeUpdater = (0, $5uXOq.useCallback)(({ isHideDoneEnabled: isHideDoneEnabled, store: store, issueSearchViewId: issueSearchViewId })=>{
        const issueSearchRecord = store.get(issueSearchViewId);
        if (issueSearchRecord) {
            const viewSettingsRecord = issueSearchRecord.getLinkedRecord('viewSettings');
            if (viewSettingsRecord) viewSettingsRecord.setValue(isHideDoneEnabled, 'hideDone');
        }
    }, []);
    const updateHideDone = (0, $5uXOq.useCallback)(({ issueSearchViewResultAri: issueSearchViewResultAri, issueSearchViewId: issueSearchViewId, isHideDoneEnabled: isHideDoneEnabled, onChangeHideDone: onChangeHideDone, viewARI: viewARI })=>{
        if (isAnonymous) {
            onChangeHideDone(isHideDoneEnabled);
            return;
        }
        onExperienceStart();
        if ((0, $4R6GH.fg)('saved_list_view_technical_changes')) commit({
            variables: {
                input: {
                    viewId: viewARI,
                    hideDoneItems: isHideDoneEnabled
                }
            },
            optimisticUpdater (store) {
                storeUpdater({
                    store: store,
                    isHideDoneEnabled: isHideDoneEnabled,
                    issueSearchViewId: issueSearchViewId
                });
                onChangeHideDone(isHideDoneEnabled);
            },
            updater: (store)=>{
                storeUpdater({
                    store: store,
                    issueSearchViewId: issueSearchViewId,
                    isHideDoneEnabled: isHideDoneEnabled
                });
            },
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira_setIssueSearchHideDoneItems ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $eCBf9.MutationError)(errors[0]);
                    handleError(error);
                    return;
                }
                onExperienceSuccess();
            },
            onError: handleError
        });
        else commitOld({
            variables: {
                viewId: issueSearchViewResultAri,
                isHideDoneEnabled: isHideDoneEnabled
            },
            optimisticUpdater (store) {
                storeUpdater({
                    store: store,
                    isHideDoneEnabled: isHideDoneEnabled,
                    issueSearchViewId: issueSearchViewId
                });
                onChangeHideDone(isHideDoneEnabled);
            },
            updater: (store)=>{
                storeUpdater({
                    store: store,
                    issueSearchViewId: issueSearchViewId,
                    isHideDoneEnabled: isHideDoneEnabled
                });
            },
            onCompleted: (response)=>{
                const { errors: errors } = response?.jira?.updateIssueSearchHideDonePreference ?? {};
                if (errors && errors.length > 0) {
                    const error = new (0, $eCBf9.MutationError)(errors[0]);
                    handleError(error);
                    return;
                }
                onExperienceSuccess();
            },
            onError: handleError
        });
    }, [
        commit,
        commitOld,
        handleError,
        isAnonymous,
        onExperienceStart,
        onExperienceSuccess,
        storeUpdater
    ]);
    return updateHideDone;
};

});
parcelRegister("kPt40", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0afe69c431a00be$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c9897ba313c3296d413bf19d6a5ec07b>>
 * @relayHash 93532fcb5b1563541fbed098abfe8c99
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a5854e1e10a16934acc024877272de440ef430aa73018f0dab1f1b55da42a59f
const $d0afe69c431a00be$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "updateHideDoneToggleMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetIssueSearchHideDoneItemsPayload",
                    "kind": "LinkedField",
                    "name": "jira_setIssueSearchHideDoneItems",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "updateHideDoneToggleMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraSetIssueSearchHideDoneItemsPayload",
                    "kind": "LinkedField",
                    "name": "jira_setIssueSearchHideDoneItems",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a5854e1e10a16934acc024877272de440ef430aa73018f0dab1f1b55da42a59f",
            "metadata": {},
            "name": "updateHideDoneToggleMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d0afe69c431a00be$var$node.hash = "388b8d343d54f6cc52149389b7be18c6";
var $d0afe69c431a00be$export$2e2bcd8739ae039 = $d0afe69c431a00be$var$node;

});

parcelRegister("1FDxu", function(module, exports) {

$parcel$export(module.exports, "default", () => $15b821bff6febda1$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<45fe94ec08e1bee33d0a2768c3cdbd64>>
 * @relayHash 4287cfc47f1fea41c9ebc20fb6e0356c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2a00a5217999d1f6bf48b73e0f9a048209a3ae6d62640010ed30c8e4e28013fe
const $15b821bff6febda1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHideDoneEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "isHideDoneEnabled",
            "variableName": "isHideDoneEnabled"
        },
        {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "success"
    }, v4 = {
        "kind": "ScalarField",
        "name": "message"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "updateHideDoneToggleOldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueSearchHideDonePreferenceMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateIssueSearchHideDonePreference",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "updateHideDoneToggleOldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraIssueSearchHideDonePreferenceMutationPayload",
                            "kind": "LinkedField",
                            "name": "updateIssueSearchHideDonePreference",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "2a00a5217999d1f6bf48b73e0f9a048209a3ae6d62640010ed30c8e4e28013fe",
            "metadata": {},
            "name": "updateHideDoneToggleOldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$15b821bff6febda1$var$node.hash = "30139df1d842375cd25b05794a1cf0e8";
var $15b821bff6febda1$export$2e2bcd8739ae039 = $15b821bff6febda1$var$node;

});

parcelRegister("edM9a", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e43266aa24af7c5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2e43266aa24af7c5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    hideDoneErrorFlagTitle: {
        "id": "issue-table-hide-done-error-flag-title",
        "defaultMessage": "Hide done preference could not be updated."
    },
    hideDoneErrorFlagDescription: {
        "id": "issue-table-hide-done-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again."
    }
});

});


parcelRegister("gBRsl", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea7806784a101795$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ea7806784a101795$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showHideDoneItems: {
        "id": "issue-table-hide-done-items",
        "defaultMessage": "Hide done work items"
    },
    showHideDoneItemsOldTerminology: {
        "id": "issue-table-hide-done-items.old-terminology",
        "defaultMessage": "Hide done"
    }
});

});



parcelRegister("7OUvL", function(module, exports) {

$parcel$export(module.exports, "SaveResetViewSettingsButton", () => $8a3e9cbd4ba892c5$export$2a684f25916e98c1);

var $bdjjT = parcelRequire("bdjjT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $7CMCs = parcelRequire("7CMCs");


var $iomL4 = parcelRequire("iomL4");
const $8a3e9cbd4ba892c5$export$2a684f25916e98c1 = /*#__PURE__*/ (0, $5uXOq.memo)(({ viewFragment: viewFragment })=>{
    const viewMetadata = (0, $8Uumt.useFragment)((0, $bdjjT.default), viewFragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-navigator-save-reset-view-settings-button",
        packageName: (0, $15b9be95f52be82f$export$b8b9d90f9e5bd72b),
        teamName: (0, $15b9be95f52be82f$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iomL4.SaveResetViewSettingsButtonCollapsible), {
        viewFragment: viewMetadata
    }));
});

});
parcelRegister("bdjjT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d81fd0e8298c7f7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3c191f54c00911db1922948d58edb098>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3d81fd0e8298c7f7$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "SaveResetViewSettingsButton",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "staticViewInput",
                    "variableName": "staticViewInput"
                }
            ],
            "kind": "FragmentSpread",
            "name": "SaveResetViewSettingsButtonCollapsible"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$3d81fd0e8298c7f7$var$node.hash = "19ee174b608e439b6b5f27a48074dc27";
var $3d81fd0e8298c7f7$export$2e2bcd8739ae039 = $3d81fd0e8298c7f7$var$node;

});

const $15b9be95f52be82f$export$b8b9d90f9e5bd72b = 'jiraIssueNavigatorSaveResetViewSettingsButton';
const $15b9be95f52be82f$export$d57b6b390e78d90f = 'wanjel';

parcelRegister("iomL4", function(module, exports) {

$parcel$export(module.exports, "SaveResetViewSettingsButtonCollapsible", () => $0d26c2ddca18bd15$export$987a12b060ce1a28);

var $a1asd = parcelRequire("a1asd");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6jE0j = parcelRequire("6jE0j");

var $1AX37 = parcelRequire("1AX37");
const $0d26c2ddca18bd15$export$987a12b060ce1a28 = /*#__PURE__*/ (0, $5uXOq.memo)(({ viewFragment: viewFragment })=>{
    const viewMetadata = (0, $8Uumt.useFragment)((0, $a1asd.default), viewFragment);
    return /*#__PURE__*/ $5uXOq.createElement((0, $6jE0j.Collapsible), {
        animationDuration: 260,
        direction: "horizontal",
        isExpanded: viewMetadata.viewSettings?.isViewConfigModified ?? false
    }, /*#__PURE__*/ $5uXOq.createElement((0, $1AX37.SaveResetViewSettingsButtonUI), {
        viewFragment: viewMetadata
    }));
});

});
parcelRegister("a1asd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea089d624be6fcfe$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<63479d402ca6c733097a2b4ac9f5586f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ea089d624be6fcfe$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "staticViewInput",
        "variableName": "staticViewInput"
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "groupBy"
            },
            {
                "kind": "RootArgument",
                "name": "issueSearchInput"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "staticViewInput"
            }
        ],
        "kind": "Fragment",
        "name": "SaveResetViewSettingsButtonCollapsible",
        "selections": [
            {
                "args": [
                    v0 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "SaveResetViewSettingsButtonUI"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "groupBy",
                                "variableName": "groupBy"
                            },
                            {
                                "kind": "Variable",
                                "name": "issueSearchInput",
                                "variableName": "issueSearchInput"
                            },
                            v0 /*: any*/ 
                        ],
                        "concreteType": "JiraIssueSearchViewConfigSettings",
                        "kind": "LinkedField",
                        "name": "viewSettings",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isViewConfigModified"
                            }
                        ]
                    }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
            }
        ],
        "type": "JiraIssueSearchViewMetadata",
        "abstractKey": "__isJiraIssueSearchViewMetadata"
    };
}();
$ea089d624be6fcfe$var$node.hash = "5781f411e21b1adaf6d76e23a0f20f89";
var $ea089d624be6fcfe$export$2e2bcd8739ae039 = $ea089d624be6fcfe$var$node;

});

parcelRegister("6jE0j", function(module, exports) {

$parcel$export(module.exports, "Collapsible", () => $23992aab491d57ae$export$6eb0f7ddcda6131f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");
const $23992aab491d57ae$var$getSize = (element, direction)=>{
    return direction === 'horizontal' ? element.scrollWidth : element.scrollHeight;
};
const $23992aab491d57ae$var$setCollapsedStyle = (wrapper, direction)=>{
    // set max width to 0 and opacity to 0
    wrapper.style.setProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`, '0px');
    wrapper.style.setProperty('opacity', '0');
    wrapper.style.setProperty('overflow', 'hidden');
};
const $23992aab491d57ae$var$setExpandedStyle = (wrapper, content, direction)=>{
    // set the max size to content size and opacity to 1
    wrapper.style.setProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`, `${$23992aab491d57ae$var$getSize(content, direction)}px`);
    wrapper.style.setProperty('opacity', '1');
};
const $23992aab491d57ae$var$resetStyle = (wrapper, direction, resetOverflow)=>{
    wrapper.style.removeProperty(`max-${direction === 'horizontal' ? 'width' : 'height'}`);
    wrapper.style.removeProperty('opacity');
    if (resetOverflow) wrapper.style.removeProperty('overflow');
};
const $23992aab491d57ae$export$6eb0f7ddcda6131f = ({ animationDuration: animationDuration = 250, children: children, direction: direction = 'vertical', id: id, isExpanded: isExpanded, resetOverflow: resetOverflow = true })=>{
    const didMountRef = (0, $5uXOq.useRef)(false);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const contentRef = (0, $5uXOq.useRef)(null);
    const [isRendered, setIsRendered] = (0, $5uXOq.useState)(isExpanded);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        // add the transition to the wrapper
        wrapperRef.current.style.setProperty('transition', `max-${direction === 'horizontal' ? 'width' : 'height'} ${animationDuration}ms ease-in-out, opacity ${animationDuration}ms ease-in-out`);
        if (!resetOverflow) wrapperRef.current.style.setProperty('overflow', 'hidden');
        if (!isExpanded) $23992aab491d57ae$var$setCollapsedStyle(wrapperRef.current, direction);
    // initial render only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $5uXOq.useEffect)(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        if (isExpanded) {
            if (!isRendered) setIsRendered(true);
            else requestAnimationFrame(()=>{
                if (!wrapperRef.current || !contentRef.current) return;
                $23992aab491d57ae$var$setExpandedStyle(wrapperRef.current, contentRef.current, direction);
                // wait for the animation to finish before removing the overflow
                Promise.all(wrapperRef.current.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                    wrapperRef.current && $23992aab491d57ae$var$resetStyle(wrapperRef.current, direction, resetOverflow);
                });
            });
        } else if (isRendered) {
            if (!wrapperRef.current || !contentRef.current) return;
            $23992aab491d57ae$var$setExpandedStyle(wrapperRef.current, contentRef.current, direction);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    if (!wrapperRef.current) return;
                    $23992aab491d57ae$var$setCollapsedStyle(wrapperRef.current, direction);
                    // wait for the animation to finish before removing the content
                    Promise.all(wrapperRef.current.getAnimations().map((animation)=>animation.finished) ?? []).then(()=>{
                        setIsRendered(false);
                    });
                });
            });
        }
    }, [
        direction,
        isExpanded,
        isRendered,
        resetOverflow
    ]);
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        id: id,
        ref: wrapperRef
    }, isRendered && /*#__PURE__*/ $5uXOq.createElement("div", {
        ref: contentRef
    }, children));
};

});

parcelRegister("1AX37", function(module, exports) {

$parcel$export(module.exports, "SaveResetViewSettingsButtonUI", () => $fb8c688fff60c98a$export$808d70defde8c5d8);

var $k9dco = parcelRequire("k9dco");

var $3rOxR = parcelRequire("3rOxR");

var $3iUeO = parcelRequire("3iUeO");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");

var $1L8xR = parcelRequire("1L8xR");

var $7sLAO = parcelRequire("7sLAO");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $pa9q9 = parcelRequire("pa9q9");

var $cFs09 = parcelRequire("cFs09");
const $fb8c688fff60c98a$var$tooltipProps = {
    position: 'top',
    hideTooltipOnClick: true
};
const $fb8c688fff60c98a$export$808d70defde8c5d8 = /*#__PURE__*/ (0, $5uXOq.memo)(({ viewFragment: viewFragment })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isModalOpen, setModalOpen] = (0, $5uXOq.useState)(false);
    const openModal = (0, $5uXOq.useCallback)(()=>setModalOpen(true), []);
    const closeModal = (0, $5uXOq.useCallback)(()=>setModalOpen(false), []);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const viewMetadata = (0, $8Uumt.useFragment)((0, $3iUeO.default), viewFragment);
    const canPublishViewConfig = viewMetadata.viewSettings?.canPublishViewConfig;
    const [publish, publishing] = (0, $8Uumt.useMutation)((0, $3rOxR.default));
    const [discard, discarding] = (0, $8Uumt.useMutation)((0, $k9dco.default));
    const onClickSave = (0, $5uXOq.useCallback)(()=>{
        closeModal();
        const showFailureFlag = ()=>{
            showFlag({
                messageId: 'issue-navigator-save-reset-view-settings-button.ui.show-flag.error.save-settings-failed',
                messageType: 'transactional',
                title: (0, $cFs09.default).saveSettingsFailedTitle,
                description: (0, $cFs09.default).saveSettingsFailedMessage,
                type: 'error'
            });
        };
        publish({
            variables: {
                input: {
                    viewId: viewMetadata.id
                }
            },
            onError () {
                showFailureFlag();
            },
            onCompleted (response) {
                if (response.jira_publishIssueSearchConfig?.success !== true) {
                    showFailureFlag();
                    return;
                }
                showFlag({
                    messageId: 'issue-navigator-save-reset-view-settings-button.ui.show-flag.success.header.save-reset-view-settings.show-flag.success.save-settings-success',
                    messageType: 'transactional',
                    title: (0, $cFs09.default).saveSettingsSuccessTitle,
                    description: (0, $cFs09.default).saveSettingsSuccessMessage,
                    type: 'success'
                });
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewSettings saved');
            }
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'saveSettings');
    }, [
        closeModal,
        createAnalyticsEvent,
        publish,
        showFlag,
        viewMetadata.id
    ]);
    const onClickReset = (0, $5uXOq.useCallback)(()=>{
        const showFailureFlag = ()=>{
            showFlag({
                messageId: 'issue-navigator-save-reset-view-settings-button.ui.show-flag.error.header.save-reset-view-settings.show-flag.error.reset-settings-failed',
                messageType: 'transactional',
                title: (0, $cFs09.default).resetSettingsFailedTitle,
                description: (0, $cFs09.default).resetSettingsFailedMessage,
                type: 'error'
            });
        };
        discard({
            variables: {
                input: {
                    viewId: viewMetadata.id
                }
            },
            onError () {
                showFailureFlag();
            },
            onCompleted (response) {
                if (response.jira_discardUserIssueSearchConfig?.success !== true) {
                    showFailureFlag();
                    return;
                }
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'viewSettings reset');
            }
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'resetSettings', {
            isProjectAdmin: canPublishViewConfig
        });
    }, [
        canPublishViewConfig,
        createAnalyticsEvent,
        discard,
        showFlag,
        viewMetadata.id
    ]);
    if (!canPublishViewConfig) return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $fb8c688fff60c98a$var$styles.root
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $42CjB.default), {
        onClick: onClickReset,
        isLoading: discarding,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7sLAO))),
        isTooltipDisabled: false,
        label: formatMessage((0, $cFs09.default).resetViewSettingsButton),
        tooltip: $fb8c688fff60c98a$var$tooltipProps
    }));
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $fb8c688fff60c98a$var$styles.root
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $5uXOq.createElement((0, $42CjB.default), {
                ...props,
                isLoading: discarding || publishing,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1L8xR))),
                label: formatMessage((0, $cFs09.default).saveOrResetViewSettingsButton),
                tooltip: $fb8c688fff60c98a$var$tooltipProps,
                ref: triggerRef
            }),
        shouldRenderToParent: false
    }, /*#__PURE__*/ $5uXOq.createElement((0, $aRoVz.default), null, /*#__PURE__*/ $5uXOq.createElement((0, $6B7KL.default), {
        onClick: openModal
    }, formatMessage((0, $cFs09.default).saveViewSettingsMenuItem)), /*#__PURE__*/ $5uXOq.createElement((0, $6B7KL.default), {
        onClick: onClickReset
    }, formatMessage((0, $cFs09.default).resetViewSettingsMenuItem)))), /*#__PURE__*/ $5uXOq.createElement((0, $i8Qvm.default), null, isModalOpen && /*#__PURE__*/ $5uXOq.createElement((0, $1R1Ge.default), {
        onClose: closeModal,
        width: "small"
    }, /*#__PURE__*/ $5uXOq.createElement((0, $jgVsb.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $5uXOq.createElement((0, $gofOI.default), null, formatMessage((0, $cFs09.default).saveConfirmationModalTitle))), /*#__PURE__*/ $5uXOq.createElement((0, $7QSqG.default), null, formatMessage((0, $cFs09.default).saveConfirmationModalBody)), /*#__PURE__*/ $5uXOq.createElement((0, $juxqI.default), null, /*#__PURE__*/ $5uXOq.createElement((0, $eCeGD.default), {
        appearance: "subtle",
        onClick: closeModal
    }, formatMessage((0, $cFs09.default).cancelButton)), /*#__PURE__*/ $5uXOq.createElement((0, $eCeGD.default), {
        appearance: "primary",
        onClick: onClickSave
    }, formatMessage((0, $cFs09.default).saveButton))))));
});
const $fb8c688fff60c98a$var$styles = {
    root: "_1e0c1txw _19bvu2gc _1bsbzwfg"
};

});
parcelRegister("k9dco", function(module, exports) {

$parcel$export(module.exports, "default", () => $36a2202fdb0f117e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<db4c5c6a8151630d7b37391460c640a0>>
 * @relayHash f557abda1cabc17ba836a51cc4ae26b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e050710552e2b21cda2300c81f90dab7cd573d24d30a1ec448daa70b36b5c0b6
const $36a2202fdb0f117e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraDiscardUserIssueSearchConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_discardUserIssueSearchConfig",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraDiscardUserIssueSearchConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_discardUserIssueSearchConfig",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e050710552e2b21cda2300c81f90dab7cd573d24d30a1ec448daa70b36b5c0b6",
            "metadata": {},
            "name": "SaveResetViewSettingsButtonUIDiscardSettingsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$36a2202fdb0f117e$var$node.hash = "f580f77a915c03ac04e06dc773ca51fa";
var $36a2202fdb0f117e$export$2e2bcd8739ae039 = $36a2202fdb0f117e$var$node;

});

parcelRegister("3rOxR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5efe02d63838b4c9$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<0c6fca161998fc832788a9e998414546>>
 * @relayHash b23890515d870d7794052b00109357a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8441efc3d6affe7e57eb88458bc5bd24a244282175c873a79b1b56217aeec22b
const $5efe02d63838b4c9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v5 = {
        "kind": "ScalarField",
        "name": "statusCode"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraPublishIssueSearchConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_publishIssueSearchConfig",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ 
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "JiraPublishIssueSearchConfigPayload",
                    "kind": "LinkedField",
                    "name": "jira_publishIssueSearchConfig",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "MutationError",
                            "kind": "LinkedField",
                            "name": "errors",
                            "plural": true,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "extensions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ],
                                            "type": "BulkMutationErrorExtension"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "8441efc3d6affe7e57eb88458bc5bd24a244282175c873a79b1b56217aeec22b",
            "metadata": {},
            "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$5efe02d63838b4c9$var$node.hash = "bfef07a629bc5ee9a43033513612e22f";
var $5efe02d63838b4c9$export$2e2bcd8739ae039 = $5efe02d63838b4c9$var$node;

});

parcelRegister("3iUeO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d84741c991d852f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6d90a1cef12b89e1c0c3c8342120f12b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9d84741c991d852f$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "SaveResetViewSettingsButtonUI",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canPublishViewConfig"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$9d84741c991d852f$var$node.hash = "a0c148b1d38cfb4a1325a7597a2f1928";
var $9d84741c991d852f$export$2e2bcd8739ae039 = $9d84741c991d852f$var$node;

});

parcelRegister("1L8xR", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d64019569838190420a4f4f1d7102ef7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1480cf1bcddc807a$var$_react = $1480cf1bcddc807a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1480cf1bcddc807a$var$_baseNew = $1480cf1bcddc807a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $1480cf1bcddc807a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1480cf1bcddc807a$var$SyncIcon = (props)=>/*#__PURE__*/ $1480cf1bcddc807a$var$_react.default.createElement($1480cf1bcddc807a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$1480cf1bcddc807a$var$SyncIcon.displayName = 'SyncIcon';
var $1480cf1bcddc807a$var$_default = module.exports.default = $1480cf1bcddc807a$var$SyncIcon;

});

parcelRegister("7sLAO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2edf8e8e6d811ed80e747695771356e6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56f010d97236ea23$var$_react = $56f010d97236ea23$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $56f010d97236ea23$var$_baseNew = $56f010d97236ea23$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $56f010d97236ea23$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Undo".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for undo in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56f010d97236ea23$var$UndoIcon = (props)=>/*#__PURE__*/ $56f010d97236ea23$var$_react.default.createElement($56f010d97236ea23$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 4.72 3.5-3.5 1.06 1.06L3.56 4.5h6.69a4.75 4.75 0 1 1 0 9.5H8v-1.5h2.25a3.25 3.25 0 0 0 0-6.5H3.56l2.22 2.22-1.06 1.06-3.5-3.5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$56f010d97236ea23$var$UndoIcon.displayName = 'UndoIcon';
var $56f010d97236ea23$var$_default = module.exports.default = $56f010d97236ea23$var$UndoIcon;

});

parcelRegister("cFs09", function(module, exports) {

$parcel$export(module.exports, "default", () => $41038f8e5015582b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $41038f8e5015582b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    resetViewSettingsButton: {
        "id": "issue-navigator-save-reset-view-settings-button.reset-view-settings-button",
        "defaultMessage": "Reset view back to default"
    },
    saveOrResetViewSettingsButton: {
        "id": "issue-navigator-save-reset-view-settings-button.save-or-reset-view-settings-button",
        "defaultMessage": "Save or reset view settings"
    },
    saveViewSettingsMenuItem: {
        "id": "issue-navigator-save-reset-view-settings-button.save-view-settings-menu-item",
        "defaultMessage": "Save view"
    },
    resetViewSettingsMenuItem: {
        "id": "issue-navigator-save-reset-view-settings-button.reset-view-settings-menu-item",
        "defaultMessage": "Reset to last saved"
    },
    saveSettingsSuccessTitle: {
        "id": "issue-navigator-save-reset-view-settings-button.save-settings-success-title",
        "defaultMessage": "View saved"
    },
    saveSettingsSuccessMessage: {
        "id": "issue-navigator-save-reset-view-settings-button.save-settings-success-message",
        "defaultMessage": "This view has been updated for everyone in this project."
    },
    saveSettingsFailedTitle: {
        "id": "issue-navigator-save-reset-view-settings-button.save-settings-failed-title",
        "defaultMessage": "Unable to save your settings"
    },
    saveSettingsFailedMessage: {
        "id": "issue-navigator-save-reset-view-settings-button.save-settings-failed-message",
        "defaultMessage": "We couldn't save your settings, try refreshing the page or try again later."
    },
    resetSettingsFailedTitle: {
        "id": "issue-navigator-save-reset-view-settings-button.reset-settings-failed-title",
        "defaultMessage": "Unable to reset your settings"
    },
    resetSettingsFailedMessage: {
        "id": "issue-navigator-save-reset-view-settings-button.reset-settings-failed-message",
        "defaultMessage": "We couldn't reset your settings, try refreshing the page or try again later."
    },
    saveConfirmationModalTitle: {
        "id": "issue-navigator-save-reset-view-settings-button.save-confirmation-modal-title",
        "defaultMessage": "Save view"
    },
    saveConfirmationModalBody: {
        "id": "issue-navigator-save-reset-view-settings-button.save-confirmation-modal-body",
        "defaultMessage": "The view will be saved for everyone in the project. They'll see the applied filters, grouping, fields, and columns."
    },
    saveButton: {
        "id": "issue-navigator-save-reset-view-settings-button.save-button",
        "defaultMessage": "Save"
    },
    cancelButton: {
        "id": "issue-navigator-save-reset-view-settings-button.cancel-button",
        "defaultMessage": "Cancel"
    }
});

});




parcelRegister("jjbNu", function(module, exports) {

$parcel$export(module.exports, "HierarchyToggleItem", () => $e1e12482daecc3c5$export$357080ffd90225cc);

var $clHlv = parcelRequire("clHlv");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $lx26o = parcelRequire("lx26o");

var $f7PHy = parcelRequire("f7PHy");
const $e1e12482daecc3c5$export$357080ffd90225cc = ({ viewResult: viewResult, isGroupingSupported: isGroupingSupported, onChangeHierarchy: onChangeHierarchy })=>{
    const viewResultData = (0, $8Uumt.useFragment)((0, $clHlv.default), viewResult);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "hierarchy-feature-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lx26o.HierarchyToggle), {
        isGroupingSupported: isGroupingSupported,
        viewResult: viewResultData,
        onChangeHierarchy: onChangeHierarchy
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f7PHy.HierarchyToggleOnboarding), null));
};

});
parcelRegister("clHlv", function(module, exports) {

$parcel$export(module.exports, "default", () => $12a7ed8434d3053c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b0f81e67c50a7e9d44fd5052fba5f4fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $12a7ed8434d3053c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "ui_issueTableHierarchyToggle_HierarchyToggle"
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$12a7ed8434d3053c$var$node.hash = "e0155f59c7e10da0ab42123f84422439";
var $12a7ed8434d3053c$export$2e2bcd8739ae039 = $12a7ed8434d3053c$var$node;

});

parcelRegister("lx26o", function(module, exports) {

$parcel$export(module.exports, "HierarchyToggle", () => $018b012745a5c896$export$3954d500c5aed66);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");


var $4hYz1 = parcelRequire("4hYz1");
const $018b012745a5c896$export$3954d500c5aed66 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        fallback: "unmount",
        id: "issue-table-hierarchy-toggle",
        packageName: (0, $bb4c54ee542a60ec$export$b8b9d90f9e5bd72b),
        teamName: (0, $bb4c54ee542a60ec$export$d57b6b390e78d90f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hYz1.HierarchyToggle), props)));

});
const $bb4c54ee542a60ec$export$b8b9d90f9e5bd72b = 'jiraIssueTableHierarchyToggle';
const $bb4c54ee542a60ec$export$d57b6b390e78d90f = 'empanada';

parcelRegister("4hYz1", function(module, exports) {

$parcel$export(module.exports, "HierarchyToggle", () => $2ecf2b723bc56fca$export$3954d500c5aed66);

var $BSGGQ = parcelRequire("BSGGQ");

var $il1iJ = parcelRequire("il1iJ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $dTlW6 = parcelRequire("dTlW6");

var $jcw0u = parcelRequire("jcw0u");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cZpsT = parcelRequire("cZpsT");


var $5Lp4g = parcelRequire("5Lp4g");
const $2ecf2b723bc56fca$export$3954d500c5aed66 = ({ viewResult: viewResult, forwardRef: forwardRef, isGroupingSupported: isGroupingSupported, onChangeHierarchy: onChangeHierarchy })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const viewResultData = (0, $8Uumt.useFragment)((0, $il1iJ.default), viewResult);
    const { viewSettings: viewSettings, id: id, viewId: viewId } = viewResultData;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const toggleIssueHierarchy = $2ecf2b723bc56fca$export$fb4258c5b554d925();
    const { isGroupingEnabled: isGroupingEnabled, canEnableGrouping: canEnableGrouping, isHierarchyEnabled: isHierarchyEnabled, canEnableHierarchy: canEnableHierarchy } = viewSettings ?? {};
    const [checked, setChecked] = (0, $5uXOq.useState)(isHierarchyEnabled);
    const updateHierarchy = (0, $5uXOq.useCallback)((hierarchyPreference)=>{
        setChecked(hierarchyPreference);
        onChangeHierarchy && onChangeHierarchy(hierarchyPreference);
    }, [
        onChangeHierarchy
    ]);
    const onChange = (0, $5uXOq.useCallback)(()=>{
        if (id) {
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'hierarchyToggle clicked', {
                isHierarchyEnabled: !isHierarchyEnabled
            });
            toggleIssueHierarchy(id, !isHierarchyEnabled, updateHierarchy);
        }
    }, [
        id,
        createAnalyticsEvent,
        isHierarchyEnabled,
        toggleIssueHierarchy,
        updateHierarchy
    ]);
    const isGrouping = isGroupingSupported && isGroupingEnabled && canEnableGrouping;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: `${viewId}_hierarchy_toggle`
    }, formatMessage((0, $5Lp4g.default).showHierarchy)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        isDisabled: !canEnableHierarchy,
        isChecked: Boolean(checked && canEnableHierarchy),
        id: `${viewId}_hierarchy_toggle`,
        ref: forwardRef,
        onChange: onChange,
        size: "large"
    })), !canEnableHierarchy && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        color: "color.text.subtlest",
        size: "small"
    }, isGrouping ? formatMessage((0, $5Lp4g.default).hierarchyDisabledReasonGroupingAndFilters) : formatMessage((0, $5Lp4g.default).hierarchyDisabledReasonFilters)));
};
const $2ecf2b723bc56fca$export$fb4258c5b554d925 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [commit] = (0, $8Uumt.useMutation)((0, $BSGGQ.default));
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const commitMutation = (0, $5uXOq.useCallback)((issueSearchViewResultAri, isHierarchyEnabled, updateHierarchy)=>{
        if (isAnonymous) {
            updateHierarchy(isHierarchyEnabled);
            return;
        }
        commit({
            variables: {
                viewId: issueSearchViewResultAri,
                isHierarchyEnabled: isHierarchyEnabled
            },
            optimisticUpdater () {
                updateHierarchy(isHierarchyEnabled);
            },
            onError: (error)=>{
                (0, $jcw0u.default)({
                    meta: {
                        id: 'issue-table-hierarchy-toggle',
                        packageName: (0, $bb4c54ee542a60ec$export$b8b9d90f9e5bd72b),
                        teamName: (0, $bb4c54ee542a60ec$export$d57b6b390e78d90f)
                    },
                    error: error
                });
                showFlag({
                    id: 'hierarchyToggleError',
                    title: formatMessage((0, $5Lp4g.default).hierarchyErrorFlagTitle),
                    description: formatMessage((0, $5Lp4g.default).hierarchyErrorFlagDescription),
                    isAutoDismiss: true,
                    type: 'error',
                    messageId: 'issue-table-hierarchy-toggle.ui.show-flag.error.hierarchy-toggle-error',
                    messageType: 'transactional'
                });
            }
        });
    }, [
        commit,
        formatMessage,
        isAnonymous,
        showFlag
    ]);
    return commitMutation;
};

});
parcelRegister("BSGGQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $348ab9fdc65ea106$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4ff7227cddb108452ddf6b3f35d6d597>>
 * @relayHash ed932e3a9d9639379c52dcf337027f34
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d0399e1dcc5bef453e30083f43581d3c86d60aab8f1a485736e24c3b95e46665
const $348ab9fdc65ea106$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isHierarchyEnabled"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v2 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "isHierarchyEnabled",
                            "variableName": "isHierarchyEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewId",
                            "variableName": "viewId"
                        }
                    ],
                    "concreteType": "JiraIssueSearchHierarchyPreferenceMutationPayload",
                    "kind": "LinkedField",
                    "name": "updateIssueSearchHierarchyPreference",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "ui_issueTableHierarchyToggle_HierarchyToggleMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "ui_issueTableHierarchyToggle_HierarchyToggleMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "id": "d0399e1dcc5bef453e30083f43581d3c86d60aab8f1a485736e24c3b95e46665",
            "metadata": {},
            "name": "ui_issueTableHierarchyToggle_HierarchyToggleMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$348ab9fdc65ea106$var$node.hash = "caf43b06bb046e13cf83843bc009eeea";
var $348ab9fdc65ea106$export$2e2bcd8739ae039 = $348ab9fdc65ea106$var$node;

});

parcelRegister("il1iJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3875b3b3287d94c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d25bc54d42d0a86d44794bdc8d6789c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e3875b3b3287d94c$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "ui_issueTableHierarchyToggle_HierarchyToggle",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        },
        {
            "kind": "ScalarField",
            "name": "viewId"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isHierarchyEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEnableHierarchy"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isGroupingEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "canEnableGrouping"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$e3875b3b3287d94c$var$node.hash = "ce946b6314755bfe6dc04ff010764974";
var $e3875b3b3287d94c$export$2e2bcd8739ae039 = $e3875b3b3287d94c$var$node;

});

parcelRegister("5Lp4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $620fcc9c943a9068$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $620fcc9c943a9068$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showHierarchy: {
        "id": "issue-table-show-hierarchy",
        "defaultMessage": "Show hierarchy"
    },
    hierarchyDisabledReasonGroupingAndFilters: {
        "id": "issue-table-hierarchy-disabled-reason-grouping-and-filters",
        "defaultMessage": "Clear grouping and filters to show hierarchy"
    },
    hierarchyDisabledReasonFilters: {
        "id": "issue-table-hierarchy-disabled-reason-filters",
        "defaultMessage": "Clear filters to show hierarchy"
    },
    hierarchyErrorFlagTitle: {
        "id": "issue-table-hierarchy-error-flag-title",
        "defaultMessage": "Hierarchy preference could not be updated."
    },
    hierarchyErrorFlagDescription: {
        "id": "issue-table-hierarchy-error-flag-description",
        "defaultMessage": "Something went wrong. Please try again."
    }
});

});




parcelRegister("1igGa", function(module, exports) {

$parcel$export(module.exports, "withReportErrors", () => $8e450634a454d1b1$export$89614e972c8b110);

var $5uXOq = parcelRequire("5uXOq");

var $7iJwP = parcelRequire("7iJwP");
const $8e450634a454d1b1$export$89614e972c8b110 = (WrappedComponent, config)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), config, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props));

});


parcelRegister("aTDVl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2a9e5a070a2144b$export$2e2bcd8739ae039);

var $3XnEx = parcelRequire("3XnEx");

var $4oTzW = parcelRequire("4oTzW");

var $erDxI = parcelRequire("erDxI");

var $d6cUj = parcelRequire("d6cUj");

var $1NCNs = parcelRequire("1NCNs");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $01Rn4 = parcelRequire("01Rn4");

var $gcl1l = parcelRequire("gcl1l");

var $jJZqs = parcelRequire("jJZqs");

var $iXVV6 = parcelRequire("iXVV6");

var $imS60 = parcelRequire("imS60");

var $lVJAU = parcelRequire("lVJAU");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $6UAdF = parcelRequire("6UAdF");

var $6QnB8 = parcelRequire("6QnB8");

var $1igGa = parcelRequire("1igGa");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $a8lIB = parcelRequire("a8lIB");

var $7OTah = parcelRequire("7OTah");

var $ih9zY = parcelRequire("ih9zY");

var $krnTs = parcelRequire("krnTs");

var $gwtSG = parcelRequire("gwtSG");

var $38r5c = parcelRequire("38r5c");

var $4LmBp = parcelRequire("4LmBp");

var $3vkQx = parcelRequire("3vkQx");

var $dTymG = parcelRequire("dTymG");
const $b2a9e5a070a2144b$var$useAnalyticsAttributes = (type)=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!type) return;
        const projectType = (0, $2vSU6.toProjectType)(type.toLowerCase());
        if (!projectType) return;
        const edition = (0, $ldyPw.getEditionForProject)(projectType, appEditions);
        if (!edition) return;
        return {
            edition: edition
        };
    }, [
        appEditions,
        type
    ]);
};
const $b2a9e5a070a2144b$var$IssueResults = ({ hasServerError: hasServerError = false, onChangeColumnConfiguration: onChangeColumnConfiguration, onChangeJql: onChangeJql, onCaughtIssueSearchError: onCaughtIssueSearchError, onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld, onIssueFlatListUpdated: onIssueFlatListUpdated, issueResults: issueResults, groupResults: groupResults, jiraView: jiraView, project: project, rankField: rankField, issueTableProps: issueTableProps, filter: filter, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_START);
    const [{ view: selectedView }] = (0, $ih9zY.useSelectedViewState)();
    const jql = (0, $gwtSG.useResolvedJql)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { setSelectedIssueByIndex: setSelectedIssueByIndex } = (0, $7OTah.useSelectedIssueActions)();
    const onSelectedRowChange = (0, $5uXOq.useCallback)((rowIndex)=>{
        setSelectedIssueByIndex(rowIndex, {
            shouldDebounce: false,
            shouldNotifyOnChange: false,
            isSelectedByUserInteraction: true
        });
    }, [
        setSelectedIssueByIndex
    ]);
    const isFetching = (0, $38r5c.useIsFetching)();
    const issueResultsData = (0, $8Uumt.useFragment)((0, $1NCNs.default), issueResults);
    const groupResultsData = (0, $8Uumt.useFragment)((0, $d6cUj.default), groupResults);
    const jiraViewData = (0, $8Uumt.useFragment)((0, $erDxI.default), jiraView);
    const projectData = (0, $8Uumt.useFragment)((0, $4oTzW.default), project);
    const rankFieldData = (0, $8Uumt.useFragment)((0, $3XnEx.default), rankField);
    let attributes;
    if ((0, $4R6GH.fg)('add-attribute-required-for-colorful-labels-expe')) // eslint-disable-next-line react-hooks/rules-of-hooks
    attributes = $b2a9e5a070a2144b$var$useAnalyticsAttributes(projectData?.projectType);
    const viewResultError = (0, $5uXOq.useMemo)(()=>{
        if (!jiraViewData) return undefined;
        const message = jiraViewData.error?.message ?? '';
        const statusCode = jiraViewData.error?.extensions?.[0].statusCode;
        if (typeof statusCode !== 'number') return;
        return new (0, $jJZqs.default)(statusCode, message);
    }, [
        jiraViewData
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_END);
    }, []);
    const onNavigateToIssue = (0, $5uXOq.useCallback)((issueKey)=>push(`/browse/${issueKey}`), [
        push
    ]);
    const sourceName = selectedView === 'detail' ? (0, $6UAdF.ANALYTICS_DETAIL_VIEW_SOURCE_NAME) : (0, $6UAdF.ANALYTICS_LIST_VIEW_SOURCE_NAME);
    let viewContent = null;
    const resultsFragment = (0, $eJ0Zs.exclusiveGroupResultsOrIssueResultsFragment)({
        groupResults: groupResultsData ?? null,
        issueResults: issueResultsData ?? null
    });
    if (!hasServerError && jiraViewData && !jiraViewData.error) {
        if (selectedView === 'detail' && jiraViewData.__typename === 'JiraDetailedView' && resultsFragment?.issueResults) viewContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4LmBp.default), {
            loading: isFetching,
            onNavigateToIssue: onNavigateToIssue,
            issueResults: resultsFragment.issueResults,
            view: jiraViewData
        });
        else if (selectedView !== 'detail' && (0, $6UAdF.isJiraSpreadsheetView)(jiraViewData) && resultsFragment) viewContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTymG.default), {
            loading: isFetching,
            onSelectedRowChange: onSelectedRowChange,
            onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld,
            onIssueFlatListUpdated: onIssueFlatListUpdated,
            view: jiraViewData,
            project: projectData ?? null,
            rankField: rankFieldData ?? null,
            onChangeColumnConfiguration: onChangeColumnConfiguration,
            issueTableProps: issueTableProps,
            isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
            isIssueRankingSupportEnabled: isIssueRankingSupportEnabled,
            isMergedColumnSupportEnabled: isMergedColumnSupportEnabled,
            filter: filter,
            ...resultsFragment
        });
    }
    if (!viewContent) return isFetching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6QnB8.ListViewSkeleton), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3vkQx.default), {
        error: viewResultError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "issue-results"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: sourceName,
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        ...attributes ? {
            attributes: attributes
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3vkQx.RecoverableErrorViewBoundary), {
        recoveryProp: isFetching,
        onCaughtIssueSearchError: onCaughtIssueSearchError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krnTs.SortContainer), {
        jql: jql,
        onChangeJql: onChangeJql
    }, viewContent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: ()=>{
            onCaughtIssueSearchError && onCaughtIssueSearchError(undefined);
        }
    }))));
};
var $b2a9e5a070a2144b$export$2e2bcd8739ae039 = (0, $1igGa.withReportErrors)($b2a9e5a070a2144b$var$IssueResults, {
    id: 'ui.issue-results.unhandled',
    packageName: (0, $6UAdF.PACKAGE_NAME),
    teamName: (0, $6UAdF.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $gcl1l.isLoaderErrorAttributes)
});

});
parcelRegister("3XnEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3432659011fd442f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b9c7354c69be3b347d84955aa12a6686>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3432659011fd442f$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_rankField",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_rankField"
        }
    ],
    "type": "JiraQuery"
};
$3432659011fd442f$var$node.hash = "6841e7e8e6eb501774888d028077731e";
var $3432659011fd442f$export$2e2bcd8739ae039 = $3432659011fd442f$var$node;

});

parcelRegister("4oTzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2140bab55204986$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<edb4dc30383db0f553ab844a357e2afa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f2140bab55204986$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_project"
        },
        {
            "kind": "ScalarField",
            "name": "projectType"
        }
    ],
    "type": "JiraProject"
};
$f2140bab55204986$var$node.hash = "d2d4ef4e95db7c6e705ce7f23b5f0a5b";
var $f2140bab55204986$export$2e2bcd8739ae039 = $f2140bab55204986$var$node;

});

parcelRegister("erDxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db08798555245e3$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4aa67d431503e89ed559c9796911ad7f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9db08798555245e3$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_jiraView",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "error",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_DetailView_view"
                }
            ],
            "type": "JiraDetailedView"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "main_issueNavigator_ListView_view"
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$9db08798555245e3$var$node.hash = "d1bfcbf5b50637766f970894f71c262d";
var $9db08798555245e3$export$2e2bcd8739ae039 = $9db08798555245e3$var$node;

});

parcelRegister("d6cUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3b7bc380ba724e0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8181ceb1b33ce238044f09e55f544564>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e3b7bc380ba724e0$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "isPaginating"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_groupResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isPaginating",
                    "variableName": "isPaginating"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_groupResults"
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$e3b7bc380ba724e0$var$node.hash = "36093a29e9613109da41814cc200e024";
var $e3b7bc380ba724e0$export$2e2bcd8739ae039 = $e3b7bc380ba724e0$var$node;

});

parcelRegister("1NCNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $c580d7f20c072557$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1826f9d09fb1c8337a9e13e4e460e750>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c580d7f20c072557$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_IssueResults_issueResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ListView_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_DetailView_issueResults"
        }
    ],
    "type": "JiraIssueConnection"
};
$c580d7f20c072557$var$node.hash = "c37abeb1fd4d1dbf65f855996be78ade";
var $c580d7f20c072557$export$2e2bcd8739ae039 = $c580d7f20c072557$var$node;

});

parcelRegister("6QnB8", function(module, exports) {

$parcel$export(module.exports, "ListViewSkeleton", () => $8f321f8af9d08cfe$export$8465c21c33452ecb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k42jv = parcelRequire("k42jv");
const $8f321f8af9d08cfe$export$8465c21c33452ecb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f321f8af9d08cfe$var$StyledListViewContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k42jv.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f321f8af9d08cfe$var$StyledListViewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("k42jv", function(module, exports) {

$parcel$export(module.exports, "NativeIssueTableSkeleton", () => $405e65301287bbc2$export$309a6db85e3f2aaa);
/* NativeIssueTableSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $67CMq = parcelRequire("67CMq");
const $405e65301287bbc2$var$customCssStyles = null;
const $405e65301287bbc2$var$containerStyles = {
    height: '448px'
};
const $405e65301287bbc2$export$309a6db85e3f2aaa = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($67CMq))),
        containerStyles: $405e65301287bbc2$var$containerStyles,
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("67CMq", function(module, exports) {
module.exports = new URL("native-issue-table-skeleton.tpl.e6209376.svg", import.meta.url).toString();

});



parcelRegister("krnTs", function(module, exports) {

$parcel$export(module.exports, "SortContainer", () => $5a9a6c0829096e54$export$f2d9f14f583efb1a);
$parcel$export(module.exports, "useSortFieldAndDirection", () => $5a9a6c0829096e54$export$951ead8cec7da319);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $4R6GH = parcelRequire("4R6GH");

var $amUxN = parcelRequire("amUxN");
const $5a9a6c0829096e54$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        field: 'created',
        direction: 'DESC'
    },
    actions: {
        setField: (field, aliases)=>({ getState: getState, setState: setState }, { onChangeJql: onChangeJql, jql: jql, JqlUtils: JqlUtils })=>{
                const { field: prevField } = getState();
                if (field !== prevField) {
                    setState({
                        field: field
                    });
                    const newJql = JqlUtils?.jql(jql).setPrimarySortField(field, undefined, aliases).toJql();
                    typeof newJql === 'string' && onChangeJql && onChangeJql(newJql);
                }
            },
        setFieldAndDirection: (field, direction, aliases)=>({ getState: getState, setState: setState }, { onChangeJql: onChangeJql, jql: jql, JqlUtils: JqlUtils })=>{
                const { field: prevField, direction: prevDirection } = getState();
                if (field !== prevField || direction !== prevDirection) {
                    setState({
                        field: field,
                        direction: direction
                    });
                    if (direction !== 'NONE' || (0, $4R6GH.fg)('jsc_list_reranking_gate')) {
                        const newJql = JqlUtils?.jql(jql).setPrimarySortField(field, direction, aliases).toJql();
                        typeof newJql === 'string' && onChangeJql && onChangeJql(newJql);
                    }
                }
            }
    },
    name: 'IssueNavigatorSelectedViewState'
});
const $5a9a6c0829096e54$export$f4b3414b22b0750b = ()=>({ getState: getState, setState: setState }, { jql: jql, JqlUtils: JqlUtils })=>{
        const field = JqlUtils?.jql(jql).getPrimarySortField();
        const direction = JqlUtils?.jql(jql).getPrimarySortDirection();
        const { field: prevField, direction: prevDirection } = getState();
        if (field !== prevField || direction !== prevDirection) setState({
            field: field,
            direction: direction
        });
    };
const $5a9a6c0829096e54$export$42a852a2b6b56249 = (0, $gg7kZ.createContainer)($5a9a6c0829096e54$var$Store, {
    onInit: $5a9a6c0829096e54$export$f4b3414b22b0750b,
    onUpdate: $5a9a6c0829096e54$export$f4b3414b22b0750b
});
const $5a9a6c0829096e54$export$f2d9f14f583efb1a = (props)=>{
    const Utils = (0, $amUxN.useJqlUtils)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5a9a6c0829096e54$export$42a852a2b6b56249, {
        JqlUtils: Utils,
        ...props
    });
};
const $5a9a6c0829096e54$export$951ead8cec7da319 = (0, $3sQ5x.createHook)($5a9a6c0829096e54$var$Store, {
    selector: ({ field: field, direction: direction })=>({
            field: field,
            direction: direction
        })
});

});
parcelRegister("amUxN", function(module, exports) {

$parcel$export(module.exports, "useJqlUtils", () => $7e8f6b46153d968f$export$c7c2706ff288264f);

var $5uXOq = parcelRequire("5uXOq");

const $7e8f6b46153d968f$export$4a178a021cc96ab5 = async ()=>{
    const module = await (parcelRequire("lEsjw"));
    const { JqlUtils: JqlUtils } = module;
    return new JqlUtils();
};
const $7e8f6b46153d968f$export$c7c2706ff288264f = ()=>{
    const [Utils, setUtils] = (0, $5uXOq.useState)();
    const asyncEffect = async ()=>{
        const ResolvedUtils = await $7e8f6b46153d968f$export$4a178a021cc96ab5();
        setUtils(ResolvedUtils);
    };
    (0, $5uXOq.useEffect)(()=>{
        asyncEffect();
    }, []);
    return Utils;
};

});
parcelRegister("lEsjw", function(module, exports) {

let $fc334bf5644f80c4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $fc334bf5644f80c4$var$load("i8Zoh").then(()=>parcelRequire('aWG9Z'));

});



parcelRegister("4LmBp", function(module, exports) {

$parcel$export(module.exports, "default", () => $53522b5e6e51bfef$export$2e2bcd8739ae039);

var $dhc4s = parcelRequire("dhc4s");

var $2Vq1u = parcelRequire("2Vq1u");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gcl1l = parcelRequire("gcl1l");

var $kYFm9 = parcelRequire("kYFm9");

var $3HwlS = parcelRequire("3HwlS");

var $5oFIy = parcelRequire("5oFIy");

var $imS60 = parcelRequire("imS60");

var $6UAdF = parcelRequire("6UAdF");

var $eojy4 = parcelRequire("eojy4");

var $1igGa = parcelRequire("1igGa");

var $a8lIB = parcelRequire("a8lIB");

var $hWtSW = parcelRequire("hWtSW");

var $428r9 = parcelRequire("428r9");
const $53522b5e6e51bfef$var$ConditionalContentContainer = ({ children: children })=>(0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $53522b5e6e51bfef$var$ContentContainerStyles
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($53522b5e6e51bfef$var$ContentStyledContainer, null, children);
const $53522b5e6e51bfef$var$DetailView = ({ IssueApp: IssueApp = (0, $eojy4.default), issueResults: issueResults, view: view, ...props })=>{
    const listRef = (0, $5uXOq.useRef)(null);
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_DETAIL_VIEW_START);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_DETAIL_VIEW_END);
    }, []);
    const detailViewData = (0, $8Uumt.useFragment)((0, $2Vq1u.default), issueResults);
    const viewData = (0, $8Uumt.useFragment)((0, $dhc4s.default), view);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "detail-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($53522b5e6e51bfef$var$ConditionalContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kYFm9.ElementSizeProvider), {
        elementRef: listRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hWtSW.default), {
        issueResults: detailViewData,
        view: viewData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $428r9.default), {
        fragment: detailViewData,
        ...props,
        listRef: listRef
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueApp, {
        isEmbedView: true,
        issueResults: detailViewData,
        view: viewData
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)));
};
// re-render regression detection
$53522b5e6e51bfef$var$DetailView.whyDidYouRender = true;
var $53522b5e6e51bfef$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $1igGa.withReportErrors)($53522b5e6e51bfef$var$DetailView, {
    id: 'ui.issue-results.detail-view.unhandled',
    packageName: (0, $6UAdF.PACKAGE_NAME),
    teamName: (0, $6UAdF.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $gcl1l.isLoaderErrorAttributes)
});
const $53522b5e6e51bfef$var$ContentStyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4t3i1osq _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $53522b5e6e51bfef$var$ContentContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: '100%',
    flexGrow: 1,
    overflow: 'hidden',
    flexBasis: 0
});

});
parcelRegister("dhc4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $105aa14c9d2fd9d2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<413e774d04809c5372ccc3674da92a96>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $105aa14c9d2fd9d2$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_DetailView_view",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "cardContainer_issueNavigator_view"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_view"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$105aa14c9d2fd9d2$var$node.hash = "68ca158b865b96f58c529de1ab919b9b";
var $105aa14c9d2fd9d2$export$2e2bcd8739ae039 = $105aa14c9d2fd9d2$var$node;

});

parcelRegister("2Vq1u", function(module, exports) {

$parcel$export(module.exports, "default", () => $30bc58ed3773e514$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<c6d20b50d30d33e809ff675bbd13cffa>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $30bc58ed3773e514$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_DetailView_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_CardList_fragment"
        },
        {
            "kind": "FragmentSpread",
            "name": "cardContainer_issueNavigator_issueResults"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_IssueAppWithData_issueResults"
        }
    ],
    "type": "JiraIssueConnection"
};
$30bc58ed3773e514$var$node.hash = "6b64dddb99a963cc9fea8872d644dae0";
var $30bc58ed3773e514$export$2e2bcd8739ae039 = $30bc58ed3773e514$var$node;

});

parcelRegister("kYFm9", function(module, exports) {

$parcel$export(module.exports, "useElementSizeSelector", () => $9fb6972593b23474$export$6af5bd31f067d7e5);
$parcel$export(module.exports, "ElementSizeProvider", () => $9fb6972593b23474$export$73bf76c50625186);

var $5uXOq = parcelRequire("5uXOq");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $9fb6972593b23474$export$e4c0458e30711294 = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0
};
const $9fb6972593b23474$export$638cf470f916deb7 = (0, $gg7kZ.createContainer)({
    getIsConcurrentSafe: ()=>true
});
const $9fb6972593b23474$export$3378d8ea7d02abd0 = {
    height: 0,
    width: 0
};
const $9fb6972593b23474$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        }
};
const $9fb6972593b23474$var$Store = (0, $iXqE5.createStore)({
    containedBy: $9fb6972593b23474$export$638cf470f916deb7,
    initialState: $9fb6972593b23474$export$3378d8ea7d02abd0,
    name: 'ElementSize',
    actions: $9fb6972593b23474$var$actions,
    handlers: {
        onInit: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            },
        onContainerUpdate: ()=>({ setState: setState, getState: getState }, { width: width, height: height })=>{
                const state = getState();
                setState({
                    ...state,
                    width: width,
                    height: height
                });
            }
    }
});
const $9fb6972593b23474$export$6af5bd31f067d7e5 = (0, $3sQ5x.createStateHook)($9fb6972593b23474$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $9fb6972593b23474$export$2b86bedf890eab8 = (elementRef)=>{
    const [size, setSize] = (0, $5uXOq.useState)($9fb6972593b23474$export$e4c0458e30711294);
    (0, $5uXOq.useEffect)(()=>{
        const element = elementRef.current;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                setSize({
                    height: element.clientHeight,
                    width: element.clientWidth,
                    scrollHeight: element.scrollHeight,
                    scrollWidth: element.scrollWidth
                });
            });
            resizeObserver.observe(element);
            return ()=>{
                resizeObserver.disconnect();
            };
        }
    }, [
        elementRef
    ]);
    return size;
};
const $9fb6972593b23474$export$73bf76c50625186 = ({ elementRef: elementRef, children: children })=>{
    const { width: width, height: height } = $9fb6972593b23474$export$2b86bedf890eab8(elementRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9fb6972593b23474$export$638cf470f916deb7, {
        width: width,
        height: height
    }, children);
};

});

parcelRegister("hWtSW", function(module, exports) {

$parcel$export(module.exports, "default", () => $75bb3ad05744ab39$export$2e2bcd8739ae039);

var $86rKB = parcelRequire("86rKB");

var $IXZB0 = parcelRequire("IXZB0");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $i9xcC = parcelRequire("i9xcC");

var $9CFBJ = parcelRequire("9CFBJ");

var $dCm1o = parcelRequire("dCm1o");

var $6UAdF = parcelRequire("6UAdF");

var $cyCoT = parcelRequire("cyCoT");

var $eLt1F = parcelRequire("eLt1F");

var $kj1di = parcelRequire("kj1di");

var $coNDq = parcelRequire("coNDq");

var $gWk5r = parcelRequire("gWk5r");

var $kwVxA = parcelRequire("kwVxA");
const $75bb3ad05744ab39$var$infiniteScrollOptions = {
    threshold: 350 // Approximately 5 min-height cards tall
};
const $75bb3ad05744ab39$var$CardContainer = ({ children: children, issueResults: issueResults, view: view })=>{
    const data = (0, $8Uumt.useFragment)((0, $IXZB0.default), issueResults);
    const viewData = (0, $8Uumt.useFragment)((0, $86rKB.default), view);
    const fieldSetIds = (0, $5uXOq.useMemo)(()=>viewData?.fieldSets?.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData?.fieldSets?.edges
    ]);
    const infiniteScrollProps = (0, $kj1di.useInfiniteScroll)({
        fieldSetIds: fieldSetIds,
        options: $75bb3ad05744ab39$var$infiniteScrollOptions,
        view: (0, $6UAdF.views).detail
    });
    const { isLoadingPrevious: isLoadingPrevious, isLoadingNext: isLoadingNext } = infiniteScrollProps;
    const { onScroll: onScroll, onLoadingThresholdCheck: onLoadingThresholdCheck } = (0, $i9xcC.useInfiniteScrollHandler)(infiniteScrollProps);
    const scrollContainerRef = (0, $5uXOq.useRef)(null);
    const totalIssues = data.totalIssueSearchResultCount ?? 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: (0, $dCm1o.isVisualRefreshEnabled)() ? undefined : 'space.025',
        grow: "fill",
        xcss: (0, $dCm1o.isVisualRefreshEnabled)() ? $75bb3ad05744ab39$var$containerStyles : $75bb3ad05744ab39$var$containerStylesOld,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.styled-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        xcss: (0, $dCm1o.isVisualRefreshEnabled)() ? $75bb3ad05744ab39$var$headerStyles : $75bb3ad05744ab39$var$headerStylesOld,
        alignBlock: (0, $dCm1o.isVisualRefreshEnabled)() ? 'center' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gWk5r.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kwVxA.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eLt1F.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9CFBJ.ScrollStateProvider), {
        scrollRef: scrollContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        grow: "fill",
        xcss: $75bb3ad05744ab39$var$loadingIndicatorContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: scrollContainerRef,
        xcss: $75bb3ad05744ab39$var$cardListStyles,
        onScroll: onScroll,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.scroll-container"
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coNDq.LoadingManager), {
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        onLoadingThresholdCheck: onLoadingThresholdCheck
    }))), totalIssues != null && totalIssues > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        alignInline: "center",
        xcss: $75bb3ad05744ab39$var$footerStyles,
        testId: "issue-navigator.ui.issue-results.detail-view.card-container.total-count"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cyCoT.default), {
        startIssueRange: -1,
        endIssueRange: -1,
        total: totalIssues,
        countExceedsMaxResults: !!data.isCappingIssueSearchResult,
        loadedIssuesCount: data.edges?.length ?? 0,
        isInfiniteScrollEnabled: true
    })));
};
var $75bb3ad05744ab39$export$2e2bcd8739ae039 = $75bb3ad05744ab39$var$CardContainer;
const $75bb3ad05744ab39$var$containerStylesOld = (0, $8CUq3.xcss)({
    borderRadius: '4px',
    backgroundColor: 'color.background.neutral',
    boxSizing: 'content-box',
    padding: 'space.025',
    marginBottom: 'space.100',
    marginRight: 'space.200',
    minWidth: '256px',
    maxWidth: '256px'
});
const $75bb3ad05744ab39$var$containerStyles = (0, $8CUq3.xcss)({
    borderRadius: '4px',
    backgroundColor: 'elevation.surface.sunken',
    boxSizing: 'content-box',
    paddingInline: 'space.025',
    marginBottom: 'space.100',
    marginRight: 'space.200',
    minWidth: '256px',
    maxWidth: '256px'
});
const $75bb3ad05744ab39$var$headerStylesOld = (0, $8CUq3.xcss)({
    flexGrow: 1,
    flexShrink: 0,
    height: '32px' // gridSize * 4
});
const $75bb3ad05744ab39$var$headerStyles = (0, $8CUq3.xcss)({
    flexGrow: 1,
    flexShrink: 0,
    height: '40px',
    marginBottom: 'space.negative.025',
    // Cards require small margin to show box shadow. This negative margin recenters the header.
    paddingInline: 'space.025'
});
const $75bb3ad05744ab39$var$loadingIndicatorContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: '1',
    flexShrink: '1',
    flexBasis: '100vh',
    overflow: 'hidden',
    position: 'relative' // Required in order to contain loading indicator
});
const $75bb3ad05744ab39$var$cardListStyles = (0, $8CUq3.xcss)({
    flexGrow: '1',
    overflow: 'auto'
});
const $75bb3ad05744ab39$var$footerStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    paddingBlock: 'space.050',
    textAlign: 'center'
});

});
parcelRegister("86rKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $76f82c5b1530b1f8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92fae5f50256e3386fc71e04131d3a3e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $76f82c5b1530b1f8$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsScope"
        }
    ],
    "kind": "Fragment",
    "name": "cardContainer_issueNavigator_view",
    "selections": [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                        "fieldSetSelectedState": "SELECTED"
                    }
                },
                {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "amountOfColumns"
                },
                {
                    "kind": "Variable",
                    "name": "scope",
                    "variableName": "fieldSetsScope"
                }
            ],
            "concreteType": "JiraIssueSearchFieldSetConnection",
            "kind": "LinkedField",
            "name": "fieldSets",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueSearchFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                        {
                            "concreteType": "JiraIssueSearchFieldSet",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "fieldSetId"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$76f82c5b1530b1f8$var$node.hash = "dd030a7b614f7ff3b54a4b31d5671be2";
var $76f82c5b1530b1f8$export$2e2bcd8739ae039 = $76f82c5b1530b1f8$var$node;

});

parcelRegister("IXZB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e83319da6aeba2fb$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<49a8b04fc3798cc5e42bb64eb7cfe233>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $e83319da6aeba2fb$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "cardContainer_issueNavigator_issueResults",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                }
            ]
        },
        {
            "kind": "ScalarField",
            "name": "totalIssueSearchResultCount"
        },
        {
            "kind": "ScalarField",
            "name": "isCappingIssueSearchResult"
        }
    ],
    "type": "JiraIssueConnection"
};
$e83319da6aeba2fb$var$node.hash = "a51c85a8ee17bb574907b5cd760bad2f";
var $e83319da6aeba2fb$export$2e2bcd8739ae039 = $e83319da6aeba2fb$var$node;

});

parcelRegister("i9xcC", function(module, exports) {

$parcel$export(module.exports, "useInfiniteScrollHandler", () => $b2b86989bea72b31$export$ee8d81e7d8c9f22d);

var $5uXOq = parcelRequire("5uXOq");

var $czfFt = parcelRequire("czfFt");

var $dbaUr = parcelRequire("dbaUr");
const $b2b86989bea72b31$var$DEFAULT_ACTIVATION_THRESHOLD = 10 * (0, $czfFt.ROW_HEIGHT);
const $b2b86989bea72b31$export$ee8d81e7d8c9f22d = ({ onLoadNext: onLoadNextProp, onLoadPrevious: onLoadPreviousProp, ...dataProps })=>{
    // Keep props as ref so the callback is stable across rerenders.
    const dataPropsRef = (0, $5uXOq.useRef)(dataProps);
    dataPropsRef.current = dataProps;
    const onLoadNext = (0, $dbaUr.useThrottle)(onLoadNextProp);
    const onLoadPrevious = (0, $dbaUr.useThrottle)(onLoadPreviousProp);
    const onLoadingThresholdCheck = (0, $5uXOq.useCallback)(({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop })=>{
        const { isLoadingNext: isLoadingNext, isLoadingPrevious: isLoadingPrevious, hasNext: hasNext, hasPrevious: hasPrevious, activationThreshold: activationThreshold = $b2b86989bea72b31$var$DEFAULT_ACTIVATION_THRESHOLD } = dataPropsRef.current;
        const scrollBottom = scrollHeight - clientHeight - scrollTop;
        const isLoading = isLoadingNext || isLoadingPrevious;
        // Prioritising loading next over loading previous to fill results downwards first,
        // to hopefully feel more natural.
        if (hasNext && !isLoading && scrollBottom <= activationThreshold) onLoadNext?.();
        else if (hasPrevious && !isLoading && scrollTop <= activationThreshold) onLoadPrevious?.();
    }, // Ensure that the callback is not recreated when props change.
    // onLoadNext & onLoadPrevious should be throttled & stable.
    [
        onLoadNext,
        onLoadPrevious
    ]);
    const onScroll = (0, $5uXOq.useCallback)((event)=>{
        onLoadingThresholdCheck(event.currentTarget);
    }, // Ensure that the callback is not recreated when props change.
    // onLoadingThresholdCheck should be stable.
    [
        onLoadingThresholdCheck
    ]);
    return {
        onLoadingThresholdCheck: onLoadingThresholdCheck,
        onScroll: onScroll
    };
};

});
parcelRegister("dbaUr", function(module, exports) {

$parcel$export(module.exports, "useThrottle", () => $9793367875371ab2$export$8b7b9481d6186f21);

var $5uXOq = parcelRequire("5uXOq");
const $9793367875371ab2$export$8b7b9481d6186f21 = (fn, wait = 100)=>{
    const fnRef = (0, $5uXOq.useRef)(fn);
    fnRef.current = fn;
    const waitRef = (0, $5uXOq.useRef)(wait);
    waitRef.current = wait;
    const timeout = (0, $5uXOq.useRef)(undefined);
    const throttled = (0, $5uXOq.useCallback)(()=>{
        if (timeout.current !== undefined) return;
        fnRef.current?.();
        timeout.current = setTimeout(()=>{
            timeout.current = undefined;
        }, waitRef.current);
    // Ensure the callback is not recreated when props change,
    // dependency array should be empty.
    }, []);
    // Cleanup the timeout on unmount.
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (timeout.current !== undefined) clearTimeout(timeout.current);
        };
    }, []);
    return throttled;
};

});


parcelRegister("9CFBJ", function(module, exports) {

$parcel$export(module.exports, "useScrollStateSelector", () => $502b0ac1011ec6e7$export$a2d79f83724ed591);
$parcel$export(module.exports, "useScrollElement", () => $502b0ac1011ec6e7$export$fae04c81b2201f65);
$parcel$export(module.exports, "ScrollStateProvider", () => $502b0ac1011ec6e7$export$9f9741e7dc6bdb9b);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $502b0ac1011ec6e7$export$50b6b7783d156e1b = 200;
const $502b0ac1011ec6e7$export$f9abcb6f103965a2 = (0, $gg7kZ.createContainer)();
const $502b0ac1011ec6e7$var$INITIAL_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null
};
const $502b0ac1011ec6e7$var$actions = {
    update: (newState)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                ...newState
            });
        }
};
const $502b0ac1011ec6e7$var$Store = (0, $iXqE5.createStore)({
    containedBy: $502b0ac1011ec6e7$export$f9abcb6f103965a2,
    initialState: $502b0ac1011ec6e7$var$INITIAL_SCROLL_STATE,
    name: 'ScrollStateManager',
    actions: $502b0ac1011ec6e7$var$actions
});
const $502b0ac1011ec6e7$var$useScrollStateActions = (0, $3sQ5x.createActionsHook)($502b0ac1011ec6e7$var$Store);
const $502b0ac1011ec6e7$export$a2d79f83724ed591 = (0, $3sQ5x.createStateHook)($502b0ac1011ec6e7$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $502b0ac1011ec6e7$export$fae04c81b2201f65 = (0, $3sQ5x.createStateHook)($502b0ac1011ec6e7$var$Store, {
    selector: (state)=>state.scrollElement
});
const $502b0ac1011ec6e7$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $502b0ac1011ec6e7$var$useElementScrollState = (scrollRef)=>{
    const { update: update } = $502b0ac1011ec6e7$var$useScrollStateActions();
    (0, $5uXOq.useEffect)(()=>{
        const targetEl = scrollRef.current;
        // The element should always exists as the useEffect triggers after the reference is assigned.
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            update({
                scrollWidth: targetEl.scrollWidth,
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                isScrolling: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollWidth: targetEl.scrollWidth,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $502b0ac1011ec6e7$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            update({
                scrollTop: targetEl.scrollTop,
                scrollLeft: targetEl.scrollLeft,
                height: targetEl.clientHeight,
                width: targetEl.clientWidth,
                scrollHeight: targetEl.scrollHeight,
                scrollWidth: targetEl.scrollWidth,
                isScrolling: true
            });
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                update({
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: false
                });
            }, $502b0ac1011ec6e7$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $502b0ac1011ec6e7$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        update({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef,
        update
    ]);
};
const $502b0ac1011ec6e7$var$ScrollStateProviderInner = ({ scrollRef: scrollRef, children: children })=>{
    $502b0ac1011ec6e7$var$useElementScrollState(scrollRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $502b0ac1011ec6e7$export$9f9741e7dc6bdb9b = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($502b0ac1011ec6e7$export$f9abcb6f103965a2, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($502b0ac1011ec6e7$var$ScrollStateProviderInner, props));
};

});

parcelRegister("cyCoT", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cb075bc3ee6def7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $79uRg = parcelRequire("79uRg");

var $b71Xi = parcelRequire("b71Xi");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8cb075bc3ee6def7$export$2e2bcd8739ae039 = ({ startIssueRange: startIssueRange, endIssueRange: endIssueRange, loadedIssuesCount: loadedIssuesCount, total: total, countExceedsMaxResults: countExceedsMaxResults, isInfiniteScrollEnabled: isInfiniteScrollEnabled // This is not the experiment; This is if the feature is enabled
 })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isTotalUnknown = total <= 0;
    if (isInfiniteScrollEnabled) {
        if (isTotalUnknown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, loadedIssuesCount);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79uRg.default), {
            prependMessage: (0, $b71Xi.default).loadedIssuesTotalKnown,
            prependMessageValues: {
                loadedIssuesCount: loadedIssuesCount
            },
            stableCount: total,
            isCapped: countExceedsMaxResults
        });
    }
    if (isTotalUnknown) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $b71Xi.default).issueRangeUnknown, {
        startIssueRange: startIssueRange,
        endIssueRange: endIssueRange
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $79uRg.default), {
        prependMessage: (0, $b71Xi.default).issueRangeKnown,
        prependMessageValues: {
            startIssueRange: startIssueRange,
            endIssueRange: endIssueRange
        },
        stableCount: total,
        isCapped: countExceedsMaxResults
    });
};

});
parcelRegister("79uRg", function(module, exports) {

$parcel$export(module.exports, "default", () => $da78c4decc98820b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $cR57N = parcelRequire("cR57N");
/**
 * Display the total number of issues from a search with the ability to toggle from stable to unstable values.
 *
 * Stable vs Unstable
 *  - the **stable count** is returned from the issueSearchStable query. It will be capped at 1000 if
 *    there are more than 1000 results. This is the default count that is displayed
 *
 *  - the **unstable count** is returned from the totalIssueCountQuery query. It is the true number of results
 *    for a search and does not have a cap. This value must be requested by the user via button click.
 */ const $da78c4decc98820b$var$TotalIssueCountWrapper = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "TotalIssueCount",
        packageName: "jiraIssueNavigator",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage(props.prependMessage, {
                ...props.prependMessageValues,
                totalNumberIssues: props.isCapped ? `${props.stableCount}+` : props.stableCount
            })),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cR57N.default), props));
};
var $da78c4decc98820b$export$2e2bcd8739ae039 = $da78c4decc98820b$var$TotalIssueCountWrapper;

});
parcelRegister("cR57N", function(module, exports) {

$parcel$export(module.exports, "default", () => $12abfe1ef23c73a0$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dD7Zc = parcelRequire("dD7Zc");

var $MHKc7 = parcelRequire("MHKc7");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $38r5c = parcelRequire("38r5c");

var $c3DxU = parcelRequire("c3DxU");

var $dZ9aY = parcelRequire("dZ9aY");
const $12abfe1ef23c73a0$var$TotalIssueCount = ({ prependMessage: prependMessage, prependMessageValues: prependMessageValues, isCapped: isCapped, stableCount: stableCount })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const totalIssueCount = (0, $38r5c.useTotalIssueCount)();
    const totalIssueCountIsFetching = (0, $38r5c.useTotalIssueCountIsFetching)();
    const totalIssueCountIsError = (0, $38r5c.useTotalIssueCountIsError)();
    const { onFetchTotalIssueCount: onFetchTotalIssueCount } = (0, $38r5c.useIssueSearchActions)();
    if (isCapped) {
        if (totalIssueCountIsError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: `${stableCount}+`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            position: "top",
            content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dZ9aY.default).errorTooltipTextIssueTermRefresh : (0, $dZ9aY.default).errorTooltipText)
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12abfe1ef23c73a0$var$ErrorIconContainer, {
                ...tooltipProps,
                "data-testid": "issue-navigator.common.ui.total-issue-count.error-icon"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
                spacing: "spacious",
                label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dZ9aY.default).errorIconLabelIssueTermRefresh : (0, $dZ9aY.default).errorIconLabel)
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
            action: "viewed",
            actionSubject: "errorIcon",
            actionSubjectId: "totalIssueCount"
        }));
        if (totalIssueCountIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: ''
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12abfe1ef23c73a0$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small",
            testId: "issue-navigator.common.ui.total-issue-count.spinner"
        })));
        if (!totalIssueCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c3DxU.default), {
                displayText: `${stableCount}+`,
                onFetchCount: onFetchTotalIssueCount
            })
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            as: "span"
        }, formatMessage(prependMessage, {
            ...prependMessageValues,
            totalNumberIssues: totalIssueCount
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        as: "span"
    }, formatMessage(prependMessage, {
        ...prependMessageValues,
        totalNumberIssues: stableCount
    }));
};
var $12abfe1ef23c73a0$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($12abfe1ef23c73a0$var$TotalIssueCount);
const $12abfe1ef23c73a0$var$ErrorIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _4t3i1tcg _syaz131l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $12abfe1ef23c73a0$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _otyr1l7b _18u01y44",
            __cmplp.className
        ])
    });
});

});
parcelRegister("c3DxU", function(module, exports) {

$parcel$export(module.exports, "default", () => $760aa3895a440d03$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $dZ9aY = parcelRequire("dZ9aY");
const $760aa3895a440d03$var$LoadUncappedCountButton = ({ onFetchCount: onFetchCount, displayText: displayText })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const fetchCount = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        onFetchCount();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'totalIssueCountButton');
    }, [
        onFetchCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dZ9aY.default).cappedCountTooltipIssueTermRefresh : (0, $dZ9aY.default).cappedCountTooltip),
        tag: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        tabIndex: 0,
        appearance: "link",
        spacing: "none",
        onClick: fetchCount,
        "aria-label": (0, $4R6GH.fg)('jsc-679_match_accessible_name_with_visual_label') ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dZ9aY.default).cappedCountButtonLabelIssueTermRefresh : (0, $dZ9aY.default).cappedCountButtonLabel, {
            count: displayText
        }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dZ9aY.default).cappedCountTooltipIssueTermRefresh : (0, $dZ9aY.default).cappedCountTooltip),
        testId: "issue-navigator.common.ui.total-issue-count.load-uncapped-count-button.button"
    }, displayText));
};
var $760aa3895a440d03$export$2e2bcd8739ae039 = $760aa3895a440d03$var$LoadUncappedCountButton;

});
parcelRegister("dZ9aY", function(module, exports) {

$parcel$export(module.exports, "default", () => $765e50af4a6c461b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $765e50af4a6c461b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTooltipText: {
        "id": "issue-navigator.common.total-issue-count.error-tooltip-text",
        "defaultMessage": "We couldn\u2019t load the total number of issues. Refresh to try again."
    },
    errorIconLabel: {
        "id": "issue-navigator.common.total-issue-count.error-icon-label",
        "defaultMessage": "Error loading total issue count"
    },
    cappedCountTooltip: {
        "id": "issue-navigator.common.total-issue-count.capped-count-tooltip",
        "defaultMessage": "See the total number of issues."
    },
    errorTooltipTextIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.error-tooltip-text-issue-term-refresh",
        "defaultMessage": "We couldn\u2019t load the total number of work items. Refresh to try again."
    },
    errorIconLabelIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.error-icon-label-issue-term-refresh",
        "defaultMessage": "Error loading total work item count"
    },
    cappedCountTooltipIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.capped-count-tooltip-issue-term-refresh",
        "defaultMessage": "See the total number of work items."
    },
    cappedCountButtonLabel: {
        "id": "issue-navigator.common.total-issue-count.capped-count-button-label",
        "defaultMessage": "{count} See the total number of issues."
    },
    cappedCountButtonLabelIssueTermRefresh: {
        "id": "issue-navigator.common.total-issue-count.capped-count-button-label-issue-term-refresh",
        "defaultMessage": "{count} See the total number of work items."
    }
});

});




parcelRegister("b71Xi", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9773df3a4a055b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $db9773df3a4a055b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadedIssuesTotalKnown: {
        "id": "issue-navigator.common.page-text.loaded-issues-total-known",
        "defaultMessage": "{loadedIssuesCount} of {totalNumberIssues}"
    },
    issueRangeKnown: {
        "id": "issue-navigator.card-container.paginator.issue-range-known",
        "defaultMessage": "{startIssueRange}-{endIssueRange} of {totalNumberIssues}"
    },
    issueRangeUnknown: {
        "id": "issue-navigator.card-container.paginator.issue-range-unknown",
        "defaultMessage": "{startIssueRange}-{endIssueRange}"
    }
});

});


parcelRegister("eLt1F", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5cafba943267706$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $jOrGg = parcelRequire("jOrGg");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $38r5c = parcelRequire("38r5c");

var $lrrHu = parcelRequire("lrrHu");
const $b5cafba943267706$var$RefreshButton = ()=>{
    const isRefreshing = (0, $38r5c.useIsRefreshing)();
    const { onRefresh: onRefresh } = (0, $38r5c.useIssueSearchActions)();
    const handleClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'reloadIssueListButton');
        onRefresh();
    }, [
        onRefresh
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        onClick: handleClick,
        testId: "issue-navigator.common.ui.refresh-button.refresh-button",
        label: formatMessage((0, $lrrHu.default).tooltip),
        icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOrGg))), {
                ...iconProps,
                color: "var(--ds-icon-subtle, #626F86)",
                LEGACY_size: "small",
                LEGACY_primaryColor: "color.icon.subtle"
            }),
        isLoading: isRefreshing
    });
};
var $b5cafba943267706$export$2e2bcd8739ae039 = $b5cafba943267706$var$RefreshButton;

});
parcelRegister("jOrGg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::97b7deedaffb04632472c93b0c8f5452>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6c828a42ee64c30$var$_react = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6c828a42ee64c30$var$_refresh = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("gPelT")));

var $e6c828a42ee64c30$var$_refresh2 = $e6c828a42ee64c30$var$_interopRequireDefault((parcelRequire("75Jbm")));
function $e6c828a42ee64c30$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for RefreshIcon.
 * This component is RefreshIcon, with `UNSAFE_fallbackIcon` set to "RefreshIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6c828a42ee64c30$var$RefreshIcon = (props)=>/*#__PURE__*/ $e6c828a42ee64c30$var$_react.default.createElement($e6c828a42ee64c30$var$_refresh.default, Object.assign({
        LEGACY_fallbackIcon: $e6c828a42ee64c30$var$_refresh2.default
    }, props));
$e6c828a42ee64c30$var$RefreshIcon.Name = 'RefreshIconMigration';
var $e6c828a42ee64c30$var$_default = module.exports.default = $e6c828a42ee64c30$var$RefreshIcon;

});
parcelRegister("gPelT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d727d3cc18de179b7b728d0be1f533d4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3fc8ad083e2745c$var$_react = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c3fc8ad083e2745c$var$_baseNew = $c3fc8ad083e2745c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c3fc8ad083e2745c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Refresh".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for reloading or replaying content
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3fc8ad083e2745c$var$RefreshIcon = (props)=>/*#__PURE__*/ $c3fc8ad083e2745c$var$_react.default.createElement($c3fc8ad083e2745c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 3.67V1H1v5c0 .414.336.75.75.75H6.5v-1.5H3.236a5.5 5.5 0 1 1-.666 3.63l-1.48.24A7.002 7.002 0 0 0 15 8 7 7 0 0 0 2.5 3.67" clip-rule="evenodd"/>`
    }, props));
$c3fc8ad083e2745c$var$RefreshIcon.displayName = 'RefreshIcon';
var $c3fc8ad083e2745c$var$_default = module.exports.default = $c3fc8ad083e2745c$var$RefreshIcon;

});

parcelRegister("75Jbm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $529c0c456318696f$var$_react = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $529c0c456318696f$var$_refresh = $529c0c456318696f$var$_interopRequireDefault((parcelRequire("gPelT")));
function $529c0c456318696f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $529c0c456318696f$var$RefreshIcon = (props)=>/*#__PURE__*/ $529c0c456318696f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M8 6.003v2.995a1 1 0 1 0 2 0V5.102C10 4.494 9.507 4 8.9 4H5a1 1 0 0 0 0 2.003z"/><path fill-rule="nonzero" d="M9.428 18.018C7.351 16.989 6 14.807 6 12.37c0-2.266 1.167-4.319 3.02-5.425.48-.286.646-.922.371-1.421a.98.98 0 0 0-1.364-.386C5.557 6.611 4 9.35 4 12.37c0 3.248 1.802 6.158 4.57 7.529.498.247 1.095.026 1.332-.493.237-.52.025-1.141-.474-1.388"/><path d="M14 15.002v3.896c0 .608.493 1.102 1.1 1.102H19a1 1 0 0 0 0-2.003h-3v-2.995a1 1 0 1 0-2 0"/><path d="M14.097 4.596c-.237.52-.025 1.14.474 1.387 2.077 1.029 3.428 3.21 3.428 5.647 0 2.266-1.167 4.32-3.021 5.425a1.063 1.063 0 0 0-.37 1.42c.274.5.885.673 1.364.387 2.47-1.473 4.027-4.212 4.027-7.232 0-3.248-1.802-6.158-4.57-7.528A.96.96 0 0 0 15.002 4a1 1 0 0 0-.905.596"/></g></svg>`
    }, props, {
        newIcon: $529c0c456318696f$var$_refresh.default
    }));
$529c0c456318696f$var$RefreshIcon.displayName = 'RefreshIcon';
var $529c0c456318696f$var$_default = module.exports.default = $529c0c456318696f$var$RefreshIcon;

});


parcelRegister("lrrHu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d0ea2577d797cdc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var // TODO - Port i18n string translations to new module ID keys
$3d0ea2577d797cdc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "issue-navigator.refresh-button.tooltip",
        "defaultMessage": "Refresh"
    },
    loading: {
        "id": "issue-navigator.refresh-button.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("coNDq", function(module, exports) {

$parcel$export(module.exports, "LoadingManager", () => $af47037513790f77$export$99cc795e99919eed);

var $5uXOq = parcelRequire("5uXOq");

var $dqoiX = parcelRequire("dqoiX");

var $koVbs = parcelRequire("koVbs");

var $kYFm9 = parcelRequire("kYFm9");

var $9CFBJ = parcelRequire("9CFBJ");

var $1XJ20 = parcelRequire("1XJ20");

var $4R6GH = parcelRequire("4R6GH");

var $50QiF = parcelRequire("50QiF");

var $arPIt = parcelRequire("arPIt");
const $af47037513790f77$export$99cc795e99919eed = ({ isLoadingPrevious: isLoadingPrevious, isLoadingNext: isLoadingNext, onLoadingThresholdCheck: onLoadingThresholdCheck })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    // List has height 0 during first render due to virtualization. Some checks need to wait for the list to have a height.
    const hasListHeight = (0, $kYFm9.useElementSizeSelector)((listElm)=>Boolean(listElm.height));
    const scrollContainerHeight = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>scrollState.height);
    const scrollElement = (0, $9CFBJ.useScrollElement)();
    // #region After-load Handler
    /**
   * After initial render and any subsequent loading events, make sure that we continue loading in more issues if
   * necessary because a single load may not have enough issues to fill the scroll container.
   */ (0, $5uXOq.useEffect)(()=>{
        if (scrollElement && onLoadingThresholdCheck && hasListHeight && !isLoadingPrevious && !isLoadingNext) onLoadingThresholdCheck(scrollElement);
    }, [
        hasListHeight,
        isLoadingPrevious,
        isLoadingNext,
        onLoadingThresholdCheck,
        scrollElement
    ]);
    // #endregion
    // #region Resize Handler
    /**
   * Check the loading boundaries when resizing the scroll container, as the new size may require loading more issues.
   */ const prevHeight = (0, $1XJ20.usePreviousWithInitial)(scrollContainerHeight);
    (0, $5uXOq.useEffect)(()=>{
        if (scrollElement && onLoadingThresholdCheck && hasListHeight && scrollContainerHeight > prevHeight) onLoadingThresholdCheck(scrollElement);
    }, [
        hasListHeight,
        scrollContainerHeight,
        prevHeight,
        onLoadingThresholdCheck,
        scrollElement
    ]);
    // #endregion
    // #region Top Scroll Handler
    /**
   * A component that ensures that the scroll position is kept stable when loading previous issues.
   * This is necessary because sometimes the browser does scroll to keep existing rows in view when new rows are prepended.
   *
   * Without this, we may see issues like continuously loading all previous issues until there are none left.
   */ const prevIsLoadingPrevious = (0, $1XJ20.usePreviousWithInitial)(isLoadingPrevious);
    const hasStartedLoadingPrevious = !prevIsLoadingPrevious && isLoadingPrevious;
    const hasFinishedLoadingPrevious = prevIsLoadingPrevious && !isLoadingPrevious;
    // Hook's scrollHeight doesn't update the height information when the scroll height changes due to DOM mutations
    // Need to track this separately when loading starts
    const scrollHeightRef = (0, $5uXOq.useRef)(0);
    (0, $5uXOq.useEffect)(()=>{
        if (scrollElement && hasStartedLoadingPrevious) scrollHeightRef.current = scrollElement.scrollHeight;
    }, [
        hasStartedLoadingPrevious,
        scrollElement
    ]);
    // Ensure that the scroll is kept in place after loading previous issues - browser doesn't always handle this properly
    // Using a layout effect to make sure this happens as quickly as possible to reduce visible movement
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (scrollElement && hasFinishedLoadingPrevious) {
            const newScrollHeight = scrollElement.scrollHeight;
            if (newScrollHeight > scrollHeightRef.current) {
                const heightIncrease = newScrollHeight - scrollHeightRef.current;
                scrollElement.scrollBy(0, heightIncrease);
            }
            scrollHeightRef.current = newScrollHeight;
        }
    }, [
        hasFinishedLoadingPrevious,
        scrollElement
    ]);
    // #endregion
    // #region Loading A11y
    const prevIsLoadingNext = (0, $1XJ20.usePreviousWithInitial)(isLoadingNext);
    const hasFinishedLoadingNext = prevIsLoadingNext && !isLoadingNext;
    const loadingCompleteLiveMessage = (0, $5uXOq.useRef)(undefined);
    if (isLoadingPrevious) loadingCompleteLiveMessage.current = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $arPIt.default).loadStartA11YMessageTopIssueTermRefresh : (0, $arPIt.default).loadStartA11YMessageTop;
    else if (hasFinishedLoadingPrevious) loadingCompleteLiveMessage.current = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $arPIt.default).loadEndA11YMessageTopIssueTermRefresh : (0, $arPIt.default).loadEndA11YMessageTop;
    else if (isLoadingNext) loadingCompleteLiveMessage.current = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $arPIt.default).loadStartA11YMessageBottomIssueTermRefresh : (0, $arPIt.default).loadStartA11YMessageBottom;
    else if (hasFinishedLoadingNext) loadingCompleteLiveMessage.current = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $arPIt.default).loadEndA11YMessageBottomIssueTermRefresh : (0, $arPIt.default).loadEndA11YMessageBottom;
    // #endregion
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isLoadingPrevious && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50QiF.LoadingIndicator), {
        position: "top"
    }), isLoadingNext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50QiF.LoadingIndicator), {
        position: "bottom"
    }), loadingCompleteLiveMessage.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        role: "alert",
        "aria-live": "polite"
    }, formatMessage(loadingCompleteLiveMessage.current)));
};

});
parcelRegister("50QiF", function(module, exports) {

$parcel$export(module.exports, "LoadingIndicator", () => $143e097710c21fde$export$7c20be4c1d342248);

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $kAT4r = parcelRequire("kAT4r");
const $143e097710c21fde$export$7c20be4c1d342248 = ({ position: position })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "center",
        xcss: [
            $143e097710c21fde$var$containerStyles,
            position === 'top' ? $143e097710c21fde$var$positionTopStyles : $143e097710c21fde$var$positionBottomStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        grow: "hug",
        xcss: $143e097710c21fde$var$loadingIndicatorStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        appearance: "invert",
        size: "small",
        interactionName: (0, $4R6GH.fg)('add_nin_press_interactions') ? 'nin-detail-view-infinite-scroll-loading' : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.inverse"
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $kAT4r.default).loadingMessageIssueTermRefresh : (0, $kAT4r.default).loadingMessage))));
};
const $143e097710c21fde$var$positionTopStyles = (0, $8CUq3.xcss)({
    top: 'space.0'
});
const $143e097710c21fde$var$positionBottomStyles = (0, $8CUq3.xcss)({
    bottom: 'space.0'
});
const $143e097710c21fde$var$loadingIndicatorStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.bold',
    borderRadius: 'border.radius',
    boxShadow: 'elevation.shadow.overlay',
    color: 'color.text.inverse',
    marginBlock: 'space.200',
    padding: 'space.100'
});
const $143e097710c21fde$var$containerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    width: '100%'
});

});
parcelRegister("kAT4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $da5373b4b1dc1638$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $da5373b4b1dc1638$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadingMessage: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.loading-indicator.loading-message",
        "defaultMessage": "Loading more issues"
    },
    loadingMessageIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.loading-indicator.loading-message-issue-term-refresh",
        "defaultMessage": "Loading more work items"
    }
});

});


parcelRegister("arPIt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d111789e86749f72$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d111789e86749f72$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loadStartA11YMessageTop: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-top",
        "defaultMessage": "Loading more issues at the top of the list."
    },
    loadEndA11YMessageTop: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-top",
        "defaultMessage": "Finished loading more issues at the top of the list."
    },
    loadStartA11YMessageBottom: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-bottom",
        "defaultMessage": "Loading more issues at the bottom of the list."
    },
    loadEndA11YMessageBottom: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-bottom",
        "defaultMessage": "Finished loading more issues at the bottom of the list."
    },
    loadStartA11YMessageTopIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Loading more work items at the top of the list."
    },
    loadEndA11YMessageTopIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-top-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the top of the list."
    },
    loadStartA11YMessageBottomIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-start-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Loading more work items at the bottom of the list."
    },
    loadEndA11YMessageBottomIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-container.loading-manager.load-end-a-11-y-message-bottom-issue-term-refresh",
        "defaultMessage": "Finished loading more work items at the bottom of the list."
    }
});

});


parcelRegister("gWk5r", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ad171d10df24f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $kEVMo = parcelRequire("kEVMo");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $a5n5E = parcelRequire("a5n5E");
var $b2TJP = parcelRequire("b2TJP");

var $8oe80 = parcelRequire("8oe80");

var $6s1PB = parcelRequire("6s1PB");

var $aWse0 = parcelRequire("aWse0");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $63r1u = parcelRequire("63r1u");

var $krnTs = parcelRequire("krnTs");

var $5NdVO = parcelRequire("5NdVO");
const $8e8ad171d10df24f$export$e813e910f52c9aab = {
    appearance: 'subtle',
    'data-testid': 'issue-navigator.ui.issue-results.detail-view.card-container.order-dropdown.button'
};
const $8e8ad171d10df24f$var$customFieldIdPattern = /^cf\[\d+\]$/;
const $8e8ad171d10df24f$var$DropdownItemRadioWithAnalytics = (0, $8oe80.default)('dropdownItemRadio', {
    onClick: 'clicked'
})((0, $a5n5E.default));
class $8e8ad171d10df24f$export$50f2c227513bcdb7 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    onItemClick(order, aliases) {
        const { onChange: onChange, onBlur: onBlur } = this.props;
        onChange(order, aliases);
        onBlur();
    }
    renderItems() {
        const { intl: { formatMessage: formatMessage }, orderField: orderField } = this.props;
        return Object.values((0, $6UAdF.supportedOrderFields)).filter((0, $eJ0Zs.isNonNullish)).map(({ jqlTerm: jqlTerm, aliases: aliases })=>{
            let jqlTermForMessage = jqlTerm;
            if ([
                'issuetype'
            ].includes(jqlTermForMessage)) jqlTermForMessage = `${jqlTerm}${(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? 'IssueTermRefresh' : ''}`;
            const messageDescriptor = (0, $5NdVO.messageLookup)[jqlTermForMessage];
            const fieldName = messageDescriptor ? formatMessage(messageDescriptor) : jqlTerm;
            const props = {
                id: jqlTerm,
                onClick: ()=>{
                    this.onItemClick(jqlTerm, aliases);
                },
                isSelected: jqlTerm === orderField || orderField && aliases.includes(orderField)
            };
            return /* @ts-expect-error - Type '{ children: string; id: string; onClick: () => void; isSelected: boolean | "" | undefined; key: string; }' is not assignable to type 'Omit<{ children: ReactNode; description?: string | Element | undefined; isDisabled?: boolean | undefined; shouldTitleWrap?: boolean | undefined; shouldDescriptionWrap?: boolean | undefined; ... 5 more ...; testId?: string | undefined; }, keyof WithAnalyticsEventsProps>'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e8ad171d10df24f$var$DropdownItemRadioWithAnalytics, {
                key: jqlTerm,
                ...props
            }, fieldName);
        });
    }
    render() {
        const { intl: { formatMessage: formatMessage }, orderField: orderField, isOpen: isOpen, className: className } = this.props;
        let fallbackMessage = '';
        let fieldName = '';
        if (typeof orderField === 'string') {
            const isCustomFieldId = $8e8ad171d10df24f$var$customFieldIdPattern.test(orderField);
            const expectedOrderField = (0, $6UAdF.supportedOrderFields)[(0, $6UAdF.getSupportedFieldForAlias)(orderField) ?? orderField];
            const fallbackMessageDescriptor = expectedOrderField ? (0, $5NdVO.messageLookup)[expectedOrderField.jqlTerm] : null;
            if (isCustomFieldId) fallbackMessage = formatMessage((0, $5NdVO.default).customField);
            else if (expectedOrderField && fallbackMessageDescriptor) fallbackMessage = formatMessage(fallbackMessageDescriptor);
            else fieldName = orderField;
        } else fallbackMessage = formatMessage((0, $5NdVO.default).defaultLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e8ad171d10df24f$var$StyledContainer // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: className
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
            isOpen: isOpen,
            onOpenChange: this.onOpenChange,
            testId: "issue-navigator.ui.issue-results.detail-view.card-container.order-dropdown",
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e8ad171d10df24f$var$StyledButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    ...props,
                    appearance: "subtle",
                    ref: triggerRef,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                        label: formatMessage((0, $5NdVO.default).defaultLabel),
                        size: "small"
                    })
                }, fieldName || fallbackMessage)),
            shouldFlip: true,
            placement: "bottom-start",
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e8ad171d10df24f$var$StyledDropdownMenuContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b2TJP.default), {
            id: "sort-field-group",
            title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5NdVO.default).fieldGroupIssueTermRefresh : (0, $5NdVO.default).fieldGroup)
        }, this.renderItems()))));
    }
    constructor(...args){
        super(...args), this.onOpenChange = ({ isOpen: isOpen } = {
            isOpen: false
        })=>{
            if (isOpen) this.props.onFocus();
            else this.props.onBlur();
        };
    }
}
const $8e8ad171d10df24f$export$f6d8103ec9453c7f = ()=>{
    const [{ isOpen: isOpen }, { open: open, close: close }] = (0, $63r1u.useOrderByOpenState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const intl = (0, $aWse0.useIntlV2)();
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $krnTs.useSortFieldAndDirection)();
    const handleOnChange = (0, $5uXOq.useCallback)((orderField, aliases)=>{
        setFieldAndDirection(orderField, direction, aliases);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItemRadio'
        });
        const { fieldType: fieldType = null } = (0, $6UAdF.supportedOrderFields)[(0, $6UAdF.getSupportedFieldForAlias)(orderField) ?? orderField] ?? {};
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sortFieldDropdownItemRadio', {
            fieldType: fieldType,
            order: direction
        });
    }, [
        createAnalyticsEvent,
        direction,
        setFieldAndDirection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8e8ad171d10df24f$export$50f2c227513bcdb7, {
        orderField: field,
        onChange: handleOnChange,
        isOpen: isOpen,
        onFocus: open,
        onBlur: close,
        intl: intl
    });
};
var $8e8ad171d10df24f$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
 = $8e8ad171d10df24f$export$f6d8103ec9453c7f;
const $8e8ad171d10df24f$var$StyledButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1s3g12gs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8ad171d10df24f$var$StyledDropdownMenuContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3inklw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8e8ad171d10df24f$var$StyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("63r1u", function(module, exports) {

$parcel$export(module.exports, "useOrderByOpenState", () => $eaf17a9c035669f9$export$32869ae0582ab3ff);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $eaf17a9c035669f9$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'IssueNavigatorOrderByOpenState'
});
const $eaf17a9c035669f9$export$2ba8216bf1290828 = (0, $51nlc.createSubscriber)($eaf17a9c035669f9$var$Store);
const $eaf17a9c035669f9$export$32869ae0582ab3ff = (0, $3sQ5x.createHook)($eaf17a9c035669f9$var$Store);

});

parcelRegister("5NdVO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d30701c7e9a99b3c$export$2e2bcd8739ae039);
$parcel$export(module.exports, "messageLookup", () => $d30701c7e9a99b3c$export$3a16bd55b6aaaf91);

var $7VHMR = parcelRequire("7VHMR");
const $d30701c7e9a99b3c$var$messages = (0, $7VHMR.defineMessages)({
    loading: {
        "id": "issue-navigator.card-container.order-dropdown.loading",
        "defaultMessage": "Loading"
    },
    fieldGroup: {
        "id": "issue-navigator.card-container.order-dropdown.field-group",
        "defaultMessage": "Order issues by"
    },
    created: {
        "id": "issue-navigator.card-container.order-dropdown.created",
        "defaultMessage": "Created"
    },
    updated: {
        "id": "issue-navigator.card-container.order-dropdown.updated",
        "defaultMessage": "Updated"
    },
    lastviewed: {
        "id": "issue-navigator.card-container.order-dropdown.lastviewed",
        "defaultMessage": "Last viewed"
    },
    status: {
        "id": "issue-navigator.card-container.order-dropdown.status",
        "defaultMessage": "Status"
    },
    priority: {
        "id": "issue-navigator.card-container.order-dropdown.priority",
        "defaultMessage": "Priority"
    },
    assignee: {
        "id": "issue-navigator.card-container.order-dropdown.assignee",
        "defaultMessage": "Assignee"
    },
    resolved: {
        "id": "issue-navigator.card-container.order-dropdown.resolved",
        "defaultMessage": "Resolved"
    },
    issuekey: {
        "id": "issue-navigator.card-container.order-dropdown.issuekey",
        "defaultMessage": "Key"
    },
    key: {
        "id": "issue-navigator.card-container.order-dropdown.key",
        "defaultMessage": "Key"
    },
    issuetype: {
        "id": "issue-navigator.card-container.order-dropdown.issuetype",
        "defaultMessage": "Issue Type"
    },
    duedate: {
        "id": "issue-navigator.card-container.order-dropdown.duedate",
        "defaultMessage": "Due date"
    },
    summary: {
        "id": "issue-navigator.card-container.order-dropdown.summary",
        "defaultMessage": "Summary"
    },
    reporter: {
        "id": "issue-navigator.card-container.order-dropdown.reporter",
        "defaultMessage": "Reporter"
    },
    customField: {
        "id": "issue-navigator.card-container.order-dropdown.custom-field",
        "defaultMessage": "Custom field"
    },
    defaultLabel: {
        "id": "issue-navigator.card-container.order-dropdown.default-label",
        "defaultMessage": "Order by"
    },
    fieldGroupIssueTermRefresh: {
        "id": "issue-navigator.card-container.order-dropdown.field-group-issue-term-refresh",
        "defaultMessage": "Order work items by"
    },
    issuetypeIssueTermRefresh: {
        "id": "issue-navigator.card-container.order-dropdown.issuetype-issue-term-refresh",
        "defaultMessage": "Work type"
    }
});
var $d30701c7e9a99b3c$export$2e2bcd8739ae039 = $d30701c7e9a99b3c$var$messages;
const $d30701c7e9a99b3c$export$3a16bd55b6aaaf91 = $d30701c7e9a99b3c$var$messages;

});


parcelRegister("kwVxA", function(module, exports) {

$parcel$export(module.exports, "default", () => $824c7ec1b60577e2$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $42CjB = parcelRequire("42CjB");

var $5LWLA = parcelRequire("5LWLA");

var $jpYlM = parcelRequire("jpYlM");

var $enBAU = parcelRequire("enBAU");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $6UAdF = parcelRequire("6UAdF");

var $krnTs = parcelRequire("krnTs");

var $cKBXV = parcelRequire("cKBXV");

var $5ngER = parcelRequire("5ngER");

var $lJCod = parcelRequire("lJCod");
class $824c7ec1b60577e2$export$e464399b18ba2124 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onSort: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    shouldComponentUpdate(nextProps) {
        return this.props.sortDirection !== nextProps.sortDirection || this.props.isDisabled !== nextProps.isDisabled;
    }
    render() {
        const { intl: { formatMessage: formatMessage }, sortDirection: sortDirection, isDisabled: isDisabled } = this.props;
        const tooltipText = sortDirection === (0, $6UAdF.sortDirections).ASC ? formatMessage((0, $lJCod.default).tooltipAsc) : formatMessage((0, $lJCod.default).tooltipDesc);
        const glyph = sortDirection === (0, $6UAdF.sortDirections).ASC ? (0, $5ngER.ArrowUpIcon) : (0, $cKBXV.ArrowDownIcon);
        const SortIcon = sortDirection === (0, $6UAdF.sortDirections).ASC ? (0, (/*@__PURE__*/$parcel$interopDefault($jpYlM))) : (0, (/*@__PURE__*/$parcel$interopDefault($enBAU)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: tooltipText
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            appearance: "subtle",
            onClick: this.onClick,
            testId: "issue-navigator.ui.issue-results.detail-view.card-container.sort-button.sort-button",
            isDisabled: isDisabled,
            icon: (props)=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SortIcon, {
                    ...props,
                    color: "currentColor"
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
                    ...props,
                    size: "small",
                    glyph: glyph
                }),
            label: tooltipText
        }));
    }
    constructor(...args){
        super(...args), this.onClick = ()=>{
            const { onSort: onSort, sortDirection: sortDirection } = this.props;
            const newSortDirection = sortDirection === (0, $6UAdF.sortDirections).ASC ? (0, $6UAdF.sortDirections).DESC : (0, $6UAdF.sortDirections).ASC;
            onSort(newSortDirection);
        };
    }
}
const $824c7ec1b60577e2$export$86b24d49f595c6f2 = (props)=>{
    const intl = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $krnTs.useSortFieldAndDirection)();
    const handleOnSort = (0, $5uXOq.useCallback)((newSortDirection)=>{
        typeof field === 'string' && setFieldAndDirection(field, newSortDirection, []);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const orderField = field ? (0, $6UAdF.supportedOrderFields)[(0, $6UAdF.getSupportedFieldForAlias)(field) ?? field] : undefined;
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sortOrderChangeButton', {
            fieldType: orderField?.fieldType ?? null,
            sortOrder: newSortDirection
        });
        return true;
    }, [
        createAnalyticsEvent,
        field,
        setFieldAndDirection
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($824c7ec1b60577e2$export$e464399b18ba2124, {
        isDisabled: typeof field !== 'string',
        sortDirection: direction,
        onSort: handleOnSort,
        ...props,
        intl: intl
    });
};
var $824c7ec1b60577e2$export$2e2bcd8739ae039 = $824c7ec1b60577e2$export$86b24d49f595c6f2;

});
parcelRegister("jpYlM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1533407203f003b100b6bc9fc1cca1a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e22f2a6ad3c1f502$var$_react = $e22f2a6ad3c1f502$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e22f2a6ad3c1f502$var$_baseNew = $e22f2a6ad3c1f502$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e22f2a6ad3c1f502$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortAscending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e22f2a6ad3c1f502$var$SortAscendingIcon = (props)=>/*#__PURE__*/ $e22f2a6ad3c1f502$var$_react.default.createElement($e22f2a6ad3c1f502$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 12.5H1V14h14zm-1.75-3.75V3.56l1.72 1.72 1.06-1.06-3-3a.75.75 0 0 0-1.06 0l-3 3 1.06 1.06 1.72-1.72v5.19zM8 7.25H1v1.5h7zM6 2H1v1.5h5z" clip-rule="evenodd"/>`
    }, props));
$e22f2a6ad3c1f502$var$SortAscendingIcon.displayName = 'SortAscendingIcon';
var $e22f2a6ad3c1f502$var$_default = module.exports.default = $e22f2a6ad3c1f502$var$SortAscendingIcon;

});

parcelRegister("enBAU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2611905fa87d707c1d555c941da4c1d2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a780601c67e57879$var$_react = $a780601c67e57879$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a780601c67e57879$var$_baseNew = $a780601c67e57879$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a780601c67e57879$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "SortDescending".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sorting data.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a780601c67e57879$var$SortDescendingIcon = (props)=>/*#__PURE__*/ $a780601c67e57879$var$_react.default.createElement($a780601c67e57879$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-1.75 3.75v5.19l1.72-1.72 1.06 1.06-3 3a.75.75 0 0 1-1.06 0l-3-3 1.06-1.06 1.72 1.72V7.25zM8 8.75H1v-1.5h7zM6 14H1v-1.5h5z" clip-rule="evenodd"/>`
    }, props));
$a780601c67e57879$var$SortDescendingIcon.displayName = 'SortDescendingIcon';
var $a780601c67e57879$var$_default = module.exports.default = $a780601c67e57879$var$SortDescendingIcon;

});

parcelRegister("cKBXV", function(module, exports) {

$parcel$export(module.exports, "ArrowDownIcon", () => $a0c24d18d28d22b1$export$1c939d3c9b6931b);

var $5uXOq = parcelRequire("5uXOq");
const $a0c24d18d28d22b1$export$1c939d3c9b6931b = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.8,4.3 C6.6,4.1 6.3,4 6,4 C5.7,4 5.4,4.1 5.2,4.3 L2.3,7.2 C1.9,7.6 1.9,8.3 2.3,8.7 C2.7,9.1 3.3,9.1 3.7,8.7 L5,7.4 L5,19.1 C5,19.6 5.4,20 6,20 C6.6,20 7,19.6 7,19.1 L7,7.4 L8.3,8.7 C8.7,9.1 9.3,9.1 9.7,8.7 C10.1,8.3 10.1,7.6 9.7,7.2 C9.04754611,6.54754611 8.5582057,6.0582057 8.23197876,5.73197876 C7.91376126,5.41376126 7.436435,4.936435 6.8,4.3 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero",
        transform: "translate(6.000000, 12.000000) rotate(180.000000) translate(-6.000000, -12.000000) "
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M21,5 L13,5 C12.4,5 12,5.4 12,6 C12,6.6 12.4,7 13,7 L21,7 C21.6,7 22,6.6 22,6 C22,5.4 21.6,5 21,5 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13,13 L18,13 C18.6,13 19,12.6 19,12 C19,11.4 18.6,11 18,11 L13,11 C12.4,11 12,11.4 12,12 C12,12.6 12.4,13 13,13 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13,19 L16,19 C16.6,19 17,18.6 17,18 C17,17.4 16.6,17 16,17 L13,17 C12.4,17 12,17.4 12,18 C12,18.6 12.4,19 13,19 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    })));

});

parcelRegister("5ngER", function(module, exports) {

$parcel$export(module.exports, "ArrowUpIcon", () => $8b9dee4ad337223b$export$f1a507b991affc46);

var $5uXOq = parcelRequire("5uXOq");
const $8b9dee4ad337223b$export$f1a507b991affc46 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.8,4.3 C7.6,4.1 7.3,4 7,4 C6.7,4 6.4,4.1 6.2,4.3 L3.3,7.2 C2.9,7.6 2.9,8.3 3.3,8.7 C3.7,9.1 4.3,9.1 4.7,8.7 L6,7.4 L6,19.1 C6,19.6 6.4,20 7,20 C7.6,20 8,19.6 8,19.1 L8,7.4 L9.3,8.7 C9.7,9.1 10.3,9.1 10.7,8.7 C11.1,8.3 11.1,7.6 10.7,7.2 C10.0475461,6.54754611 9.5582057,6.0582057 9.23197876,5.73197876 C8.91376126,5.41376126 8.436435,4.936435 7.8,4.3 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M21,17 L13,17 C12.4,17 12,17.4 12,18 C12,18.6 12.4,19 13,19 L21,19 C21.6,19 22,18.6 22,18 C22,17.4 21.6,17 21,17 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13,13 L18,13 C18.6,13 19,12.6 19,12 C19,11.4 18.6,11 18,11 L13,11 C12.4,11 12,11.4 12,12 C12,12.6 12.4,13 13,13 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13,7 L16,7 C16.6,7 17,6.6 17,6 C17,5.4 16.6,5 16,5 L13,5 C12.4,5 12,5.4 12,6 C12,6.6 12.4,7 13,7 Z",
        id: "Path",
        fill: "currentColor",
        fillRule: "nonzero"
    })));

});

parcelRegister("lJCod", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed0328825ac5e155$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ed0328825ac5e155$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltipAsc: {
        "id": "issue-navigator.card-container.sort-button.tooltip-asc",
        "defaultMessage": "Sort ascending"
    },
    tooltipDesc: {
        "id": "issue-navigator.card-container.sort-button.tooltip-desc",
        "defaultMessage": "Sort descending"
    }
});

});



parcelRegister("428r9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f84771d642bef682$export$2e2bcd8739ae039);

var $xFU5V = parcelRequire("xFU5V");

var $fAUMk = parcelRequire("fAUMk");

var $iu474 = parcelRequire("iu474");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $a8lIB = parcelRequire("a8lIB");

var $7OTah = parcelRequire("7OTah");

var $bUpV8 = parcelRequire("bUpV8");

var $74FKa = parcelRequire("74FKa");

var $ly5B7 = parcelRequire("ly5B7");

var $1ocSs = parcelRequire("1ocSs");

var $4f2Gl = parcelRequire("4f2Gl");

var $2UJgO = parcelRequire("2UJgO");
const $f84771d642bef682$var$BLANK_CARD_ANALYTICS_ID = 'blankIssueCard';
const $f84771d642bef682$var$ISSUE_CARD_ANALYTICS_ID = 'issueCard';
const $f84771d642bef682$var$CardWithSelectedIssue = ({ issue: issue, fieldSets: fieldSets, isFocused: isFocused, onFocus: onFocus, onBlur: onBlur })=>{
    const issueData = (0, $8Uumt.useFragment)((0, $iu474.default), issue);
    const fieldSetsData = (0, $8Uumt.useFragment)((0, $fAUMk.default), fieldSets);
    const { key: key } = issueData;
    const isSelected = (0, $7OTah.useIsSelectedIssue)(key);
    const { setSelectedIssueByKey: setSelectedIssueByKey } = (0, $7OTah.useSelectedIssueActions)();
    const onCardFocus = (0, $5uXOq.useCallback)(()=>{
        onFocus(key);
        setSelectedIssueByKey(key, {
            shouldDebounce: true
        });
    }, [
        key,
        onFocus,
        setSelectedIssueByKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f84771d642bef682$var$CardWithAnalytics, {
        issue: issueData,
        fieldSets: fieldSetsData ?? null,
        isFocused: isFocused,
        isSelected: isSelected,
        onFocus: onCardFocus,
        onBlur: onBlur
    });
};
const $f84771d642bef682$var$CardWithAnalytics = ({ isFocused: isFocused, isSelected: isSelected, issue: issue, fieldSets: fieldSets, onFocus: onFocus, onBlur: onBlur })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cardRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (isSelected) {
            // Scroll to the card whenever it is selected and focus on it
            cardRef.current?.scrollIntoView && cardRef.current?.scrollIntoView({
                block: 'nearest'
            });
            isFocused && cardRef.current?.focus();
        }
    }, [
        isSelected,
        isFocused
    ]);
    const onClickWithAnalytics = (0, $5uXOq.useCallback)((event)=>{
        const id = issue ? $f84771d642bef682$var$ISSUE_CARD_ANALYTICS_ID : $f84771d642bef682$var$BLANK_CARD_ANALYTICS_ID;
        const attributes = {
            keyboardShortcut: false
        };
        if ((0, $eJ0Zs.isNormalClick)(event)) {
            event.preventDefault();
            const analyticsEvent = createAnalyticsEvent({
                action: 'selected',
                actionSubject: 'card'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, id, attributes);
        } else {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'card'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, id, attributes);
        }
    }, [
        createAnalyticsEvent,
        issue
    ]);
    const onContextMenuHandler = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'contextMenu clicked',
            actionSubject: 'card'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, $f84771d642bef682$var$ISSUE_CARD_ANALYTICS_ID, {
            keyboardShortcut: false
        });
    }, [
        createAnalyticsEvent
    ]);
    return issue == null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ly5B7.default), {
        ref: cardRef,
        isSelected: isSelected,
        onClick: onClickWithAnalytics,
        onFocus: onFocus
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ocSs.default), {
        ref: cardRef,
        issue: issue,
        fieldSets: fieldSets,
        onClick: onClickWithAnalytics,
        onFocus: onFocus,
        onBlur: onBlur,
        isSelected: isSelected,
        onContextMenu: onContextMenuHandler
    });
};
const $f84771d642bef682$export$4683131014ccb7f3 = ()=>(0, $5uXOq.useState)(null);
const $f84771d642bef682$var$CardList = ({ fragment: fragment, loading: loading, onNavigateToIssue: onNavigateToIssue, listRef: listRef })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_START); // Analytics
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)(); // Main
    const [focusedIssueKey, setFocusedIssueKey] = $f84771d642bef682$export$4683131014ccb7f3();
    const maxIssuesPerPage = (0, $6UAdF.getMaxIssuesPerPage)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_DETAIL_VIEW_CARD_LIST_END);
    }, []);
    const fragmentData = (0, $8Uumt.useFragment)((0, $xFU5V.default), fragment);
    const onIssueChangeEvent = (0, $5uXOq.useCallback)((issueKey)=>{
        if (issueKey) setFocusedIssueKey(issueKey);
        const id = issueKey ? $f84771d642bef682$var$ISSUE_CARD_ANALYTICS_ID : $f84771d642bef682$var$BLANK_CARD_ANALYTICS_ID;
        const analyticsEvent = createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'card'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, id, {
            keyboardShortcut: true
        });
    }, [
        createAnalyticsEvent,
        setFocusedIssueKey
    ]);
    const cards = (0, $5uXOq.useMemo)(()=>fragmentData?.edges?.map((edge)=>edge?.node && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f84771d642bef682$var$CardWithSelectedIssue, {
                key: edge.node.key,
                isFocused: edge.node.key === focusedIssueKey,
                issue: edge.node,
                fieldSets: edge.fieldSets ?? null,
                onFocus: setFocusedIssueKey,
                onBlur: ()=>setFocusedIssueKey(null)
            })) ?? [], [
        fragmentData?.edges,
        focusedIssueKey,
        setFocusedIssueKey
    ]);
    const focusedIssue = (0, $5uXOq.useMemo)(()=>{
        if ((0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return fragmentData?.edges?.find((edge)=>edge?.node?.key === focusedIssueKey)?.node ?? null;
        return null;
    }, [
        focusedIssueKey,
        fragmentData?.edges
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f84771d642bef682$export$22a81bdd3a723b46, {
        "aria-label": formatMessage((0, $2UJgO.default).issues)
    }, [
        ...Array(maxIssuesPerPage)
    ].map((__, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $74FKa.default), {
            key: index,
            issueIndex: index
        })));
    if (cards.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUpV8.default), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4f2Gl.default), {
        focusedIssueKey: focusedIssueKey,
        onIssueChangeEvent: onIssueChangeEvent,
        onNavigateToIssue: onNavigateToIssue,
        disableListControls: loading,
        focusedIssue: focusedIssue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f84771d642bef682$export$22a81bdd3a723b46, {
        ref: listRef,
        "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2UJgO.default).issuesIssueTermRefresh : (0, $2UJgO.default).issues)
    }, cards));
};
var $f84771d642bef682$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $f84771d642bef682$var$CardList;
const $f84771d642bef682$export$22a81bdd3a723b46 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_qtt8glyw _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("xFU5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef209f17a9c7453f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<91a26a6ac2094feef90cf1527c78a5ec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $ef209f17a9c7453f$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardList_fragment",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_Card_issue"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_CardWithSelectedIssue_issue"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": "keyboardShortcuts_issueNavigator"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 500
                        }
                    ],
                    "concreteType": "JiraIssueFieldSetConnection",
                    "kind": "LinkedField",
                    "name": "fieldSets",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_Card_fieldSets"
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "main_issueNavigator_CardWithSelectedIssue_fieldSets"
                        }
                    ],
                    "storageKey": "fieldSets(first:500)"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$ef209f17a9c7453f$var$node.hash = "c325676a12fa6072040143369b5cb3e8";
var $ef209f17a9c7453f$export$2e2bcd8739ae039 = $ef209f17a9c7453f$var$node;

});

parcelRegister("fAUMk", function(module, exports) {

$parcel$export(module.exports, "default", () => $14475bc489a27f22$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<624714bc7d64cade4aaede35e606ffae>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $14475bc489a27f22$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardWithSelectedIssue_fieldSets",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Card_fieldSets"
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$14475bc489a27f22$var$node.hash = "5d80b931b560f2c418fca0d9f032c9a0";
var $14475bc489a27f22$export$2e2bcd8739ae039 = $14475bc489a27f22$var$node;

});

parcelRegister("iu474", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3fbd4a51bc8d266$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ef67c1b29917e04b29ae418c9bcc3e9d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b3fbd4a51bc8d266$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_CardWithSelectedIssue_issue",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_Card_issue"
        }
    ],
    "type": "JiraIssue"
};
$b3fbd4a51bc8d266$var$node.hash = "8eb4cdf2fd848d8fc193cb41d7f7d67f";
var $b3fbd4a51bc8d266$export$2e2bcd8739ae039 = $b3fbd4a51bc8d266$var$node;

});

parcelRegister("bUpV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b23b0330efbf510$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4wcJR = parcelRequire("4wcJR");
const $7b23b0330efbf510$export$36d139f95680ab4e = ()=>// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7b23b0330efbf510$var$StyledContainer, {
        "data-testid": "issue-navigator.issue-results.detail-view.card-list.card-empty-list"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4wcJR.default), null));
var $7b23b0330efbf510$export$2e2bcd8739ae039 = $7b23b0330efbf510$export$36d139f95680ab4e;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b23b0330efbf510$var$StyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _4t3i1osq _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4wcJR", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b8e75c7cc60728f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $kjIEI = parcelRequire("kjIEI");

var $c7i3D = parcelRequire("c7i3D");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $beQyQ = parcelRequire("beQyQ");
const $5b8e75c7cc60728f$export$f3f2e7ed2b6256b1 = ({ intl: { formatMessage: formatMessage } })=>{
    const noIssues = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $beQyQ.default).noIssuesIssueTermRefresh : (0, $beQyQ.default).noIssues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5b8e75c7cc60728f$var$ImageWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c7i3D.default), {
        alt: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5b8e75c7cc60728f$var$ImageWrapperStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjIEI.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, noIssues));
};
var /* eslint-disable-next-line jira/js/no-inject-intl-if-functional-component */ $5b8e75c7cc60728f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($5b8e75c7cc60728f$export$f3f2e7ed2b6256b1);
const $5b8e75c7cc60728f$var$ImageWrapperStylesOld = (0, $8CUq3.xcss)({
    height: '146px',
    width: '160px'
});
const $5b8e75c7cc60728f$var$ImageWrapperStyles = (0, $8CUq3.xcss)({
    height: '165px',
    width: '150px'
});

});
parcelRegister("beQyQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba07fcf1bf5ac48f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ba07fcf1bf5ac48f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noIssues: {
        "id": "issue-navigator.common.empty-list-icon.no-issues",
        "defaultMessage": "No issues were found matching your search"
    },
    noIssuesIssueTermRefresh: {
        "id": "issue-navigator.common.empty-list-icon.no-issues-issue-term-refresh",
        "defaultMessage": "There's nothing matching your search"
    }
});

});



parcelRegister("74FKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $349ff8ff8da44cac$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dD7Zc = parcelRequire("dD7Zc");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $5xVPG = parcelRequire("5xVPG");

var $jXcGy = parcelRequire("jXcGy");

var $4IWp9 = parcelRequire("4IWp9");

var $2fvFU = parcelRequire("2fvFU");
const $349ff8ff8da44cac$var$shimmer = null;
// eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$SkeletonBackground = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasError: hasError, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_5sag126j _1o51q7pw _j7hq1en8 _1pglp3kn _bfhkh3tw _1itkwp5g _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.hasError ? "_tip8idpf" : "_tip812c5",
            __cmplp.className
        ])
    });
});
const $349ff8ff8da44cac$var$defaultIssueCardHeight = 97; // eslint-disable-next-line jira/styled/styled-component-order, @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$SkeletonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1rbs _1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $349ff8ff8da44cac$var$IssueCardSkeleton = ({ hasError: hasError = false, issueIndex: issueIndex })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        xcss: (0, $dCm1o.isVisualRefreshEnabled)() ? $349ff8ff8da44cac$var$ListItemStyle : $349ff8ff8da44cac$var$ListItemStyleOld,
        "aria-label": formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4IWp9.default).issueLoadingLabelIssueTermRefresh : (0, $4IWp9.default).issueLoadingLabel, {
            number: issueIndex
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$CardContainer, {
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$SkeletonBackground, {
        hasError: hasError,
        "data-component-selector": (0, $2fvFU.skeletonBackgroundSelector)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$ColumnMask, {
        "data-component-selector": (0, $2fvFU.columnMaskSelector)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$SummaryMask, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$TextLineMask, {
        fontSize: 20,
        lineHeight: 24,
        intrusion: 20
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$TextLineMask, {
        fontSize: 20,
        lineHeight: 24,
        intrusion: 60
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$FooterMask, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$TypeMask, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$SeparatorMask, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$IssueKeyMask, null), hasError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$ErrorIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)",
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$BlankMask, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($349ff8ff8da44cac$var$ErrorWrapper, {
        "data-component-selector": (0, $2fvFU.errorWrapperSelector)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jXcGy.default), null)))));
};
var $349ff8ff8da44cac$export$2e2bcd8739ae039 = $349ff8ff8da44cac$var$IssueCardSkeleton;
const $349ff8ff8da44cac$var$ListItemStyleOld = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.0'
});
const $349ff8ff8da44cac$var$ListItemStyle = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.0',
    marginBlockEnd: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$CardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $5xVPG.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$ErrorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cglyw _1bsb1osq _4cvr1h6o _18u0u2gc _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$ErrorIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkvuon _16jlkb7n _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$BlankMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _bfhkvuon _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$SeparatorMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbftgi _bfhkvuon",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $349ff8ff8da44cac$var$IssueKeyMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4t3i1tcg _1bsb16xz",
            __cmplp.className
        ])
    });
});
const $349ff8ff8da44cac$var$TypeMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4t3i1tcg _1bsb1tcg _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $349ff8ff8da44cac$var$TextLineMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { intrusion: intrusion, lineHeight: lineHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rjhebn": (0, $lD23V.default)(__cmplp.fontSize, "px"),
            "--_1oqupad": (0, $lD23V.default)(__cmplp.intrusion, "px"),
            "--_c633pi": (0, $lD23V.default)((__cmplp.lineHeight - __cmplp.fontSize) / 2, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1s7z87mc _x3do1cy7 _n7zl1cy7 _kqswh2mm _4t3i3gti",
            __cmplp.className
        ])
    });
});
const $349ff8ff8da44cac$var$FooterMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zlv4vr _x3do16sd _1e0c1txw _2lx2vrvc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $349ff8ff8da44cac$var$SummaryMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zl15mc",
            __cmplp.className
        ])
    });
});
const $349ff8ff8da44cac$var$ColumnMask = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kl715mc _1s7z15mc _kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5xVPG", function(module, exports) {

$parcel$export(module.exports, "CardBaseStyle", () => $489d3a2e61cd5aa2$export$d10d52f6c0613cc3);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $jQtKF = parcelRequire("jQtKF");
const $489d3a2e61cd5aa2$var$backgroundColorSelected = "var(--ds-background-selected, #E9F2FF)";
const $489d3a2e61cd5aa2$var$backgroundColor = "var(--ds-surface-raised, #FFFFFF)";
const $489d3a2e61cd5aa2$var$borderColor = "var(--ds-border, #091E4224)";
const $489d3a2e61cd5aa2$var$boxShadowColor = `1px 0px ${"var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"}`;
const $489d3a2e61cd5aa2$export$d10d52f6c0613cc3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1vy64tb": (0, $lD23V.default)(__cmplp.isSelected ? "var(--ds-background-accent-blue-subtlest, #E9F2FF)" : "var(--ds-surface-raised, #FFFFFF)"),
            "--_11cvo1a": (0, $lD23V.default)(__cmplp.isSelected ? $489d3a2e61cd5aa2$var$backgroundColorSelected : $489d3a2e61cd5aa2$var$backgroundColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1yt4u2gc _1e0c1ule _vchhusvi _1a3b18uv _4fprglyw _5goinqa1 _nt751r31 _49pcglyw _1hvw1o36 _7ehiytyo _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.visualRefresh ? "_2rkoiti9 _18s8v77o _1yt4utpp _16qszucj _bfhk1sss" : "_x3doidpf _n7zlzgxb _1kl7zgxb _bfhk2rqg _1jc11j8p _14t0zgxb _e6md1se7 _13jwelmp _1tzh1y44",
            __cmplp.className
        ])
    });
});
const $489d3a2e61cd5aa2$export$b15a6cf2987e4b39 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $jQtKF.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jXcGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1838c9b738176ad$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $6s1PB = parcelRequire("6s1PB");

var $az4zD = parcelRequire("az4zD");

var $7Csvc = parcelRequire("7Csvc");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-empty-styled-expression
const $b1838c9b738176ad$var$InfoMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.className
        ])
    });
});
const $b1838c9b738176ad$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1kw7 _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
class $b1838c9b738176ad$export$e8132eb38e030ec6 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onResetErrors: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1838c9b738176ad$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1838c9b738176ad$var$InfoMessage, null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7Csvc.default).infoTextIssueTermRefresh : (0, $7Csvc.default).infoText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "link",
            onClick: this.onReloadIssueClick,
            spacing: "none"
        }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7Csvc.default).reloadIssueIssueTermRefresh : (0, $7Csvc.default).reloadIssue)));
    }
    constructor(...args){
        super(...args), // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onReloadIssueClick = (...attrs)=>{
            const analyticsEvent = attrs.pop();
            this.props.onResetErrors(analyticsEvent);
        };
    }
}
var $b1838c9b738176ad$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($b1838c9b738176ad$export$e8132eb38e030ec6);

});
parcelRegister("7Csvc", function(module, exports) {

$parcel$export(module.exports, "default", () => $18a133c57e2faa08$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $18a133c57e2faa08$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    infoText: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.info-text",
        "defaultMessage": "We couldn't load this issue."
    },
    reloadIssue: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.reload-issue",
        "defaultMessage": "Reload issue"
    },
    infoTextIssueTermRefresh: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.info-text-issue-term-refresh",
        "defaultMessage": "We couldn't load this work item."
    },
    reloadIssueIssueTermRefresh: {
        "id": "issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.reload-issue-issue-term-refresh",
        "defaultMessage": "Reload work item"
    }
});

});


parcelRegister("4IWp9", function(module, exports) {

$parcel$export(module.exports, "default", () => $078c5bf6273acc7a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $078c5bf6273acc7a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueLoadingLabel: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card-skeleton.issue-loading-label",
        "defaultMessage": "Issue card {number} loading"
    },
    issueLoadingLabelIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card-skeleton.issue-loading-label-issue-term-refresh",
        "defaultMessage": "Work item card {number} loading"
    }
});

});

parcelRegister("2fvFU", function(module, exports) {

$parcel$export(module.exports, "errorWrapperSelector", () => $3769c2df00d1a140$export$a03455d77d6a4ea);
$parcel$export(module.exports, "skeletonBackgroundSelector", () => $3769c2df00d1a140$export$85fe8f1edff78b98);
$parcel$export(module.exports, "columnMaskSelector", () => $3769c2df00d1a140$export$67b279fb398d016e);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
const $3769c2df00d1a140$var$defaultIssueCardHeight = 97;
const $3769c2df00d1a140$export$66b8cea0c448285 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1rbs _1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$var$shimmer = null;
const $3769c2df00d1a140$export$c3b0ebed856b8b1a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasError: hasError, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_5sag126j _1o51q7pw _j7hq1en8 _1pglp3kn _bfhkh3tw _1itkwp5g _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.hasError ? "_tip8idpf" : "_tip812c5",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$439b7c87164a9b43 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kl715mc _1s7z15mc _kqswh2mm _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$792e72b41c80f830 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zl15mc",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$ab3fe3ddc5c7354f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_n7zlv4vr _x3do16sd _1e0c1txw _2lx2vrvc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$f3e0fd2d5209f88b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { intrusion: intrusion, lineHeight: lineHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_rjhebn": (0, $lD23V.default)(__cmplp.fontSize, "px"),
            "--_1oqupad": (0, $lD23V.default)(__cmplp.intrusion, "px"),
            "--_c633pi": (0, $lD23V.default)((__cmplp.lineHeight - __cmplp.fontSize) / 2, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1s7z87mc _x3do1cy7 _n7zl1cy7 _kqswh2mm _4t3i3gti",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$59d16c2cd3bc3a2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4t3i1tcg _1bsb1tcg _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$ca1c048394ed3dbb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4t3i1tcg _1bsb16xz",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$bdc7d72765b181c3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbftgi _bfhkvuon",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$a1b9063b4cbc0844 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _bfhkvuon _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$90993d2d9550d725 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhkvuon _16jlkb7n _1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$bb27b7e39840238f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cglyw _1bsb1osq _4cvr1h6o _18u0u2gc _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $3769c2df00d1a140$export$a03455d77d6a4ea = 'jira-issue-navigator-card-skeleton-error-wrapper';
const $3769c2df00d1a140$export$85fe8f1edff78b98 = 'jira-issue-navigator-card-skeleton-skeleton-background';
const $3769c2df00d1a140$export$67b279fb398d016e = 'jira-issue-navigator-card-skeleton-column-mask';

});


parcelRegister("ly5B7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8caaf0a251343b7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $dCm1o = parcelRequire("dCm1o");

var $5xVPG = parcelRequire("5xVPG");

var $iwwo9 = parcelRequire("iwwo9");
const $f8caaf0a251343b7$var$EmptyCard = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isSelected: isSelected = false, onClick: onClick, onFocus: onFocus }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "li",
        xcss: $f8caaf0a251343b7$var$ListItemStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f8caaf0a251343b7$var$EmptyCardContainer, {
        tabIndex: isSelected ? 0 : -1,
        ref: ref ?? undefined,
        isSelected: isSelected,
        onClick: onClick,
        href: "#",
        onFocus: onFocus,
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iwwo9.default).emptyCardTextIssueTermRefresh : (0, $iwwo9.default).emptyCardText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "blankIssue"
    })));
});
var $f8caaf0a251343b7$export$2e2bcd8739ae039 = $f8caaf0a251343b7$var$EmptyCard;
const $f8caaf0a251343b7$var$textColorActiveState = "var(--ds-text-selected, #0C66E4)";
const $f8caaf0a251343b7$var$textColor = "var(--ds-text, #172B4D)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f8caaf0a251343b7$var$EmptyCardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $5xVPG.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _80omtlke",
            __cmplp.isSelected ? "_syazaqb7" : "_syaz1fxt",
            __cmplp.isSelected ? "_f8pjaqb7 _30l3aqb7" : "_f8pj1fxt _30l31fxt",
            __cmplp.className
        ])
    });
});
const $f8caaf0a251343b7$var$ListItemStyle = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.0'
});

});
parcelRegister("iwwo9", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffb369d8ea4f3908$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ffb369d8ea4f3908$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    blankText: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.blank-text",
        "defaultMessage": "We can't display this issue"
    },
    emptyCardText: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.empty-card-text",
        "defaultMessage": "This issue cannot be opened because it may have been deleted or you do not have access to it"
    },
    tooltip: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.tooltip",
        "defaultMessage": "Either this issue has been deleted, or you don\u2019t have access to it."
    },
    blankTextIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.blank-text-issue-term-refresh",
        "defaultMessage": "We can't display this work item"
    },
    emptyCardTextIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.empty-card-text-issue-term-refresh",
        "defaultMessage": "This work item cannot be opened because it may have been deleted or you do not have access to it"
    },
    tooltipIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.empty-card.tooltip-issue-term-refresh",
        "defaultMessage": "Either this work item has been deleted, or you don\u2019t have access to it."
    }
});

});


parcelRegister("1ocSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $04760746f23b3b20$export$2e2bcd8739ae039);

var $eLObg = parcelRequire("eLObg");

var $5g6U1 = parcelRequire("5g6U1");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $g5X3G = parcelRequire("g5X3G");

var $dCm1o = parcelRequire("dCm1o");

var $5xVPG = parcelRequire("5xVPG");

var $1BB6R = parcelRequire("1BB6R");
const $04760746f23b3b20$var$backgroundColorSelected = "var(--ds-background-selected, #E9F2FF)";
const $04760746f23b3b20$var$backgroundColorHovered = "var(--ds-background-neutral-subtle-hovered, #091E420F)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04760746f23b3b20$var$StyledListElement = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf",
            __cmplp.visualRefresh && "_otyr1b66",
            __cmplp.className
        ])
    });
});
const $04760746f23b3b20$export$1d41361302b577a1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $5xVPG.CardBaseStyle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _f8pj1kw7 _30l31kw7",
            __cmplp.isSelected ? "_syazaqb7" : "_syaz1kw7",
            __cmplp.isSelected ? "_irr3fg4m" : "_irr3166n",
            __cmplp.className
        ])
    });
});
const $04760746f23b3b20$export$c3fc4c88db352deb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_slp31hna _1i4q1hna _1nmz1hna",
            __cmplp.visualRefresh ? "_otyru2gc" : "_otyr1b66",
            __cmplp.className
        ])
    });
});
const $04760746f23b3b20$var$Card = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ style: style, onMounted: onMounted, onClick: onClick, onFocus: onFocus, onBlur: onBlur, issue: issue, fieldSets: fieldSetsFragment, isSelected: isSelected, onContextMenu: onContextMenu }, ref)=>{
    const fragmentData = (0, $8Uumt.useFragment)((0, $5g6U1.default), issue);
    const fieldSets = fieldSetsFragment;
    const fieldSetsData = (0, $8Uumt.useFragment)((0, $eLObg.default), fieldSets);
    const issueKey = fragmentData.key;
    (0, $5uXOq.useEffect)(()=>{
        onMounted && onMounted();
    }, [
        onMounted
    ]);
    const fieldEdges = fieldSetsData?.edges ?? null;
    const summary = (0, $1BB6R.byFieldId)(fieldEdges, 'summary', (summaryEdge)=>summaryEdge?.node?.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04760746f23b3b20$var$StyledListElement, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card.list-item",
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04760746f23b3b20$export$1d41361302b577a1 // @ts-expect-error incorrect ref type
    , {
        ref: ref ?? undefined,
        onContextMenu: onContextMenu,
        isSelected: isSelected,
        onBlur: onBlur,
        tabIndex: isSelected ? 0 : -1,
        onClick: onClick,
        onFocus: onFocus,
        style: style,
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card",
        href: `/browse/${issueKey}`,
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04760746f23b3b20$export$c3fc4c88db352deb, {
        "data-testid": "issue-navigator.ui.issue-results.detail-view.card-list.card.summary",
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, summary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1BB6R.Footer), {
        issueKey: (0, $g5X3G.toIssueKey)(issueKey),
        isResolved: fragmentData.isResolved,
        fieldSets: fieldSetsData ?? null,
        isSelected: isSelected
    })));
});
var $04760746f23b3b20$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($04760746f23b3b20$var$Card);

});
parcelRegister("eLObg", function(module, exports) {

$parcel$export(module.exports, "default", () => $52436c85d14b8231$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<665198baf0f9c2c411158353f00d7520>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $52436c85d14b8231$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Card_fieldSets",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "footer_issueNavigator_FooterInternal"
        },
        {
            "concreteType": "JiraIssueFieldSetEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssueFieldSet",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueFieldEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "fieldId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "text"
                                                        }
                                                    ],
                                                    "type": "JiraSingleLineTextField"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueFieldSetConnection"
};
$52436c85d14b8231$var$node.hash = "606cafbbef903d4ec28da2ea50226fe2";
var $52436c85d14b8231$export$2e2bcd8739ae039 = $52436c85d14b8231$var$node;

});

parcelRegister("5g6U1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b4e46f8431bdece$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<9095b5dd69b4238d53bbc2293313a78a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4b4e46f8431bdece$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_Card_issue",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "key"
            },
            "action": "THROW",
            "path": "key"
        },
        {
            "kind": "ScalarField",
            "name": "isResolved"
        }
    ],
    "type": "JiraIssue"
};
$4b4e46f8431bdece$var$node.hash = "e3f34b125801c49c601cb9bbb61a7a14";
var $4b4e46f8431bdece$export$2e2bcd8739ae039 = $4b4e46f8431bdece$var$node;

});

parcelRegister("1BB6R", function(module, exports) {

$parcel$export(module.exports, "byFieldId", () => $508c659e42eab501$export$7a6e1e67b4eca178);
$parcel$export(module.exports, "Footer", () => $508c659e42eab501$export$a06f1c675e846f6f);

var $cA9Wh = parcelRequire("cA9Wh");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $ujWmd = parcelRequire("ujWmd");

var $3bDjY = parcelRequire("3bDjY");

var $dqoiX = parcelRequire("dqoiX");

var $gULOk = parcelRequire("gULOk");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $ku7XM = parcelRequire("ku7XM");

var $dCm1o = parcelRequire("dCm1o");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $aEaMJ = parcelRequire("aEaMJ");
const $508c659e42eab501$export$7a6e1e67b4eca178 = (edges, fieldId, mapperFn)=>edges?.map((edge)=>edge?.node?.fields?.edges?.[0]).filter((edge)=>edge?.node?.fieldId === fieldId).filter((0, $eJ0Zs.isNonNullish)).map(mapperFn)[0];
const $508c659e42eab501$var$FooterInternal = ({ issueKey: issueKey, isResolved: isResolvedProp, isSelected: isSelected, fieldSets: fieldSets })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const fieldSetsData = (0, $8Uumt.useFragment)((0, $cA9Wh.default), fieldSets);
    const fieldSetEdges = fieldSetsData?.edges;
    const assignee = $508c659e42eab501$export$7a6e1e67b4eca178(fieldSetEdges, 'assignee', (assigneeEdge)=>assigneeEdge?.node?.user);
    const issueType = $508c659e42eab501$export$7a6e1e67b4eca178(fieldSetEdges, 'issuetype', (issueTypeEdge)=>issueTypeEdge?.node?.issueType);
    const statusCategoryId = $508c659e42eab501$export$7a6e1e67b4eca178(fieldSetEdges, 'statusCategory', (statusCategoryEdge)=>statusCategoryEdge?.node?.statusCategory?.statusCategoryId);
    const isResolved = (0, $ku7XM.shouldDisplayStrikethrough)(isResolvedProp ?? undefined, (0, $gULOk.statusCategoryForId)(statusCategoryId));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($508c659e42eab501$var$StyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($508c659e42eab501$var$TypeIcon, {
        src: issueType?.avatar?.small ?? undefined,
        alt: issueType?.name ?? undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($508c659e42eab501$export$263c092b561e7355, {
        isSelected: isSelected,
        isResolved: isResolved,
        isVisualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, issueKey, isResolved && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        role: "status"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $aEaMJ.default).screenReaderFooterKeyResolvedIssueTermRefresh : (0, $aEaMJ.default).screenReaderFooterKeyResolved, {
        issueKey: issueKey
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($508c659e42eab501$var$AvatarStyledContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: assignee?.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: assignee?.picture,
        name: assignee?.name,
        size: "small"
    }))));
};
const $508c659e42eab501$export$a06f1c675e846f6f = /*#__PURE__*/ (0, $5uXOq.memo)($508c659e42eab501$var$FooterInternal); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $508c659e42eab501$var$StyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $508c659e42eab501$var$TypeIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _1bsb7vkz _4t3i7vkz _2hwx1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $508c659e42eab501$var$AvatarStyledContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1f4h _19bvu2gc _18u01wug _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $508c659e42eab501$export$263c092b561e7355 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefresh: isVisualRefresh, isSelected: isSelected, isResolved: isResolved, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _kqswh2mm",
            __cmplp.isVisualRefresh ? "_k48p1wq8" : "_k48pmoej",
            __cmplp.isSelected ? "_syazaqb7" : __cmplp.isVisualRefresh ? "_syaz1gjq" : "_syaz1fxt",
            __cmplp.isResolved ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cA9Wh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9702b926129cb95c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<54d5e2050f16aa77b0b95c4ea04b0425>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9702b926129cb95c$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "footer_issueNavigator_FooterInternal",
        "selections": [
            {
                "concreteType": "JiraIssueFieldSetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JiraIssueFieldConnection",
                                "kind": "LinkedField",
                                "name": "fields",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraIssueFieldEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "kind": "ScalarField",
                                                                "name": "text"
                                                            }
                                                        ],
                                                        "type": "JiraSingleLineTextField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            v1 /*: any*/ ,
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "picture"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraSingleSelectUserPickerField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraIssueType",
                                                                "kind": "LinkedField",
                                                                "name": "issueType",
                                                                "plural": false,
                                                                "selections": [
                                                                    v1 /*: any*/ ,
                                                                    {
                                                                        "concreteType": "JiraAvatar",
                                                                        "kind": "LinkedField",
                                                                        "name": "avatar",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "name": "small"
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraIssueTypeField"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            v0 /*: any*/ ,
                                                            {
                                                                "concreteType": "JiraStatusCategory",
                                                                "kind": "LinkedField",
                                                                "name": "statusCategory",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "statusCategoryId"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraStatusCategoryField"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraIssueFieldSetConnection"
    };
}();
$9702b926129cb95c$var$node.hash = "80bd71836423cbf18b560dfc0418dc69";
var $9702b926129cb95c$export$2e2bcd8739ae039 = $9702b926129cb95c$var$node;

});

parcelRegister("gULOk", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e77315bf13f8b83b$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e77315bf13f8b83b$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e77315bf13f8b83b$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e77315bf13f8b83b$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e77315bf13f8b83b$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e77315bf13f8b83b$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e77315bf13f8b83b$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e77315bf13f8b83b$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e77315bf13f8b83b$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e77315bf13f8b83b$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e77315bf13f8b83b$export$d928f247c903643a);
const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
    $e77315bf13f8b83b$export$6db089fe7b26f5b6,
    $e77315bf13f8b83b$export$aa456a5030160740,
    $e77315bf13f8b83b$export$5a9ac66c2785cc13,
    $e77315bf13f8b83b$export$71efb3495f6084f2
];
const $e77315bf13f8b83b$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
    }
];
const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
};
const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});

parcelRegister("ku7XM", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayStrikethrough", () => $5e2ee485e17261c7$export$1e1e848245d3a6f7);

var $gULOk = parcelRequire("gULOk");
const { DONE: $5e2ee485e17261c7$var$DONE } = (0, $gULOk);
const $5e2ee485e17261c7$export$1e1e848245d3a6f7 = (isResolved, statusCategory)=>{
    if (isResolved !== undefined) return isResolved;
    // In JSW, the strikethrough must now only depend on resolution. However we have to keep
    // this logic because there is a consumer of issue-line-card in JSM that displays
    // the strikethrough based on status src/packages/servicedesk/post-incident-review/src/ui/primary-incident/index.tsx
    return statusCategory === $5e2ee485e17261c7$var$DONE;
};

});

parcelRegister("aEaMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8db5e8f8694ecf3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f8db5e8f8694ecf3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    screenReaderFooterKeyResolved: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-resolved",
        "defaultMessage": "Resolved issue: {issueKey}"
    },
    screenReaderFooterKeyDone: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-done",
        "defaultMessage": "Done issue: {issueKey}"
    },
    screenReaderFooterKeyResolvedIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-resolved-issue-term-refresh",
        "defaultMessage": "Resolved issue: {issueKey}"
    },
    screenReaderFooterKeyDoneIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.card.footer.screen-reader-footer-key-done-issue-term-refresh",
        "defaultMessage": "Done work item: {issueKey}"
    }
});

});



parcelRegister("4f2Gl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3513a249a124c25$export$2e2bcd8739ae039);

var $2bUDh = parcelRequire("2bUDh");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3Tty1 = parcelRequire("3Tty1");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $63r1u = parcelRequire("63r1u");

var $7OTah = parcelRequire("7OTah");

var $eaucu = parcelRequire("eaucu");
const $b3513a249a124c25$var$useUpdatingRef = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
};
const $b3513a249a124c25$var$KeyboardShortcuts = (props)=>{
    const issueData = (0, $8Uumt.useFragment)((0, $2bUDh.default), props.focusedIssue);
    const workType = issueData?.issueTypeField?.issueType?.name;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const propsRef = $b3513a249a124c25$var$useUpdatingRef(props);
    const openStateRef = $b3513a249a124c25$var$useUpdatingRef((0, $63r1u.useOrderByOpenState)());
    const selectedIssueKey = (0, $7OTah.useSelectedIssueKey)();
    const selectedIssueKeyRef = $b3513a249a124c25$var$useUpdatingRef(selectedIssueKey);
    const { selectNextIssue: selectNextIssue, selectPreviousIssue: selectPreviousIssue } = (0, $7OTah.useSelectedIssueActions)();
    const nextIssueKey = (0, $7OTah.useNextIssueKey)() ?? (0, $g5X3G.toIssueKey)('');
    const nextIssueKeyRef = (0, $5uXOq.useRef)(nextIssueKey);
    nextIssueKeyRef.current = nextIssueKey;
    const handleNext = (0, $5uXOq.useCallback)(()=>{
        const { onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
        if (selectNextIssue(true)) onIssueChangeEvent && onIssueChangeEvent(nextIssueKeyRef.current);
    // Dependencies must be stable as downstream useMemo has an empty dependencies array
    }, [
        propsRef,
        selectNextIssue
    ]);
    const previousIssueKey = (0, $7OTah.usePreviousIssueKey)() ?? (0, $g5X3G.toIssueKey)('');
    const previousIssueKeyRef = (0, $5uXOq.useRef)(previousIssueKey);
    previousIssueKeyRef.current = previousIssueKey;
    const handlePrevious = (0, $5uXOq.useCallback)(()=>{
        const { onIssueChangeEvent: onIssueChangeEvent } = propsRef.current;
        if (selectPreviousIssue(true)) onIssueChangeEvent && onIssueChangeEvent(previousIssueKeyRef.current);
    // Dependencies must be stable as downstream useMemo has an empty dependencies array
    }, [
        propsRef,
        selectPreviousIssue
    ]);
    const openIssueFullScreenMessage = (()=>{
        if (workType && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $eaucu.default).openIssueFullScreenIssueTerminologyRefreshM4, {
            workType: workType
        });
        return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eaucu.default).openIssueFullScreenIssueTermRefresh : (0, $eaucu.default).openIssueFullScreen);
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: (0, $5uXOq.useMemo)(()=>({
                j: {
                    callback: ()=>{
                        const { disableListControls: disableListControls } = propsRef.current;
                        if (disableListControls === true) return;
                        // handleNext needs to be a stable function references as useMemo has an empty dependencies array
                        handleNext();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eaucu.default).nextIssueIssueTermRefresh : (0, $eaucu.default).nextIssue))
                },
                k: {
                    callback: ()=>{
                        const { disableListControls: disableListControls } = propsRef.current;
                        if (disableListControls === true) return;
                        // handlePrevious needs to be a stable function references as useMemo has an empty dependencies array
                        handlePrevious();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eaucu.default).previousIssueIssueTermRefresh : (0, $eaucu.default).previousIssue))
                },
                y: {
                    callback: ()=>{
                        const [{ isOpen: isOpen }, { open: open, close: close }] = openStateRef.current;
                        isOpen ? close() : open();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $eaucu.default).displaySortFields))
                },
                z: {
                    callback: ()=>{
                        if (selectedIssueKeyRef.current) propsRef.current.onNavigateToIssue(selectedIssueKeyRef.current);
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, openIssueFullScreenMessage)
                },
                arrowup: {
                    callback: ()=>{
                        const { disableListControls: disableListControls, focusedIssueKey: focusedIssueKey } = propsRef.current;
                        if (disableListControls === true) return;
                        const isSelectedIssueFocused = focusedIssueKey !== null && focusedIssueKey === selectedIssueKeyRef.current;
                        if (isSelectedIssueFocused) handlePrevious();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eaucu.default).previousIssueIssueTermRefresh : (0, $eaucu.default).previousIssue))
                },
                arrowdown: {
                    callback: ()=>{
                        const { disableListControls: disableListControls, focusedIssueKey: focusedIssueKey } = propsRef.current;
                        if (disableListControls === true) return;
                        const isSelectedIssueFocused = focusedIssueKey !== null && focusedIssueKey === selectedIssueKeyRef.current;
                        if (isSelectedIssueFocused) handleNext();
                    },
                    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eaucu.default).nextIssueIssueTermRefresh : (0, $eaucu.default).nextIssue))
                }
            }), [] // eslint-disable-line react-hooks/exhaustive-deps
        )
    });
};
$b3513a249a124c25$var$KeyboardShortcuts.defaultProps = {
    disableListControls: false
};
var $b3513a249a124c25$export$2e2bcd8739ae039 = $b3513a249a124c25$var$KeyboardShortcuts;

});
parcelRegister("2bUDh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93c434060f136f5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2314afbcde7d8980ae1e76ca96f70867>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a93c434060f136f5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "keyboardShortcuts_issueNavigator",
    "selections": [
        {
            "concreteType": "JiraIssueTypeField",
            "kind": "LinkedField",
            "name": "issueTypeField",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraIssueType",
                    "kind": "LinkedField",
                    "name": "issueType",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssue"
};
$a93c434060f136f5$var$node.hash = "b6db91587551c3c9c628860986b56a99";
var $a93c434060f136f5$export$2e2bcd8739ae039 = $a93c434060f136f5$var$node;

});

parcelRegister("eaucu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f07eece787fe1a7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1f07eece787fe1a7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    nextIssue: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.next-issue",
        "defaultMessage": "Next issue"
    },
    previousIssue: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.previous-issue",
        "defaultMessage": "Previous issue"
    },
    displaySortFields: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.display-sort-fields",
        "defaultMessage": "Detail view order by"
    },
    openIssueFullScreen: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.open-issue-full-screen",
        "defaultMessage": "Open issue fullscreen"
    },
    nextIssueIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.next-issue-issue-term-refresh",
        "defaultMessage": "Next work item"
    },
    previousIssueIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.previous-issue-issue-term-refresh",
        "defaultMessage": "Previous work item"
    },
    openIssueFullScreenIssueTermRefresh: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.open-issue-full-screen-issue-term-refresh",
        "defaultMessage": "Open the work item in fullscreen"
    },
    openIssueFullScreenIssueTerminologyRefreshM4: {
        "id": "issue-navigator.card-list.keyboard-shortcuts.open-issue-full-screen-issue-terminology-refresh-m4",
        "defaultMessage": "Open the {workType} in fullscreen"
    }
});

});


parcelRegister("2UJgO", function(module, exports) {

$parcel$export(module.exports, "default", () => $28be3dd688e218d3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $28be3dd688e218d3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issues: {
        "id": "issue-navigator.issue-results.detail-view.card-list.issues",
        "defaultMessage": "Issues"
    },
    issuesIssueTermRefresh: {
        "id": "issue-navigator.issue-results.detail-view.card-list.issues-issue-term-refresh",
        "defaultMessage": "Work items"
    }
});

});



parcelRegister("3vkQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $8745c6e002add02e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "RecoverableErrorViewBoundary", () => $8745c6e002add02e$export$d42c1f6e3e564ee9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $81Uw2 = parcelRequire("81Uw2");

var $kjIEI = parcelRequire("kjIEI");

var $c7i3D = parcelRequire("c7i3D");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");

var $dCm1o = parcelRequire("dCm1o");

var $38r5c = parcelRequire("38r5c");

var $hlGjX = parcelRequire("hlGjX");
const $8745c6e002add02e$var$ErrorView = ({ onCaughtIssueSearchError: onCaughtIssueSearchError, error: errorProp })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onRefresh: onRefresh } = (0, $38r5c.useIssueSearchActions)();
    const onClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        // @ts-expect-error - Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent.clone(), 'refreshFromError');
        onRefresh();
    }, [
        onRefresh
    ]);
    const error = (0, $5uXOq.useMemo)(()=>errorProp || new Error('There was an error searching for issues'), [
        errorProp
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        onCaughtIssueSearchError && onCaughtIssueSearchError(error);
    }, [
        onCaughtIssueSearchError,
        error
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8745c6e002add02e$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $hlGjX.default).emptyStateErrorHeader),
        description: formatMessage((0, $hlGjX.default).emptyStateErrorDescription),
        testId: "issue-navigator.ui.issue-results.error-view.error-message",
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            onClick: onClick
        }, formatMessage((0, $hlGjX.default).emptyStateErrorAction)),
        renderImage: ()=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $8745c6e002add02e$var$ImageWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c7i3D.default), {
                alt: ""
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $8745c6e002add02e$var$ImageWrapperStylesOld
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kjIEI.default), {
                alt: ""
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "viewed",
        actionSubject: "screen",
        actionSubjectId: "issueSearchError"
    }));
};
var $8745c6e002add02e$export$2e2bcd8739ae039 = $8745c6e002add02e$var$ErrorView;
const $8745c6e002add02e$export$d42c1f6e3e564ee9 = (0, $81Uw2.withRecoverableErrorBoundary)(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children), {
    recoveryProp: 'recoveryProp',
    Fallback: $8745c6e002add02e$var$ErrorView
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8745c6e002add02e$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlkb7n _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $8745c6e002add02e$var$ImageWrapperStylesOld = (0, $8CUq3.xcss)({
    maxHeight: '146px',
    maxWidth: '160px',
    margin: 'auto',
    marginBottom: 'space.300'
});
const $8745c6e002add02e$var$ImageWrapperStyles = (0, $8CUq3.xcss)({
    maxHeight: '165px',
    maxWidth: '150px',
    margin: 'auto',
    marginBottom: 'space.300'
});

});
parcelRegister("hlGjX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7ed0162ee24bd2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c7ed0162ee24bd2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    emptyStateErrorHeader: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-header",
        "defaultMessage": "We couldn\u2019t load your search results"
    },
    emptyStateErrorDescription: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-description",
        "defaultMessage": "Refresh to try again."
    },
    emptyStateErrorAction: {
        "id": "issue-navigator.issue-results.error-view.empty-state-error-action",
        "defaultMessage": "Refresh"
    }
});

});


parcelRegister("dTymG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c7151db16a02806$export$2e2bcd8739ae039);

var $59Iqo = parcelRequire("59Iqo");

var $3Q636 = parcelRequire("3Q636");

var $6VsB9 = parcelRequire("6VsB9");

var $bW3jF = parcelRequire("bW3jF");

var $1Fibi = parcelRequire("1Fibi");

var $2fw1T = parcelRequire("2fw1T");

var $krXnE = parcelRequire("krXnE");

var $ebHAX = parcelRequire("ebHAX");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jcw0u = parcelRequire("jcw0u");

var $gcl1l = parcelRequire("gcl1l");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $6bs0c = parcelRequire("6bs0c");

var $gkVdw = parcelRequire("gkVdw");

var $hH4aB = parcelRequire("hH4aB");

var $czfFt = parcelRequire("czfFt");

var $aB7bN = parcelRequire("aB7bN");

var $5iGOJ = parcelRequire("5iGOJ");

var $32GaU = parcelRequire("32GaU");

var $3HwlS = parcelRequire("3HwlS");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $cZpsT = parcelRequire("cZpsT");

var $imS60 = parcelRequire("imS60");

var $4R6GH = parcelRequire("4R6GH");

var $ePhT2 = parcelRequire("ePhT2");

var $6UAdF = parcelRequire("6UAdF");

var $1igGa = parcelRequire("1igGa");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $a8lIB = parcelRequire("a8lIB");

var $jlRhf = parcelRequire("jlRhf");

var $hZQx0 = parcelRequire("hZQx0");

var $7OTah = parcelRequire("7OTah");

var $ih9zY = parcelRequire("ih9zY");

var $krnTs = parcelRequire("krnTs");

var $gwtSG = parcelRequire("gwtSG");

var $kiKYF = parcelRequire("kiKYF");

var $kj1di = parcelRequire("kj1di");

var $38r5c = parcelRequire("38r5c");

var $gUt9J = parcelRequire("gUt9J");

var $7UBlg = parcelRequire("7UBlg");

var $bC77a = parcelRequire("bC77a");

var $8ev74 = parcelRequire("8ev74");

var $2hlL8 = parcelRequire("2hlL8");

var $df5k9 = parcelRequire("df5k9");

var $cKSn6 = parcelRequire("cKSn6");

var $1g3qz = parcelRequire("1g3qz");

var $ePwTF = parcelRequire("ePwTF");

var $dHKP1 = parcelRequire("dHKP1");

var $dYvVi = parcelRequire("dYvVi");
const $9c7151db16a02806$var$reorderColumnsErrorFlag = {
    type: 'error',
    title: (0, $df5k9.default).reorderColumnsErrorTitle,
    description: (0, $df5k9.default).columnConfigMutationErrorDescription,
    isAutoDismiss: true,
    messageId: 'issue-navigator.ui.issue-results.list-view.reorder-columns-error-flag.error',
    messageType: 'transactional'
};
const $9c7151db16a02806$var$resetColumnsErrorFlag = {
    type: 'error',
    title: (0, $df5k9.default).resetColumnsErrorTitle,
    description: (0, $df5k9.default).columnConfigMutationErrorDescription,
    isAutoDismiss: true,
    messageId: 'issue-navigator.ui.issue-results.list-view.reset-columns-error-flag.error',
    messageType: 'transactional'
};
const $9c7151db16a02806$var$TableContainer = ({ children: children })=>(0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9c7151db16a02806$var$TableContainerStyles
    }, children) : children;
const $9c7151db16a02806$export$b4f6a715a9e57e85 = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { isFilterEditable: isFilterEditable } = (0, $gwtSG.useActiveJql)();
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const { isLoading: isLoading } = (0, $jlRhf.useColumnPickerLoadingContext)();
    return !isAnonymous && (!(0, $eJ0Zs.isFilterViewId)(view) || isFilterEditable === true) && !isLoading;
};
const $9c7151db16a02806$export$539ae4acd804b244 = (onRestoreDefaultColumns, hasDefaultFieldSets)=>{
    const { isFilterEditable: isFilterEditable } = (0, $gwtSG.useActiveJql)();
    const [{ view: selectedView }] = (0, $ih9zY.useSelectedViewState)();
    return !((0, $eJ0Zs.isFilterViewId)(selectedView) && isFilterEditable === false) && hasDefaultFieldSets === false ? onRestoreDefaultColumns : undefined;
};
const $9c7151db16a02806$export$3e7a75a1659bbaae = (onColumnsChange)=>{
    const canEditColumns = $9c7151db16a02806$export$b4f6a715a9e57e85();
    return canEditColumns ? onColumnsChange : undefined;
};
const $9c7151db16a02806$export$d7623a323994e4cc = (selectedColumns)=>{
    const [{ view: selectedView }] = (0, $ih9zY.useSelectedViewState)();
    const canEditColumns = $9c7151db16a02806$export$b4f6a715a9e57e85();
    return (0, $kiKYF.useColumnLoader)(selectedView, canEditColumns, selectedColumns, (0, $4R6GH.fg)('jira_inline_field_config_gate'));
};
const $9c7151db16a02806$export$90b784197d8a906f = ()=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return !isAnonymous ? $9c7151db16a02806$export$d7623a323994e4cc : undefined;
};
const $9c7151db16a02806$var$ListView = ({ loading: loading, onChangeColumnConfiguration: onChangeColumnConfiguration, onSelectedRowChange: onSelectedRowChange, issueResults: issueResults, groupResults: groupResults, view: view, project: project, rankField: rankField, issueTableProps: issueTableProps, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isIssueRankingSupportEnabled: isIssueRankingSupportEnabled, isMergedColumnSupportEnabled: isMergedColumnSupportEnabled, filter: filter, onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld, onIssueFlatListUpdated: onIssueFlatListUpdated })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_LIST_VIEW_START);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).ISSUE_RESULTS_LIST_VIEW_END);
    }, []);
    const resolvedJql = (0, $gwtSG.useResolvedJql)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isRowContextMenuEnabled = (0, $4R6GH.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $ePhT2.useIssueNavigatorFeatures)().isRowContextMenuEnabled : true;
    /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ const issueResultsData = (0, $8Uumt.useFragment)((0, $ebHAX.default), issueResults);
    const groupResultsData = (0, $8Uumt.useFragment)((0, $krXnE.default), groupResults);
    const viewData = (0, $8Uumt.useFragment)((0, $2fw1T.default), view);
    const projectData = (0, $8Uumt.useFragment)((0, $1Fibi.default), project);
    const filterData = (0, $8Uumt.useFragment)((0, $bW3jF.default), filter);
    const rankFieldData = (0, $8Uumt.useFragment)((0, $6VsB9.default), rankField);
    const selectedIssueKey = (0, $7OTah.useSelectedIssueKey)();
    const selectedIssueIndex = (0, $7OTah.useSelectedIssueIndex)();
    const currentPage = issueResultsData?.pageCursors?.around?.find((cursor)=>cursor?.isCurrent)?.pageNumber ?? 1;
    const [{ field: field, direction: direction }, { setFieldAndDirection: setFieldAndDirection }] = (0, $krnTs.useSortFieldAndDirection)();
    // TODO JSC-242 Need to figure out appropriate refetch behaviour, e.g. do we want to try keep visible issues in view?
    const { onRefetch: onIssueSearchForColumnConfig, onRefresh: onRefresh } = (0, $38r5c.useIssueSearchActions)();
    const { isLoading: isColumnPickerLoading, setIsRestoringDefaultColumns: setIsRestoringDefaultColumns } = (0, $jlRhf.useColumnPickerLoadingContext)();
    const onModifyColumns = (0, $5uXOq.useCallback)(()=>{
        onChangeColumnConfiguration && onChangeColumnConfiguration();
        onIssueSearchForColumnConfig();
    }, [
        onChangeColumnConfiguration,
        onIssueSearchForColumnConfig
    ]);
    const fieldSetIds = (0, $5uXOq.useMemo)(()=>viewData.fieldSets.edges?.map((edge)=>edge?.node?.fieldSetId).filter(Boolean) ?? [], [
        viewData.fieldSets.edges
    ]);
    const eventHandlers = (0, $dYvVi.useEventHandlers)(issueResultsData?.__id, fieldSetIds);
    const overriddenTableComponents = issueTableProps?.components;
    const projectContext = issueTableProps?.projectContext;
    const isGroupingSupported = issueTableProps?.isGroupingSupported;
    const viewSettings = viewData?.viewSettings;
    /**
   * isHierarchyEnabled reflects user preference in the current page,
   * canEnableHierarchy reflects whether the hierarchy can be enabled based on the JQL / other settings,
   * isIssueHierarchySupportEnabled reflects whether the hierarchy is supported in the experience.
   * The combination of these three values determines whether issue hierarchy is enabled in issue table.
   */ const isHierarchyEnabled = viewSettings?.isHierarchyEnabled && viewSettings.canEnableHierarchy && isIssueHierarchySupportEnabled;
    const infiniteScrollProps = (0, $kj1di.useInfiniteScroll)({
        isHierarchyEnabled: isHierarchyEnabled,
        fieldSetIds: fieldSetIds,
        groupBy: isGroupingSupported ? viewData?.viewSettings?.groupByConfig?.groupByField?.fieldId : undefined,
        view: (0, $6UAdF.views).list,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        isHideDoneEnabled: viewSettings?.hideDone || false
    });
    const onSortOrderChange = (0, $5uXOq.useCallback)((sortField, sortDirection)=>setFieldAndDirection(sortField, sortDirection, []), [
        setFieldAndDirection
    ]);
    const hasMaxSelectedColumns = viewData?.fieldSets?.totalCount ? viewData?.fieldSets?.totalCount >= (0, $czfFt.MAX_COLUMNS) : false;
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const [replaceSpreadsheetViewFieldSets] = (0, $8Uumt.useMutation)((0, $3Q636.default));
    const onColumnsChange = (0, $5uXOq.useCallback)((columnIds, changeType, optimisticFieldSets, onSuccessCallback, onErrorCallback, retries = 0, analyticsAttributes, skipRefetch)=>{
        let attempts = 0;
        // This handler can be called from a native event listener hence React does not batch state updates.
        // We manually batch this update for better rendering performance and more accurate measurement of
        // drag-and-drop interaction performance. We can remove this with React 18's automatic batching.
        (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).unstable_batchedUpdates(()=>{
            if (changeType === (0, $czfFt.REORDER_COLUMNS)) (0, $dHKP1.dragAndDropExperience).start();
            const variables = {
                id: viewData.id,
                amountOfColumns: (0, $czfFt.MAX_COLUMNS),
                fieldSetsInput: {
                    replaceFieldSetsInput: {
                        nodes: columnIds,
                        ...projectContext && (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false) && {
                            context: {
                                projectContext: {
                                    project: projectData?.projectId
                                }
                            }
                        }
                    }
                },
                includeView: changeType === (0, $czfFt.REORDER_COLUMNS),
                ...projectContext && (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false) && {
                    fieldSetsScope: {
                        operationScope: projectContext ? (0, $6UAdF.NIN_PROJECT_OPERATION_SCOPE) : (0, $6UAdF.NIN_GLOBAL_OPERATION_SCOPE),
                        projectKey: projectData?.key
                    }
                }
            };
            const handleCompleted = (success)=>{
                if (success) {
                    const canSkipRefetch = skipRefetch && (0, $4R6GH.fg)('jira_inline_field_config_gate');
                    if (changeType === (0, $czfFt.MODIFY_COLUMNS) && !canSkipRefetch) onModifyColumns();
                    else if (changeType === (0, $czfFt.REORDER_COLUMNS)) (0, $dHKP1.dragAndDropExperience).success();
                    if ((0, $4R6GH.fg)('jira_nin_table_column_update_analytics')) {
                        if ((0, $4R6GH.fg)('jira_inline_field_config_gate')) {
                            const eventAttributes = {
                                ...analyticsAttributes,
                                operationScope: projectContext ? (0, $6UAdF.NIN_PROJECT_OPERATION_SCOPE) : (0, $6UAdF.NIN_GLOBAL_OPERATION_SCOPE)
                            };
                            if (changeType === (0, $czfFt.MODIFY_COLUMNS)) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', eventAttributes || {});
                            else if (changeType === (0, $czfFt.REORDER_COLUMNS)) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', {
                                actionType: (0, $czfFt.REORDER_COLUMNS),
                                operationScope: projectContext ? (0, $6UAdF.NIN_PROJECT_OPERATION_SCOPE) : (0, $6UAdF.NIN_GLOBAL_OPERATION_SCOPE)
                            });
                        } else {
                            const totalCount = viewData?.fieldSets?.totalCount;
                            if (changeType === (0, $czfFt.MODIFY_COLUMNS)) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', {
                                isInline: false,
                                actionType: columnIds.length < (totalCount ?? 0) ? (0, $hH4aB.REMOVE_COLUMNS) : (0, $hH4aB.ADD_COLUMNS)
                            });
                            else if (changeType === (0, $czfFt.REORDER_COLUMNS)) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', {
                                actionType: (0, $czfFt.REORDER_COLUMNS)
                            });
                        }
                    }
                    if ((0, $4R6GH.fg)('jira_inline_field_config_gate')) onSuccessCallback?.();
                } else {
                    const showError = !(0, $4R6GH.fg)('jira_inline_field_config_gate') || attempts === retries;
                    if (showError) {
                        showFlag($9c7151db16a02806$var$reorderColumnsErrorFlag);
                        (0, $jcw0u.default)({
                            meta: {
                                id: 'commitReplaceListViewFieldSetsMutationUnsuccessful',
                                packageName: (0, $6UAdF.PACKAGE_NAME),
                                teamName: (0, $6UAdF.TEAM_NAME)
                            },
                            sendToPrivacyUnsafeSplunk: true,
                            attributes: {
                                changeType: changeType,
                                retries: retries
                            }
                        });
                        if (changeType === (0, $czfFt.REORDER_COLUMNS)) (0, $dHKP1.dragAndDropExperience).failure();
                        if ((0, $4R6GH.fg)('jira_inline_field_config_gate')) onErrorCallback?.();
                    } else {
                        attempts++;
                        commitFieldSets();
                    }
                }
            };
            const handleError = (error)=>{
                const showError = !(0, $4R6GH.fg)('jira_inline_field_config_gate') || attempts === retries;
                if (showError) {
                    showFlag($9c7151db16a02806$var$reorderColumnsErrorFlag);
                    (0, $jcw0u.default)({
                        meta: {
                            id: 'commitReplaceListViewFieldSetsMutationError',
                            packageName: (0, $6UAdF.PACKAGE_NAME),
                            teamName: (0, $6UAdF.TEAM_NAME)
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true,
                        attributes: {
                            changeType: changeType
                        }
                    });
                    if (changeType === (0, $czfFt.REORDER_COLUMNS)) (0, $dHKP1.dragAndDropExperience).failure();
                    if ((0, $4R6GH.fg)('jira_inline_field_config_gate')) onErrorCallback?.();
                } else {
                    attempts++;
                    commitFieldSets();
                }
            };
            const commitFieldSets = ()=>{
                replaceSpreadsheetViewFieldSets({
                    variables: variables,
                    optimisticResponse: changeType === (0, $czfFt.REORDER_COLUMNS) && optimisticFieldSets ? {
                        jira: {
                            replaceSpreadsheetViewFieldSets: {
                                success: true,
                                view: {
                                    __typename: viewData.__typename,
                                    id: viewData.id,
                                    hasDefaultFieldSets: viewData.hasDefaultFieldSets,
                                    fieldSets: {
                                        ...optimisticFieldSets
                                    }
                                }
                            }
                        }
                    } : undefined,
                    onCompleted (data) {
                        handleCompleted(data.jira?.replaceSpreadsheetViewFieldSets?.success);
                    },
                    onError (error) {
                        handleError(error);
                    }
                });
            };
            commitFieldSets();
        });
    }, [
        viewData.id,
        viewData?.fieldSets?.totalCount,
        viewData.__typename,
        viewData.hasDefaultFieldSets,
        projectData?.projectId,
        projectData?.key,
        projectContext,
        onModifyColumns,
        createAnalyticsEvent,
        showFlag,
        replaceSpreadsheetViewFieldSets
    ]);
    const [updateFieldSetPreferences] = (0, $8Uumt.useMutation)((0, $59Iqo.default));
    const cloudId = (0, $koeKL.useCloudId)();
    const updateColumnWidth = (0, $5iGOJ.useColumnWidthUpdater)(viewData.fieldSets.__id);
    const onColumnResize = (0, $5uXOq.useCallback)((columnId, width)=>{
        // skip mutation for anonymous users as they don't have access to user preferences
        if (!isAnonymous) // we intentionally don't optimistically update the store to avoid rolling back column widths
        // in case of a mutation error, which would be very jarring for the user
        updateFieldSetPreferences({
            variables: {
                cloudId: cloudId,
                input: {
                    nodes: [
                        {
                            fieldSetId: columnId,
                            width: width ?? null
                        }
                    ]
                },
                ...projectContext && (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false) && {
                    context: {
                        projectContext: {
                            project: projectData?.projectId
                        }
                    },
                    viewId: viewData.id
                }
            },
            onCompleted (data) {
                if (!data.jira?.updateUserFieldSetPreferences?.success) // silently fail as column will remain at the desired width until the next page load
                (0, $jcw0u.default)({
                    meta: {
                        id: 'commitUpdateFieldSetPreferencesMutationUnsuccessful',
                        packageName: (0, $6UAdF.PACKAGE_NAME),
                        teamName: (0, $6UAdF.TEAM_NAME)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onError (error) {
                // silently fail as column will remain at the desired width until the next page load
                (0, $jcw0u.default)({
                    meta: {
                        id: 'commitUpdateFieldSetPreferencesMutationError',
                        packageName: (0, $6UAdF.PACKAGE_NAME),
                        teamName: (0, $6UAdF.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        // commit local update to the store independently of the mutation result to preserve user's desired width
        updateColumnWidth(columnId, width);
    }, [
        cloudId,
        isAnonymous,
        viewData.id,
        projectContext,
        projectData?.projectId,
        updateColumnWidth,
        updateFieldSetPreferences
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $dHKP1.dragAndDropExperience).markInlineResponse();
    });
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            hasMaxSelectedColumns: hasMaxSelectedColumns,
            filterName: filterData?.name
        }), [
        filterData?.name,
        hasMaxSelectedColumns
    ]);
    const onRestoreDefaultColumns = (0, $5uXOq.useCallback)(()=>{
        setIsRestoringDefaultColumns(true);
        const variables = {
            id: viewData.id,
            amountOfColumns: (0, $czfFt.MAX_COLUMNS),
            includeView: true,
            fieldSetsInput: {
                resetToDefaultFieldSets: true
            }
        };
        const handleCompleted = (success)=>{
            setIsRestoringDefaultColumns(false);
            if (success) {
                if ((0, $4R6GH.fg)('jira_nin_table_column_update_analytics')) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueTableColumns updated', {
                    actionType: (0, $czfFt.RESTORE_COLUMNS),
                    operationScope: projectContext ? (0, $6UAdF.NIN_PROJECT_OPERATION_SCOPE) : (0, $6UAdF.NIN_GLOBAL_OPERATION_SCOPE)
                });
                onRefresh();
            } else {
                showFlag($9c7151db16a02806$var$resetColumnsErrorFlag);
                (0, $jcw0u.default)({
                    meta: {
                        id: 'commitReplaceListViewUsingResetFieldSetsMutationUnsuccessful',
                        packageName: (0, $6UAdF.PACKAGE_NAME),
                        teamName: (0, $6UAdF.TEAM_NAME)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        const handleError = (error)=>{
            setIsRestoringDefaultColumns(false);
            showFlag($9c7151db16a02806$var$resetColumnsErrorFlag);
            (0, $jcw0u.default)({
                meta: {
                    id: 'commitReplaceListViewUsingResetFieldSetsMutationError',
                    packageName: (0, $6UAdF.PACKAGE_NAME),
                    teamName: (0, $6UAdF.TEAM_NAME)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        };
        replaceSpreadsheetViewFieldSets({
            variables: variables,
            onCompleted (data) {
                handleCompleted(data.jira?.replaceSpreadsheetViewFieldSets?.success);
            },
            onError (error) {
                handleError(error);
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        setIsRestoringDefaultColumns,
        viewData.id,
        onRefresh,
        showFlag,
        replaceSpreadsheetViewFieldSets
    ]);
    /**
   * returns undefined if there are default field sets
   * returns undefined if the user is on filter tab but cannot edit filter
   */ const conditionalOnRestoreDefaults = $9c7151db16a02806$export$539ae4acd804b244(onRestoreDefaultColumns, viewData?.hasDefaultFieldSets);
    const tableComponents = (0, $5uXOq.useMemo)(// We shallow merge these objects to make it easier for issue-navigator consumers to revert custom column
    // picker components, which are very NIN specific. This decision can be reconsidered if we need to introduce
    // additional nested custom components in the issue table and make those available to all consumers.
    ()=>({
            columnPicker: {
                Container: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bC77a.ColumnPickerRemountManager), {
                        viewIdFromResponse: (0, $eJ0Zs.parseIssueNavigatorViewIdOrDefault)(viewData.viewId)
                    }, children),
                PopupComponent: (0, $4R6GH.fg)('jira_inline_field_config_gate') ? (0, $7UBlg.createPopupComponent)(conditionalOnRestoreDefaults) : (0, $7UBlg.default)
            },
            IssueCount: $2hlL8.IssueCount,
            NoColumns: $cKSn6.NoColumns,
            NoIssues: $1g3qz.NoIssues,
            ...overriddenTableComponents,
            ConnectionsSubscriber: (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) ? ({ connections: connections, updateConnectionDetails: updateConnectionDetails })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ev74.BulkOpsConnectionsSubscriber), {
                    connections: connections,
                    updateConnectionDetails: updateConnectionDetails,
                    fragmentRef: issueResultsData || groupResultsData?.firstGroup?.issues || null
                }) : undefined
        }), [
        overriddenTableComponents,
        viewData.viewId,
        issueResultsData,
        groupResultsData?.firstGroup?.issues,
        conditionalOnRestoreDefaults
    ]);
    const conditionalOnChange = $9c7151db16a02806$export$3e7a75a1659bbaae(onColumnsChange);
    const conditionalColumnLoader = $9c7151db16a02806$export$90b784197d8a906f();
    const [isIFCEnabled, ifcConfig] = (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $gUt9J.useIFCSidebar)({
        projectKey: projectData?.key,
        projectId: projectData?.projectId
    }) : [
        false,
        undefined
    ];
    const resultsFragment = (0, $aB7bN.exclusiveGroupsOrIssuesFragment)({
        groups: groupResultsData ?? null,
        issues: issueResultsData ?? null
    });
    if (!resultsFragment) throw new Error('Missing groups or issues data');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "list-view"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkVdw.DialogContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            currentPage: currentPage,
            isAnonymous: isAnonymous
        }
    }, resultsFragment.issues && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePwTF.AsyncRegisterShortcutDialogActions), {
        issues: resultsFragment.issues,
        selectedIssueKey: selectedIssueKey,
        eventHandlers: eventHandlers
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hZQx0.ColumnPickerMessageContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9c7151db16a02806$var$TableContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $32GaU.default), {
        columns: viewData.fieldSets,
        onColumnsChange: conditionalOnChange,
        onRestoreDefaultColumns: conditionalOnRestoreDefaults,
        useColumnLoader: conditionalColumnLoader,
        loading: loading,
        eventHandlers: eventHandlers,
        onSelectedRowChange: onSelectedRowChange,
        selectedRow: selectedIssueIndex,
        sortField: field,
        sortDirection: direction,
        onSortChange: onSortOrderChange,
        onRefetch: onIssueSearchForColumnConfig,
        components: tableComponents,
        issueSearchBaseUrl: "" // Relative to current route rendering the issue navigator
        ,
        isColumnPickerLoading: isColumnPickerLoading,
        projectContext: projectContext,
        isGroupingSupported: isGroupingSupported,
        isIssueCreateEnabled: true // It's already tied to the project context
        ,
        onColumnResize: onColumnResize,
        project: projectData,
        rankField: rankFieldData?.rankField,
        isIssueHierarchyEnabled: Boolean(isHierarchyEnabled),
        isInlineEditingExtendedFieldSupportEnabled: (0, $6s1PB.expVal)('jira_list_inline_editing', 'isInlineEditingEnabled', false),
        isInBetweenColumnPickerEnabled: (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false),
        isInlineFieldConfigEnabled: (0, $6s1PB.expVal)('jira_inline_field_config', 'isInlineFieldConfigEnabled', false),
        ifcConfig: isIFCEnabled ? ifcConfig : undefined,
        onIssueFlatListUpdatedOld: onIssueFlatListUpdatedOld,
        onIssueFlatListUpdated: onIssueFlatListUpdated,
        ...(0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') && {
            jql: resolvedJql
        },
        ...(0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) && {
            enableMultiSelect: true
        },
        ...(0, $6s1PB.expVal)('jira_list_reparenting', 'isReparentingEnabled', false) && {
            isReparentingEnabled: true
        },
        ...(0, $6s1PB.expVal)('jira_list_single_line_row_height', 'isEnabled', false) && {
            isSingleLineRowHeightEnabled: true
        },
        ...(0, $6s1PB.expVal)('jira_list_hide_done_items', 'isEnabled', false) && {
            isHideDoneItemsEnabled: viewSettings?.hideDone ?? false
        },
        isMergedColumnEnabled: isMergedColumnSupportEnabled && (0, $4R6GH.fg)('jira_list_merged_column_gate'),
        ...infiniteScrollProps,
        ...resultsFragment,
        preloadedEntryPoints: issueTableProps?.preloadedEntryPoints,
        preloadedQueries: (0, $4R6GH.fg)('conditional-formatting-new-list-targeting-gate') ? issueTableProps?.preloadedQueries : undefined,
        ...(0, $4R6GH.fg)('jsc_list_reranking_gate') && {
            isIssueRankingEnabled: (isIssueRankingSupportEnabled && viewSettings?.canEnableReranking) ?? false
        },
        ...(0, $4R6GH.fg)('jira_nin_smart_link') && {
            isIssueOperationMeatballMenuEnabled: isRowContextMenuEnabled
        }
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6bs0c.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)));
};
// re-render regression detection
$9c7151db16a02806$var$ListView.whyDidYouRender = true;
const $9c7151db16a02806$var$ListViewWithColumnPickerContext = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jlRhf.ColumnPickerLoadingContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9c7151db16a02806$var$ListView, props));
var $9c7151db16a02806$export$2e2bcd8739ae039 = (0, $1igGa.withReportErrors)($9c7151db16a02806$var$ListViewWithColumnPickerContext, {
    id: 'ui.issue-results.list-view.unhandled',
    packageName: (0, $6UAdF.PACKAGE_NAME),
    teamName: (0, $6UAdF.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $gcl1l.isLoaderErrorAttributes)
});
const $9c7151db16a02806$var$TableContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: 1,
    flexBasis: 0,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    flexDirection: 'column'
});

});
parcelRegister("59Iqo", function(module, exports) {

$parcel$export(module.exports, "default", () => $02853882c92b5022$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<668fbf06820fa5f9f621813a86fd792f>>
 * @relayHash 9ea995599d5a28724f789a13cffad87f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 84a5bf8db4d5733b55ab8be4a9bac682b89dc1e3f8ab6e56f5369a3137e6aa15
const $02853882c92b5022$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "context"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v4 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "context",
                            "variableName": "context"
                        },
                        {
                            "kind": "Variable",
                            "name": "fieldSetPreferencesInput",
                            "variableName": "input"
                        },
                        {
                            "kind": "Variable",
                            "name": "viewId",
                            "variableName": "viewId"
                        }
                    ],
                    "concreteType": "JiraFieldSetPreferencesUpdatePayload",
                    "kind": "LinkedField",
                    "name": "updateUserFieldSetPreferences",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_updateFieldSetPreferencesMutation",
            "selections": v4 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_updateFieldSetPreferencesMutation",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "84a5bf8db4d5733b55ab8be4a9bac682b89dc1e3f8ab6e56f5369a3137e6aa15",
            "metadata": {},
            "name": "main_updateFieldSetPreferencesMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$02853882c92b5022$var$node.hash = "a01e3ed61486b0d7d7faf04b338c4960";
var $02853882c92b5022$export$2e2bcd8739ae039 = $02853882c92b5022$var$node;

});

parcelRegister("3Q636", function(module, exports) {

$parcel$export(module.exports, "default", () => $189300f3c547d1b2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<858e566a6d361370f60385b1acc7d201>>
 * @relayHash 3e2208bb12d1b5ebcf14463e04d4a3b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e9f48b150d01c00d0a13044182bb0277229eb28f007a36f825ff3054e5b26fbd

var $gY76A = parcelRequire("gY76A");
const $189300f3c547d1b2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "amountOfColumns"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsInput"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fieldSetsScope"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeView"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "fieldSetsInput",
            "variableName": "fieldSetsInput"
        },
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "success"
    }, v7 = {
        "kind": "ScalarField",
        "name": "hasDefaultFieldSets"
    }, v8 = [
        {
            "kind": "Literal",
            "name": "filter",
            "value": {
                "fieldSetSelectedState": "SELECTED"
            }
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "amountOfColumns"
        },
        {
            "kind": "Variable",
            "name": "scope",
            "variableName": "fieldSetsScope"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v11 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "displayName"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_replaceSpreadsheetViewFieldSetsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceSpreadsheetViewFieldSets",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v8 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "ui_nativeIssueTable_NativeIssueTable_columns"
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "main_replaceSpreadsheetViewFieldSetsMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v5 /*: any*/ ,
                            "concreteType": "JiraSpreadsheetViewPayload",
                            "kind": "LinkedField",
                            "name": "replaceSpreadsheetViewFieldSets",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                {
                                    "condition": "includeView",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "view",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v7 /*: any*/ ,
                                                {
                                                    "args": v8 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v12 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "jqlTerm"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "isSortable"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldSetPreferences",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldSetPreferences",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "width"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueSearchFieldMetadataConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldsMetadata",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraIssueSearchFieldMetadataEdge",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "edges",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueSearchMetadataField",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "node",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "canBeConfigured"
                                                                                                        },
                                                                                                        {
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "fieldId"
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ClientExtension",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isPlaceHolderField"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraFieldType",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v12 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        v11 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "id"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e9f48b150d01c00d0a13044182bb0277229eb28f007a36f825ff3054e5b26fbd",
            "metadata": {},
            "name": "main_replaceSpreadsheetViewFieldSetsMutation",
            "operationKind": "mutation",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": (0, $gY76A.default)
            }
        }
    };
}();
$189300f3c547d1b2$var$node.hash = "9f89ce3672c41453eb505fbdd852ee51";
var $189300f3c547d1b2$export$2e2bcd8739ae039 = $189300f3c547d1b2$var$node;

});

parcelRegister("6VsB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $56fb40d9dccec0cf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fa3ecc724c8165a8c16f67b69f379dbc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $56fb40d9dccec0cf$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "cloudId"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_rankField",
    "selections": [
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraJqlFieldWithAliases",
                    "kind": "LinkedField",
                    "name": "rankField",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "ui_nativeIssueTable_NativeIssueTable_rankField"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraQuery"
};
$56fb40d9dccec0cf$var$node.hash = "a97a4dfe64654347c948bfd1fa0c5092";
var $56fb40d9dccec0cf$export$2e2bcd8739ae039 = $56fb40d9dccec0cf$var$node;

});

parcelRegister("bW3jF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b474cf232be6876b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b1ac4ee09aa06d0c162ef3bdadd8c445>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b474cf232be6876b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "name"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$b474cf232be6876b$var$node.hash = "42fd583d4b19e59270b0aa45271f2d67";
var $b474cf232be6876b$export$2e2bcd8739ae039 = $b474cf232be6876b$var$node;

});

parcelRegister("1Fibi", function(module, exports) {

$parcel$export(module.exports, "default", () => $98a08b67ac7f6a8a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8ecb59397caeeba8b1f96e7ccfec494a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $98a08b67ac7f6a8a$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_project",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "key"
        },
        {
            "kind": "ScalarField",
            "name": "projectId"
        },
        {
            "kind": "FragmentSpread",
            "name": "ui_nativeIssueTable_NativeIssueTable_project"
        }
    ],
    "type": "JiraProject"
};
$98a08b67ac7f6a8a$var$node.hash = "704e90d839184a3c8963617bf36efd8c";
var $98a08b67ac7f6a8a$export$2e2bcd8739ae039 = $98a08b67ac7f6a8a$var$node;

});

parcelRegister("2fw1T", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a78a0369755798f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<880b3d5a2390fb0457f1bc5bf5555b6a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $9a78a0369755798f$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "amountOfColumns"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsScope"
        },
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_view",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "viewId"
            },
            "action": "THROW",
            "path": "viewId"
        },
        {
            "kind": "ScalarField",
            "name": "hasDefaultFieldSets"
        },
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                            "fieldSetSelectedState": "SELECTED"
                        }
                    },
                    {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "amountOfColumns"
                    },
                    {
                        "kind": "Variable",
                        "name": "scope",
                        "variableName": "fieldSetsScope"
                    }
                ],
                "concreteType": "JiraIssueSearchFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSets",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "totalCount"
                    },
                    {
                        "concreteType": "JiraIssueSearchFieldSetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraIssueSearchFieldSet",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "fieldSetId"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "FragmentSpread",
                        "name": "ui_nativeIssueTable_NativeIssueTable_columns"
                    },
                    {
                        "kind": "ClientExtension",
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "__id"
                            }
                        ]
                    }
                ]
            },
            "action": "THROW",
            "path": "fieldSets"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "canEnableHierarchy"
                        },
                        {
                            "concreteType": "JiraSpreadsheetGroupByConfig",
                            "kind": "LinkedField",
                            "name": "groupByConfig",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraField",
                                    "kind": "LinkedField",
                                    "name": "groupByField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isHierarchyEnabled"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        },
                        {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscissuerankingrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canEnableReranking"
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraIssueSearchViewMetadata",
    "abstractKey": "__isJiraIssueSearchViewMetadata"
};
$9a78a0369755798f$var$node.hash = "68eb6cf9c2684b23884e4e9fc1efd3ed";
var $9a78a0369755798f$export$2e2bcd8739ae039 = $9a78a0369755798f$var$node;

});

parcelRegister("krXnE", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd44a72c3036ca18$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d652a1b2284d199da24c97c8d94c171c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $cd44a72c3036ca18$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "fieldSetsInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isPaginating"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_groupResults",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isPaginating",
                    "variableName": "isPaginating"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                }
            ],
            "kind": "FragmentSpread",
            "name": "ui_nativeIssueTable_NativeIssueTable_groups"
        },
        {
            "condition": "isPaginating",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraSpreadsheetGroup",
                    "kind": "LinkedField",
                    "name": "firstGroup",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "fieldSetsInput",
                                    "variableName": "fieldSetsInput"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 50
                                }
                            ],
                            "concreteType": "JiraIssueConnection",
                            "kind": "LinkedField",
                            "name": "issues",
                            "plural": false,
                            "selections": [
                                {
                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "ui_issueNavigatorBulkOperationsConnectionsSubscriber_BulkOpsConnectionsSubscriber"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$cd44a72c3036ca18$var$node.hash = "704a4bd6ed89da1a55b318db843e480c";
var $cd44a72c3036ca18$export$2e2bcd8739ae039 = $cd44a72c3036ca18$var$node;

});

parcelRegister("ebHAX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be221d7b1d11260$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<92eb7e574617eb356b13722ca2af5d5b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5be221d7b1d11260$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectKeys"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldQueryHasChildren"
        }
    ],
    "kind": "Fragment",
    "name": "main_issueNavigator_ListView_issueResults",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "registerShortcutDialogActions_issueNavigator_RegisterShortcutsDialogActions"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "isReparentingEnabled",
                    "variableName": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
                },
                {
                    "kind": "Variable",
                    "name": "projectKey",
                    "variableName": "projectKey"
                },
                {
                    "kind": "Variable",
                    "name": "projectKeys",
                    "variableName": "projectKeys"
                },
                {
                    "kind": "Variable",
                    "name": "shouldQueryHasChildren",
                    "variableName": "shouldQueryHasChildren"
                }
            ],
            "kind": "FragmentSpread",
            "name": "ui_nativeIssueTable_NativeIssueTable_issues"
        },
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "maxCursors",
                    "value": 7
                }
            ],
            "concreteType": "JiraPageCursors",
            "kind": "LinkedField",
            "name": "pageCursors",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraPageCursor",
                    "kind": "LinkedField",
                    "name": "around",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "pageNumber"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isCurrent"
                        }
                    ]
                }
            ],
            "storageKey": "pageCursors(maxCursors:7)"
        },
        {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisbulkopsinninenabledrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueNavigatorBulkOperationsConnectionsSubscriber_BulkOpsConnectionsSubscriber"
                }
            ]
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__id"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$5be221d7b1d11260$var$node.hash = "8788f53f8a15dc0aef8fef526135d46a";
var $5be221d7b1d11260$export$2e2bcd8739ae039 = $5be221d7b1d11260$var$node;

});

parcelRegister("6bs0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $c801f3f91f59a7ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gjEtj = parcelRequire("gjEtj");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c801f3f91f59a7ab$var$AsyncAttachFileModal = (0, $kxZPA.lazy)(()=>(parcelRequire("2PYe2")), {
    moduleId: "./src/packages/issue-navigator/issue-operations/dialogs/attach-file-dialog/src/ui/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c801f3f91f59a7ab$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "attach-file-dialog",
        packageName: "native-issue-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c801f3f91f59a7ab$var$AsyncAttachFileModal, null));

});
parcelRegister("2PYe2", function(module, exports) {

let $210f0fb05b7fb84e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $210f0fb05b7fb84e$var$load("3wXgs").then(()=>parcelRequire('jStLa'));

});


parcelRegister("gkVdw", function(module, exports) {

$parcel$export(module.exports, "DialogContextContainer", () => $2bf33a8fdc4b74e3$export$8e9ef3fae6d51d86);
$parcel$export(module.exports, "useIssueOperationsDialogContext", () => $2bf33a8fdc4b74e3$export$a2a00ec2da7337e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $2bf33a8fdc4b74e3$var$initialState = {
    openDialog: null,
    issueKey: null,
    issueId: null,
    workType: null,
    mediaUploadContext: null
};
const $2bf33a8fdc4b74e3$var$actions = {
    setDialogContext: (openDialog, issueId, issueKey, mediaUploadContext, workType)=>({ setState: setState })=>{
            setState({
                openDialog: openDialog,
                issueId: issueId,
                issueKey: issueKey,
                mediaUploadContext: mediaUploadContext,
                workType: workType
            });
        }
};
const $2bf33a8fdc4b74e3$var$Store = (0, $iXqE5.createStore)({
    initialState: $2bf33a8fdc4b74e3$var$initialState,
    actions: $2bf33a8fdc4b74e3$var$actions,
    name: 'IssueNavigatorIssueOperationsDialogContext'
});
const $2bf33a8fdc4b74e3$export$8e9ef3fae6d51d86 = (0, $gg7kZ.createContainer)($2bf33a8fdc4b74e3$var$Store);
const $2bf33a8fdc4b74e3$export$a2a00ec2da7337e = (0, $3sQ5x.createHook)($2bf33a8fdc4b74e3$var$Store);

});

parcelRegister("hH4aB", function(module, exports) {

$parcel$export(module.exports, "MAX_COLUMNS", () => $3fccc46c5f9227b4$export$7ec4af037f372df4);
$parcel$export(module.exports, "createDebouncedColumnLoader", () => $3fccc46c5f9227b4$export$a6cff24b97727de1);
$parcel$export(module.exports, "REMOVE_COLUMNS", () => $3fccc46c5f9227b4$export$191e3e934175a609);
$parcel$export(module.exports, "ADD_COLUMNS", () => $3fccc46c5f9227b4$export$ccf17692f1fc979a);

var $7pFAn = parcelRequire("7pFAn");

const $3fccc46c5f9227b4$export$7ec4af037f372df4 = 500;
const $3fccc46c5f9227b4$export$a6cff24b97727de1 = (0, $7pFAn.createGenericDebouncableDataLoader);
const $3fccc46c5f9227b4$export$191e3e934175a609 = 'REMOVE_COLUMNS';
const $3fccc46c5f9227b4$export$ccf17692f1fc979a = 'ADD_COLUMNS';

});
parcelRegister("7pFAn", function(module, exports) {

$parcel$export(module.exports, "createGenericDebouncableDataLoader", () => $b301ace3fb837e49$export$ea63a11564958c9e);

var $lFKmC = parcelRequire("lFKmC");
const $b301ace3fb837e49$export$ea63a11564958c9e = (dataLoader)=>{
    const debouncedDataLoader = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((search, enableFullList, endCursor, cb)=>dataLoader(search, enableFullList, endCursor).then((data)=>{
            cb(data);
            return data;
        }), 500);
    return (search, enableFullList, endCursor, cb)=>{
        // No need to debounce When no search string is provided.
        // We want the initial list displaying as quickly as possible when a user reopens the dropdown.
        // It will be cached by the GraphQL client and debouncing will show an unneccessary spinner.
        if (!search) {
            debouncedDataLoader.cancel();
            return dataLoader(search, enableFullList, endCursor).then((data)=>{
                cb(data);
                return data;
            });
        }
        return debouncedDataLoader(search, enableFullList, endCursor, cb);
    };
};
var $b301ace3fb837e49$export$2e2bcd8739ae039 = $b301ace3fb837e49$export$ea63a11564958c9e;

});


parcelRegister("aB7bN", function(module, exports) {

$parcel$export(module.exports, "isNonNullish", () => $9f1ae0edfbf313d7$export$70573498ee17fe1d);
$parcel$export(module.exports, "isKnownColumnType", () => $9f1ae0edfbf313d7$export$e8280bcdc1c3f84);
$parcel$export(module.exports, "exclusiveGroupsOrIssuesFragment", () => $9f1ae0edfbf313d7$export$7ac78cf15a1a4ba3);
$parcel$export(module.exports, "getProjectKeyFromIssueKey", () => $9f1ae0edfbf313d7$export$defe38779a6b81d2);
$parcel$export(module.exports, "escapeBackslashes", () => $9f1ae0edfbf313d7$export$fbd15c27bb7e257c);

var $65VLO = parcelRequire("65VLO");

function $9f1ae0edfbf313d7$export$70573498ee17fe1d(value) {
    return value != null;
}
function $9f1ae0edfbf313d7$export$e8280bcdc1c3f84(value) {
    return value !== undefined && Object.values((0, $65VLO.KNOWN_COLUMN_TYPES)).includes(value);
}
function $9f1ae0edfbf313d7$export$7ac78cf15a1a4ba3({ groups: groups, issues: issues }) {
    if (issues) return {
        groups: null,
        issues: issues
    };
    if (groups) return {
        groups: groups,
        issues: null
    };
    return null;
}
function $9f1ae0edfbf313d7$export$defe38779a6b81d2(issueKey) {
    return issueKey.split('-')[0];
}
const $9f1ae0edfbf313d7$export$fbd15c27bb7e257c = (text)=>text.replace(/\\/g, '\\\\');

});

parcelRegister("5iGOJ", function(module, exports) {

$parcel$export(module.exports, "useColumnWidthUpdater", () => $64afe22c2487a08a$export$e54397ae25183faf);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $eiowN = parcelRequire("eiowN");
const $64afe22c2487a08a$export$e54397ae25183faf = (connectionId)=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    return (0, $5uXOq.useCallback)((columnId, width)=>{
        (0, $eiowN.commitLocalUpdate)(environment, (store)=>{
            const connection = store.get(connectionId);
            const fieldSetEdges = connection?.getLinkedRecords('edges') ?? [];
            const fieldSetEdge = fieldSetEdges.find((edge)=>{
                const fieldSetId = edge?.getLinkedRecord('node')?.getValue('fieldSetId');
                return columnId === fieldSetId;
            });
            if (!fieldSetEdge) return;
            const fieldSetNode = fieldSetEdge.getLinkedRecord('node');
            if (!fieldSetNode) return;
            if (width == null) {
                fieldSetNode.setValue(null, 'fieldSetPreferences');
                return;
            }
            const fieldSetPreferences = fieldSetNode.getOrCreateLinkedRecord('fieldSetPreferences', 'JiraFieldSetPreferences');
            fieldSetPreferences.setValue(width, 'width');
        });
    }, [
        connectionId,
        environment
    ]);
};

});

parcelRegister("32GaU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6283edc5fe5ca969$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $l8ruj = parcelRequire("l8ruj");

var $7CMCs = parcelRequire("7CMCs");

var $frBVt = parcelRequire("frBVt");

var $4R6GH = parcelRequire("4R6GH");

var $7iJwP = parcelRequire("7iJwP");

var $hxGva = parcelRequire("hxGva");

const $6283edc5fe5ca969$var$AsyncNativeIssueTable = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7kcpe")), {
    moduleId: "./src/packages/platform/ui/issue-table/issue-table/src/ui/index.tsx"
});
const $6283edc5fe5ca969$var$AsyncNativeIssueTableOld = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hxGva.IssueTableSkeleton), null),
        name: "async-native-issue-table"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6283edc5fe5ca969$var$AsyncNativeIssueTable, props)));
const $6283edc5fe5ca969$var$AsyncNativeIssueTableNew = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const entryPointReference = props.preloadedEntryPoints?.nativeIssueTableEntryPoint;
    const ErrorBoundary = (0, $4R6GH.fg)('improve_nin_slo_events') ? (0, $7iJwP.default) : (0, $7CMCs.JSErrorBoundary);
    if (entryPointReference) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "native-issue-table-entrypoint"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ErrorBoundary, {
        id: "native-issue-table-entrypoint",
        packageName: "jiraNativeIssueTable"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $frBVt.EntryPointReferencePlaceholder), {
        name: "native-issue-table",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hxGva.IssueTableSkeleton), null),
        entryPointReference: entryPointReference
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Uumt.EntryPointContainer), {
        entryPointReference: entryPointReference,
        // EntryPointContainer can't infer the type of props from entryPointReference correctly
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        props: props
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6283edc5fe5ca969$var$AsyncNativeIssueTableOld, props);
});
var $6283edc5fe5ca969$export$2e2bcd8739ae039 = $6283edc5fe5ca969$var$AsyncNativeIssueTableNew;

});
parcelRegister("hxGva", function(module, exports) {

$parcel$export(module.exports, "IssueTableSkeleton", () => $d6b3a71d2cc1f810$export$32020b6a5557f03e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k42jv = parcelRequire("k42jv");
const $d6b3a71d2cc1f810$export$32020b6a5557f03e = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d6b3a71d2cc1f810$var$SkeletonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k42jv.NativeIssueTableSkeleton), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d6b3a71d2cc1f810$var$SkeletonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7kcpe", function(module, exports) {

let $555406398a463f88$var$load = (parcelRequire("28QjX"))(4);



module.exports = Promise.all([
    (parcelRequire("avM1e"))('vc90_async_icon_general_perf_improvements', function() {
        return Promise.all([
            $555406398a463f88$var$load("8i6Do")
        ]);
    }, function() {
        return Promise.all([
            $555406398a463f88$var$load("k6g9p")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $555406398a463f88$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $555406398a463f88$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $555406398a463f88$var$load("cTJTG"),
            $555406398a463f88$var$load("l253H"),
            $555406398a463f88$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $555406398a463f88$var$load("4Qxp7")
        ]);
    }),
    $555406398a463f88$var$load("ffQaD"),
    $555406398a463f88$var$load("kvRbA"),
    $555406398a463f88$var$load("fliVL"),
    $555406398a463f88$var$load("kNFvF"),
    $555406398a463f88$var$load("kQN3l")
]).then(()=>parcelRequire('bPcgy'));

});


parcelRegister("ePhT2", function(module, exports) {

$parcel$export(module.exports, "useIssueNavigatorFeatures", () => $293e0ae5772e12ec$export$403fe21e578d284c);
$parcel$export(module.exports, "IssueNavigatorFeatureProvider", () => $293e0ae5772e12ec$export$682e7a54b8447684);
$parcel$export(module.exports, "IssueNavigatorFeatureGuard", () => $293e0ae5772e12ec$export$7b56b3a54a98f99c);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");
const $293e0ae5772e12ec$var$defaultFeatureContext = {
    isViewSwitcherEnabled: true,
    isOnboardingEnabled: true,
    isExportMenuEnabled: true,
    isRowContextMenuEnabled: true,
    isSaveFilterButtonEnabled: true,
    isBulkChangeWorkItemsEnabled: true,
    isImportWorkItemsFromCSVEnabled: true
};
const $293e0ae5772e12ec$var$IssueNavigatorFeatureContext = /*#__PURE__*/ (0, $5uXOq.createContext)($293e0ae5772e12ec$var$defaultFeatureContext);
const $293e0ae5772e12ec$export$403fe21e578d284c = ()=>(0, $5uXOq.useContext)($293e0ae5772e12ec$var$IssueNavigatorFeatureContext);
const $293e0ae5772e12ec$export$caa5cde5243e13a8 = (featureKey)=>$293e0ae5772e12ec$export$403fe21e578d284c()[featureKey];
const $293e0ae5772e12ec$export$682e7a54b8447684 = ({ children: children, ...props })=>{
    const value = (0, $5uXOq.useMemo)(()=>({
            ...$293e0ae5772e12ec$var$defaultFeatureContext,
            ...props
        }), [
        props
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($293e0ae5772e12ec$var$IssueNavigatorFeatureContext.Provider, {
        value: value
    }, children);
};
const $293e0ae5772e12ec$var$IssueNavigatorFeatureGuard = ({ featureKey: featureKey, on: on, off: off })=>{
    const feature = $293e0ae5772e12ec$export$caa5cde5243e13a8(featureKey);
    return feature ? on : off;
};
const $293e0ae5772e12ec$export$7b56b3a54a98f99c = ({ fallback: fallback, ...props })=>{
    return (0, $4R6GH.fg)('jira_nin_smart_link') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($293e0ae5772e12ec$var$IssueNavigatorFeatureGuard, props) : fallback;
};

});

parcelRegister("jlRhf", function(module, exports) {

$parcel$export(module.exports, "useColumnPickerLoadingContext", () => $7e5a5499bbded874$export$bd7ab5278af9a7dd);
$parcel$export(module.exports, "ColumnPickerLoadingContextProvider", () => $7e5a5499bbded874$export$9e9936dbd6aef092);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $38r5c = parcelRequire("38r5c");
const $7e5a5499bbded874$var$defaultState = {
    isLoading: false,
    setIsRestoringDefaultColumns: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $7e5a5499bbded874$var$ColumnPickerLoadingContext = /*#__PURE__*/ (0, $5uXOq.createContext)($7e5a5499bbded874$var$defaultState);
const $7e5a5499bbded874$export$bd7ab5278af9a7dd = ()=>(0, $5uXOq.useContext)($7e5a5499bbded874$var$ColumnPickerLoadingContext);
const $7e5a5499bbded874$export$9e9936dbd6aef092 = ({ children: children })=>{
    const [isRestoringDefaultColumns, setIsRestoringDefaultColumns] = (0, $5uXOq.useState)(false);
    const isFetchingView = (0, $38r5c.useIsFetchingView)();
    const isRefreshing = (0, $38r5c.useIsRefreshing)();
    const isLoading = isRestoringDefaultColumns || isFetchingView || isRefreshing;
    const contextValue = (0, $5uXOq.useMemo)(()=>({
            isLoading: isLoading,
            setIsRestoringDefaultColumns: setIsRestoringDefaultColumns
        }), [
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7e5a5499bbded874$var$ColumnPickerLoadingContext.Provider, {
        value: contextValue
    }, children);
};

});

parcelRegister("hZQx0", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerMessageContext", () => $709509bebc56c733$export$2f14e8286acf4660);

var $5uXOq = parcelRequire("5uXOq");
const $709509bebc56c733$var$defaultMessageContext = {
    hasMaxSelectedColumns: false
};
const $709509bebc56c733$export$2f14e8286acf4660 = /*#__PURE__*/ (0, $5uXOq.createContext)($709509bebc56c733$var$defaultMessageContext);

});

parcelRegister("kiKYF", function(module, exports) {

$parcel$export(module.exports, "useColumnLoader", () => $c727c8c1b7da3679$export$6dc2ac601f90aafc);

var $5MNOm = parcelRequire("5MNOm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $dS3PR = parcelRequire("dS3PR");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $hH4aB = parcelRequire("hH4aB");

var $Nu4Sg = parcelRequire("Nu4Sg");

var $kHDIc = parcelRequire("kHDIc");

var $koeKL = parcelRequire("koeKL");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $bWSqf = parcelRequire("bWSqf");

var $2F3SN = parcelRequire("2F3SN");
const $c727c8c1b7da3679$var$mapColumnPickerOptions = (data, search, intl, selectedColumns, canEditColumns, isIFCEnabled)=>{
    let totalCount = 0;
    let edges;
    let endCursor;
    if (!isIFCEnabled && data?.jira.issueSearchViewByNamespaceAndViewId?.fieldSets) {
        totalCount = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount;
        edges = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges;
        endCursor = data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.pageInfo?.endCursor ? data?.jira.issueSearchViewByNamespaceAndViewId.fieldSets.pageInfo.endCursor : undefined;
    }
    if (isIFCEnabled && data?.jira.issueSearchViewResult?.fieldSets) {
        totalCount = data?.jira.issueSearchViewResult.fieldSets.totalCount;
        edges = data?.jira.issueSearchViewResult.fieldSets.edges;
        endCursor = data?.jira.issueSearchViewResult.fieldSets.pageInfo?.endCursor ? data?.jira.issueSearchViewResult.fieldSets.pageInfo.endCursor : undefined;
    }
    // @ts-expect-error - Argument of type '(edge: Node) => { secondaryLabel?: JSX.Element | undefined; isDisabled?: true | undefined; disabledMessage?: React.ReactNode; optionType: "option"; cursor: string; value: string; label: string; }' is not assignable to parameter of type '(value: { readonly cursor: string; readonly node: { readonly displayName: string; readonly fieldSetId: string; readonly fieldType?: { readonly displayName: string | null | undefined; } | null | undefined; readonly type: string; }; }, index: number, array: { ...; }[]) => { ...; }'.
    const options = edges?.filter((0, $eJ0Zs.isNonNullish)).map((edge)=>{
        const fieldTypeDisplayName = edge.node.fieldType?.displayName;
        const icon = edge.node.type ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kHDIc.FieldTypeIcon), {
            type: edge.node.type,
            size: "small"
        }) : undefined;
        const isOnlyUnselectable = (0, $2F3SN.isOnlyUnselectableField)(edge.node.type, canEditColumns);
        return {
            optionType: 'option',
            cursor: edge.cursor,
            value: edge.node.fieldSetId,
            label: edge.node.displayName,
            secondaryLabel: fieldTypeDisplayName && icon ? (0, $Nu4Sg.getSecondaryLabelWithIcon)(icon, fieldTypeDisplayName) : undefined,
            ...isOnlyUnselectable && {
                isOnlyUnselectable: isOnlyUnselectable,
                disabledMessage: intl.formatMessage((0, $bWSqf.default).deprecatedParentyLinkMessage, {
                    field: edge.node.displayName,
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                            as: "strong",
                            color: "inherit",
                            size: "UNSAFE_small"
                        }, chunks)
                })
            },
            ...isIFCEnabled && {
                customWidth: edge.node.fieldSetPreferences?.width,
                type: edge.node.type
            }
        };
    });
    if (!options?.length) return {
        options: [],
        totalCount: 0
    };
    if (search.length) return {
        options: options,
        totalCount: totalCount,
        endCursor: endCursor
    };
    // total count is the count of unselected options for non-search queries
    totalCount += selectedColumns.length;
    return {
        options: [
            {
                id: (0, $6UAdF.ALL_COLUMNS_ID),
                label: intl.formatMessage((0, $bWSqf.default).columnGroupHeader),
                optionType: 'group',
                options: options
            }
        ],
        totalCount: totalCount,
        endCursor: endCursor
    };
};
const $c727c8c1b7da3679$export$6dc2ac601f90aafc = (viewId, canEditColumns, selectedColumns, isIFCEnabled)=>{
    const intl = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $8Uumt.useRelayEnvironment)();
    // refs for selectedColumns, endCursor and search prevent outdated data in the relay store from being used
    // in cases when selected options changes & picker is paginated
    const columnsRef = (0, $5uXOq.useRef)(selectedColumns);
    const endCursorRef = (0, $5uXOq.useRef)();
    const searchRef = (0, $5uXOq.useRef)();
    const loadedOptionsRef = (0, $5uXOq.useRef)();
    return (0, $5uXOq.useMemo)(()=>(0, $hH4aB.createDebouncedColumnLoader)(async (search, renderInitialValues, endCursor)=>{
            let cursor = endCursor;
            if (!canEditColumns) {
                const options = selectedColumns ? selectedColumns.filter((col)=>col.optionType === 'option' && (search ? col.label.toLocaleLowerCase().includes(search.toLocaleLowerCase()) : true)) : [];
                return Promise.resolve({
                    options: options,
                    totalCount: options.length
                });
            }
            // calculate cursor from edges, since endCursor might not be valid anymore when last option was selected
            if (endCursor !== undefined && loadedOptionsRef.current && selectedColumns) cursor = (0, $2F3SN.getCursorOfLastUnselectedOption)(loadedOptionsRef.current, selectedColumns, search, endCursor);
            try {
                const result = await (0, $8Uumt.fetchQuery)(environment, (0, $5MNOm.default), {
                    cloudId: cloudId,
                    namespace: (0, $6UAdF.ISSUE_SEARCH_NAMESPACE),
                    viewId: viewId,
                    first: 25,
                    after: cursor,
                    filter: {
                        searchString: search,
                        fieldSetSelectedState: !search ? 'NON_SELECTED' : 'ALL'
                    },
                    isIFCEnabled: !!isIFCEnabled
                }, {
                    fetchPolicy: columnsRef.current !== selectedColumns || endCursorRef.current !== cursor || searchRef.current !== search ? 'network-only' : 'store-or-network'
                }).toPromise();
                columnsRef.current = selectedColumns;
                endCursorRef.current = cursor;
                searchRef.current = search;
                const pickerOptions = $c727c8c1b7da3679$var$mapColumnPickerOptions(result, search, intl, selectedColumns, canEditColumns, isIFCEnabled);
                loadedOptionsRef.current = pickerOptions.options || undefined;
                return pickerOptions;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    meta: {
                        id: 'fetchColumnPickerOptions',
                        packageName: (0, $6UAdF.PACKAGE_NAME),
                        teamName: (0, $6UAdF.TEAM_NAME)
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                loadedOptionsRef.current = undefined;
                return {
                    options: [
                        {
                            optionType: 'error',
                            error: error,
                            onRetry: ()=>undefined
                        }
                    ],
                    totalCount: 0
                };
            }
        }), [
        canEditColumns,
        cloudId,
        environment,
        intl,
        isIFCEnabled,
        selectedColumns,
        viewId
    ]);
};

});
parcelRegister("5MNOm", function(module, exports) {

$parcel$export(module.exports, "default", () => $611919e8b187ec0e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2ede3a039e0a48fb848162fb9dde351a>>
 * @relayHash cab0eefa33d0d1c36a97ce8b73b3afb4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 446095d828f64da903b60abae20e5d251003a76cbf9d089a7ca34036c1918133
const $611919e8b187ec0e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filter"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIFCEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "namespace"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "viewId"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "namespace",
            "variableName": "namespace"
        },
        {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
        }
    ], v8 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "totalCount"
    }, v10 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v12 = {
        "kind": "ScalarField",
        "name": "fieldSetId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v14 = {
        "kind": "ScalarField",
        "name": "type"
    }, v15 = {
        "concreteType": "JiraFieldType",
        "kind": "LinkedField",
        "name": "fieldType",
        "plural": false,
        "selections": [
            v13 /*: any*/ 
        ]
    }, v16 = {
        "concreteType": "JiraFieldSetPreferences",
        "kind": "LinkedField",
        "name": "fieldSetPreferences",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "width"
            }
        ]
    }, v17 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "fetchColumnPickerOptionsQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "isIFCEnabled",
                                "kind": "Condition",
                                "passingValue": false,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v7 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchView",
                                            "kind": "LinkedField",
                                            "name": "issueSearchViewByNamespaceAndViewId",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": {
                                                        "args": v8 /*: any*/ ,
                                                        "concreteType": "JiraIssueSearchFieldSetConnection",
                                                        "kind": "LinkedField",
                                                        "name": "fieldSets",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v9 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.totalCount"
                                                            },
                                                            v10 /*: any*/ ,
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": {
                                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v11 /*: any*/ ,
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": {
                                                                                "concreteType": "JiraIssueSearchFieldSet",
                                                                                "kind": "LinkedField",
                                                                                "name": "node",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v12 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.fieldSetId"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v13 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.displayName"
                                                                                    },
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v14 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node.type"
                                                                                    },
                                                                                    v15 /*: any*/ 
                                                                                ]
                                                                            },
                                                                            "action": "THROW",
                                                                            "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges.node"
                                                                        }
                                                                    ]
                                                                },
                                                                "action": "THROW",
                                                                "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets.edges"
                                                            }
                                                        ]
                                                    },
                                                    "action": "THROW",
                                                    "path": "jira.issueSearchViewByNamespaceAndViewId.fieldSets"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.issueSearchViewByNamespaceAndViewId"
                                    }
                                ]
                            },
                            {
                                "condition": "isIFCEnabled",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "RequiredField",
                                        "field": {
                                            "args": v7 /*: any*/ ,
                                            "kind": "LinkedField",
                                            "name": "issueSearchViewResult",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "RequiredField",
                                                            "field": {
                                                                "args": v8 /*: any*/ ,
                                                                "concreteType": "JiraIssueSearchFieldSetConnection",
                                                                "kind": "LinkedField",
                                                                "name": "fieldSets",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v9 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "jira.issueSearchViewResult.fieldSets.totalCount"
                                                                    },
                                                                    v10 /*: any*/ ,
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": {
                                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v11 /*: any*/ ,
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": {
                                                                                        "concreteType": "JiraIssueSearchFieldSet",
                                                                                        "kind": "LinkedField",
                                                                                        "name": "node",
                                                                                        "plural": false,
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": v12 /*: any*/ ,
                                                                                                "action": "THROW",
                                                                                                "path": "jira.issueSearchViewResult.fieldSets.edges.node.fieldSetId"
                                                                                            },
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": v13 /*: any*/ ,
                                                                                                "action": "THROW",
                                                                                                "path": "jira.issueSearchViewResult.fieldSets.edges.node.displayName"
                                                                                            },
                                                                                            {
                                                                                                "kind": "RequiredField",
                                                                                                "field": v14 /*: any*/ ,
                                                                                                "action": "THROW",
                                                                                                "path": "jira.issueSearchViewResult.fieldSets.edges.node.type"
                                                                                            },
                                                                                            v15 /*: any*/ ,
                                                                                            v16 /*: any*/ 
                                                                                        ]
                                                                                    },
                                                                                    "action": "THROW",
                                                                                    "path": "jira.issueSearchViewResult.fieldSets.edges.node"
                                                                                }
                                                                            ]
                                                                        },
                                                                        "action": "THROW",
                                                                        "path": "jira.issueSearchViewResult.fieldSets.edges"
                                                                    }
                                                                ]
                                                            },
                                                            "action": "THROW",
                                                            "path": "jira.issueSearchViewResult.fieldSets"
                                                        }
                                                    ],
                                                    "type": "JiraIssueSearchView"
                                                }
                                            ]
                                        },
                                        "action": "THROW",
                                        "path": "jira.issueSearchViewResult"
                                    }
                                ]
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "fetchColumnPickerOptionsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "condition": "isIFCEnabled",
                            "kind": "Condition",
                            "passingValue": false,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "concreteType": "JiraIssueSearchView",
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewByNamespaceAndViewId",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": v8 /*: any*/ ,
                                            "concreteType": "JiraIssueSearchFieldSetConnection",
                                            "kind": "LinkedField",
                                            "name": "fieldSets",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                {
                                                    "concreteType": "JiraIssueSearchFieldSetEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        v11 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSet",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                v12 /*: any*/ ,
                                                                v13 /*: any*/ ,
                                                                v14 /*: any*/ ,
                                                                v15 /*: any*/ 
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        v17 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "condition": "isIFCEnabled",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                                {
                                    "args": v7 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "issueSearchViewResult",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "args": v8 /*: any*/ ,
                                                    "concreteType": "JiraIssueSearchFieldSetConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldSets",
                                                    "plural": false,
                                                    "selections": [
                                                        v9 /*: any*/ ,
                                                        v10 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssueSearchFieldSetEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                v11 /*: any*/ ,
                                                                {
                                                                    "concreteType": "JiraIssueSearchFieldSet",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraIssueSearchView"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                v17 /*: any*/ 
                                            ],
                                            "type": "Node",
                                            "abstractKey": "__isNode"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "446095d828f64da903b60abae20e5d251003a76cbf9d089a7ca34036c1918133",
            "metadata": {},
            "name": "fetchColumnPickerOptionsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$611919e8b187ec0e$var$node.hash = "921f1fdd989c0f6dbf67c6e1e7e52de9";
var $611919e8b187ec0e$export$2e2bcd8739ae039 = $611919e8b187ec0e$var$node;

});

parcelRegister("Nu4Sg", function(module, exports) {

$parcel$export(module.exports, "getSecondaryLabelWithIcon", () => $f4ca1075411980d4$export$de24d837eb50c435);

var $5uXOq = parcelRequire("5uXOq");
const $f4ca1075411980d4$export$de24d837eb50c435 = (icon, fieldTypeDisplayName)=>({
        label: fieldTypeDisplayName,
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, icon, fieldTypeDisplayName)
    });

});

parcelRegister("kHDIc", function(module, exports) {

$parcel$export(module.exports, "fieldTypesIcons", () => $84df96f6dc813d24$export$67f993f3bbfb364d);
$parcel$export(module.exports, "panelIcons", () => $84df96f6dc813d24$export$4641b622f6c36f58);
$parcel$export(module.exports, "allFieldTypeGlyphs", () => $84df96f6dc813d24$export$14355977bfae6aaa);
$parcel$export(module.exports, "StrictFieldTypeIcon", () => $84df96f6dc813d24$export$aaac7dbe01e6025d);
$parcel$export(module.exports, "FieldTypeIcon", () => $84df96f6dc813d24$export$87c5289d8835f589);
$parcel$export(module.exports, "default", () => $84df96f6dc813d24$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $4iV1e = parcelRequire("4iV1e");

var $b0XU0 = parcelRequire("b0XU0");

var $4hqZ5 = parcelRequire("4hqZ5");

var $h8cgU = parcelRequire("h8cgU");

var $fyC9a = parcelRequire("fyC9a");

var $5fc53 = parcelRequire("5fc53");

var $5fc53 = parcelRequire("5fc53");
var $3XO6n = parcelRequire("3XO6n");

var $VoGvu = parcelRequire("VoGvu");
// @ts-expect-error - TS2322 - Type '(props: { [key: string]: string; }) => ReactElement<any, string | JSXElementConstructor<any>>' is not assignable to type 'ComponentType<CustomGlyphProps> | undefined'.
const $84df96f6dc813d24$var$ResizedIcon = ({ glyph: glyph })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: "",
        glyph: glyph,
        size: "medium"
    });
const $84df96f6dc813d24$var$checkedFieldTypesIcons = {
    [(0, $5fc53.NUMBER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.numberGlyph)
    }),
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.numberGlyph)
    }),
    [(0, $5fc53.LABELS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    [(0, $5fc53.DATE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    [(0, $5fc53.DATETIME_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.radioGlyph)
    }),
    [(0, $5fc53.SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.doubleDropdownGlyph)
    }),
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.VERSION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $3XO6n.USERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $3XO6n.MULTIUSERPICKER_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.PEOPLE_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.FLAGGED_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    [(0, $5fc53.URL_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    [(0, $5fc53.TEAM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    // <ResizedIcon /> was introduced when SWIFT had a limited number of supported field types,
    // but it's no longer a scalable option. We should be using icons directly provided by @atlaskit,
    // and if it does not match our design constraints, then we'll need to investigate contributing to a new @atlaskit icon set.
    [(0, $5fc53.TEAMS_PLATFORM_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4hqZ5))), {
        spacing: "spacious",
        label: ""
    }),
    [(0, $5fc53.PARENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    [(0, $5fc53.BASELINE_START_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    [(0, $5fc53.BASELINE_END_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    [(0, $5fc53.SPRINT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.shipGlyph)
    }),
    [(0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGroupGlyph)
    }),
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.officeBuildingGlyph)
    }),
    [(0, $5fc53.REPORTER_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.ATTACHMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.attachmentGlyph)
    }),
    [(0, $5fc53.ASSIGNEE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    [(0, $5fc53.LABELS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    [(0, $5fc53.PRIORITY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.priorityGlyph)
    }),
    [(0, $5fc53.DUE_DATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    [(0, $5fc53.TIME_ESTIMATE_CONFIG_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    [(0, $5fc53.TIME_TRACKING_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeTrackingGlyph)
    }),
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.originalTimeEstimateGlyph)
    }),
    [(0, $5fc53.ASSETS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.screenGlyph)
    }),
    [(0, $5fc53.SERVICE_ENTITY_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    [(0, $5fc53.STATUS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.arrowRightGlyph)
    }),
    [(0, $5fc53.SUMMARY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.shortTextGlyph)
    }),
    [(0, $3XO6n.DESCRIPTION_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.TEXT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.shortTextGlyph)
    }),
    [(0, $3XO6n.TEXT_AREA_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.checkboxGlyph)
    }),
    [(0, $5fc53.ISSUE_LINKS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    [(0, $3XO6n.ENVIRONMENT_FIELD_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.COMMENT_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.commentGlyph)
    }),
    [(0, $5fc53.APPROVERS_LIST_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.appAccessGlyph)
    }),
    [(0, $5fc53.APPROVALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.appAccessGlyph)
    }),
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.folderGlyph)
    }),
    [(0, $5fc53.MESSAGE_EDIT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.MESSAGE_VIEW_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    [(0, $5fc53.CATEGORY_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.jwmCategoryGlyph)
    }),
    [(0, $5fc53.ENTITLEMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    [(0, $5fc53.SENTIMENT_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    }),
    [(0, $5fc53.GOALS_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))), {
        label: "",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }),
    [(0, $5fc53.ORGANIZATION_CF_TYPE)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    })
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
({
    ...$84df96f6dc813d24$var$checkedFieldTypesIcons
});
const $84df96f6dc813d24$export$67f993f3bbfb364d = $84df96f6dc813d24$var$checkedFieldTypesIcons;
const $84df96f6dc813d24$export$4641b622f6c36f58 = {
    development: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b0XU0))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    }),
    devSummary: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b0XU0))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    }),
    timetracking: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fyC9a))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    })
};
/**
 * @deprecated - consider using allFieldTypeGlyphs or FieldTypeIcon instead
 */ const $84df96f6dc813d24$var$allIcons = {
    ...$84df96f6dc813d24$export$67f993f3bbfb364d,
    text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.paragraphGlyph)
    }),
    number: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.numberGlyph)
    }),
    date: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dateGlyph)
    }),
    datetime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    dropdown: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    addon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.addonGlyph)
    }),
    checkbox: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.checkboxGlyph)
    }),
    user: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.peopleGlyph)
    }),
    radio: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.radioGlyph)
    }),
    time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.timeStampGlyph)
    }),
    message: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.commentGlyph)
    }),
    bulletList: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.bulletListGlyph)
    }),
    label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    labelpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.labelGlyph)
    }),
    close: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.closeGlyph)
    }),
    assetspicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.screenGlyph)
    }),
    select: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    multiselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    cascadingselect: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.doubleDropdownGlyph)
    }),
    multigrouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    grouppicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    multiversion: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    version: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    projectpicker: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.dropdownGlyph)
    }),
    customField: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($84df96f6dc813d24$var$ResizedIcon, {
        glyph: (0, $VoGvu.customFieldGlyph)
    })
};
const $84df96f6dc813d24$var$checkedFieldTypesGlyphs = {
    [(0, $5fc53.NUMBER_CF_TYPE)]: (0, $VoGvu.numberGlyph),
    [(0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE)]: (0, $VoGvu.numberGlyph),
    [(0, $5fc53.LABELS_CF_TYPE)]: (0, $VoGvu.labelGlyph),
    [(0, $5fc53.DATE_CF_TYPE)]: (0, $VoGvu.dateGlyph),
    [(0, $5fc53.DATETIME_CF_TYPE)]: (0, $VoGvu.timeStampGlyph),
    [(0, $5fc53.RADIO_BUTTONS_CF_TYPE)]: (0, $VoGvu.radioGlyph),
    [(0, $5fc53.SELECT_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.MULTI_SELECT_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.CASCADING_SELECT_CF_TYPE)]: (0, $VoGvu.doubleDropdownGlyph),
    [(0, $5fc53.MULTI_VERSION_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.VERSION_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.GROUP_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.MULTI_GROUP_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.USER_CF_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $3XO6n.USERPICKER_FIELD_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.MULTI_USER_CF_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $3XO6n.MULTIUSERPICKER_FIELD_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.PEOPLE_CF_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.FLAGGED_CF_TYPE)]: (0, $VoGvu.timeStampGlyph),
    [(0, $5fc53.URL_CF_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $5fc53.TEAM_CF_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $5fc53.PARENT_CF_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $5fc53.BASELINE_START_CF_TYPE)]: (0, $VoGvu.dateGlyph),
    [(0, $5fc53.BASELINE_END_CF_TYPE)]: (0, $VoGvu.dateGlyph),
    [(0, $5fc53.SPRINT_TYPE)]: (0, $VoGvu.shipGlyph),
    [(0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE)]: (0, $VoGvu.peopleGroupGlyph),
    [(0, $5fc53.ORGANIZATIONS_CF_TYPE)]: (0, $VoGvu.officeBuildingGlyph),
    [(0, $5fc53.REPORTER_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.ATTACHMENT_TYPE)]: (0, $VoGvu.attachmentGlyph),
    [(0, $5fc53.ASSIGNEE_TYPE)]: (0, $VoGvu.peopleGlyph),
    [(0, $5fc53.LABELS_TYPE)]: (0, $VoGvu.labelGlyph),
    [(0, $5fc53.PRIORITY_TYPE)]: (0, $VoGvu.priorityGlyph),
    [(0, $5fc53.DUE_DATE_TYPE)]: (0, $VoGvu.dateGlyph),
    [(0, $5fc53.TIME_ESTIMATE_CONFIG_TYPE)]: (0, $VoGvu.timeStampGlyph),
    [(0, $5fc53.TIME_TRACKING_TYPE)]: (0, $VoGvu.timeTrackingGlyph),
    [(0, $5fc53.TIME_ESTIMATE_TYPE)]: (0, $VoGvu.originalTimeEstimateGlyph),
    [(0, $5fc53.ASSETS_CF_TYPE)]: (0, $VoGvu.screenGlyph),
    [(0, $5fc53.SERVICE_ENTITY_CF_TYPE)]: (0, $VoGvu.labelGlyph),
    [(0, $5fc53.STATUS_TYPE)]: (0, $VoGvu.arrowRightGlyph),
    [(0, $5fc53.SUMMARY_TYPE)]: (0, $VoGvu.shortTextGlyph),
    [(0, $3XO6n.DESCRIPTION_FIELD_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.TEXT_CF_TYPE)]: (0, $VoGvu.shortTextGlyph),
    [(0, $3XO6n.TEXT_AREA_CF_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)]: (0, $VoGvu.checkboxGlyph),
    [(0, $5fc53.ISSUE_LINKS_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $3XO6n.ENVIRONMENT_FIELD_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.FIX_VERSIONS_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.COMMENT_TYPE)]: (0, $VoGvu.commentGlyph),
    [(0, $5fc53.APPROVERS_LIST_CF_TYPE)]: (0, $VoGvu.appAccessGlyph),
    [(0, $5fc53.APPROVALS_CF_TYPE)]: (0, $VoGvu.appAccessGlyph),
    [(0, $5fc53.PROJECT_PICKER_CF_TYPE)]: (0, $VoGvu.folderGlyph),
    [(0, $5fc53.MESSAGE_EDIT_CF_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.MESSAGE_VIEW_CF_TYPE)]: (0, $VoGvu.paragraphGlyph),
    [(0, $5fc53.CATEGORY_TYPE)]: (0, $VoGvu.jwmCategoryGlyph),
    [(0, $5fc53.ENTITLEMENT_CF_TYPE)]: (0, $VoGvu.dropdownGlyph),
    [(0, $5fc53.SENTIMENT_CF_TYPE)]: (0, $VoGvu.customFieldGlyph),
    [(0, $5fc53.ORGANIZATION_CF_TYPE)]: (0, $VoGvu.customFieldGlyph)
};
const $84df96f6dc813d24$export$14355977bfae6aaa = {
    ...$84df96f6dc813d24$var$checkedFieldTypesGlyphs,
    text: (0, $VoGvu.paragraphGlyph),
    number: (0, $VoGvu.numberGlyph),
    date: (0, $VoGvu.dateGlyph),
    datetime: (0, $VoGvu.timeStampGlyph),
    dropdown: (0, $VoGvu.dropdownGlyph),
    addon: (0, $VoGvu.addonGlyph),
    checkbox: (0, $VoGvu.checkboxGlyph),
    user: (0, $VoGvu.peopleGlyph),
    radio: (0, $VoGvu.radioGlyph),
    time: (0, $VoGvu.timeStampGlyph),
    message: (0, $VoGvu.commentGlyph),
    bulletList: (0, $VoGvu.bulletListGlyph),
    label: (0, $VoGvu.labelGlyph),
    labelpicker: (0, $VoGvu.labelGlyph),
    close: (0, $VoGvu.closeGlyph),
    assetspicker: (0, $VoGvu.screenGlyph),
    select: (0, $VoGvu.dropdownGlyph),
    multiselect: (0, $VoGvu.dropdownGlyph),
    cascadingselect: (0, $VoGvu.doubleDropdownGlyph),
    multigrouppicker: (0, $VoGvu.dropdownGlyph),
    grouppicker: (0, $VoGvu.dropdownGlyph),
    multiversion: (0, $VoGvu.dropdownGlyph),
    version: (0, $VoGvu.dropdownGlyph),
    projectpicker: (0, $VoGvu.dropdownGlyph),
    customField: (0, $VoGvu.customFieldGlyph)
};
const $84df96f6dc813d24$export$aaac7dbe01e6025d = /*#__PURE__*/ (0, $5uXOq.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h8cgU))), {
        label: "",
        size: size,
        testId: testId
    });
    if (type === (0, $5fc53.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: "",
        glyph: $84df96f6dc813d24$var$checkedFieldTypesGlyphs[type] || $84df96f6dc813d24$var$checkedFieldTypesGlyphs.customField,
        size: size,
        testId: testId
    });
});
const $84df96f6dc813d24$export$87c5289d8835f589 = /*#__PURE__*/ (0, $5uXOq.memo)(({ type: type, size: size = 'medium', testId: testId })=>{
    if (type === (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h8cgU))), {
        label: "",
        size: size,
        testId: testId
    });
    if (type === (0, $5fc53.GOALS_CF_TYPE)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iV1e))), {
        label: "",
        spacing: "spacious",
        testId: testId,
        color: "var(--ds-icon, #44546F)"
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        label: "",
        glyph: $84df96f6dc813d24$export$14355977bfae6aaa[type] || $84df96f6dc813d24$export$14355977bfae6aaa.customField,
        size: size,
        testId: testId
    });
});
var /**
 * @deprecated - Use allFieldTypeGlyphs or FieldTypeIcon instead.
 */ $84df96f6dc813d24$export$2e2bcd8739ae039 = $84df96f6dc813d24$var$allIcons;

});
parcelRegister("b0XU0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bf5f697d891cc6bba8e40c46639eb125>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $804e2928682a9df6$var$_react = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $804e2928682a9df6$var$_branch = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("4iPF3")));

var $804e2928682a9df6$var$_branches = $804e2928682a9df6$var$_interopRequireDefault((parcelRequire("9XvX5")));
function $804e2928682a9df6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for BranchIcon.
 * This component is BranchIcon, with `UNSAFE_fallbackIcon` set to "BitbucketBranchesIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $804e2928682a9df6$var$BranchIcon = (props)=>/*#__PURE__*/ $804e2928682a9df6$var$_react.default.createElement($804e2928682a9df6$var$_branch.default, Object.assign({
        LEGACY_fallbackIcon: $804e2928682a9df6$var$_branches.default
    }, props));
$804e2928682a9df6$var$BranchIcon.Name = 'BranchIconMigration';
var $804e2928682a9df6$var$_default = module.exports.default = $804e2928682a9df6$var$BranchIcon;

});
parcelRegister("4iPF3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3220eab15e59539d$var$_react = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3220eab15e59539d$var$_baseNew = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3220eab15e59539d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3220eab15e59539d$var$BranchIcon = (props)=>/*#__PURE__*/ $3220eab15e59539d$var$_react.default.createElement($3220eab15e59539d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$3220eab15e59539d$var$BranchIcon.displayName = 'BranchIcon';
var $3220eab15e59539d$var$_default = module.exports.default = $3220eab15e59539d$var$BranchIcon;

});

parcelRegister("9XvX5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $740268c474e86b43$var$_react = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $740268c474e86b43$var$_branch = $740268c474e86b43$var$_interopRequireDefault((parcelRequire("4iPF3")));
function $740268c474e86b43$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $740268c474e86b43$var$BitbucketBranchesIcon = (props)=>/*#__PURE__*/ $740268c474e86b43$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3M8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1m8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1m-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1"/></svg>`
    }, props, {
        newIcon: $740268c474e86b43$var$_branch.default
    }));
$740268c474e86b43$var$BitbucketBranchesIcon.displayName = 'BitbucketBranchesIcon';
var $740268c474e86b43$var$_default = module.exports.default = $740268c474e86b43$var$BitbucketBranchesIcon;

});


parcelRegister("fyC9a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f8fa98d5af7aa71848cf5218e04fd5c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b5379f2924fc9e12$var$_react = $b5379f2924fc9e12$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b5379f2924fc9e12$var$_stopwatch = $b5379f2924fc9e12$var$_interopRequireDefault((parcelRequire("cXVn2")));

var $b5379f2924fc9e12$var$_stopwatch2 = $b5379f2924fc9e12$var$_interopRequireDefault((parcelRequire("63gsv")));
function $b5379f2924fc9e12$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for StopwatchIcon.
 * This component is StopwatchIcon, with `UNSAFE_fallbackIcon` set to "StopwatchIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b5379f2924fc9e12$var$StopwatchIcon = (props)=>/*#__PURE__*/ $b5379f2924fc9e12$var$_react.default.createElement($b5379f2924fc9e12$var$_stopwatch.default, Object.assign({
        LEGACY_fallbackIcon: $b5379f2924fc9e12$var$_stopwatch2.default
    }, props));
$b5379f2924fc9e12$var$StopwatchIcon.Name = 'StopwatchIconMigration';
var $b5379f2924fc9e12$var$_default = module.exports.default = $b5379f2924fc9e12$var$StopwatchIcon;

});
parcelRegister("cXVn2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da0501648aefebd7252ab6523b352986>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $97077f52e189c3c9$var$_react = $97077f52e189c3c9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $97077f52e189c3c9$var$_baseNew = $97077f52e189c3c9$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $97077f52e189c3c9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Stopwatch".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: timer in Confluence Whiteboards.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $97077f52e189c3c9$var$StopwatchIcon = (props)=>/*#__PURE__*/ $97077f52e189c3c9$var$_react.default.createElement($97077f52e189c3c9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 0h6v1.5H8.75v1.543a6.47 6.47 0 0 1 3.06 1.19l1.137-1.24 1.106 1.014-1.137 1.24a6.5 6.5 0 1 1-9.832 0l-1.137-1.24 1.106-1.014 1.137 1.24a6.47 6.47 0 0 1 3.06-1.19V1.5H5zm3 4.5a4.98 4.98 0 0 0-3.378 1.314A5 5 0 1 0 8 4.5m2.842 3.01-2.541 2.75-1.102-1.02 2.542-2.75z" clip-rule="evenodd"/>`
    }, props));
$97077f52e189c3c9$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $97077f52e189c3c9$var$_default = module.exports.default = $97077f52e189c3c9$var$StopwatchIcon;

});

parcelRegister("63gsv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $467fca4622452061$var$_react = $467fca4622452061$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $467fca4622452061$var$_stopwatch = $467fca4622452061$var$_interopRequireDefault((parcelRequire("cXVn2")));
function $467fca4622452061$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $467fca4622452061$var$StopwatchIcon = (props)=>/*#__PURE__*/ $467fca4622452061$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.587 6.988.626-.664c.203-.215.481-.324.76-.324.247 0 .496.086.694.262a.98.98 0 0 1 .063 1.414l-.565.6a7 7 0 1 1-10.33 0l-.564-.6a.98.98 0 0 1 .062-1.414A1.04 1.04 0 0 1 7.03 6c.278 0 .556.109.76.324l.624.664a7 7 0 0 1 2.582-.916L10.998 5H10.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.498l.001 1.071a7 7 0 0 1 2.584.917M12 18a5 5 0 1 0 0-10 5 5 0 0 0 0 10m.368-4.232a.796.796 0 0 1-1.14-.018.834.834 0 0 1 .018-1.163l2.386-2.355a.796.796 0 0 1 1.14.018.834.834 0 0 1-.018 1.163z"/></svg>`
    }, props, {
        newIcon: $467fca4622452061$var$_stopwatch.default
    }));
$467fca4622452061$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $467fca4622452061$var$_default = module.exports.default = $467fca4622452061$var$StopwatchIcon;

});


parcelRegister("VoGvu", function(module, exports) {

$parcel$export(module.exports, "numberGlyph", () => $2e91e7edf801074a$export$b368272069fe93ea);
$parcel$export(module.exports, "checkboxGlyph", () => $2e91e7edf801074a$export$747056db840f2e62);
$parcel$export(module.exports, "folderGlyph", () => $2e91e7edf801074a$export$fc939f15c0ac57d8);
$parcel$export(module.exports, "dateGlyph", () => $2e91e7edf801074a$export$54ae6633cc16eed1);
$parcel$export(module.exports, "dropdownGlyph", () => $2e91e7edf801074a$export$d298f123ec74117c);
$parcel$export(module.exports, "doubleDropdownGlyph", () => $2e91e7edf801074a$export$b3ea0fc10228ca3e);
$parcel$export(module.exports, "labelGlyph", () => $2e91e7edf801074a$export$fc64eea29ed0831d);
$parcel$export(module.exports, "paragraphGlyph", () => $2e91e7edf801074a$export$cbee9ded46569696);
$parcel$export(module.exports, "peopleGlyph", () => $2e91e7edf801074a$export$2ade78849d2113ea);
$parcel$export(module.exports, "shortTextGlyph", () => $2e91e7edf801074a$export$1c6cf19eb34bcc14);
$parcel$export(module.exports, "timeStampGlyph", () => $2e91e7edf801074a$export$98a4a461fe316fce);
$parcel$export(module.exports, "timeTrackingGlyph", () => $2e91e7edf801074a$export$637d50811e2b7176);
$parcel$export(module.exports, "originalTimeEstimateGlyph", () => $2e91e7edf801074a$export$bc2bb299bed9df91);
$parcel$export(module.exports, "arrowRightGlyph", () => $2e91e7edf801074a$export$3a9d3f1c52f4dab9);
$parcel$export(module.exports, "addonGlyph", () => $2e91e7edf801074a$export$a4cdad58220c405a);
$parcel$export(module.exports, "attachmentGlyph", () => $2e91e7edf801074a$export$e6e85f1bc2e23bd4);
$parcel$export(module.exports, "bulletListGlyph", () => $2e91e7edf801074a$export$a6a7f7b7c0399a2a);
$parcel$export(module.exports, "commentGlyph", () => $2e91e7edf801074a$export$835d228e2a9d6a93);
$parcel$export(module.exports, "officeBuildingGlyph", () => $2e91e7edf801074a$export$fdad804cb16a6544);
$parcel$export(module.exports, "peopleGroupGlyph", () => $2e91e7edf801074a$export$a20644de4b67f161);
$parcel$export(module.exports, "radioGlyph", () => $2e91e7edf801074a$export$ce87e45dceec205d);
$parcel$export(module.exports, "shipGlyph", () => $2e91e7edf801074a$export$d95e2215202c8556);
$parcel$export(module.exports, "priorityGlyph", () => $2e91e7edf801074a$export$3062e49c5521698d);
$parcel$export(module.exports, "screenGlyph", () => $2e91e7edf801074a$export$17d48fc8b753df77);
$parcel$export(module.exports, "closeGlyph", () => $2e91e7edf801074a$export$cbbe21ca62a58ed6);
$parcel$export(module.exports, "appAccessGlyph", () => $2e91e7edf801074a$export$8fd991b9da3a43e5);
$parcel$export(module.exports, "jwmCategoryGlyph", () => $2e91e7edf801074a$export$f21213fb7b480582);
$parcel$export(module.exports, "customFieldGlyph", () => $2e91e7edf801074a$export$88453606d7da6ff7);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $2e91e7edf801074a$export$b368272069fe93ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 4h10a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zm.417 10.636h1.15V9.141H7.42L6 10.12v1.07l1.348-.93h.069v4.376zm1.923-3.85v.02h1.067v-.024c0-.506.365-.857.898-.857.503 0 .861.313.861.755 0 .357-.194.643-.967 1.397l-1.794 1.756v.803h3.964v-.955h-2.406v-.069l1.05-1.002c.953-.895 1.277-1.409 1.277-2.007 0-.944-.8-1.603-1.947-1.603-1.188 0-2.003.724-2.003 1.786zm5.811 1.466h.682c.617 0 .994.297.994.777 0 .469-.4.792-.975.792-.59 0-.983-.293-1.017-.757h-1.1c.05 1.035.88 1.713 2.106 1.713 1.253 0 2.159-.697 2.159-1.66 0-.724-.472-1.226-1.226-1.31v-.069c.613-.125 1.013-.62 1.013-1.257 0-.864-.811-1.481-1.939-1.481-1.2 0-1.972.655-2.01 1.695H14.9c.03-.476.385-.777.918-.777.537 0 .88.282.88.723 0 .45-.355.754-.876.754h-.67v.857z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$747056db840f2e62 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4 5.994C4 4.893 4.895 4 5.994 4h12.012C19.107 4 20 4.895 20 5.994v12.012A1.995 1.995 0 0 1 18.006 20H5.994A1.995 1.995 0 0 1 4 18.006V5.994zm5.707 5.299a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$fc939f15c0ac57d8 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M20 19V8h-9.154l-.503-1.258-.455-1.136C9.778 5.33 9.291 5 9.003 5H3.997C4.002 5 4 19 4 19h16zM12.2 6h7.809C21.109 6 22 6.893 22 7.992v11.016c0 1.1-.898 1.992-1.991 1.992H3.991C2.891 21 2 20.107 2 19.008V5.006C2 3.898 2.896 3 3.997 3h5.006c1.103 0 2.327.826 2.742 1.862L12.2 6z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$54ae6633cc16eed1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.667 6.167V7A.834.834 0 0 1 7 7V5.333a.834.834 0 0 1 1.667 0v.834zm6.666 0v-.834a.834.834 0 0 1 1.667 0V7a.834.834 0 0 1-1.667 0v-.833zm2.5 0h.005c.918 0 1.662.745 1.662 1.661v10.01c0 .918-.743 1.662-1.662 1.662H6.161A1.663 1.663 0 0 1 4.5 17.838V7.828c0-.917.743-1.661 1.662-1.661h.005V7c0 .927.746 1.667 1.666 1.667C8.76 8.667 9.5 7.92 9.5 7v-.833h5V7c0 .927.746 1.667 1.667 1.667.927 0 1.666-.747 1.666-1.667v-.833zm-10 6.667H9.5v-1.667H7.833v1.667zm0 3.334H9.5V14.5H7.833v1.668zm3.334-3.334h1.666v-1.667h-1.666v1.667zm0 3.334h1.666V14.5h-1.666v1.668zm3.333-3.334h1.667v-1.667H14.5v1.667zm0 3.334h1.667V14.5H14.5v1.668z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$d298f123ec74117c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM15.708 11.723L12.779 14.678C12.566 14.893 12.288 15 12.009 15C11.73 15 11.449 14.893 11.231 14.678L8.291 11.713C7.903 11.321 7.903 10.686 8.291 10.294C8.679 9.902 9.309 9.902 9.698 10.294L12.005 12.621L14.303 10.304C14.69 9.912 15.32 9.912 15.708 10.304C16.097 10.696 16.097 11.331 15.708 11.723Z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$b3ea0fc10228ca3e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM10.0543 7.95865C9.72121 7.63948 9.17412 7.63199 8.83238 7.94192C8.49064 8.25184 8.48365 8.76182 8.81678 9.08099L11.3658 11.5232C11.5389 11.689 11.7698 11.7707 11.9997 11.7675C12.2295 11.7707 12.4604 11.689 12.6335 11.5232L15.1825 9.08099C15.5156 8.76182 15.5087 8.25184 15.1669 7.94192C14.8252 7.63199 14.2781 7.63948 13.945 7.95865L11.9997 9.82242L10.0543 7.95865ZM8.83238 12.3333C9.17412 12.0234 9.72121 12.0309 10.0543 12.35L11.9997 14.2138L13.945 12.35C14.2781 12.0309 14.8252 12.0234 15.1669 12.3333C15.5087 12.6432 15.5156 13.1532 15.1825 13.4724L12.6335 15.9146C12.4604 16.0804 12.2295 16.1621 11.9997 16.1588C11.7698 16.1621 11.5389 16.0804 11.3658 15.9146L8.81678 13.4724C8.48365 13.1532 8.49064 12.6432 8.83238 12.3333Z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$fc64eea29ed0831d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.433 5.428l-4.207.6a2 2 0 0 0-1.697 1.698l-.601 4.207a1 1 0 0 0 .283.849l6.894 6.894a1 1 0 0 0 1.414 0l5.657-5.657a1 1 0 0 0 0-1.414L12.282 5.71a1 1 0 0 0-.849-.283zm-.647 5.858a1.667 1.667 0 1 1-2.357-2.357 1.667 1.667 0 0 1 2.357 2.357z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$cbee9ded46569696 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 7h11a1 1 0 0 1 0 2H7a1 1 0 1 1 0-2zm0 4h11a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2zm0 4h6a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$2ade78849d2113ea = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.12 20.249a8.398 8.398 0 0 1-.39-.003A8.25 8.25 0 0 1 3.75 12 8.25 8.25 0 0 1 12 3.75 8.25 8.25 0 0 1 20.25 12a8.25 8.25 0 0 1-8.13 8.25v-.001zm4.463-3.762A6.396 6.396 0 0 0 18.417 12 6.424 6.424 0 0 0 12 5.583 6.424 6.424 0 0 0 5.583 12c0 1.745.7 3.33 1.834 4.487v-1.27a2.291 2.291 0 0 1 2.292-2.292h4.582a2.292 2.292 0 0 1 2.292 2.291v1.27zM12 12a2.75 2.75 0 1 1 0-5.5 2.75 2.75 0 0 1 0 5.5z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$1c6cf19eb34bcc14 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.72 7.178l-2.93 8.627a.5.5 0 0 0 .473.661h.842a.75.75 0 0 0 .716-.53l.581-1.887h3.425l.58 1.887a.75.75 0 0 0 .717.53h.916a.5.5 0 0 0 .473-.66L9.578 7.177a1 1 0 0 0-.946-.678h-.966a1 1 0 0 0-.947.678zm1.37 1.228h.047l1.25 4.082H6.841l1.25-4.082zm10.187 1.872v-.23a.986.986 0 1 1 1.972 0v5.433a.986.986 0 0 1-1.972 0v-.217h-.08c-.36.802-1.13 1.32-2.217 1.32-1.81 0-2.952-1.479-2.952-3.834 0-2.334 1.149-3.805 2.952-3.805 1.075 0 1.858.546 2.216 1.333h.08zm-.04 2.486c0-1.347-.63-2.203-1.61-2.203-.978 0-1.58.843-1.58 2.203 0 1.368.602 2.196 1.58 2.196.988 0 1.61-.836 1.61-2.196z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$98a4a461fe316fce = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm.787-7.674V8.944c0-.52-.402-.944-.893-.944-.492 0-.894.425-.894.944v3.777c0 .263.104.5.269.672l2.207 2.332a.862.862 0 0 0 1.263 0 .985.985 0 0 0 0-1.336l-1.952-2.063z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$637d50811e2b7176 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M17.476 9.067A6.552 6.552 0 0 1 19 13.263C19 16.983 15.866 20 12 20s-7-3.016-7-6.737c0-1.587.57-3.045 1.524-4.196l-.383-.402a.82.82 0 0 1 .054-1.19.9.9 0 0 1 1.237.052l.345.363a7.116 7.116 0 0 1 3.348-1.312v-.894h-.438a.43.43 0 0 1-.437-.42V4.42a.43.43 0 0 1 .438-.42h2.624a.43.43 0 0 1 .438.421v.842a.43.43 0 0 1-.438.421h-.437v.894a7.116 7.116 0 0 1 3.348 1.312l.345-.363a.9.9 0 0 1 1.237-.052.82.82 0 0 1 .054 1.19l-.383.402zM12 18.316c2.9 0 5.25-2.262 5.25-5.053 0-2.79-2.35-5.052-5.25-5.052s-5.25 2.262-5.25 5.052c0 2.79 2.35 5.053 5.25 5.053zm.645-4.562a.9.9 0 0 1-1.237-.02.82.82 0 0 1 .02-1.19l2.588-2.412a.9.9 0 0 1 1.238.02.82.82 0 0 1-.02 1.19l-2.589 2.412z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$bc2bb299bed9df91 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$3a9d3f1c52f4dab9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.268 4.934a.919.919 0 0 0 0 1.296l4.852 4.853H4.668A.92.92 0 0 0 3.75 12a.92.92 0 0 0 .917.917H17.12l-4.856 4.855a.917.917 0 0 0 1.296 1.296l6.416-6.415c.002 0 .003-.003.006-.004a.914.914 0 0 0 .267-.65.915.915 0 0 0-.274-.653l-6.412-6.412a.915.915 0 0 0-.648-.267.915.915 0 0 0-.648.267z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$a4cdad58220c405a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.928 6.917l4.81-2.846c.727-.429 1.8-.427 2.523 0l4.811 2.846c.726.43 1.261 1.382 1.261 2.238v5.69c0 .859-.537 1.81-1.26 2.238L13.26 19.93c-.726.429-1.799.427-2.522 0l-4.811-2.846c-.726-.43-1.261-1.382-1.261-2.238v-5.69c0-.859.537-1.81 1.26-2.238zm6.408-1.204c-.152-.09-.52-.09-.672 0L6.853 8.558c-.152.09-.336.416-.336.597v5.69c0 .18.183.507.336.597l4.81 2.845c.153.09.52.09.673 0l4.811-2.845c.152-.09.336-.416.336-.597v-5.69c0-.18-.183-.507-.336-.597l-4.81-2.845zM12 15.667a3.667 3.667 0 1 1 0-7.334 3.667 3.667 0 0 1 0 7.334zm0-1.834a1.833 1.833 0 1 0 0-3.666 1.833 1.833 0 0 0 0 3.666z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$e6e85f1bc2e23bd4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.672 17.468c-1.402 1.37-3.68 1.37-5.08.004a3.458 3.458 0 0 1 .002-4.962l6.552-6.402a2.123 2.123 0 0 1 2.964-.003c.818.8.82 2.092.003 2.89L10.968 15a.599.599 0 0 1-.838-.008.568.568 0 0 1 0-.827l5.71-5.58a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.268 0l-5.71 5.58a2.294 2.294 0 0 0 0 3.307 2.423 2.423 0 0 0 3.375.008l6.145-6.005a3.735 3.735 0 0 0-.003-5.37 3.947 3.947 0 0 0-5.502.003L6.325 11.27a5.184 5.184 0 0 0-.001 7.442c2.1 2.052 5.514 2.051 7.617-.004l6.13-5.99a.863.863 0 0 0 0-1.24.912.912 0 0 0-1.27 0l-6.129 5.99z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$a6a7f7b7c0399a2a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5.5 7.59a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.008v.152A1 1 0 0 1 6.659 8.75h-.152A1 1 0 0 1 5.5 7.743V7.59zm4.333 8.667a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.008h-6.678a.993.993 0 0 1-.995-1.008v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.008h-.152A1 1 0 0 1 5.5 16.409v-.152zm4.333-4.333a.999.999 0 0 1 .995-1.007h6.678c.549 0 .994.438.994 1.007v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007v-.152zm-4.333 0a1 1 0 0 1 1.007-1.007h.152a1 1 0 0 1 1.008 1.007v.152a1 1 0 0 1-1.008 1.007h-.152A1 1 0 0 1 5.5 12.076v-.152zM9.833 7.59a.999.999 0 0 1 .995-1.008h6.678c.549 0 .994.439.994 1.008v.152a.999.999 0 0 1-.994 1.007h-6.678a.993.993 0 0 1-.995-1.007V7.59z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$835d228e2a9d6a93 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 0 0 .164.033.515.515 0 0 0 .474-.716zM7 10c0-.552.456-1 .995-1h8.01c.55 0 .995.444.995 1 0 .552-.456 1-.995 1h-8.01A.995.995 0 0 1 7 10zm0 3c0-.552.444-1 1-1h3c.552 0 1 .444 1 1 0 .552-.444 1-1 1H8c-.552 0-1-.444-1-1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$fdad804cb16a6544 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.444 14.667V20H5.785C4.8 20 4 19.146 4 18.09V8.577c0-1.055.802-1.91 1.785-1.91h2.66v3.556H6.666V12h1.777v.889H6.667v1.778h1.777zm.89-8.894A1.78 1.78 0 0 1 11.119 4h7.096A1.78 1.78 0 0 1 20 5.773v12.454c0 .979-.802 1.773-1.785 1.773H9.333V5.773zM12 7.556v1.777h1.778V7.556H12zm0 2.666V12h1.778v-1.778H12zm0 2.667v1.778h1.778v-1.778H12zm1.778 2.667v2.666h1.778v-2.666h-1.778zm1.778-8v1.777h1.777V7.556h-1.777zm0 2.666V12h1.777v-1.778h-1.777zm0 2.667v1.778h1.777v-1.778h-1.777z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$a20644de4b67f161 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 12a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm-3.228-1.667A3.333 3.333 0 0 0 9.795 12H9.5A2.501 2.501 0 0 0 7 14.497v2.469c-1.771-.147-3.333-.766-3.333-1.858V12c0-.92.74-1.667 1.666-1.667h3.439zm6.456 0h3.439c.92 0 1.666.738 1.666 1.667v3.108c0 1.092-1.562 1.711-3.333 1.858v-2.47A2.5 2.5 0 0 0 14.5 12h-.295a3.333 3.333 0 0 0 1.023-1.667zM10.306 6.63A3.332 3.332 0 0 0 8.67 9.357a2.5 2.5 0 1 1 1.636-2.728zm5.024 2.728a3.328 3.328 0 0 0-1.636-2.73 2.5 2.5 0 1 1 1.636 2.73zm-7.497 5.456c0-1.093.892-1.98 1.996-1.98h4.342a2 2 0 0 1 1.996 1.994v2.781c0 2.523-8.334 2.523-8.334 0v-2.795z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$ce87e45dceec205d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$d95e2215202c8556 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.5 12h7.333v-1.833H6.5V12zM4.667 9.242c0-.502.417-.909.919-.909h9.162c.507 0 .919.414.919.909v4.591h-11V9.242zm.458 7.341h12.828l.919-2.75H4.795l.33 2.75zm-2.287-3.677A.79.79 0 0 1 3.643 12h16.86c.504 0 .786.382.625.865l-1.565 4.686c-.16.478-.695.866-1.205.866H4.415c-.506 0-.964-.402-1.025-.906l-.552-4.605zM6.5 7.42c0-1.015.823-1.838 1.831-1.838h1.838c1.011 0 1.831.82 1.831 1.838v2.746H6.5V7.42zm3.667 0v-.004H8.331c.005 0 .002.002.002.004v.912h1.834V7.42z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$3062e49c5521698d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.959 15.833V8.474l-2.868 2.868a.541.541 0 1 1-.766-.766l3.79-3.789.001-.004a.544.544 0 0 1 .77.003l3.791 3.792a.543.543 0 0 1 0 .766.543.543 0 0 1-.765 0l-2.87-2.87v7.36a.543.543 0 0 1-.541.541.543.543 0 0 1-.542-.542zm7-6.666v7.359l-2.868-2.868a.541.541 0 1 0-.766.766l3.79 3.789.001.004a.544.544 0 0 0 .77-.003l3.791-3.792a.543.543 0 0 0 0-.766.543.543 0 0 0-.765 0l-2.87 2.87v-7.36a.543.543 0 0 0-.541-.541.543.543 0 0 0-.542.542z",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: ".5",
        fillRule: "evenodd"
    }));
const $2e91e7edf801074a$export$17d48fc8b753df77 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4 6.772C4 5.793 4.793 5 5.773 5h12.454C19.206 5 20 5.796 20 6.772v7.044c0 .979-.793 1.772-1.773 1.772H5.773A1.774 1.774 0 0 1 4 13.816V6.772zm1.778 7.052h12.444v-7.06H5.778v7.06zm8 5.294h.452c.241 0 .437.204.437.44V20H9.333v-.441c0-.244.203-.441.437-.441h.452V16.47h3.556v2.647z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$cbbe21ca62a58ed6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16.244 6.244a.833.833 0 1 1 1.179 1.179l-4.412 4.41 4.412 4.411a.834.834 0 0 1 .074 1.093l-.074.086a.833.833 0 0 1-1.179 0l-4.411-4.412-4.41 4.412a.834.834 0 0 1-1.094.074l-.085-.074a.833.833 0 0 1 0-1.179l4.411-4.411-4.41-4.41a.834.834 0 0 1-.076-1.094l.075-.085a.833.833 0 0 1 1.179 0l4.41 4.411z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$8fd991b9da3a43e5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12.682 12H5.01A2.006 2.006 0 0 0 3 14v4.446c0 2.162 4.836 2.951 8.368 2.368A5.975 5.975 0 0 1 10 17a5.994 5.994 0 0 1 2.682-5z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        fill: "currentColor",
        cx: "9",
        cy: "7",
        r: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        fill: "currentColor",
        cx: "16",
        cy: "17",
        r: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14.674 19.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3l1.406 1.405z",
        fill: "inherit"
    })));
const $2e91e7edf801074a$export$f21213fb7b480582 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 12zm0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 16zm0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 8z",
        fill: "currentColor"
    }));
const $2e91e7edf801074a$export$88453606d7da6ff7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        role: "presentation",
        focusable: "false",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M3 6C2.44772 6 2 6.44772 2 7C2 7.55228 2.44772 8 3 8H11C11.5523 8 12 7.55228 12 7C12 6.44772 11.5523 6 11 6H3ZM4 16V12H20V16H4ZM2 12C2 10.8954 2.89543 10 4 10H20C21.1046 10 22 10.8954 22 12V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V12Z",
        fill: "currentColor"
    })));

});


parcelRegister("bWSqf", function(module, exports) {

$parcel$export(module.exports, "default", () => $c969c7acf49869cf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c969c7acf49869cf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    columnGroupHeader: {
        "id": "issue-table-column-picker.common.column-group-header",
        "defaultMessage": "All columns"
    },
    deprecatedParentyLinkMessage: {
        "id": "issue-navigator.services.fetch-column-picker-options.deprecated-parenty-link-message",
        "defaultMessage": "<strong>{field}</strong> is replaced by <strong>Parent</strong>. Use the <strong>Parent</strong> field instead."
    }
});

});

parcelRegister("2F3SN", function(module, exports) {

$parcel$export(module.exports, "getCursorOfLastUnselectedOption", () => $0932bf87004e47f4$export$5918fea5c056698b);
$parcel$export(module.exports, "isOnlyUnselectableField", () => $0932bf87004e47f4$export$bf5bbd6344a5f1aa);

var $hIkqU = parcelRequire("hIkqU");

var $jG2IE = parcelRequire("jG2IE");

var $6UAdF = parcelRequire("6UAdF");
const $0932bf87004e47f4$var$isNotinSelectedList = (selectedOptions, option)=>{
    const optionFound = selectedOptions.find((select)=>(0, $jG2IE.isSingleValueOption)(select) && (0, $jG2IE.isSingleValueOption)(option) && select.cursor === option.cursor);
    return optionFound === undefined;
};
const $0932bf87004e47f4$export$5918fea5c056698b = (options, selectedOptions, search, endCursor)=>{
    const flatten = options.flatMap((option)=>option.optionType === 'group' ? option.options : option);
    const lastUnselectedOption = (0, (/*@__PURE__*/$parcel$interopDefault($hIkqU)))(flatten, (option)=>(0, $jG2IE.isSingleValueOption)(option) && !!option.cursor && $0932bf87004e47f4$var$isNotinSelectedList(selectedOptions, option));
    let cursor = lastUnselectedOption && (0, $jG2IE.isSingleValueOption)(lastUnselectedOption) ? lastUnselectedOption?.cursor : undefined;
    // with a given search input, don't set cursor to undefined when there are only selected options in the list, because we query with 'ALL' options
    if (search && cursor === undefined && endCursor) cursor = endCursor;
    return cursor;
};
const $0932bf87004e47f4$export$bf5bbd6344a5f1aa = (fieldType, canEditColumns)=>{
    if (fieldType === (0, $6UAdF.COLUMN_TYPE_EPIC_LINK)) return canEditColumns;
    if (fieldType === (0, $6UAdF.COLUMN_TYPE_PARENT_LINK)) return canEditColumns;
    return false;
};

});
parcelRegister("hIkqU", function(module, exports) {

var $bptzf = parcelRequire("bptzf");

var $apUNl = parcelRequire("apUNl");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $0353f9604956038c$var$findLast = $bptzf($apUNl);
module.exports = $0353f9604956038c$var$findLast;

});
parcelRegister("bptzf", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $hTJwX = parcelRequire("hTJwX");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $84e8f705a13e859f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$hTJwX(collection)) {
            var iteratee = $bxDef(predicate, 3);
            collection = $66FNL(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $84e8f705a13e859f$var$createFind;

});

parcelRegister("apUNl", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $79584b713e0c6354$var$nativeMax = Math.max, $79584b713e0c6354$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $79584b713e0c6354$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $kPZpS(fromIndex);
        index = fromIndex < 0 ? $79584b713e0c6354$var$nativeMax(length + index, 0) : $79584b713e0c6354$var$nativeMin(index, length - 1);
    }
    return $b5dwA(array, $bxDef(predicate, 3), index, true);
}
module.exports = $79584b713e0c6354$var$findLastIndex;

});


parcelRegister("jG2IE", function(module, exports) {

$parcel$export(module.exports, "isSingleValueOption", () => $4dbead67dfc4bb06$export$35faed52a6bc243e);
const $4dbead67dfc4bb06$export$35faed52a6bc243e = (option)=>option.optionType === 'option' || option.optionType === 'avatar' || option.optionType === 'lozenge' || option.optionType === 'field';

});



parcelRegister("gUt9J", function(module, exports) {

$parcel$export(module.exports, "useIFCSidebar", () => $c81b19b8c94d3931$export$50b7b16d5dcf708b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");

var $eZJjh = parcelRequire("eZJjh");

var $f98ZZ = parcelRequire("f98ZZ");

var $7XluA = parcelRequire("7XluA");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");

var $4anLj = parcelRequire("4anLj");

var $47gW9 = parcelRequire("47gW9");

var $jfQeI = parcelRequire("jfQeI");
const $c81b19b8c94d3931$var$IFCTriggerRef = ({ children: children })=>{
    const { entryPointActions: entryPointActions } = (0, $jfQeI.useIFCEntryPointContext)();
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    return children({
        triggerRef: triggerRef
    });
};
const $c81b19b8c94d3931$export$50b7b16d5dcf708b = ({ projectId: projectId, projectKey: projectKey })=>{
    const ifcContext = (0, $jfQeI.useIFCEntryPointContext)();
    const [, { setStaticSidebarContent: setStaticSidebarContent, closeSidebar: closeSidebar }] = (0, $f98ZZ.useSidebar)();
    const isSiteAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = (0, $4anLj.useIsProjectAdmin)();
    const isAdmin = isSiteAdmin || isProjectAdmin;
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const isIFCEnabled = Boolean(isAdmin && project?.simplified);
    const onUpdate = (0, $5uXOq.useCallback)(({ fieldId: fieldId, onFieldDeleted: onFieldDeleted, onFieldUpdated: onFieldUpdated, onStartFieldUpdate: onStartFieldUpdate, onFieldUpdateError: onFieldUpdateError })=>{
        if (projectId && projectKey) setStaticSidebarContent?.('ifc-sidebar-edit', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $c81b19b8c94d3931$var$styles.sidebarContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: ifcContext.entryPointReferenceSubject,
            id: "jira-nin-inline-field-config-sidebar",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "medium"
            })),
            runtimeProps: {
                projectId: projectId,
                projectKey: projectKey,
                onClose: closeSidebar,
                fieldId: fieldId,
                mode: 'edit',
                onFieldDeleted: onFieldDeleted,
                onFieldUpdated: onFieldUpdated,
                onStartFieldUpdate: onStartFieldUpdate,
                onFieldUpdateError: onFieldUpdateError
            }
        })));
    }, [
        closeSidebar,
        ifcContext.entryPointReferenceSubject,
        projectId,
        projectKey,
        setStaticSidebarContent
    ]);
    const onCreate = (0, $5uXOq.useCallback)((createArgs)=>{
        if (projectId && projectKey) setStaticSidebarContent?.('ifc-sidebar-create', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $c81b19b8c94d3931$var$styles.sidebarContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: ifcContext.entryPointReferenceSubject,
            id: "jira-nin-inline-field-config-sidebar",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "medium"
            })),
            runtimeProps: {
                projectId: projectId,
                projectKey: projectKey,
                onClose: closeSidebar,
                onStartFieldCreate: createArgs?.onStartFieldCreate,
                onFieldCreated: createArgs?.onFieldCreated,
                onFieldCreateError: createArgs?.onFieldCreateError,
                mode: 'create'
            }
        })));
    }, [
        closeSidebar,
        ifcContext.entryPointReferenceSubject,
        projectId,
        projectKey,
        setStaticSidebarContent
    ]);
    return (0, $5uXOq.useMemo)(()=>[
            isIFCEnabled,
            {
                IFCTriggerRef: $c81b19b8c94d3931$var$IFCTriggerRef,
                onCreate: onCreate,
                onUpdate: onUpdate
            }
        ], [
        isIFCEnabled,
        onCreate,
        onUpdate
    ]);
};
const $c81b19b8c94d3931$var$styles = {
    sidebarContent: "_4t3i1osq _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp"
};

});
parcelRegister("4anLj", function(module, exports) {

$parcel$export(module.exports, "useIsProjectAdmin", () => $28cdc31165a564f1$export$9facd8d31b938a25);

var $dAfqg = parcelRequire("dAfqg");
const $28cdc31165a564f1$export$9facd8d31b938a25 = ()=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    return !!data?.isProjectAdmin;
};

});


parcelRegister("7UBlg", function(module, exports) {

$parcel$export(module.exports, "createPopupComponent", () => $3f97be657325a468$export$7b08561157a7df33);
$parcel$export(module.exports, "default", () => $3f97be657325a468$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $ousew = parcelRequire("ousew");

var $4R6GH = parcelRequire("4R6GH");

var $hZQx0 = parcelRequire("hZQx0");

var $ih9zY = parcelRequire("ih9zY");

var $gwtSG = parcelRequire("gwtSG");

var $hW8cB = parcelRequire("hW8cB");

var $8HSL7 = parcelRequire("8HSL7");

var $f4YBC = parcelRequire("f4YBC");

var $kgFPU = parcelRequire("kgFPU");
const $3f97be657325a468$var$ColumnPickerPopupComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, onRestoreDefaults: onRestoreDefaults, ...props }, ref)=>{
    const { filterId: filterId, isFilterEditable: isFilterEditable } = (0, $gwtSG.useActiveJql)();
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const { hasMaxSelectedColumns: hasMaxSelectedColumns, filterName: filterName } = (0, $5uXOq.useContext)((0, $hZQx0.ColumnPickerMessageContext));
    let bannerMessage = null;
    if (hasMaxSelectedColumns) bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8HSL7.ColumnPickerMaxSelectedColumns), null);
    else if (view === 'list_system') bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hW8cB.ColumnPickerBannerMessage), {
        bannerMessage: (0, $4R6GH.fg)('jira_inline_field_config_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kgFPU.default).listSystemWarningMessageNew) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kgFPU.default).listSystemWarningMessage),
        type: "warning"
    });
    else if (view === `list_filter_${filterId}`) {
        if (isFilterEditable === false) bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hW8cB.ColumnPickerBannerMessage), {
            type: "info",
            bannerMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                ...(0, $kgFPU.default).listNonEditableFilterInfoMessage,
                values: {
                    // To remove @ts-expect-error below we need to upgrade intl to v6
                    // https://stackoverflow.com/questions/67884173/formattedmessage-values-chunks-using-typescript
                    // @ts-expect-error TS2322: Type '(chunks: ReactNode[]) => JSX.Element' is not assignable to type 'ReactNode'.
                    link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                            href: `/jira/filters${filterName ? `?name="${encodeURIComponent(filterName)}"` : ''}`,
                            target: "_blank"
                        }, chunks)
                }
            })
        });
        else bannerMessage = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hW8cB.ColumnPickerBannerMessage), {
            bannerMessage: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $kgFPU.default).listFilterWarningMessage),
            type: "warning"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f97be657325a468$var$PopupComponentContainer, {
        ...props,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f4YBC.default), {
        onRestoreDefaults: (0, $4R6GH.fg)('jira_inline_field_config_gate') ? onRestoreDefaults : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f97be657325a468$var$TabsContentContainer, null, bannerMessage, children)));
});
const $3f97be657325a468$export$7b08561157a7df33 = (onRestoreDefaultColumns)=>/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f97be657325a468$var$ColumnPickerPopupComponent, {
            ...props,
            ref: ref,
            onRestoreDefaults: onRestoreDefaultColumns
        }));
var $3f97be657325a468$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3f97be657325a468$var$ColumnPickerPopupComponent;
const $3f97be657325a468$var$PopupComponentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1bsb1mjv _bfhk1bhr _16qs1cd0 _1pby1nn1 _ca0q1b66 _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3f97be657325a468$var$TabsContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hW8cB", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerBannerMessage", () => $cc30b6aaadae0517$export$3ccab74b576df308);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1jWct = parcelRequire("1jWct");

var $bU3PY = parcelRequire("bU3PY");
const $cc30b6aaadae0517$export$3ccab74b576df308 = ({ bannerMessage: bannerMessage, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc30b6aaadae0517$var$BannerContent, {
        type: type
    }, type === 'warning' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc30b6aaadae0517$var$BannerMessage, null, bannerMessage));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc30b6aaadae0517$var$BannerContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _syaz1gjq",
            __cmplp.type === 'warning' ? "_bfhk1tzq" : "_bfhk33gi",
            __cmplp.className
        ])
    });
});
const $cc30b6aaadae0517$var$BannerMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _19pkidpf _2hwxidpf _otyridpf _18u0u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8HSL7", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerMaxSelectedColumns", () => $661e3e27622b6b54$export$3ec21851fe32329c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6tRzQ = parcelRequire("6tRzQ");

var $koVbs = parcelRequire("koVbs");

var $czfFt = parcelRequire("czfFt");

var $5oFIy = parcelRequire("5oFIy");

var $dyiFy = parcelRequire("dyiFy");
const $661e3e27622b6b54$export$3ec21851fe32329c = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($661e3e27622b6b54$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
        spacing: "spacious",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($661e3e27622b6b54$var$Message, null, formatMessage((0, $dyiFy.default).maxSelectedColumns, {
        maxColumns: (0, $czfFt.MAX_COLUMNS)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "maxSelectedFieldsMessage",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $661e3e27622b6b54$var$MessageContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _bfhkm7j4 _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _syaz1gjq _19pku2gc",
            __cmplp.className
        ])
    });
});
const $661e3e27622b6b54$var$Message = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _19pkidpf _2hwxidpf _otyridpf _18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dyiFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf25dbe16eb48e62$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cf25dbe16eb48e62$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    maxSelectedColumns: {
        "id": "issue-navigator.issue-results.list-view.column-picker-max-selected-columns.max-selected-columns",
        "defaultMessage": "The column limit is {maxColumns, number}. Remove and add the most important ones to your view."
    }
});

});


parcelRegister("f4YBC", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4d61f43128e0eaf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");

var $fphHl = parcelRequire("fphHl");
var $cte3m = parcelRequire("cte3m");
var $eQ4wW = parcelRequire("eQ4wW");

var $koVbs = parcelRequire("koVbs");

var $9Nvh7 = parcelRequire("9Nvh7");

var $8zOmE = parcelRequire("8zOmE");

var $g5X3G = parcelRequire("g5X3G");

var $itmJb = parcelRequire("itmJb");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $ih9zY = parcelRequire("ih9zY");

var $gwtSG = parcelRequire("gwtSG");

var $2CHGs = parcelRequire("2CHGs");

var $k4UJN = parcelRequire("k4UJN");
const $a4d61f43128e0eaf$var$CustomTabPanel = ({ children: children })=>{
    /**
   * We can omit the tab index as our panel always contains a focusable input as the first element https://www.w3.org/WAI/ARIA/apg/example-index/tabs/tabs-automatic#accessibilityfeatures.
   * > It is recommended that all tabpanel elements in a tab set are focusable if there are any panels in the set that
   * > contain content where the first element in the panel is not focusable.
   */ const { tabIndex: tabIndex, ...tabPanelAttributes } = (0, $eQ4wW.useTabPanel)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", tabPanelAttributes, children);
};
const $a4d61f43128e0eaf$var$ColumnPickerTabs = ({ children: children, onRestoreDefaults: onRestoreDefaults })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { filterId: filterId } = (0, $gwtSG.useActiveJql)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const [{ view: view }, { setView: setView }] = (0, $ih9zY.useSelectedViewState)();
    const isFilterTabEnabled = filterId != null && (0, $9Nvh7.isCustomFilter)(filterId);
    const tabsMetaData = (0, $5uXOq.useMemo)(()=>{
        const resultTabs = [
            {
                key: 'Default',
                label: formatMessage((0, $2CHGs.default).pickerTabTextDefault),
                view: 'list_default',
                onRestoreDefaults: onRestoreDefaults
            }
        ];
        if (isFilterTabEnabled) {
            const filterViewId = (0, $eJ0Zs.convertFilterIdToIssueNavigatorId)(filterId);
            if (filterViewId != null) resultTabs.push({
                key: 'Filter',
                label: formatMessage((0, $2CHGs.default).pickerTabTextFilter),
                view: filterViewId
            });
        }
        if (isAdmin) resultTabs.push({
            key: 'System',
            label: formatMessage((0, $2CHGs.default).pickerTabTextSystem),
            view: 'list_system'
        });
        return resultTabs;
    }, [
        formatMessage,
        isFilterTabEnabled,
        filterId,
        isAdmin,
        onRestoreDefaults
    ]);
    const handleUpdate = (0, $5uXOq.useCallback)((index, event)=>{
        if (view !== tabsMetaData[index].view) {
            (0, $8zOmE.fireUIAnalytics)(event, 'columnPickerTabs', {
                tab: tabsMetaData[index].view
            });
            setView(tabsMetaData[index].view, (0, $g5X3G.toIssueKey)(''));
        }
    }, [
        setView,
        tabsMetaData,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fphHl.default), {
        id: "issue-table-column-picker.ui.column-picker.picker-tabs",
        onChange: handleUpdate,
        selected: tabsMetaData.findIndex((tab)=>tab.view === view),
        shouldUnmountTabPanelOnChange: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cte3m.default), null, tabsMetaData.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k4UJN.default), {
            key: tab.key,
            label: tab.label,
            maxWidth: `${Math.floor(100 / (tabsMetaData.length || 1))}%`,
            onRestoreDefaults: tab.onRestoreDefaults
        })))), tabsMetaData.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4d61f43128e0eaf$var$CustomTabPanel, {
            key: tab.key
        }, children)));
};
var $a4d61f43128e0eaf$export$2e2bcd8739ae039 = $a4d61f43128e0eaf$var$ColumnPickerTabs;

});
parcelRegister("fphHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4810d6c8b7d5c95d$export$2e2bcd8739ae039);
/* tabs.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $dWD6q = parcelRequire("dWD6q");
const $4810d6c8b7d5c95d$var$baseStyles = null;
const $4810d6c8b7d5c95d$var$tabsStyles = null;
const $4810d6c8b7d5c95d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $4810d6c8b7d5c95d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        children: tabPanel
    }, index); /**
                                * __Tabs__
                                *
                                * Tabs acts as a container for all Tab components.
                                *
                                * - [Examples](https://atlassian.design/components/tabs/examples)
                                * - [Code](https://atlassian.design/components/tabs/code)
                                * - [Usage](https://atlassian.design/components/tabs/usage)
                                */ 
const $4810d6c8b7d5c95d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $5uXOq.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $5uXOq.Children).toArray(children) // Don't include any conditional children
    .filter((child)=>Boolean(child)); // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray; // Keep track of visited and add to a set
    const visited = (0, $5uXOq.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $5uXOq.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$4810d6c8b7d5c95d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $4810d6c8b7d5c95d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$4810d6c8b7d5c95d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1osq _1tkeidpf _i0dl1osq _2lx21bp4 _16jlkb7n",
            "_1c3y1txw _ftfaidpf _18i0kb7n _185bglyw"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabListContext).Provider, {
                value: {
                    selected: selected,
                    onChange: onChangeAnalytics,
                    tabsId: id
                },
                children: tabList
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Fragment), {
                children: tabPanelsWithContext
            })
        ]
    });
};
var $4810d6c8b7d5c95d$export$2e2bcd8739ae039 = $4810d6c8b7d5c95d$var$Tabs;

});
parcelRegister("dWD6q", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $b47499898157cfdc$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $b47499898157cfdc$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $b47499898157cfdc$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $5uXOq = parcelRequire("5uXOq");
const $b47499898157cfdc$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $b47499898157cfdc$export$2054129d247c3102 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);

});


parcelRegister("cte3m", function(module, exports) {

$parcel$export(module.exports, "default", () => $e15f9538b451f314$export$2e2bcd8739ae039);
/* tab-list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $eQ4wW = parcelRequire("eQ4wW");

var $dWD6q = parcelRequire("dWD6q");
const $e15f9538b451f314$var$baseStyles = null;
const $e15f9538b451f314$var$tabListStyles = null;
const $e15f9538b451f314$var$tabListStylesOld = null;
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $e15f9538b451f314$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $eQ4wW.useTabList)();
    const ref = /*#__PURE__*/ (0, $5uXOq.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $5uXOq.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $5uXOq.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $5uXOq.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dWD6q.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            children: tab
        }, index), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "tablist",
        ref: ref,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _1lzu8zxi _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1b8d8zxi _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _rsmz174y _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _1mp41kw7 _kfgte4h9 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc" : "_k48p1wq8 _ahbqx0bf _gpbcidpf _10vzidpf _1mmwidpf _15plidpf _7hip15vq _1fud15vq _bb0mh2mm _1quzjjyb _rzxytlke _1ofh12x7 _pryi12x7 _1a85u2gc _rmpau2gc _1dze1l2s _1tms1q9c _fiizidpf _1xrmidpf _xyihidpf _166qidpf _17hygqwt _1lzu1eqa _24g71kw7 _140sidpf _lycustnw _15d8b3bt _1fztidpf _wd7eu2gc _1olcu2gc _1oazdud1 _w9ewidpf _170tidpf _y1g1idpf _1nvfidpf _1jakgqwt _1b8d1eqa _1n121kw7 _7p9oidpf _o2e1stnw _16u6b3bt _1yk1idpf _1lbou2gc _1c9uu2gc _1i201ouy _bppridpf _1mbxidpf _kn0bidpf _wsgdidpf _9r9ugqwt _rsmz1gcm _1m0e1kw7 _93pdidpf _1sglstnw _1ksob3bt _1p9sidpf _1qa1u2gc _1jjcu2gc _fiem1ldt _pascidpf _eid3idpf _zr3eidpf _fntnidpf _rfx3gqwt _1mp41kw7 _kfgt1bk5 _1cs8stnw _1rushloo _1kt9b3bt _1fkridpf _1enwidpf _z5wtu2gc"
        ]),
        children: childrenArray.map((child, index)=>getTabWithContext({
                tab: child,
                index: index,
                isSelected: index === selected
            }))
    });
};
var $e15f9538b451f314$export$2e2bcd8739ae039 = $e15f9538b451f314$var$TabList;

});
parcelRegister("eQ4wW", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $4d8616502e4de6b0$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $4d8616502e4de6b0$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $4d8616502e4de6b0$export$fae0121b5afe572d);

var $5uXOq = parcelRequire("5uXOq");

var $dWD6q = parcelRequire("dWD6q");
const $4d8616502e4de6b0$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $5uXOq.useContext)((0, $dWD6q.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $4d8616502e4de6b0$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $5uXOq.useContext)((0, $dWD6q.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $4d8616502e4de6b0$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $5uXOq.useContext)((0, $dWD6q.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("2CHGs", function(module, exports) {

$parcel$export(module.exports, "default", () => $824f5fbceb95a5ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $824f5fbceb95a5ee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pickerTabTextDefault: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-default",
        "defaultMessage": "My defaults"
    },
    pickerTabTextFilter: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-filter",
        "defaultMessage": "Filter"
    },
    pickerTabTextSystem: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.picker-tab-text-system",
        "defaultMessage": "System"
    }
});

});

parcelRegister("k4UJN", function(module, exports) {

$parcel$export(module.exports, "default", () => $51a2efbb5ab69baf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eQ4wW = parcelRequire("eQ4wW");

var $42CjB = parcelRequire("42CjB");

var $lzNDe = parcelRequire("lzNDe");

var $fKpEJ = parcelRequire("fKpEJ");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $fijky = parcelRequire("fijky");

var $diHTh = parcelRequire("diHTh");
const $51a2efbb5ab69baf$var$Tab = ({ label: label, maxWidth: maxWidth = '100%', onRestoreDefaults: onRestoreDefaults })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { labelOverflows: labelOverflows, onLabelRef: onLabelRef } = (0, $diHTh.useLabelOverflow)();
    const tabAttributes = (0, $eQ4wW.useTab)();
    const handleRestoreDefaults = (0, $5uXOq.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'filterSearchRestoreDefaults', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onRestoreDefaults && typeof onRestoreDefaults === 'function' && onRestoreDefaults();
    }, [
        onRestoreDefaults
    ]);
    if ((0, $4R6GH.fg)('jira_inline_field_config_gate')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51a2efbb5ab69baf$var$TabStyled, {
        maxWidthValue: maxWidth,
        ...tabAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fKpEJ.ConditionalTooltip), {
        condition: labelOverflows,
        content: label,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $51a2efbb5ab69baf$var$tabStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: onLabelRef,
        xcss: $51a2efbb5ab69baf$var$textStyles
    }, label), onRestoreDefaults !== undefined && typeof onRestoreDefaults === 'function' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lzNDe))),
        onClick: handleRestoreDefaults,
        label: formatMessage((0, $fijky.default).restoreDefaults),
        appearance: "subtle",
        spacing: "compact",
        isTooltipDisabled: false
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($51a2efbb5ab69baf$var$TabStyled, {
        maxWidthValue: maxWidth,
        ...tabAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fKpEJ.ConditionalTooltip), {
        condition: labelOverflows,
        content: label,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: onLabelRef,
        xcss: $51a2efbb5ab69baf$var$textStyles
    }, label)));
};
const $51a2efbb5ab69baf$var$textStyles = (0, $8CUq3.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
const $51a2efbb5ab69baf$var$tabStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $51a2efbb5ab69baf$var$TabStyled = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { maxWidthValue: maxWidthValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ocvhpw": (0, $lD23V.default)(__cmplp.maxWidthValue)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12fd0nw _vchhusvi _ae4v1h6o",
            __cmplp.className
        ])
    });
});
var $51a2efbb5ab69baf$export$2e2bcd8739ae039 = $51a2efbb5ab69baf$var$Tab;

});
parcelRegister("lzNDe", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2b87cc7d74b53f2f9074ecfc04ea4b65>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fb535dae8e778b64$var$_react = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fb535dae8e778b64$var$_baseNew = $fb535dae8e778b64$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fb535dae8e778b64$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Retry".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for retry.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fb535dae8e778b64$var$RetryIcon = (props)=>/*#__PURE__*/ $fb535dae8e778b64$var$_react.default.createElement($fb535dae8e778b64$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 8a7 7 0 0 1 12.5-4.33V1H15v5a.75.75 0 0 1-.75.75H9.5v-1.5h3.264a5.5 5.5 0 1 0 .665 3.63l1.482.24A7.002 7.002 0 0 1 1 8" clip-rule="evenodd"/>`
    }, props));
$fb535dae8e778b64$var$RetryIcon.displayName = 'RetryIcon';
var $fb535dae8e778b64$var$_default = module.exports.default = $fb535dae8e778b64$var$RetryIcon;

});

parcelRegister("fKpEJ", function(module, exports) {

$parcel$export(module.exports, "ConditionalTooltip", () => $68dbfbed07ea6c84$export$d8abb7a1cfbd4b6b);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");
const $68dbfbed07ea6c84$export$d8abb7a1cfbd4b6b = ({ condition: condition, children: children, ...rest })=>condition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), rest, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});

parcelRegister("fijky", function(module, exports) {

$parcel$export(module.exports, "default", () => $531ffbde38170d0a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $531ffbde38170d0a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    restoreDefaults: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.tab.restore-defaults",
        "defaultMessage": "Restore defaults"
    }
});

});

parcelRegister("diHTh", function(module, exports) {

$parcel$export(module.exports, "useLabelOverflow", () => $553ab2a51c9cea37$export$96d540e3e625885f);

var $5uXOq = parcelRequire("5uXOq");
const $553ab2a51c9cea37$export$96d540e3e625885f = ()=>{
    const [labelOverflows, setLabelOverflows] = (0, $5uXOq.useState)(false);
    const onLabelRef = (0, $5uXOq.useCallback)((node)=>{
        if (node != null) {
            const isOverflow = Boolean(node.offsetWidth < node.scrollWidth);
            isOverflow !== labelOverflows && setLabelOverflows(isOverflow);
        }
    }, [
        labelOverflows
    ]);
    return {
        labelOverflows: labelOverflows,
        onLabelRef: onLabelRef,
        setLabelOverflows: setLabelOverflows
    };
};

});



parcelRegister("kgFPU", function(module, exports) {

$parcel$export(module.exports, "default", () => $77988429b36d0c09$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $77988429b36d0c09$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    listSystemWarningMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-system-warning-message",
        "defaultMessage": "Any changes here will modify columns for all users."
    },
    listSystemWarningMessageNew: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-system-warning-message-new",
        "defaultMessage": "Changes will apply to everyone."
    },
    listFilterWarningMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-filter-warning-message",
        "defaultMessage": "Any changes here will affect all users of this filter."
    },
    listNonEditableFilterInfoMessage: {
        "id": "issue-navigator.issue-results.list-view.column-picker-popup-component.list-non-editable-filter-info-message",
        "defaultMessage": "You can\u2019t modify this filter. Contact the owner using the <link>Filters directory</link> for edit permission."
    }
});

});


parcelRegister("bC77a", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerRemountManager", () => $43bbd345ff33d027$export$a4237a5d372a0de2);

var $5uXOq = parcelRequire("5uXOq");

var $jlRhf = parcelRequire("jlRhf");

var $ih9zY = parcelRequire("ih9zY");
const $43bbd345ff33d027$export$a4237a5d372a0de2 = ({ children: children, viewIdFromResponse: viewIdFromResponse })=>{
    const [{ view: optimisticViewId }] = (0, $ih9zY.useSelectedViewState)();
    const { isLoading: isLoading } = (0, $jlRhf.useColumnPickerLoadingContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
        key: isLoading ? 'loading' : `${optimisticViewId}${viewIdFromResponse}`
    }, children);
};

});

parcelRegister("8ev74", function(module, exports) {

$parcel$export(module.exports, "BulkOpsConnectionsSubscriber", () => $fdbbad112159e743$export$e722c6c8da1d5a1a);

var $5uXOq = parcelRequire("5uXOq");

var $48rMm = parcelRequire("48rMm");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $9fB6c = parcelRequire("9fB6c");
const $fdbbad112159e743$var$entryPointParams = {};
const $fdbbad112159e743$export$e722c6c8da1d5a1a = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const selectedIssues = (0, $48rMm.useIssueTableSelectedIssues)();
    const [hasSelectedAtLeastOnce, setHasSelectedAtLeastOnce] = (0, $5uXOq.useState)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $9fB6c.bulkOperationsConnectionsSubscriberEntryPoint), $fdbbad112159e743$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (!hasSelectedAtLeastOnce && selectedIssues.length > 0) {
            setHasSelectedAtLeastOnce(true);
            entryPointActions.load();
        }
    }, [
        entryPointActions,
        hasSelectedAtLeastOnce,
        selectedIssues.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.nin-bulk.operations.connections.subscriber",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
});

});
parcelRegister("9fB6c", function(module, exports) {

$parcel$export(module.exports, "bulkOperationsConnectionsSubscriberEntryPoint", () => $1445af39083fc172$export$f0e5693d80379467);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1445af39083fc172$export$f0e5693d80379467 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("kBjWC")), {
        moduleId: "a230f98b",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("kBjWC", function(module, exports) {

let $eff6bbe511ec6efd$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eff6bbe511ec6efd$var$load("19TWk").then(()=>parcelRequire('HQMPw'));

});



parcelRegister("2hlL8", function(module, exports) {

$parcel$export(module.exports, "IssueCount", () => $987d8685128f2230$export$542fba90cc9c1bd1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");

var $cyCoT = parcelRequire("cyCoT");

var $eLt1F = parcelRequire("eLt1F");
const $987d8685128f2230$export$542fba90cc9c1bd1 = (issueCountProps)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($987d8685128f2230$var$IssueCountContainer, {
        "data-testid": "issue-navigator.ui.issue-results.list-view.issue-count",
        isFlexEnd: issueCountProps.isNewFooterOrderEnabled
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        testId: "issue-navigator.ui.issue-results.list-view.issue-count.text",
        xcss: $987d8685128f2230$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cyCoT.default), issueCountProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": "issue-navigator.ui.issue-results.list-view.issue-count.text"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cyCoT.default), issueCountProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eLt1F.default), null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $987d8685128f2230$var$IssueCountContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexEnd: isFlexEnd, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _zulp1b66 _1e0c1txw _4cvr1h6o _k48p1pd9",
            __cmplp.isFlexEnd ? "_1bahesu3" : "_1bah1h6o",
            __cmplp.className
        ])
    });
});
const $987d8685128f2230$var$textStyles = (0, $8CUq3.xcss)({
    fontWeight: 'font.weight.medium',
    color: 'color.text.subtle'
});

});

parcelRegister("df5k9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9512add73ee5293a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9512add73ee5293a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    reorderColumnsErrorTitle: {
        "id": "issue-navigator.issue-results.list-view.reorder-columns-error-title",
        "defaultMessage": "We couldn't reorder your columns"
    },
    resetColumnsErrorTitle: {
        "id": "issue-navigator.issue-results.list-view.reset-columns-error-title",
        "defaultMessage": "We couldn't restore your default columns"
    },
    columnConfigMutationErrorDescription: {
        "id": "issue-navigator.issue-results.list-view.column-config-mutation-error-description",
        "defaultMessage": "Refresh and try again."
    }
});

});

parcelRegister("cKSn6", function(module, exports) {

$parcel$export(module.exports, "NoColumns", () => $21675d57ff4dba29$export$a0e9f6d02eee4aa4);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $MHKc7 = parcelRequire("MHKc7");

var $6s1PB = parcelRequire("6s1PB");

var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $9DYf6 = parcelRequire("9DYf6");

var $8zOmE = parcelRequire("8zOmE");

var $g5X3G = parcelRequire("g5X3G");

var $cZpsT = parcelRequire("cZpsT");

var $ih9zY = parcelRequire("ih9zY");

var $1oKq6 = parcelRequire("1oKq6");
const $21675d57ff4dba29$var$Bold = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, children);
const $21675d57ff4dba29$var$NoColumnsAnonymous = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { setView: setView }] = (0, $ih9zY.useSelectedViewState)();
    const onClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton', {
            isAnon: true
        });
        setView('detail', (0, $g5X3G.toIssueKey)(''));
    }, [
        setView
    ]);
    const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $1oKq6.default).noColumnsHeaderAnonymous),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
            componentsMapping: {
                bold: $21675d57ff4dba29$var$Bold
            },
            message: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1oKq6.default).noColumnsDescriptionAnonymousIssueTermRefresh : (0, $1oKq6.default).noColumnsDescriptionAnonymous, {
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}'
            })
        }),
        testId: "issue-navigator.ui.issue-results.list-view.no-columns.no-columns-anonymous",
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            onClick: onClick
        }, formatMessage((0, $1oKq6.default).switchView)),
        renderImage: ()=>defaultNoColumnsGlyph
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingBlock: "space.800"
    }, component);
};
const $21675d57ff4dba29$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    return isAnonymous ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($21675d57ff4dba29$var$NoColumnsAnonymous, {
        defaultNoColumnsGlyph: defaultNoColumnsGlyph
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9DYf6.components).NoColumns, {
        defaultNoColumnsGlyph: defaultNoColumnsGlyph,
        hasColumnConfiguration: hasColumnConfiguration
    });
};

});
parcelRegister("8Q4sF", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $7c8c20575fbc9bfc$export$200d7bd7633253ce);

var $5uXOq = parcelRequire("5uXOq");

var $gHDlh = parcelRequire("gHDlh");

var $9Byym = parcelRequire("9Byym");
const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $5uXOq.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $9Byym.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $9Byym.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $9Byym.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $gHDlh.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $gHDlh.MalformedMessageError)) {
                (0, $gHDlh.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $gHDlh.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("gHDlh", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $ecff24857c176a60$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $ecff24857c176a60$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $ecff24857c176a60$export$40d900e818b9630e);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $jcw0u.default)({
            meta: {
                packageName: packageName,
                id: (0, $5514815b06163219$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
        (0, $2YZCu.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $ecff24857c176a60$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("9Byym", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $84498158f946a67b$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $84498158f946a67b$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $84498158f946a67b$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $84498158f946a67b$export$d5170904651e91b1);

const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);

});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';



parcelRegister("9DYf6", function(module, exports) {

$parcel$export(module.exports, "components", () => $b2da35897bea1cb9$export$9b5ac10f59f76296);

var $eUiAo = parcelRequire("eUiAo");

var $35sx5 = parcelRequire("35sx5");

var $56vto = parcelRequire("56vto");
const $b2da35897bea1cb9$export$9b5ac10f59f76296 = {
    columnPicker: $eUiAo.components,
    Footer: $35sx5.Footer,
    NoColumns: $56vto.NoColumns
};

});
parcelRegister("eUiAo", function(module, exports) {

$parcel$export(module.exports, "components", () => $63a1b7bd09a72394$export$9b5ac10f59f76296);

var $50z6e = parcelRequire("50z6e");
const $63a1b7bd09a72394$export$9b5ac10f59f76296 = {
    NoOptionsMessage: $50z6e.default
};

});
parcelRegister("50z6e", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a81df9ef986c35d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dD7Zc = parcelRequire("dD7Zc");

var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $dCm1o = parcelRequire("dCm1o");

var $7krAo = parcelRequire("7krAo");
const $1a81df9ef986c35d$var$IconContainerConditional = ({ children: children })=>{
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1a81df9ef986c35d$var$IconContainer, null, children);
};
const $1a81df9ef986c35d$var$MessageContainer = ({ icon: icon, children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150",
        xcss: $1a81df9ef986c35d$var$stackStyles,
        alignInline: "center"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text"
    }, formatMessage((0, $7krAo.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.subtle",
        size: "small"
    }, formatMessage((0, $7krAo.default).noOptionsSecondaryMessage)), children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1a81df9ef986c35d$var$Container, null, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1a81df9ef986c35d$var$StyledTitle, null, formatMessage((0, $7krAo.default).title)), children);
};
/**
 * Custom message to show when no options are visible in the column picker. This allows additional help text/content to
 * be rendered using the children prop.
 */ const $1a81df9ef986c35d$var$NoOptionsMessage = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1a81df9ef986c35d$var$MessageContainer, {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1a81df9ef986c35d$var$IconContainerConditional, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
            label: "",
            color: "var(--ds-icon, #44546F)",
            LEGACY_primaryColor: "currentColor"
        }))
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "emptyState",
        action: "viewed",
        actionSubjectId: "columnPicker"
    }));
};
var $1a81df9ef986c35d$export$2e2bcd8739ae039 = $1a81df9ef986c35d$var$NoOptionsMessage;
const $1a81df9ef986c35d$var$stackStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.100',
    // this is for the children additional help text/content
    color: 'color.text.subtlest'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1a81df9ef986c35d$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s81gzt _syaz131l _1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $1a81df9ef986c35d$var$IconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyru2gc _w8l5t9kd _1752t9kd",
            __cmplp.className
        ])
    });
});
const $1a81df9ef986c35d$var$StyledTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1fxt _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7krAo", function(module, exports) {

$parcel$export(module.exports, "default", () => $51300b676abd2848$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $51300b676abd2848$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-table-column-picker.column-picker.no-options-message.title",
        "defaultMessage": "We couldn\u2019t find the field you\u2019re looking for."
    },
    noOptionsPrimaryMessage: {
        "id": "issue-table-column-picker.common.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "issue-table-column-picker.common.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});

});



parcelRegister("35sx5", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $9ac639c2cf475c33$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4R6GH = parcelRequire("4R6GH");

var $kYFm9 = parcelRequire("kYFm9");

var $9CFBJ = parcelRequire("9CFBJ");
const $9ac639c2cf475c33$export$a06f1c675e846f6f = ({ start: start = $9ac639c2cf475c33$var$SpacerElement, center: center = $9ac639c2cf475c33$var$SpacerElement, end: end = $9ac639c2cf475c33$var$SpacerElement })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ac639c2cf475c33$var$FooterBase, null, start, center, end);
};
function $9ac639c2cf475c33$var$FooterBase({ children: children }) {
    const tableHeight = (0, $kYFm9.useElementSizeSelector)((size)=>size.height);
    const hasShadow = (0, $9CFBJ.useScrollStateSelector)((scrollState)=>{
        const { height: containerHeight, scrollTop: scrollTop } = scrollState;
        // Scroll measurements are fractional, while height measurements are integer, so we need to round before comparing
        return containerHeight < tableHeight && Math.round(scrollTop) < tableHeight - containerHeight;
    });
    return (0, $4R6GH.fg)('reduce_size_of_scroll_container_shadow') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ac639c2cf475c33$var$FooterWrapper, null, hasShadow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ac639c2cf475c33$var$FooterShadow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ac639c2cf475c33$var$FooterContainer, {
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: false
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ac639c2cf475c33$var$FooterContainer, {
        "data-testid": "native-issue-table.common.ui.components.footer.footer-container",
        hasShadow: hasShadow
    }, children);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ac639c2cf475c33$var$FooterWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $9ac639c2cf475c33$var$FooterShadow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _4t3i1y44 _lcxvglyw _16qs9g9j",
            __cmplp.className
        ])
    });
});
const $9ac639c2cf475c33$var$FooterContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasShadow: hasShadow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb _1e0c1txw _2lx2vrvc _1n261q9c _kqsw1if8 _1ltvidpf _94n5idpf _bfhkvuon _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
            __cmplp.hasShadow && "_16qsahas",
            __cmplp.className
        ])
    });
});
const $9ac639c2cf475c33$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $9ac639c2cf475c33$var$SpacerElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ac639c2cf475c33$export$d7a54cba636a8cd6, null);

});

parcelRegister("56vto", function(module, exports) {

$parcel$export(module.exports, "NoColumns", () => $1e9e65187073fe12$export$a0e9f6d02eee4aa4);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $MHKc7 = parcelRequire("MHKc7");

var $koVbs = parcelRequire("koVbs");

var $bHZac = parcelRequire("bHZac");

var $8zOmE = parcelRequire("8zOmE");

var $9yV2W = parcelRequire("9yV2W");
const $1e9e65187073fe12$export$a0e9f6d02eee4aa4 = ({ defaultNoColumnsGlyph: defaultNoColumnsGlyph, hasColumnConfiguration: hasColumnConfiguration })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ isOpen: isOpen }, actions] = (0, $bHZac.useColumnPickerOpenState)();
    const onOpenColumnPicker = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'noColumnsButton');
        if (!isOpen) actions.open();
    }, [
        isOpen,
        actions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $9yV2W.default).noColumnsHeaderText),
        description: formatMessage((0, $9yV2W.default).noColumnsDescriptionText),
        testId: "native-issue-table.common.ui.components.no-columns.no-columns",
        primaryAction: hasColumnConfiguration ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "primary",
            onClick: onOpenColumnPicker
        }, formatMessage((0, $9yV2W.default).configureColumns)) : undefined,
        renderImage: ()=>defaultNoColumnsGlyph
    }));
};

});
parcelRegister("bHZac", function(module, exports) {

$parcel$export(module.exports, "ColumnPickerContainer", () => $cceed226e735615f$export$e1286e1cb3fa0dec);
$parcel$export(module.exports, "useColumnPickerOpenState", () => $cceed226e735615f$export$81588ffe8d9d4add);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $cceed226e735615f$export$e1286e1cb3fa0dec = (0, $gg7kZ.createContainer)();
const $cceed226e735615f$var$Store = (0, $iXqE5.createStore)({
    initialState: {
        isOpen: false
    },
    actions: {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    },
    name: 'ColumnPickerOpenState',
    containedBy: $cceed226e735615f$export$e1286e1cb3fa0dec
});
const $cceed226e735615f$export$81588ffe8d9d4add = (0, $3sQ5x.createHook)($cceed226e735615f$var$Store);

});

parcelRegister("9yV2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb37f0f12ee9177e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cb37f0f12ee9177e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noColumnsHeaderText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-header-text",
        "defaultMessage": "Configure your columns"
    },
    noColumnsDescriptionText: {
        "id": "native-issue-table.issue-table.no-columns.no-columns-description-text",
        "defaultMessage": "You haven't configured any columns yet. Add fields as columns to see search results and their information."
    },
    configureColumns: {
        "id": "native-issue-table.issue-table.no-columns.configure-columns",
        "defaultMessage": "Configure columns"
    }
});

});



parcelRegister("1oKq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $180f8d8b8bfd2e47$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $180f8d8b8bfd2e47$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noColumnsHeaderAnonymous: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-header-anonymous",
        "defaultMessage": "The admin hasn't configured any columns"
    },
    noColumnsDescriptionAnonymous: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-description-anonymous",
        "defaultMessage": "Switch to {boldStart}Detail view{boldEnd} to see issues and their information."
    },
    switchView: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.switch-view",
        "defaultMessage": "Switch to detail view"
    },
    noColumnsDescriptionAnonymousIssueTermRefresh: {
        "id": "issue-navigator.issue-results.list-view.issue-table-no-columns-anonymous.no-columns-description-anonymous-issue-term-refresh",
        "defaultMessage": "Switch to {boldStart}Detail view{boldEnd} to see work items and their information."
    }
});

});


parcelRegister("1g3qz", function(module, exports) {

$parcel$export(module.exports, "NoIssues", () => $b830958a6a36b095$export$a7a61a727a1d891b);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $MHKc7 = parcelRequire("MHKc7");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $hgx9A = parcelRequire("hgx9A");
const $b830958a6a36b095$export$a7a61a727a1d891b = ({ defaultNoIssuesGlyph: defaultNoIssuesGlyph })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingBlock: "space.800"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        header: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $hgx9A.default).noIssuesIssueTermRefresh : (0, $hgx9A.default).noIssues),
        renderImage: ()=>defaultNoIssuesGlyph,
        testId: "issue-navigator.ui.issue-results.list-view.no-issues.empty-state"
    }));
};

});
parcelRegister("hgx9A", function(module, exports) {

$parcel$export(module.exports, "default", () => $4793c96b4dc9cacf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4793c96b4dc9cacf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noIssues: {
        "id": "issue-navigator.common.empty-list-icon.no-issues",
        "defaultMessage": "No issues were found matching your search"
    },
    noIssuesIssueTermRefresh: {
        "id": "issue-navigator.issue-results.list-view.no-issues.no-issues-issue-term-refresh",
        "defaultMessage": "There's nothing matching your search"
    }
});

});


parcelRegister("ePwTF", function(module, exports) {

$parcel$export(module.exports, "AsyncRegisterShortcutDialogActions", () => $336808f7ab792907$export$53d5920188b673b6);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $a0UwL = parcelRequire("a0UwL");

var $kxZPA = parcelRequire("kxZPA");
var $6Lg6A = parcelRequire("6Lg6A");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $336808f7ab792907$var$LazyRegisterShortcutDialogActions = (0, $kxZPA.lazy)(()=>(parcelRequire("7SI1T")), {
    moduleId: "./src/packages/issue-navigator/issue-navigator/src/ui/issue-results/list-view/register-shortcut-dialog-actions/index.tsx"
});
const $336808f7ab792907$export$53d5920188b673b6 = (props)=>{
    const [{ isShortcutsDialogVisible: isShortcutsDialogVisible }] = (0, $a0UwL.useShortcuts)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraIssueNavigator",
        id: "register-issue-actions-worklflow-shortcuts-dialog",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lg6A.LazyWait), {
        until: isShortcutsDialogVisible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "register-shortcut-dialog-actions",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($336808f7ab792907$var$LazyRegisterShortcutDialogActions, props))));
};

});
parcelRegister("a0UwL", function(module, exports) {

$parcel$export(module.exports, "useShortcuts", () => $991d4b7077d5c717$export$a1ca853c6e4bb6fb);
$parcel$export(module.exports, "useShortcutsActions", () => $991d4b7077d5c717$export$b331ee6e87b9104c);

var $axjlw = parcelRequire("axjlw");
const $991d4b7077d5c717$export$a1ca853c6e4bb6fb = ()=>(0, $axjlw.useShortcutsStore)();
const $991d4b7077d5c717$export$b331ee6e87b9104c = ()=>{
    const [, actions] = (0, $axjlw.useShortcutsActionsStore)();
    return [
        undefined,
        actions
    ];
};

});
parcelRegister("axjlw", function(module, exports) {

$parcel$export(module.exports, "useShortcutsStore", () => $fefbe59bb1ce22b9$export$a14646bfc7ba8d81);
$parcel$export(module.exports, "useShortcutsActionsStore", () => $fefbe59bb1ce22b9$export$1a29bfef7fa09838);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $f0R9h = parcelRequire("f0R9h");
const $fefbe59bb1ce22b9$export$d4c72bab9d6cc13a = {
    shortcuts: {
        admin: {
            key: 'admin',
            label: 'ADMIN',
            options: [],
            isLoaded: false
        }
    },
    isShortcutsDialogVisible: false,
    isShortcutsLoading: false,
    hasError: false,
    isAdminLoading: false,
    selectedItemKey: null,
    header: null,
    title: undefined
};
const $fefbe59bb1ce22b9$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'shortcuts',
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly shortcuts: { readonly admin: { readonly key: "admin"; readonly label: "ADMIN"; readonly options: readonly []; readonly isLoaded: false; }; }; readonly isShortcutsDialogVisible: false; readonly isShortcutsLoading: false; ... 4 more ...; readonly title: undefined; }' is not assignable to type 'State'.
    $fefbe59bb1ce22b9$export$d4c72bab9d6cc13a,
    actions: $f0R9h
});
const $fefbe59bb1ce22b9$export$a14646bfc7ba8d81 = (0, $3sQ5x.createHook)($fefbe59bb1ce22b9$export$6f57813fe9f31bf9);
const $fefbe59bb1ce22b9$export$1a29bfef7fa09838 = (0, $3sQ5x.createHook)($fefbe59bb1ce22b9$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("f0R9h", function(module, exports) {

$parcel$export(module.exports, "registerShortcuts", () => $d845eb212fa1ca53$export$598ec0e6047cbdca);
$parcel$export(module.exports, "setShortcutsDialogVisibility", () => $d845eb212fa1ca53$export$80ab1e79e32c3021);
$parcel$export(module.exports, "setShortcutsLoading", () => $d845eb212fa1ca53$export$7ed2ac8328423043);
$parcel$export(module.exports, "setHasError", () => $d845eb212fa1ca53$export$645a7c7453685186);
$parcel$export(module.exports, "setHeader", () => $d845eb212fa1ca53$export$604ed74fb893f0e2);
$parcel$export(module.exports, "fetchAdminSections", () => $d845eb212fa1ca53$export$aec87c8c9bde62e6);
$parcel$export(module.exports, "setSelectedItemKey", () => $d845eb212fa1ca53$export$249c9d5b49cd9712);
$parcel$export(module.exports, "dropShortcutsByKeys", () => $d845eb212fa1ca53$export$9cf39adf0dec984);

var $k8IPx = parcelRequire("k8IPx");

var $1qfyE = parcelRequire("1qfyE");

var $8mrJC = parcelRequire("8mrJC");
const $d845eb212fa1ca53$export$598ec0e6047cbdca = (shortcuts)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const newShortcuts = shortcuts.reduce((acc, current)=>{
            acc[current.key] = current;
            return acc;
        }, {
            ...currentState.shortcuts
        });
        setState({
            ...currentState,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };
const $d845eb212fa1ca53$export$80ab1e79e32c3021 = (isVisible)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsDialogVisible: isVisible
        });
    };
const $d845eb212fa1ca53$export$7ed2ac8328423043 = (isLoading)=>({ getState: getState, setState: setState })=>{
        setState({
            ...getState(),
            isShortcutsLoading: isLoading
        });
    };
const $d845eb212fa1ca53$export$645a7c7453685186 = (hasError)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            hasError: hasError
        });
    };
const $d845eb212fa1ca53$export$604ed74fb893f0e2 = (header, title)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            header: header,
            title: title
        });
    };
const $d845eb212fa1ca53$export$aec87c8c9bde62e6 = ()=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        setState({
            ...currentState,
            isAdminLoading: true
        });
        const result = await (0, $1qfyE.default)();
        const shortcuts = result ? (0, $8mrJC.buildAdminSections)(result) : [];
        const newState = getState();
        setState({
            ...newState,
            shortcuts: {
                ...newState.shortcuts,
                admin: {
                    ...newState.shortcuts.admin,
                    key: 'admin',
                    options: shortcuts,
                    isLoaded: true
                }
            },
            hasError: currentState.hasError || !result,
            isAdminLoading: false
        });
    };
const $d845eb212fa1ca53$export$249c9d5b49cd9712 = (item)=>({ setState: setState, getState: getState })=>{
        setState({
            ...getState(),
            selectedItemKey: item
        });
    };
const $d845eb212fa1ca53$export$9cf39adf0dec984 = (keys)=>({ getState: getState, setState: setState })=>{
        if (!keys.length) return;
        const { shortcuts: shortcuts, ...rest } = getState();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newShortcuts = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(Object.keys(shortcuts), keys).reduce((acc, key)=>{
            acc[key] = shortcuts[key];
            return acc;
        }, {});
        setState({
            ...rest,
            shortcuts: newShortcuts,
            isShortcutsLoading: false
        });
    };

});
parcelRegister("1qfyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0636f27c00094fd3$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $7f4tk = parcelRequire("7f4tk");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0636f27c00094fd3$export$2e2bcd8739ae039 = async ()=>{
    try {
        return await (0, $7f4tk.default)('/rest/adminquicksearch/latest/links/default');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('shortcuts-dialog.fetch-admin-links', error.toString());
        return null;
    }
};

});

parcelRegister("8mrJC", function(module, exports) {

$parcel$export(module.exports, "buildAdminSections", () => $9289773ab8ca36d5$export$5f8c94ecd4c9eb76);
const $9289773ab8ca36d5$export$5f8c94ecd4c9eb76 = (parent, result = [])=>{
    if (parent.sections && parent.sections.length) parent.sections.forEach((s)=>$9289773ab8ca36d5$export$5f8c94ecd4c9eb76(s, result));
    if (parent.items && parent.items.length) parent.items.forEach((i)=>result.push({
            key: i.key,
            label: i.label,
            // @ts-expect-error - TS2322 - Type '() => void' is not assignable to type '(event?: Event | undefined) => Promise<undefined> | undefined'.
            onClick: ()=>{
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.location.href = i.linkUrl;
            }
        }));
    return result;
};

});




parcelRegister("7SI1T", function(module, exports) {

let $5bcfbae8681af307$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5bcfbae8681af307$var$load("beI6N").then(()=>parcelRequire('Jq3ih'));

});


parcelRegister("dHKP1", function(module, exports) {

$parcel$export(module.exports, "dragAndDropExperience", () => $ede56ac081600cc8$export$c1eb53e51d4d0ab3);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $ede56ac081600cc8$export$c1eb53e51d4d0ab3 = new (0, $duUGa.UFOExperience)('jira-issue-navigator.list-view.drag-and-drop', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("dYvVi", function(module, exports) {

$parcel$export(module.exports, "useEventHandlers", () => $a2e970e494c5fd70$export$8ce912bc34d0dbea);

var $5uXOq = parcelRequire("5uXOq");

var $g5X3G = parcelRequire("g5X3G");

var $7OTah = parcelRequire("7OTah");

var $cqgcE = parcelRequire("cqgcE");

var $6Hhfn = parcelRequire("6Hhfn");
const $a2e970e494c5fd70$export$8ce912bc34d0dbea = (connectionId, fieldSetIds)=>{
    const { setSelectedIssueByKey: setSelectedIssueByKey, deselectIssue: deselectIssue } = (0, $7OTah.useSelectedIssueActions)();
    const onDeleteIssue = (0, $cqgcE.useOnDeleteIssue)(connectionId);
    const onIssueByFieldsRefetch = (0, $6Hhfn.useIssueByFieldsRefetch)(fieldSetIds);
    const onIssueRefetch = onIssueByFieldsRefetch;
    // While we don't have a mutation setup for inline editing, use issue refetch as a substitute
    const onUpdateCache = onIssueByFieldsRefetch;
    const onIssueDelete = (0, $5uXOq.useCallback)((deletedIssueKey)=>{
        const issueKeyToSelect = onDeleteIssue(deletedIssueKey);
        if (!issueKeyToSelect.length) {
            deselectIssue({
                shouldDebounce: false,
                shouldNotifyOnChange: false,
                isSelectedByUserInteraction: false
            });
            return;
        }
        setSelectedIssueByKey((0, $g5X3G.toIssueKey)(issueKeyToSelect), {
            shouldDebounce: false,
            shouldNotifyOnChange: false,
            isSelectedByUserInteraction: false
        });
    }, [
        onDeleteIssue,
        setSelectedIssueByKey,
        deselectIssue
    ]);
    const onIssueLinkSelected = (0, $5uXOq.useCallback)((issueKey, viewActivity)=>{
        setSelectedIssueByKey((0, $g5X3G.toIssueKey)(issueKey), {
            viewActivity: viewActivity
        });
        return true;
    }, [
        setSelectedIssueByKey
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            onIssueRefetch: onIssueRefetch,
            onUpdateCache: onUpdateCache,
            onIssueDelete: onIssueDelete,
            onIssueLinkSelected: onIssueLinkSelected
        }), [
        onIssueRefetch,
        onUpdateCache,
        onIssueDelete,
        onIssueLinkSelected
    ]);
};

});



parcelRegister("gOpmP", function(module, exports) {

$parcel$export(module.exports, "default", () => $df04299218cd8fb7$export$2e2bcd8739ae039);

var $2KpEY = parcelRequire("2KpEY");

var $CuCBv = parcelRequire("CuCBv");

var $9XMR6 = parcelRequire("9XMR6");

var $gq57B = parcelRequire("gq57B");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7CMCs = parcelRequire("7CMCs");

var $gcl1l = parcelRequire("gcl1l");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $lhXIu = parcelRequire("lhXIu");

var $kQ256 = parcelRequire("kQ256");

var $3RNwj = parcelRequire("3RNwj");

var $8WcPx = parcelRequire("8WcPx");

var $032ey = parcelRequire("032ey");

var $3HwlS = parcelRequire("3HwlS");

var $elFwM = parcelRequire("elFwM");

var $9z65D = parcelRequire("9z65D");

var $cZpsT = parcelRequire("cZpsT");

var $l8ruj = parcelRequire("l8ruj");

var $7XYc4 = parcelRequire("7XYc4");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $a8lIB = parcelRequire("a8lIB");

var $1z7Yr = parcelRequire("1z7Yr");

var $acgaZ = parcelRequire("acgaZ");

var $anxcG = parcelRequire("anxcG");

var $gwtSG = parcelRequire("gwtSG");

var $38r5c = parcelRequire("38r5c");

var $ePhT2 = parcelRequire("ePhT2");

var $bNJuB = parcelRequire("bNJuB");

var $5aoL8 = parcelRequire("5aoL8");

var $66jXs = parcelRequire("66jXs");

var $weR3I = parcelRequire("weR3I");

var $3iu8n = parcelRequire("3iu8n");

const $df04299218cd8fb7$var$JQLBuilderWrapper = ({ defaultJql: defaultJql, onFilterSave: onFilterSave, onReset: onReset, onChangeJql: onChangeJql, onToggleAi: onToggleAi, groupResults: groupResults, issueResults: issueResults, filter: filter, jqlBuilderProps: jqlBuilderProps, jqlBuilderWithAiKey: jqlBuilderWithAiKey, initialQueryAsJql: initialQueryAsJql })=>{
    const { startJqlBuilderMetric: startJqlBuilderMetric, stopJqlBuilderMetric: stopJqlBuilderMetric, markJqlBuilderMetric: markJqlBuilderMetric } = (0, $weR3I.useJqlBuilderInstrumentation)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        startJqlBuilderMetric();
        markJqlBuilderMetric((0, $a8lIB.marks).JQL_BUILDER_START);
    }, [
        startJqlBuilderMetric,
        markJqlBuilderMetric
    ]);
    const { query: query, onSearch: onSearch } = (0, $anxcG.useJqlSearch)(onChangeJql);
    const { maybeHydrationQueryReference: maybeHydrationQueryReference, ...restJqlBuilderProps } = jqlBuilderProps ?? {
        maybeHydrationQueryReference: undefined
    }; /**
      * We will only utilise a router resource HydrationQueryReference if it is the
      * first time the component is mounted on page load.
      * So we check whether the query hasn't changed between page load and component mount
      */ 
    const [hydrationQueryReferenceRef] = (0, $5uXOq.useState)(()=>{
        if (!(0, $4R6GH.fg)('jracloud_85520_hydration_ref_only_on_page_load')) return undefined;
        return initialQueryAsJql === query ? maybeHydrationQueryReference : undefined;
    });
    const { jql: jql, filterJql: filterJql, filterId: filterId } = (0, $gwtSG.useActiveJql)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const isSaveFilterButtonEnabled = (0, $4R6GH.fg)('jira_nin_smart_link') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $ePhT2.useIssueNavigatorFeatures)().isSaveFilterButtonEnabled : true;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isFetching = (0, $38r5c.useIsFetching)();
    const groupResultsData = (0, $8Uumt.useFragment)((0, $gq57B.default), groupResults);
    const issueResultsData = (0, $8Uumt.useFragment)((0, $9XMR6.default), issueResults);
    const issueSearchError = issueResultsData?.issueSearchError ?? null;
    const jqlErrors = (0, $5uXOq.useMemo)(()=>{
        const groupConnectionClientErrors = (groupResultsData?.errors ?? []).filter(({ extensions: extensions })=>extensions?.some(({ statusCode: statusCode })=>typeof statusCode === 'number' && statusCode >= 400 && statusCode < 500));
        if (!isFetching) {
            if (issueSearchError) {
                if (issueSearchError.__typename === 'JiraInvalidJqlError') return issueSearchError.messages?.filter((0, $eJ0Zs.isNonNullish)).map((message)=>({
                        type: 'error',
                        message: message
                    })) ?? [];
                if (issueSearchError.__typename === 'JiraInvalidSyntaxError' && issueSearchError.message != null) return [
                    {
                        type: 'error',
                        message: issueSearchError.message,
                        errorType: issueSearchError.errorType ?? undefined
                    }
                ];
            } else if (groupConnectionClientErrors.length) return groupConnectionClientErrors.map(({ message: message })=>({
                    message: message,
                    type: 'error'
                }));
        }
        return undefined;
    }, [
        groupResultsData?.errors,
        isFetching,
        issueSearchError
    ]);
    const filterData = (0, $8Uumt.useFragment)((0, $CuCBv.default), filter);
    const ResetButtonControl = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $66jXs.default), {
            onReset: onReset
        }), [
        onReset
    ]);
    const GoBackToFilterButtonControl = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $66jXs.default), {
            onReset: onReset,
            isResetToFilter: true
        }), [
        onReset
    ]);
    const SaveFilterDialog = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('nin-save-filter-dialog-entry-point'), (0, $elFwM.SaveFilterDialog), (0, $9z65D.AsyncSaveFilterDialog));
    const SaveFilterControl = (0, $5uXOq.useCallback)(({ searchMode: searchMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df04299218cd8fb7$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.save-filter-control",
            "data-vc": "jql-builder-ui-save-filter-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SaveFilterDialog, {
            jql: query,
            attributes: {
                isAdvancedModeEnabled: searchMode === (0, $032ey.SEARCH_MODE_ADVANCED)
            },
            onFilterSave: onFilterSave,
            buttonText: formatMessage((0, $bNJuB.default).saveFilterButton),
            title: formatMessage((0, $bNJuB.default).saveFilterDialogTitle)
        })), [
        onFilterSave,
        query,
        formatMessage,
        SaveFilterDialog
    ]);
    const SaveFilterDropdownControl = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df04299218cd8fb7$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.save-filter-dropdown-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lhXIu.SaveFilterDropdown), {
            query: query,
            filterId: filterId,
            onFilterSave: onFilterSave
        })), [
        filterId,
        query,
        onFilterSave
    ]);
    const CopyFilterControl = (0, $5uXOq.useCallback)(({ searchMode: searchMode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df04299218cd8fb7$var$SaveFilterWrapper, {
            "data-testid": "issue-navigator.ui.jql-builder.copy-filter-control"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SaveFilterDialog, {
            jql: query,
            filterId: filterId,
            attributes: {
                isAdvancedModeEnabled: searchMode === (0, $032ey.SEARCH_MODE_ADVANCED)
            },
            onFilterSave: onFilterSave,
            buttonText: formatMessage((0, $bNJuB.default).copyFilterButton),
            title: formatMessage((0, $bNJuB.default).copyFilterDialogTitle)
        })), [
        onFilterSave,
        query,
        filterId,
        formatMessage,
        SaveFilterDialog
    ]);
    const renderFilterControls = (0, $5uXOq.useCallback)(()=>{
        const extraControls = []; // Button nor dropdown should be shown when user is anonymous
        if (!isAnonymous && isSaveFilterButtonEnabled) {
            if (filterData) {
                const { isEditable: isEditable } = filterData; // Should not show neither the button nor the dropdown if jql errors
                if (!jqlErrors || jqlErrors.length === 0) {
                    if ((0, $3iu8n.isFilterJqlModified)({
                        filterJql: filterJql,
                        query: query
                    })) {
                        if (isEditable === true) extraControls.push(SaveFilterDropdownControl);
                        else extraControls.push(SaveFilterControl);
                    } else extraControls.push(CopyFilterControl);
                }
            } else extraControls.push(SaveFilterControl);
        }
        return extraControls;
    }, [
        CopyFilterControl,
        SaveFilterControl,
        SaveFilterDropdownControl,
        filterData,
        filterJql,
        isAnonymous,
        isSaveFilterButtonEnabled,
        jqlErrors,
        query
    ]);
    const renderExtraControls = (0, $5uXOq.useCallback)(()=>{
        const extraControls = [];
        const showResetButton = (0, $3iu8n.isOnlyJqlAndDifferentToDefault)(jql, defaultJql, filterJql) || (0, $3iu8n.isOnlyFilterAndDifferentToDefault)(jql, defaultJql, filterJql) || (0, $3iu8n.filterAndJqlIsTheSameAndDifferentToDefault)(jql, defaultJql, filterJql);
        const showGoBackToFilterButton = (0, $3iu8n.jqlIsDifferentToFilter)(jql, filterJql);
        const addResetButton = ()=>showGoBackToFilterButton || showResetButton;
        if (addResetButton()) extraControls.push(showResetButton ? ResetButtonControl : GoBackToFilterButtonControl);
        extraControls.push(...renderFilterControls());
        return extraControls;
    }, [
        renderFilterControls,
        jql,
        defaultJql,
        filterJql,
        ResetButtonControl,
        GoBackToFilterButtonControl
    ]);
    const { messages: jqlInfos } = (0, $acgaZ.useJqlSearchStatus)({
        query: query,
        isSearching: isFetching
    });
    const jqlMessages = (0, $5uXOq.useMemo)(()=>[
            ...jqlErrors || [],
            ...jqlInfos || []
        ], [
        jqlErrors,
        jqlInfos
    ]);
    const onLoad = (0, $5uXOq.useCallback)((mode)=>{
        if (mode === (0, $032ey.SEARCH_MODE_BASIC)) markJqlBuilderMetric((0, $a8lIB.marks).JQL_BUILDER_BASIC_START);
        else markJqlBuilderMetric((0, $a8lIB.marks).JQL_BUILDER_ADVANCED_START);
    }, [
        markJqlBuilderMetric
    ]);
    const onReady = (0, $5uXOq.useCallback)((mode)=>{
        if (mode === (0, $032ey.SEARCH_MODE_BASIC)) {
            markJqlBuilderMetric((0, $a8lIB.marks).JQL_BUILDER_BASIC_END);
            markJqlBuilderMetric((0, $a8lIB.marks).JQL_BUILDER_END);
        } else {
            markJqlBuilderMetric((0, $a8lIB.marks).JQL_BUILDER_ADVANCED_END);
            markJqlBuilderMetric((0, $a8lIB.marks).JQL_BUILDER_END);
        }
        stopJqlBuilderMetric();
    }, [
        stopJqlBuilderMetric,
        markJqlBuilderMetric
    ]);
    const aiBuilderOverrides = (0, $5uXOq.useMemo)(()=>({
            // Only render filter controls (no reset action) for the AI embedded JQL builder
            renderExtraControls: renderFilterControls
        }), [
        renderFilterControls
    ]); /* eslint-disable @atlassian/relay/must-colocate-fragment-spreads */ 
    const jqlBuilderWithAiData = (0, $8Uumt.useFragment)((0, $2KpEY.default), jqlBuilderWithAiKey); /* eslint-enable @atlassian/relay/must-colocate-fragment-spreads */ 
    const { onJourneyStart: onJourneyStart } = (0, $1z7Yr.useAppContextualAnalyticsActions)();
    const handlePerformanceMark = (0, $5uXOq.useCallback)(({ mark: mark })=>{
        markJqlBuilderMetric(mark);
    }, [
        markJqlBuilderMetric
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $df04299218cd8fb7$var$wrapperStyles,
            (0, $3HwlS.getWillShowNav4)() && $df04299218cd8fb7$var$newWrapperStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kQ256.ShortcutsDialogIntegrationProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8WcPx.default), {
        analyticsSource: (0, $6UAdF.ANALYTICS_SOURCE),
        query: query,
        onSearch: onSearch,
        renderExtraControls: renderExtraControls,
        jqlMessages: jqlMessages,
        isSearching: isFetching,
        onReady: onReady,
        onLoad: onLoad,
        onJourneyStart: onJourneyStart,
        NoOptionComponent: (0, $5aoL8.NoOptionsMessage),
        aiBuilderOverrides: aiBuilderOverrides,
        onToggleAi: onToggleAi,
        fragmentKey: jqlBuilderWithAiData ?? null,
        onPerformanceMark: handlePerformanceMark,
        ...(0, $4R6GH.fg)('jracloud_85520_hydration_ref_only_on_page_load') ? {
            maybeHydrationQueryReference: hydrationQueryReferenceRef,
            ...restJqlBuilderProps
        } : jqlBuilderProps
    })));
};
const $df04299218cd8fb7$var$JQLBuilderWrapperWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "issue-navigator-jql-builder"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "ui.jql-builder.error-boundary",
        packageName: (0, $6UAdF.PACKAGE_NAME),
        teamName: (0, $6UAdF.TEAM_NAME),
        sendToPrivacyUnsafeSplunk: true,
        attributes: (0, $gcl1l.isLoaderErrorAttributes),
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3RNwj.JQLBuilderErrorBoundryFallback), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df04299218cd8fb7$var$JQLBuilderWrapper, props)));
var $df04299218cd8fb7$export$2e2bcd8739ae039 = $df04299218cd8fb7$var$JQLBuilderWrapperWithErrorBoundary;
const $df04299218cd8fb7$var$wrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.negative.025',
    marginBottom: 'space.0'
});
const $df04299218cd8fb7$var$newWrapperStyles = (0, $8CUq3.xcss)({
    flexGrow: 'var(--jql-wrapper-grow, 0)',
    maxHeight: 'min-content'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df04299218cd8fb7$var$SaveFilterWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2KpEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f74bc17cdb37af$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<96f197ee49bffef91f88aabc89058cb4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $f3f74bc17cdb37af$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_jqlBuilderWithAiKey",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "ui_jqlBuilderWithAi_JQLBuilderWithAI"
        }
    ],
    "type": "JiraQuery"
};
$f3f74bc17cdb37af$var$node.hash = "dd0aae667d7d92a8112c28d2dcff0ac8";
var $f3f74bc17cdb37af$export$2e2bcd8739ae039 = $f3f74bc17cdb37af$var$node;

});

parcelRegister("CuCBv", function(module, exports) {

$parcel$export(module.exports, "default", () => $85c380d9942dc9d5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a76e30faae7fd3f790cc395215820217>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $85c380d9942dc9d5$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "isEditable"
        }
    ],
    "type": "JiraCustomFilter"
};
$85c380d9942dc9d5$var$node.hash = "46b543f50c73d7423957a8ecbe71b627";
var $85c380d9942dc9d5$export$2e2bcd8739ae039 = $85c380d9942dc9d5$var$node;

});

parcelRegister("9XMR6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2c66ac90ee34e3d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a3182e66785e68d12090ebb9bf08695e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a2c66ac90ee34e3d$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_issueResults",
    "selections": [
        {
            "kind": "LinkedField",
            "name": "issueSearchError",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "messages"
                        }
                    ],
                    "type": "JiraInvalidJqlError"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "errorType"
                        }
                    ],
                    "type": "JiraInvalidSyntaxError"
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$a2c66ac90ee34e3d$var$node.hash = "eeb59c3a307dc75263f7e39b4f314c7c";
var $a2c66ac90ee34e3d$export$2e2bcd8739ae039 = $a2c66ac90ee34e3d$var$node;

});

parcelRegister("gq57B", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e1d70940a61f798$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2da135e56e9e45c2e5f481821656e304>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0e1d70940a61f798$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "jqlBuilder_issueNavigator_JQLBuilderWrapper_groupResults",
    "selections": [
        {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
                {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ],
    "type": "JiraSpreadsheetGroupConnection"
};
$0e1d70940a61f798$var$node.hash = "30cd518272beee6c712a219e1b78cd63";
var $0e1d70940a61f798$export$2e2bcd8739ae039 = $0e1d70940a61f798$var$node;

});

parcelRegister("lhXIu", function(module, exports) {

$parcel$export(module.exports, "SaveFilterDropdown", () => $27f5e7d6c447efe5$export$4aae2fedc7924eed);

var $64TeP = parcelRequire("64TeP");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Uumt = parcelRequire("8Uumt");

var $kEVMo = parcelRequire("kEVMo");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $jcw0u = parcelRequire("jcw0u");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $7oAQw = parcelRequire("7oAQw");

var $eVAtv = parcelRequire("eVAtv");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $c88gN = parcelRequire("c88gN");

var $cKjus = parcelRequire("cKjus");

var $9OXo1 = parcelRequire("9OXo1");

var $a0UsQ = parcelRequire("a0UsQ");

var $4R6GH = parcelRequire("4R6GH");

var $lXAdy = parcelRequire("lXAdy");

var $inHPh = parcelRequire("inHPh");
const $27f5e7d6c447efe5$export$a3ca021e3e6c7315 = (0, $7HGHK.toFlagId)('issue-navigator-save-filter-success-flag');
const $27f5e7d6c447efe5$export$f5e4c120ac01b615 = (0, $7HGHK.toFlagId)('issue-navigator-save-filter-error-flag');
const $27f5e7d6c447efe5$export$4aae2fedc7924eed = ({ defaultOpen: defaultOpen = false, filterId: filterId, query: query, onFilterSave: onFilterSave })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const [updateJiraCustomFilterJqlMutation] = (0, $8Uumt.useMutation)((0, $64TeP.default));
    const { activationId: activationId, cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    const onSaveChanges = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'saveFilterChanges');
        filterId !== undefined && updateJiraCustomFilterJqlMutation({
            variables: {
                id: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }),
                jql: query
            },
            onCompleted: ({ jira: jira })=>{
                if (jira?.jiraFilterMutation?.updateJiraCustomFilterJql) {
                    const { success: success, filter: filter, errors: jiraErrors } = jira?.jiraFilterMutation?.updateJiraCustomFilterJql;
                    if (success && filter) {
                        const { name: name } = filter;
                        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({
                            actionSubject: 'issueFilterJql',
                            action: 'updated'
                        }), 'issueFilterJql updated');
                        showFlag({
                            id: $27f5e7d6c447efe5$export$a3ca021e3e6c7315,
                            render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eVAtv.SuccessFlag), {
                                    id: $27f5e7d6c447efe5$export$a3ca021e3e6c7315,
                                    messageId: "issue-navigator-custom-filters.ui.save-filter-dropdown.success-flag",
                                    messageType: "transactional",
                                    filterName: name,
                                    viewUrl: `${window.location.origin}/issues/?filter=${filterId}`,
                                    analyticsEvent: createAnalyticsEvent({
                                        actionSubject: 'button',
                                        action: 'clicked'
                                    }),
                                    ...renderProps
                                })
                        });
                    } else {
                        const errors = jiraErrors ? jiraErrors.map((error)=>error.message || '') : [];
                        showFlag({
                            id: $27f5e7d6c447efe5$export$f5e4c120ac01b615,
                            render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7oAQw.ErrorFlag), {
                                    id: $27f5e7d6c447efe5$export$f5e4c120ac01b615,
                                    messageId: "issue-navigator-custom-filters.ui.save-filter-dropdown.error-flag",
                                    messageType: "transactional",
                                    errors: errors,
                                    ...renderProps
                                })
                        });
                        (0, $jcw0u.default)({
                            event: analyticsEvent,
                            error: new Error(errors[0]),
                            meta: {
                                id: 'updateFilterJqlMutation',
                                packageName: 'jiraIssueNavigatorCustomFilters',
                                teamName: 'empanada'
                            }
                        });
                    }
                }
            },
            onError: (error)=>{
                showFlag({
                    id: $27f5e7d6c447efe5$export$f5e4c120ac01b615,
                    render: (renderProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7oAQw.ErrorFlag), {
                            id: $27f5e7d6c447efe5$export$f5e4c120ac01b615,
                            messageId: "issue-navigator-custom-filters.ui.save-filter-dropdown.error-flag.1",
                            messageType: "transactional",
                            ...renderProps,
                            errors: [
                                ''
                            ]
                        })
                });
                (0, $jcw0u.default)({
                    event: analyticsEvent,
                    error: error,
                    meta: {
                        id: 'updateFilterJqlMutation',
                        packageName: 'jiraIssueNavigatorCustomFilters',
                        teamName: 'empanada'
                    }
                });
                return undefined;
            }
        });
    }, [
        activationId,
        cloudId,
        createAnalyticsEvent,
        filterId,
        query,
        showFlag,
        updateJiraCustomFilterJqlMutation,
        analyticsEvent
    ]);
    const [isModalOpen, setIsModalOpen] = (0, $5uXOq.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(defaultOpen);
    const [shouldShowThirdPartyNudge, setShouldShowThirdPartyNudge] = (0, $5uXOq.useState)(false);
    const onOpenSaveFilterModal = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'saveFilterCopy');
        if (!(0, $4R6GH.fg)('nin-save-filter-dialog-entry-point')) setIsModalOpen(true);
    }, [
        createAnalyticsEvent,
        setIsModalOpen
    ]);
    const onCloseSaveFilterModal = (0, $5uXOq.useCallback)(()=>{
        setIsModalOpen(false);
    }, [
        setIsModalOpen
    ]);
    let modalProps;
    let entryPointProps;
    let entryPointParams;
    if ((0, $4R6GH.fg)('nin-save-filter-dialog-entry-point')) {
        modalProps = {
            width: 'medium',
            shouldScrollInViewport: true,
            shouldReturnFocus: false
        }; // eslint-disable-next-line react-hooks/rules-of-hooks
        entryPointProps = (0, $5uXOq.useMemo)(()=>({
                jql: query,
                filterId: filterId,
                onFilterSave: onFilterSave,
                title: formatMessage((0, $inHPh.default).copyFilterDialogTitle)
            }), [
            query,
            filterId,
            onFilterSave,
            formatMessage
        ]); // eslint-disable-next-line react-hooks/rules-of-hooks
        entryPointParams = (0, $5uXOq.useMemo)(()=>({
                filterAri: filterId !== null && filterId !== undefined ? (0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'filter',
                    resourceId: filterId,
                    activationId: activationId
                }) : undefined
            }), [
            filterId,
            cloudId,
            activationId
        ]);
    }
    const onTriggerClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        }), 'filterOptions');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowThirdPartyNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a0UsQ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($27f5e7d6c447efe5$var$DropdownMenuWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isOpen: isDropdownOpen,
        onOpenChange: (attrs)=>{
            setIsDropdownOpen(attrs.isOpen);
            if (attrs.isOpen) {
                setShouldShowThirdPartyNudge(true);
                onTriggerClick();
            }
        },
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                appearance: "link",
                ref: triggerRef,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                    label: formatMessage((0, $inHPh.default).saveFilter),
                    size: "small"
                })
            }, formatMessage((0, $inHPh.default).saveFilter)),
        shouldRenderToParent: (0, $4R6GH.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onSaveChanges
    }, formatMessage((0, $inHPh.default).saveChanges)), (0, $4R6GH.fg)('nin-save-filter-dialog-entry-point') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXAdy.ModalEntryPointDropdownItemTrigger), {
        onClick: onOpenSaveFilterModal,
        modalProps: modalProps,
        entryPoint: (0, $c88gN.saveFilterDialogEntryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "jiraSaveFilterDialog.SaveFilter",
        useInternalModal: true
    }, formatMessage((0, $inHPh.default).saveAsACopy)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: onOpenSaveFilterModal
    }, formatMessage((0, $inHPh.default).saveAsACopy))))), !(0, $4R6GH.fg)('nin-save-filter-dialog-entry-point') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKjus.AsyncSaveFilterDialogContent), {
        isOpen: isModalOpen,
        jql: query,
        filterId: filterId,
        onClose: onCloseSaveFilterModal,
        onFilterSave: onFilterSave,
        title: formatMessage((0, $inHPh.default).copyFilterDialogTitle)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $27f5e7d6c447efe5$var$DropdownMenuWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k4hekqvv",
            __cmplp.className
        ])
    });
});

});
parcelRegister("64TeP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e51d2a292043c16$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bfa68958cffd28f839eb1cc1261ee729>>
 * @relayHash a8b99d4e5148c557424db90f1be8215c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 33abce877d8ddf36bd3fdb295b2e91c467ceff0b718872d73a32845f7130d8d5
const $7e51d2a292043c16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "concreteType": "JiraMutation",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "concreteType": "JiraFilterMutation",
                    "kind": "LinkedField",
                    "name": "jiraFilterMutation",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "fields": [
                                        {
                                            "kind": "Variable",
                                            "name": "id",
                                            "variableName": "id"
                                        },
                                        {
                                            "kind": "Variable",
                                            "name": "jql",
                                            "variableName": "jql"
                                        }
                                    ],
                                    "kind": "ObjectValue",
                                    "name": "input"
                                }
                            ],
                            "concreteType": "JiraUpdateCustomFilterJqlPayload",
                            "kind": "LinkedField",
                            "name": "updateJiraCustomFilterJql",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "success"
                                },
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "message"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraCustomFilter",
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "jql"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainUpdateFilterJqlMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainUpdateFilterJqlMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "33abce877d8ddf36bd3fdb295b2e91c467ceff0b718872d73a32845f7130d8d5",
            "metadata": {},
            "name": "mainUpdateFilterJqlMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$7e51d2a292043c16$var$node.hash = "6807efed6a00f60f9cf95df455e467fd";
var $7e51d2a292043c16$export$2e2bcd8739ae039 = $7e51d2a292043c16$var$node;

});

parcelRegister("7oAQw", function(module, exports) {

$parcel$export(module.exports, "ErrorFlag", () => $8373e62b74d8a04b$export$518ba8e0e60f145f);

var $5uXOq = parcelRequire("5uXOq");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $1wpPp = parcelRequire("1wpPp");

var $koVbs = parcelRequire("koVbs");

var $f2rml = parcelRequire("f2rml");
const $8373e62b74d8a04b$export$518ba8e0e60f145f = ({ id: id, errors: errors, messageId: messageId = 'issue-navigator-actions-common.ui.error-flag.jira-error-flag', messageType: messageType = 'transactional' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const onDismissed = (0, $5uXOq.useCallback)(()=>dismissFlag(id), [
        dismissFlag,
        id
    ]);
    const description = (0, $5uXOq.useMemo)(()=>errors.reduce((desc, error)=>`${desc}\n${error}`), [
        errors
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wpPp.default), {
        id: (0, $7HGHK.fromFlagId)(id),
        onDismissed: onDismissed,
        title: formatMessage((0, $f2rml.default).flagTitle),
        description: description,
        messageId: messageId,
        messageType: messageType
    });
};

});
parcelRegister("f2rml", function(module, exports) {

$parcel$export(module.exports, "default", () => $9196e79ea8ea2ad1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9196e79ea8ea2ad1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "issue-navigator-actions-common.error-flag.flag-title",
        "defaultMessage": "Filter couldn't be saved"
    }
});

});


parcelRegister("eVAtv", function(module, exports) {

$parcel$export(module.exports, "SuccessFlag", () => $92d66436aee8a83b$export$93bd4963a1d00fd5);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $4ywcn = parcelRequire("4ywcn");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $d0WfM = parcelRequire("d0WfM");
const $92d66436aee8a83b$export$93bd4963a1d00fd5 = ({ id: id, filterName: filterName, viewUrl: viewUrl, analyticsEvent: analyticsEvent, messageId: messageId = 'issue-navigator-actions-common.ui.success-flag.jira-success-flag', messageType: messageType = 'transactional' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const [isCopied, setCopied] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const copyToClipboard = (0, $5uXOq.useCallback)(()=>{
        try {
            if ((0, $4R6GH.fg)('jfp-magma-undefined-navigator')) globalThis.navigator.clipboard.writeText(viewUrl);
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            navigator.clipboard.writeText(viewUrl);
            setCopied(true);
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'copyLink'); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'copyToClipboard',
                    packageName: 'jiraIssueNavigatorActionsCommon'
                }
            });
        }
    }, [
        analyticsEvent,
        viewUrl
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>{
        const flagActions = [];
        flagActions.push({
            content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92d66436aee8a83b$var$CopySuccess, null, formatMessage((0, $d0WfM.default).copyActionCopied)) : formatMessage((0, $d0WfM.default).copyAction),
            onClick: copyToClipboard
        });
        return flagActions;
    }, [
        copyToClipboard,
        formatMessage,
        isCopied
    ]);
    const onDismissed = (0, $5uXOq.useCallback)(()=>dismissFlag(id), [
        dismissFlag,
        id
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4ywcn.default), {
        id: (0, $7HGHK.fromFlagId)(id),
        onDismissed: onDismissed,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($92d66436aee8a83b$var$WordBreakSpan, null, formatMessage((0, $d0WfM.default).flagTitle, {
            name: filterName
        })),
        description: formatMessage((0, $d0WfM.default).flagDescription),
        messageId: messageId,
        messageType: messageType,
        actions: actions
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92d66436aee8a83b$var$CopySuccess = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazy73q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92d66436aee8a83b$var$WordBreakSpan = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1nmz1hna",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $92d66436aee8a83b$export$7ed12d2a5241e393 = {
    WordBreakSpan: $92d66436aee8a83b$var$WordBreakSpan
};

});
parcelRegister("d0WfM", function(module, exports) {

$parcel$export(module.exports, "default", () => $be725ec701d9f454$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $be725ec701d9f454$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    flagTitle: {
        "id": "issue-navigator-actions-common.success-flag.flag-title",
        "defaultMessage": "\"{name}\" filter saved"
    },
    flagDescription: {
        "id": "issue-navigator-actions-common.success-flag.flag-description",
        "defaultMessage": "We\u2019ve saved this filter successfully."
    },
    viewAction: {
        "id": "issue-navigator-actions-common.success-flag.view-action",
        "defaultMessage": "View filter"
    },
    copyAction: {
        "id": "issue-navigator-actions-common.success-flag.copy-action",
        "defaultMessage": "Copy link"
    },
    copyActionCopied: {
        "id": "issue-navigator-actions-common.success-flag.copy-action-copied",
        "defaultMessage": "Copied"
    }
});

});


parcelRegister("a0UsQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $18bfcc44ee4250a9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $apcoj = parcelRequire("apcoj");
const $18bfcc44ee4250a9$var$runtimeProps = {};
const $18bfcc44ee4250a9$var$entryPointParams = {};
const $18bfcc44ee4250a9$var$AsyncThirdPartyNudge = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $apcoj.thirdPartyNudgeEntryPoint), $18bfcc44ee4250a9$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "third-party-nudge-spotlight",
        packageName: "third-party-nudge",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: $18bfcc44ee4250a9$var$runtimeProps,
        errorFallback: "unmount"
    });
};
var $18bfcc44ee4250a9$export$2e2bcd8739ae039 = $18bfcc44ee4250a9$var$AsyncThirdPartyNudge;

});
parcelRegister("apcoj", function(module, exports) {

$parcel$export(module.exports, "thirdPartyNudgeEntryPoint", () => $b44a97c5eec5eb15$export$b751b31b276f613a);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $b44a97c5eec5eb15$export$b751b31b276f613a = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("h3bSU")), {
        moduleId: "3cb7fd8f",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("h3bSU", function(module, exports) {

let $c69bef8699e2d1e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c69bef8699e2d1e0$var$load("auQ6U").then(()=>parcelRequire('7R5AD'));

});



parcelRegister("inHPh", function(module, exports) {

$parcel$export(module.exports, "default", () => $610585c330983aff$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $610585c330983aff$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    saveFilter: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-filter",
        "defaultMessage": "Save filter"
    },
    saveChanges: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-changes",
        "defaultMessage": "Save changes"
    },
    saveAsACopy: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.save-as-a-copy",
        "defaultMessage": "Save as a copy"
    },
    copyFilterDialogTitle: {
        "id": "issue-navigator-custom-filters.save-filter-dropdown.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    }
});

});


parcelRegister("kQ256", function(module, exports) {

$parcel$export(module.exports, "useIntegrateDotDialogContext", () => $4f25f7900866c0e5$export$705d46354f301b1c);
$parcel$export(module.exports, "ShortcutsDialogIntegrationProvider", () => $4f25f7900866c0e5$export$97e3ca22c7078b46);

var $5uXOq = parcelRequire("5uXOq");
const $4f25f7900866c0e5$var$PRESET_VALUE = {
    DEFAULT: {
        isShortcutsDialogIntegrationAvailable: false
    },
    INTEGRATED: {
        isShortcutsDialogIntegrationAvailable: true
    }
};
const $4f25f7900866c0e5$var$IntegrateDotDialogContext = /*#__PURE__*/ (0, $5uXOq.createContext)($4f25f7900866c0e5$var$PRESET_VALUE.DEFAULT);
const $4f25f7900866c0e5$export$705d46354f301b1c = ()=>(0, $5uXOq.useContext)($4f25f7900866c0e5$var$IntegrateDotDialogContext);
const $4f25f7900866c0e5$export$97e3ca22c7078b46 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f25f7900866c0e5$var$IntegrateDotDialogContext.Provider, {
        value: $4f25f7900866c0e5$var$PRESET_VALUE.INTEGRATED
    }, children);

});

parcelRegister("3RNwj", function(module, exports) {

$parcel$export(module.exports, "JQLBuilderErrorBoundryFallback", () => $8e5460bcff63ee1a$export$4c766016a5659721);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $92Z2l = parcelRequire("92Z2l");

var $koVbs = parcelRequire("koVbs");

var $iWDqa = parcelRequire("iWDqa");
const $8e5460bcff63ee1a$var$onRefresh = ()=>{
    if (typeof window !== 'undefined') window.location.reload();
};
const $8e5460bcff63ee1a$export$4c766016a5659721 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "error",
        testId: "jql-builder-common.ui.error-boundry-fallback.section-message"
    }, formatMessage((0, $iWDqa.default).errorMessage, {
        link: (linkText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "link",
                spacing: "none",
                onClick: $8e5460bcff63ee1a$var$onRefresh
            }, linkText)
    }));
};

});
parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $VSDnB.fg)('platform_ads_explicit_font_styles') && $a97355a0cc6aeb06$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $dg0Fl = parcelRequire("dg0Fl");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");

const $d1d7dced94bb00f5$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$var$appearanceIconSchema[appearance] || $d1d7dced94bb00f5$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';



parcelRegister("iWDqa", function(module, exports) {

$parcel$export(module.exports, "default", () => $c45ebd3e2c96181c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c45ebd3e2c96181c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "jql-builder-common.error-boundry-fallback.error-message",
        "defaultMessage": "We couldn't load your search criteria. <link>Refresh the page</link> to try again."
    }
});

});


parcelRegister("8WcPx", function(module, exports) {

$parcel$export(module.exports, "default", () => $95e61a910f85b3f4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $4p4kl = parcelRequire("4p4kl");

var $kxZPA = parcelRequire("kxZPA");

const $95e61a910f85b3f4$var$JQLBuilderWithAIAsync = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("7TSK3")), {
    moduleId: "./src/packages/jql-builder/with-ai/src/index.tsx"
});
const $95e61a910f85b3f4$var$JQLBuilderWithAI = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-jql-builder-with-ai",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4p4kl.IssueNavigatorJQLBuilderSkeleton), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95e61a910f85b3f4$var$JQLBuilderWithAIAsync, props));
var $95e61a910f85b3f4$export$2e2bcd8739ae039 = $95e61a910f85b3f4$var$JQLBuilderWithAI;

});
parcelRegister("4p4kl", function(module, exports) {

$parcel$export(module.exports, "IssueNavigatorJQLBuilderSkeleton", () => $fb9c2cbb8213ab8c$export$5be82223ddc28851);
/* jql-builder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $9cyb9 = parcelRequire("9cyb9");
const $fb9c2cbb8213ab8c$var$customCssStyles = null;
const $fb9c2cbb8213ab8c$var$containerStyles = {
    height: '52px'
};
const $fb9c2cbb8213ab8c$export$5be82223ddc28851 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9cyb9))),
        containerStyles: $fb9c2cbb8213ab8c$var$containerStyles,
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("9cyb9", function(module, exports) {
module.exports = new URL("issue-navigator-jql-builder-skeleton.tpl.20beba3c.svg", import.meta.url).toString();

});


parcelRegister("7TSK3", function(module, exports) {

let $5c08220bcb163c90$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $5c08220bcb163c90$var$load("ffQaD"),
    $5c08220bcb163c90$var$load("kvRbA"),
    $5c08220bcb163c90$var$load("bmCqg")
]).then(()=>parcelRequire('7F6VS'));

});


parcelRegister("032ey", function(module, exports) {

$parcel$export(module.exports, "SEARCH_MODE_BASIC", () => $e090bb7ab54db3ef$export$f963d14b266e4d2e);
$parcel$export(module.exports, "SEARCH_MODE_ADVANCED", () => $e090bb7ab54db3ef$export$aad1d9eb9b751555);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_BASIC", () => $e090bb7ab54db3ef$export$87c41a6b3123c00f);
$parcel$export(module.exports, "SERVER_SEARCH_MODE_ADVANCED", () => $e090bb7ab54db3ef$export$a7a000706ebc3ba8);
$parcel$export(module.exports, "DEFAULT_SEARCH_MODE", () => $e090bb7ab54db3ef$export$e1eb2ddab803c5ec);
$parcel$export(module.exports, "mapSearchModeToAnalyticAtribute", () => $e090bb7ab54db3ef$export$70c8f980e4a50682);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_LEFT_LOCATION", () => $e090bb7ab54db3ef$export$4dab29e715a4e6fb);
$parcel$export(module.exports, "SEARCH_MODE_SWITCHER_RIGHT_LOCATION", () => $e090bb7ab54db3ef$export$59848395da0b4bcb);
$parcel$export(module.exports, "PACKAGE_NAME", () => $e090bb7ab54db3ef$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "TEAM_NAME", () => $e090bb7ab54db3ef$export$d57b6b390e78d90f);
const $e090bb7ab54db3ef$export$f963d14b266e4d2e = 'basic';
const $e090bb7ab54db3ef$export$aad1d9eb9b751555 = 'advanced';
const $e090bb7ab54db3ef$export$87c41a6b3123c00f = 'BASIC';
const $e090bb7ab54db3ef$export$a7a000706ebc3ba8 = 'ADVANCED';
const $e090bb7ab54db3ef$export$e1eb2ddab803c5ec = $e090bb7ab54db3ef$export$f963d14b266e4d2e;
const $e090bb7ab54db3ef$export$70c8f980e4a50682 = {
    [$e090bb7ab54db3ef$export$f963d14b266e4d2e]: $e090bb7ab54db3ef$export$f963d14b266e4d2e,
    [$e090bb7ab54db3ef$export$aad1d9eb9b751555]: 'JQL'
};
const $e090bb7ab54db3ef$export$4dab29e715a4e6fb = 'Left';
const $e090bb7ab54db3ef$export$59848395da0b4bcb = 'Right';
const $e090bb7ab54db3ef$export$b8b9d90f9e5bd72b = 'jiraJqlBuilder';
const $e090bb7ab54db3ef$export$d57b6b390e78d90f = 'empanada';

});

parcelRegister("elFwM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "SaveFilterDialog", () => $32d4bc710130ff58$export$935f6430ba933614);
$parcel$export(module.exports, "default", () => $32d4bc710130ff58$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $4R6GH = parcelRequire("4R6GH");

var $2KAtx = parcelRequire("2KAtx");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $c88gN = parcelRequire("c88gN");

var $cKjus = parcelRequire("cKjus");
const $32d4bc710130ff58$export$935f6430ba933614 = ({ buttonText: buttonText, filterId: filterId, ...props })=>{
    if (!(0, $4R6GH.fg)('nin-save-filter-dialog-entry-point')) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const openModal = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'saveFilterDialog');
            setIsOpen(true);
        }, [
            setIsOpen
        ]);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const closeModal = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
            setIsOpen
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: openModal,
            appearance: "link",
            testId: "save-filter-dialog.ui.save-filter-dialog.button"
        }, buttonText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cKjus.AsyncSaveFilterDialogContent), {
            onClose: closeModal,
            filterId: filterId,
            ...props,
            isOpen: isOpen
        }));
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const modalProps = (0, $5uXOq.useMemo)(()=>({
            width: 'medium',
            shouldScrollInViewport: true
        }), []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            filterId: filterId,
            ...props
        }), [
        filterId,
        props
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const cloudId = (0, $koeKL.useCloudId)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const activationId = (0, $fY39E.useActivationId)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            filterAri: filterId !== null && filterId !== undefined ? (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'filter',
                resourceId: filterId,
                activationId: activationId
            }) : undefined
        }), [
        filterId,
        cloudId,
        activationId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        modalProps: modalProps,
        entryPoint: (0, $c88gN.saveFilterDialogEntryPoint),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "jiraSaveFilterDialog.SaveFilter",
        useInternalModal: true
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: (_, analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'saveFilterDialog'),
            appearance: "link",
            testId: "save-filter-dialog.ui.save-filter-dialog.button",
            ref: ref
        }, buttonText));
};
var $32d4bc710130ff58$export$2e2bcd8739ae039 = $32d4bc710130ff58$export$935f6430ba933614;

});

parcelRegister("9z65D", function(module, exports) {

$parcel$export(module.exports, "AsyncSaveFilterDialog", () => $88c358d8076a9a73$export$2213da0eee0aa8f);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $4R6GH = parcelRequire("4R6GH");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $88c358d8076a9a73$var$SaveFilterDialog = (0, $kxZPA.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("elFwM"))), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/save-filter-dialog/src/ui/save-filter-dialog/main.tsx"
});
const $88c358d8076a9a73$export$2213da0eee0aa8f = (props)=>{
    if ((0, $4R6GH.fg)('nin-save-filter-dialog-entry-point')) throw new Error('RLL-based AsyncSaveFilterDialog Component should no longer be used');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "save-filters-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "link",
            isDisabled: true
        }, props.buttonText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88c358d8076a9a73$var$SaveFilterDialog, props));
};

});

parcelRegister("acgaZ", function(module, exports) {

$parcel$export(module.exports, "useJqlSearchStatus", () => $68036d2e3f2d9e10$export$6d36bd77a6aeafd9);

var $0qvdT = parcelRequire("0qvdT");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jcw0u = parcelRequire("jcw0u");

var $6MtPV = parcelRequire("6MtPV");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $4fmBV = parcelRequire("4fmBV");
const $68036d2e3f2d9e10$export$529d2e9d8e9d3cad = 2000; // wait 2s before making the request
const $68036d2e3f2d9e10$export$bbec15ef0a4926b6 = 7000; // wait 7s before retrying after the previous request
const $68036d2e3f2d9e10$export$cf31b3fd6a57249f = 5; // Check the status no more than 5 times for the same JQL search
const $68036d2e3f2d9e10$var$statusToMessages = (status, formatMessage)=>{
    if (status == null || !('functions' in status) || !Array.isArray(status?.functions)) return [];
    const processing = status.functions.filter((fn)=>fn.app && fn.function && fn.status === 'PROCESSING');
    const functions = Array.from(new Set(processing.map((fn)=>fn.function)));
    const apps = Array.from(new Set(processing.map((fn)=>fn.app)));
    switch(functions.length){
        case 0:
            return [];
        case 1:
            {
                const message = formatMessage((0, $4fmBV.default).singleSlowForgeFunction, {
                    functionName: functions[0],
                    appName: apps[0]
                });
                return [
                    {
                        type: 'info',
                        message: message
                    }
                ];
            }
        default:
            {
                let message;
                switch(apps.length){
                    case 1:
                        message = formatMessage((0, $4fmBV.default).multipleSlowForgeFunctionsFromTheSameApp, {
                            appName: apps[0]
                        });
                        break;
                    case 2:
                        message = formatMessage((0, $4fmBV.default).multipleSlowForgeFunctionsTwoApps, {
                            appName1: apps[0],
                            appName2: apps[1]
                        });
                        break;
                    default:
                        message = formatMessage((0, $4fmBV.default).multipleSlowForgeFunctionsThreeApps, {
                            appName1: apps[0],
                            appName2: apps[1],
                            appName3: apps[2]
                        });
                }
                return [
                    {
                        type: 'info',
                        message: message
                    }
                ];
            }
    }
};
const $68036d2e3f2d9e10$var$analyticsMeta = {
    id: 'jqlSearchStatus',
    packageName: 'jiraIssueNavigator',
    teamName: 'empanada'
};
const $68036d2e3f2d9e10$var$EMPTY_EXTERNAL_INFO = [];
const $68036d2e3f2d9e10$export$6d36bd77a6aeafd9 = ({ query: query, isSearching: isSearching })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [statusMessages, setStatusMessages] = (0, $5uXOq.useState)($68036d2e3f2d9e10$var$EMPTY_EXTERNAL_INFO);
    const isSearchingRef = (0, $5uXOq.useRef)(isSearching);
    const timeoutRef = (0, $5uXOq.useRef)(null);
    const fetchCountRef = (0, $5uXOq.useRef)(0);
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireOperationalEvent = (0, $5uXOq.useCallback)((action, attributes)=>(0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${$68036d2e3f2d9e10$var$analyticsMeta.packageName}.${$68036d2e3f2d9e10$var$analyticsMeta.id} ${action}`, attributes), [
        createAnalyticsEvent
    ]);
    const cancelPendingOperations = (0, $5uXOq.useCallback)(()=>{
        timeoutRef.current && clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
        fetchCountRef.current = 0;
    }, []);
    const scheduleSearchStatusFetch = (0, $5uXOq.useCallback)((delay)=>{
        const isRetry = delay === $68036d2e3f2d9e10$export$bbec15ef0a4926b6;
        const defaultAnalyticsAttributes = (0, $6MtPV.createAttributes)({
            isRetry: isRetry
        });
        const timeout = setTimeout(()=>{
            if (fetchCountRef.current >= $68036d2e3f2d9e10$export$cf31b3fd6a57249f) {
                fireOperationalEvent('interrupted', {
                    ...defaultAnalyticsAttributes,
                    reason: 'MAX_ATTEMPTS_REACHED'
                });
                return;
            }
            fireOperationalEvent('attempt', defaultAnalyticsAttributes);
            fetchCountRef.current += 1;
            (0, $8Uumt.fetchQuery)(environment, (0, $0qvdT.default), {
                cloudId: cloudId,
                jql: query
            }, {
                fetchPolicy: 'network-only'
            }).toPromise().then((data)=>{
                let hasPendingFn = false;
                const status = data?.jira?.issueSearchStatus ?? null;
                if (isSearchingRef.current && timeoutRef.current === timeout) {
                    const infos = $68036d2e3f2d9e10$var$statusToMessages(status, formatMessage);
                    setStatusMessages(infos);
                    if (infos.length) {
                        hasPendingFn = true;
                        scheduleSearchStatusFetch($68036d2e3f2d9e10$export$bbec15ef0a4926b6);
                    }
                }
                fireOperationalEvent('finished', {
                    ...defaultAnalyticsAttributes,
                    hasPendingFn: hasPendingFn
                });
            }).catch((error)=>{
                (0, $jcw0u.default)({
                    meta: $68036d2e3f2d9e10$var$analyticsMeta,
                    attributes: (0, $6MtPV.createAttributes)({
                        error: error,
                        isRetry: isRetry
                    })
                });
                if (isSearchingRef.current && timeoutRef.current === timeout) scheduleSearchStatusFetch($68036d2e3f2d9e10$export$bbec15ef0a4926b6);
            });
        }, delay);
        timeoutRef.current = timeout;
    }, [
        cloudId,
        environment,
        fireOperationalEvent,
        formatMessage,
        query
    ]);
    (0, $5uXOq.useEffect)(()=>{
        isSearchingRef.current = isSearching;
    }, [
        isSearching
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setStatusMessages($68036d2e3f2d9e10$var$EMPTY_EXTERNAL_INFO);
        cancelPendingOperations();
        if (isSearching) scheduleSearchStatusFetch($68036d2e3f2d9e10$export$529d2e9d8e9d3cad);
    }, [
        isSearching,
        query,
        cancelPendingOperations,
        scheduleSearchStatusFetch
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            messages: statusMessages
        }), [
        statusMessages
    ]);
};

});
parcelRegister("0qvdT", function(module, exports) {

$parcel$export(module.exports, "default", () => $12b7df9e3f6f6313$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<06f329a4787d481a42a4c55f0b801953>>
 * @relayHash 7d47bdaa4d5aeb847704c6e13c25fd58
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 8e680ef9e6d909ed43bf02677fe95ccafcad565518b3a659febcd16aa4f5bbd8
const $12b7df9e3f6f6313$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "jql",
                            "variableName": "jql"
                        }
                    ],
                    "concreteType": "JiraIssueSearchStatus",
                    "kind": "LinkedField",
                    "name": "issueSearchStatus",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JiraJqlFunctionProcessingStatus",
                            "kind": "LinkedField",
                            "name": "functions",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "status"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "function"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "app"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "jqlSearchStatus_Query",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "jqlSearchStatus_Query",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "8e680ef9e6d909ed43bf02677fe95ccafcad565518b3a659febcd16aa4f5bbd8",
            "metadata": {},
            "name": "jqlSearchStatus_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$12b7df9e3f6f6313$var$node.hash = "9dd1bed08ceb0d25df132f36097ae6d1";
var $12b7df9e3f6f6313$export$2e2bcd8739ae039 = $12b7df9e3f6f6313$var$node;

});

parcelRegister("4fmBV", function(module, exports) {

$parcel$export(module.exports, "default", () => $15682dd15c8b1e33$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $15682dd15c8b1e33$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    singleSlowForgeFunction: {
        "id": "issue-navigator.controllers.jql-search-status.single-slow-forge-function",
        "defaultMessage": "{appName} is still executing the {functionName} JQL function."
    },
    multipleSlowForgeFunctionsFromTheSameApp: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-from-the-same-app",
        "defaultMessage": "{appName} is still executing multiple JQL functions."
    },
    multipleSlowForgeFunctionsTwoApps: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-two-apps",
        "defaultMessage": "{appName1} and {appName2} are still executing multiple JQL functions."
    },
    multipleSlowForgeFunctionsThreeApps: {
        "id": "issue-navigator.controllers.jql-search-status.multiple-slow-forge-functions-three-apps",
        "defaultMessage": "{appName1}, {appName2}, and {appName3} are still executing multiple JQL functions."
    }
});

});


parcelRegister("anxcG", function(module, exports) {

$parcel$export(module.exports, "useJqlSearch", () => $34ef274676d00077$export$e69d0de2e354a2cb);

var $5uXOq = parcelRequire("5uXOq");

var $gwtSG = parcelRequire("gwtSG");

var $38r5c = parcelRequire("38r5c");
const $34ef274676d00077$export$e69d0de2e354a2cb = (changeJql)=>{
    const query = (0, $gwtSG.useResolvedJql)();
    const { onRefetch: onRefetch } = (0, $38r5c.useIssueSearchActions)();
    const onSearch = (0, $5uXOq.useCallback)((jql)=>{
        if (jql === query) // This will execute a new search against the network with current JQL input arguments
        onRefetch();
        else changeJql && changeJql(jql);
    }, [
        query,
        onRefetch,
        changeJql
    ]);
    return {
        onSearch: onSearch,
        query: query
    };
};

});

parcelRegister("bNJuB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f106025efda7e896$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f106025efda7e896$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    saveFilterButton: {
        "id": "issue-navigator.jql-builder.save-filter-button",
        "defaultMessage": "Save filter"
    },
    saveFilterDialogTitle: {
        "id": "issue-navigator.jql-builder.save-filter-dialog-title",
        "defaultMessage": "Save filter"
    },
    copyFilterButton: {
        "id": "issue-navigator.jql-builder.copy-filter-button",
        "defaultMessage": "Copy filter"
    },
    copyFilterDialogTitle: {
        "id": "issue-navigator.jql-builder.copy-filter-dialog-title",
        "defaultMessage": "Copy filter"
    }
});

});

parcelRegister("5aoL8", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $c1e8091431e2a9ec$export$d58b72b7d3c4072c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $3EOg8 = parcelRequire("3EOg8");
const $c1e8091431e2a9ec$var$IconContainer = ({ children: children })=>{
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_otyru2gc _w8l5t9kd _1752t9kd"
        ])
    }, children);
};
const $c1e8091431e2a9ec$var$MessageContainer = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150",
        xcss: $c1e8091431e2a9ec$var$stackStyles,
        alignInline: "center"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text"
    }, formatMessage((0, $3EOg8.default).noOptionsPrimaryMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $3EOg8.default).noOptionsSecondaryMessage)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c1e8091431e2a9ec$var$boxStyles
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", {
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyru2gc _18u0idpf _1i4qfg65"
        ])
    }, formatMessage((0, $3EOg8.default).fieldNotFoundMessage)));
};
const $c1e8091431e2a9ec$export$d58b72b7d3c4072c = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1e8091431e2a9ec$var$MessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1e8091431e2a9ec$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        label: "",
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon-subtle, #626F86)"
    })));
};
const $c1e8091431e2a9ec$var$boxStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: 'space.100',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    paddingBottom: 'space.100',
    color: 'color.text.subtle',
    textAlign: 'center'
});
const $c1e8091431e2a9ec$var$stackStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.150',
    paddingInline: 'space.100'
});
const $c1e8091431e2a9ec$var$titleStyles = null;
const $c1e8091431e2a9ec$var$iconContainerStyles = null;

});
parcelRegister("3EOg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d1234d483fa7193$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1d1234d483fa7193$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    fieldNotFoundMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.field-not-found-message",
        "defaultMessage": "We couldn't find the field you are looking for."
    },
    noOptionsPrimaryMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.no-options-primary-message",
        "defaultMessage": "We couldn't find what you're looking for"
    },
    noOptionsSecondaryMessage: {
        "id": "issue-navigator.jql-builder.no-options-message.no-options-secondary-message",
        "defaultMessage": "Try using different search terms."
    }
});

});


parcelRegister("66jXs", function(module, exports) {

$parcel$export(module.exports, "ResetButton", () => $8f283f726de8b644$export$2491f201e3dd9acf);
$parcel$export(module.exports, "default", () => $8f283f726de8b644$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $7HGp6 = parcelRequire("7HGp6");
const $8f283f726de8b644$export$2491f201e3dd9acf = ({ onReset: onReset, isResetToFilter: isResetToFilter = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleOnReset = (0, $5uXOq.useCallback)((mouseEvent, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, isResetToFilter ? 'goBackToFilterButton' : 'resetButton', {
            // If number of clicks is 0, button was actioned using the keyboard
            keyboard: mouseEvent.detail === 0
        });
        onReset && onReset(isResetToFilter);
    }, [
        onReset,
        isResetToFilter
    ]);
    const resetButtonText = (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $7HGp6.default).clearFiltersButtonText : (0, $7HGp6.default).resetButtonText;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8f283f726de8b644$var$ResetButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "issue-navigator.ui.jql-builder.reset-button",
        appearance: "subtle-link",
        onClick: handleOnReset
    }, formatMessage(isResetToFilter ? (0, $7HGp6.default).goBackToFilterButtonText : resetButtonText)));
};
var $8f283f726de8b644$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $8f283f726de8b644$export$2491f201e3dd9acf;
const $8f283f726de8b644$var$ResetButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zkb7n _i0dlf1ug _1e0c1txw _p12fuuw1 _4cvr1h6o _4t3izwfg _19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7HGp6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b65ac11d69a3064$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0b65ac11d69a3064$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    clearFiltersButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.clear-filters-button-text",
        "defaultMessage": "Clear filters"
    },
    resetButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.reset-button-text",
        "defaultMessage": "Reset"
    },
    goBackToFilterButtonText: {
        "id": "issue-navigator.jql-builder.reset-button.go-back-to-filter-button-text",
        "defaultMessage": "Go back to filter"
    }
});

});


parcelRegister("weR3I", function(module, exports) {

$parcel$export(module.exports, "useJqlBuilderInstrumentation", () => $83b99282af44666a$export$42691712ca1334f9);

var $5uXOq = parcelRequire("5uXOq");

var $a8lIB = parcelRequire("a8lIB");
const $83b99282af44666a$export$42691712ca1334f9 = ()=>{
    const [finished, setFinished] = (0, $5uXOq.useState)(false);
    return (0, $5uXOq.useMemo)(()=>({
            startJqlBuilderMetric: ()=>{
                if (finished) return;
                (0, $a8lIB.NINJqlBuilderAsyncLoad).start();
            },
            stopJqlBuilderMetric: ()=>{
                setFinished(true);
                (0, $a8lIB.NINJqlBuilderAsyncLoad).stop();
            },
            markJqlBuilderMetric: (mark)=>{
                if (finished) return;
                (0, $a8lIB.markOnce)(mark);
            }
        }), [
        finished
    ]);
};

});

parcelRegister("3iu8n", function(module, exports) {

$parcel$export(module.exports, "isOnlyJqlAndDifferentToDefault", () => $6170d953a5f8d41c$export$3cfc4f52186efe7d);
$parcel$export(module.exports, "isOnlyFilterAndDifferentToDefault", () => $6170d953a5f8d41c$export$933470cfeba275aa);
$parcel$export(module.exports, "filterAndJqlIsTheSameAndDifferentToDefault", () => $6170d953a5f8d41c$export$a25fc74cc3fc7015);
$parcel$export(module.exports, "jqlIsDifferentToFilter", () => $6170d953a5f8d41c$export$7dfcf59726e2b396);
$parcel$export(module.exports, "isFilterJqlModified", () => $6170d953a5f8d41c$export$d3d543997ba807);
const $6170d953a5f8d41c$export$3cfc4f52186efe7d = (jqlParam, defaultJqlTerm, filterParam)=>filterParam === undefined && jqlParam !== undefined && jqlParam.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $6170d953a5f8d41c$export$933470cfeba275aa = (jqlParam, defaultJqlTerm, filterJqlTerm)=>filterJqlTerm !== undefined && jqlParam === undefined && filterJqlTerm.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $6170d953a5f8d41c$export$a25fc74cc3fc7015 = (jqlParam, defaultJqlTerm, filterJqlTerm)=>jqlParam !== undefined && filterJqlTerm !== undefined && jqlParam.toLowerCase() === filterJqlTerm.toLowerCase() && filterJqlTerm.toLowerCase() !== defaultJqlTerm.toLowerCase();
const $6170d953a5f8d41c$export$7dfcf59726e2b396 = (jqlParam, filterJqlTerm)=>jqlParam !== undefined && filterJqlTerm !== undefined && filterJqlTerm.toLowerCase() !== jqlParam.toLowerCase();
const $6170d953a5f8d41c$export$d3d543997ba807 = ({ query: query, filterJql: filterJql })=>filterJql !== undefined && query.toLowerCase().trim() !== filterJql.toLowerCase().trim();

});


parcelRegister("7Cqtr", function(module, exports) {

$parcel$export(module.exports, "default", () => $912451f7718e6cf5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $912451f7718e6cf5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    screenReaderGroupResultInfo: {
        "id": "issue-navigator.screen-reader-group-result-info",
        "defaultMessage": "Grouping has been applied to the list."
    },
    screenReaderSearchResultInfo: {
        "id": "issue-navigator.screen-reader-search-result-info",
        "defaultMessage": "{total, plural, one {One issue matches your search.} other {{total} issues match your search.}}"
    },
    screenReaderSearchResultMoreInfo: {
        "id": "issue-navigator.screen-reader-search-result-more-info",
        "defaultMessage": "{total, plural, one {{total} or more issues found} other {{total} or more issues found}}."
    },
    screenReaderSearchResultInfoIssueTermRefresh: {
        "id": "issue-navigator.screen-reader-search-result-info-issue-term-refresh",
        "defaultMessage": "{total, plural, one {One work item matches your search.} other {{total} work items match your search.}}"
    },
    screenReaderSearchResultMoreInfoIssueTermRefresh: {
        "id": "issue-navigator.screen-reader-search-result-more-info-issue-term-refresh",
        "defaultMessage": "{total, plural, one {{total} or more work items found} other {{total} or more work items found}}."
    }
});

});

parcelRegister("5RTlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f478b4b7c16dded$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");

var $3Tty1 = parcelRequire("3Tty1");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $9f478b4b7c16dded$var$RegisterDotShortcut = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ isLoaded: isLoaded }, { open: open }] = (0, $d8lE2.useCommandPaletteIsLoaded)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: {
            '.': {
                callback: (ev)=>{
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'pressed',
                        actionSubject: 'keyboardShortcut'
                    }), 'dotDialogKeyboardShortcut', {
                        keyPressed: '.',
                        keyboardShortcut: true,
                        isLoaded: isLoaded
                    });
                    ev?.preventDefault();
                    open();
                }
            }
        }
    });
};
var $9f478b4b7c16dded$export$2e2bcd8739ae039 = $9f478b4b7c16dded$var$RegisterDotShortcut;

});

parcelRegister("6tXCF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7541b9a37d8ce6a5$export$2e2bcd8739ae039);

var $gPAgh = parcelRequire("gPAgh");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $5Czte = parcelRequire("5Czte");

var $atxn1 = parcelRequire("atxn1");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $ih9zY = parcelRequire("ih9zY");
const $7541b9a37d8ce6a5$var$IssueNavigatorSpotlight = ({ hasIssueResults: hasIssueResults, userPreferences: userPreferences, isAiEnabled: isAiEnabled })=>{
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const searchModeResponse = (0, $8Uumt.useFragment)((0, $gPAgh.default), userPreferences);
    const selectedSearchMode = (0, $atxn1.toSearchModeWithBasicModeFallback)(searchModeResponse?.jqlBuilderSearchMode);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Czte.NinChangeboardingTourCard), {
        mode: selectedSearchMode,
        view: (0, $eJ0Zs.convertToView)(view),
        hasIssueResults: hasIssueResults,
        isAiEnabled: isAiEnabled
    });
};
var $7541b9a37d8ce6a5$export$2e2bcd8739ae039 = $7541b9a37d8ce6a5$var$IssueNavigatorSpotlight;

});
parcelRegister("gPAgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $74e7fcdf8e98c48e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<30a8994404dfcae5d894d268d148ffe9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $74e7fcdf8e98c48e$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "spotlight_issueNavigator_IssueNavigatorSpotlight",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "jqlBuilderSearchMode"
        }
    ],
    "type": "JiraUserPreferences"
};
$74e7fcdf8e98c48e$var$node.hash = "3c8e72948beb901cccd7a6650610b18e";
var $74e7fcdf8e98c48e$export$2e2bcd8739ae039 = $74e7fcdf8e98c48e$var$node;

});

parcelRegister("atxn1", function(module, exports) {

$parcel$export(module.exports, "toSearchModeWithBasicModeFallback", () => $b0ab4dfe8728dd0f$export$7c0f55a4bd3730ea);
$parcel$export(module.exports, "toServerSearchMode", () => $b0ab4dfe8728dd0f$export$32a166cc1b3e6927);

var $032ey = parcelRequire("032ey");
function $b0ab4dfe8728dd0f$export$7c0f55a4bd3730ea(value) {
    switch(value){
        case 0, $032ey.SERVER_SEARCH_MODE_ADVANCED:
            return 0, $032ey.SEARCH_MODE_ADVANCED;
        default:
            return 0, $032ey.DEFAULT_SEARCH_MODE;
    }
}
function $b0ab4dfe8728dd0f$export$32a166cc1b3e6927(mode) {
    switch(mode){
        case 0, $032ey.SEARCH_MODE_ADVANCED:
            return 0, $032ey.SERVER_SEARCH_MODE_ADVANCED;
        default:
            return 0, $032ey.SERVER_SEARCH_MODE_BASIC;
    }
}

});


parcelRegister("dqObP", function(module, exports) {

$parcel$export(module.exports, "default", () => $072aa667050b5f51$export$2e2bcd8739ae039);

var $iZ0Dm = parcelRequire("iZ0Dm");

var $12cBT = parcelRequire("12cBT");

var $d0LIH = parcelRequire("d0LIH");

var $iCUpo = parcelRequire("iCUpo");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $gcl1l = parcelRequire("gcl1l");

var $1asmd = parcelRequire("1asmd");

var $hP2me = parcelRequire("hP2me");

var $3HwlS = parcelRequire("3HwlS");

var $48rMm = parcelRequire("48rMm");

var $6s1PB = parcelRequire("6s1PB");

var $imS60 = parcelRequire("imS60");

var $4R6GH = parcelRequire("4R6GH");

var $iofGi = parcelRequire("iofGi");

var $7OUvL = parcelRequire("7OUvL");

var $6UAdF = parcelRequire("6UAdF");

var $jjbNu = parcelRequire("jjbNu");

var $1igGa = parcelRequire("1igGa");

var $ih9zY = parcelRequire("ih9zY");

var $gwtSG = parcelRequire("gwtSG");

var $cKK2E = parcelRequire("cKK2E");

var $38r5c = parcelRequire("38r5c");
const $072aa667050b5f51$var$getLastPage = (pageCursors)=>{
    if (pageCursors?.last) return pageCursors.last.pageNumber;
    if (pageCursors?.around?.length) return pageCursors.around[pageCursors.around.length - 1]?.pageNumber;
    return undefined;
};
const $072aa667050b5f51$var$styles = {
    jqlWrapper: "_5ynfkb7n"
};
const $072aa667050b5f51$var$TopBar = ({ ActionMenu: ActionMenu, filter: filter, issueResults: issueResults, HeaderSkeletonImage: HeaderSkeletonImage, jqlBuilder: jqlBuilder, jiraViewResult: jiraViewResult, isGroupingSupported: isGroupingSupported, onChangeFilter: onChangeFilter, project: project })=>{
    const issueResultsData = (0, $8Uumt.useFragment)((0, $iCUpo.default), issueResults);
    // Compute page data for our search results which is needed when requesting items for the legacy meatball menu
    const offset = (issueResultsData?.issueNavigatorPageInfo?.firstIssuePosition ?? 1) - 1; // offset is 0 based so subtract 1
    const pages = $072aa667050b5f51$var$getLastPage(issueResultsData?.pageCursors) ?? 0;
    const total = issueResultsData?.totalIssueSearchResultCount ?? 0;
    const searchResultPageData = (0, $5uXOq.useMemo)(()=>({
            offset: offset,
            pages: pages,
            total: total
        }), [
        offset,
        pages,
        total
    ]);
    const { filterId: filterId } = (0, $gwtSG.useActiveJql)();
    const jql = (0, $gwtSG.useResolvedJql)();
    const { filterQueryIsFetching: filterQueryIsFetching } = (0, $cKK2E.useFilterQuery)();
    const filterData = (0, $8Uumt.useFragment)((0, $d0LIH.default), filter);
    const jiraViewData = (0, $8Uumt.useFragment)((0, $12cBT.default), jiraViewResult);
    const projectData = (0, $8Uumt.useFragment)((0, $iZ0Dm.default), project);
    const filterDetails = (0, $5uXOq.useMemo)(()=>filterData ? {
            filterId: filterData.filterId,
            name: filterData.name,
            jql: filterData.jql,
            isFavourite: Boolean(filterData.isFavourite)
        } : undefined, [
        filterData
    ]);
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const jiraViewResultData = jiraViewData;
    let onChangeHierarchy = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    let onChangeGroupedByField = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    let onChangeHideDone = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ onChangeHierarchy: onChangeHierarchy, onChangeGroupedByField: onChangeGroupedByField, onChangeHideDone: onChangeHideDone } = (0, $38r5c.useIssueSearchActions)());
    let hideDone = false;
    if ((0, $4R6GH.fg)('jsc_bulk_edit_hide_done_work_items')) hideDone = jiraViewData?.viewSettings?.hideDone ?? false;
    const HierarchyToggle = jiraViewResultData && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjbNu.HierarchyToggleItem), {
        isGroupingSupported: isGroupingSupported,
        viewResult: jiraViewResultData,
        onChangeHierarchy: onChangeHierarchy
    }) : null;
    const GroupByDropdown = isGroupingSupported && jiraViewData && (0, $6UAdF.isJiraSpreadsheetView)(jiraViewData) && view !== 'detail' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hP2me.GroupByDropdown), {
        onChangeGroupedByField: onChangeGroupedByField,
        spreadsheetView: jiraViewData
    }) : null;
    let onResetSelectedIssues = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
    if (// eslint-disable-next-line jira/ff/no-preconditioning
    (0, $6s1PB.expVal)('bulk_operations_in_nin_experiment', 'isEnabled', false) && (0, $4R6GH.fg)('jsc_list_hide_done_items')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ reset: onResetSelectedIssues } = (0, $48rMm.useIssueTableSelectedIssuesActions)());
    if (filterQueryIsFetching) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(HeaderSkeletonImage, null);
    const HideDoneToggle = jiraViewResultData && view !== 'detail' && (0, $4R6GH.fg)('jsc_list_hide_done_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iofGi.HideDoneItemsToggle), {
        viewResult: jiraViewResultData,
        onChangeHideDone: onChangeHideDone,
        onResetSelectedIssues: onResetSelectedIssues,
        project: projectData ?? null
    }) : null;
    const saveResetViewSettingsButton = jiraViewResultData && (0, $6s1PB.expVal)('saved_list_view', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7OUvL.SaveResetViewSettingsButton), {
        viewFragment: jiraViewResultData
    });
    const pageTopBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1asmd.PageTopBar), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ActionMenu, {
            jql: jql,
            filterId: filterId,
            filterDetails: filterDetails,
            searchResultPageData: searchResultPageData,
            HierarchyToggle: HierarchyToggle,
            GroupByDropdown: GroupByDropdown,
            HideDoneToggle: HideDoneToggle,
            SaveResetViewSettingsButton: saveResetViewSettingsButton,
            isHideDoneWorkItemsEnabled: hideDone,
            onChangeFilter: onChangeFilter
        }),
        bottomBar: jqlBuilder
    });
    if ((0, $3HwlS.getWillShowNav4)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "top-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $072aa667050b5f51$var$styles.jqlWrapper
        ])
    }, pageTopBar));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imS60.default), {
        name: "top-bar"
    }, pageTopBar);
};
var $072aa667050b5f51$export$2e2bcd8739ae039 = (0, $1igGa.withReportErrors)($072aa667050b5f51$var$TopBar, {
    id: 'ui.topbar.unhandled',
    packageName: (0, $6UAdF.PACKAGE_NAME),
    teamName: (0, $6UAdF.TEAM_NAME),
    sendToPrivacyUnsafeSplunk: true,
    attributes: (0, $gcl1l.isLoaderErrorAttributes)
});

});
parcelRegister("iZ0Dm", function(module, exports) {

$parcel$export(module.exports, "default", () => $37144bbd49aa7ccf$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e77ea76df4beb00a3c30efbe8205b523>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $37144bbd49aa7ccf$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topBar_issueNavigator_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle_project"
        }
    ],
    "type": "JiraProject"
};
$37144bbd49aa7ccf$var$node.hash = "55a62f7611991a65e32f4906894b8260";
var $37144bbd49aa7ccf$export$2e2bcd8739ae039 = $37144bbd49aa7ccf$var$node;

});

parcelRegister("12cBT", function(module, exports) {

$parcel$export(module.exports, "default", () => $24510a11b4a5f3a6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ac502013e73d87d494a5199022ec6e05>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $24510a11b4a5f3a6$var$node = {
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider"
        },
        {
            "kind": "RootArgument",
            "name": "groupBy"
        },
        {
            "kind": "RootArgument",
            "name": "issueSearchInput"
        },
        {
            "kind": "RootArgument",
            "name": "staticViewInput"
        }
    ],
    "kind": "Fragment",
    "name": "topBar_issueNavigator_jiraViewResult",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "__typename"
        },
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "hierarchyToggle_issueNavigator_HierarchyToggleItem"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "ui_issueTableGroupByDropdown_GroupByDropdown"
                },
                {
                    "kind": "FragmentSpread",
                    "name": "src_issueTableHideDoneToggle_HideDoneItemsToggle_viewResult"
                },
                {
                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewenabledrelayprovider",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "SaveResetViewSettingsButton"
                        }
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "groupBy",
                            "variableName": "groupBy"
                        },
                        {
                            "kind": "Variable",
                            "name": "issueSearchInput",
                            "variableName": "issueSearchInput"
                        },
                        {
                            "kind": "Variable",
                            "name": "staticViewInput",
                            "variableName": "staticViewInput"
                        }
                    ],
                    "concreteType": "JiraIssueSearchViewConfigSettings",
                    "kind": "LinkedField",
                    "name": "viewSettings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hideDone"
                        }
                    ]
                }
            ],
            "type": "JiraSpreadsheetView",
            "abstractKey": "__isJiraSpreadsheetView"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$24510a11b4a5f3a6$var$node.hash = "f14da59e0b4c43049dee842e89bc78ad";
var $24510a11b4a5f3a6$export$2e2bcd8739ae039 = $24510a11b4a5f3a6$var$node;

});

parcelRegister("d0LIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d39de334e93931$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6ab7c2a8b5f9d7e53e2eda0626fb3cbe>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $45d39de334e93931$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "topBar_issueNavigator_filter",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "filterId"
        },
        {
            "kind": "ScalarField",
            "name": "name"
        },
        {
            "kind": "ScalarField",
            "name": "isFavourite"
        },
        {
            "kind": "ScalarField",
            "name": "jql"
        }
    ],
    "type": "JiraFilter",
    "abstractKey": "__isJiraFilter"
};
$45d39de334e93931$var$node.hash = "d1fd34a229f9cb2668ab6793af284885";
var $45d39de334e93931$export$2e2bcd8739ae039 = $45d39de334e93931$var$node;

});

parcelRegister("iCUpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $a632fb92c01e9f2e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<222e07e55baf5ff3dcc37bb6cbd7a80e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a632fb92c01e9f2e$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "pageNumber"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "topBar_issueNavigator_issueResults",
        "selections": [
            {
                "concreteType": "JiraIssueNavigatorPageInfo",
                "kind": "LinkedField",
                "name": "issueNavigatorPageInfo",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "firstIssuePosition"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "maxCursors",
                        "value": 7
                    }
                ],
                "concreteType": "JiraPageCursors",
                "kind": "LinkedField",
                "name": "pageCursors",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "around",
                        "plural": true,
                        "selections": v0 /*: any*/ 
                    },
                    {
                        "concreteType": "JiraPageCursor",
                        "kind": "LinkedField",
                        "name": "last",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "storageKey": "pageCursors(maxCursors:7)"
            },
            {
                "kind": "ScalarField",
                "name": "totalIssueSearchResultCount"
            }
        ],
        "type": "JiraIssueConnection"
    };
}();
$a632fb92c01e9f2e$var$node.hash = "52b4c743e436bc90ea0831559f2c3e48";
var $a632fb92c01e9f2e$export$2e2bcd8739ae039 = $a632fb92c01e9f2e$var$node;

});

parcelRegister("1asmd", function(module, exports) {

$parcel$export(module.exports, "PageTopBar", () => $a509d50a7a06aca2$export$7e5801dc91bf1819);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");

var $cS37j = parcelRequire("cS37j");

var $3HwlS = parcelRequire("3HwlS");

var $dCm1o = parcelRequire("dCm1o");

const $a509d50a7a06aca2$var$SporkPageTopBar = ({ bottomBar: bottomBar, actions: actions, wrapAtMd: wrapAtMd = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: (0, $2fd65ab7d0fa0d2a$export$90c4434a1e138106),
        xcss: [
            !(0, $dCm1o.isVisualRefreshEnabled)() && $a509d50a7a06aca2$var$wrapperStylesOld2,
            (0, $dCm1o.isVisualRefreshEnabled)() && $a509d50a7a06aca2$var$wrapperStyles,
            wrapAtMd ? $a509d50a7a06aca2$var$wrapAtMdStyle : $a509d50a7a06aca2$var$noWrapStyle
        ]
    }, bottomBar, actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: (0, $2fd65ab7d0fa0d2a$export$1742330ac6a668f0),
        xcss: [
            $a509d50a7a06aca2$var$actionsBoxStyles,
            wrapAtMd && $a509d50a7a06aca2$var$actionsBoxAtMdStyles
        ]
    }, actions));
const $a509d50a7a06aca2$export$7e5801dc91bf1819 = (props)=>(0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a509d50a7a06aca2$var$SporkPageTopBar, {
        bottomBar: props.bottomBar,
        actions: props.actions,
        wrapAtMd: props.wrapAtMd
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), props);
const $a509d50a7a06aca2$var$noWrapStyle = (0, $8CUq3.xcss)({
    flexWrap: 'nowrap'
});
const $a509d50a7a06aca2$var$wrapAtMdStyle = (0, $8CUq3.xcss)({
    flexWrap: 'wrap-reverse',
    [(0, $h9kUS.media).above.md]: {
        flexWrap: 'nowrap'
    }
});
const $a509d50a7a06aca2$var$wrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    paddingTop: 'space.250',
    paddingBottom: 'space.200',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $h9kUS.media).above.md]: {
        gap: 'space.300'
    }
});
const $a509d50a7a06aca2$var$wrapperStylesOld2 = (0, $8CUq3.xcss)({
    display: 'flex',
    paddingTop: 'space.150',
    paddingBottom: 'space.150',
    justifyContent: 'space-between',
    gap: 'space.100',
    [(0, $h9kUS.media).above.md]: {
        gap: 'space.300'
    }
});
const $a509d50a7a06aca2$var$actionsBoxAtMdStyles = (0, $8CUq3.xcss)({
    flex: '1 1 auto',
    [(0, $h9kUS.media).above.md]: {
        flex: '0 1 auto'
    }
});
const $a509d50a7a06aca2$var$actionsBoxStyles = (0, $8CUq3.xcss)({
    marginLeft: 'auto',
    display: 'flex',
    justifyContent: 'flex-end',
    flex: '0 0 auto'
});

});
parcelRegister("cS37j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a15efb09f101ecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $57MwZ = parcelRequire("57MwZ");
const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57MwZ.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
    });
var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a15efb09f101ecb$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("57MwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9694e728fd1ea060$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eeGIy = parcelRequire("eeGIy");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.OuterWrapper), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.TitleWrapper), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.TitleContainer), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.StyledTitleWrapper), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.ActionsWrapper), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.BottomBarWrapper), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;

});
parcelRegister("eeGIy", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $0c196d37a4e8266c$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $0c196d37a4e8266c$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $0c196d37a4e8266c$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $0c196d37a4e8266c$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $0c196d37a4e8266c$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $0c196d37a4e8266c$export$6330225854c30dc);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $0c196d37a4e8266c$var$styles = {
    bottomBar: "_1pfhpxbi"
};
const $0c196d37a4e8266c$var$truncateStyles = null;
const $0c196d37a4e8266c$var$outerStyles = null;
const $0c196d37a4e8266c$var$titleStyles = null;
const $0c196d37a4e8266c$var$titleWrapperStyles = null;
const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = null;
const $0c196d37a4e8266c$var$titleContainerStyles = null;
const $0c196d37a4e8266c$var$actionStyles = null;
const $0c196d37a4e8266c$var$titleContainerTruncateStyles = null;
const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _12ji1r31 _1qu2glyw _12y31o36 _syaz1fxt _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m _1n261g80",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $0c196d37a4e8266c$var$styles.bottomBar,
        children: children
    });
};

});



const $2fd65ab7d0fa0d2a$export$90c4434a1e138106 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar';
const $2fd65ab7d0fa0d2a$export$1742330ac6a668f0 = 'horizontal-nav-page-topbar.ui.horizontal-nav-page-topbar.actions';



parcelRegister("cWY4u", function(module, exports) {

$parcel$export(module.exports, "SidebarCloserController", () => $7429dc5179f79a1f$export$700866716e53c09d);

var $ih9zY = parcelRequire("ih9zY");

var $f98ZZ = parcelRequire("f98ZZ");

var $1XJ20 = parcelRequire("1XJ20");
const $7429dc5179f79a1f$export$700866716e53c09d = ()=>{
    const [{ id: id }, { closeSidebar: closeSidebar }] = (0, $f98ZZ.useSidebar)();
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const prevView = (0, $1XJ20.usePrevious)(view);
    if (id !== null && view === 'detail' && prevView !== 'detail') closeSidebar();
    return null;
};

});

parcelRegister("887Eo", function(module, exports) {

$parcel$export(module.exports, "SidebarExperienceRegistryWithErrorBoundary", () => $d16820970d8c3915$export$2ca0ed61c620e2d7);

var $5rE7D = parcelRequire("5rE7D");

var $9FkTm = parcelRequire("9FkTm");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $f98ZZ = parcelRequire("f98ZZ");

var $6gWfU = parcelRequire("6gWfU");


var $7CMCs = parcelRequire("7CMCs");

var $6s1PB = parcelRequire("6s1PB");

var $gwtSG = parcelRequire("gwtSG");

var $gcgVs = parcelRequire("gcgVs");

var $4WYaK = parcelRequire("4WYaK");

var $gQTlb = parcelRequire("gQTlb");
const $d16820970d8c3915$export$50cee155b5f4b008 = ({ project: project })=>{
    const [{ id: id, content: content }, { closeSidebar: closeSidebar }] = (0, $f98ZZ.useSidebar)();
    const jql = (0, $gwtSG.useResolvedJql)();
    const projectData = (0, $8Uumt.useFragment)((0, $9FkTm.default), project);
    if (content) return content;
    if (id === (0, $6gWfU.SIDEBAR_EXPERIENCE_NAME) && (0, $6s1PB.expVal)('helios_list_view_statistics_nin_migration', 'isEnabled', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gcgVs.IssueFieldStatisticsSidebarExperience), {
        jql: jql,
        onClose: closeSidebar
    });
    if (id === (0, $dedf6e2c0f10d2d6$export$716d68d214fad041)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gQTlb.MaybeConditionalFormattingSidebarExperience), {
        project: projectData ?? null,
        onClose: closeSidebar
    });
    return null;
};
const $d16820970d8c3915$export$2ca0ed61c620e2d7 = ({ project: project })=>{
    const { closeSidebar: closeSidebar } = (0, $f98ZZ.useSidebarActions)();
    const fallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4WYaK.ErrorState), {
            onClose: closeSidebar
        }), [
        closeSidebar
    ]);
    const projectData = (0, $8Uumt.useFragment)((0, $5rE7D.default), project);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "sidebarExperienceRegistry",
        packageName: "jiraIssueNavigator",
        teamName: "empanada",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d16820970d8c3915$export$50cee155b5f4b008, {
        project: projectData ?? null
    }));
};

});
parcelRegister("5rE7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $16adf196c2f881c6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<aba6c9bc59e02b41122553682539a4e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $16adf196c2f881c6$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistryWithErrorBoundary_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project"
        }
    ],
    "type": "JiraProject"
};
$16adf196c2f881c6$var$node.hash = "af3a08a5830cf80396852c8c7e211c1e";
var $16adf196c2f881c6$export$2e2bcd8739ae039 = $16adf196c2f881c6$var$node;

});

parcelRegister("9FkTm", function(module, exports) {

$parcel$export(module.exports, "default", () => $af095ffc42eba209$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<19bf34b3cf975d580f035bf998079e51>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $af095ffc42eba209$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "experienceRegistry_issueNavigator_SidebarExperienceRegistry_project",
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "main_issueNavigator_ConditionalFormattingSidebarExperience"
        }
    ],
    "type": "JiraProject"
};
$af095ffc42eba209$var$node.hash = "982a93fe0249ea3bc1cc43a3ce04f768";
var $af095ffc42eba209$export$2e2bcd8739ae039 = $af095ffc42eba209$var$node;

});

const $dedf6e2c0f10d2d6$export$716d68d214fad041 = 'conditional-formatting';

parcelRegister("gcgVs", function(module, exports) {

$parcel$export(module.exports, "IssueFieldStatisticsSidebarExperience", () => $2bb3e7cbb51113a5$export$63b30538475bf529);

var $5uXOq = parcelRequire("5uXOq");

var $SpDot = parcelRequire("SpDot");

var $7XluA = parcelRequire("7XluA");

var $4WYaK = parcelRequire("4WYaK");
const $2bb3e7cbb51113a5$var$HELIOS_TEAM_NAME = 'helios-reports';
const $2bb3e7cbb51113a5$export$63b30538475bf529 = ({ jql: jql, onClose: onClose })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $SpDot.useIssueFieldStatisticsEntryPoint)();
    const issueFieldStatisticsRuntimeProps = (0, $5uXOq.useMemo)(()=>({
            jql: jql,
            onClose: onClose
        }), [
        jql,
        onClose
    ]);
    const errorFallback = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4WYaK.ErrorState), {
            onClose: onClose
        }), [
        onClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "issueFieldStatisticsSidebar",
        packageName: "jiraIssueNavigatorActionIssueFieldStatistics",
        errorFallback: errorFallback,
        teamName: $2bb3e7cbb51113a5$var$HELIOS_TEAM_NAME,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: issueFieldStatisticsRuntimeProps
    });
};

});
parcelRegister("4WYaK", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $fbefa06fe4c91318$export$c1ed4f415b9e7023);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $42CjB = parcelRequire("42CjB");

var $84THj = parcelRequire("84THj");

var $koVbs = parcelRequire("koVbs");

var $a2fxE = parcelRequire("a2fxE");

var $hi7kV = parcelRequire("hi7kV");
const $fbefa06fe4c91318$export$c1ed4f415b9e7023 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        alignItems: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        alignItems: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($84THj))),
        label: formatMessage((0, $hi7kV.default).close),
        isTooltipDisabled: false,
        onClick: ()=>{
            onClose();
        }
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        alignItems: "center",
        xcss: $fbefa06fe4c91318$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a2fxE.default), {
        alt: formatMessage((0, $hi7kV.default).warning)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        weight: "bold"
    }, formatMessage((0, $hi7kV.default).errorTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        align: "center"
    }, formatMessage((0, $hi7kV.default).errorBody))));
};
const $fbefa06fe4c91318$var$contentStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.800',
    gap: 'space.100'
});

});
parcelRegister("a2fxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b458312a82455ed$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $dCLgq = parcelRequire("dCLgq");

var $lncPz = parcelRequire("lncPz");

var $3dzYL = parcelRequire("3dzYL");
const $5b458312a82455ed$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($lncPz)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($3dzYL))
});
var $5b458312a82455ed$export$2e2bcd8739ae039 = $5b458312a82455ed$var$Illustration;
const $5b458312a82455ed$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    212
];

});
parcelRegister("lncPz", function(module, exports) {
module.exports = new URL("error-triangle-basic.6c1bbfdc.svg", import.meta.url).toString();

});

parcelRegister("3dzYL", function(module, exports) {
module.exports = new URL("error-triangle-basic-darkmode.aa5ef22c.svg", import.meta.url).toString();

});


parcelRegister("hi7kV", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d4cac6e48b6b74$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $63d4cac6e48b6b74$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    warning: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.warning-icon-label",
        "defaultMessage": "Warning"
    },
    close: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.close",
        "defaultMessage": "Close"
    },
    errorTitle: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.error-title",
        "defaultMessage": "Something went wrong"
    },
    errorBody: {
        "id": "issue-navigator.sidebar.experience-registry.error-state.error-body",
        "defaultMessage": "Try refreshing the page, or check your connection."
    }
});

});



parcelRegister("gQTlb", function(module, exports) {

$parcel$export(module.exports, "MaybeConditionalFormattingSidebarExperience", () => $e6c143a3289fba38$export$8e9dd628d56e5950);

var $cw0ym = parcelRequire("cw0ym");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $7XluA = parcelRequire("7XluA");

var $cRyQg = parcelRequire("cRyQg");

var $7XYc4 = parcelRequire("7XYc4");

var $4WYaK = parcelRequire("4WYaK");
function $e6c143a3289fba38$var$ConditionalFormattingSidebarExperience({ onClose: onClose, project: project }) {
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $cRyQg.useConditionalFormattingEntryPoint)();
    const projectData = (0, $8Uumt.useFragment)((0, $cw0ym.default), project);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "conditionalFormattingSidebar",
        packageName: "jiraIssueNavigatorActionConditionalFormatting",
        errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4WYaK.ErrorState), {
                onClose: onClose
            }),
        teamName: "Keystone",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: {
            message: 'Hello world!',
            projectId: projectData?.id,
            onClose: onClose
        }
    });
}
const $e6c143a3289fba38$export$8e9dd628d56e5950 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('conditional-formatting-new-list-targeting-gate'), $e6c143a3289fba38$var$ConditionalFormattingSidebarExperience, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null));

});
parcelRegister("cw0ym", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c630cd9ea4f8bc0$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b7ccb3ba30690fdf8e131aead8148b1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $7c630cd9ea4f8bc0$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "main_issueNavigator_ConditionalFormattingSidebarExperience",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "id"
        }
    ],
    "type": "JiraProject"
};
$7c630cd9ea4f8bc0$var$node.hash = "3ea0c99d55d188dfcf550df88b4fa039";
var $7c630cd9ea4f8bc0$export$2e2bcd8739ae039 = $7c630cd9ea4f8bc0$var$node;

});




parcelRegister("9BgIv", function(module, exports) {

$parcel$export(module.exports, "SelectedIssue", () => $29e7a5baa3c338c1$export$39b2b4a30505b395);

var $1qDhJ = parcelRequire("1qDhJ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $g5X3G = parcelRequire("g5X3G");

var $4R6GH = parcelRequire("4R6GH");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $hnJJ3 = parcelRequire("hnJJ3");

var $ih9zY = parcelRequire("ih9zY");

var $38r5c = parcelRequire("38r5c");

var $gM6H8 = parcelRequire("gM6H8");
const $29e7a5baa3c338c1$export$39b2b4a30505b395 = ({ children: children, issues: issues, selectedIssueKey: selectedIssueKey, onChange: onChange })=>{
    const [{ view: view }] = (0, $ih9zY.useSelectedViewState)();
    const searchKey = (0, $38r5c.useSearchKey)();
    const issueData = (0, $8Uumt.useFragment)((0, $1qDhJ.default), issues);
    let issuesFlatList;
    if ((0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes')) // eslint-disable-next-line react-hooks/rules-of-hooks
    issuesFlatList = (0, $gM6H8.useFlatListIssues)();
    const issueKeys = (0, $5uXOq.useMemo)(()=>view !== 'detail' && issuesFlatList && (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? issuesFlatList : issueData?.edges?.map((edge)=>(0, $g5X3G.toIssueKey)(edge?.node?.key ?? '')) ?? [], [
        issuesFlatList,
        issueData?.edges,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hnJJ3.SelectedIssueContainer), {
        view: (0, $eJ0Zs.convertToView)(view),
        issueKeys: issueKeys,
        searchKey: searchKey,
        selectedIssueKey: selectedIssueKey,
        onChange: onChange
    }, children);
};

});
parcelRegister("1qDhJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $41bc6b895343393b$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<861c6a2b5276ec2a8b6ba119835e232f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $41bc6b895343393b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedIssue_issueNavigator",
    "selections": [
        {
            "concreteType": "JiraIssueEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraIssue",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "JiraIssueConnection"
};
$41bc6b895343393b$var$node.hash = "966aa39a272d43746556adcb1b54c0d8";
var $41bc6b895343393b$export$2e2bcd8739ae039 = $41bc6b895343393b$var$node;

});


parcelRegister("k4pU6", function(module, exports) {

$parcel$export(module.exports, "SelectedViewContainer", () => $f88dfd427b272bd1$export$6e497a97feb37da2);

var $6qOEo = parcelRequire("6qOEo");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $ih9zY = parcelRequire("ih9zY");

var $38r5c = parcelRequire("38r5c");
const $f88dfd427b272bd1$export$6e497a97feb37da2 = ({ children: children, jiraView: jiraView, onSetView: onSetView })=>{
    const { onChangeView: onIssueSearchForView } = (0, $38r5c.useIssueSearchActions)();
    const jiraViewData = (0, $8Uumt.useFragment)((0, $6qOEo.default), jiraView);
    const viewId = (0, $eJ0Zs.parseIssueNavigatorViewIdOrDefault)(jiraViewData?.viewId, (0, $6UAdF.DEFAULT_VIEW_ID));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ih9zY.Container), {
        view: viewId,
        onSetView: onSetView,
        onIssueSearchForView: onIssueSearchForView
    }, children);
};

});
parcelRegister("6qOEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $118bd4eda5b42768$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<04fbb2bde6ed8bae3b30f5a477ad3660>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $118bd4eda5b42768$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "selectedView_issueNavigator_SelectedViewContainer",
    "selections": [
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "viewId"
                }
            ],
            "type": "JiraIssueSearchViewMetadata",
            "abstractKey": "__isJiraIssueSearchViewMetadata"
        }
    ],
    "type": "JiraView",
    "abstractKey": "__isJiraView"
};
$118bd4eda5b42768$var$node.hash = "7af7655c76c900649cc8f8ecf6ff6734";
var $118bd4eda5b42768$export$2e2bcd8739ae039 = $118bd4eda5b42768$var$node;

});



parcelRegister("cf7yQ", function(module, exports) {

$parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", () => $8aa55ef5824c4e4d$export$46976e0f90edfcfe);
$parcel$export(module.exports, "JsdGettingStartedPanel", () => $8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
$parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", () => $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
$parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", () => $8aa55ef5824c4e4d$export$c7732c55900cf0b9);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("5DTXc")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("1Gae1")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("8Jf7e")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("41w1E")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
    moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
});
const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-should-render",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
$8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-panel",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
$8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-open-button",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jsm-getting-started-panel-async-reopen-spotlight",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
$8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';

});
parcelRegister("5DTXc", function(module, exports) {

let $41bbff89fe37fc18$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $41bbff89fe37fc18$var$load("kVX56"),
    $41bbff89fe37fc18$var$load("it614")
]).then(()=>parcelRequire('hZyYK'));

});

parcelRegister("1Gae1", function(module, exports) {

let $1391a53316aa0a08$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1391a53316aa0a08$var$load("kVX56"),
    $1391a53316aa0a08$var$load("76n7a"),
    $1391a53316aa0a08$var$load("l253H"),
    $1391a53316aa0a08$var$load("bET2R")
]).then(()=>parcelRequire('2NciN'));

});

parcelRegister("8Jf7e", function(module, exports) {

let $65ae405bb0a885ec$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $65ae405bb0a885ec$var$load("kVX56"),
    $65ae405bb0a885ec$var$load("76n7a"),
    $65ae405bb0a885ec$var$load("l253H"),
    $65ae405bb0a885ec$var$load("7yzag")
]).then(()=>parcelRequire('4F6ZA'));

});

parcelRegister("41w1E", function(module, exports) {

let $2ee0190d7637d443$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $2ee0190d7637d443$var$load("kVX56"),
    $2ee0190d7637d443$var$load("76n7a"),
    $2ee0190d7637d443$var$load("l253H"),
    $2ee0190d7637d443$var$load("2vlLl")
]).then(()=>parcelRequire('6Wput'));

});


parcelRegister("jev6s", function(module, exports) {

$parcel$export(module.exports, "ProjectIssueNavigatorHeaderSkeleton", () => $05f946505413a410$export$28359b78c47abc93);
/* project-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $aOAC4 = parcelRequire("aOAC4");
const $05f946505413a410$var$customCssStyles = null;
const $05f946505413a410$var$containerStyles = {
    height: '104px'
};
const $05f946505413a410$export$28359b78c47abc93 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($aOAC4))),
        containerStyles: $05f946505413a410$var$containerStyles,
        className: (0, $bwpsq.default)([
            "_1wgmglyw"
        ])
    });

});
parcelRegister("aOAC4", function(module, exports) {
module.exports = new URL("project-issue-navigator-header-skeleton.tpl.7e712bab.svg", import.meta.url).toString();

});


parcelRegister("kZqgk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f96a1f575a76ba1c$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<188813c08a6b767043dfdfcd6e9e6e61>>
 * @relayHash 4269726e8ba7ceef0720803c06ec9dc3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4da1e676fb4717f68009f63522b10789960d60fc3543044cb90995abbb254a51
const $f96a1f575a76ba1c$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "documentTitleQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "documentTitleQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4da1e676fb4717f68009f63522b10789960d60fc3543044cb90995abbb254a51",
            "metadata": {},
            "name": "documentTitleQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f96a1f575a76ba1c$var$node.hash = "37cf341ecbc6674a0e4301d1a119d06d";
var $f96a1f575a76ba1c$export$2e2bcd8739ae039 = $f96a1f575a76ba1c$var$node;

});

parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("k0YyU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6639894c6c75260$export$2e2bcd8739ae039);

var $kDP4t = parcelRequire("kDP4t");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3bDjY = parcelRequire("3bDjY");

var $jS4lj = parcelRequire("jS4lj");

var $gEFwt = parcelRequire("gEFwt");

var $cS37j = parcelRequire("cS37j");

var $7CMCs = parcelRequire("7CMCs");

var $gcl1l = parcelRequire("gcl1l");

var $6s1PB = parcelRequire("6s1PB");

var $id7K0 = parcelRequire("id7K0");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $9Nvh7 = parcelRequire("9Nvh7");

var $jCD74 = parcelRequire("jCD74");

var $cgTfp = parcelRequire("cgTfp");

var $2jaAN = parcelRequire("2jaAN");

var $lfTZh = parcelRequire("lfTZh");

var $kDP4t = parcelRequire("kDP4t");

var $koeKL = parcelRequire("koeKL");

var $cZpsT = parcelRequire("cZpsT");

var $4R6GH = parcelRequire("4R6GH");

var $dxZ04 = parcelRequire("dxZ04");

var $byGGJ = parcelRequire("byGGJ");
const $c6639894c6c75260$export$49640514ca453805 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c6639894c6c75260$var$FilterTitleTooltipTagStyled, {
        ref: ref,
        ...props
    }));
const $c6639894c6c75260$var$ProjectBreadcrumbWithData = ({ queryReference: queryReference, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.usePreloadedQuery)((0, $kDP4t.default), queryReference);
    const projectName = data?.jira?.jiraProjectByKey?.name ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $3HwlS.getWillShowNav4)() ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dxZ04.default).windowTitleMigrationIssueTermRefresh : (0, $dxZ04.default).windowTitleMigration, {
            projectName: projectName
        })
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: "",
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null)));
};
const $c6639894c6c75260$var$BreadcrumbFallback = ({ projectKey: projectKey, projectName: projectName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: "",
        projectKey: projectKey,
        projectName: projectName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jS4lj.default), null));
const $c6639894c6c75260$var$Header = ({ projectKey: projectKey, jql: jql, filterId: filterId, filterDetails: filterDetails, searchResultPageData: searchResultPageData, isQuickFiltersDisabled: isQuickFiltersDisabled = false, HierarchyToggle: HierarchyToggle, GroupByDropdown: GroupByDropdown, HideDoneToggle: HideDoneToggle, SaveResetViewSettingsButton: SaveResetViewSettingsButton, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isHideDoneSupportEnabled: isHideDoneSupportEnabled, isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled, onChangeFilter: onChangeFilter })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const [queryReference, loadQuery] = (0, $8Uumt.useQueryLoader)((0, $kDP4t.default));
    const cloudId = (0, $koeKL.useCloudId)();
    (0, $5uXOq.useEffect)(()=>{
        loadQuery({
            projectKey: projectKey,
            cloudId: cloudId
        });
    }, [
        loadQuery,
        projectKey,
        cloudId
    ]);
    const heading = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $dxZ04.default).headingIssueTermRefresh : (0, $dxZ04.default).heading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
        breadcrumbs: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "page-header",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c6639894c6c75260$var$BreadcrumbFallback, {
                projectKey: projectKey,
                projectName: ""
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            id: "ui.project-name-query.boundary",
            packageName: "projectIssueNavigator",
            teamName: "empanada",
            sendToPrivacyUnsafeSplunk: true,
            attributes: (0, $gcl1l.isLoaderErrorAttributes),
            fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c6639894c6c75260$var$BreadcrumbFallback, {
                    projectKey: projectKey,
                    projectName: projectKey
                })
        }, queryReference !== null && queryReference !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c6639894c6c75260$var$ProjectBreadcrumbWithData, {
            queryReference: queryReference,
            projectKey: projectKey
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c6639894c6c75260$var$BreadcrumbFallback, {
            projectKey: projectKey,
            projectName: ""
        }))),
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $byGGJ.default), {
            jql: jql,
            filterId: filterId,
            isModifiedFilter: filterDetails?.jql !== jql,
            searchResultPageData: searchResultPageData,
            isQuickFiltersDisabled: isQuickFiltersDisabled,
            HierarchyToggle: HierarchyToggle,
            GroupByDropdown: GroupByDropdown,
            HideDoneToggle: HideDoneToggle,
            SaveResetViewSettingsButton: SaveResetViewSettingsButton,
            isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
            isHideDoneSupportEnabled: isHideDoneSupportEnabled,
            isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled,
            onChangeFilter: onChangeFilter
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c6639894c6c75260$var$HeaderContentWrapper, null, (0, $9Nvh7.isFilterId)(filterId) && filterDetails ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: filterDetails.name,
        tag: $c6639894c6c75260$export$49640514ca453805,
        position: "mouse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c6639894c6c75260$var$FilterTitleTooltipContent, null, filterDetails.name)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2jaAN.FavoriteButtonHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2jaAN.FavoriteButton), {
        filterId: filterDetails.filterId,
        isFavoriteInitial: filterDetails.isFavourite
    })), (0, $9Nvh7.isCustomFilter)(filterDetails.filterId) && filterId !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgTfp.DetailsButtonHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jCD74.DetailsPopup), {
        filterId: filterId
    }))) : heading)));
};
const $c6639894c6c75260$var$MemoHeader = /*#__PURE__*/ (0, $5uXOq.memo)($c6639894c6c75260$var$Header);
var $c6639894c6c75260$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $c6639894c6c75260$var$MemoHeader;
const $c6639894c6c75260$var$FilterTitleTooltipTagStyled = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c6639894c6c75260$var$FilterTitleTooltipContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $c6639894c6c75260$var$HeaderContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _1e0c116y _4cvr1y6m _4t3izwfg _p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kDP4t", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2c7f90f38cc4432$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<67e071a33cf45c408e850b759f06d544>>
 * @relayHash 2dcb74ffdda96ee8a118627d99d348d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 95320ce8ef75d958fcc0085329ca22dbd72ca5869d41448c798a39e83b9c8b19
const $f2c7f90f38cc4432$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectKey"
    }, v2 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "projectKey"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v4 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "mainProjectNameQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "mainProjectNameQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "jiraProjectByKey",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "95320ce8ef75d958fcc0085329ca22dbd72ca5869d41448c798a39e83b9c8b19",
            "metadata": {},
            "name": "mainProjectNameQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$f2c7f90f38cc4432$var$node.hash = "fca14514ec7cc9e866219e1ef4f3f1e9";
var $f2c7f90f38cc4432$export$2e2bcd8739ae039 = $f2c7f90f38cc4432$var$node;

});

parcelRegister("jCD74", function(module, exports) {

$parcel$export(module.exports, "DetailsPopup", () => $ad1b1ac535cd8166$export$b61797ace80c3d8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $bWn3s = parcelRequire("bWn3s");

var $fVnbM = parcelRequire("fVnbM");

var $eZJjh = parcelRequire("eZJjh");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");

var $6KXPO = parcelRequire("6KXPO");

var $4R6GH = parcelRequire("4R6GH");

var $lu5k0 = parcelRequire("lu5k0");

var $epiY4 = parcelRequire("epiY4");

var $cZpsT = parcelRequire("cZpsT");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $cSD7y = parcelRequire("cSD7y");

var $jcw0u = parcelRequire("jcw0u");


var $52X9s = parcelRequire("52X9s");

var $9DNHu = parcelRequire("9DNHu");

var $i4HKU = parcelRequire("i4HKU");

var $cfTve = parcelRequire("cfTve");

const $ad1b1ac535cd8166$var$DetailsPopupOld = ({ filterId: filterId, defaultOpen: defaultOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const triggerRef = (0, $5uXOq.useRef)(null);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultOpen);
    const onClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const titleId = 'issue-navigator-custom-filters.ui.details-popup.popup.title';
    const onTriggerClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        setIsOpen(!isOpen);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'filterDetailsButton');
    }, [
        isOpen,
        setIsOpen
    ]);
    const [isEditFilterModalOpen, setIsEditFilterModalOpen] = (0, $5uXOq.useState)(false);
    const onOpenEditFilterModal = (0, $5uXOq.useCallback)(()=>{
        if (!(0, $4R6GH.fg)('nin-save-filter-dialog-entry-point')) setIsEditFilterModalOpen(true);
        else setReturnFocusTo(triggerRef);
        onClose();
    }, [
        onClose,
        setReturnFocusTo
    ]);
    const onCloseEditFilterModal = (0, $5uXOq.useCallback)(()=>{
        setIsEditFilterModalOpen(false);
        setReturnFocusTo(triggerRef);
    }, [
        setReturnFocusTo
    ]);
    const Content = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9DNHu.PopupContent), {
            ...props,
            ...(0, $4R6GH.fg)('jfp-a11y-team_return-focus-to-filter-details') && {
                triggerRef: triggerRef
            },
            onOpenEditFilterModal: onOpenEditFilterModal,
            onOpenNewSubscriptionModal: onClose,
            filterId: filterId,
            titleId: titleId
        }), [
        filterId,
        onClose,
        onOpenEditFilterModal
    ]);
    const Trigger = (0, $5uXOq.useCallback)((props)=>{
        const ref = (0, $bWn3s.mergeRefs)([
            props.ref,
            triggerRef
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...props,
            appearance: "link",
            onClick: onTriggerClick,
            isSelected: isOpen,
            onMouseOver: (0, $9DNHu.preloadPopupContentComponent),
            testId: "issue-navigator-custom-filters.ui.details-popup.button",
            ref: ref
        }, formatMessage((0, $i4HKU.default).filterDetails));
    }, [
        isOpen,
        onTriggerClick,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, $4R6GH.fg)('nin-save-filter-dialog-entry-point') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6KXPO.AsyncUpdateFilterDialog), {
        filterId: filterId,
        onClose: onCloseEditFilterModal,
        isOpen: isEditFilterModalOpen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: onClose,
        shouldRenderToParent: (0, $4R6GH.fg)('jfp_a11y_team_fix_filter_details_reading_order'),
        placement: "bottom-start",
        messageId: "issue-navigator-custom-filters.ui.details-popup.popup",
        messageType: "transactional",
        content: Content,
        trigger: Trigger,
        testId: "issue-navigator-custom-filters.ui.details-popup.popup",
        role: "dialog",
        titleId: titleId
    }));
};
const $ad1b1ac535cd8166$var$Trigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ triggerRef: triggerRef, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const mergedRef = (0, $bWn3s.mergeRefs)([
        ref,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        appearance: "link",
        isSelected: props['aria-expanded'],
        testId: "issue-navigator-custom-filters.ui.details-popup.button",
        ref: mergedRef
    }, formatMessage((0, $i4HKU.default).filterDetails));
});
const $ad1b1ac535cd8166$var$DetailsPopupNew = ({ filterId: filterId })=>{
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const activationId = (0, $fY39E.useActivationId)();
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            filterId: filterId,
            activationId: activationId,
            cloudId: cloudId,
            isAnonymous: isAnonymous
        }), [
        filterId,
        activationId,
        cloudId,
        isAnonymous
    ]);
    const triggerRef = (0, $5uXOq.useRef)(null);
    const titleId = 'issue-navigator-custom-filters.ui.details-popup.popup.title';
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            titleId: titleId,
            triggerRef: triggerRef
        }), [
        triggerRef,
        titleId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $epiY4.PopupTrigger), {
        entryPoint: (0, $52X9s.popupContentEntrypoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        trigger: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad1b1ac535cd8166$var$Trigger, {
                ...props,
                triggerRef: triggerRef
            }),
        errorFallback: (0, $cfTve.ErrorState),
        onError: (props)=>{
            (0, $jcw0u.default)({
                ...props,
                meta: {
                    id: 'DetailsPopupEntryPoint',
                    packageName: (0, $c18cf10dfb008b12$export$ad257a98f20ee631),
                    teamName: 'empanada'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        },
        shouldRenderToParent: true,
        placement: "bottom-start",
        testId: "issue-navigator-custom-filters.ui.details-popup.popup",
        role: "dialog",
        titleId: titleId,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad1b1ac535cd8166$var$LoadingFallback, null)
    });
};
const $ad1b1ac535cd8166$export$b61797ace80c3d8 = (0, $cSD7y.componentWithFG)('nin_filter_details_popup_entrypoint_migration', $ad1b1ac535cd8166$var$DetailsPopupNew, $ad1b1ac535cd8166$var$DetailsPopupOld);
const $ad1b1ac535cd8166$var$LoadingFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ad1b1ac535cd8166$var$LoadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $ad1b1ac535cd8166$var$LoadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _y3gn1h6o _1bsb1vif _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _c71lqdd9",
            __cmplp.className
        ])
    });
});

});
const $c18cf10dfb008b12$export$ad257a98f20ee631 = 'jiraIssueNavigatorCustomFilters';

parcelRegister("52X9s", function(module, exports) {

$parcel$export(module.exports, "popupContentEntrypoint", () => $456c8c67a2797a76$export$530cc5cbdf6236ea);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

var $dXq4S = parcelRequire("dXq4S");

var $bGxOb = parcelRequire("bGxOb");

const $456c8c67a2797a76$export$530cc5cbdf6236ea = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("9xeYe")), {
        moduleId: "0bfd023c",
        priority: "interaction"
    }),
    getPreloadProps: ({ filterId: filterId, activationId: activationId, cloudId: cloudId, isAnonymous: isAnonymous })=>{
        const filterAri = (0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'filter',
            resourceId: filterId,
            activationId: activationId
        });
        return {
            queries: {
                filterData: {
                    parameters: $bGxOb.default,
                    variables: {
                        filterAri: filterAri,
                        isAnonymous: isAnonymous
                    }
                }
            },
            extraProps: {
                filterId: filterId,
                filterAri: filterAri
            }
        };
    }
});

});
parcelRegister("bGxOb", function(module, exports) {

$parcel$export(module.exports, "default", () => $208d33cacd8348e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<cabde37d42247daed0f55869eb5b6fd9>>
 * @relayHash 9f4cdfd24c4837edbec911e81f56cc4c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6bc8c23e9cd41f906771238f4fc28eed8056bad2b96a927b890039d4d973ea8d
const $208d33cacd8348e2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterAri"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "isAnonymous"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "filterAri"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "name"
    }, v3 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
            v2 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "key"
            },
            v5 /*: any*/ 
        ]
    }, v7 = [
        v2 /*: any*/ ,
        v5 /*: any*/ 
    ], v8 = {
        "concreteType": "JiraGroup",
        "kind": "LinkedField",
        "name": "group",
        "plural": false,
        "selections": v7 /*: any*/ 
    }, v9 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
            v4 /*: any*/ ,
            v2 /*: any*/ ,
            v5 /*: any*/ 
        ]
    }, v10 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v6 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityProjectGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v6 /*: any*/ ,
                        {
                            "concreteType": "JiraRole",
                            "kind": "LinkedField",
                            "name": "role",
                            "plural": false,
                            "selections": v7 /*: any*/ 
                        }
                    ],
                    "type": "JiraShareableEntityProjectRoleGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v8 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityGroupGrant"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v9 /*: any*/ 
                    ],
                    "type": "JiraShareableEntityUserGrant"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainPopupContentFilterByAriQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraQuery",
                        "kind": "LinkedField",
                        "name": "jira",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v1 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "filter",
                                    "plural": false,
                                    "selections": [
                                        v2 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "description_issueNavigatorCustomFilters"
                                                },
                                                {
                                                    "condition": "isAnonymous",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "owner_issueNavigatorCustomFilters"
                                                        },
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": "subscriptions_issueNavigatorCustomFilters"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "FragmentSpread",
                                                    "name": "permissions_issueNavigatorCustomFilters"
                                                }
                                            ],
                                            "type": "JiraCustomFilter"
                                        },
                                        v3 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "jira.filter"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "jira"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainPopupContentFilterByAriQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "filter",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v2 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "description"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditable"
                                        },
                                        {
                                            "concreteType": "JiraShareableEntityShareGrantConnection",
                                            "kind": "LinkedField",
                                            "name": "shareGrants",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraShareableEntityShareGrantEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "concreteType": "JiraShareableEntityEditGrantConnection",
                                            "kind": "LinkedField",
                                            "name": "editGrants",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraShareableEntityEditGrantEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": v10 /*: any*/ 
                                                }
                                            ]
                                        },
                                        {
                                            "condition": "isAnonymous",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "owner",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "accountId"
                                                        },
                                                        v2 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "picture"
                                                        },
                                                        v5 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "filterId"
                                                },
                                                {
                                                    "args": [
                                                        {
                                                            "kind": "Literal",
                                                            "name": "last",
                                                            "value": 5
                                                        }
                                                    ],
                                                    "concreteType": "JiraFilterEmailSubscriptionConnection",
                                                    "kind": "LinkedField",
                                                    "name": "emailSubscriptions",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraFilterEmailSubscriptionEdge",
                                                            "kind": "LinkedField",
                                                            "name": "edges",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraFilterEmailSubscription",
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v8 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "storageKey": "emailSubscriptions(last:5)"
                                                }
                                            ]
                                        }
                                    ],
                                    "type": "JiraCustomFilter"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6bc8c23e9cd41f906771238f4fc28eed8056bad2b96a927b890039d4d973ea8d",
            "metadata": {},
            "name": "mainPopupContentFilterByAriQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$208d33cacd8348e2$var$node.hash = "0d557f612ff494f70f6caa72336c5a34";
var $208d33cacd8348e2$export$2e2bcd8739ae039 = $208d33cacd8348e2$var$node;

});

parcelRegister("9xeYe", function(module, exports) {

let $6f12cef91427641b$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $6f12cef91427641b$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $6f12cef91427641b$var$load("kcs34")
        ]);
    }),
    $6f12cef91427641b$var$load("76n7a"),
    $6f12cef91427641b$var$load("l253H"),
    $6f12cef91427641b$var$load("dbZAC")
]).then(()=>parcelRequire('lxlno'));

});


parcelRegister("9DNHu", function(module, exports) {

$parcel$export(module.exports, "preloadPopupContentComponent", () => $166058a1fd3e08e7$export$c115357d632001d1);
$parcel$export(module.exports, "PopupContent", () => $166058a1fd3e08e7$export$2a2c7ba12d3231e3);
/* async.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $dnjeJ = parcelRequire("dnjeJ");

var $eyQMS = parcelRequire("eyQMS");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $166058a1fd3e08e7$export$1c4b66177193d06d = (0, $kxZPA.lazy)(()=>(parcelRequire("bZos7")), {
    moduleId: "./src/packages/issue-navigator/custom-filters/src/ui/details-popup/popup-content/index.tsx"
});
const $166058a1fd3e08e7$export$c115357d632001d1 = ()=>$166058a1fd3e08e7$export$1c4b66177193d06d.preload();
const $166058a1fd3e08e7$var$LoadingFallback = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($166058a1fd3e08e7$var$LoadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null));
const $166058a1fd3e08e7$export$2a2c7ba12d3231e3 = (props)=>{
    (0, $dnjeJ.useUFOComponentExperience)((0, $eyQMS.viewDetailsPopupExperience));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "popup-content",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($166058a1fd3e08e7$var$LoadingFallback, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($166058a1fd3e08e7$export$1c4b66177193d06d, props));
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $166058a1fd3e08e7$var$ContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _1bsb1vif _ca0qv47k _u5f3v47k _n3tdv47k _19bvv47k _c71lqdd9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $166058a1fd3e08e7$var$LoadingWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $166058a1fd3e08e7$var$ContentWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dnjeJ", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $44448c24118cb590$export$30ab340faaed55d4);

var $5uXOq = parcelRequire("5uXOq");
const $44448c24118cb590$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $5uXOq.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $44448c24118cb590$export$30ab340faaed55d4 = (experience)=>{
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $44448c24118cb590$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("eyQMS", function(module, exports) {

$parcel$export(module.exports, "viewDetailsPopupExperience", () => $0dbbce9899ca1284$export$54c37dd263cb6171);
$parcel$export(module.exports, "viewNewSubscriptionModal", () => $0dbbce9899ca1284$export$1584a1158c503c0a);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $0dbbce9899ca1284$export$54c37dd263cb6171 = new (0, $duUGa.UFOExperience)('jira-issue-navigator.custom-filters.view-details-popup', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});
const $0dbbce9899ca1284$export$1584a1158c503c0a = new (0, $duUGa.UFOExperience)('jira-issue-navigator.custom-filters.details-popup.view-new-subscription-modal', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("bZos7", function(module, exports) {

let $8ba85bf8c4983b9c$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $8ba85bf8c4983b9c$var$load("czifk")
        ]);
    }, function() {
        return Promise.all([
            $8ba85bf8c4983b9c$var$load("kcs34")
        ]);
    }),
    $8ba85bf8c4983b9c$var$load("76n7a"),
    $8ba85bf8c4983b9c$var$load("l253H"),
    $8ba85bf8c4983b9c$var$load("9Fyrx")
]).then(()=>parcelRequire('6ibCj'));

});


parcelRegister("i4HKU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a4107a8a3141584$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4a4107a8a3141584$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterDetails: {
        "id": "issue-navigator-custom-filters.details-popup.filter-details",
        "defaultMessage": "Filter details"
    }
});

});

parcelRegister("cfTve", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $74239872e5f407d0$export$c1ed4f415b9e7023);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $Y0ZJB = parcelRequire("Y0ZJB");

var $5uW5X = parcelRequire("5uW5X");
const $74239872e5f407d0$export$c1ed4f415b9e7023 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Y0ZJB.ErrorState), {
        description: formatMessage((0, $5uW5X.default).errorMessage),
        pageAction: "detailsPopup"
    });
};

});
parcelRegister("Y0ZJB", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $a04e313879f6b069$export$c1ed4f415b9e7023);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fVnbM = parcelRequire("fVnbM");

var $dD7Zc = parcelRequire("dD7Zc");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $6TIqn = parcelRequire("6TIqn");

var $4MFPU = parcelRequire("4MFPU");
const $a04e313879f6b069$var$BOX_HEIGHT = (0, $gwIPs.gridSize) * 18;
const $a04e313879f6b069$var$ERROR_ICON_BOX_WRAPPER_HEIGHT = (0, $gwIPs.gridSize) * 9;
const $a04e313879f6b069$var$ICON_SIZE = (0, $gwIPs.gridSize) * 9;
const $a04e313879f6b069$export$c1ed4f415b9e7023 = (props)=>{
    const { pageAction: pageAction, onRetry: onRetry, description: description, role: role } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClick = ()=>{
        onRetry?.();
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${pageAction}Retry clicked`);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a04e313879f6b069$var$StyledBox, {
        height: $a04e313879f6b069$var$BOX_HEIGHT,
        role: role
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a04e313879f6b069$var$StyledBox, {
        height: $a04e313879f6b069$var$ERROR_ICON_BOX_WRAPPER_HEIGHT,
        iconSize: $a04e313879f6b069$var$ICON_SIZE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        color: "var(--ds-icon, #44546F)",
        LEGACY_primaryColor: "var(--ds-icon, #44546F)",
        label: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4MFPU.StyledText), null, description !== undefined ? description : formatMessage((0, $6TIqn.default).errorMessage)), (onRetry || !(0, $4R6GH.fg)('nin_filter_details_popup_entrypoint_migration')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onClick,
        appearance: "link",
        testId: "issue-navigator-actions-common.ui.error.button"
    }, formatMessage((0, $6TIqn.default).retryMessage)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $a04e313879f6b069$var$StyledBox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $lD23V.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6TIqn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c213a9b9cc23628d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $c213a9b9cc23628d$var$messages = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-actions-common.error.error-message",
        "defaultMessage": "Couldn't retrieve data"
    },
    retryMessage: {
        "id": "issue-navigator-actions-common.error.retry-message",
        "defaultMessage": "Click to retry"
    }
});
var $c213a9b9cc23628d$export$2e2bcd8739ae039 = $c213a9b9cc23628d$var$messages;

});

parcelRegister("4MFPU", function(module, exports) {

$parcel$export(module.exports, "StyledText", () => $acc4659069112fb0$export$31ea92f3997410dd);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $l1N8i = parcelRequire("l1N8i");
const $acc4659069112fb0$export$d675f139b342d51a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconSize: iconSize, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height, "px"),
            "--_1kpj8xj": (0, $lD23V.default)(__cmplp.iconSize, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _2lx21bp4 _4t3i1474 _1bah1h6o _19pkpxbi _2hwx1ejb _otyrpxbi _18u01ejb",
            __cmplp.iconSize && "_w8l51dmb _17521dmb",
            __cmplp.className
        ])
    });
});
const $acc4659069112fb0$var$StyledTextComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
});
const $acc4659069112fb0$export$31ea92f3997410dd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($acc4659069112fb0$var$StyledTextComponent, props));

});


parcelRegister("5uW5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $05daab2e4c331df1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $05daab2e4c331df1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "issue-navigator-custom-filters.details-popup.error-state.error-message",
        "defaultMessage": "We couldn't display the filter details."
    }
});

});



parcelRegister("cgTfp", function(module, exports) {

$parcel$export(module.exports, "DetailsButtonHeaderWrapper", () => $f2f63e79032646e3$export$1eb74eb504903ed6);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $f2f63e79032646e3$export$1eb74eb504903ed6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _19pkv77o _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2jaAN", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $dc82f725480f4be1$export$8d5dab2ad1e19ea0);
$parcel$export(module.exports, "FavoriteButtonHeaderWrapper", () => $dc82f725480f4be1$export$5ca4047aa6ecffac);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hLZZY = parcelRequire("hLZZY");

var $eXQym = parcelRequire("eXQym");
const $dc82f725480f4be1$export$8d5dab2ad1e19ea0 = ({ filterId: filterId, isFavoriteInitial: isFavoriteInitial, favoriteItemName: favoriteItemName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hLZZY.default), {
        key: filterId,
        baseUrl: "",
        itemType: (0, $eXQym.FILTERS_ITEM_TYPE),
        itemId: filterId,
        isFavoriteInitial: isFavoriteInitial,
        favoriteItemName: favoriteItemName,
        isShownInList: true
    });
const $dc82f725480f4be1$export$5ca4047aa6ecffac = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _4t3izwfg _19pkze3t _2hwx1b66 _otyrze3t _18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hLZZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a968ac170a325ff4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4041n = parcelRequire("4041n");


var $fH2dG = parcelRequire("fH2dG");
class $a968ac170a325ff4$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4041n.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fH2dG.FavoriteButton), {
                ...this.props,
                favoriteChangeContext: favoriteChangeContext
            }));
    }
}

});
parcelRegister("fH2dG", function(module, exports) {

$parcel$export(module.exports, "FavoriteButton", () => $e0f2aac973023e83$export$8d5dab2ad1e19ea0);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $hcObS = parcelRequire("hcObS");

var $eXQym = parcelRequire("eXQym");

var $1WPu2 = parcelRequire("1WPu2");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $e0f2aac973023e83$var$isProduction = window.BUILD_KEY !== 'JF-TEST';
class $e0f2aac973023e83$export$8d5dab2ad1e19ea0 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isFavoriteInitial: undefined,
            favoriteItemName: undefined,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props), this.onClick = (analyticsEvent)=>{
            const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType, onClick: onClick } = this.props;
            const { changeFavorite: changeFavorite } = favoriteChangeContext;
            if (changeFavorite) changeFavorite({
                id: itemId,
                type: itemType,
                value: !this.getIsFavorite()
            }, analyticsEvent);
            if (typeof onClick === 'function') onClick();
        };
        this.state = {
            isFavorite: props.isFavoriteInitial
        };
    }
    componentDidMount() {
        const { baseUrl: baseUrl, itemId: itemId, itemType: itemType } = this.props;
        if (typeof baseUrl === 'undefined' || typeof itemId === 'undefined' || typeof itemType === 'undefined') return;
        // Adding an Error here for the next dev to implement this button.
        // This error won't show in prod, but will show when running a fragment.
        if (!$e0f2aac973023e83$var$isProduction && !(0, $eXQym.VALID_ITEM_TYPES).includes(itemType)) throw new Error(`FavoriteButton: Invalid value for prop 'type'.\n You passed: "${itemType}"\n It must be one of [${JSON.stringify((0, $eXQym.VALID_ITEM_TYPES))}]\n\n`);
        if (typeof this.props.isFavoriteInitial !== 'undefined') // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        this.props.favoriteChangeContext.items[itemType][itemId] = {
            id: itemId,
            type: itemType,
            value: this.props.isFavoriteInitial,
            pending: false
        };
        if (this.getIsFavorite() === undefined) (0, $1WPu2.getFavorite)(baseUrl, {
            id: itemId,
            type: itemType
        }).then((isFavorite)=>{
            this.setState({
                isFavorite: isFavorite
            });
        });
    }
    getIsFavorite() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.value : this.state.isFavorite;
    }
    getIsPending() {
        const { favoriteChangeContext: favoriteChangeContext, itemId: itemId, itemType: itemType } = this.props;
        let itemChanged;
        if (typeof favoriteChangeContext.items[itemType] !== 'undefined' && // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        typeof favoriteChangeContext.items[itemType][itemId] !== 'undefined') // @ts-expect-error - TS2532 - TS doesn't refine types with index access in this version.
        itemChanged = favoriteChangeContext.items[itemType][itemId];
        return itemChanged ? itemChanged.pending : false;
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "favourite-button.favorite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
            isFavorite: this.getIsFavorite(),
            favoriteItemName: this.props.favoriteItemName,
            pending: this.getIsPending(),
            hideTooltip: this.props.hideTooltip,
            tooltipPosition: this.props.tooltipPosition,
            onClick: this.onClick,
            isShownInList: this.props.isShownInList,
            isSmall: this.props.isSmall
        }));
    }
}

});
parcelRegister("hcObS", function(module, exports) {

$parcel$export(module.exports, "FavoriteButtonWrapper", () => $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $0a68425ce3fc2fa8$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dm1qi = parcelRequire("dm1qi");

var $dAf5R = parcelRequire("dAf5R");

var $5oTeF = parcelRequire("5oTeF");

var $bH1hf = parcelRequire("bH1hf");

var $fNobW = parcelRequire("fNobW");

var $3bDjY = parcelRequire("3bDjY");

var $iQv12 = parcelRequire("iQv12");

var $7XYc4 = parcelRequire("7XYc4");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $6fQ6A = parcelRequire("6fQ6A");
const $0a68425ce3fc2fa8$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper'; // eslint-disable-next-line jira/react/no-class-components
class $0a68425ce3fc2fa8$export$f8ad2acf0ec4860f extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $0a68425ce3fc2fa8$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$db65185b5889c83, {
            "data-testid": $0a68425ce3fc2fa8$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $0a68425ce3fc2fa8$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dm1qi))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($bH1hf))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6fQ6A.default).removeFromStarred)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dAf5R))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($5oTeF))),
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6fQ6A.default).addToStarred)
        }));
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6fQ6A.default).removeFromStarred) : formatMessage((0, $6fQ6A.default).addToStarred);
            const StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($dm1qi))) : (0, (/*@__PURE__*/$parcel$interopDefault($dAf5R)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label,
                size: isSmall ? 'small' : 'medium'
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $6fQ6A.default).removeFromStarred) : formatMessage((0, $6fQ6A.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6fQ6A.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6fQ6A.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a68425ce3fc2fa8$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $0a68425ce3fc2fa8$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $iQv12.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $az4zD.injectIntlV2))($0a68425ce3fc2fa8$export$f8ad2acf0ec4860f);
const $0a68425ce3fc2fa8$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0a68425ce3fc2fa8$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1ssb _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseNew, $0a68425ce3fc2fa8$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a68425ce3fc2fa8$var$FavIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0a68425ce3fc2fa8$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syaz1oju",
            __cmplp.isFavorite ? "_30l31vop" : "_30l3wdcn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0a68425ce3fc2fa8$export$db65185b5889c83 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dm1qi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b8e6f0febff8b04$var$_react = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9b8e6f0febff8b04$var$_baseNew = $9b8e6f0febff8b04$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9b8e6f0febff8b04$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b8e6f0febff8b04$var$StarStarredIcon = (props)=>/*#__PURE__*/ $9b8e6f0febff8b04$var$_react.default.createElement($9b8e6f0febff8b04$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$9b8e6f0febff8b04$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $9b8e6f0febff8b04$var$_default = module.exports.default = $9b8e6f0febff8b04$var$StarStarredIcon;

});

parcelRegister("5oTeF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eea0a48351333dc$var$_react = $3eea0a48351333dc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $3eea0a48351333dc$var$_starUnstarred = $3eea0a48351333dc$var$_interopRequireDefault((parcelRequire("dAf5R")));
function $3eea0a48351333dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3eea0a48351333dc$var$StarIcon = (props)=>/*#__PURE__*/ $3eea0a48351333dc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m12 16.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L12 5.687l-1.972 4.189-4.524.689L8.78 13.91l-.762 4.655zm0 2.283-3.016 1.662a2 2 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a2 2 0 0 1 1.129-3.377l3.47-.528 1.518-3.224a2 2 0 0 1 3.618 0l1.519 3.224 3.47.528a2 2 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a2 2 0 0 1-2.94 2.075z"/></svg>`
    }, props, {
        newIcon: $3eea0a48351333dc$var$_starUnstarred.default
    }));
$3eea0a48351333dc$var$StarIcon.displayName = 'StarIcon';
var $3eea0a48351333dc$var$_default = module.exports.default = $3eea0a48351333dc$var$StarIcon;

});

parcelRegister("bH1hf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8834b3797a7b4177$var$_react = $8834b3797a7b4177$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $8834b3797a7b4177$var$_starStarred = $8834b3797a7b4177$var$_interopRequireDefault((parcelRequire("dm1qi")));
function $8834b3797a7b4177$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8834b3797a7b4177$var$StarFilledIcon = (props)=>/*#__PURE__*/ $8834b3797a7b4177$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m12.072 17.284-3.905 2.053a1 1 0 0 1-1.451-1.054l.745-4.349-3.159-3.08a1 1 0 0 1 .554-1.705l4.366-.635 1.953-3.956a1 1 0 0 1 1.794 0l1.952 3.956 4.366.635a1 1 0 0 1 .555 1.705l-3.16 3.08.746 4.349a1 1 0 0 1-1.45 1.054z"/></svg>`
    }, props, {
        newIcon: $8834b3797a7b4177$var$_starStarred.default
    }));
$8834b3797a7b4177$var$StarFilledIcon.displayName = 'StarFilledIcon';
var $8834b3797a7b4177$var$_default = module.exports.default = $8834b3797a7b4177$var$StarFilledIcon;

});

parcelRegister("6fQ6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $10bc2ec5d9a72db1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $10bc2ec5d9a72db1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});

});


parcelRegister("1WPu2", function(module, exports) {

$parcel$export(module.exports, "getFavorite", () => $1961b1823763022d$export$fce5eda070ce88d0);

var $eusud = parcelRequire("eusud");
const $1961b1823763022d$export$959ca2ee969adb8d = (baseUrl, request)=>`${baseUrl}/rest/internal/2/favourites/${request.type}/${request.id}`;
const $1961b1823763022d$export$fce5eda070ce88d0 = async (baseUrl, request)=>(0, $eusud.performGetRequest)($1961b1823763022d$export$959ca2ee969adb8d(baseUrl, request));

});




parcelRegister("dxZ04", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ef21018a973de0a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $4ef21018a973de0a$var$messages = (0, $7VHMR.defineMessages)({
    heading: {
        "id": "project-issue-navigator.heading",
        "defaultMessage": "Issues"
    },
    windowTitleMigration: {
        "id": "project-issue-navigator.window-title-migration",
        "defaultMessage": "{projectName} - Issues"
    },
    windowTitleMigrationIssueTermRefresh: {
        "id": "project-issue-navigator.window-title-migration-issue-term-refresh",
        "defaultMessage": "{projectName} - All work"
    },
    headingIssueTermRefresh: {
        "id": "project-issue-navigator.heading-issue-term-refresh",
        "defaultMessage": "All work"
    }
});
var $4ef21018a973de0a$export$2e2bcd8739ae039 = $4ef21018a973de0a$var$messages;

});

parcelRegister("byGGJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fe5095ea57a261f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eTYOj = parcelRequire("eTYOj");

var $ebyGx = parcelRequire("ebyGx");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $2NMNM = parcelRequire("2NMNM");

var $6B7KL = parcelRequire("6B7KL");

var $gC0dr = parcelRequire("gC0dr");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $lAa9j = parcelRequire("lAa9j");

var $cY1ec = parcelRequire("cY1ec");

var $1VU5d = parcelRequire("1VU5d");


var $eo4oy = parcelRequire("eo4oy");

var $7bJv8 = parcelRequire("7bJv8");

var $78lPv = parcelRequire("78lPv");

var $9Nvh7 = parcelRequire("9Nvh7");

var $a8lIB = parcelRequire("a8lIB");

var $lml1M = parcelRequire("lml1M");

var $5xvWJ = parcelRequire("5xvWJ");

var $8CVvd = parcelRequire("8CVvd");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");

var $cZpsT = parcelRequire("cZpsT");

var $dCm1o = parcelRequire("dCm1o");

var $ePhT2 = parcelRequire("ePhT2");

var $jeYA3 = parcelRequire("jeYA3");
const $8fe5095ea57a261f$var$HierarchyToggleWrapper = ({ children: children })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.050",
        paddingInline: "space.150",
        onClick: (e)=>e.stopPropagation()
    }, children);
const $8fe5095ea57a261f$var$HideDoneToggleWrapper = ({ children: children })=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.050",
        paddingInline: "space.150",
        onClick: (e)=>e.stopPropagation()
    }, children);
const $8fe5095ea57a261f$var$AdditionalItemsWrapper = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8fe5095ea57a261f$var$menuItemStyles
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
const $8fe5095ea57a261f$var$PageActions = ({ jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter, searchResultPageData: searchResultPageData, isQuickFiltersDisabled: isQuickFiltersDisabled = false, HierarchyToggle: HierarchyToggle, GroupByDropdown: GroupByDropdown, HideDoneToggle: HideDoneToggle, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isHideDoneSupportEnabled: isHideDoneSupportEnabled, isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled, SaveResetViewSettingsButton: SaveResetViewSettingsButton, onChangeFilter: onChangeFilter })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).PAGE_ACTIONS_START);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).PAGE_ACTIONS_END);
    }, []);
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const savedFilter = (0, $9Nvh7.isFilterId)(filterId) ? filterId : undefined; // filter out non-standard PIN named filters
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireAdvanceSearchClickAnalytics = (e)=>{
        const leftClick = e.type === 'contextmenu';
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const withCmd = e.ctrlKey || e.metaKey;
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'advancedSearchButton', {
            openedIn: leftClick && !withCmd ? 'sameTab' : 'newTab'
        });
    };
    const jqlString = isModifiedFilter ? jql : undefined;
    const advancedSearchHref = (0, $4R6GH.fg)('nin_fix_stringify_in_go_to_advanced') ? `/issues/?${(0, $eTYOj.stringify)({
        jql: jqlString,
        filter: filterId
    })}` : `/issues/?${(0, $ebyGx.stringify)({
        jql: jqlString,
        filter: filterId
    })}`;
    const HierarchyToggleComponent = HierarchyToggle !== null && HierarchyToggle !== undefined && (0, $6s1PB.expVal)('jsc_m2_hierarchy', 'isHierarchyEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        key: (0, $c0dd5067255a9d64$export$72cbdf7971462ebd),
        component: $8fe5095ea57a261f$var$HierarchyToggleWrapper
    }, HierarchyToggle) : null;
    const HideDoneToggleComponent = HideDoneToggle !== null && HideDoneToggle !== undefined && (0, $4R6GH.fg)('jsc_list_hide_done_items') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "nin-hide-done-toggle-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        key: (0, $c0dd5067255a9d64$export$6e37bc383199950c),
        component: $8fe5095ea57a261f$var$HideDoneToggleWrapper
    }, HideDoneToggle)) : null;
    const viewOptions = HideDoneToggleComponent || HierarchyToggleComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, HideDoneToggleComponent, HierarchyToggleComponent) : null;
    const additionalMenuItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        key: (0, $c0dd5067255a9d64$export$a7a312131aa962e0),
        onClick: (e)=>fireAdvanceSearchClickAnalytics(e),
        href: advancedSearchHref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8fe5095ea57a261f$var$AdditionalItemsWrapper, null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jeYA3.default).allIssuesIssueTermRefresh : (0, $jeYA3.default).allIssues)));
    const customExportTrigger = (isOpen, triggerButtonProps)=>{
        const { triggerRef: triggerRef, ...props } = triggerButtonProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $78lPv.FilterIconButton), {
            customTriggerProps: {
                ...props,
                ref: triggerRef
            },
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC0dr))),
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jeYA3.default).exportIssuesButtonIconLabelIssueTermRefresh : (0, $jeYA3.default).exportIssuesButtonIconLabel),
            isSelected: isOpen
        });
    };
    const customExportDisabled = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $78lPv.FilterIconButton), {
        isDisabled: true,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gC0dr))),
        label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jeYA3.default).exportIssuesButtonIconLabelIssueTermRefresh : (0, $jeYA3.default).exportIssuesButtonIconLabel)
    });
    let enableQuickFilters = false;
    if ((0, $3HwlS.getWillShowNav4)()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const [isNaturalLanguageMode] = (0, $5xvWJ.useNaturalLanguageMode)();
        enableQuickFilters = !isNaturalLanguageMode && !isQuickFiltersDisabled;
    }
    const viewSwitcher = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8fe5095ea57a261f$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lml1M.default), {
        filterId: filterId
    }));
    const exportMenu = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8fe5095ea57a261f$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cY1ec.default), {
        jql: jql,
        filterId: savedFilter,
        isModifiedFilter: isModifiedFilter,
        showEcosystemApps: false,
        ...(0, $3HwlS.getWillShowNav4)() && {
            customTriggerButton: customExportTrigger,
            customDisabledButton: customExportDisabled
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8fe5095ea57a261f$export$48377ae1c677702b, null, !isAnonymous && (0, $8CVvd.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8fe5095ea57a261f$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7bJv8.ShareButton), {
        jql: jql,
        filterId: savedFilter,
        isModifiedFilter: isModifiedFilter
    })), (0, $3HwlS.getWillShowNav4)() && enableQuickFilters && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8fe5095ea57a261f$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eo4oy.default), {
        onChangeFilter: onChangeFilter
    })), GroupByDropdown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8fe5095ea57a261f$var$StyledPageAction, null, GroupByDropdown), !((0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons')) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePhT2.IssueNavigatorFeatureGuard), {
        featureKey: "isExportMenuEnabled",
        on: exportMenu,
        fallback: exportMenu
    }), (0, $8CVvd.getWillShowNav3)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8fe5095ea57a261f$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lAa9j.default), {
        jql: jql,
        filterId: savedFilter,
        isModifiedFilter: isModifiedFilter
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ePhT2.IssueNavigatorFeatureGuard), {
        featureKey: "isViewSwitcherEnabled",
        on: viewSwitcher,
        fallback: viewSwitcher
    }), SaveResetViewSettingsButton && (0, $6s1PB.expVal)('saved_list_view', 'isEnabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $8fe5095ea57a261f$var$styles.saveResetButtonWrapper
        ])
    }, SaveResetViewSettingsButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8fe5095ea57a261f$var$StyledPageAction, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1VU5d.default), {
        jql: jql,
        filterId: savedFilter,
        searchResultPageData: searchResultPageData,
        additionalMenuItems: (0, $3HwlS.getWillShowNav4)() && additionalMenuItems,
        viewOptions: viewOptions,
        isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled,
        isHideDoneSupportEnabled: isHideDoneSupportEnabled,
        isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled
    })));
};
var $8fe5095ea57a261f$export$2e2bcd8739ae039 = $8fe5095ea57a261f$var$PageActions;
const $8fe5095ea57a261f$var$styles = {
    saveResetButtonWrapper: "_19pkidpf _2hwx1b66 _otyridpf _18u0r5cr _1ul9idpf"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8fe5095ea57a261f$var$StyledPageAction = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1b66 _otyridpf _18u01b66 _1ul9idpf _1xoqidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $8fe5095ea57a261f$export$48377ae1c677702b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c",
            __cmplp.className
        ])
    });
});
const $8fe5095ea57a261f$var$menuItemStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});

});
parcelRegister("eTYOj", function(module, exports) {

$parcel$export(module.exports, "decode", () => $ad955f71a780c006$export$2f872c0f2117be69, (v) => $ad955f71a780c006$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "parse", () => $ad955f71a780c006$export$98e6a39c04603d36, (v) => $ad955f71a780c006$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "encode", () => $ad955f71a780c006$export$c564cdbbe6da493, (v) => $ad955f71a780c006$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "stringify", () => $ad955f71a780c006$export$fac44ee5b035f737, (v) => $ad955f71a780c006$export$fac44ee5b035f737 = v);
var $ad955f71a780c006$export$2f872c0f2117be69;
var $ad955f71a780c006$export$98e6a39c04603d36;
var $ad955f71a780c006$export$c564cdbbe6da493;
var $ad955f71a780c006$export$fac44ee5b035f737;
'use strict';

$ad955f71a780c006$export$2f872c0f2117be69 = $ad955f71a780c006$export$98e6a39c04603d36 = (parcelRequire("1aASF"));

$ad955f71a780c006$export$c564cdbbe6da493 = $ad955f71a780c006$export$fac44ee5b035f737 = (parcelRequire("eDdlV"));

});
parcelRegister("1aASF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $0da35560ba4ecd4e$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$0da35560ba4ecd4e$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($0da35560ba4ecd4e$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $0da35560ba4ecd4e$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});

parcelRegister("eDdlV", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $aa6f10c0e9e7da3c$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $aa6f10c0e9e7da3c$var$map($aa6f10c0e9e7da3c$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($aa6f10c0e9e7da3c$var$stringifyPrimitive(k)) + eq;
        if ($aa6f10c0e9e7da3c$var$isArray(obj[k])) return $aa6f10c0e9e7da3c$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($aa6f10c0e9e7da3c$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($aa6f10c0e9e7da3c$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($aa6f10c0e9e7da3c$var$stringifyPrimitive(name)) + eq + encodeURIComponent($aa6f10c0e9e7da3c$var$stringifyPrimitive(obj));
};
var $aa6f10c0e9e7da3c$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $aa6f10c0e9e7da3c$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $aa6f10c0e9e7da3c$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});


parcelRegister("gC0dr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2d5f7514cb392dc767c819058ee1ff0e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c1805ccdd7796085$var$_react = $c1805ccdd7796085$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c1805ccdd7796085$var$_upload = $c1805ccdd7796085$var$_interopRequireDefault((parcelRequire("50qBU")));

var $c1805ccdd7796085$var$_export = $c1805ccdd7796085$var$_interopRequireDefault((parcelRequire("61MPp")));
function $c1805ccdd7796085$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for UploadIcon.
 * This component is UploadIcon, with `UNSAFE_fallbackIcon` set to "ExportIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c1805ccdd7796085$var$UploadIcon = (props)=>/*#__PURE__*/ $c1805ccdd7796085$var$_react.default.createElement($c1805ccdd7796085$var$_upload.default, Object.assign({
        LEGACY_fallbackIcon: $c1805ccdd7796085$var$_export.default
    }, props));
$c1805ccdd7796085$var$UploadIcon.Name = 'UploadIconMigration';
var $c1805ccdd7796085$var$_default = module.exports.default = $c1805ccdd7796085$var$UploadIcon;

});
parcelRegister("50qBU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f74f927ffa6330940d56635efcb4a7d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3a519821f4edd432$var$_react = $3a519821f4edd432$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3a519821f4edd432$var$_baseNew = $3a519821f4edd432$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3a519821f4edd432$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Upload".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for upload in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3a519821f4edd432$var$UploadIcon = (props)=>/*#__PURE__*/ $3a519821f4edd432$var$_react.default.createElement($3a519821f4edd432$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.47 1.22a.75.75 0 0 1 1.06 0l4 4-1.06 1.06-2.72-2.72V11h-1.5V3.56L4.53 6.28 3.47 5.22zM1 13V9h1.5v4a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V9H15v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$3a519821f4edd432$var$UploadIcon.displayName = 'UploadIcon';
var $3a519821f4edd432$var$_default = module.exports.default = $3a519821f4edd432$var$UploadIcon;

});

parcelRegister("61MPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4638b6534bbbec0b$var$_react = $4638b6534bbbec0b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4638b6534bbbec0b$var$_upload = $4638b6534bbbec0b$var$_interopRequireDefault((parcelRequire("50qBU")));
function $4638b6534bbbec0b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4638b6534bbbec0b$var$ExportIcon = (props)=>/*#__PURE__*/ $4638b6534bbbec0b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
    }, props, {
        newIcon: $4638b6534bbbec0b$var$_upload.default
    }));
$4638b6534bbbec0b$var$ExportIcon.displayName = 'ExportIcon';
var $4638b6534bbbec0b$var$_default = module.exports.default = $4638b6534bbbec0b$var$ExportIcon;

});


parcelRegister("lAa9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $07f54044eeaf5600$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $fVnbM = parcelRequire("fVnbM");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hjSul = parcelRequire("hjSul");

var $ero1P = parcelRequire("ero1P");
const $07f54044eeaf5600$var$AdvancedSearchButton = ({ jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const jqlString = isModifiedFilter ? jql : undefined;
    const href = `/issues/?${(0, $ebyGx.stringify)({
        jql: jqlString,
        filter: filterId
    })}`;
    const fireClickAnalytics = (e, leftClick)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        const withCmd = e.ctrlKey || e.metaKey;
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'advancedSearchButton', {
            openedIn: leftClick && !withCmd ? 'sameTab' : 'newTab'
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "issue-navigator-action-advanced-search-button.advanced-search-button",
        onContextMenu: (e)=>fireClickAnalytics(e, false),
        onClick: (e)=>fireClickAnalytics(e, true),
        href: href,
        component: (0, $hjSul.Link)
    }, ' ', formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $ero1P.default).allIssuesIssueTermRefresh : (0, $ero1P.default).allIssues));
};
var $07f54044eeaf5600$export$2e2bcd8739ae039 = $07f54044eeaf5600$var$AdvancedSearchButton;

});
parcelRegister("ero1P", function(module, exports) {

$parcel$export(module.exports, "default", () => $c806cd863fbcbb6a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $c806cd863fbcbb6a$var$messages = (0, $7VHMR.defineMessages)({
    allIssues: {
        "id": "issue-navigator-action-advanced-search-button.all-issues",
        "defaultMessage": "Go to all issues"
    },
    allIssuesIssueTermRefresh: {
        "id": "issue-navigator-action-advanced-search-button.all-issues-issue-term-refresh",
        "defaultMessage": "Go to all work items"
    }
});
var $c806cd863fbcbb6a$export$2e2bcd8739ae039 = $c806cd863fbcbb6a$var$messages;

});


parcelRegister("cY1ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $10ae3433867a34b6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $BLPHT = parcelRequire("BLPHT");

var $4R6GH = parcelRequire("4R6GH");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $Y0ZJB = parcelRequire("Y0ZJB");

var $WbiIJ = parcelRequire("WbiIJ");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $6h1uG = parcelRequire("6h1uG");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $10ae3433867a34b6$var$ExportIssues = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("1bFRG")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/actions/export-issues/src/ui/index.tsx"
});
const $10ae3433867a34b6$var$Fallback = ({ onRetry: onRetry, customTriggerButton: customTriggerButton })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const triggerButton = ({ triggerRef: triggerRef, ...props })=>customTriggerButton ? customTriggerButton(false, {
            triggerRef: triggerRef,
            ...props
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WbiIJ.FilterButton), {
            ...props,
            text: formatMessage((0, $6h1uG.default).exportButtonText),
            label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6h1uG.default).exportIssuesButtonIconLabelIssueTerminologyRefreshM4 : (0, $6h1uG.default).exportIssuesButtonIconLabel),
            ref: triggerRef
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>triggerButton({
                triggerRef: triggerRef,
                ...props
            }),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact",
        shouldRenderToParent: (0, $4R6GH.fg)('should-render-to-parent-should-be-true-empanada')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Y0ZJB.ErrorState), {
        onRetry: onRetry,
        pageAction: "exportIssues"
    }));
};
const $10ae3433867a34b6$var$AsyncExportIssues = (props)=>{
    const { customTriggerButton: customTriggerButton, customDisabledButton: customDisabledButton } = props;
    const [resetCaughtError, setResetCaughtError] = (0, $5uXOq.useState)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorActionExportIssues",
        id: "async-export-issues",
        sendToPrivacyUnsafeSplunk: true,
        // Attempt to re-render children when retry is pressed in the fallback error state
        fallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10ae3433867a34b6$var$Fallback, {
                onRetry: ()=>setResetCaughtError(error),
                customTriggerButton: customTriggerButton
            }),
        onError: ()=>setResetCaughtError(undefined),
        resetCaughtError: resetCaughtError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-export-issues",
        fallback: customDisabledButton ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WbiIJ.FilterButton), {
            isDisabled: true,
            text: formatMessage((0, $6h1uG.default).exportButtonText),
            label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $6h1uG.default).exportIssuesButtonIconLabelIssueTerminologyRefreshM4 : (0, $6h1uG.default).exportIssuesButtonIconLabel)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10ae3433867a34b6$var$ExportIssues, props)));
};
var $10ae3433867a34b6$export$2e2bcd8739ae039 = $10ae3433867a34b6$var$AsyncExportIssues;

});
parcelRegister("WbiIJ", function(module, exports) {

$parcel$export(module.exports, "FilterButton", () => $d3768321d4c015de$export$fb46dd9777cc6db0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $kEVMo = parcelRequire("kEVMo");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $d3768321d4c015de$export$fb46dd9777cc6db0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isSelected: isSelected, onClick: onClick, testId: testId, vcId: vcId, isDisabled: isDisabled, text: text, label: label, customTriggerProps: customTriggerProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $d3768321d4c015de$var$buttonWrapperStyles,
        "data-vc": `${vcId}-button${false ? '-ssr' : ''}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        isDisabled: isDisabled,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d3768321d4c015de$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
            label: label,
            color: "currentColor",
            size: "small"
        })),
        ...customTriggerProps
    }, text)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3768321d4c015de$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _2hwx196n",
            __cmplp.className
        ])
    });
});
const $d3768321d4c015de$var$buttonWrapperStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});

});

parcelRegister("6h1uG", function(module, exports) {

$parcel$export(module.exports, "default", () => $85218cd505ca3251$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $85218cd505ca3251$var$messages = (0, $7VHMR.defineMessages)({
    exportButtonText: {
        "id": "issue-navigator-action-export-issues.export-button-text",
        "defaultMessage": "Export"
    },
    exportIssuesButtonIconLabel: {
        "id": "issue-navigator-action-export-issues.export-issues-button-icon-label",
        "defaultMessage": "Open export issues dropdown"
    },
    exportIssuesButtonIconLabelIssueTerminologyRefreshM4: {
        "id": "issue-navigator-action-export-issues.export-issues-button-icon-label-issue-terminology-refresh-m4",
        "defaultMessage": "Open export work items dropdown"
    }
});
var $85218cd505ca3251$export$2e2bcd8739ae039 = $85218cd505ca3251$var$messages;

});

parcelRegister("1bFRG", function(module, exports) {

let $0dd74b008bac7705$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0dd74b008bac7705$var$load("2aI3U").then(()=>parcelRequire('3wO03'));

});


parcelRegister("1VU5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $501391b3afc4b8d9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bJeNF = parcelRequire("bJeNF");

var $eZJjh = parcelRequire("eZJjh");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");

var $8U6zd = parcelRequire("8U6zd");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dG0IQ = parcelRequire("dG0IQ");

var $koVbs = parcelRequire("koVbs");

var $7XYc4 = parcelRequire("7XYc4");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $47gW9 = parcelRequire("47gW9");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $Y0ZJB = parcelRequire("Y0ZJB");

var $5Czte = parcelRequire("5Czte");

var $7mPT9 = parcelRequire("7mPT9");

var $f7PHy = parcelRequire("f7PHy");

var $cZpsT = parcelRequire("cZpsT");

var $dCm1o = parcelRequire("dCm1o");

var $8zOmE = parcelRequire("8zOmE");

var $ceKQx = parcelRequire("ceKQx");

var $2fsrR = parcelRequire("2fsrR");

var $jeztk = parcelRequire("jeztk");

var $cuGU0 = parcelRequire("cuGU0");

var $k7Zdy = parcelRequire("k7Zdy");

const $501391b3afc4b8d9$var$StatisticsOnboardingSpotlight = (0, $7XYc4.componentWithCondition)(()=>(0, $6s1PB.expVal)('helios_list_view_statistics_nin_migration', 'isEnabled', false), ({ children: children, shouldShowSpotlight: shouldShowSpotlight, coordinationClient: coordinationClient, onStatisticsTryNow: onStatisticsTryNow, onStatisticsOnboardingStop: onStatisticsOnboardingStop })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cuGU0.StatisticsOnboarding), {
        shouldShowSpotlight: shouldShowSpotlight,
        coordinationClient: coordinationClient,
        onStatisticsTryNow: onStatisticsTryNow,
        onStatisticsOnboardingStop: ()=>onStatisticsOnboardingStop((0, $ff8c546d428de2bd$export$36bc26bb4371a2a))
    }, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
const $501391b3afc4b8d9$export$ef4a0fdddd7eccb7 = ({ jql: jql, filterId: filterId = '', searchResultPageData: searchResultPageData, additionalMenuItems: additionalMenuItems, showEcosystemAppsInExport: showEcosystemAppsInExport, viewOptions: viewOptions, isIssueHierarchySupportEnabled: isIssueHierarchySupportEnabled, isHideDoneSupportEnabled: isHideDoneSupportEnabled, isHideDoneWorkItemsEnabled: isHideDoneWorkItemsEnabled, isConditionalFormattingEnabled: isConditionalFormattingEnabled })=>{
    const { data: data, loading: loading, error: error, fetch: fetch, requestPayload: requestPayload } = (0, $ceKQx.useMeatballMenuItems)(searchResultPageData);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isNinChangeboardingEnabled = (0, $5uXOq.useContext)((0, $5Czte.NinChangeboardingContext));
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const shouldShowOptOut = isNinChangeboardingEnabled && !isAnonymous;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const lastUsedRequestPayload = (0, $5uXOq.useRef)();
    const hasPreviousError = (0, $5uXOq.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const isMeatballMenuOpenedWithNewPayload = isOpen && JSON.stringify(requestPayload) !== JSON.stringify(lastUsedRequestPayload.current);
        if (!loading && !hasPreviousError.current && isMeatballMenuOpenedWithNewPayload) {
            fetch(requestPayload);
            lastUsedRequestPayload.current = requestPayload;
        }
        // If there was a fetch error, we clear the lastUsedRequestPayload
        if (error) {
            hasPreviousError.current = true;
            lastUsedRequestPayload.current = undefined;
        }
    }, [
        fetch,
        isOpen,
        loading,
        requestPayload,
        error
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $2fsrR.meatballMenuPopUpEntryPoint), {});
    const { shouldShowSpotlight: shouldShowSpotlight, onStatisticsOnboardingStop: onStatisticsOnboardingStop, coordinationClient: coordinationClient } = (0, $k7Zdy.useStatisticsSpotlight)();
    const onStatisticsTryNow = ()=>{
        onStatisticsOnboardingStop((0, $ff8c546d428de2bd$export$e328a74db0175ecc));
        entryPointActions.load();
        setIsOpen(true);
    };
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            jql: jql,
            filterId: filterId,
            additionalMenuItems: additionalMenuItems,
            viewOptions: viewOptions,
            shouldShowOptOut: shouldShowOptOut,
            data: data,
            showEcosystemAppsInExport: showEcosystemAppsInExport,
            isHideDoneWorkItemsEnabled: isHideDoneSupportEnabled && isHideDoneWorkItemsEnabled && (0, $4R6GH.fg)('jsc_bulk_edit_hide_done_work_items'),
            isConditionalFormattingEnabled: isConditionalFormattingEnabled && (0, $4R6GH.fg)('conditional-formatting-new-list-targeting-gate')
        }), [
        jql,
        filterId,
        additionalMenuItems,
        viewOptions,
        shouldShowOptOut,
        data,
        showEcosystemAppsInExport,
        isHideDoneSupportEnabled,
        isHideDoneWorkItemsEnabled,
        isConditionalFormattingEnabled
    ]);
    const entryPointTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const [retryKey, setRetryKey] = (0, $5uXOq.useState)(0);
    const errorFallback = (onRetry)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Y0ZJB.ErrorState), {
            onRetry: onRetry,
            pageAction: "meatballMenu"
        });
    const { showToggleOnboarding: showToggleOnboarding } = (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $f7PHy.useHierarchyOnboardingContext)() : {
        showToggleOnboarding: false
    };
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (showToggleOnboarding && isIssueHierarchySupportEnabled) {
            // We cannot access the ref of the "next" button in the onboarding spotlight.
            // Easiest workaround is to load the entrypoint here before we open the menu.
            // Once onboarding is removed, we can likely remove the entire isOpen prop from
            // the DropdownMenu component to avoid this issue in the future.
            entryPointActions.load();
            setIsOpen(true);
        }
    }, [
        showToggleOnboarding,
        entryPointActions,
        isIssueHierarchySupportEnabled
    ]);
    const { showHideDoneOnboarding: showHideDoneOnboarding } = (0, $4R6GH.fg)('jsc_list_hide_done_items') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $dG0IQ.useHideDoneOnboarding)({
        isHideDoneSupportEnabled: isHideDoneSupportEnabled
    }) : {
        showHideDoneOnboarding: false
    };
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (showHideDoneOnboarding && isHideDoneSupportEnabled && (0, $4R6GH.fg)('jsc_list_hide_done_items')) {
            // We cannot open the menu without loading the entrypoint.
            // Easiest workaround is to load the entrypoint here before we open the menu.
            // Once onboarding is removed, we can likely remove the entire isOpen prop from
            // the DropdownMenu component to avoid this issue in the future.
            entryPointActions.load();
            setIsOpen(true);
        }
    }, [
        entryPointActions,
        isHideDoneSupportEnabled,
        showHideDoneOnboarding
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isLoading: loading && JSON.stringify(requestPayload) === JSON.stringify(lastUsedRequestPayload.current),
        onOpenChange: (nextState)=>{
            if (nextState.isOpen) hasPreviousError.current = false;
            setIsOpen(nextState.isOpen);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: nextState.isOpen ? 'opened' : 'closed',
                actionSubject: 'button'
            }), 'meatballMenuPopup');
        },
        isOpen: isOpen,
        trigger: ({ triggerRef: triggerRef, ...props })=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($501391b3afc4b8d9$var$StatisticsOnboardingSpotlight, {
                shouldShowSpotlight: shouldShowSpotlight,
                onStatisticsTryNow: onStatisticsTryNow,
                onStatisticsOnboardingStop: onStatisticsOnboardingStop,
                coordinationClient: coordinationClient
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ref: (0, $7mPT9.mergeRefs)(triggerRef, entryPointTriggerRef),
                ...props,
                testId: "issue-navigator-action-meatball-menu.ui.menu-trigger",
                isSelected: isOpen,
                label: formatMessage((0, $jeztk.default).moreActionsLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))),
                isTooltipDisabled: false
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($501391b3afc4b8d9$var$StatisticsOnboardingSpotlight, {
                shouldShowSpotlight: shouldShowSpotlight,
                onStatisticsTryNow: onStatisticsTryNow,
                onStatisticsOnboardingStop: onStatisticsOnboardingStop,
                coordinationClient: coordinationClient
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...props,
                testId: "issue-navigator-action-meatball-menu.ui.menu-trigger",
                spacing: "default",
                isSelected: isOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    label: formatMessage((0, $jeztk.default).moreActionsLabel),
                    LEGACY_size: "medium",
                    spacing: "spacious"
                }),
                ref: (0, $7mPT9.mergeRefs)(triggerRef, entryPointTriggerRef)
            })),
        shouldFlip: true,
        placement: "bottom-end",
        spacing: "compact",
        testId: "issue-navigator-action-meatball-menu.ui.dropdown-menu",
        shouldRenderToParent: (0, $4R6GH.fg)('should-render-to-parent-should-be-true-empanada')
    }, !error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        key: retryKey,
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "popup-content",
        packageName: "jiraIssueNavigatorActionMeatballMenu",
        errorFallback: ()=>errorFallback(()=>{
                ()=>setRetryKey((prev)=>prev + 1);
            }),
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $501391b3afc4b8d9$var$spinnerContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        })),
        runtimeProps: runtimeProps
    }) : errorFallback(()=>{
        fetch(requestPayload);
        lastUsedRequestPayload.current = requestPayload;
    }));
};
const $501391b3afc4b8d9$var$spinnerContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
var $501391b3afc4b8d9$export$2e2bcd8739ae039 = $501391b3afc4b8d9$export$ef4a0fdddd7eccb7;

});
parcelRegister("ceKQx", function(module, exports) {

$parcel$export(module.exports, "useMeatballMenuItems", () => $b2c469395e2212b2$export$dcc369963df3381d);

var $5uXOq = parcelRequire("5uXOq");

var $ebyGx = parcelRequire("ebyGx");

var $ld2hZ = parcelRequire("ld2hZ");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");
const $b2c469395e2212b2$export$162e19c052deab0b = '/rest/issueNav/1/issueNav/operations/tools';
const $b2c469395e2212b2$export$34482912a4c2747c = (options)=>(0, $eusud.performPostRequest)($b2c469395e2212b2$export$162e19c052deab0b, {
        credentials: 'same-origin',
        body: (0, $ebyGx.stringify)(options),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            'X-Atlassian-Token': 'no-check',
            __amdModuleName: 'jira/issue/utils/xsrf-token-header'
        }
    });
const $b2c469395e2212b2$export$dcc369963df3381d = (searchResultPageData)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)($b2c469395e2212b2$export$34482912a4c2747c);
    const { offset: offset, pages: pages, total: total } = searchResultPageData;
    // Issue count here is used to show warning message in
    // bulk edit page. We show a warning message if the issue count is > 999.
    const allIssues = total > 999 ? 1000 : 999;
    const requestPayload = {
        offset: offset,
        searchResultsTotal: (0, $4R6GH.fg)('jsc_m2_hierarchy_fe_changes') ? allIssues : total,
        searchResultsPages: pages,
        // useColumns and skipColumns aren't used in the endpoint but is required for the constructor
        useColumns: false,
        skipColumns: false,
        new: true
    };
    (0, $5uXOq.useEffect)(()=>{
        if (loading) return;
        if (error) (0, $jcw0u.default)({
            error: error,
            event: createAnalyticsEvent({}),
            meta: {
                id: 'useMeatballMenuItems'
            }
        });
        else if (data) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useMeatballMenuItems succeeded', 'meatballMenu');
    }, [
        createAnalyticsEvent,
        data,
        error,
        loading
    ]);
    return {
        loading: loading,
        error: error,
        data: data,
        fetch: fetch,
        requestPayload: requestPayload
    };
};

});

parcelRegister("2fsrR", function(module, exports) {

$parcel$export(module.exports, "meatballMenuPopUpEntryPoint", () => $ffbb05921429c280$export$a544c6272b25c45e);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $ffbb05921429c280$export$a544c6272b25c45e = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("IeQog")), {
        moduleId: "87e9200c",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("IeQog", function(module, exports) {

let $084f9fe2d8629908$var$load = (parcelRequire("28QjX"))(4);
module.exports = $084f9fe2d8629908$var$load("cn5xt").then(()=>parcelRequire('14NkX'));

});


parcelRegister("jeztk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e045e5a40071d40$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $6e045e5a40071d40$var$messages = (0, $7VHMR.defineMessages)({
    moreActionsLabel: {
        "id": "issue-navigator-action-meatball-menu.more-actions-label",
        "defaultMessage": "More actions"
    },
    actionsOptOutDisplayText: {
        "id": "issue-navigator-action-meatball-menu.actions-opt-out-display-text",
        "defaultMessage": "Go back to the old issue search"
    },
    actionsGiveFeedbackDisplayText: {
        "id": "issue-navigator-action-meatball-menu.actions-give-feedback-display-text",
        "defaultMessage": "Give feedback"
    },
    feedbackTitle: {
        "id": "issue-navigator-action-meatball-menu.feedback-title",
        "defaultMessage": "Give feedback for issue search"
    },
    feedbackTitleDetails: {
        "id": "issue-navigator-action-meatball-menu.feedback-title-details",
        "defaultMessage": "Let us know how we can improve this experience."
    },
    feedbackTitleDetailsContactSupport: {
        "id": "issue-navigator-action-meatball-menu.feedback-title-details-contact-support",
        "defaultMessage": "If you\u2019re having technical issues, contact our support team."
    },
    feedbackTypePlaceholder: {
        "id": "issue-navigator-action-meatball-menu.feedback-type-placeholder",
        "defaultMessage": "Select an option"
    },
    bulkChangeIssues: {
        "id": "issue-navigator-action-meatball-menu.bulk-change-issues",
        "defaultMessage": "Bulk change work items"
    },
    bulkChangeIssuesOldTerminology: {
        "id": "issue-navigator-action-meatball-menu.bulk-change-issues-old-terminology",
        "defaultMessage": "Bulk change issues"
    },
    viewIssuesAsAChart: {
        "id": "issue-navigator-action-meatball-menu.view-issues-as-a-chart",
        "defaultMessage": "View issues as a chart"
    },
    viewWorkItemsAsAChart: {
        "id": "issue-navigator-action-meatball-menu.view-issues-as-a-chart-issue-term-refresh",
        "defaultMessage": "View work items as a chart"
    },
    export: {
        "id": "issue-navigator-action-meatball-menu.export",
        "defaultMessage": "Export"
    },
    newLozengeLabel: {
        "id": "issue-navigator-action-meatball-menu.new-lozenge-label",
        "defaultMessage": "New"
    },
    actionsOptOutDisplayTextIssueTerminologyRefreshM4: {
        "id": "issue-navigator-action-meatball-menu.actions-opt-out-display-text-issue-terminology-refresh-m4",
        "defaultMessage": "Go back to the old search"
    },
    feedbackTitleIssueTerminologyRefreshM4: {
        "id": "issue-navigator-action-meatball-menu.feedback-title-issue-terminology-refresh-m4",
        "defaultMessage": "Give feedback for the search"
    },
    formatRules: {
        "id": "issue-navigator-action-meatball-menu.formatRules",
        "defaultMessage": "Format rules"
    }
});
var $6e045e5a40071d40$export$2e2bcd8739ae039 = $6e045e5a40071d40$var$messages;

});

parcelRegister("cuGU0", function(module, exports) {

$parcel$export(module.exports, "StatisticsOnboarding", () => $a14340ed73a0f079$export$d628ca45cec6f862);

var $5uXOq = parcelRequire("5uXOq");

var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $hxoiH = parcelRequire("hxoiH");

var $ioD1B = parcelRequire("ioD1B");

var $2xpjA = parcelRequire("2xpjA");

var $75XXC = parcelRequire("75XXC");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $ggZrk = parcelRequire("ggZrk");

const $a14340ed73a0f079$export$d628ca45cec6f862 = ({ shouldShowSpotlight: shouldShowSpotlight, coordinationClient: coordinationClient, onStatisticsTryNow: onStatisticsTryNow, onStatisticsOnboardingStop: onStatisticsOnboardingStop, children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { colorMode: colorMode } = (0, $hxoiH.default)();
    if (!shouldShowSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "nin-meatball-button-statistics-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 3,
        pulse: shouldShowSpotlight
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
        heading: formatMessage((0, $ggZrk.default).getWorkInsights),
        messageId: (0, $4R6GH.fg)('helios_nin_statistics_onboarding_spotlight') ? (0, $ff8c546d428de2bd$export$e57f07f68ad825f4) : (0, $ff8c546d428de2bd$export$60f0ae43d6be43f1),
        image: colorMode === 'dark' ? (0, (/*@__PURE__*/$parcel$interopDefault($75XXC))) : (0, (/*@__PURE__*/$parcel$interopDefault($2xpjA))),
        key: "nin-meatball-button-statistics-spotlight",
        actions: [
            {
                onClick: onStatisticsTryNow,
                text: formatMessage((0, $ggZrk.default).tryItOut)
            },
            {
                onClick: onStatisticsOnboardingStop,
                text: formatMessage((0, $ggZrk.default).dismiss)
            }
        ],
        targetRadius: 3,
        targetBgColor: "var(--ds-background-discovery, #F3F0FF)",
        target: "nin-meatball-button-statistics-spotlight",
        messageType: "engagement",
        dialogPlacement: "bottom right"
    }, (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? formatMessage((0, $ggZrk.default).onboardingStatisticsDescriptionIssueTermRefresh) : formatMessage((0, $ggZrk.default).onboardingStatisticsDescription))));
};

});
parcelRegister("2xpjA", function(module, exports) {
module.exports = new URL("issue-view-statistics-onboarding.3f045443.gif", import.meta.url).toString();

});

parcelRegister("75XXC", function(module, exports) {
module.exports = new URL("issue-view-statistics-onboarding-dark-mode.18820f06.gif", import.meta.url).toString();

});

parcelRegister("ggZrk", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc0701c9aa6fc3d6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $dc0701c9aa6fc3d6$var$messages = (0, $7VHMR.defineMessages)({
    onboardingStatisticsDescription: {
        "id": "issue-navigator-action-meatball-menu.onboarding-statistics-description",
        "defaultMessage": "You can now create charts from filtered issues for quick and useful insights."
    },
    onboardingStatisticsDescriptionIssueTermRefresh: {
        "id": "issue-navigator-action-meatball-menu.onboarding-statistics-description-issue-term-refresh",
        "defaultMessage": "You can now create charts from filtered work items for quick and useful insights."
    },
    tryItOut: {
        "id": "issue-navigator-action-meatball-menu.try-it-out",
        "defaultMessage": "Try it out"
    },
    dismiss: {
        "id": "issue-navigator-action-meatball-menu.dismiss",
        "defaultMessage": "Dismiss"
    },
    getWorkInsights: {
        "id": "issue-navigator-action-meatball-menu.get-work-insights",
        "defaultMessage": "Get work insights"
    }
});
var $dc0701c9aa6fc3d6$export$2e2bcd8739ae039 = $dc0701c9aa6fc3d6$var$messages;

});

const $ff8c546d428de2bd$export$c7e6a6b283196232 = '/gateway/api';
const $ff8c546d428de2bd$export$60f0ae43d6be43f1 = 'jira-nin-statistics-onboarding-spotlight';
const $ff8c546d428de2bd$export$e57f07f68ad825f4 = 'jira_helios_nin_statistics_onboarding';
const $ff8c546d428de2bd$export$e328a74db0175ecc = 'jiraNinStatisticsOnboardingTryItOut';
const $ff8c546d428de2bd$export$36bc26bb4371a2a = 'jiraNinStatisticsOnboardingDismiss';
const $ff8c546d428de2bd$export$db1926f449c86467 = 'jiraNinStatisticsOnboardingSpotlight';


parcelRegister("k7Zdy", function(module, exports) {

$parcel$export(module.exports, "useStatisticsSpotlight", () => $5fd3cc9895f4daa9$export$e4f5ca4f8dca0290);

var $5uXOq = parcelRequire("5uXOq");

var $kbqIt = parcelRequire("kbqIt");

var $eGLgs = parcelRequire("eGLgs");

var $6s1PB = parcelRequire("6s1PB");

var $koeKL = parcelRequire("koeKL");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

const $5fd3cc9895f4daa9$export$e4f5ca4f8dca0290 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [showPulse, setShowPulse] = (0, $5uXOq.useState)(false);
    const coordinationClient = (0, $5uXOq.useMemo)(()=>new (0, $eGLgs.CoordinationClient)(cloudId, (0, $ff8c546d428de2bd$export$c7e6a6b283196232), false, '', 'engagement'), [
        cloudId
    ]);
    const [isMessageActive, stopMessage] = (0, $kbqIt.useCoordination)(coordinationClient, (0, $4R6GH.fg)('helios_nin_statistics_onboarding_spotlight') ? (0, $ff8c546d428de2bd$export$e57f07f68ad825f4) : (0, $ff8c546d428de2bd$export$60f0ae43d6be43f1));
    (0, $5uXOq.useEffect)(()=>{
        if (isMessageActive) {
            setShowPulse(true);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'viewed',
                actionSubject: 'spotlight'
            }), (0, $ff8c546d428de2bd$export$db1926f449c86467));
        }
    }, [
        coordinationClient,
        createAnalyticsEvent,
        isMessageActive
    ]);
    const shouldShowSpotlight = (0, $5uXOq.useMemo)(()=>showPulse && (0, $6s1PB.expVal)('helios_list_view_statistics_nin_migration', 'isEnabled', false), [
        showPulse
    ]);
    const onStatisticsOnboardingStop = (0, $5uXOq.useCallback)((actionSubject)=>{
        stopMessage();
        setShowPulse(false);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: `${actionSubject} button`
        }));
    }, [
        stopMessage,
        createAnalyticsEvent
    ]);
    return {
        shouldShowSpotlight: shouldShowSpotlight,
        onStatisticsOnboardingStop: onStatisticsOnboardingStop,
        coordinationClient: coordinationClient
    };
};

});


const $c0dd5067255a9d64$export$8a0f2e68464a820f = 'bulk_create_dd_link';
const $c0dd5067255a9d64$export$efad93080758a558 = 'bulkedit_curr_pg';
const $c0dd5067255a9d64$export$66cb530046350ea5 = 'bulkedit_all';
const $c0dd5067255a9d64$export$df7b2838a6fc207e = 'gin-meatball-menu-clear-sorts';
const $c0dd5067255a9d64$export$e389676e8d50a810 = 'opt-out-feedback';
const $c0dd5067255a9d64$export$c1dcd93cb65a1cc5 = 'connect-app';
const $c0dd5067255a9d64$export$3c1bb52064935485 = 'give-feedback';
const $c0dd5067255a9d64$export$a7a312131aa962e0 = 'go-to-all-issues';
const $c0dd5067255a9d64$export$72cbdf7971462ebd = 'hierarchy-toggle';
const $c0dd5067255a9d64$export$6e37bc383199950c = 'hide-done-toggle';
const $c0dd5067255a9d64$export$5fba477f4490fb8 = 'view-issues-as-a-chart';
const $c0dd5067255a9d64$export$d544dff0deb6c9b0 = 'export-issues';

parcelRegister("eo4oy", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf157d9126b3c63d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $jX361 = parcelRequire("jX361");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cZpsT = parcelRequire("cZpsT");

var $dCm1o = parcelRequire("dCm1o");

var $doZTA = parcelRequire("doZTA");

var $iwMsj = parcelRequire("iwMsj");
const $bf157d9126b3c63d$var$QuickFiltersDropdown = ({ isOpen: isOpen = false, onChangeFilter: onChangeFilter })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ match: match }] = (0, $doZTA.useRouter)();
    const urlPrefix = match.url.endsWith('/') ? `${match.url}?filter=` : `${match.url}/?filter=`;
    const isAnonymous = (0, $cZpsT.useIsAnonymous)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnOpenChange = (0, $5uXOq.useCallback)(({ isOpen: newIsOpen })=>{
        if (newIsOpen) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'opened',
            actionSubject: 'dropdown'
        }), 'issueNavigatorQuickFiltersDropdown');
        else (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'dropdown'
        }), 'issueNavigatorQuickFiltersDropdown');
    }, [
        createAnalyticsEvent
    ]);
    const handleOnClick = (0, $5uXOq.useCallback)((filter)=>(e)=>{
            if (onChangeFilter && (0, $4R6GH.fg)('jira_nin_smart_link')) {
                onChangeFilter(filter);
                e.preventDefault();
            }
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'filter',
                action: 'selected'
            }), 'issueNavigatorQuickFiltersDropdown', {
                filter: filter
            });
        }, [
        createAnalyticsEvent,
        onChangeFilter
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: (0, $dCm1o.isVisualRefreshEnabled)() ? ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...props,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($jX361))),
                label: formatMessage((0, $iwMsj.default).quickFilterDropdownTrigger),
                ref: triggerRef,
                isTooltipDisabled: false
            }) : formatMessage((0, $iwMsj.default).quickFilterDropdownTrigger),
        shouldRenderToParent: true,
        defaultOpen: isOpen,
        testId: "issue-navigator-action-quick-filters",
        onOpenChange: handleOnOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        href: `${urlPrefix}myopenissues`,
        onClick: handleOnClick('myopenissues')
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $iwMsj.default).myOpenIssuesIssueTermRefresh : (0, $iwMsj.default).myOpenIssues)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        href: `${urlPrefix}reportedbyme`,
        onClick: handleOnClick('reportedbyme')
    }, formatMessage((0, $iwMsj.default).reportedByMe)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        href: `${urlPrefix}allopenissues`,
        onClick: handleOnClick('allopenissues')
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $iwMsj.default).openIssuesIssueTermRefresh : (0, $iwMsj.default).openIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        href: `${urlPrefix}doneissues`,
        onClick: handleOnClick('doneissues')
    }, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $iwMsj.default).doneIssuesIssueTermRefresh : (0, $iwMsj.default).doneIssues)), !isAnonymous && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        href: `${urlPrefix}recentlyviewed`,
        onClick: handleOnClick('recentlyviewed')
    }, formatMessage((0, $iwMsj.default).viewedRecently)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        href: `${urlPrefix}resolvedrecently`,
        onClick: handleOnClick('resolvedrecently')
    }, formatMessage((0, $iwMsj.default).resolvedRecently)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        href: `${urlPrefix}updatedrecently`,
        onClick: handleOnClick('updatedrecently')
    }, formatMessage((0, $iwMsj.default).updatedRecently))));
};
var $bf157d9126b3c63d$export$2e2bcd8739ae039 = $bf157d9126b3c63d$var$QuickFiltersDropdown;

});
parcelRegister("iwMsj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbe293c6411d5c28$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $cbe293c6411d5c28$var$messages = (0, $7VHMR.defineMessages)({
    quickFilterDropdownTrigger: {
        "id": "issue-navigator-action-quick-filters.quick-filter-dropdown-trigger",
        "defaultMessage": "Quick filters"
    },
    myOpenIssues: {
        "id": "issue-navigator-action-quick-filters.my-open-issues",
        "defaultMessage": "My open issues"
    },
    myOpenIssuesIssueTermRefresh: {
        "id": "issue-navigator-action-quick-filters.my-open-issues-issue-term-refresh",
        "defaultMessage": "My open work items"
    },
    reportedByMe: {
        "id": "issue-navigator-action-quick-filters.reported-by-me",
        "defaultMessage": "Reported by me"
    },
    openIssues: {
        "id": "issue-navigator-action-quick-filters.open-issues",
        "defaultMessage": "Open issues"
    },
    openIssuesIssueTermRefresh: {
        "id": "issue-navigator-action-quick-filters.open-issues-issue-term-refresh",
        "defaultMessage": "Open work items"
    },
    doneIssues: {
        "id": "issue-navigator-action-quick-filters.done-issues",
        "defaultMessage": "Done issues"
    },
    doneIssuesIssueTermRefresh: {
        "id": "issue-navigator-action-quick-filters.done-issues-issue-term-refresh",
        "defaultMessage": "Done work items"
    },
    viewedRecently: {
        "id": "issue-navigator-action-quick-filters.viewed-recently",
        "defaultMessage": "Viewed recently"
    },
    createdRecently: {
        "id": "issue-navigator-action-quick-filters.created-recently",
        "defaultMessage": "Created recently"
    },
    resolvedRecently: {
        "id": "issue-navigator-action-quick-filters.resolved-recently",
        "defaultMessage": "Resolved recently"
    },
    updatedRecently: {
        "id": "issue-navigator-action-quick-filters.updated-recently",
        "defaultMessage": "Updated recently"
    }
});
var $cbe293c6411d5c28$export$2e2bcd8739ae039 = $cbe293c6411d5c28$var$messages;

});


parcelRegister("7bJv8", function(module, exports) {

$parcel$export(module.exports, "ShareButton", () => $2f0198851cf45c49$export$e980dfbc2840e8bc);

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $3Tty1 = parcelRequire("3Tty1");

var $koVbs = parcelRequire("koVbs");

var $WbiIJ = parcelRequire("WbiIJ");

var $9Nvh7 = parcelRequire("9Nvh7");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $iL8EU = parcelRequire("iL8EU");

var $16v4H = parcelRequire("16v4H");

var $a0UsQ = parcelRequire("a0UsQ");

var $bcD3e = parcelRequire("bcD3e");

var $i5w7k = parcelRequire("i5w7k");

var $68QXU = parcelRequire("68QXU");

var $lYorD = parcelRequire("lYorD");
const $2f0198851cf45c49$var$getShareLink = (param, value)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { hostname: hostname, protocol: protocol } = window.location;
    return `${protocol}//${hostname}/issues/?${param}=${encodeURIComponent(value)}`;
};
const $2f0198851cf45c49$var$CustomTriggerButton = ({ isDisabled: isDisabled, isSelected: isSelected, onClick: onClick }, triggerProps)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onKeyboardShortcutClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'pressed',
            actionSubject: 'keyboardShortcut'
        }), 'shareSearchCriteriaModalKeyboardShortcut', {
            keyPressed: 's',
            keyboardShortcut: true
        });
        onClick();
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const shortcutsKeyMap = (0, $5uXOq.useMemo)(()=>({
            s: {
                callback: onKeyboardShortcutClick,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, formatMessage((0, $lYorD.messages).shareKeyboardShortcut))
            }
        }), [
        formatMessage,
        onKeyboardShortcutClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: shortcutsKeyMap
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $WbiIJ.FilterButton), {
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        label: "",
        text: formatMessage((0, $lYorD.messages).share),
        customTriggerProps: {
            ...triggerProps,
            'aria-haspopup': false
        },
        vcId: "share-button"
    }));
};
const $2f0198851cf45c49$var$addContextToEvent = (event)=>{
    const attributes = event.context.map((context)=>context.attributes);
    event.update((payload)=>({
            ...payload,
            attributes: Object.assign(event.payload.attributes || {}, ...attributes)
        }));
};
const $2f0198851cf45c49$export$e980dfbc2840e8bc = ({ jql: jql, filterId: filterId, isModifiedFilter: isModifiedFilter = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const subProduct = (0, $16v4H.useSubProduct)();
    const [shouldShowThirdPartyNudge, setShouldShowThirdPartyNudge] = (0, $5uXOq.useState)(false);
    const showFilterShareLinkNew = filterId !== undefined && (0, $9Nvh7.isCustomFilter)(filterId) && !isModifiedFilter;
    // share custom filters by ID if the JQL is not overridden, otherwise just share the JQL
    const additionalProps = showFilterShareLinkNew ? {
        integrationType: (0, $bcD3e.INTEGRATION_TYPES).FILTER,
        shareContentType: (0, $bcD3e.INTEGRATION_TYPES).FILTER,
        shareLink: $2f0198851cf45c49$var$getShareLink('filter', filterId),
        shareTitle: formatMessage((0, $lYorD.messages).filter),
        shareFormTitle: formatMessage((0, $lYorD.messages).dialogTitleFilter)
    } : {
        integrationType: (0, $bcD3e.INTEGRATION_TYPES).SEARCH,
        shareContentType: (0, $bcD3e.INTEGRATION_TYPES).SEARCH,
        shareLink: $2f0198851cf45c49$var$getShareLink('jql', jql),
        shareTitle: formatMessage((0, $lYorD.messages).search),
        shareFormTitle: formatMessage((0, $lYorD.messages).dialogTitleSearch)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvUB1.default), {
        channel: "*",
        onEvent: $2f0198851cf45c49$var$addContextToEvent
    }, shouldShowThirdPartyNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a0UsQ.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL8EU.ShareButton), {
        triggerButtonStyle: "icon-with-text",
        productId: "jira",
        subProductId: (0, $68QXU.getShareSubProductId)(subProduct),
        objectAri: "" // The legacy sharing API does not use ARIs
        ,
        legacyShareClientConfig: (0, $i5w7k.shareSearchClientConfig),
        renderCustomTriggerButton: $2f0198851cf45c49$var$CustomTriggerButton,
        onTriggerButtonClick: ()=>{
            setShouldShowThirdPartyNudge(true);
        },
        ...additionalProps
    }));
};

});
parcelRegister("iL8EU", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $4e5335f44d688bbf$export$5619d05bf511476b);
$parcel$export(module.exports, "ShareButtonAnalyticsWrapperWithGating", () => $4e5335f44d688bbf$export$593c5080db936480);
$parcel$export(module.exports, "ShareButtonSync", () => $4e5335f44d688bbf$export$9b6a83af27cc7de5);
$parcel$export(module.exports, "ShareButton", () => $4e5335f44d688bbf$export$e980dfbc2840e8bc);
$parcel$export(module.exports, "ShareButtonAsync", () => $4e5335f44d688bbf$export$3585ee2128ae4c25);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $kOEld = parcelRequire("kOEld");

var $42CjB = parcelRequire("42CjB");

var $1PVpv = parcelRequire("1PVpv");

var $empdx = parcelRequire("empdx");

var $b71gk = parcelRequire("b71gk");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $itmJb = parcelRequire("itmJb");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");

var $7XYc4 = parcelRequire("7XYc4");

var $67hPg = parcelRequire("67hPg");
var $kNJSJ = parcelRequire("kNJSJ");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $2vSU6 = parcelRequire("2vSU6");

var $Kpokz = parcelRequire("Kpokz");

var $7aU9g = parcelRequire("7aU9g");

var $8BVfN = parcelRequire("8BVfN");
const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            color: "var(--ds-icon, #44546F)"
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $Kpokz.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4e5335f44d688bbf$var$ShareButtonBase = (0, $kxZPA.lazyAfterPaint)(()=>Promise.resolve((parcelRequire("7aU9g"))), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
const $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper = ({ children: children })=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const projectKey = data?.projectKey || '';
    const projectType = data?.projectType;
    const projectStyle = data?.simplified ? (0, $2vSU6.TEAM_MANAGED_PROJECT) : (0, $2vSU6.COMPANY_MANAGED_PROJECT);
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = data?.isProjectAdmin || false;
    const analyticsData = (0, $5uXOq.useMemo)(()=>{
        const projectContextData = projectKey ? {
            projectType: projectType,
            projectStyle: projectStyle,
            isProjectAdmin: isProjectAdmin
        } : undefined;
        return {
            isAdmin: isAdmin,
            userLocation: userLocation,
            ...projectContextData
        };
    }, [
        projectKey,
        projectType,
        projectStyle,
        isProjectAdmin,
        userLocation,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PVpv.FabricElementsAnalyticsContext), {
        data: analyticsData
    }, children));
};
const $4e5335f44d688bbf$export$593c5080db936480 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsw-smart-access-extended-analytics-enabled'), $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper, (0, $5uXOq.Fragment));
const $4e5335f44d688bbf$export$9b6a83af27cc7de5 = (props)=>(0, $4R6GH.fg)('migrate_share_dialog_error_boundary') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7aU9g.default), props))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7aU9g.default), props)));
const $4e5335f44d688bbf$export$e980dfbc2840e8bc = (props)=>(0, $4R6GH.fg)('migrate_share_dialog_error_boundary') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async.share.button",
        packageName: "share-button",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props))));
const $4e5335f44d688bbf$export$3585ee2128ae4c25 = (props)=>{
    const { Panel: Panel, trigger: trigger } = (0, $kNJSJ.usePanel)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            ...props
        }), [
        props
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: props.errorBoundaryId,
        packageName: "jiraShareButton",
        teamName: props.teamName,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67hPg.Trigger), {
        trigger: trigger,
        entryPoint: (0, $8BVfN.shareButtonEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps
    }, ({ ref: ref })=>!isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            testId: "share-button.button",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            appearance: "default",
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($empdx))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
            onClick: ()=>setIsOpen(true)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Panel, null));
};

});
parcelRegister("kOEld", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eddb3c8fd23121248d7a9663e3c0819a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f277c50ed79b6741$var$_react = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f277c50ed79b6741$var$_share = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("empdx")));

var $f277c50ed79b6741$var$_share2 = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("jZX0t")));
function $f277c50ed79b6741$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f277c50ed79b6741$var$ShareIcon = (props)=>/*#__PURE__*/ $f277c50ed79b6741$var$_react.default.createElement($f277c50ed79b6741$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $f277c50ed79b6741$var$_share2.default
    }, props));
$f277c50ed79b6741$var$ShareIcon.Name = 'ShareIconMigration';
var $f277c50ed79b6741$var$_default = module.exports.default = $f277c50ed79b6741$var$ShareIcon;

});
parcelRegister("jZX0t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8f17c524b03e26b$var$_react = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e8f17c524b03e26b$var$_share = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("empdx")));
function $e8f17c524b03e26b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e8f17c524b03e26b$var$ShareIcon = (props)=>/*#__PURE__*/ $e8f17c524b03e26b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $e8f17c524b03e26b$var$_share.default
    }));
$e8f17c524b03e26b$var$ShareIcon.displayName = 'ShareIcon';
var $e8f17c524b03e26b$var$_default = module.exports.default = $e8f17c524b03e26b$var$ShareIcon;

});


parcelRegister("Kpokz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $026d1258a1c95d57$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $026d1258a1c95d57$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("7aU9g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "JiraShareButton", () => $4e0ba5939e9454a3$export$1b9334aba47cc461);
$parcel$export(module.exports, "default", () => $4e0ba5939e9454a3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $81zXP = parcelRequire("81zXP");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $14XJw = parcelRequire("14XJw");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $7CMCs = parcelRequire("7CMCs");

var $dAfqg = parcelRequire("dAfqg");

var $cSD7y = parcelRequire("cSD7y");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lIxty = parcelRequire("lIxty");

var $3Qkpk = parcelRequire("3Qkpk");

var $ly021 = parcelRequire("ly021");

var $3Misg = parcelRequire("3Misg");

var $cvSAQ = parcelRequire("cvSAQ");

var $60DYE = parcelRequire("60DYE");

var $5GqLe = parcelRequire("5GqLe");

var $cRUzY = parcelRequire("cRUzY");

var $fG2b8 = parcelRequire("fG2b8");

var $hn0BX = parcelRequire("hn0BX");

var $1uAgh = parcelRequire("1uAgh");

var $ckpyh = parcelRequire("ckpyh");
// Remove Old suffix and wrap in memo on clean up of vc90_perf_improve_pre_share_on_issue_view
const $4e0ba5939e9454a3$var$JiraShareButtonOld = (props)=>{
    const { triggerButtonStyle: triggerButtonStyle, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose, renderCustomTriggerButton: renderCustomTriggerButton, shareShortcutTriggerCount: shareShortcutTriggerCount = 0, prevShareShortcutTriggerCount: prevShareShortcutTriggerCount = 0, shareFormTitle: shareFormTitle, shareContentType: shareContentType, poSpotlightShareButtonId: poSpotlightShareButtonId, additionalTabs: additionalTabs, shareIntegrations: shareIntegrations, shareFieldsFooter: shareFieldsFooterProp, ...otherProps } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const { cloudId: cloudId, activationId: activationId } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ loading: loadingOutgoingMailStatus, data: outgoingMailStatus, error: outgoingMailStatusError }, fetchEmailSettings] = (0, $3Qkpk.default)();
    const [{ data: hasUserPermission, error: userPermissionError }, fetchUserPermission] = (0, $ly021.default)();
    const [{ loading: loadingComplainceStatusHipaa, data: complainceStatusHIPAA, error: complainceStatusHipaaError }, fetchHipaaComplianceStatus] = (0, $lIxty.useIsHipaaComplianceService)();
    const isExtendedShareDialogEnabled = (0, $cvSAQ.useIsExtendedShareDialogEnabled)();
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { data: projectAccessData, fetch: fetchProjectAccessLevels, loading: isProjectAccessLoading, error: fetchProjectAccessError } = (0, $3Misg.useProjectAccessLevel)();
    const { data: userRoles, fetch: fetchUserRoles, loading: userRolesLoading, error: fetchUserRolesError } = (0, $60DYE.useUserRole)(projectContext?.projectKey);
    const [isAutoOpen, setIsAutoOpen] = (0, $5uXOq.useState)(true);
    const shortcutPressed = !!(shareShortcutTriggerCount && shareShortcutTriggerCount > 0 && shareShortcutTriggerCount > prevShareShortcutTriggerCount);
    (0, $5uXOq.useEffect)(()=>{
        if (outgoingMailStatus === undefined && isAutoOpenDialog === true) fetchEmailSettings();
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        outgoingMailStatus
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (complainceStatusHIPAA === undefined && isAutoOpenDialog === true) fetchHipaaComplianceStatus();
    // complianceStatusHIPAA is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        complainceStatusHIPAA
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasUserPermission === undefined && isAutoOpenDialog === true) fetchUserPermission();
    // hasUserPermission is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isAutoOpenDialog,
        hasUserPermission
    ]);
    // This is used purely to trigger a re-render.
    // If `isAutoOpenDialog` prop is already true, when the prop is recalculated
    // in the parent if it's `true` again there will be no re-render.
    (0, $5uXOq.useEffect)(()=>{
        if (outgoingMailStatus === undefined && shortcutPressed) fetchEmailSettings();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        outgoingMailStatus,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (complainceStatusHIPAA === undefined && shortcutPressed) fetchHipaaComplianceStatus();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchEmailSettings is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        complainceStatusHIPAA,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (hasUserPermission === undefined && shortcutPressed) fetchUserPermission();
        if (shortcutPressed) setIsAutoOpen(shortcutPressed);
    // fetchUserPermission is unstable and casues a setState loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasUserPermission,
        shortcutPressed,
        shareShortcutTriggerCount
    ]);
    const getCustomFormTitle = (0, $5uXOq.useCallback)(()=>{
        switch(shareContentType){
            case 'summary':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmSummary);
            case 'board':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmBoard);
            case 'list':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmList);
            case 'calendar':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmCalendar);
            case 'timeline':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmTimeline);
            case 'form':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmForm);
            case 'attachments':
                return formatMessage((0, $fG2b8.default).shareMainTabTextJwmAttachments);
            default:
                return shareFormTitle;
        }
    }, [
        formatMessage,
        shareContentType,
        shareFormTitle
    ]);
    // Error handling fires analytics.
    (0, $5uXOq.useEffect)(()=>{
        if (outgoingMailStatusError) (0, $jcw0u.default)({
            meta: {
                id: 'getEmailSettings',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        outgoingMailStatusError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (complainceStatusHipaaError) (0, $jcw0u.default)({
            meta: {
                id: 'getComplainceStatusHIPAA',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        complainceStatusHipaaError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (userPermissionError) (0, $jcw0u.default)({
            meta: {
                id: 'userPermissionError',
                packageName: 'jiraShareButton',
                teamName: 'people-and-teams-collective'
            }
        });
    }, [
        userPermissionError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (fetchProjectAccessError) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fetchProjectAccessLevels failed', 'shareButton', {
            source: (0, $5GqLe.ANALYTICS_SOURCE),
            error: fetchProjectAccessError
        });
    }, [
        createAnalyticsEvent,
        fetchProjectAccessError
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (fetchUserRolesError) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'fetchUserRoles failed', 'shareButton', {
            source: (0, $5GqLe.ANALYTICS_SOURCE),
            error: fetchUserRolesError
        });
    }, [
        createAnalyticsEvent,
        fetchUserRolesError
    ]);
    // Loading but no errors or data available.
    const shouldAutoOpenPreShareDialog = isAutoOpenDialog === true && (loadingOutgoingMailStatus || loadingComplainceStatusHipaa || complainceStatusHIPAA !== undefined || !!outgoingMailStatusError || !!complainceStatusHipaaError || outgoingMailStatus !== undefined);
    const shareFieldsFooter = isExtendedShareDialogEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jiraShareButtonProjectAccessLevel",
        packageName: "jiraShareButton",
        teamName: "a4t-pandora",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckpyh.ProjectAccessLevelSelectContainer), {
        currentAccessLevel: projectAccessData?.accessLevel,
        accessLevels: projectAccessData?.availableAccessLevels,
        getProjectAccessLevels: fetchProjectAccessLevels,
        isLoading: isProjectAccessLoading
    })), shareFieldsFooterProp) : shareFieldsFooterProp;
    const isOutgoingMailDisabled = outgoingMailStatus?.isEmailEnabled === false;
    const isDisabledDueToEmail = isOutgoingMailDisabled && (additionalTabs?.length ?? 0) === 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (outgoingMailStatus === undefined || isDisabledDueToEmail || complainceStatusHIPAA?.isCompliant === true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hn0BX.default), {
        triggerButtonStyle: triggerButtonStyle,
        loading: loadingOutgoingMailStatus || loadingComplainceStatusHipaa,
        error: outgoingMailStatusError || complainceStatusHipaaError,
        emailSettings: outgoingMailStatus,
        hipaaStatus: complainceStatusHIPAA,
        renderCustomTriggerButton: renderCustomTriggerButton,
        getEmailSettings: fetchEmailSettings,
        getHipaaStatus: fetchHipaaComplianceStatus,
        getUserPermission: fetchUserPermission,
        ...isExtendedShareDialogEnabled && {
            getUserRoles: fetchUserRoles
        },
        isAutoOpenDialog: shortcutPressed || shouldAutoOpenPreShareDialog,
        onTriggerButtonClick: props.onTriggerButtonClick,
        shareShortcutTriggerCount: shareShortcutTriggerCount,
        poSpotlightShareButtonId: poSpotlightShareButtonId
    }), outgoingMailStatus !== undefined && !isDisabledDueToEmail && complainceStatusHIPAA?.isCompliant === false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1uAgh.default), {
        triggerButtonAppearance: "default",
        isAutoOpenDialog: isAutoOpen,
        renderCustomTriggerButton: renderCustomTriggerButton,
        shareContentType: shareContentType,
        shareFormTitle: shareFormTitle || getCustomFormTitle(),
        triggerButtonStyle: triggerButtonStyle,
        isBrowseUsersEnabled: hasUserPermission,
        onDialogClose: ()=>{
            setIsAutoOpen(false);
            if (onDialogClose) onDialogClose();
        },
        orgId: orgId,
        workspaceAri: (0, $4R6GH.fg)('jira_share_button-enable_jira_workspace_ari') ? (0, $81zXP.JiraWorkspaceAri).create({
            activationId: activationId,
            siteId: cloudId
        }).toString() : (0, $dXq4S.createAri)({
            resourceId: activationId,
            cloudId: cloudId,
            resourceType: 'workspace',
            resourceOwner: 'jira'
        }),
        additionalTabs: additionalTabs,
        shareIntegrations: isOutgoingMailDisabled ? [] : shareIntegrations,
        isOutgoingMailDisabled: isOutgoingMailDisabled,
        shareFieldsFooter: isOutgoingMailDisabled ? (0, $cRUzY.default)({
            canUserEnableEmail: outgoingMailStatus?.canUserEnableEmail
        }) : shareFieldsFooter,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        ...isExtendedShareDialogEnabled && {
            userRoles: userRoles,
            userRolesLoading: userRolesLoading,
            accessLevel: projectAccessData?.accessLevel.value
        },
        ...otherProps
    }));
};
const $4e0ba5939e9454a3$var$MemoedJiraShareButton = /*#__PURE__*/ (0, $5uXOq.memo)($4e0ba5939e9454a3$var$JiraShareButtonOld);
const $4e0ba5939e9454a3$export$1b9334aba47cc461 = (0, $cSD7y.componentWithFG)('vc90_perf_improve_pre_share_on_issue_view', $4e0ba5939e9454a3$var$MemoedJiraShareButton, $4e0ba5939e9454a3$var$JiraShareButtonOld);
var $4e0ba5939e9454a3$export$2e2bcd8739ae039 = $4e0ba5939e9454a3$export$1b9334aba47cc461;

});
parcelRegister("lIxty", function(module, exports) {

$parcel$export(module.exports, "useIsHipaaComplianceService", () => $8b53c07d7b6353b9$export$dad138577ca71048);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $8b53c07d7b6353b9$var$getHipaaComplianceStatus = async ()=>(0, $eusud.performGetRequest)('/rest/internal/latest/compliance/status/HIPAA');
const $8b53c07d7b6353b9$export$dad138577ca71048 = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchHipaaComplianceStatus } = (0, $ld2hZ.useService)($8b53c07d7b6353b9$var$getHipaaComplianceStatus);
    const transformedData = (0, $5uXOq.useMemo)(()=>data ? {
            isCompliant: data.isCompliant
        } : undefined, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: transformedData
        },
        fetchHipaaComplianceStatus
    ];
};

});

parcelRegister("3Qkpk", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b79009b50ad613d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $8b79009b50ad613d$var$getEmailSettings = async ()=>(0, $eusud.performGetRequest)('/rest/jira-mail-plugin/1.0/outgoingMail/config');
const $8b79009b50ad613d$export$5f20fafd52370aae = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchEmailSettings } = (0, $ld2hZ.useService)($8b79009b50ad613d$var$getEmailSettings);
    const transformedData = (0, $5uXOq.useMemo)(()=>data ? {
            isEmailEnabled: data.enabled,
            canUserEnableEmail: data.canEditConfig
        } : undefined, [
        data
    ]);
    return [
        {
            loading: loading,
            error: error,
            data: transformedData
        },
        fetchEmailSettings
    ];
};
var $8b79009b50ad613d$export$2e2bcd8739ae039 = $8b79009b50ad613d$export$5f20fafd52370aae;

});

parcelRegister("ly021", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3c761b58cac213d$export$2e2bcd8739ae039);

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");
const $b3c761b58cac213d$var$getUserPermission = async ()=>(0, $eusud.performGetRequest)('/rest/api/3/mypermissions?permissions=USER_PICKER');
const $b3c761b58cac213d$export$ce7974a7294500be = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetchUserPermission } = (0, $ld2hZ.useService)($b3c761b58cac213d$var$getUserPermission);
    return [
        {
            loading: loading,
            error: error,
            data: data?.permissions?.USER_PICKER?.havePermission
        },
        fetchUserPermission
    ];
};
var $b3c761b58cac213d$export$2e2bcd8739ae039 = $b3c761b58cac213d$export$ce7974a7294500be;

});

parcelRegister("3Misg", function(module, exports) {

$parcel$export(module.exports, "useProjectAccessLevel", () => $da4bace31cc40a76$export$e262f937bd216199);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");

var $dAfqg = parcelRequire("dAfqg");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5GqLe = parcelRequire("5GqLe");
const $da4bace31cc40a76$var$getProjectAccessLevel = async (projectId)=>{
    if (!projectId) throw new Error('Project ID is missing while fetching project access level.');
    return (0, $eusud.performGetRequest)(`/rest/internal/simplified/1.0/accesslevel/project/${projectId}`);
};
const $da4bace31cc40a76$var$getProjectAccessLevels = async ()=>{
    return (0, $eusud.performGetRequest)('/rest/internal/simplified/1.0/accesslevel?projectType=software');
};
const $da4bace31cc40a76$var$updateProjectAccessLevel = async ({ projectId: projectId, projectKey: projectKey, accessLevel: accessLevel })=>{
    if (!projectId || !projectKey) throw new Error('Project ID and/or Key is missing while updating project access level.');
    return (0, $eusud.performPutRequest)(`/rest/internal/simplified/1.0/projects/${projectId}/summary`, {
        body: JSON.stringify({
            accessLevel: accessLevel,
            key: projectKey
        })
    });
};
const $da4bace31cc40a76$export$e262f937bd216199 = ()=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { projectId: projectId, projectKey: projectKey } = (0, $5uXOq.useMemo)(()=>({
            projectId: projectContext?.projectId,
            projectKey: projectContext?.projectKey
        }), [
        projectContext
    ]);
    const fetchProjectAccessLevels = (0, $5uXOq.useCallback)(()=>Promise.all([
            $da4bace31cc40a76$var$getProjectAccessLevel(projectId),
            $da4bace31cc40a76$var$getProjectAccessLevels()
        ]).then(([accessLevel, availableAccessLevels])=>({
                accessLevel: accessLevel,
                availableAccessLevels: availableAccessLevels
            })), [
        projectId
    ]);
    const sendProjectAccessLevelUpdate = (0, $5uXOq.useCallback)(({ accessLevel: accessLevel })=>$da4bace31cc40a76$var$updateProjectAccessLevel({
            projectId: projectId,
            projectKey: projectKey,
            accessLevel: accessLevel
        }), [
        projectId,
        projectKey
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)(fetchProjectAccessLevels);
    const { loading: isUpdating, error: updateError, fetch: update } = (0, $ld2hZ.useService)(sendProjectAccessLevelUpdate);
    const fetchWithAnalytics = (0, $5uXOq.useCallback)(async ()=>{
        const result = await fetch();
        if (result) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchProjectAccessLevels succeeded', 'shareButton', {
            source: (0, $5GqLe.ANALYTICS_SOURCE)
        });
        return result;
    }, [
        fetch,
        createAnalyticsEvent
    ]);
    return {
        loading: loading || isUpdating,
        error: error,
        updateError: updateError,
        data: data,
        fetch: fetchWithAnalytics,
        update: update
    };
};

});
parcelRegister("5GqLe", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $0970fea694a8095f$export$a7359bcfb0ca8e98);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $0970fea694a8095f$export$f7109619a5e9e0d6);
const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments',
    DEPENDENCIES: 'dependencies',
    INCREMENT: 'increment',
    QUEUE: 'queue'
};
const $0970fea694a8095f$export$f7109619a5e9e0d6 = 'growthShareButton';

});


parcelRegister("cvSAQ", function(module, exports) {

$parcel$export(module.exports, "useIsExtendedShareDialogEnabled", () => $8c2efaed9c82d207$export$1000ebfdeca10b3c);

var $6s1PB = parcelRequire("6s1PB");

var $3HwlS = parcelRequire("3HwlS");

var $lODMY = parcelRequire("lODMY");

var $itmJb = parcelRequire("itmJb");

var $dAfqg = parcelRequire("dAfqg");
const $8c2efaed9c82d207$export$1000ebfdeca10b3c = ()=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isProjectAdmin = !!projectContextData?.isProjectAdmin;
    const isTMP = (0, $dAfqg.useIsSimplifiedProject)();
    const projectType = projectContextData?.projectType;
    const isBusinessOrSoftwareProject = projectType === 'business' || projectType === 'software';
    const shouldShowInNav3View = (0, $lODMY.useIsActiveRoute)(new Set([
        'software-timeline',
        'software-boards',
        'software-backlog',
        'issue'
    ]));
    return ((0, $3HwlS.getWillShowNav4)() || shouldShowInNav3View) && isBusinessOrSoftwareProject && isTMP && (isAdmin || isProjectAdmin) && (0, $6s1PB.expVal)('tmp_secure_project_access_share_dialog', 'isEnabled', false);
};

});

parcelRegister("60DYE", function(module, exports) {

$parcel$export(module.exports, "useUserRole", () => $13fb2e5bc2538e40$export$77101ee802ae0455);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eIGIx = parcelRequire("eIGIx");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5GqLe = parcelRequire("5GqLe");
const $13fb2e5bc2538e40$var$getUserRolesService = (projectKey)=>{
    if (!projectKey) throw new Error('Project Key is required to fetch user roles');
    return (0, $eusud.performGetRequest)(`/rest/api/3/project/${projectKey}/roledetails?excludeConnectAddons=true`);
};
const $13fb2e5bc2538e40$var$addUserRoleService = ({ projectKey: projectKey, roleId: roleId, groups: groups, users: users })=>{
    if (!projectKey) throw new Error('Project key is required to add user role');
    return (0, $eusud.performPostRequest)(`/rest/projectconfig/latest/roles/${projectKey}/${roleId}`, {
        body: JSON.stringify({
            groups: groups,
            users: users
        })
    });
};
const $13fb2e5bc2538e40$export$77101ee802ae0455 = (projectKey)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { data: data, fetch: fetch, loading: isFetching, error: fetchError } = (0, $ld2hZ.useService)((0, $eIGIx.useCallbackWithCondition)(()=>$13fb2e5bc2538e40$var$getUserRolesService(projectKey), [
        projectKey
    ], ()=>(0, $4R6GH.fg)('jfp_magma_issue-stability-phase1')));
    const { loading: isAdding, error: addError, fetch: addUserRoleInternal } = (0, $ld2hZ.useService)($13fb2e5bc2538e40$var$addUserRoleService);
    const add = (0, $5uXOq.useCallback)((roleId, { users: users, groups: groups })=>addUserRoleInternal({
            projectKey: projectKey,
            roleId: roleId,
            users: users,
            groups: groups
        }), [
        addUserRoleInternal,
        projectKey
    ]);
    const fetchWithAnalytics = (0, $5uXOq.useCallback)(async ()=>{
        const result = await fetch();
        if (result) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'fetchUserRoles succeeded', 'shareButton', {
            source: (0, $5GqLe.ANALYTICS_SOURCE)
        });
        return result;
    }, [
        createAnalyticsEvent,
        fetch
    ]);
    return {
        fetch: fetchWithAnalytics,
        add: add,
        data: data,
        loading: isFetching || isAdding,
        error: fetchError,
        updateError: addError
    };
};

});

parcelRegister("cRUzY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2333dcf1c6e1c11b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $92Z2l = parcelRequire("92Z2l");
var $ctz0s = parcelRequire("ctz0s");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $cGLqe = parcelRequire("cGLqe");
const $2333dcf1c6e1c11b$var$OutgoingMailWarningMessage = ({ canUserEnableEmail: canUserEnableEmail })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return canUserEnableEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctz0s.default), {
            href: "/secure/admin/OutgoingMailServers.jspa"
        }, formatMessage((0, $cGLqe.default).outgoingMailSettingsLink)),
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $cGLqe.default).disabledWarningMessage))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $cGLqe.default).disabledWarningMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), null, formatMessage((0, $cGLqe.default).nonAdminWarningMessage)));
};
var $2333dcf1c6e1c11b$export$2e2bcd8739ae039 = $2333dcf1c6e1c11b$var$OutgoingMailWarningMessage;

});
parcelRegister("ctz0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e844da07d79ea04$export$2e2bcd8739ae039);
/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $5McnS = parcelRequire("5McnS");
var $MHKc7 = parcelRequire("MHKc7");
var $3Lty3 = parcelRequire("3Lty3");
const $2e844da07d79ea04$var$styles = {
    common: "_11c82smr _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
    anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
    pressable: "_bfhk1w7a _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $2e844da07d79ea04$var$SectionMessageAction = /*#__PURE__*/ (0, $5uXOq.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    if (!linkComponent && (0, $VSDnB.fg)('platform_section_message_action_migration')) {
        if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5McnS.default), {
            testId: testId,
            onClick: onClick,
            href: href,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.anchor),
            children: children
        });
        if (onClick) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
            testId: testId,
            onClick: onClick,
            xcss: (0, $3JT92.cx)($2e844da07d79ea04$var$styles.common, $2e844da07d79ea04$var$styles.pressable),
            children: children
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            as: "span",
            testId: testId,
            children: children
        });
    }
    return onClick || href ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined,
        children: children
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: children
    });
});
var $2e844da07d79ea04$export$2e2bcd8739ae039 = $2e844da07d79ea04$var$SectionMessageAction;

});

parcelRegister("cGLqe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5118dd1ca51be8cb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5118dd1ca51be8cb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    disabledWarningMessage: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message",
        "defaultMessage": "Outgoing mail is not configured."
    },
    adminEnableOutgoingMail: {
        "id": "share-button.pre-share-view.warning-content.admin-enable-outgoing-mail",
        "defaultMessage": "You can configure it here"
    },
    outgoingMail: {
        "id": "share-button.pre-share-view.warning-content.outgoing-mail",
        "defaultMessage": "Outgoing Mail"
    },
    nonAdminWarningMessage: {
        "id": "share-button.pre-share-view.warning-content.non-admin-warning-message",
        "defaultMessage": "Please contact your Jira administrator to enable sharing."
    },
    disabledWarningMessageIfHipaa: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message-if-hipaa",
        "defaultMessage": "You cannot share issue as your organization has signed up for HIPAA compliance"
    },
    disabledWarningMessageIfHipaaIssueTermRefresh: {
        "id": "share-button.pre-share-view.warning-content.disabled-warning-message-if-hipaa-issue-term-refresh",
        "defaultMessage": "You can't share work item as your organization has signed up for HIPAA compliance"
    },
    outgoingMailSettingsLink: {
        "id": "share-button.pre-share-view.warning-content.enable-outgoing-mail-link",
        "defaultMessage": "Set up email sharing"
    }
});

});


parcelRegister("fG2b8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a915a4d87397f963$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a915a4d87397f963$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareMainTabTextJwmSummary: {
        "id": "share-button.share-main-tab-text-jwm-summary",
        "defaultMessage": "Share summary"
    },
    shareMainTabTextJwmBoard: {
        "id": "share-button.share-main-tab-text-jwm-board",
        "defaultMessage": "Share board"
    },
    shareMainTabTextJwmList: {
        "id": "share-button.share-main-tab-text-jwm-list",
        "defaultMessage": "Share list"
    },
    shareMainTabTextJwmCalendar: {
        "id": "share-button.share-main-tab-text-jwm-calendar",
        "defaultMessage": "Share calendar"
    },
    shareMainTabTextJwmTimeline: {
        "id": "share-button.share-main-tab-text-jwm-timeline",
        "defaultMessage": "Share timeline"
    },
    shareMainTabTextJwmForm: {
        "id": "share-button.share-main-tab-text-jwm-form",
        "defaultMessage": "Share form"
    },
    shareMainTabTextJwmAttachments: {
        "id": "share-button.share-main-tab-text-jwm-attachments",
        "defaultMessage": "Share attachments"
    }
});

});

parcelRegister("hn0BX", function(module, exports) {

$parcel$export(module.exports, "default", () => $6286a7fcdb67d585$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $fVnbM = parcelRequire("fVnbM");

var $empdx = parcelRequire("empdx");

var $kOEld = parcelRequire("kOEld");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $jgJNO = parcelRequire("jgJNO");

var $9fuVs = parcelRequire("9fuVs");

var $gwIPs = parcelRequire("gwIPs");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $cSD7y = parcelRequire("cSD7y");

var $ggimd = parcelRequire("ggimd");

var $6P8F6 = parcelRequire("6P8F6");
const $6286a7fcdb67d585$var$ConditionalTooltip = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $ggimd.default).shareTriggerButtonText),
        ...(0, $4R6GH.fg)('jfp_a11y_team_button_has_verbose_accessible_name') && {
            isScreenReaderAnnouncementDisabled: true
        },
        position: "top"
    }, children);
};
// Remove Old suffix and wrap in memo on clean up of vc90_perf_improve_pre_share_on_issue_view
const $6286a7fcdb67d585$var$PreShareViewOld = ({ triggerButtonStyle: triggerButtonStyle, loading: loading, error: error, emailSettings: emailSettings, hipaaStatus: hipaaStatus, renderCustomTriggerButton: renderCustomTriggerButton, getEmailSettings: getEmailSettings, getHipaaStatus: getHipaaStatus, getUserPermission: getUserPermission, getUserRoles: getUserRoles, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose, onTriggerButtonClick: onTriggerButtonClick, shareShortcutTriggerCount: shareShortcutTriggerCount, poSpotlightShareButtonId: poSpotlightShareButtonId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isAutoOpenDialog);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // Used to invoke a re-render when isAutoOpenDialog has not changed but the shortcut has been pressed again.
    (0, $5uXOq.useEffect)(()=>{
        setIsOpen(isAutoOpenDialog);
    }, [
        isAutoOpenDialog,
        shareShortcutTriggerCount
    ]);
    const onTriggerClick = (0, $5uXOq.useCallback)((trigger)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'PreShareView Button Clicked',
            actionSubject: 'Share'
        });
        setIsOpen(!isOpen);
        if (!isOpen) {
            getUserPermission();
            getEmailSettings();
            getHipaaStatus();
            getUserRoles && getUserRoles();
        }
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, trigger);
        if (onTriggerButtonClick) onTriggerButtonClick();
    }, [
        createAnalyticsEvent,
        isOpen,
        onTriggerButtonClick,
        getUserPermission,
        getEmailSettings,
        getHipaaStatus,
        getUserRoles
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        onClose: ()=>{
            setIsOpen(false);
            onDialogClose && onDialogClose();
        },
        zIndex: (0, $gwIPs.layers).modal,
        messageId: "share-button.ui.pre-share-view.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fuVs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6286a7fcdb67d585$var$DialogLayout, {
                "data-testid": "share-button.ui.pre-share-view.warningModal"
            }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                testId: "share-button.ui.pre-share-view.loading",
                size: "medium"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6P8F6.WarningContent), {
                isEmailEnabled: emailSettings?.isEmailEnabled,
                canUserEnableEmail: !!emailSettings?.canUserEnableEmail,
                isUserHIPAA: !!hipaaStatus?.isCompliant
            }), error && // eslint-disable-next-line @atlaskit/design-system/use-heading
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h1", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $ggimd.default).errorMessage)))),
        isOpen: isOpen,
        placement: "left-start",
        trigger: (triggerProps)=>renderCustomTriggerButton ? renderCustomTriggerButton({
                isSelected: isOpen,
                onClick: ()=>onTriggerClick('RenderCustomTriggerPreShareView')
            }, triggerProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6286a7fcdb67d585$var$ConditionalTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
                name: "issue-pre-share-button"
            }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                testId: "share-button.ui.pre-share-view.button",
                id: poSpotlightShareButtonId,
                isDisabled: loading,
                label: formatMessage((0, $ggimd.default).shareTriggerButtonText),
                ...triggerProps,
                appearance: "default",
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($empdx))), {
                        spacing: "spacious",
                        ...(0, $4R6GH.fg)('jfp_a11y_team_button_has_verbose_accessible_name') ? {
                            testId: 'share-button.ui.pre-share-view.share-icon',
                            label: ''
                        } : {
                            label: triggerButtonStyle === 'icon-with-text' ? '' : formatMessage((0, $ggimd.default).shareTriggerButtonText)
                        },
                        color: "var(--ds-icon, #44546F)"
                    }),
                onClick: ()=>onTriggerClick('PreShareView')
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                testId: "share-button.ui.pre-share-view.button",
                id: poSpotlightShareButtonId,
                disabled: loading,
                ...triggerProps,
                appearance: "subtle",
                ...(0, $4R6GH.fg)('jfp_a11y_team_button_has_verbose_accessible_name') && {
                    'aria-label': formatMessage((0, $ggimd.default).shareTriggerButtonText)
                },
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
                    LEGACY_size: "medium",
                    spacing: "spacious",
                    ...(0, $4R6GH.fg)('jfp_a11y_team_button_has_verbose_accessible_name') ? {
                        testId: 'share-button.ui.pre-share-view.share-icon',
                        label: ''
                    } : {
                        label: triggerButtonStyle === 'icon-with-text' ? '' : formatMessage((0, $ggimd.default).shareTriggerButtonText)
                    },
                    color: "var(--ds-icon, #44546F)"
                }),
                onClick: ()=>onTriggerClick('PreShareView')
            }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $ggimd.default).shareTriggerButtonText) : null)))
    });
};
const $6286a7fcdb67d585$var$MemoedPreShareView = /*#__PURE__*/ (0, $5uXOq.memo)($6286a7fcdb67d585$var$PreShareViewOld);
const $6286a7fcdb67d585$export$412417a0122f041e = (0, $cSD7y.componentWithFG)('vc90_perf_improve_pre_share_on_issue_view', $6286a7fcdb67d585$var$MemoedPreShareView, $6286a7fcdb67d585$var$PreShareViewOld);
var $6286a7fcdb67d585$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $6286a7fcdb67d585$export$412417a0122f041e;
const $6286a7fcdb67d585$var$DialogLayout = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ggimd", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3676909909c5a34$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a3676909909c5a34$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.pre-share-view.share-trigger-button-text",
        "defaultMessage": "Share"
    },
    errorMessage: {
        "id": "share-button.pre-share-view.error-message",
        "defaultMessage": "Unable to fetch sharing details"
    }
});

});

parcelRegister("6P8F6", function(module, exports) {

$parcel$export(module.exports, "WarningContent", () => $ecad3da73effb00b$export$b7eb687edfdfe752);

var $5uXOq = parcelRequire("5uXOq");

var $bU3PY = parcelRequire("bU3PY");

var $41j30 = parcelRequire("41j30");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $cGLqe = parcelRequire("cGLqe");
function $ecad3da73effb00b$export$b7eb687edfdfe752({ isEmailEnabled: isEmailEnabled, canUserEnableEmail: canUserEnableEmail, isUserHIPAA: isUserHIPAA }) {
    if (isEmailEnabled === false || isUserHIPAA) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa),
        sourceName: "PreShareWarningView"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: "Warning",
        testId: "share-button.ui.pre-share-view.warning-content.warning-icon"
    }), isEmailEnabled === false && // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).disabledWarningMessage), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), canUserEnableEmail ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).adminEnableOutgoingMail), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $41j30.default), {
        href: "/secure/admin/OutgoingMailServers.jspa"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).outgoingMail))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $cGLqe.default).nonAdminWarningMessage)), isEmailEnabled !== false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $cGLqe.default).disabledWarningMessageIfHipaaIssueTermRefresh : (0, $cGLqe.default).disabledWarningMessageIfHipaa), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            canUserEnableEmail: canUserEnableEmail,
            isUserHIPAA: isUserHIPAA
        }
    }));
    return null;
}

});


parcelRegister("1uAgh", function(module, exports) {

$parcel$export(module.exports, "default", () => $379ea30a2af32bdf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2gQ83 = parcelRequire("2gQ83");

var $dsCiy = parcelRequire("dsCiy");

var $4Pf62 = parcelRequire("4Pf62");

var $7f4tk = parcelRequire("7f4tk");

var $pa9q9 = parcelRequire("pa9q9");
var $34Vv8 = parcelRequire("34Vv8");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $kAdLR = parcelRequire("kAdLR");

var $aYuZy = parcelRequire("aYuZy");

var $kwHgU = parcelRequire("kwHgU");

var $8HBuB = parcelRequire("8HBuB");

var $cvSAQ = parcelRequire("cvSAQ");

var $3Misg = parcelRequire("3Misg");

var $b4Qrh = parcelRequire("b4Qrh");

var $60DYE = parcelRequire("60DYE");

var $5GqLe = parcelRequire("5GqLe");
const $379ea30a2af32bdf$var$USER_PICKER_LIMIT = 20;
class $379ea30a2af32bdf$export$e980dfbc2840e8bc extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            shouldAutoDismissFlag: true,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onTriggerButtonClick: ()=>{}
        };
    }
    constructor(props){
        super(props), this.getOriginTracingInstance = ()=>new (0, $2gQ83.default)({
                product: this.props.productId
            }), this.loadUsers = async (searchText = '')=>{
            const searchTextEncoded = encodeURIComponent(searchText);
            const url = `/rest/api/3/groupuserpicker?maxResults=${$379ea30a2af32bdf$var$USER_PICKER_LIMIT}&query=${searchTextEncoded}&showAvatar=true&avatarSize=medium&excludeConnectAddons=true`;
            const groupsAndUsers = await (0, $7f4tk.default)(url);
            return groupsAndUsers.users.users.filter((user)=>user.accountType === 'atlassian').map((user)=>{
                const userData = {
                    type: 'user',
                    id: user.accountId,
                    name: user.displayName,
                    avatarUrl: user.avatarUrl
                };
                return userData;
            });
        }, this.showFlags = (flags)=>{
            const { flagService: flagService, shouldAutoDismissFlag: shouldAutoDismissFlag } = this.props;
            if (flagService?.showFlag) flags.forEach((flag)=>{
                flagService.showFlag({
                    type: flag.appearance,
                    title: flag.title.defaultMessage,
                    isAutoDismiss: shouldAutoDismissFlag,
                    messageId: `share-button.ui.share-view.showFlag.${flag.title.id}`,
                    messageType: 'transactional'
                });
            });
        }, this.cloudId = '';
        this.cloudId = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)().cloudId;
        if (props.legacyShareClientConfig !== undefined) this.legacyShareClient = new (0, $aYuZy.default)(props.legacyShareClientConfig);
    }
    render() {
        const { objectAri: objectAri, renderCustomTriggerButton: renderCustomTriggerButton, shareLink: shareLink, shareTitle: shareTitle, shareContentType: shareContentType, shareFormTitle: shareFormTitle, subProductId: subProductId, triggerButtonAppearance: triggerButtonAppearance = 'subtle', triggerButtonStyle: triggerButtonStyle, onTriggerButtonClick: onTriggerButtonClick, shareIntegrations: shareIntegrations, integrationMode: integrationMode = 'off', isAutoOpenDialog: isAutoOpenDialog, onDialogClose: onDialogClose, copyTooltipText: copyTooltipText, orgId: orgId, isBrowseUsersEnabled: isBrowseUsersEnabled, shareFormHelperMessage: shareFormHelperMessage, shareFieldsFooter: shareFieldsFooter, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, isOutgoingMailDisabled: isOutgoingMailDisabled, customHeader: customHeader, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, onSubmit: onSubmit, userRoles: userRoles = [], userRolesLoading: userRolesLoading } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsCiy.ShareDialogContainer), {
            shareClient: this.legacyShareClient,
            triggerButtonAppearance: triggerButtonAppearance,
            triggerButtonStyle: triggerButtonStyle,
            cloudId: this.cloudId,
            orgId: orgId,
            loadUserOptions: this.legacyShareClient && this.loadUsers,
            // @ts-expect-error - TS2322 - Type '() => OriginTracing' is not assignable to type 'OriginTracingFactory'.
            originTracingFactory: this.getOriginTracingInstance,
            productId: subProductId,
            renderCustomTriggerButton: renderCustomTriggerButton,
            shareAri: objectAri || (0, $kAdLR.createAri)(subProductId, this.cloudId),
            shareFormHelperMessage: shareFormHelperMessage,
            shareLink: shareLink,
            shareTitle: shareTitle,
            shareContentType: shareContentType,
            shareFormTitle: shareFormTitle,
            showFlags: this.showFlags,
            enableSmartUserPicker: !this.legacyShareClient,
            product: "jira",
            onTriggerButtonClick: onTriggerButtonClick,
            shareIntegrations: shareIntegrations,
            integrationMode: integrationMode,
            isAutoOpenDialog: isAutoOpenDialog,
            onDialogClose: onDialogClose,
            copyTooltipText: copyTooltipText,
            isBrowseUsersDisabled: isBrowseUsersEnabled === false,
            shareFieldsFooter: shareFieldsFooter,
            workspaceAri: this.props.workspaceAri,
            additionalTabs: additionalTabs,
            builtInTabContentWidth: builtInTabContentWidth,
            isSubmitShareDisabled: isOutgoingMailDisabled,
            customHeader: customHeader,
            isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
            additionalUserFields: isExtendedShareDialogEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8HBuB.UserRole), {
                roles: userRoles,
                isLoading: !!userRolesLoading
            }),
            CustomSubmitButton: isExtendedShareDialogEnabled ? (0, $b4Qrh.CustomShareSubmitButton) : undefined,
            onSubmit: onSubmit
        });
    }
}
const $379ea30a2af32bdf$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projectAccessLevelUpdated: {
        "id": "share-button.ui.share-view.project-access-level-updated.non-final",
        "defaultMessage": "Access updated"
    },
    errorUpdateProjectAccessLevel: {
        "id": "share-button.ui.share-view.error-update-project-access-level.non-final",
        "defaultMessage": "Error updating project access level"
    },
    errorAddingUsersToRole: {
        "id": "share-button.ui.share-view.error-adding-users-to-role.non-final",
        "defaultMessage": "Error adding users to role"
    }
});
const $379ea30a2af32bdf$var$noop = ()=>null;
const $379ea30a2af32bdf$var$ShareButtonFC = ({ objectAri: objectAri, triggerButtonAppearance: triggerButtonAppearance = 'subtle', onTriggerButtonClick: onTriggerButtonClick = $379ea30a2af32bdf$var$noop, integrationMode: integrationMode = 'off', isBrowseUsersEnabled: isBrowseUsersEnabled, isOutgoingMailDisabled: isOutgoingMailDisabled, legacyShareClientConfig: legacyShareClientConfig, shouldAutoDismissFlag: shouldAutoDismissFlag = false, onSubmit: onSubmit, userRoles: userRoles = [], userRolesLoading: userRolesLoading, accessLevel: accessLevel, ...props })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isExtendedShareDialogEnabled = (0, $cvSAQ.useIsExtendedShareDialogEnabled)();
    const legacyShareClient = (0, $5uXOq.useMemo)(()=>legacyShareClientConfig && new (0, $aYuZy.default)(legacyShareClientConfig), [
        legacyShareClientConfig
    ]);
    const getOriginTracingInstance = (0, $5uXOq.useCallback)(()=>{
        return new (0, $2gQ83.default)({
            product: 'jira'
        });
    }, []);
    const showFlags = (0, $5uXOq.useCallback)((flags)=>{
        if (showFlag) flags.forEach((flag)=>{
            showFlag({
                type: flag.appearance,
                title: flag.title.defaultMessage,
                isAutoDismiss: shouldAutoDismissFlag,
                messageId: `share-button.ui.share-view.showFlag.${flag.title.id}`,
                messageType: 'transactional'
            });
        });
    }, [
        showFlag,
        shouldAutoDismissFlag
    ]);
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { update: updateProjectAccessLevel, updateError: projectAccessLevelError } = (0, $3Misg.useProjectAccessLevel)();
    const { add: addToUserRole, updateError: useRoleError } = (0, $60DYE.useUserRole)(projectContext?.projectKey);
    (0, $5uXOq.useEffect)(()=>{
        if (projectAccessLevelError) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraUsersAndRoles.updateAccessType failed', 'changeAccessButton', {
                source: (0, $5GqLe.ANALYTICS_SOURCE),
                projectType: projectContext?.projectType,
                isTmp: true,
                error: projectAccessLevelError
            });
            showFlag({
                type: 'error',
                title: formatMessage($379ea30a2af32bdf$export$defe85febe8b728c.errorUpdateProjectAccessLevel),
                isAutoDismiss: shouldAutoDismissFlag,
                messageId: 'share-button.ui.share-view.show-flag.error.update-project-access-level',
                messageType: 'transactional'
            });
        }
    }, [
        projectAccessLevelError,
        formatMessage,
        showFlag,
        shouldAutoDismissFlag,
        createAnalyticsEvent,
        projectContext?.projectType
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (useRoleError) {
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraUsersAndRoles.addActorToRole failed', 'roleOption', {
                source: (0, $5GqLe.ANALYTICS_SOURCE),
                packageName: '@atlassian/jira-share-button',
                error: useRoleError
            });
            showFlag({
                type: 'error',
                title: formatMessage($379ea30a2af32bdf$export$defe85febe8b728c.errorAddingUsersToRole),
                isAutoDismiss: shouldAutoDismissFlag,
                messageId: 'share-button.ui.share-view.show-flag.error.adding-users-to-role.1',
                messageType: 'transactional'
            });
        }
    }, [
        useRoleError,
        formatMessage,
        showFlag,
        shouldAutoDismissFlag,
        createAnalyticsEvent
    ]);
    const handleOnSubmit = (0, $5uXOq.useCallback)((data)=>{
        if (isExtendedShareDialogEnabled) {
            if (data?.projectAccessLevel?.value && data?.projectAccessLevel?.value !== accessLevel) // We use `.then()` syntax here instead of changing the entire function to `async` to avoid blocking the user role updates below
            updateProjectAccessLevel({
                accessLevel: data?.projectAccessLevel.value
            }).then((response)=>{
                if (!response) return;
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'project updated', 'changeAccessButton', {
                    source: (0, $5GqLe.ANALYTICS_SOURCE),
                    projectType: projectContext?.projectType,
                    isTmp: true,
                    updatedItem: 'projectAccess',
                    accessLevel: data?.projectAccessLevel?.value
                });
                if (!data.users?.length) showFlag({
                    type: 'success',
                    title: formatMessage($379ea30a2af32bdf$export$defe85febe8b728c.projectAccessLevelUpdated),
                    isAutoDismiss: shouldAutoDismissFlag,
                    messageId: 'share-button.ui.share-view.show-flag.success.project-access-level-updated',
                    messageType: 'transactional'
                });
            });
            if (data.users?.length > 0 && data?.userRole?.value) {
                const { value: roleId, label: roleName } = data.userRole;
                const userIds = data.users.filter((user)=>user.type === 'user').map((user)=>user.id);
                const groupIds = data.users.filter((user)=>user.type === 'group').map((group)=>group.id);
                addToUserRole(roleId, {
                    users: userIds,
                    groups: groupIds
                }).then((response)=>{
                    if (!response) return;
                    (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'project updated', 'roleOption', {
                        source: (0, $5GqLe.ANALYTICS_SOURCE),
                        roleId: roleId,
                        roleName: roleName,
                        numberOfExistingUsersAdded: userIds.length,
                        numberOfExistingGroupsAdded: groupIds.length,
                        updatedItem: 'projectRole'
                    });
                });
            }
        }
        onSubmit && onSubmit(data);
    }, [
        isExtendedShareDialogEnabled,
        onSubmit,
        accessLevel,
        updateProjectAccessLevel,
        createAnalyticsEvent,
        projectContext?.projectType,
        showFlag,
        formatMessage,
        shouldAutoDismissFlag,
        addToUserRole
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dsCiy.ShareDialogContainer), {
        shareClient: legacyShareClient,
        cloudId: cloudId,
        loadUserOptions: legacyShareClient && (0, $kwHgU.loadUsers),
        // @ts-expect-error - TS2322 - Type '() => OriginTracing' is not assignable to type 'OriginTracingFactory'.
        originTracingFactory: getOriginTracingInstance,
        shareAri: objectAri || (0, $kAdLR.createAri)(props.subProductId, cloudId),
        showFlags: showFlags,
        enableSmartUserPicker: !legacyShareClient,
        product: "jira",
        isBrowseUsersDisabled: isBrowseUsersEnabled === false,
        isSubmitShareDisabled: isOutgoingMailDisabled,
        triggerButtonAppearance: triggerButtonAppearance,
        onTriggerButtonClick: onTriggerButtonClick,
        integrationMode: integrationMode,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        onSubmit: handleOnSubmit,
        CustomSubmitButton: isExtendedShareDialogEnabled ? (0, $b4Qrh.CustomShareSubmitButton) : undefined,
        additionalUserFields: isExtendedShareDialogEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8HBuB.UserRole), {
            accessLevel: accessLevel,
            roles: userRoles,
            isLoading: !!userRolesLoading
        }),
        ...props
    });
};
var $379ea30a2af32bdf$export$2e2bcd8739ae039 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jira-growth-share-button-refactor-fc'), $379ea30a2af32bdf$var$ShareButtonFC, (0, $az4zD.injectIntlV2)((0, $34Vv8.default)($379ea30a2af32bdf$export$e980dfbc2840e8bc)));

});
parcelRegister("dsCiy", function(module, exports) {

$parcel$export(module.exports, "ShareDialogContainer", () => $dd0122880035a80e$export$78b28896b43ae5d6);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1SBaA = parcelRequire("1SBaA");

var $8QpSo = parcelRequire("8QpSo");

var $ousew = parcelRequire("ousew");

var $3joPi = parcelRequire("3joPi");

var $cb25w = parcelRequire("cb25w");

var $VSDnB = parcelRequire("VSDnB");

var $9b5JR = parcelRequire("9b5JR");

var $inlXa = parcelRequire("inlXa");

var $idKBS = parcelRequire("idKBS");

var $b2oBK = parcelRequire("b2oBK");

var $hQWyD = parcelRequire("hQWyD");

var $65uFp = parcelRequire("65uFp");

var $2sAb4 = parcelRequire("2sAb4");

var $7ZU6o = parcelRequire("7ZU6o");

var $7v5Ga = parcelRequire("7v5Ga");

var $4gTjW = parcelRequire("4gTjW");
const $dd0122880035a80e$var$COPY_LINK_EVENT = (0, $b2oBK.copyLinkButtonClicked)({
    start: 0
});
const $dd0122880035a80e$export$f84bd70098573c5c = {
    disableSharingToEmails: false
};
const $dd0122880035a80e$var$memoizedFormatCopyLink = (0, $8QpSo.default)((origin, link)=>origin.addToUrl(link));
function $dd0122880035a80e$var$getCurrentPageUrl() {
    return window.location.href;
}
class $dd0122880035a80e$export$bc8c417f2da43f4 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = {
            enableSmartUserPicker: false,
            shareeAction: 'view',
            product: 'confluence'
        };
    }
    constructor(props){
        super(props), this._isMounted = false, this._urlShorteningRequestCounter = 0, this._lastUrlShorteningWasTooSlow = false, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $b2oBK.CHANNEL_ID));
        }, this.fetchConfig = ()=>{
            this.setState({
                isFetchingConfig: true
            }, async ()=>{
                try {
                    (0, $65uFp.renderShareDialogExp).start();
                    const config = await this.shareClient.getConfig(this.props.cloudId);
                    if (this._isMounted) this.setState({
                        config: config,
                        isFetchingConfig: false
                    });
                    (0, $65uFp.renderShareDialogExp).success();
                } catch (error) {
                    if (this._isMounted) this.setState({
                        config: $dd0122880035a80e$export$f84bd70098573c5c,
                        isFetchingConfig: false
                    });
                    let { ...errObj } = error;
                    if (error instanceof Error) errObj = {
                        ...errObj,
                        className: error.constructor.name
                    };
                    (0, $hQWyD.isValidFailedExperience)((0, $65uFp.renderShareDialogExp), errObj);
                }
            });
        }, this.handleSubmitShare = ({ users: users, comment: comment, ...rest })=>{
            const shareLink = this.getFormShareLink();
            const { productId: productId, shareAri: shareAri, shareContentType: shareContentType, shareTitle: shareTitle, shareeAction: shareeAction, workspaceAri: workspaceAri, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled } = this.props;
            const content = {
                ari: shareAri,
                link: shareLink,
                title: shareTitle,
                type: shareContentType,
                workspaceAri: workspaceAri
            };
            const metaData = {
                productId: productId,
                atlOriginId: this.getFormShareOriginTracing().id,
                shareeAction: shareeAction
            };
            this.props.onSubmit?.({
                users: users,
                comment: comment,
                ...rest
            });
            if (isExtendedShareDialogEnabled && users.length === 0) return Promise.resolve();
            return this.shareClient.share(content, (0, $4gTjW.optionDataToUsers)(users), metaData, comment).then(()=>{
                if (!this._isMounted) return;
                // renew Origin Tracing Id per share action succeeded
                this.setState((state)=>({
                        shareActionCount: state.shareActionCount + 1
                    }));
            });
        }, this.handleDialogOpen = async ()=>{
            if (this.props.onDialogOpen) this.props.onDialogOpen();
            this.setState({
                currentPageUrl: $dd0122880035a80e$var$getCurrentPageUrl()
            }, ()=>{
                this.updateShortCopyLink();
            });
            // always refetch the config when modal is re-opened
            this.fetchConfig();
        }, this.decorateAnalytics = (payload)=>{
            if (payload.type === $dd0122880035a80e$var$COPY_LINK_EVENT.type && payload.action === $dd0122880035a80e$var$COPY_LINK_EVENT.action && payload.actionSubjectId === $dd0122880035a80e$var$COPY_LINK_EVENT.actionSubjectId) {
                const isCopyLinkShortened = !!this.getShortenedCopyLink();
                payload = {
                    ...payload,
                    attributes: {
                        ...payload.attributes,
                        shortUrl: isCopyLinkShortened
                    }
                };
                if (this.shouldShortenCopyLink() && !isCopyLinkShortened) this._lastUrlShorteningWasTooSlow = true;
            }
            return payload;
        }, // ensure origin is re-generated if the link or the factory changes
        // separate memoization is needed since copy != form
        this.getUniqueCopyLinkOriginTracing = (0, $8QpSo.default)((link, originTracingFactory)=>{
            return originTracingFactory();
        }), // form origin must furthermore be regenerated after each form share
        this.getUniqueFormShareOriginTracing = (0, $8QpSo.default)((link, originTracingFactory, shareCount)=>{
            return originTracingFactory();
        }), this.getUpToDateShortenedCopyLink = (0, $8QpSo.default)((data, originId)=>{
            this._lastUrlShorteningWasTooSlow = false;
            this._urlShorteningRequestCounter++;
            this.createAndFireEvent((0, $b2oBK.shortUrlRequested)());
            const start = Date.now();
            return this.urlShortenerClient.shorten({
                ...data,
                originId: originId
            }).then((response)=>{
                this.createAndFireEvent((0, $b2oBK.shortUrlGenerated)(start, this._lastUrlShorteningWasTooSlow));
                return response.shortUrl;
            }).catch(()=>{
                this.createAndFireEvent((0, $b2oBK.errorEncountered)('urlShortening'));
                return null;
            });
        }, (0, (/*@__PURE__*/$parcel$interopDefault($1SBaA)))), this.getFormShareLink = ()=>{
            // original share link is used here
            return this.getRawLink();
        };
        // v0.4 -> v0.5 .client -> .shareClient
        (0, $3joPi.default)(!props.client, 'elements/share: Breaking change, please update your props!');
        this.shareClient = props.shareClient || new (0, $inlXa.ShareServiceClient)();
        this.urlShortenerClient = props.urlShortenerClient || new (0, $9b5JR.AtlassianUrlShortenerClient)();
        this.state = {
            shareActionCount: 0,
            config: $dd0122880035a80e$export$f84bd70098573c5c,
            isFetchingConfig: false,
            currentPageUrl: $dd0122880035a80e$var$getCurrentPageUrl(),
            shortenedCopyLink: null
        };
    }
    componentDidMount() {
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    componentDidUpdate(prevProps) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($1SBaA)))(prevProps.shortLinkData, this.props.shortLinkData)) this.updateShortCopyLink();
    }
    getRawLink() {
        const { shareLink: shareLink } = this.props;
        const { currentPageUrl: currentPageUrl } = this.state;
        return shareLink || currentPageUrl;
    }
    getCopyLinkOriginTracing() {
        const { originTracingFactory: originTracingFactory } = this.props;
        const shareLink = this.getRawLink();
        return this.getUniqueCopyLinkOriginTracing(shareLink, originTracingFactory);
    }
    getFormShareOriginTracing() {
        const { originTracingFactory: originTracingFactory } = this.props;
        const { shareActionCount: shareActionCount } = this.state;
        const shareLink = this.getRawLink();
        return this.getUniqueFormShareOriginTracing(shareLink, originTracingFactory, shareActionCount);
    }
    getFullCopyLink() {
        const { formatCopyLink: formatCopyLink } = this.props;
        const shareLink = this.getRawLink();
        const copyLinkOrigin = this.getCopyLinkOriginTracing();
        return (formatCopyLink || $dd0122880035a80e$var$memoizedFormatCopyLink)(copyLinkOrigin, shareLink);
    }
    shouldShortenCopyLink() {
        return !!this.props.shortLinkData || !!this.props.useUrlShortener;
    }
    getShortenedCopyLink() {
        return this.shouldShortenCopyLink() && this.state.shortenedCopyLink || undefined;
    }
    getCopyLink() {
        return this.getShortenedCopyLink() || this.getFullCopyLink();
    }
    updateShortCopyLink() {
        this.setState({
            shortenedCopyLink: null
        });
        const { shortLinkData: shortLinkData } = this.props;
        if (!shortLinkData) return;
        const originId = this.getCopyLinkOriginTracing().id;
        const shortLink = this.getUpToDateShortenedCopyLink(shortLinkData, originId);
        const requestCounter = this._urlShorteningRequestCounter;
        shortLink.then((shortenedCopyLink)=>{
            if (!this._isMounted) return;
            const isRequestOutdated = requestCounter !== this._urlShorteningRequestCounter;
            if (isRequestOutdated) return;
            this.setState({
                shortenedCopyLink: shortenedCopyLink
            });
        });
    }
    render() {
        const { cloudId: cloudId, orgId: orgId, isAutoOpenDialog: isAutoOpenDialog, dialogPlacement: dialogPlacement, loadUserOptions: loadUserOptions, renderCustomTriggerButton: renderCustomTriggerButton, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, shouldCloseOnEscapePress: shouldCloseOnEscapePress, showFlags: showFlags, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, triggerButtonAppearance: triggerButtonAppearance, triggerButtonIcon: triggerButtonIcon, triggerButtonStyle: triggerButtonStyle, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, bottomMessage: bottomMessage, shareeAction: shareeAction, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, onTriggerButtonClick: onTriggerButtonClick, onUserSelectionChange: onUserSelectionChange, shareFieldsFooter: shareFieldsFooter, isCopyDisabled: isCopyDisabled, isPublicLink: isPublicLink, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, shareAri: shareAri, tabIndex: tabIndex, copyTooltipText: copyTooltipText, onDialogClose: onDialogClose, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const { config: config, isFetchingConfig: isFetchingConfig } = this.state;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2sAb4.default), {
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7ZU6o.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7v5Ga.ShareDialogWithTrigger), {
                    onTriggerButtonClick: onTriggerButtonClick,
                    isAutoOpenDialog: isAutoOpenDialog,
                    config: config,
                    isFetchingConfig: isFetchingConfig,
                    copyLink: this.getCopyLink(),
                    analyticsDecorator: this.decorateAnalytics,
                    dialogPlacement: dialogPlacement,
                    loadUserOptions: loadUserOptions,
                    onDialogOpen: this.handleDialogOpen,
                    onShareSubmit: this.handleSubmitShare,
                    renderCustomTriggerButton: renderCustomTriggerButton,
                    shareContentType: shareContentType,
                    shareContentSubType: shareContentSubType,
                    shareContentId: shareContentId,
                    shareFormTitle: shareFormTitle,
                    shareFormHelperMessage: shareFormHelperMessage,
                    copyLinkOrigin: this.getCopyLinkOriginTracing(),
                    formShareOrigin: this.getFormShareOriginTracing(),
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress,
                    showFlags: showFlags,
                    enableSmartUserPicker: enableSmartUserPicker,
                    loggedInAccountId: loggedInAccountId,
                    cloudId: cloudId,
                    orgId: orgId,
                    triggerButtonAppearance: triggerButtonAppearance,
                    triggerButtonIcon: triggerButtonIcon,
                    triggerButtonStyle: triggerButtonStyle,
                    triggerButtonTooltipPosition: triggerButtonTooltipPosition,
                    triggerButtonTooltipText: triggerButtonTooltipText,
                    bottomMessage: bottomMessage,
                    submitButtonLabel: shareeAction === 'edit' && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                        ...(0, $idKBS.messages).inviteTriggerButtonText
                    }),
                    product: product,
                    productAttributes: productAttributes,
                    customHeader: (0, $VSDnB.fg)('platform_share_custom_header_prop') && customHeader,
                    customFooter: customFooter,
                    onUserSelectionChange: onUserSelectionChange,
                    shareFieldsFooter: shareFieldsFooter,
                    isCopyDisabled: isCopyDisabled,
                    isPublicLink: isPublicLink,
                    integrationMode: integrationMode,
                    shareIntegrations: shareIntegrations,
                    shareAri: shareAri,
                    tabIndex: tabIndex,
                    copyTooltipText: copyTooltipText,
                    onDialogClose: onDialogClose,
                    isBrowseUsersDisabled: isBrowseUsersDisabled,
                    userPickerOptions: userPickerOptions,
                    additionalTabs: additionalTabs,
                    builtInTabContentWidth: builtInTabContentWidth,
                    isSubmitShareDisabled: isSubmitShareDisabled,
                    additionalUserFields: additionalUserFields,
                    isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                    CustomSubmitButton: CustomSubmitButton
                })
            })
        });
    }
}
const $dd0122880035a80e$export$78b28896b43ae5d6 = (0, $cb25w.default)()($dd0122880035a80e$export$bc8c417f2da43f4);

});
parcelRegister("1SBaA", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("9b5JR", function(module, exports) {

$parcel$export(module.exports, "AtlassianUrlShortenerClient", () => $db8e8ad360042aaf$export$8fed7002650b52ef);
class $db8e8ad360042aaf$export$8fed7002650b52ef {
    async shorten(data) {
        try {
            const response = await fetch('/gateway/api/atl-link/create', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });
            if (!response.ok) throw new Error(`status="${response.status}"`);
            const result = await response.json();
            if (!result.shortUrl) throw new Error('Breach of contract!');
            return result;
        } catch (err) {
            if (err instanceof Error) err.message = `While shortening URL: ${err.message}!`;
            throw err;
        }
    }
}

});

parcelRegister("inlXa", function(module, exports) {

$parcel$export(module.exports, "ShareServiceClient", () => $17bc358e1d85e6d0$export$ee05f3e1f0248b62);

var $dS9cn = parcelRequire("dS9cn");
const $17bc358e1d85e6d0$export$a7d7a4246bdd7a12 = 'share';
const $17bc358e1d85e6d0$export$1a440d9a41e6ce3e = 'share/configuration';
const $17bc358e1d85e6d0$export$7745139d0aa6183c = '/gateway/api';
class $17bc358e1d85e6d0$export$ee05f3e1f0248b62 {
    constructor(serviceConfig){
        this.serviceConfig = {
            url: $17bc358e1d85e6d0$export$7745139d0aa6183c,
            ...serviceConfig || {}
        };
    }
    getConfig(cloudId) {
        const options = {
            path: $17bc358e1d85e6d0$export$1a440d9a41e6ce3e,
            queryParams: {
                cloudId: cloudId
            },
            requestInit: {
                method: 'get'
            }
        };
        return (0, $dS9cn.utils).requestService(this.serviceConfig, options);
    }
    /**
	 * To send a POST request to the share endpoint in Share service
	 */ share(content, recipients, metadata, comment) {
        return fetch(`${this.serviceConfig.url}/${$17bc358e1d85e6d0$export$a7d7a4246bdd7a12}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json; charset=UTF-8'
            },
            credentials: 'include',
            body: JSON.stringify({
                content: content,
                recipients: recipients,
                metadata: metadata,
                comment: comment
            })
        }).then((response)=>{
            if (response.status === 204) return Promise.resolve();
            else if (response.ok) return response.json();
            else return Promise.reject({
                code: response.status,
                reason: response.statusText,
                body: response.json()
            });
        });
    }
}

});

parcelRegister("idKBS", function(module, exports) {

$parcel$export(module.exports, "messages", () => $990cec53807f67a0$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $990cec53807f67a0$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    formTitle: {
        id: 'fabric.elements.share.form.title',
        defaultMessage: 'Share',
        description: 'Title for Share form.'
    },
    formSend: {
        id: 'fabric.elements.share.form.send',
        defaultMessage: 'Send',
        description: 'Label for Share form submit button.'
    },
    formShare: {
        id: 'fabric.elements.share.form.share',
        defaultMessage: 'Share',
        description: 'Label for Share form submit button.'
    },
    formSendPublic: {
        id: 'fabric.elements.share.form.public.send',
        defaultMessage: 'Send public link',
        description: 'Label for Share form submit button when link is public.'
    },
    formSharePublic: {
        id: 'fabric.elements.share.form.public.share',
        defaultMessage: 'Share public link',
        description: 'Label for Share form submit button when link is public.'
    },
    formRetry: {
        id: 'fabric.elements.share.form.retry',
        defaultMessage: 'Retry',
        description: 'Label for Share from retry button.'
    },
    formNoPermissions: {
        id: 'fabric.elements.share.form.no-permissions',
        defaultMessage: 'You do not have the ability to share.',
        description: 'Copy to show when a user can not share.'
    },
    commentLabel: {
        id: 'fabric.elements.share.form.comment.label',
        defaultMessage: 'Message (optional)',
        description: 'Label for the comment field in the Share form.'
    },
    extendedDialogCommentLabel: {
        id: 'fabric.elements.share.form.extended.dialog.comment.label',
        defaultMessage: 'Message',
        description: 'Label for the comment field in the extended share dialog.'
    },
    commentPlaceholder: {
        id: 'fabric.elements.share.form.comment.placeholder',
        defaultMessage: 'Anything they should know?',
        description: 'Placeholder for the comment field in Share form.'
    },
    // Email disabled (Jira)
    userPickerLabelEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.label.email-disabled-jira',
        defaultMessage: 'Names or teams',
        description: 'Label for the user picker field in the Share form in Jira with no email option.'
    },
    userPickerPlaceholderEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira',
        defaultMessage: 'e.g. Maria, Team Orange',
        description: 'Placeholder for the user picker field in the Share form in Jira with no email option. These examples should be localized.'
    },
    userPickerRequiredMessageEmailDisabledJira: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira',
        defaultMessage: 'Select at least one person or team',
        description: 'Error message for the user picker field in the Share form in Jira with no email option, when no entries are selected.'
    },
    // Email disabled (Confluence)
    userPickerLabelEmailDisabledConfluence: {
        id: 'fabric.elements.share.form.user-picker.label.email-disabled-confluence',
        defaultMessage: 'Names, teams, or groups',
        description: 'Label for the user picker field in the Share form in Confluence with no email option.'
    },
    userPickerRequiredMessageEmailDisabledConfluence: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence',
        defaultMessage: 'Select at least one person, team, or group',
        description: 'Error message for the user picker field in the Share form in Confluence with no email option, when no entries are selected.'
    },
    // Browse users disabled
    userPickerLabelBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.label.email-only',
        defaultMessage: 'Emails',
        description: 'Label for the user picker field in the Share form when browse user permissions are disabled.'
    },
    userPickerPlaceholderBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.placeholder.email-only',
        defaultMessage: 'e.g. maria@company.com',
        description: 'Placeholder for the user picker field in the Share form when browse user permissions are disabled. These examples should be localized.'
    },
    userPickerRequiredMessageBrowseUsersDisabled: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.email-only',
        defaultMessage: 'Select at least one email',
        description: 'Error message for the user picker field in the Share form in when browse user permissions are disabled, when no entries are selected.'
    },
    // Generic (Jira)
    userPickerLabelJira: {
        id: 'fabric.elements.share.form.user-picker.label.jira',
        defaultMessage: 'Names, teams, or emails',
        description: 'Label for the user picker field in the Share form in Jira.'
    },
    userPickerPlaceholderJira: {
        id: 'fabric.elements.share.form.user-picker.placeholder.jira',
        defaultMessage: 'e.g. Maria, Team Orange, maria@company.com',
        description: 'Placeholder for the user picker field in the Share form in Jira. These examples should be localized.'
    },
    userPickerRequiredMessageJira: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.jira',
        defaultMessage: 'Select at least one person, team, or email',
        description: 'Error message for the user picker field in the Share form in Jira, when no entries are selected.'
    },
    // Generic (Confluence)
    userPickerLabelConfluence: {
        id: 'fabric.elements.share.form.user-picker.label.confluence',
        defaultMessage: 'Names, teams, groups, or emails',
        description: 'Label for the user picker field in the Share form in Confluence.'
    },
    userPickerPlaceholderConfluence: {
        id: 'fabric.elements.share.form.user-picker.placeholder.confluence',
        defaultMessage: 'e.g. Maria, Team Orange, group-one',
        description: 'Placeholder for the user picker field in the Share form in Confluence. These examples should be localized.'
    },
    userPickerRequiredMessageConfluence: {
        id: 'fabric.elements.share.form.user-picker.validation.required-message.confluence',
        defaultMessage: 'Select at least one person, team, group, or email',
        description: 'Error message for the user picker field in the Share form in Confluence, when no entries are selected.'
    },
    // Common messages
    userPickerAddMoreMessage: {
        id: 'fabric.elements.share.form.user-picker.add-more',
        defaultMessage: 'Enter more',
        description: 'Message to encourage the user to add more items to user picker in Share form.'
    },
    userPickerRequiredMessage: {
        id: 'fabric.elements.share.form.user-picker.validation.required',
        defaultMessage: 'Select at least one user, group, team or email.',
        description: 'Required error message for the user picker field in Share form.'
    },
    userPickerExistingUserOnlyNoOptionsMessage: {
        id: 'fabric.elements.share.form.user-picker.no-options.existingUserOnly',
        defaultMessage: `We couldn\u{2019}t find any results for "{inputValue}".`,
        description: 'Existing user only no options message displayed when the search for users returns empty.'
    },
    userPickerGenericNoOptionsMessage: {
        id: 'fabric.elements.share.form.user-picker.no-options.generic',
        defaultMessage: `We couldn\u{2019}t find any results for "{inputValue}". Invite people by using an email address.`,
        description: 'Generic no options message displayed when the search for users returns empty.'
    },
    shareTriggerButtonIconLabel: {
        id: 'fabric.elements.share.trigger.button.icon.label',
        defaultMessage: 'Share icon',
        description: 'Default text for aria-label of the share dialog trigger button icon'
    },
    shareTriggerButtonText: {
        id: 'fabric.elements.share.trigger.button.text',
        defaultMessage: 'Share',
        description: 'Default text for the share dialog trigger button'
    },
    shareTriggerButtonTooltipText: {
        id: 'fabric.elements.share.trigger.button.tooltip.text',
        defaultMessage: 'Share',
        description: 'Default text for tooltip on the icon-only share dialog trigger button'
    },
    inviteTriggerButtonText: {
        id: 'fabric.elements.share.trigger.button.invite.text',
        defaultMessage: 'Invite',
        description: 'Button label for when the sharee action is set to "edit".'
    },
    copyLinkButtonText: {
        id: 'fabric.elements.share.copylink.button.text',
        defaultMessage: 'Copy link',
        description: 'Default text for the Copy Link button'
    },
    copyPublicLinkButtonText: {
        id: 'fabric.elements.share.copypubliclink.button.text',
        defaultMessage: 'Copy public link',
        description: 'Default text for the Copy Link button when the link is public'
    },
    copiedToClipboardMessage: {
        id: 'fabric.elements.share.copied.to.clipboard.message',
        defaultMessage: 'Link copied to clipboard',
        description: 'Default text for the copied link message'
    },
    infoMessageDefaultConfluence: {
        id: 'fabric.elements.share.form.info.message.no.invite.confluence',
        defaultMessage: 'Recipients will see the name of the page and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Confluence page title and the included message'
    },
    infoMessageDefaultJira: {
        id: 'fabric.elements.share.form.info.message.no.invite.jira',
        defaultMessage: 'Recipients will see the name of the issue and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Jira issue title and the included message'
    },
    infoMessageDefaultJiraIssueTermRefresh: {
        id: 'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh',
        defaultMessage: 'Recipients will see the name of the work item and your message',
        description: 'Message indicating the recipients of the email share will be able to see the Jira issue title and the included message'
    },
    requiredFieldSummary: {
        id: 'fabric.elements.share.form.required-field.summary',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Summary info of required fields asterisk.'
    },
    shareFailureIconLabel: {
        id: 'fabric.elements.share.failure.icon.label',
        defaultMessage: 'Error icon',
        description: 'Default text for the aria-label of the share failure error icon in the tooltip'
    },
    shareFailureMessage: {
        id: 'fabric.elements.share.failure.message',
        defaultMessage: 'Unable to share',
        description: 'Default text for share failure message displayed in the tooltip'
    },
    shareSuccessMessage: {
        id: 'fabric.elements.share.success.message',
        defaultMessage: "{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}",
        description: 'Default text for share success message displayed in a flag'
    },
    shareToIntegrationButtonText: {
        id: 'fabric.elements.share.to.integration.button',
        defaultMessage: 'Share to {integrationName}',
        description: 'Text for the button that allows the user to share the currently viewed item through a 3rd party app like Slack'
    },
    shareInIntegrationButtonText: {
        id: 'fabric.elements.share.in.integration.button',
        defaultMessage: 'Share in {integrationName}',
        description: 'Text for the button that allows the user to share the currently viewed item through a 3rd party app like Slack'
    },
    shareMainTabTextJira: {
        id: 'fabric.elements.share.main.tab.text.jira',
        defaultMessage: 'Share issue',
        description: 'Text for the main share tab for jira'
    },
    shareMainTabTextConfluence: {
        id: 'fabric.elements.share.main.tab.text.confluence',
        defaultMessage: 'Share page',
        description: 'Text for the main share tab for confluence'
    },
    inviteToConfluence: {
        id: 'fabric.elements.share.invite.to.confluence',
        defaultMessage: 'Invite to Confluence',
        description: 'Text for the byline of the non-licensed users'
    },
    inviteToJira: {
        id: 'fabric.elements.share.invite.to.jira',
        defaultMessage: 'Invite to Jira',
        description: 'Text for the byline of the non-licensed users'
    },
    sharePopupLabel: {
        id: 'fabric.elements.share.popup.label',
        defaultMessage: 'Share',
        description: 'Label of the popup that contains share menu used by assistive technologies'
    },
    slackMenuItemText: {
        id: 'fabric.elements.share.menu.slack.label',
        defaultMessage: 'Slack',
        description: 'Text for the slack menu in share'
    },
    emailMenuItemText: {
        id: 'fabric.elements.share.menu.email.label',
        defaultMessage: 'Email',
        description: 'Text for the email menu in share'
    }
});

});

parcelRegister("b2oBK", function(module, exports) {

$parcel$export(module.exports, "CHANNEL_ID", () => $5f90f772f4877396$export$e5fd2b76433ec8a8);
$parcel$export(module.exports, "ANALYTICS_SOURCE", () => $5f90f772f4877396$export$f7109619a5e9e0d6);
$parcel$export(module.exports, "INTEGRATION_MODAL_SOURCE", () => $5f90f772f4877396$export$8944b0a832f27e18);
$parcel$export(module.exports, "screenEvent", () => $5f90f772f4877396$export$a129deea0412e0d8);
$parcel$export(module.exports, "shareSplitButtonEvent", () => $5f90f772f4877396$export$eab30ffadcd0ab75);
$parcel$export(module.exports, "shareIntegrationButtonEvent", () => $5f90f772f4877396$export$f04d85d45801fef1);
$parcel$export(module.exports, "errorEncountered", () => $5f90f772f4877396$export$afe83ea4a1997503);
$parcel$export(module.exports, "shareTriggerButtonClicked", () => $5f90f772f4877396$export$584e8ee8b04ff145);
$parcel$export(module.exports, "shareTabClicked", () => $5f90f772f4877396$export$544b588ba577a9a6);
$parcel$export(module.exports, "shareMenuItemClicked", () => $5f90f772f4877396$export$69ab8fd7ab99f6db);
$parcel$export(module.exports, "cancelShare", () => $5f90f772f4877396$export$b4731c87331a8174);
$parcel$export(module.exports, "shortUrlRequested", () => $5f90f772f4877396$export$35781a2d50f9fba9);
$parcel$export(module.exports, "shortUrlGenerated", () => $5f90f772f4877396$export$e78d65558f8d859a);
$parcel$export(module.exports, "copyLinkButtonClicked", () => $5f90f772f4877396$export$9af471d00b79f9b0);
$parcel$export(module.exports, "formShareSubmitted", () => $5f90f772f4877396$export$e2e6cacbe383cb80);

var $3smIt = parcelRequire("3smIt");
const $5f90f772f4877396$var$buildAttributes = (attributes = {})=>({
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        ...attributes
    });
const $5f90f772f4877396$var$createEvent = (eventType, source, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        source: source,
        attributes: $5f90f772f4877396$var$buildAttributes(attributes)
    });
const $5f90f772f4877396$var$createScreenEvent = (name, attributes = {})=>({
        eventType: 'screen',
        name: name,
        attributes: $5f90f772f4877396$var$buildAttributes(attributes)
    });
const $5f90f772f4877396$export$e5fd2b76433ec8a8 = 'fabric-elements';
const $5f90f772f4877396$export$f7109619a5e9e0d6 = 'shareModal';
const $5f90f772f4877396$export$8944b0a832f27e18 = 'integrationShareDialog';
const $5f90f772f4877396$export$a129deea0412e0d8 = ({ isPublicLink: isPublicLink = false })=>$5f90f772f4877396$var$createScreenEvent($5f90f772f4877396$export$f7109619a5e9e0d6, {
        isPublicLink: isPublicLink
    });
const $5f90f772f4877396$export$eab30ffadcd0ab75 = ()=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$8944b0a832f27e18, 'clicked', 'button', 'shareSplitButton');
const $5f90f772f4877396$export$f04d85d45801fef1 = (type = '')=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$8944b0a832f27e18, 'clicked', 'button', 'shareToIntegration', {
        integrationType: type.toLowerCase()
    });
const $5f90f772f4877396$export$afe83ea4a1997503 = (actionSubjectId, attributes = {})=>$5f90f772f4877396$var$createEvent('operational', $5f90f772f4877396$export$f7109619a5e9e0d6, 'encountered', 'error', actionSubjectId, {
        ...attributes,
        source: $5f90f772f4877396$export$f7109619a5e9e0d6
    });
const $5f90f772f4877396$export$584e8ee8b04ff145 = ()=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'button', 'share');
const $5f90f772f4877396$export$544b588ba577a9a6 = (subjectId, shareContentType)=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'tab', subjectId || 'shareTab', {
        shareContentType: shareContentType
    });
const $5f90f772f4877396$export$69ab8fd7ab99f6db = (subjectId, shareContentType)=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'menuItem', subjectId || 'shareMenuItem', {
        shareContentType: shareContentType
    });
const $5f90f772f4877396$export$b4731c87331a8174 = (start)=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'pressed', 'keyboardShortcut', 'cancelShare', {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6,
        duration: $5f90f772f4877396$var$duration(start)
    });
const $5f90f772f4877396$export$35781a2d50f9fba9 = ()=>$5f90f772f4877396$var$createEvent('operational', $5f90f772f4877396$export$f7109619a5e9e0d6, 'requested', 'shortUrl', undefined, {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6
    });
const $5f90f772f4877396$export$e78d65558f8d859a = (start, tooSlow)=>$5f90f772f4877396$var$createEvent('operational', $5f90f772f4877396$export$f7109619a5e9e0d6, 'generated', 'shortUrl', undefined, {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6,
        duration: $5f90f772f4877396$var$duration(start),
        tooSlow: tooSlow
    });
const $5f90f772f4877396$export$9af471d00b79f9b0 = ({ start: start, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false, ari: ari })=>$5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'button', 'copyShareLink', {
        source: $5f90f772f4877396$export$f7109619a5e9e0d6,
        duration: $5f90f772f4877396$var$duration(start),
        shortUrl: undefined,
        // unknown at creation, will be filled later
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        isPublicLink: isPublicLink,
        ari: ari,
        // this specific string is needed for marking a successful navigation session
        navdexPointType: 'navigationSessionEnd',
        ...$5f90f772f4877396$var$getOriginTracingAttributes(shareOrigin)
    });
const $5f90f772f4877396$export$e2e6cacbe383cb80 = ({ start: start, data: data, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, shareOrigin: shareOrigin, isPublicLink: isPublicLink = false })=>{
    const users = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isUser));
    const externalUsers = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isExternalUser));
    const groups = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isGroup));
    const teams = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isTeam));
    const teamUserCounts = $5f90f772f4877396$var$extractMemberCountsFromTeams(data, (0, $3smIt.isTeam));
    const emails = $5f90f772f4877396$var$extractIdsByType(data, (0, $3smIt.isEmail));
    return $5f90f772f4877396$var$createEvent('ui', $5f90f772f4877396$export$f7109619a5e9e0d6, 'clicked', 'button', 'submitShare', {
        ...$5f90f772f4877396$var$getOriginTracingAttributes(shareOrigin),
        contentType: shareContentType,
        contentSubType: shareContentSubType,
        contentId: shareContentId,
        duration: $5f90f772f4877396$var$duration(start),
        emailCount: emails.length,
        teamCount: teams.length,
        userCount: users.length,
        groupCount: groups.length,
        externalUserCount: externalUsers.length,
        users: users,
        teams: teams,
        teamUserCounts: teamUserCounts,
        groups: groups,
        messageLength: data.comment && data.comment.format === 'plain_text' ? data.comment.value.length : 0,
        isMessageEnabled: true,
        isPublicLink: isPublicLink
    });
};
const $5f90f772f4877396$var$duration = (start)=>Date.now() - start;
const $5f90f772f4877396$var$getOriginTracingAttributes = (origin)=>origin ? origin.toAnalyticsAttributes({
        hasGeneratedId: true
    }) : {};
const $5f90f772f4877396$var$extractIdsByType = (data, checker)=>data.users.filter(checker).map((option)=>option.id);
const $5f90f772f4877396$var$extractMemberCountsFromTeams = (data, checker)=>// teams with zero memberships cannot exist in share, so we use that
    // as the default value for undefined team member counts
    data.users.filter(checker).map((option)=>option.memberCount || 0);

});

parcelRegister("hQWyD", function(module, exports) {

$parcel$export(module.exports, "isValidFailedExperience", () => $4557ff6e37d018ec$export$883079293b9cad76);
const $4557ff6e37d018ec$var$ignoredErrorStatusCode = [
    401,
    403,
    429
];
const $4557ff6e37d018ec$export$883079293b9cad76 = (experience, // the type for error is 'any' because consumers of the share config can pass in custom error objects
error)=>{
    const errorStatusCode = error.code || error.status || error.statusCode;
    if ($4557ff6e37d018ec$var$ignoredErrorStatusCode.includes(parseInt(errorStatusCode))) {
        experience.abort({
            metadata: {
                error: error
            }
        });
        return;
    }
    experience.failure({
        metadata: {
            error: error
        }
    });
};

});

parcelRegister("65uFp", function(module, exports) {

$parcel$export(module.exports, "renderShareDialogExp", () => $8388968bcc7a2bcd$export$99c0383421ae57eb);
$parcel$export(module.exports, "shareSubmitExp", () => $8388968bcc7a2bcd$export$31627ee726f40567);

var $7Zbvr = parcelRequire("7Zbvr");
var $boHLC = parcelRequire("boHLC");
const $8388968bcc7a2bcd$export$99c0383421ae57eb = new (0, $boHLC.UFOExperience)('render-share-dialog', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});
const $8388968bcc7a2bcd$export$31627ee726f40567 = new (0, $boHLC.UFOExperience)('share-submit-action', {
    type: (0, $7Zbvr.ExperienceTypes).Experience,
    performanceType: (0, $7Zbvr.ExperiencePerformanceTypes).InlineResult,
    platform: {
        component: 'people'
    }
});

});

parcelRegister("2sAb4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d485dd997db54c76$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $b2oBK = parcelRequire("b2oBK");
// ErrorBoundary does not support in functional component
// eslint-disable-next-line @repo/internal/react/no-class-components
class $d485dd997db54c76$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidCatch(error) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) createAnalyticsEvent((0, $b2oBK.errorEncountered)(undefined, {
            message: error.message,
            errorClass: error.name
        })).fire((0, $b2oBK.CHANNEL_ID));
        this.setState({
            hasError: true
        });
    }
    render() {
        const { hasError: hasError } = this.state;
        if (hasError) // Silently fail.
        return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false
        };
    }
}
var $d485dd997db54c76$export$2e2bcd8739ae039 = (0, $cb25w.default)()($d485dd997db54c76$var$ErrorBoundary);

});

parcelRegister("7ZU6o", function(module, exports) {

$parcel$export(module.exports, "default", () => $3769956cd18ef333$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8RXs9 = parcelRequire("8RXs9");
var $i5FdW = parcelRequire("i5FdW");

var $55GMe = parcelRequire("55GMe");
const $3769956cd18ef333$var$MessagesIntlProvider = ({ intl: intl, children: children })=>{
    const mergedMessages = (0, $5uXOq.useMemo)(()=>{
        return {
            ...intl.messages,
            ...(0, $55GMe.getMessagesForLocale)(intl.locale)
        };
    }, [
        intl.messages,
        intl.locale
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i5FdW.default), {
        locale: intl.locale,
        messages: mergedMessages,
        defaultLocale: "en-US",
        children: children
    });
};
var $3769956cd18ef333$export$2e2bcd8739ae039 = (0, $8RXs9.default)($3769956cd18ef333$var$MessagesIntlProvider);

});
parcelRegister("55GMe", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $8fc7d6e642efa1c9$export$d0a3169680473b6c);
// Cannot import from `../i18n` because there is `../i18n.tsx` file there.
/* eslint-disable @atlassian/tangerine/import/no-dangling-index */ 
var $aiyiV = parcelRequire("aiyiV");
var $c7HRD = parcelRequire("c7HRD");
var $gdvwP = parcelRequire("gdvwP");
var $1mT6n = parcelRequire("1mT6n");
var $axcS0 = parcelRequire("axcS0");
var $gM6wy = parcelRequire("gM6wy");
var $jCrgt = parcelRequire("jCrgt");
var $ddwcq = parcelRequire("ddwcq");
var $2Slqk = parcelRequire("2Slqk");
var $byDyk = parcelRequire("byDyk");
var $9y8hX = parcelRequire("9y8hX");
var $bMFAQ = parcelRequire("bMFAQ");
var $4JZF5 = parcelRequire("4JZF5");
var $dzumV = parcelRequire("dzumV");
var $fH3rr = parcelRequire("fH3rr");
var $16RW6 = parcelRequire("16RW6");
var $hrNSu = parcelRequire("hrNSu");
var $ioYTp = parcelRequire("ioYTp");
var $iQCSg = parcelRequire("iQCSg");
var $hkr2R = parcelRequire("hkr2R");
var $7dbDF = parcelRequire("7dbDF");
var $8zZLq = parcelRequire("8zZLq");
var $dGOFQ = parcelRequire("dGOFQ");
var $64yeQ = parcelRequire("64yeQ");
var $iTJhG = parcelRequire("iTJhG");
const $8fc7d6e642efa1c9$var$localesMessagesMap = {
    cs: $aiyiV.default,
    da: $c7HRD.default,
    de: $gdvwP.default,
    en: $1mT6n.default,
    en_GB: $axcS0.default,
    en_ZZ: $gM6wy.default,
    es: $jCrgt.default,
    et: $ddwcq.default,
    fi: $2Slqk.default,
    fr: $byDyk.default,
    hu: $9y8hX.default,
    is: $bMFAQ.default,
    it: $4JZF5.default,
    ja: $dzumV.default,
    ko: $fH3rr.default,
    nb: $16RW6.default,
    nl: $hrNSu.default,
    pl: $ioYTp.default,
    pt_BR: $iQCSg.default,
    'pt-BR': (0, $iQCSg.default),
    pt_PT: $hkr2R.default,
    'pt-PT': (0, $hkr2R.default),
    ro: $7dbDF.default,
    ru: $8zZLq.default,
    sk: $dGOFQ.default,
    sv: $64yeQ.default,
    zh: $iTJhG.default
};
const $8fc7d6e642efa1c9$export$d0a3169680473b6c = (locale)=>{
    let messages = $8fc7d6e642efa1c9$var$localesMessagesMap[locale];
    if (!messages) {
        const parentLocale = locale.split(/[-_]/)[0];
        messages = $8fc7d6e642efa1c9$var$localesMessagesMap[parentLocale];
    }
    if (!messages) messages = (0, $1mT6n.default);
    return messages;
};

});
parcelRegister("aiyiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b03a8517fda6267e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $b03a8517fda6267e$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Odkaz zkop\xedrov\xe1n do schr\xe1nky",
    'fabric.elements.share.copylink.button.text': "Zkop\xedrovat odkaz",
    'fabric.elements.share.copypubliclink.button.text': "Kop\xedrovat ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.failure.icon.label': 'Ikona chyby',
    'fabric.elements.share.failure.message': "Nelze sd\xedlet",
    'fabric.elements.share.form.comment.label': "Zpr\xe1va (voliteln\xe1)",
    'fabric.elements.share.form.comment.placeholder': "N\u011Bco, co by m\u011Bli v\u011Bd\u011Bt?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "P\u0159\xedjemci uvid\xed n\xe1zev str\xe1nky a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.info.message.no.invite.jira': "P\u0159\xedjemci uvid\xed n\xe1zev po\u017Eadavku a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "P\u0159\xedjemci uvid\xed n\xe1zev po\u017Eadavku a\xa0va\u0161i zpr\xe1vu.",
    'fabric.elements.share.form.no-permissions': "Nem\xe1te mo\u017Enost sd\xedlet.",
    'fabric.elements.share.form.public.send': "Odeslat ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.form.public.share': "Sd\xedlet ve\u0159ejn\xfd odkaz",
    'fabric.elements.share.form.required-field.summary': "Povinn\xe1 pole jsou ozna\u010Dena hv\u011Bzdi\u010Dkou.",
    'fabric.elements.share.form.retry': 'Zkusit znovu',
    'fabric.elements.share.form.send': 'Odeslat',
    'fabric.elements.share.form.share': "Sd\xedlet",
    'fabric.elements.share.form.title': "Sd\xedlet",
    'fabric.elements.share.form.user-picker.add-more': "Zadejte v\xedce",
    'fabric.elements.share.form.user-picker.label.confluence': "Jm\xe9na, t\xfdmy, skupiny nebo e-maily",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Jm\xe9na, t\xfdmy nebo skupiny",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Jm\xe9na nebo t\xfdmy",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-maily',
    'fabric.elements.share.form.user-picker.label.jira': "Jm\xe9na, t\xfdmy nebo e-maily",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Pro \u201E{inputValue}\u201C se nepoda\u0159ilo naj\xedt \u017E\xe1dn\xe9 v\xfdsledky.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Pro \u201E{inputValue}\u201C se nepoda\u0159ilo naj\xedt \u017E\xe1dn\xe9 v\xfdsledky. Pozv\u011Bte lidi pomoc\xed jejich e-mailov\xe9 adresy.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "nap\u0159. Marie, T\xfdm pomeran\u010D, skupina-jedna",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "nap\u0159. Marie, T\xfdm pomeran\u010D",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "nap\u0159. marie@spolecnost.cz",
    'fabric.elements.share.form.user-picker.placeholder.jira': "nap\u0159. Marie, T\xfdm pomeran\u010D, marie@spolecnost.cz",
    'fabric.elements.share.form.user-picker.validation.required': "Vyberte alespo\u0148 jednoho u\u017Eivatele, skupinu, t\xfdm nebo e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Vyberte alespo\u0148 jednu osobu, t\xfdm, skupinu nebo e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Vyberte alespo\u0148 jednu osobu, t\xfdm nebo skupinu",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Vyberte alespo\u0148 jednu osobu nebo t\xfdm",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Vyberte alespo\u0148 jeden e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Vyberte alespo\u0148 jednu osobu, t\xfdm nebo e-mail",
    'fabric.elements.share.in.integration.button': "Sd\xedlet v: {integrationName}",
    'fabric.elements.share.invite.to.confluence': 'Pozvat do Confluence',
    'fabric.elements.share.invite.to.jira': 'Pozvat do Jira',
    'fabric.elements.share.main.tab.text.confluence': "Sd\xedlet str\xe1nku",
    'fabric.elements.share.main.tab.text.jira': "Sd\xedlet po\u017Eadavek",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Sd\xedlet",
    'fabric.elements.share.success.message': "{object, select,blogpost {P\u0159\xedsp\u011Bvek na blogu byl sd\xedlen}board {Board byl sd\xedlen}calendar {Kalend\xe1\u0159 byl sd\xedlen}draft {Koncept byl sd\xedlen}filter {Filtr byl sd\xedlen}issue {Po\u017Eadavek byl sd\xedlen}summary {Souhrn byl sd\xedlen}list {Seznam byl sd\xedlen}timeline {\u010Casov\xe1 osa byla sd\xedlena}form {Formul\xe1\u0159 byl sd\xedlen}media {Multim\xe9dia byla sd\xedlena}page {Str\xe1nka byla sd\xedlena}project {Projekt byl sd\xedlen}pullrequest {Pull request byl sd\xedlen}question {Ot\xe1zka byla sd\xedlena}report {Sestava byla sd\xedlena}repository {Repozit\xe1\u0159 byl sd\xedlen}request {\u017D\xe1dost byla sd\xedlena}roadmap {\u010Casov\xe1 osa byla sd\xedlena}site {Web byl sd\xedlen}space {Prostor byl sd\xedlen}other {Odkaz byl sd\xedlen}}",
    'fabric.elements.share.to.integration.button': "Sd\xedlet ve slu\u017Eb\u011B {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona sd\xedlen\xed",
    'fabric.elements.share.trigger.button.invite.text': 'Pozvat',
    'fabric.elements.share.trigger.button.text': "Sd\xedlet",
    'fabric.elements.share.trigger.button.tooltip.text': "Sd\xedlet"
};

});

parcelRegister("c7HRD", function(module, exports) {

$parcel$export(module.exports, "default", () => $40449a444ce6f8c1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Danish (Denmark)
var $40449a444ce6f8c1$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link er kopieret til udklipsholder',
    'fabric.elements.share.copylink.button.text': 'Kopier link',
    'fabric.elements.share.copypubliclink.button.text': "Kopi\xe9r offentligt link",
    'fabric.elements.share.failure.icon.label': 'Fejlikon',
    'fabric.elements.share.failure.message': 'Kan ikke deles',
    'fabric.elements.share.form.comment.label': 'Besked (valgfrit)',
    'fabric.elements.share.form.comment.placeholder': "Er der noget, de b\xf8r vide?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Modtagere vil se navnet p\xe5 siden og din besked",
    'fabric.elements.share.form.info.message.no.invite.jira': "Modtagere vil se navnet p\xe5 sagen og din meddelelse",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Modtagere f\xe5r vist navnet p\xe5 sagen og din besked",
    'fabric.elements.share.form.no-permissions': 'Du kan ikke dele.',
    'fabric.elements.share.form.public.send': 'Send offentligt link',
    'fabric.elements.share.form.public.share': 'Del offentligt link',
    'fabric.elements.share.form.required-field.summary': "P\xe5kr\xe6vede felter er markeret med en stjerne",
    'fabric.elements.share.form.retry': "Pr\xf8v igen",
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Del',
    'fabric.elements.share.form.title': 'Del',
    'fabric.elements.share.form.user-picker.add-more': 'Indtast mere',
    'fabric.elements.share.form.user-picker.label.confluence': 'Navne, teams, grupper eller e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navne, teams eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navne eller teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Navne, teams eller e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi kunne ikke finde nogen resultater for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi kunne ikke finde nogen resultater for "{inputValue}". Invit\xe9r personer via e-mailadresser.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'f.eks. Maria, Team Orange, gruppe et',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': "V\xe6lg mindst \xe9n bruger, \xe9n gruppe, \xe9t team eller \xe9n e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe6lg mindst en person, et team, en gruppe eller en e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe6lg mindst en person, et team eller en gruppe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe6lg mindst en person eller et team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe6lg mindst en e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe6lg mindst en person, et team eller en e-mail",
    'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
    'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Del side',
    'fabric.elements.share.main.tab.text.jira': 'Del sag',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Del',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogindl\xe6g delt}board {Tavle delt}calendar {Kalender delt}draft {Udkast delt}filter {Filter delt}issue {Sag delt}summary {Oversigt delt}list {Liste delt}timeline {Tidslinje delt}form {Formular delt}media {Medier delt}page {Side delt}project {Projekt delt}pullrequest {Pullanmodning delt}question {Sp\xf8rgsm\xe5l delt}report {Rapport delt}repository {Lager delt}request {Anmodning delt}roadmap {Tidslinje delt}site {Websted delt}space {Omr\xe5de delt}other {Link delt}}",
    'fabric.elements.share.to.integration.button': 'Del med {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Del ikon',
    'fabric.elements.share.trigger.button.invite.text': "Invit\xe9r",
    'fabric.elements.share.trigger.button.text': 'Del',
    'fabric.elements.share.trigger.button.tooltip.text': 'Del'
};

});

parcelRegister("gdvwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9ad081aeac1c38f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //German (Germany)
var $c9ad081aeac1c38f$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link in Zwischenablage kopiert',
    'fabric.elements.share.copylink.button.text': 'Link kopieren',
    'fabric.elements.share.copypubliclink.button.text': "\xd6ffentlichen Link kopieren",
    'fabric.elements.share.failure.icon.label': 'Fehler-Symbol',
    'fabric.elements.share.failure.message': "Teilen nicht m\xf6glich",
    'fabric.elements.share.form.comment.label': 'Nachricht (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Irgendetwas Wissenswertes?',
    'fabric.elements.share.form.info.message.no.invite.confluence': "Empf\xe4nger sehen den Namen der Seite und Ihre Nachricht",
    'fabric.elements.share.form.info.message.no.invite.jira': "Empf\xe4nger sehen den Namen des Vorgangs und Ihre Nachricht",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Empf\xe4nger sehen den Namen des Vorgangs und Ihre Nachricht",
    'fabric.elements.share.form.no-permissions': "Sie k\xf6nnen keine Elemente teilen.",
    'fabric.elements.share.form.public.send': "\xd6ffentlichen Link senden",
    'fabric.elements.share.form.public.share': "\xd6ffentlichen Link teilen",
    'fabric.elements.share.form.required-field.summary': 'Pflichtfelder sind mit einem Sternchen markiert.',
    'fabric.elements.share.form.retry': 'Erneut versuchen',
    'fabric.elements.share.form.send': 'Senden',
    'fabric.elements.share.form.share': 'Teilen',
    'fabric.elements.share.form.title': 'Teilen',
    'fabric.elements.share.form.user-picker.add-more': 'Weitere eingeben',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namen, Teams, Gruppen oder E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namen, Teams oder Gruppen',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namen oder Teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.label.jira': 'Namen, Teams oder E-Mail-Adressen',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Es wurden keine Ergebnisse f\xfcr \u201E{inputValue}\u201C gefunden.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Es wurden keine Ergebnisse f\xfcr \u201E{inputValue}\u201C gefunden. Laden Sie Personen mittels E-Mail-Adresse ein.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "z.\xa0B. Maria, Team Orange, Gruppe eins",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "z.\xa0B. Maria, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "z.\xa0B. maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "z.\xa0B. Maria, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "W\xe4hlen Sie mindestens einen Benutzer, eine Gruppe, ein Team oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "W\xe4hlen Sie mindestens eine Person, ein Team, eine Gruppe oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "W\xe4hlen Sie mindestens eine Person, ein Team oder eine Gruppe aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "W\xe4hlen Sie mindestens eine Person oder ein Team aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "W\xe4hlen Sie mindestens eine E-Mail-Adresse aus.",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "W\xe4hlen Sie mindestens eine Person, ein Team oder eine E-Mail-Adresse aus.",
    'fabric.elements.share.in.integration.button': 'In {integrationName} teilen',
    'fabric.elements.share.invite.to.confluence': 'Zu Confluence einladen',
    'fabric.elements.share.invite.to.jira': 'Zu Jira einladen',
    'fabric.elements.share.main.tab.text.confluence': 'Seite teilen',
    'fabric.elements.share.main.tab.text.jira': 'Vorgang teilen',
    'fabric.elements.share.menu.email.label': 'E-Mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Teilen',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blogpost geteilt}board {Board geteilt}calendar {Kalender geteilt}draft {Entwurf geteilt}filter {Filter geteilt}issue {Vorgang geteilt}summary {Zusammenfassung geteilt}list {Liste geteilt}timeline {Zeitleiste geteilt}form {Formular geteilt}media {Medien geteilt}page {Seite geteilt}project {Projekt geteilt}pullrequest {Pull-Anfrage geteilt}question {Frage geteilt}report {Bericht geteilt}repository {Repository geteilt}request {Anfrage geteilt}roadmap {Zeitleiste geteilt}site {Site geteilt}space {Bereich geteilt}other {Link geteilt}}',
    'fabric.elements.share.to.integration.button': 'Mit {integrationName} teilen',
    'fabric.elements.share.trigger.button.icon.label': 'Teilen-Symbol',
    'fabric.elements.share.trigger.button.invite.text': 'Einladen',
    'fabric.elements.share.trigger.button.text': 'Teilen',
    'fabric.elements.share.trigger.button.tooltip.text': 'Teilen'
};

});

parcelRegister("1mT6n", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae943d78330d54c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $5ae943d78330d54c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copied to clipboard',
    'fabric.elements.share.copylink.button.text': 'Copy link',
    'fabric.elements.share.copypubliclink.button.text': 'Copy public link',
    'fabric.elements.share.failure.icon.label': 'Error icon',
    'fabric.elements.share.failure.message': 'Unable to share',
    'fabric.elements.share.form.comment.label': 'Message (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Anything they should know?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Recipients will see the name of the page and your message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Recipients will see the name of the issue and your message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Recipients will see the name of the work item and your message',
    'fabric.elements.share.form.no-permissions': 'You do not have the ability to share.',
    'fabric.elements.share.form.public.send': 'Send public link',
    'fabric.elements.share.form.public.share': 'Share public link',
    'fabric.elements.share.form.required-field.summary': 'Required fields are marked with an asterisk',
    'fabric.elements.share.form.retry': 'Retry',
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Share',
    'fabric.elements.share.form.title': 'Share',
    'fabric.elements.share.form.user-picker.add-more': 'Enter more',
    'fabric.elements.share.form.user-picker.label.confluence': 'Names, teams, groups, or emails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Names, teams, or groups',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Names or teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'Emails',
    'fabric.elements.share.form.user-picker.label.jira': 'Names, teams, or emails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'We couldn\u2019t find any results for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'e.g. Maria, Team Orange, group-one',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'e.g. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'e.g. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'e.g. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': 'Select at least one user, group, team or email.',
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Select at least one person, team, group, or email',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Select at least one person, team, or group',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Select at least one person or team',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Select at least one email',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Select at least one person, team, or email',
    'fabric.elements.share.in.integration.button': 'Share in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invite to Confluence',
    'fabric.elements.share.invite.to.jira': 'Invite to Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Share page',
    'fabric.elements.share.main.tab.text.jira': 'Share issue',
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Share',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}',
    'fabric.elements.share.to.integration.button': 'Share to {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Share icon',
    'fabric.elements.share.trigger.button.invite.text': 'Invite',
    'fabric.elements.share.trigger.button.text': 'Share',
    'fabric.elements.share.trigger.button.tooltip.text': 'Share'
};

});

parcelRegister("axcS0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4de2c962853eb1a7$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $4de2c962853eb1a7$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copied to clipboard',
    'fabric.elements.share.copylink.button.text': 'Copy link',
    'fabric.elements.share.copypubliclink.button.text': 'Copy public link',
    'fabric.elements.share.failure.icon.label': 'Error icon',
    'fabric.elements.share.failure.message': 'Unable to share',
    'fabric.elements.share.form.comment.label': 'Message (optional)',
    'fabric.elements.share.form.comment.placeholder': 'Anything they should know?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Recipients will see the name of the page and your message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Recipients will see the name of the issue and your message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Recipients will see the name of the work item and your message',
    'fabric.elements.share.form.no-permissions': 'You do not have the ability to share.',
    'fabric.elements.share.form.public.send': 'Send public link',
    'fabric.elements.share.form.public.share': 'Share public link',
    'fabric.elements.share.form.required-field.summary': 'Required fields are marked with an asterisk',
    'fabric.elements.share.form.retry': 'Retry',
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Share',
    'fabric.elements.share.form.title': 'Share',
    'fabric.elements.share.form.user-picker.add-more': 'Enter more',
    'fabric.elements.share.form.user-picker.label.confluence': 'Names, teams, groups, or emails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Names, teams, or groups',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Names or teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'Emails',
    'fabric.elements.share.form.user-picker.label.jira': 'Names, teams, or emails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'We couldn\u2019t find any results for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'e.g. Maria, Team Orange, group-one',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'e.g. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'e.g. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'e.g. Maria, Team Orange, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': 'Select at least one user, group, team or email.',
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Select at least one person, team, group, or email',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Select at least one person, team, or group',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Select at least one person or team',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Select at least one email',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Select at least one person, team, or email',
    'fabric.elements.share.in.integration.button': 'Share in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invite to Confluence',
    'fabric.elements.share.invite.to.jira': 'Invite to Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Share page',
    'fabric.elements.share.main.tab.text.jira': 'Share issue',
    'fabric.elements.share.menu.email.label': 'Email',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Share',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}',
    'fabric.elements.share.to.integration.button': 'Share to {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Share icon',
    'fabric.elements.share.trigger.button.invite.text': 'Invite',
    'fabric.elements.share.trigger.button.text': 'Share',
    'fabric.elements.share.trigger.button.tooltip.text': 'Share'
};

});

parcelRegister("gM6wy", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ca0de856e819520$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $8ca0de856e819520$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u2063\u2062Link copied to clipboard\x8f\u200D\x8f\u2061\u206B\u206A\u200D\u206E\x8f\x8d\x8f\u206C\u206A\u206C\x90\u200C\x9d\u206F\x81\x90\u206C\u206B\u2061\u206A\x8d\x8d\u206A\x90\u206C\x8d\u2060\u2061\u2063\u2064",
    'fabric.elements.share.copylink.button.text': "\u2063\u2062Copy link\x8d\u206C\x8f\u206E\u206A\u200D\u206E\x9d\x90\u061C\u2061\x8d\u206E\x90\u206D\x8d\u2061\u200C\u206F\x8d\u2061\x8d\u206A\x81\x81\u206B\u206E\u200C\x9d\u2060\u206F\x81\u2063\u2064",
    'fabric.elements.share.copypubliclink.button.text': "\u2063\u2062Copy public link\u2061\x81\u200C\u206F\u200D\u206D\x9d\u2061\x8f\u206C\u206D\x8f\u2061\x81\x81\u206A\u206A\x90\u206E\u2060\u061C\u2060\u206F\u206E\u206B\u206D\u200C\u061C\u200C\x9d\x9d\x9d\u2063\u2064",
    'fabric.elements.share.failure.icon.label': "\u2063\u2062Error icon\u200D\u061C\u206C\u206E\u206F\u2061\u206E\u206F\x8f\x90\u2060\u061C\x90\u061C\u200D\u200C\u206A\u206A\u200C\u200C\u206E\u206F\x90\u200D\u2061\u206B\u206A\u2060\x8f\u200C\x90\u206E\u2063\u2064",
    'fabric.elements.share.failure.message': "\u2063\u2062Unable to share\x8f\u206A\u206E\x90\u200D\x90\u2061\x90\u206A\x8d\u206D\x8d\x9d\u2060\x90\x9d\u206C\u2061\u206C\x9d\x8d\u206C\u206C\u206B\x9d\x8d\u206B\x9d\u200C\x81\u200D\u2060\u2063\u2064",
    'fabric.elements.share.form.comment.label': "\u2063\u2062Message (optional)\x8d\u200D\u206F\x8d\u206B\x90\u2060\u2061\u206D\u206E\u206F\u2061\u2060\x8f\u206C\u206E\u206B\x81\u200C\x90\u206D\u206C\x8d\u2060\u061C\u2060\u2060\x81\x8f\u200D\u200D\u206F\u2063\u2064",
    'fabric.elements.share.form.comment.placeholder': "\u2063\u2062Anything they should know?\u2060\u206F\x81\u061C\x8d\u2061\u2061\u200D\u206B\u206B\u206F\u206A\x81\u2061\u200C\u2060\x8d\x90\u206E\x90\u206E\x81\u206D\u200D\x8f\u206C\u206E\u206A\u206C\u2060\u206A\u206D\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u2063\u2062Recipients will see the name of the page and your message\u206F\u2060\x81\x90\u200C\u200C\x81\x90\u061C\u2060\x8d\u200C\x81\u206A\u2061\u061C\u206E\x8f\u2060\u206D\u206D\x8f\u200C\u200C\x9d\u206D\u200C\u2060\x8f\x8f\u206A\u200C\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u2063\u2062Recipients will see the name of the issue and your message\x81\u206C\u206C\x8d\u206F\u200D\u206B\u200D\u2060\u061C\u2061\x81\u206D\x8d\u206A\x8d\x90\u206B\x8d\u206A\x8f\x8d\u206D\u206E\u206D\x9d\u200D\u206C\u206E\x9d\u206F\u2060\u2063\u2064",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u2063\u2062Recipients will see the name of the work item and your message\u061C\u206B\u200D\u206B\u206D\u2060\u200D\u200C\u200C\x90\x8f\u206D\u2060\u200C\x8f\u206E\u206B\x9d\x9d\u206E\x8f\u2060\x90\u206F\u2060\x9d\u206D\u2060\u206F\x81\u206B\u206B\u2063\u2064",
    'fabric.elements.share.form.no-permissions': "\u2063\u2062You do not have the ability to share.\x8f\u206B\u206F\x8f\u061C\u206B\u206D\x81\u206C\u206F\u206F\u206C\u2060\u206E\u200D\u200D\x81\x81\u200D\u206B\x8d\u206E\x9d\u206C\x8f\u206A\u2061\u2060\u2061\x90\u206D\u206E\u2063\u2064",
    'fabric.elements.share.form.public.send': "\u2063\u2062Send public link\u206E\u206B\x8d\u206D\u206E\u206C\u2060\u206F\u206B\u206F\u061C\u2060\x8d\x9d\u200D\u206F\u2060\u2061\u206E\x81\u061C\u206F\u206D\x8d\x8f\u200C\x8d\x81\u206D\u2061\u206B\u2060\u2063\u2064",
    'fabric.elements.share.form.public.share': "\u2063\u2062Share public link\u2060\u2061\x90\u200D\u206A\u206A\u200D\u206F\u200D\x8f\u206B\u200C\u2060\u206C\u061C\u200D\u206C\u200C\u206F\x9d\u206F\x8d\u200D\x81\x9d\u206D\u2061\u2061\u206D\u2061\u061C\u206E\u2063\u2064",
    'fabric.elements.share.form.required-field.summary': "\u2063\u2062Required fields are marked with an asterisk\x8d\x8d\u200D\u206C\u2060\u206F\u206A\x9d\u206F\u200D\x90\x9d\u206A\u206D\x9d\u206B\u206C\u200C\x90\x81\x81\u206C\u2061\u200C\u200C\u2060\u200D\u061C\u206B\x9d\u206B\x9d\u2063\u2064",
    'fabric.elements.share.form.retry': "\u2063\u2062Retry\u200C\u206B\u206F\u206D\u200C\x9d\u206C\u2061\u061C\u200C\u206C\u206C\u206A\u206C\u206C\x8d\x90\u206A\x9d\x8d\u206C\u206A\u200C\x81\x8f\x8f\u2061\u2061\u206F\x90\u200C\x8d\u2063\u2064",
    'fabric.elements.share.form.send': "\u2063\u2062Send\x90\u200D\u206D\u200C\x8f\u2060\u2060\u200D\u061C\u200D\x8d\u200C\u206D\u206F\u200D\u206E\u206B\u206D\u2061\u206F\x9d\u206F\u206F\u206F\u061C\u206A\u206D\u206A\x8d\x8d\u2060\u061C\u2063\u2064",
    'fabric.elements.share.form.share': "\u2063\u2062Share\u2060\x8f\u200C\u200D\x9d\x9d\u206A\u206D\u206B\u206C\x81\x90\x8d\u2060\x8f\x8f\u206C\u200C\u206A\u200C\u061C\u2060\u061C\x8f\u061C\x8f\u206D\u206E\x8f\x8f\u200C\x81\u2063\u2064",
    'fabric.elements.share.form.title': "\u2063\u2062Share\u206E\u206B\u2060\u206E\x9d\u206C\x8d\u061C\x90\x9d\u206A\u206B\u206D\u206F\u200C\u206F\u200D\x9d\u061C\u200D\u206E\u2060\u206E\x81\u206F\u061C\x8d\x81\x8f\u2061\u206B\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.add-more': "\u2063\u2062Enter more\u2060\x9d\u2060\x81\u2061\u200D\u206B\u206F\u206E\x8d\x8d\u206B\u200C\u061C\u061C\u200C\x9d\u200D\u2060\x8d\x9d\u206C\x8f\u206A\x8f\u206B\x8d\x9d\u061C\u206C\u200D\u2060\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.confluence': "\u2063\u2062Names, teams, groups, or emails\u206F\x9d\u206F\u206D\x81\u2061\x90\u200D\u206E\u2060\x90\x8f\x81\x8d\u2061\u206D\u200D\u206D\u200D\u206A\x9d\x81\u206F\u206C\u061C\x90\u200C\u200D\x81\x8d\u206E\u200D\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u2063\u2062Names, teams, or groups\u206A\x8d\x8f\u206F\x90\u206E\u200D\u206E\u2060\u061C\u206F\u206C\x8d\x8d\x9d\u200C\x90\u206F\x9d\u061C\u206C\x90\x90\u206B\u2060\u061C\u2060\u206E\x8d\u2061\x8f\u206A\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u2063\u2062Names or teams\x8d\u206B\u206C\u206D\u206E\x90\x9d\u200C\u206A\x90\x90\u206D\u200D\u206F\u200D\x8f\u061C\u061C\u206F\u206F\u061C\u206E\u206F\u206B\u2060\u061C\u2060\u200D\u2061\x9d\x8d\x90\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.email-only': "\u2063\u2062Emails\x81\u061C\x9d\u206C\x8f\u206A\u200C\u206A\u206F\u2060\u206B\x9d\u206F\x90\x9d\x9d\u206A\u061C\x8f\u206B\u206F\u206E\x8f\u061C\x9d\u206C\u206E\u206F\u2060\u206C\x8f\u206C\u2063\u2064",
    'fabric.elements.share.form.user-picker.label.jira': "\u2063\u2062Names, teams, or emails\u200C\u2061\u206D\u206B\u200C\u061C\u206F\u061C\u2060\u200C\x8f\x8f\u2061\u206D\x81\u206B\x8f\u061C\u200D\x8d\x8f\u2061\u206E\u061C\u206D\x81\u2060\u061C\u2060\u206B\u206F\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '\u2063\u2062We couldn\u2019t find any results for "{inputValue}".\u206D\x8f\x8f\u2061\u206D\u200C\x81\x9d\u206D\x90\x8f\u200C\u206E\u206F\u206B\x8f\u061C\u2061\u2061\u206F\u2061\x81\x9d\u2060\x90\u2060\u206B\x9d\u200D\u206D\u200D\u206A\u2063\u2064',
    'fabric.elements.share.form.user-picker.no-options.generic': '\u2063\u2062We couldn\u2019t find any results for "{inputValue}". Invite people by using an email address.\x8d\u2061\u061C\x8f\x9d\u206E\u061C\u200D\u2060\u206A\u206A\x9d\u061C\x9d\x8f\x90\u2060\u2060\u2061\u206E\u061C\u206F\u206C\x90\u2061\u2060\u206D\u200D\u206B\x8f\x90\u200D\u2063\u2064',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u2063\u2062e.g. Maria, Team Orange, group-one\u200D\u206D\x81\u2061\u200D\u2060\u206B\u061C\x90\x8f\u206C\u206E\u206A\x8f\x8f\u061C\u206E\u200D\x90\x8d\x8d\x90\u206C\x90\u2061\u206C\x9d\u206F\x90\u206F\u206C\x9d\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u2063\u2062e.g. Maria, Team Orange\x81\u206E\u206C\x81\u061C\x9d\u2061\u206A\u206F\x9d\x90\u206C\u200C\x90\u2061\u200D\u206D\x90\u206F\x81\x81\u061C\u206C\u206C\u206C\x8d\u061C\x8d\u206F\u061C\u206A\u061C\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u2063\u2062e.g. maria@company.com\x8d\u206B\u206A\u061C\x9d\u206B\x81\u2060\u206B\x9d\u206B\u206C\u206B\u200C\u206C\u200D\u206C\u206F\u061C\u206B\x90\u206A\x8f\u2060\u200D\u061C\u206F\u206E\u200C\x8f\u061C\x8d\u2063\u2064",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u2063\u2062e.g. Maria, Team Orange, maria@company.com\x8f\x8d\u206A\u200C\u2061\u061C\u206D\x81\u2061\x8d\u206A\x8d\u200D\x8d\u206A\u206D\u2061\u2061\u061C\u200C\x9d\u200C\u206C\u200D\u206A\x8f\u206C\u2060\u206D\u206B\x9d\u2061\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required': "\u2063\u2062Select at least one user, group, team or email.\x81\u206E\u206A\x81\u206F\u2061\x8f\x9d\x9d\u206D\u2061\u061C\u206B\u206F\x9d\u200C\u200D\u206D\u206B\x81\x81\u206A\u206F\u200C\x8d\x90\x81\u206B\u2060\u061C\x9d\u206B\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u2063\u2062Select at least one person, team, group, or email\u206B\x81\u206E\x9d\u206D\x90\u200D\x9d\u200C\u206D\x9d\u2060\u206B\x8d\x8f\u206C\u206C\u2061\u206D\u206F\x8d\x90\u200C\x90\u200D\u206F\u200C\u206A\u206D\u2061\u2060\u200D\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u2063\u2062Select at least one person, team, or group\x8d\u206C\u206F\u061C\x90\u206D\x9d\u206D\u206A\u200C\u206E\x8f\u2060\u206D\x81\u206A\x8d\u206A\x9d\x9d\u2060\u200C\u206A\x8f\u200C\x9d\x9d\u206E\u2061\x8d\x81\x8f\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u2063\u2062Select at least one person or team\u206A\u206F\u200D\x8f\u206D\u206F\u206B\x90\u206C\x81\u206E\u2060\u200D\u2061\x81\u206A\x8d\u206E\u206F\x8f\x9d\x8f\x8f\u2060\x9d\x81\x81\u206A\u206C\x81\u200C\u2061\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u2063\u2062Select at least one email\x8f\u206F\u206D\x81\u200D\u206B\u206B\x8d\u206D\x8d\u200C\x8d\x9d\u200C\u206F\u200D\u200D\u2060\u2061\u206F\u061C\x8d\u206F\x90\u200D\u2061\u206A\x8d\x90\u200C\x8f\u200C\u2063\u2064",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u2063\u2062Select at least one person, team, or email\u2060\x9d\u2060\u206A\x90\u200C\u200C\u061C\u206C\u200D\x8d\u200D\u200D\u2060\u200C\u206C\u206A\u206D\u206D\u206E\u200D\u200D\x90\u061C\u200C\u2060\u206A\u206B\u2061\u206A\u2060\x8f\u2063\u2064",
    'fabric.elements.share.in.integration.button': "\u2063\u2062Share in {integrationName}\u2060\u061C\x90\u206A\u2061\u206C\u206D\u2061\u206D\x90\x8f\x8f\u200C\u206B\u206A\x9d\u206C\u2061\u061C\u200C\x90\u206E\u206A\u206F\u206C\x81\u200C\x8f\u206C\u200C\x81\u206D\u2063\u2064",
    'fabric.elements.share.invite.to.confluence': "\u2063\u2062Invite to Confluence\u206A\u206E\x8f\u2061\x8f\u206D\u206B\x9d\u206A\x9d\x8f\u206F\u061C\u200D\u206B\u206A\u200D\x9d\u2060\u206D\u200D\x8f\u2061\x8d\u2060\u2061\u206E\x81\u206C\u061C\u200D\u200D\u2063\u2064",
    'fabric.elements.share.invite.to.jira': "\u2063\u2062Invite to Jira\u061C\x8f\u2060\u2061\x8f\u206F\x8d\x81\x9d\x81\u206C\u2060\u200C\u206E\u206E\u061C\x90\u2060\u206E\u2060\u200D\x8d\x81\u206B\u206F\x8d\u200D\u206B\u2061\x9d\u206C\x8f\u2063\u2064",
    'fabric.elements.share.main.tab.text.confluence': "\u2063\u2062Share page\x81\u206A\u206F\u206D\u206C\u206C\x8f\x8f\x8f\x8d\x8f\x8f\u206A\u206C\u206F\x9d\u200C\x8f\u200D\u200C\u200D\u2060\x8d\u206B\x8f\u2061\u061C\u206E\x81\u200C\x8d\u206E\u2063\u2064",
    'fabric.elements.share.main.tab.text.jira': "\u2063\u2062Share issue\x9d\x9d\x8f\x9d\u061C\u206D\u200D\u206E\x90\x81\u200D\x9d\x81\x90\x8f\u206C\u061C\u200D\x9d\x9d\u206C\x9d\u206F\u2061\u2060\u2060\u206A\u206E\u061C\x81\u200D\x8f\u2063\u2064",
    'fabric.elements.share.menu.email.label': "\u2063\u2062Email\u206E\x90\u200D\u206B\u2061\u206C\u061C\u206A\u206A\u200C\u200C\x8f\u061C\x8f\u200C\u200C\u206C\u206D\u200C\u206A\x8f\x81\u206F\u2061\x8d\u2061\u206E\u2061\u206E\u206C\u206A\u206A\u2063\u2064",
    'fabric.elements.share.menu.slack.label': "\u2063\u2062Slack\u206B\u200C\u206B\x8f\u061C\u206D\x9d\u061C\x8f\u200D\u2060\u200D\x81\x90\u206C\u206F\u200C\x81\u2061\x9d\x8f\u206F\u200D\x8f\u206E\u200C\x8f\x81\u206C\u2060\x8d\u2060\u2063\u2064",
    'fabric.elements.share.popup.label': "\u2063\u2062Share\u206D\x9d\u206D\u206B\u206C\u200D\u200C\u206C\x8f\u206C\x90\x81\x81\x8d\x90\x8f\u206B\u206A\u2061\u200C\u206F\u206A\u200C\u206E\x9d\x8d\u206E\u200C\u200D\u200D\x81\u206C\u2063\u2064",
    'fabric.elements.share.success.message': "\u2063\u2062{object, select,blogpost {Blog post shared}board {Board shared}calendar {Calendar shared}draft {Draft shared}filter {Filter shared}issue {Issue shared}summary {Summary shared}list {List shared}timeline {Timeline shared}form {Form shared}media {Media shared}page {Page shared}project {Project shared}pullrequest {Pull Request shared}question {Question shared}report {Report shared}repository {Repository shared}request {Request shared}roadmap {Timeline shared}site {Site shared}space {Space shared}other {Link Shared}}\x8f\x8f\u206A\x81\x9d\u206F\u061C\u206F\u206A\u200C\u206C\u206F\u206F\x8d\x8d\u206C\u206C\x8d\u206C\u206D\u206C\u206A\u206E\u2060\u200D\x90\u061C\x90\x81\u206E\u206D\x9d\u2063\u2064",
    'fabric.elements.share.to.integration.button': "\u2063\u2062Share to {integrationName}\x9d\u206D\u200C\x9d\x8d\u206C\u206E\u206E\u206D\u206A\u2061\u200C\u2060\u206F\x90\u2061\x8d\u2061\u2061\u2060\x9d\u200D\x90\u200D\u206A\x9d\u061C\u200C\x9d\u206B\u2061\x8f\u2063\u2064",
    'fabric.elements.share.trigger.button.icon.label': "\u2063\u2062Share icon\x81\x90\u200C\x9d\u206C\u200D\x8f\x8f\u206E\x9d\u206F\u206B\x8f\u206F\x9d\x8d\x8d\u061C\u200D\x9d\x8f\u206C\u206F\u200D\u206D\u061C\x90\u206A\u200C\u206A\u206B\u2061\u2063\u2064",
    'fabric.elements.share.trigger.button.invite.text': "\u2063\u2062Invite\u2061\u200D\u206A\u206B\x9d\u206D\x8f\u200D\u206F\x81\u2060\u206B\u206B\x8f\x8f\u206E\u061C\u2061\x8f\u200C\u206E\x81\u2060\u061C\u061C\x9d\u206E\u061C\x9d\u206D\u206A\u061C\u2063\u2064",
    'fabric.elements.share.trigger.button.text': "\u2063\u2062Share\u206B\u206A\x81\x8d\x8d\x9d\x8f\u200C\u206D\u206D\x9d\u2061\x81\x81\u200D\u206F\u200C\u206C\u200D\x90\u206A\u206B\u206F\u061C\u061C\u206E\x9d\u2061\u200D\x90\x81\u206B\u2063\u2064",
    'fabric.elements.share.trigger.button.tooltip.text': "\u2063\u2062Share\u200C\u206F\u2061\u206A\x90\u200C\u061C\u200C\x8f\u200C\u206A\u206F\u206D\u2060\u061C\u2061\u206D\u206F\u206E\u206D\x8d\u200C\x90\u200C\u200D\u206A\u206E\x8d\u206A\u200C\u206C\u206A\u2063\u2064"
};

});

parcelRegister("jCrgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa4d05b5c2cb0939$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Spanish (International)
var $fa4d05b5c2cb0939$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Enlace copiado en el portapapeles',
    'fabric.elements.share.copylink.button.text': 'Copiar enlace',
    'fabric.elements.share.copypubliclink.button.text': "Copiar enlace p\xfablico",
    'fabric.elements.share.failure.icon.label': 'Icono de error',
    'fabric.elements.share.failure.message': 'No se puede compartir',
    'fabric.elements.share.form.comment.label': 'Mensaje (opcional)',
    'fabric.elements.share.form.comment.placeholder': "\xbfHay algo que haya que saber?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Los destinatarios ver\xe1n el nombre de la p\xe1gina y tu mensaje",
    'fabric.elements.share.form.info.message.no.invite.jira': "Los destinatarios ver\xe1n el nombre de la incidencia y tu mensaje",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Los destinatarios ver\xe1n el nombre de la actividad y tu mensaje",
    'fabric.elements.share.form.no-permissions': 'No puedes compartir.',
    'fabric.elements.share.form.public.send': "Enviar enlace p\xfablico",
    'fabric.elements.share.form.public.share': "Compartir enlace p\xfablico",
    'fabric.elements.share.form.required-field.summary': "Los campos obligatorios est\xe1n marcados con un asterisco",
    'fabric.elements.share.form.retry': 'Reintentar',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.share': 'Compartir',
    'fabric.elements.share.form.title': 'Compartir',
    'fabric.elements.share.form.user-picker.add-more': "Introduce m\xe1s cosas",
    'fabric.elements.share.form.user-picker.label.confluence': "Nombres, equipos, grupos o correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nombres, equipos o grupos',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nombres o equipos',
    'fabric.elements.share.form.user-picker.label.email-only': "Correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.label.jira': "Nombres, equipos o correos electr\xf3nicos",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'No hemos encontrado ning\xfan resultado para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'No hemos encontrado ning\xfan resultado para "{inputValue}". Invita a la gente mediante una direcci\xf3n de correo electr\xf3nico.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "p.\xa0ej. Mar\xeda, equipo naranja, grupo uno",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "p.\xa0ej. Mar\xeda, equipo naranja",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "p.\xa0ej. maria@empresa.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "p.\xa0ej. Mar\xeda, equipo naranja, maria@empresa.com",
    'fabric.elements.share.form.user-picker.validation.required': "Selecciona al menos un usuario, grupo, equipo o correo electr\xf3nico.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Selecciona al menos una persona, equipo, grupo o correo electr\xf3nico",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Selecciona al menos una persona, equipo o grupo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Selecciona al menos una persona o equipo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Selecciona al menos un correo electr\xf3nico",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Selecciona al menos una persona, equipo o correo electr\xf3nico",
    'fabric.elements.share.in.integration.button': 'Compartir en {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invitar a Confluence',
    'fabric.elements.share.invite.to.jira': 'Invitar a Jira',
    'fabric.elements.share.main.tab.text.confluence': "Compartir p\xe1gina",
    'fabric.elements.share.main.tab.text.jira': 'Compartir incidencia',
    'fabric.elements.share.menu.email.label': "Correo electr\xf3nico",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Compartir',
    'fabric.elements.share.success.message': "{object, select,blogpost {Entrada de blog compartida}board {Tablero compartido}calendar {Calendario compartido}draft {Borrador compartido}filter {Filtro compartido}issue {Incidencia compartida}summary {Resumen compartido}list {Lista compartida}timeline {Cronograma compartido}form {Formulario compartido}media {Recursos multimedia compartidos}page {P\xe1gina compartida}project {Proyecto compartido}pullrequest {Solicitud de incorporaci\xf3n de cambios compartida}question {Pregunta compartida}report {Informe compartido}repository {Repositorio compartido}request {Solicitud compartida}roadmap {Cronograma compartido}site {Sitio compartido}space {Espacio compartido}other {Enlace compartido}}",
    'fabric.elements.share.to.integration.button': 'Compartir en {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Icono de compartir',
    'fabric.elements.share.trigger.button.invite.text': 'Invitar',
    'fabric.elements.share.trigger.button.text': 'Compartir',
    'fabric.elements.share.trigger.button.tooltip.text': 'Compartir'
};

});

parcelRegister("ddwcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8a813df19fa2152$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Estonian
var $f8a813df19fa2152$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Link kopeeritud l\xf5ikelauale",
    'fabric.elements.share.copylink.button.text': 'Kopeeri link',
    'fabric.elements.share.failure.icon.label': 'Vea ikoon',
    'fabric.elements.share.failure.message': 'Jagamine nurjus',
    'fabric.elements.share.form.comment.placeholder': "S\xf5numi lisamine",
    'fabric.elements.share.form.retry': 'Proovi uuesti',
    'fabric.elements.share.form.send': 'Saada',
    'fabric.elements.share.form.title': 'Jaga',
    'fabric.elements.share.form.user-picker.add-more': 'Sisesta veel',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Me ei suutnud leida \xfchtegi tulemust seoses otsitavaga \u201E{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Me ei suutnud leida \xfchtegi tulemust seoses otsitavaga \u201E{inputValue}". Kutsu inimesi e-posti aadressi alusel.',
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Sisesta nimi v\xf5i meeskond",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Sisestage nimi, r\xfchm, meeskond v\xf5i meil",
    'fabric.elements.share.form.user-picker.placeholder.jira': "Sisestage nimi, tiim v\xf5i meil",
    'fabric.elements.share.form.user-picker.validation.required': "Valige v\xe4hemalt \xfcks kasutaja, r\xfchm, meeskond v\xf5i meil.",
    'fabric.elements.share.form.user-picker.validation.required.jira': "Valige v\xe4hemalt \xfcks kasutaja, tiim v\xf5i meil.",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blogipostitus jagatud} board {T\xf6\xf6laud jagatud} calendar {Kalender jagatud} draft {Mustand jagatud} filter {Filter jagatud} issue {Probleem jagatud} media {Meediafail jagatud} page {Leht jagatud} project {Projekt jagatud} pullrequest {T\xf5mbekutse jagatud} question {K\xfcsimus jagatud} report {Raport jagatud} repository {Koodihoidla jagatud} request {Taotlus jagatud} roadmap {T\xf6\xf6plaan jagatud} site {Sait jagatud} space {Ruum jagatud} other {Link jagatud}}",
    'fabric.elements.share.trigger.button.icon.label': 'Jagamisikoon',
    'fabric.elements.share.trigger.button.invite.text': 'Kutsu',
    'fabric.elements.share.trigger.button.text': 'Jaga',
    'fabric.elements.share.trigger.button.tooltip.text': 'Jaga'
};

});

parcelRegister("2Slqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8abdec291b18f8c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Finnish
var $c8abdec291b18f8c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Linkki kopioitu leikep\xf6yd\xe4lle",
    'fabric.elements.share.copylink.button.text': 'Kopioi linkki',
    'fabric.elements.share.copypubliclink.button.text': 'Kopioi julkinen linkki',
    'fabric.elements.share.failure.icon.label': 'Virhekuvake',
    'fabric.elements.share.failure.message': 'Ei voitu jakaa',
    'fabric.elements.share.form.comment.label': 'Viesti (valinnainen)',
    'fabric.elements.share.form.comment.placeholder': "Mit\xe4 muiden tulisi tiet\xe4\xe4?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Vastaanottajat n\xe4kev\xe4t sivun nimen ja viestisi",
    'fabric.elements.share.form.info.message.no.invite.jira': "Vastaanottajat n\xe4kev\xe4t asian nimen ja viestisi",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Vastaanottajat n\xe4kev\xe4t ty\xf6teht\xe4v\xe4n nimen ja viestisi",
    'fabric.elements.share.form.no-permissions': 'Sinulla ei ole jakamisoikeutta.',
    'fabric.elements.share.form.public.send': "L\xe4het\xe4 julkinen linkki",
    'fabric.elements.share.form.public.share': 'Jaa julkinen linkki',
    'fabric.elements.share.form.required-field.summary': "Pakolliset kent\xe4t on merkitty t\xe4hdell\xe4",
    'fabric.elements.share.form.retry': "Yrit\xe4 uudelleen",
    'fabric.elements.share.form.send': "L\xe4het\xe4",
    'fabric.elements.share.form.share': 'Jaa',
    'fabric.elements.share.form.title': 'Jaa',
    'fabric.elements.share.form.user-picker.add-more': "Sy\xf6t\xe4 lis\xe4\xe4",
    'fabric.elements.share.form.user-picker.label.confluence': "Nimet, tiimit, ryhm\xe4t tai s\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Nimet, tiimit tai ryhm\xe4t",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nimet tai tiimit',
    'fabric.elements.share.form.user-picker.label.email-only': "S\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.label.jira': "Nimet, tiimit tai s\xe4hk\xf6postiosoitteet",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Tuloksia ei l\xf6ytynyt haulle "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Tuloksia ei l\xf6ytynyt haulle "{inputValue}". Kutsu henkil\xf6it\xe4 s\xe4hk\xf6postiosoitteen avulla.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "esim. Maria, Oranssi tiimi, ykk\xf6sryhm\xe4",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'esim. Maria, Oranssi tiimi',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'esim. maria@yritys.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'esim. Maria, Oranssi tiimi, maria@yritys.com',
    'fabric.elements.share.form.user-picker.validation.required': "Valitse v\xe4hint\xe4\xe4n yksi k\xe4ytt\xe4j\xe4, ryhm\xe4, tiimi tai s\xe4hk\xf6postiosoite.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi, ryhm\xe4 tai s\xe4hk\xf6postiosoite",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi tai ryhm\xe4",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6 tai tiimi",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Valitse v\xe4hint\xe4\xe4n yksi s\xe4hk\xf6postiosoite",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Valitse v\xe4hint\xe4\xe4n yksi henkil\xf6, tiimi tai s\xe4hk\xf6postiosoite",
    'fabric.elements.share.in.integration.button': 'Jaa sovelluksessa {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Kutsu Confluenceen',
    'fabric.elements.share.invite.to.jira': 'Kutsu Jiraan',
    'fabric.elements.share.main.tab.text.confluence': 'Jaa sivu',
    'fabric.elements.share.main.tab.text.jira': 'Jaa asia',
    'fabric.elements.share.menu.email.label': "S\xe4hk\xf6posti",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Jaa',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogijulkaisu jaettu}board {Taulu jaettu}calendar {Kalenteri jaettu}draft {Luonnos jaettu}filter {Suodatin jaettu}issue {Asia jaettu}summary {Yhteenveto jaettu}list {Luettelo jaettu}timeline {Aikajana jaettu}form {Lomake jaettu}media {Media jaettu}page {Sivu jaettu}project {Projekti jaettu}pullrequest {Pull-pyynt\xf6 jaettu}question {Kysymys jaettu}report {Raportti jaettu}repository {S\xe4il\xf6 jaettu}request {Pyynt\xf6 jaettu}roadmap {Aikajana jaettu}site {Sivusto jaettu}space {Ty\xf6tila jaettu}other {Linkki jaettu}}",
    'fabric.elements.share.to.integration.button': 'Jaa kohteeseen {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Jaa kuvake',
    'fabric.elements.share.trigger.button.invite.text': 'Kutsu',
    'fabric.elements.share.trigger.button.text': 'Jaa',
    'fabric.elements.share.trigger.button.tooltip.text': 'Jaa'
};

});

parcelRegister("byDyk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1bb494a2b2c3eb5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //French (France)
var $f1bb494a2b2c3eb5$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Lien copi\xe9 dans le presse-papier",
    'fabric.elements.share.copylink.button.text': 'Copier le lien',
    'fabric.elements.share.copypubliclink.button.text': 'Copier le lien public',
    'fabric.elements.share.failure.icon.label': "Ic\xf4ne d'erreur",
    'fabric.elements.share.failure.message': 'Partage impossible',
    'fabric.elements.share.form.comment.label': 'Message (facultatif)',
    'fabric.elements.share.form.comment.placeholder': "D'autres choses \xe0 savoir\xa0?",
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Les destinataires verront le nom de la page et votre message',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Les destinataires verront le nom du ticket et votre message',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Les destinataires verront le nom du ticket et votre message',
    'fabric.elements.share.form.no-permissions': 'Vous ne pouvez pas partager ce contenu.',
    'fabric.elements.share.form.public.send': 'Envoyer le lien public',
    'fabric.elements.share.form.public.share': 'Partager un lien public',
    'fabric.elements.share.form.required-field.summary': "Les champs obligatoires sont marqu\xe9s d'un ast\xe9risque",
    'fabric.elements.share.form.retry': "R\xe9essayer",
    'fabric.elements.share.form.send': 'Envoyer',
    'fabric.elements.share.form.share': 'Partager',
    'fabric.elements.share.form.title': 'Partager',
    'fabric.elements.share.form.user-picker.add-more': "Saisir plus d\u2019\xe9l\xe9ments",
    'fabric.elements.share.form.user-picker.label.confluence': "Noms, \xe9quipes, groupes ou e-mails",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Noms, \xe9quipes ou groupes",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Noms ou \xe9quipes",
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': "Noms, \xe9quipes ou e-mails",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Pas de r\xe9sultats pour \xab\xa0{inputValue}\xa0\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Pas de r\xe9sultats pour \xab\xa0{inputValue}\xa0\xbb. Invitez des personnes \xe0 l'aide d'une adresse e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "Par exemple, Maria, \xe9quipe Orange, groupe-1",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "Par exemple, Maria, \xe9quipe Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'Par exemple, maria@entreprise.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': "Par exemple, Maria, \xe9quipe Orange, maria@entreprise.com",
    'fabric.elements.share.form.user-picker.validation.required': "S\xe9lectionnez au moins un utilisateur, un groupe, une \xe9quipe ou une adresse e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "S\xe9lectionnez au moins une personne, une \xe9quipe, un groupe ou un e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "S\xe9lectionnez au moins une personne, une \xe9quipe ou un groupe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "S\xe9lectionnez au moins une personne ou \xe9quipe",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "S\xe9lectionnez au moins un e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "S\xe9lectionnez au moins une personne, une \xe9quipe ou un e-mail",
    'fabric.elements.share.in.integration.button': 'Partager dans {integrationName}',
    'fabric.elements.share.invite.to.confluence': "Inviter \xe0 rejoindre Confluence",
    'fabric.elements.share.invite.to.jira': "Inviter \xe0 rejoindre Jira",
    'fabric.elements.share.main.tab.text.confluence': 'Partager la page',
    'fabric.elements.share.main.tab.text.jira': 'Partager le ticket',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Partager',
    'fabric.elements.share.success.message': "{object, select,blogpost {Billet de blog partag\xe9}board {Tableau partag\xe9}calendar {Calendrier partag\xe9}draft {Brouillon partag\xe9}filter {Filtre partag\xe9}issue {Ticket partag\xe9}summary {R\xe9sum\xe9 partag\xe9}list {Liste partag\xe9e}timeline {Chronologie partag\xe9e}form {Formulaire partag\xe9}media {M\xe9dia partag\xe9}page {Page partag\xe9e}project {Projet partag\xe9}pullrequest {Pull request partag\xe9e}question {Question partag\xe9e}report {Rapport partag\xe9}repository {D\xe9p\xf4t partag\xe9}request {Demande partag\xe9e}roadmap {Chronologie partag\xe9e}site {Site partag\xe9}space {Espace partag\xe9}other {Lien partag\xe9}}",
    'fabric.elements.share.to.integration.button': 'Partager avec {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "Ic\xf4ne de partage",
    'fabric.elements.share.trigger.button.invite.text': 'Inviter',
    'fabric.elements.share.trigger.button.text': 'Partager',
    'fabric.elements.share.trigger.button.tooltip.text': 'Partager'
};

});

parcelRegister("9y8hX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b7ac209639193ae$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Hungarian
var $7b7ac209639193ae$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Hivatkoz\xe1s \xe1tm\xe1solva a v\xe1g\xf3lapra",
    'fabric.elements.share.copylink.button.text': "Hivatkoz\xe1s m\xe1sol\xe1sa",
    'fabric.elements.share.copypubliclink.button.text': "Publikus link m\xe1sol\xe1sa",
    'fabric.elements.share.failure.icon.label': 'Hiba ikon',
    'fabric.elements.share.failure.message': 'Nem lehet megosztani',
    'fabric.elements.share.form.comment.label': "\xdczenet (nem k\xf6telez\u0151)",
    'fabric.elements.share.form.comment.placeholder': "Van b\xe1rmi, amit \xe9rdemes tudni?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "A c\xedmzettek l\xe1tj\xe1k az oldal nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.info.message.no.invite.jira': "A c\xedmzettek l\xe1tj\xe1k az \xfcgy nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "A c\xedmzettek l\xe1tj\xe1k az \xfcgy nev\xe9t \xe9s az \xfczenetedet",
    'fabric.elements.share.form.no-permissions': "Nincs lehet\u0151s\xe9ged a megoszt\xe1sra.",
    'fabric.elements.share.form.public.send': "Publikus link k\xfcld\xe9se",
    'fabric.elements.share.form.public.share': "Nyilv\xe1nos link megoszt\xe1sa",
    'fabric.elements.share.form.required-field.summary': "A k\xf6telez\u0151 mez\u0151k csillaggal vannak megjel\xf6lve",
    'fabric.elements.share.form.retry': "\xdajra",
    'fabric.elements.share.form.send': "K\xfcld\xe9s",
    'fabric.elements.share.form.share': "Megoszt\xe1s",
    'fabric.elements.share.form.title': "Megoszt\xe1s",
    'fabric.elements.share.form.user-picker.add-more': "Tov\xe1bbiak megad\xe1sa",
    'fabric.elements.share.form.user-picker.label.confluence': "Nevek, csapatok, csoportok vagy e-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nevek, csapatok vagy csoportok',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nevek vagy csapatok',
    'fabric.elements.share.form.user-picker.label.email-only': "E-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.label.jira': "Nevek, csapatok vagy e-mail-c\xedmek",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nincs tal\xe1lat a k\xf6vetkez\u0151 keres\xe9sre: \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nincs tal\xe1lat a k\xf6vetkez\u0151 keres\xe9sre: \u201E{inputValue}\u201D. H\xedvj meg embereket az e-mail-c\xedm\xfck alapj\xe1n.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "pl. M\xe1ria, Narancs csapat, egyes-csoport",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "pl. M\xe1ria, Narancs csapat",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'pl. maria@vallalat.hu',
    'fabric.elements.share.form.user-picker.placeholder.jira': "pl. M\xe1ria, Narancs csapat, maria@vallalat.hu",
    'fabric.elements.share.form.user-picker.validation.required': "V\xe1lassz ki legal\xe1bb egy felhaszn\xe1l\xf3t, csoportot, csapatot vagy e-mail-c\xedmet.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot, csoportot vagy e-mail-c\xedmet",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot vagy csoportot",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt vagy csapatot",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe1lassz ki legal\xe1bb egy e-mail-c\xedmet",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe1lassz ki legal\xe1bb egy szem\xe9lyt, csapatot vagy e-mail-c\xedmet",
    'fabric.elements.share.in.integration.button': "Megoszt\xe1s itt: {integrationName}",
    'fabric.elements.share.invite.to.confluence': "Megh\xedv\xe1s a Confluence-be",
    'fabric.elements.share.invite.to.jira': "Megh\xedv\xe1s a Jir\xe1ba",
    'fabric.elements.share.main.tab.text.confluence': "Oldal megoszt\xe1sa",
    'fabric.elements.share.main.tab.text.jira': "\xdcgy megoszt\xe1sa",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Megoszt\xe1s",
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogposzt megosztva}board {T\xe1bla megosztva}calendar {Napt\xe1r megosztva}draft {Piszkozat megosztva}filter {Sz\u0171r\u0151 megosztva}issue {\xdcgy megosztva}summary {\xd6sszefoglal\xf3 megosztva}list {Lista megosztva}timeline {Id\u0151vonal megosztva}form {\u0170rlap megosztva}media {M\xe9dia megosztva}page {Oldal megosztva}project {Projekt megosztva}pullrequest {Pull-k\xe9relem megosztva}question {K\xe9rd\xe9s megosztva}report {Jelent\xe9s megosztva}repository {Adatt\xe1r megosztva}request {K\xe9relem megosztva}roadmap {Id\u0151vonal megosztva}site {Webhely megosztva}space {Munkat\xe9r megosztva}other {Link megosztva}}",
    'fabric.elements.share.to.integration.button': "Megoszt\xe1s itt: {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikon megoszt\xe1sa",
    'fabric.elements.share.trigger.button.invite.text': "Megh\xedv\xe1s",
    'fabric.elements.share.trigger.button.text': "Megoszt\xe1s",
    'fabric.elements.share.trigger.button.tooltip.text': "Megoszt\xe1s"
};

});

parcelRegister("bMFAQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $567821fb7188ce82$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Icelandic
var $567821fb7188ce82$export$2e2bcd8739ae039 = {
    'fabric.elements.share.form.title': 'Deila',
    'fabric.elements.share.form.send': 'Senda ',
    'fabric.elements.share.form.retry': 'Reyna aftur',
    'fabric.elements.share.form.comment.placeholder': "B\xe6ta vi\xf0 skilabo\xf0um",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Sl\xe1\xf0u inn nafn, teymi e\xf0a t\xf6lvup\xf3stur",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Sl\xe1\xf0u inn nafn e\xf0a teymi",
    'fabric.elements.share.form.user-picker.add-more': "F\xe6ra inn fleiri ",
    'fabric.elements.share.form.user-picker.validation.required': "Veldu a\xf0 minnsta kosti einn notanda, teymi e\xf0a netfang.",
    'fabric.elements.share.form.user-picker.no-options.domainBasedUserOnly': "\xde\xfa getur a\xf0eins bo\xf0i\xf0 f\xf3lki sem eru me\xf0 {domains} netf\xf6ng. Haf\xf0u samband vi\xf0 stj\xf3rnanda s\xed\xf0unnar \xfeinnar til a\xf0 bj\xf3\xf0a \xf6\xf0ru f\xf3lki.",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Ekki fundust neinar ni\xf0urst\xf6\xf0ur fyrir \u201E{inputValue}\u201C. Bj\xf3ddu f\xf3lki me\xf0 \xfev\xed a\xf0 nota netf\xf6ng.",
    'fabric.elements.share.form.user-picker.no-options.generic': 'Engar ni\xf0urst\xf6\xf0ur fundust fyrir "{inputValue}". Bj\xf3ddu f\xf3lki me\xf0 \xfev\xed a\xf0 nota t\xf6lvup\xf3stfang.',
    'fabric.elements.share.trigger.button.icon.label': "Deilingart\xe1kn",
    'fabric.elements.share.trigger.button.text': 'Deila',
    'fabric.elements.share.trigger.button.tooltip.text': 'Deila',
    'fabric.elements.share.trigger.button.invite.text': "Bo\xf0i\xf0",
    'fabric.elements.share.copylink.button.icon.label': "\u201EAfrita tengil\u201C-t\xe1kn",
    'fabric.elements.share.copylink.button.text': 'Afrita tengil',
    'fabric.elements.share.copied.to.clipboard.icon.label': "T\xe1kn sem s\xfdnir a\xf0 tengilinn hafi veri\xf0 afrita\xf0ur me\xf0 g\xf3\xf0um \xe1rangri",
    'fabric.elements.share.copied.to.clipboard.message': "Tengill afrita\xf0ur \xe1 klippibor\xf0",
    'fabric.elements.share.form.capabilities.info.message': "Bo\xf0skorti\xf0 \xfeitt ver\xf0ur sent til stj\xf3rnanda til sam\xfeykkis",
    'fabric.elements.share.failure.icon.label': "Villut\xe1kn",
    'fabric.elements.share.failure.message': "Ekki er h\xe6gt a\xf0 deila",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blog post shared} tafla {Board shared} dagatal {Calendar shared} uppkast {Draft shared} s\xeda {Filter shared} m\xe1lefni {Issue shared} mi\xf0ill {Media shared} s\xed\xf0a {Page shared} verkefni {Project shared} togbei\xf0ni {Pull Request shared} spurning {Question shared} sk\xfdrsla {Report shared} Gagnageymsla {Repository shared} bei\xf0ni {Request shared} vegv\xedsir {Roadmap shared} s\xed\xf0a {Site shared} sv\xe6\xf0i {Space shared} anna\xf0 {Link Shared}}",
    'fabric.elements.share.admin.notified.message': "Stj\xf3rnanda hefur veri\xf0 tilkynnt"
};

});

parcelRegister("4JZF5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee9f8422b31a9859$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Italian (Italy)
var $ee9f8422b31a9859$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link copiato negli appunti',
    'fabric.elements.share.copylink.button.text': 'Copia link',
    'fabric.elements.share.copypubliclink.button.text': 'Copia link pubblico',
    'fabric.elements.share.failure.icon.label': 'Icona Errore',
    'fabric.elements.share.failure.message': 'Impossibile effettuare la condivisione',
    'fabric.elements.share.form.comment.label': 'Messaggio (opzionale)',
    'fabric.elements.share.form.comment.placeholder': 'Vuoi comunicare loro qualcosa?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'I destinatari vedranno il nome della pagina e il tuo messaggio',
    'fabric.elements.share.form.info.message.no.invite.jira': 'I destinatari vedranno il nome del ticket e il tuo messaggio',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'I destinatari vedranno il nome del ticket e il tuo messaggio',
    'fabric.elements.share.form.no-permissions': 'Non puoi eseguire condivisioni.',
    'fabric.elements.share.form.public.send': 'Invia link pubblico',
    'fabric.elements.share.form.public.share': 'Condividi link pubblico',
    'fabric.elements.share.form.required-field.summary': 'I campi obbligatori sono contrassegnati da un asterisco',
    'fabric.elements.share.form.retry': 'Riprova',
    'fabric.elements.share.form.send': 'Invia',
    'fabric.elements.share.form.share': 'Condividi',
    'fabric.elements.share.form.title': 'Condividi',
    'fabric.elements.share.form.user-picker.add-more': 'Inerisci altri elementi',
    'fabric.elements.share.form.user-picker.label.confluence': 'Nomi, team, gruppi o indirizzi e-mail',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomi, team o gruppi',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomi o team',
    'fabric.elements.share.form.user-picker.label.email-only': 'Indirizzi e-mail',
    'fabric.elements.share.form.user-picker.label.jira': 'Nomi, team o indirizzi e-mail',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nessun risultato trovato per \u201C{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nessun risultato trovato per \u201C{inputValue}\u201D. Invita le persone inserendo il loro indirizzo e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'ad esempio Maria, Team Arancione, gruppo uno',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'ad esempio Maria, Team Arancione',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'ad esempio maria@azienda.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'ad esempio Maria, Team Arancione, maria@azienda.com',
    'fabric.elements.share.form.user-picker.validation.required': "Seleziona almeno un utente, un gruppo, un team o un'e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Seleziona almeno una persona, un team, un gruppo o un indirizzo e-mail.',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Seleziona almeno una persona, un team o un gruppo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Seleziona almeno una persona o un team.',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Seleziona almeno un indirizzo e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Seleziona almeno una persona, un team o un indirizzo e-mail',
    'fabric.elements.share.in.integration.button': 'Condividi in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Invita in Confluence',
    'fabric.elements.share.invite.to.jira': 'Invita in Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Condividi pagina',
    'fabric.elements.share.main.tab.text.jira': 'Condividi ticket',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Condividi',
    'fabric.elements.share.success.message': '{object, select,blogpost {Post del blog condiviso}board {Board condivisa}calendar {Calendario condiviso}draft {Bozza condivisa}filter {Filtro condiviso}issue {Ticket condiviso}summary {Riepilogo condiviso}list {Elenco condiviso}timeline {Timeline condivisa}form {Modulo condiviso}media {Elemento multimediale condiviso}page {Pagina condiviso}project {Progetto condiviso}pullrequest {Pull request condivisa}question {Domanda condivisa}report {Report condiviso}repository {Repository condiviso}request {Richiesta condivisa}roadmap {Timeline condivisa}site {Sito condiviso}space {Spazio condiviso}other {Link condiviso}}',
    'fabric.elements.share.to.integration.button': 'Condividi in {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Icona Condividi',
    'fabric.elements.share.trigger.button.invite.text': 'Invita',
    'fabric.elements.share.trigger.button.text': 'Condividi',
    'fabric.elements.share.trigger.button.tooltip.text': 'Condividi'
};

});

parcelRegister("dzumV", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb77872613c037b3$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Japanese
var $eb77872613c037b3$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F",
    'fabric.elements.share.copylink.button.text': "\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.elements.share.copypubliclink.button.text': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u30B3\u30D4\u30FC",
    'fabric.elements.share.failure.icon.label': "\u30A8\u30E9\u30FC \u30A2\u30A4\u30B3\u30F3",
    'fabric.elements.share.failure.message': "\u5171\u6709\u3067\u304D\u307E\u305B\u3093",
    'fabric.elements.share.form.comment.label': "\u30E1\u30C3\u30BB\u30FC\u30B8 (\u30AA\u30D7\u30B7\u30E7\u30F3)",
    'fabric.elements.share.form.comment.placeholder': "\u5171\u6709\u5148\u306E\u30E6\u30FC\u30B6\u30FC\u3078\u306E\u30B3\u30E1\u30F3\u30C8\u304C\u3042\u308B\u5834\u5408\u306F\u3053\u3053\u306B\u66F8\u304D\u8FBC\u307F\u307E\u3059\u3002",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u53D7\u4FE1\u8005\u306B\u30DA\u30FC\u30B8\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u53D7\u4FE1\u8005\u306B\u8AB2\u984C\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u53D7\u4FE1\u8005\u306B\u4F5C\u696D\u9805\u76EE\u306E\u540D\u524D\u3068\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059",
    'fabric.elements.share.form.no-permissions': "\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u3002",
    'fabric.elements.share.form.public.send': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u9001\u4FE1",
    'fabric.elements.share.form.public.share': "\u516C\u958B\u30EA\u30F3\u30AF\u3092\u5171\u6709",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u9808\u30D5\u30A3\u30FC\u30EB\u30C9\u306B\u306F\u30A2\u30B9\u30BF\u30EA\u30B9\u30AF\u304C\u4ED8\u3044\u3066\u3044\u307E\u3059",
    'fabric.elements.share.form.retry': "\u518D\u8A66\u884C",
    'fabric.elements.share.form.send': "\u9001\u4FE1",
    'fabric.elements.share.form.share': "\u5171\u6709",
    'fabric.elements.share.form.title': "\u5171\u6709",
    'fabric.elements.share.form.user-picker.add-more': "\u3055\u3089\u306B\u8FFD\u52A0",
    'fabric.elements.share.form.user-picker.label.confluence': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B0\u30EB\u30FC\u30D7",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u540D\u524D\u307E\u305F\u306F\u30C1\u30FC\u30E0",
    'fabric.elements.share.form.user-picker.label.email-only': "\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.label.jira': "\u540D\u524D\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}" \u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}" \u306B\u4E00\u81F4\u3059\u308B\u7D50\u679C\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u4F7F\u7528\u3057\u3066\u30E6\u30FC\u30B6\u30FC\u3092\u62DB\u5F85\u3057\u3066\u304F\u3060\u3055\u3044\u3002',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8\u3001\u30B0\u30EB\u30FC\u30D7\u30EF\u30F3",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B: sato@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B: \u4F50\u85E4\u3001\u30C1\u30FC\u30E0 \u30AA\u30EC\u30F3\u30B8\u3001sato@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u30E6\u30FC\u30B6\u30FC\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u30C1\u30FC\u30E0\u3001\u30E1\u30FC\u30EB\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u30B0\u30EB\u30FC\u30D7\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30B0\u30EB\u30FC\u30D7\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u30E6\u30FC\u30B6\u30FC\u307E\u305F\u306F\u30C1\u30FC\u30E0\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u30E6\u30FC\u30B6\u30FC\u3001\u30C1\u30FC\u30E0\u3001\u307E\u305F\u306F\u30E1\u30FC\u30EB \u30A2\u30C9\u30EC\u30B9\u3092\u5C11\u306A\u304F\u3068\u3082 1 \u3064\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044",
    'fabric.elements.share.in.integration.button': "{integrationName} \u3067\u5171\u6709",
    'fabric.elements.share.invite.to.confluence': "Confluence \u306B\u62DB\u5F85",
    'fabric.elements.share.invite.to.jira': "Jira \u306B\u62DB\u5F85",
    'fabric.elements.share.main.tab.text.confluence': "\u30DA\u30FC\u30B8\u3092\u5171\u6709",
    'fabric.elements.share.main.tab.text.jira': "\u8AB2\u984C\u3092\u5171\u6709",
    'fabric.elements.share.menu.email.label': "\u30E1\u30FC\u30EB",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5171\u6709",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u30D6\u30ED\u30B0\u6295\u7A3F\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}board {\u30DC\u30FC\u30C9\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}calendar {\u30AB\u30EC\u30F3\u30C0\u30FC\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}draft {\u4E0B\u66F8\u304D\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}filter {\u30D5\u30A3\u30EB\u30BF\u30FC\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}issue {\u8AB2\u984C\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}summary {\u8981\u7D04\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}list {\u30EA\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}timeline {\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}form {\u30D5\u30A9\u30FC\u30E0\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}media {\u30E1\u30C7\u30A3\u30A2\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}page {\u30DA\u30FC\u30B8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}project {\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}pullrequest {\u30D7\u30EB \u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}question {\u8CEA\u554F\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}report {\u30EC\u30DD\u30FC\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}repository {\u30EA\u30DD\u30B8\u30C8\u30EA\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}request {\u30EA\u30AF\u30A8\u30B9\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}roadmap {\u30BF\u30A4\u30E0\u30E9\u30A4\u30F3\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}site {\u30B5\u30A4\u30C8\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}space {\u30B9\u30DA\u30FC\u30B9\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}other {\u30EA\u30F3\u30AF\u304C\u5171\u6709\u3055\u308C\u307E\u3057\u305F}}",
    'fabric.elements.share.to.integration.button': "{integrationName} \u3068\u5171\u6709",
    'fabric.elements.share.trigger.button.icon.label': "\u5171\u6709\u30A2\u30A4\u30B3\u30F3",
    'fabric.elements.share.trigger.button.invite.text': "\u62DB\u5F85",
    'fabric.elements.share.trigger.button.text': "\u5171\u6709",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5171\u6709"
};

});

parcelRegister("fH3rr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c880483be1fc144$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $6c880483be1fc144$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\uB9C1\uD06C\uB97C \uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uD568",
    'fabric.elements.share.copylink.button.text': "\uB9C1\uD06C \uBCF5\uC0AC",
    'fabric.elements.share.copypubliclink.button.text': "\uACF5\uAC1C \uB9C1\uD06C \uBCF5\uC0AC",
    'fabric.elements.share.failure.icon.label': "\uC624\uB958 \uC544\uC774\uCF58",
    'fabric.elements.share.failure.message': "\uACF5\uC720\uD560 \uC218 \uC5C6\uC74C",
    'fabric.elements.share.form.comment.label': "\uBA54\uC2DC\uC9C0(\uC120\uD0DD \uC0AC\uD56D)",
    'fabric.elements.share.form.comment.placeholder': "\uC0AC\uC6A9\uC790\uAC00 \uC54C\uC544\uC57C \uD560 \uB0B4\uC6A9\uC774 \uC788\uC2B5\uB2C8\uAE4C?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\uC218\uC2E0\uC790\uAC00 \uD398\uC774\uC9C0 \uC774\uB984\uACFC \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.info.message.no.invite.jira': "\uC218\uC2E0\uC790\uAC00 \uC774\uC288 \uC774\uB984\uACFC \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\uC218\uC2E0\uC790\uAC00 \uC5C5\uBB34 \uD56D\uBAA9 \uC774\uB984 \uBC0F \uBA54\uC2DC\uC9C0\uB97C \uBCFC \uC218 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.no-permissions': "\uACF5\uC720\uD560 \uAD8C\uD55C\uC774 \uC5C6\uC2B5\uB2C8\uB2E4.",
    'fabric.elements.share.form.public.send': "\uACF5\uAC1C \uB9C1\uD06C \uBCF4\uB0B4\uAE30",
    'fabric.elements.share.form.public.share': "\uACF5\uAC1C \uB9C1\uD06C \uACF5\uC720",
    'fabric.elements.share.form.required-field.summary': "\uD544\uC218 \uD544\uB4DC\uB294 \uBCC4\uD45C\uB85C \uD45C\uC2DC\uB418\uC5B4 \uC788\uC2B5\uB2C8\uB2E4",
    'fabric.elements.share.form.retry': "\uB2E4\uC2DC \uC2DC\uB3C4",
    'fabric.elements.share.form.send': "\uBCF4\uB0B4\uAE30",
    'fabric.elements.share.form.share': "\uACF5\uC720",
    'fabric.elements.share.form.title': "\uACF5\uC720",
    'fabric.elements.share.form.user-picker.add-more': "\uB354 \uC785\uB825\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.label.confluence': "\uC774\uB984, \uD300, \uADF8\uB8F9 \uB610\uB294 \uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\uC774\uB984, \uD300 \uB610\uB294 \uADF8\uB8F9",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\uC774\uB984 \uB610\uB294 \uD300",
    'fabric.elements.share.form.user-picker.label.email-only': "\uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.label.jira': "\uC774\uB984, \uD300 \uB610\uB294 \uC774\uBA54\uC77C",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': '"{inputValue}"\uC5D0 \uB300\uD55C \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4.',
    'fabric.elements.share.form.user-picker.no-options.generic': '"{inputValue}"\uC5D0 \uB300\uD55C \uACB0\uACFC\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4. \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC0AC\uC6A9\uC790\uB97C \uCD08\uB300\uD558\uC138\uC694.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\uC608: Maria, Team Orange, group-one",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\uC608: Maria, Team Orange",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\uC608: maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\uC608: Maria, Team Orange, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\uC0AC\uC6A9\uC790, \uADF8\uB8F9, \uD300 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\uC0AC\uC6A9\uC790, \uD300, \uADF8\uB8F9 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\uC0AC\uC6A9\uC790, \uD300 \uB610\uB294 \uADF8\uB8F9\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\uC0AC\uC6A9\uC790 \uB610\uB294 \uD300\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\uC0AC\uC6A9\uC790, \uD300 \uB610\uB294 \uC774\uBA54\uC77C\uC744 \uD558\uB098 \uC774\uC0C1 \uC120\uD0DD\uD558\uC138\uC694",
    'fabric.elements.share.in.integration.button': "{integrationName}\uC5D0\uC11C \uACF5\uC720",
    'fabric.elements.share.invite.to.confluence': "Confluence\uC5D0 \uCD08\uB300",
    'fabric.elements.share.invite.to.jira': "Jira\uC5D0 \uCD08\uB300",
    'fabric.elements.share.main.tab.text.confluence': "\uD398\uC774\uC9C0 \uACF5\uC720",
    'fabric.elements.share.main.tab.text.jira': "\uC774\uC288 \uACF5\uC720",
    'fabric.elements.share.menu.email.label': "\uC774\uBA54\uC77C",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\uACF5\uC720",
    'fabric.elements.share.success.message': "{object, select,blogpost {\uACF5\uC720\uD55C \uBE14\uB85C\uADF8 \uAC8C\uC2DC\uBB3C}board {\uACF5\uC720\uD55C \uBCF4\uB4DC}calendar {\uACF5\uC720\uD55C \uCE98\uB9B0\uB354}draft {\uACF5\uC720\uD55C \uCD08\uC548}filter {\uACF5\uC720\uD55C \uD544\uD130}issue {\uACF5\uC720\uD55C \uC774\uC288}summary {\uACF5\uC720\uD55C \uC694\uC57D}list {\uACF5\uC720\uD55C \uBAA9\uB85D}timeline {\uACF5\uC720\uD55C \uD0C0\uC784\uB77C\uC778}form {\uACF5\uC720\uD55C \uC591\uC2DD}media {\uACF5\uC720\uD55C \uBBF8\uB514\uC5B4}page {\uACF5\uC720\uD55C \uD398\uC774\uC9C0}project {\uACF5\uC720\uD55C \uD504\uB85C\uC81D\uD2B8}pullrequest {\uACF5\uC720\uD55C \uD480\uB9AC\uD018\uC2A4\uD2B8}question {\uACF5\uC720\uD55C \uC9C8\uBB38}report {\uACF5\uC720\uD55C \uBCF4\uACE0\uC11C}repository {\uACF5\uC720\uD55C \uB9AC\uD3EC\uC9C0\uD1A0\uB9AC}request {\uACF5\uC720\uD55C \uC694\uCCAD}timeline {\uACF5\uC720\uD55C \uD0C0\uC784\uB77C\uC778}site {\uACF5\uC720\uD55C \uC0AC\uC774\uD2B8}space {\uACF5\uC720\uD55C \uC2A4\uD398\uC774\uC2A4}other {\uACF5\uC720\uD55C \uB9C1\uD06C}}",
    'fabric.elements.share.to.integration.button': "{integrationName}\uC5D0 \uACF5\uC720",
    'fabric.elements.share.trigger.button.icon.label': "\uACF5\uC720 \uC544\uC774\uCF58",
    'fabric.elements.share.trigger.button.invite.text': "\uCD08\uB300",
    'fabric.elements.share.trigger.button.text': "\uACF5\uC720",
    'fabric.elements.share.trigger.button.tooltip.text': "\uACF5\uC720"
};

});

parcelRegister("16RW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa1be7e35603d5ed$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Norwegian (Bokmål)
var $fa1be7e35603d5ed$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Kobling er kopiert til utklippstavlen',
    'fabric.elements.share.copylink.button.text': 'Kopier kobling',
    'fabric.elements.share.copypubliclink.button.text': 'Kopier offentlig tilgjengelig kobling',
    'fabric.elements.share.failure.icon.label': 'Feil-ikon',
    'fabric.elements.share.failure.message': 'Kan ikke deles',
    'fabric.elements.share.form.comment.label': 'Melding (valgfritt)',
    'fabric.elements.share.form.comment.placeholder': "Er det noe mottakerne b\xf8r vite om dette?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Mottakerne vil se navnet p\xe5 siden og meldingen",
    'fabric.elements.share.form.info.message.no.invite.jira': "Mottakerne vil se navnet p\xe5 saken og meldingen",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Mottakerne vil se navnet p\xe5 arbeidsoppgaven og meldingen",
    'fabric.elements.share.form.no-permissions': "Du har ikke muligheten til \xe5 dele.",
    'fabric.elements.share.form.public.send': 'Send offentlig tilgjengelig kobling',
    'fabric.elements.share.form.public.share': 'Del offentlig kobling',
    'fabric.elements.share.form.required-field.summary': 'Obligatoriske felt er merket med stjerne',
    'fabric.elements.share.form.retry': "Pr\xf8v igjen",
    'fabric.elements.share.form.send': 'Send',
    'fabric.elements.share.form.share': 'Del',
    'fabric.elements.share.form.title': 'Del',
    'fabric.elements.share.form.user-picker.add-more': 'Legg til mer',
    'fabric.elements.share.form.user-picker.label.confluence': 'Navn, team, grupper eller e-poster',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navn, team eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navn eller team',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-poster',
    'fabric.elements.share.form.user-picker.label.jira': 'Navn, team eller e-poster',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi kunne ikke finne noen resultater for "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi kunne ikke finne noen resultater for "{inputValue}". Inviter personer ved \xe5 bruke en e-postadresse.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': "f.eks. Maria, oransje team, gruppe \xe9n",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, oransje team',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, oransje team, maria@company.com',
    'fabric.elements.share.form.user-picker.validation.required': "Velg minst \xe9n bruker, gruppe eller e-post eller minst ett team.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Velg minst \xe9n person, gruppe, e-postadresse eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Velg minst \xe9n person, gruppe eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Velg minst \xe9n person eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Velg minst \xe9n e-postadresse",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Velg minst \xe9n person, gruppe, e-postadresse eller ett team",
    'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
    'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Del side',
    'fabric.elements.share.main.tab.text.jira': 'Del sak',
    'fabric.elements.share.menu.email.label': 'E-post',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Del',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogginnlegg er delt}board {Tavle er delt}calendar {Kalender er delt}draft {Utkast er delt}filter {Filter er delt}issue {Sak er delt}summary {Sammendrag er delt}list {Liste er delt}timeline {Tidslinje er delt}form {Skjema er delt}media {Medier er delt}page {Side er delt}project {Prosjekt er delt}pullrequest {Pull-foresp\xf8rsel er delt}question {Sp\xf8rsm\xe5l er delt}report {Rapport er delt}repository {Repositorium er delt}request {Foresp\xf8rsel er delt}roadmap {Veikart er delt}site {Nettsted er delt}space {Omr\xe5de er delt}other {Kobling er delt}}",
    'fabric.elements.share.to.integration.button': 'Del til {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Dele-ikon',
    'fabric.elements.share.trigger.button.invite.text': 'Inviter',
    'fabric.elements.share.trigger.button.text': 'Del',
    'fabric.elements.share.trigger.button.tooltip.text': 'Del'
};

});

parcelRegister("hrNSu", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cf381178f2c2c61$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $9cf381178f2c2c61$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': 'Link naar klembord gekopieerd',
    'fabric.elements.share.copylink.button.text': "Link kopi\xebren",
    'fabric.elements.share.copypubliclink.button.text': "Openbare link kopi\xebren",
    'fabric.elements.share.failure.icon.label': "Pictogram 'Fout'",
    'fabric.elements.share.failure.message': 'Kan niet delen',
    'fabric.elements.share.form.comment.label': 'Bericht (optioneel)',
    'fabric.elements.share.form.comment.placeholder': 'Is er iets ze moet weten?',
    'fabric.elements.share.form.info.message.no.invite.confluence': 'Ontvangers zien de naam van de pagina en je bericht',
    'fabric.elements.share.form.info.message.no.invite.jira': 'Ontvangers zien de naam van de issue en je bericht',
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': 'Ontvangers zien de naam van het werkitem en je bericht',
    'fabric.elements.share.form.no-permissions': 'Je kunt niet delen.',
    'fabric.elements.share.form.public.send': 'Openbare link verzenden',
    'fabric.elements.share.form.public.share': 'Openbare link delen',
    'fabric.elements.share.form.required-field.summary': 'Verplichte velden zijn aangeduid met een asterisk',
    'fabric.elements.share.form.retry': 'Opnieuw proberen',
    'fabric.elements.share.form.send': 'Verzenden',
    'fabric.elements.share.form.share': 'Delen',
    'fabric.elements.share.form.title': 'Delen',
    'fabric.elements.share.form.user-picker.add-more': 'Meer invoeren',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namen, teams, groepen of e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namen, teams of groepen',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namen of teams',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Namen, teams of e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Geen resultaten gevonden voor ''{inputValue}'.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Geen resultaten gevonden voor ''{inputValue}'. Nodig personen uit door hun e-mailadres in te voeren.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'bijv. Maria, team Oranje, groep-een',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'bijv. Maria, team Oranje',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'bijv. Maria, maria@bedrijf.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'bijv. Maria, team Oranje, maria@bedrijf.com',
    'fabric.elements.share.form.user-picker.validation.required': "Selecteer minimaal \xe9\xe9n gebruiker, groep, team of e-mailadres.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Selecteer minimaal \xe9\xe9n persoon, team, groep of e-mailadres",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Selecteer minimaal \xe9\xe9n persoon, team of groep",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Selecteer minimaal \xe9\xe9n persoon of team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "Selecteer minimaal \xe9\xe9n e-mailadres",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Selecteer minimaal \xe9\xe9n persoon, team of e-mailadres",
    'fabric.elements.share.in.integration.button': 'Delen in {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Uitnodigen voor Confluence',
    'fabric.elements.share.invite.to.jira': 'Uitnodigen voor Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Pagina delen',
    'fabric.elements.share.main.tab.text.jira': 'Issue delen',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Delen',
    'fabric.elements.share.success.message': '{object, select,blogpost {Blogpost gedeeld}board {Bord gedeeld}calendar {Agenda gedeeld}draft {Concept gedeeld}filter {Filter gedeeld}issue {Issue gedeeld}summary {Samenvatting gedeeld}list {Lijst gedeeld}timeline {Tijdlijn gedeeld}form {Formulier gedeeld}media {Media gedeeld}page {Pagina gedeeld}project {Project gedeeld}pullrequest {Pull-request gedeeld}question {Vraag gedeeld}report {Rapport gedeeld}repository {Repository gedeeld}request {Aanvraag gedeeld}roadmap {Tijdlijn gedeeld}site {Site gedeeld}space {Space gedeeld}other {Link gedeeld}}',
    'fabric.elements.share.to.integration.button': 'Delen met {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "Pictogram 'Delen'",
    'fabric.elements.share.trigger.button.invite.text': 'Uitnodigen',
    'fabric.elements.share.trigger.button.text': 'Delen',
    'fabric.elements.share.trigger.button.tooltip.text': 'Delen'
};

});

parcelRegister("ioYTp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7d711b9dc04d41d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Polish (Poland)
var $f7d711b9dc04d41d$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0141\u0105cze skopiowano do schowka",
    'fabric.elements.share.copylink.button.text': "Kopiuj \u0142\u0105cze",
    'fabric.elements.share.copypubliclink.button.text': "Kopiuj \u0142\u0105cze publiczne",
    'fabric.elements.share.failure.icon.label': "Ikona b\u0142\u0119du",
    'fabric.elements.share.failure.message': "Nie mo\u017Cna udost\u0119pni\u0107",
    'fabric.elements.share.form.comment.label': "Wiadomo\u015B\u0107 (opcjonalnie)",
    'fabric.elements.share.form.comment.placeholder': "Czy jest co\u015B, o czym powinni wiedzie\u0107?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Odbiorcy zobacz\u0105 nazw\u0119 strony i Tw\xf3j komunikat",
    'fabric.elements.share.form.info.message.no.invite.jira': "Odbiorcy zobacz\u0105 nazw\u0119 zg\u0142oszenia i Tw\xf3j komunikat",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Odbiorcy zobacz\u0105 nazw\u0119 zg\u0142oszenia i\xa0Tw\xf3j komunikat.",
    'fabric.elements.share.form.no-permissions': "Nie mo\u017Cesz udost\u0119pnia\u0107.",
    'fabric.elements.share.form.public.send': "Wy\u015Blij \u0142\u0105cze publiczne",
    'fabric.elements.share.form.public.share': "Udost\u0119pnij \u0142\u0105cze publiczne",
    'fabric.elements.share.form.required-field.summary': "Pola wymagane s\u0105 oznaczone gwiazdk\u0105",
    'fabric.elements.share.form.retry': "Spr\xf3buj ponownie",
    'fabric.elements.share.form.send': "Wy\u015Blij",
    'fabric.elements.share.form.share': "Udost\u0119pnij",
    'fabric.elements.share.form.title': "Udost\u0119pnij",
    'fabric.elements.share.form.user-picker.add-more': "Wprowad\u017A wi\u0119cej",
    'fabric.elements.share.form.user-picker.label.confluence': "Nazwy, zespo\u0142y, grupy lub adresy e-mail",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "Nazwy, zespo\u0142y lub grupy",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "Nazwy lub zespo\u0142y",
    'fabric.elements.share.form.user-picker.label.email-only': 'Adresy e-mail',
    'fabric.elements.share.form.user-picker.label.jira': "Nazwy, zespo\u0142y lub adresy e-mail",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nie znaleziono wynik\xf3w dla \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nie znaleziono wynik\xf3w dla \u201E{inputValue}\u201D. Zapro\u015B u\u017Cytkownik\xf3w, podaj\u0105c adres e-mail.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy, grupa 1",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy",
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'np. maria@firma.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': "np. Maria, zesp\xf3\u0142 pomara\u0144czowy, maria@firma.com",
    'fabric.elements.share.form.user-picker.validation.required': "Wybierz co najmniej jednego u\u017Cytkownika, jedn\u0105 grup\u0119 albo jeden zesp\xf3\u0142 lub adres e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142, jedn\u0105 grup\u0119 lub jeden adres e-mail",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142 lub jedn\u0105 grup\u0119",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "Wybierz co najmniej jedn\u0105 osob\u0119 lub jeden zesp\xf3\u0142",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Wybierz co najmniej jeden adres e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "Wybierz co najmniej jedn\u0105 osob\u0119, jeden zesp\xf3\u0142 lub jeden adres e-mail",
    'fabric.elements.share.in.integration.button': "Udost\u0119pnij w {integrationName}",
    'fabric.elements.share.invite.to.confluence': "Zapro\u015B do\xa0Confluence",
    'fabric.elements.share.invite.to.jira': "Zapro\u015B do\xa0systemu Jira",
    'fabric.elements.share.main.tab.text.confluence': "Udost\u0119pnij stron\u0119",
    'fabric.elements.share.main.tab.text.jira': "Udost\u0119pnij zg\u0142oszenie",
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "Udost\u0119pnij",
    'fabric.elements.share.success.message': "{object, select,blogpost {Udost\u0119pniono wpis na blogu}board {Udost\u0119pniono tablic\u0119}calendar {Udost\u0119pniono kalendarz}draft {Udost\u0119pniono wersj\u0119 robocz\u0105}filter {Udost\u0119pniono filtr}issue {Udost\u0119pniono zg\u0142oszenie}summary {Udost\u0119pniono podsumowanie}list {Udost\u0119pniono list\u0119}timeline {Udost\u0119pniono o\u015B czasu}form {Udost\u0119pniono formularz}media {Udost\u0119pniono multimedia}page {Udost\u0119pniono stron\u0119}project {Udost\u0119pniono projekt}pullrequest {Udost\u0119pniono pull request}question {Udost\u0119pniono pytanie}report {Udost\u0119pniono raport}repository {Udost\u0119pniono repozytorium}request {Udost\u0119pniono wniosek}roadmap {Udost\u0119pniono o\u015B czasu}site {Udost\u0119pniono witryn\u0119}space {Udost\u0119pniono przestrze\u0144}other {Udost\u0119pniono \u0142\u0105cze}}",
    'fabric.elements.share.to.integration.button': "Udost\u0119pnij w {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona udost\u0119pniania",
    'fabric.elements.share.trigger.button.invite.text': "Zapro\u015B",
    'fabric.elements.share.trigger.button.text': "Udost\u0119pnij",
    'fabric.elements.share.trigger.button.tooltip.text': "Udost\u0119pnij"
};

});

parcelRegister("iQCSg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2341ebeae6083b8$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $b2341ebeae6083b8$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Link copiado para a \xe1rea de transfer\xeancia",
    'fabric.elements.share.copylink.button.text': 'Copiar link',
    'fabric.elements.share.copypubliclink.button.text': "Copiar link p\xfablico",
    'fabric.elements.share.failure.icon.label': "\xcdcone de erro",
    'fabric.elements.share.failure.message': "N\xe3o foi poss\xedvel compartilhar",
    'fabric.elements.share.form.comment.label': 'Mensagem (opcional)',
    'fabric.elements.share.form.comment.placeholder': "H\xe1 algo que eles deveriam saber?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Os destinat\xe1rios v\xe3o ver o nome da p\xe1gina e sua mensagem",
    'fabric.elements.share.form.info.message.no.invite.jira': "Os destinat\xe1rios v\xe3o ver o nome do item e sua mensagem",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Os destinat\xe1rios v\xe3o ver o nome do ticket e a mensagem",
    'fabric.elements.share.form.no-permissions': "Voc\xea n\xe3o est\xe1 apto a compartilhar.",
    'fabric.elements.share.form.public.send': "Enviar link p\xfablico",
    'fabric.elements.share.form.public.share': "Compartilhar link p\xfablico",
    'fabric.elements.share.form.required-field.summary': "Os campos obrigat\xf3rios est\xe3o marcados com um asterisco",
    'fabric.elements.share.form.retry': 'Tentar novamente',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.share': 'Compartilhar',
    'fabric.elements.share.form.title': 'Compartilhar',
    'fabric.elements.share.form.user-picker.add-more': 'Insira mais itens',
    'fabric.elements.share.form.user-picker.label.confluence': 'Nomes, equipes, grupos ou e-mails',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Nomes, equipes ou grupos',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Nomes ou equipes',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-mails',
    'fabric.elements.share.form.user-picker.label.jira': 'Nomes, equipes ou e-mails',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'N\xe3o encontramos nenhum resultado para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'N\xe3o encontramos nenhum resultado para "{inputValue}". Convide pessoas usando um endere\xe7o de e-mail.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 'por exemplo, Maria, equipe laranja, grupo um',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'por exemplo, Maria, equipe laranja',
    'fabric.elements.share.form.user-picker.placeholder.email-only': 'por exemplo, maria@empresa.com',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'por exemplo, Maria, equipe laranja, maria@empresa.com',
    'fabric.elements.share.form.user-picker.validation.required': "Selecione ao menos um usu\xe1rio, grupo, equipe ou e-mail.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': 'Selecione pelo menos uma pessoa, equipe, grupo ou e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': 'Selecione pelo menos uma pessoa, equipe ou grupo',
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': 'Selecione pelo menos uma pessoa ou equipe',
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Selecione pelo menos um e-mail',
    'fabric.elements.share.form.user-picker.validation.required-message.jira': 'Selecione pelo menos uma pessoa, equipe ou e-mail',
    'fabric.elements.share.in.integration.button': 'Compartilhar em {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Convidar para o Confluence',
    'fabric.elements.share.invite.to.jira': 'Convidar para o Jira',
    'fabric.elements.share.main.tab.text.confluence': "Compartilhar p\xe1gina",
    'fabric.elements.share.main.tab.text.jira': 'Compartilhar item',
    'fabric.elements.share.menu.email.label': 'E-mail',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Compartilhar',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blog compartilhado}board {Quadro compartilhado}calendar {Calend\xe1rio compartilhado}draft {Rascunho compartilhado}filter {Filtro compartilhado}issue {Item compartilhado}summary {Resumo compartilhado}list {Lista compartilhada}timeline {Cronograma compartilhado}form {Formul\xe1rio compartilhado}media {M\xeddia compartilhada}page {P\xe1gina compartilhada}project {Projeto compartilhado}pullrequest {Pull request compartilhada}question {Pergunta compartilhada}report {Relat\xf3rio compartilhado}repository {Reposit\xf3rio compartilhado}request {Solicita\xe7\xe3o compartilhada}roadmap {Cronograma compartilhado}site {Site compartilhado}space {Espa\xe7o compartilhado}other {Link compartilhado}}",
    'fabric.elements.share.to.integration.button': 'Compartilhar em {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': "\xcdcone de compartilhamento",
    'fabric.elements.share.trigger.button.invite.text': 'Convidar',
    'fabric.elements.share.trigger.button.text': 'Compartilhar',
    'fabric.elements.share.trigger.button.tooltip.text': 'Compartilhar'
};

});

parcelRegister("hkr2R", function(module, exports) {

$parcel$export(module.exports, "default", () => $362c0a09cda3dcd7$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Portugal)
var $362c0a09cda3dcd7$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Liga\xe7\xe3o copiada para a \xe1rea de transfer\xeancia",
    'fabric.elements.share.copylink.button.text': "Copiar liga\xe7\xe3o",
    'fabric.elements.share.failure.icon.label': "\xcdcone de erro",
    'fabric.elements.share.failure.message': "N\xe3o \xe9 poss\xedvel partilhar",
    'fabric.elements.share.form.comment.placeholder': 'Adicionar uma mensagem',
    'fabric.elements.share.form.retry': 'Tentar novamente',
    'fabric.elements.share.form.send': 'Enviar',
    'fabric.elements.share.form.title': 'Partilhar',
    'fabric.elements.share.form.user-picker.add-more': 'Introduza mais',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'N\xe3o foi poss\xedvel encontrar resultados para "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'N\xe3o foi poss\xedvel encontrar resultados para "{inputValue}". Convite pessoas adicionando um endere\xe7o de e-mail.',
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': 'Introduza o nome ou equipa',
    'fabric.elements.share.form.user-picker.placeholder.generic': 'Introduza o nome, grupo, equipa ou e-mail',
    'fabric.elements.share.form.user-picker.placeholder.jira': 'Introduza o nome, a equipa ou o e-mail',
    'fabric.elements.share.form.user-picker.validation.required': 'Selecione, pelo menos, um utilizador, grupo, equipa ou e-mail.',
    'fabric.elements.share.form.user-picker.validation.required.jira': 'Selecione, pelo menos, um utilizador, equipa ou e-mail.',
    'fabric.elements.share.success.message': "{object, select, blogpost {Publica\xe7\xe3o do blogue partilhada} board {Quadro partilhado} calendar {Calend\xe1rio partilhado} draft {Rascunho partilhado} filter {Filtro partilhado} issue {Problema partilhado} media {Multim\xe9dia partilhado} page {P\xe1gina partilhada} project {Projeto partilhado} pullrequest {Pedidos Pull partilhados} question {Pergunta partilhada} report {Relat\xf3rio partilhado} repository {Reposit\xf3rio partilhado} request {Pedido partilhado} roadmap {Roteiro partilhado} site {Site partilhado} space {Espa\xe7o partilhado} other {Liga\xe7\xe3o partilhada}}",
    'fabric.elements.share.trigger.button.icon.label': "Partilhar \xedcone",
    'fabric.elements.share.trigger.button.invite.text': 'Convidar',
    'fabric.elements.share.trigger.button.text': 'Partilhar',
    'fabric.elements.share.trigger.button.tooltip.text': 'Partilhar'
};

});

parcelRegister("7dbDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bc047a07085c3fb$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ // Romanian
var $6bc047a07085c3fb$export$2e2bcd8739ae039 = {
    'fabric.elements.share.form.title': "Partaja\u021Bi",
    'fabric.elements.share.form.send': "Trimite\u021Bi",
    'fabric.elements.share.form.retry': "Re\xeencerca\u021Bi",
    'fabric.elements.share.form.comment.placeholder': "Ad\u0103uga\u021Bi un mesaj",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Introduce\u021Bi nume, echip\u0103 sau e-mail",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Introduce\u021Bi nume sau echip\u0103",
    'fabric.elements.share.form.user-picker.add-more': "Introduce\u021Bi mai multe",
    'fabric.elements.share.form.user-picker.validation.required': "Selecta\u021Bi cel pu\u021Bin un utilizator, echip\u0103 sau e-mail.",
    'fabric.elements.share.form.user-picker.no-options.domainBasedUserOnly': "Pute\u021Bi invita persoane nu mai cu adrese de e-mail {domains}. Contacta\u021Bi administratorul site-ului pentru a invita alte persoane.",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nu am g\u0103sit niciun rezultat pentru \u201E{inputValue}\u201D.",
    'fabric.elements.share.form.user-picker.no-options.generic': 'Nu am g\u0103sit niciun rezultat pentru "{inputValue}". Invit\u0103 persoane utiliz\xe2nd o adres\u0103 de e-mail.',
    'fabric.elements.share.trigger.button.icon.label': "Pictogram\u0103 partajare",
    'fabric.elements.share.trigger.button.text': "Partaja\u021Bi",
    'fabric.elements.share.trigger.button.tooltip.text': "Partaja\u021Bi",
    'fabric.elements.share.trigger.button.invite.text': "Invita\u021Bi",
    'fabric.elements.share.copylink.button.icon.label': "Pictogram\u0103 copiere link",
    'fabric.elements.share.copylink.button.text': "Copia\u021Bi link",
    'fabric.elements.share.copied.to.clipboard.icon.label': "Pictogram\u0103 copiere linkuri cu succes",
    'fabric.elements.share.copied.to.clipboard.message': "Link copiat \xeen clipboard",
    'fabric.elements.share.form.capabilities.info.message': "Invita\u021Bia dvs. va fi transmis\u0103 unui administrator pentru aprobare",
    'fabric.elements.share.failure.icon.label': "Pictogram\u0103 eroare",
    'fabric.elements.share.failure.message': 'Nu se poate partaja',
    'fabric.elements.share.success.message': "{object, select, blogpost {Blog post shared} panou {Board shared} calendar {Calendar shared} schi\u021B\u0103{Draft shared} filtru {Filter shared} problem\u0103 {Issue shared} media {Media shared} pagin\u0103 {Page shared} proiect {Project shared} pullrequest {Pull Request shared} \xeentrebare {Question shared} raport {Report shared} depozit {Repository shared} solicitare {Request shared} planificare {Roadmap shared} site {Site shared} spa\u021Biu {Space shared} altele {Link Shared}}",
    'fabric.elements.share.admin.notified.message': 'Administratorul dvs. a fost notificat'
};

});

parcelRegister("8zZLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d906580aa8a5e1c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $7d906580aa8a5e1c$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u0421\u0441\u044B\u043B\u043A\u0430 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430 \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430",
    'fabric.elements.share.copylink.button.text': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.copypubliclink.button.text': "\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.failure.icon.label': "\u0417\u043D\u0430\u0447\u043E\u043A \u043E\u0448\u0438\u0431\u043A\u0438",
    'fabric.elements.share.failure.message': "\u041D\u0435 \u0443\u0434\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.comment.label': "\u0421\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 (\u043D\u0435\u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E)",
    'fabric.elements.share.form.comment.placeholder': "\u0427\u0442\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F\u043C \u0441\u043B\u0435\u0434\u0443\u0435\u0442 \u0437\u043D\u0430\u0442\u044C?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u041F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0438 \u0443\u0432\u0438\u0434\u044F\u0442 \u0438\u043C\u044F \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u0432\u0430\u0448\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435",
    'fabric.elements.share.form.no-permissions': "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043E\u0431\u0449\u0438\u0439 \u0434\u043E\u0441\u0442\u0443\u043F.",
    'fabric.elements.share.form.public.send': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0443\u0431\u043B\u0438\u0447\u043D\u0443\u044E \u0441\u0441\u044B\u043B\u043A\u0443",
    'fabric.elements.share.form.public.share': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0441\u044B\u043B\u043A\u043E\u0439 \u043E\u0431\u0449\u0435\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430",
    'fabric.elements.share.form.required-field.summary': "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F \u043E\u0442\u043C\u0435\u0447\u0435\u043D\u044B \u0437\u0432\u0435\u0437\u0434\u043E\u0447\u043A\u043E\u0439",
    'fabric.elements.share.form.retry': "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C",
    'fabric.elements.share.form.send': "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C",
    'fabric.elements.share.form.share': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.title': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.form.user-picker.add-more': "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439",
    'fabric.elements.share.form.user-picker.label.confluence': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B, \u0433\u0440\u0443\u043F\u043F\u044B \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u044B",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u0418\u043C\u0435\u043D\u0430 \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u044B",
    'fabric.elements.share.form.user-picker.label.email-only': "\u0410\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.label.jira': "\u0418\u043C\u0435\u043D\u0430, \u043A\u043E\u043C\u0430\u043D\u0434\u044B \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \xab{inputValue}\xbb.",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u041D\u0435\u0442 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \xab{inputValue}\xbb. \u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B.",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb, \u0433\u0440\u0443\u043F\u043F\u0430-\u043E\u0434\u0438\u043D",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, maria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u041C\u0430\u0440\u0438\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \xab\u0410\u043F\u0435\u043B\u044C\u0441\u0438\u043D\xbb, maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B 1\xa0\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u0433\u0440\u0443\u043F\u043F\u0443, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443, \u0433\u0440\u0443\u043F\u043F\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0433\u0440\u0443\u043F\u043F\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043B\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u0443",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F, \u043A\u043E\u043C\u0430\u043D\u0434\u0443 \u0438\u043B\u0438 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B",
    'fabric.elements.share.in.integration.button': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.invite.to.confluence': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0432 Confluence",
    'fabric.elements.share.invite.to.jira': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C \u0432 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435\u0439",
    'fabric.elements.share.main.tab.text.jira': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0437\u0430\u0434\u0430\u0447\u0435\u0439",
    'fabric.elements.share.menu.email.label': "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0438\u0441\u0438 \u0432 \u0431\u043B\u043E\u0433\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}board {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0434\u043E\u0441\u043A\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}calendar {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}draft {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0447\u0435\u0440\u043D\u043E\u0432\u0438\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}filter {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u0438\u043B\u044C\u0442\u0440\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}issue {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u0434\u0430\u0447\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}summary {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0442\u0435\u043C\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}list {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u043F\u0438\u0441\u043A\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}timeline {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}form {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0444\u043E\u0440\u043C\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}media {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043C\u0435\u0434\u0438\u0430\u0444\u0430\u0439\u043B\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}page {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}project {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043F\u0440\u043E\u0435\u043A\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}pullrequest {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u043E\u0441\u0443 pull \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}question {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u043E\u043F\u0440\u043E\u0441\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}report {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u043E\u0442\u0447\u0435\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}repository {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0435\u043F\u043E\u0437\u0438\u0442\u043E\u0440\u0438\u044E \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}request {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}roadmap {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0445\u0440\u043E\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}site {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0430\u0439\u0442\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}space {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0440\u0430\u0437\u0434\u0435\u043B\u0443 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}other {\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0441\u0441\u044B\u043B\u043A\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D}}",
    'fabric.elements.share.to.integration.button': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0432 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u0417\u043D\u0430\u0447\u043E\u043A \xab\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F\xbb",
    'fabric.elements.share.trigger.button.invite.text': "\u041F\u0440\u0438\u0433\u043B\u0430\u0441\u0438\u0442\u044C",
    'fabric.elements.share.trigger.button.text': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F",
    'fabric.elements.share.trigger.button.tooltip.text': "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F"
};

});

parcelRegister("dGOFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cd5c80c863bfbe9$export$2e2bcd8739ae039);
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $9cd5c80c863bfbe9$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "Prepojenie sa skop\xedrovalo do schr\xe1nky",
    'fabric.elements.share.copylink.button.text': "Kop\xedrova\u0165 prepojenie",
    'fabric.elements.share.failure.icon.label': 'Ikona chyby',
    'fabric.elements.share.failure.message': "Zdie\u013Eanie nie je mo\u017En\xe9",
    'fabric.elements.share.form.comment.placeholder': "Prida\u0165 spr\xe1vu",
    'fabric.elements.share.form.retry': "Opakova\u0165",
    'fabric.elements.share.form.send': "Odosla\u0165",
    'fabric.elements.share.form.title': "Zdie\u013Eanie",
    'fabric.elements.share.form.user-picker.add-more': "Zadajte \u010Fal\u0161ie polo\u017Eky",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "Nepodarilo sa n\xe1js\u0165 \u017Eiadne v\xfdsledky pre \u201E{inputValue}\u201C.",
    'fabric.elements.share.form.user-picker.no-options.generic': "Nepodarilo sa n\xe1js\u0165 \u017Eiadne v\xfdsledky pre \u201E{inputValue}\u201C. Pozvite \u013Eud\xed pomocou e-mailovej adresy.",
    'fabric.elements.share.form.user-picker.placeholder.existingUserOnly': "Zadajte meno alebo t\xedm",
    'fabric.elements.share.form.user-picker.placeholder.generic': "Zadajte meno, skupinu, t\xedm alebo e-mail",
    'fabric.elements.share.form.user-picker.placeholder.jira': "Zadajte meno, t\xedm alebo e-mail",
    'fabric.elements.share.form.user-picker.validation.required': "Vyberte aspo\u0148 jedn\xe9ho pou\u017E\xedvate\u013Ea, skupinu, t\xedm alebo e-mail.",
    'fabric.elements.share.form.user-picker.validation.required.jira': "Vyberte aspo\u0148 jedn\xe9ho pou\u017E\xedvate\u013Ea, t\xedm alebo e-mail.",
    'fabric.elements.share.success.message': "{object, select, blogpost {Blogov\xfd pr\xedspevok sa zdie\u013Eal} board {N\xe1stenka sa zdie\u013Eala} calendar {Kalend\xe1r sa zdie\u013Eal} draft {Koncept sa zdie\u013Eal} filter {Filter sa zdie\u013Eal} issue {Probl\xe9m sa zdie\u013Eal} media {Medi\xe1lny s\xfabor sa zdie\u013Eal} page {Str\xe1nka sa zdie\u013Eala} project {Projekt sa zdie\u013Eal} pullrequest {Po\u017Eiadavka na stiahnutie a pos\xfadenie sa zdie\u013Eala} question {Ot\xe1zka sa zdie\u013Eala} report {Zostava sa zdie\u013Eala} repository {Repozit\xe1r sa zdie\u013Eal} request {\u017Diados\u0165 sa zdie\u013Eala} roadmap {Pl\xe1n sa zdie\u013Eal} site {Web sa zdie\u013Eal} space {Priestor sa zdie\u013Eal} other {Prepojenie sa zdie\u013Ealo}}",
    'fabric.elements.share.trigger.button.icon.label': "Ikona zdie\u013Eania",
    'fabric.elements.share.trigger.button.invite.text': "Pozva\u0165",
    'fabric.elements.share.trigger.button.text': "Zdie\u013Ea\u0165",
    'fabric.elements.share.trigger.button.tooltip.text': "Zdie\u013Eanie"
};

});

parcelRegister("64yeQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $643613031271747a$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $643613031271747a$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "L\xe4nk kopierad till urklipp",
    'fabric.elements.share.copylink.button.text': "Kopiera l\xe4nk",
    'fabric.elements.share.copypubliclink.button.text': "Kopiera offentlig l\xe4nk",
    'fabric.elements.share.failure.icon.label': 'Fel-ikon',
    'fabric.elements.share.failure.message': 'Det gick inte att dela',
    'fabric.elements.share.form.comment.label': 'Meddelande (valfritt)',
    'fabric.elements.share.form.comment.placeholder': "Finns det n\xe5got de beh\xf6ver veta?",
    'fabric.elements.share.form.info.message.no.invite.confluence': "Mottagare ser namnet p\xe5 sidan och ditt meddelande",
    'fabric.elements.share.form.info.message.no.invite.jira': "Mottagare ser namnet p\xe5 \xe4rendet och ditt meddelande",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "Mottagare ser namnet p\xe5 arbetsuppgiften och ditt meddelande",
    'fabric.elements.share.form.no-permissions': "Du har inte m\xf6jlighet att dela.",
    'fabric.elements.share.form.public.send': "Skicka offentlig l\xe4nk",
    'fabric.elements.share.form.public.share': "Dela offentlig l\xe4nk",
    'fabric.elements.share.form.required-field.summary': "Obligatoriska f\xe4lt \xe4r markerade med en asterisk",
    'fabric.elements.share.form.retry': "F\xf6rs\xf6k igen",
    'fabric.elements.share.form.send': 'Skicka',
    'fabric.elements.share.form.share': 'Dela',
    'fabric.elements.share.form.title': 'Dela',
    'fabric.elements.share.form.user-picker.add-more': 'Ange fler',
    'fabric.elements.share.form.user-picker.label.confluence': 'Namn, team, grupper eller e-postadresser',
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Namn, team eller grupper',
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Namn eller team',
    'fabric.elements.share.form.user-picker.label.email-only': 'E-postadresser',
    'fabric.elements.share.form.user-picker.label.jira': 'Namn, team eller e-postadresser',
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': 'Vi hittade inte n\xe5gra resultat f\xf6r "{inputValue}".',
    'fabric.elements.share.form.user-picker.no-options.generic': 'Vi hittade inte n\xe5gra resultat f\xf6r "{inputValue}". Bjud in personer genom att anv\xe4nda e-postadresser.',
    'fabric.elements.share.form.user-picker.placeholder.confluence': 't.ex. Maria, Team Orange, grupp-ett',
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 't.ex. Maria, Team Orange',
    'fabric.elements.share.form.user-picker.placeholder.email-only': "t.ex. maria@f\xf6retag.se",
    'fabric.elements.share.form.user-picker.placeholder.jira': "t.ex. Maria, Team Orange, maria@f\xf6retag.se",
    'fabric.elements.share.form.user-picker.validation.required': "V\xe4lj minst en anv\xe4ndare, en grupp, ett team eller en e-postadress.",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "V\xe4lj minst en person, ett team, en grupp eller en e-postadress",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "V\xe4lj minst en person, ett team eller en grupp",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "V\xe4lj minst en person eller ett team",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "V\xe4lj minst en e-postadress",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "V\xe4lj minst en person, ett team eller en e-postadress",
    'fabric.elements.share.in.integration.button': 'Dela i {integrationName}',
    'fabric.elements.share.invite.to.confluence': 'Bjud in till Confluence',
    'fabric.elements.share.invite.to.jira': 'Bjud in till Jira',
    'fabric.elements.share.main.tab.text.confluence': 'Dela sida',
    'fabric.elements.share.main.tab.text.jira': "Dela \xe4rende",
    'fabric.elements.share.menu.email.label': 'E-post',
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': 'Dela',
    'fabric.elements.share.success.message': "{object, select,blogpost {Blogginl\xe4gg har delats}board {Tavla har delats}calendar {Kalender har delats}draft {Utkast har delats}filter {Filter har delats}issue {\xc4rende har delats}summary {Sammanfattning har delats}list {Lista har delats}timeline {Tidslinje har delats}form {Formul\xe4r har delats}media {Media har delats}page {Sida har delats}project {Projekt har delats}pullrequest {Pull request har delats}question {Fr\xe5ga har delats}report {Rapport har delats}repository {Lagringsplats har delats}request {F\xf6rfr\xe5gan har delats}roadmap {Tidslinje har delats}site {Webbplats har delats}space {Utrymme har delats}other {L\xe4nk har delats}}",
    'fabric.elements.share.to.integration.button': 'Dela till {integrationName}',
    'fabric.elements.share.trigger.button.icon.label': 'Dela-ikon',
    'fabric.elements.share.trigger.button.invite.text': 'Bjud In',
    'fabric.elements.share.trigger.button.text': 'Dela',
    'fabric.elements.share.trigger.button.tooltip.text': 'Dela'
};

});

parcelRegister("iTJhG", function(module, exports) {

$parcel$export(module.exports, "default", () => $65937a71b1200549$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Simplified)
var $65937a71b1200549$export$2e2bcd8739ae039 = {
    'fabric.elements.share.copied.to.clipboard.message': "\u94FE\u63A5\u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F",
    'fabric.elements.share.copylink.button.text': "\u590D\u5236\u94FE\u63A5",
    'fabric.elements.share.copypubliclink.button.text': "\u590D\u5236\u516C\u5171\u94FE\u63A5",
    'fabric.elements.share.failure.icon.label': "\u9519\u8BEF\u56FE\u6807",
    'fabric.elements.share.failure.message': "\u65E0\u6CD5\u5171\u4EAB",
    'fabric.elements.share.form.comment.label': "\u6D88\u606F\uFF08\u53EF\u9009\uFF09",
    'fabric.elements.share.form.comment.placeholder': "\u5BF9\u65B9\u662F\u5426\u5E94\u77E5\u9053\u67D0\u4E9B\u4FE1\u606F\uFF1F",
    'fabric.elements.share.form.info.message.no.invite.confluence': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u9875\u9762\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.info.message.no.invite.jira': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u4E8B\u52A1\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh': "\u6536\u4EF6\u4EBA\u5C06\u770B\u5230\u5DE5\u4F5C\u9879\u540D\u79F0\u548C\u60A8\u7684\u6D88\u606F",
    'fabric.elements.share.form.no-permissions': "\u60A8\u65E0\u6CD5\u5171\u4EAB\u3002",
    'fabric.elements.share.form.public.send': "\u53D1\u9001\u516C\u5171\u94FE\u63A5",
    'fabric.elements.share.form.public.share': "\u5206\u4EAB\u516C\u5F00\u94FE\u63A5",
    'fabric.elements.share.form.required-field.summary': "\u5FC5\u586B\u5B57\u6BB5\u6807\u6709\u661F\u53F7",
    'fabric.elements.share.form.retry': "\u91CD\u8BD5",
    'fabric.elements.share.form.send': "\u53D1\u9001",
    'fabric.elements.share.form.share': "\u5171\u4EAB",
    'fabric.elements.share.form.title': "\u5171\u4EAB",
    'fabric.elements.share.form.user-picker.add-more': "\u8F93\u5165\u66F4\u591A",
    'fabric.elements.share.form.user-picker.label.confluence': "\u59D3\u540D\u3001\u56E2\u961F\u3001\u7FA4\u7EC4\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.label.email-disabled-confluence': "\u59D3\u540D\u3001\u56E2\u961F\u6216\u7FA4\u7EC4",
    'fabric.elements.share.form.user-picker.label.email-disabled-jira': "\u59D3\u540D\u6216\u56E2\u961F",
    'fabric.elements.share.form.user-picker.label.email-only': "\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.label.jira': "\u59D3\u540D\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.no-options.existingUserOnly': "\u6211\u4EEC\u627E\u4E0D\u5230\u4EFB\u4F55\u5173\u4E8E\u201C{inputValue}\u201D\u7684\u7ED3\u679C\u3002",
    'fabric.elements.share.form.user-picker.no-options.generic': "\u6211\u4EEC\u627E\u4E0D\u5230\u4EFB\u4F55\u5173\u4E8E\u201C{inputValue}\u201D\u7684\u7ED3\u679C\u3002\u8BF7\u7528\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u9080\u8BF7\u4ED6\u4EBA\u3002",
    'fabric.elements.share.form.user-picker.placeholder.confluence': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F\u3001\u7B2C\u4E00\u7EC4",
    'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F",
    'fabric.elements.share.form.user-picker.placeholder.email-only': "\u4F8B\u5982\uFF0Cmaria@company.com",
    'fabric.elements.share.form.user-picker.placeholder.jira': "\u4F8B\u5982\uFF0C\u739B\u5229\u4E9A\u3001\u6A59\u961F\u3001maria@company.com",
    'fabric.elements.share.form.user-picker.validation.required': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u7528\u6237\u3001\u7EC4\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u3002",
    'fabric.elements.share.form.user-picker.validation.required-message.confluence': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u3001\u7FA4\u7EC4\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u6216\u7FA4\u7EC4",
    'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u6216\u56E2\u961F",
    'fabric.elements.share.form.user-picker.validation.required-message.email-only': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.form.user-picker.validation.required-message.jira': "\u8BF7\u81F3\u5C11\u9009\u62E9\u4E00\u4E2A\u4EBA\u5458\u3001\u56E2\u961F\u6216\u7535\u5B50\u90AE\u4EF6\u5730\u5740",
    'fabric.elements.share.in.integration.button': "\u5728 {integrationName} \u4E2D\u5206\u4EAB",
    'fabric.elements.share.invite.to.confluence': "\u9080\u8BF7\u52A0\u5165 Confluence",
    'fabric.elements.share.invite.to.jira': "\u9080\u8BF7\u52A0\u5165 Jira",
    'fabric.elements.share.main.tab.text.confluence': "\u5206\u4EAB\u9875\u9762",
    'fabric.elements.share.main.tab.text.jira': "\u5171\u4EAB\u4E8B\u52A1",
    'fabric.elements.share.menu.email.label': "\u7535\u5B50\u90AE\u4EF6",
    'fabric.elements.share.menu.slack.label': 'Slack',
    'fabric.elements.share.popup.label': "\u5171\u4EAB",
    'fabric.elements.share.success.message': "{object, select,blogpost {\u535A\u5BA2\u6587\u7AE0\u5DF2\u5171\u4EAB}board {\u9762\u677F\u5DF2\u5171\u4EAB}calendar {\u65E5\u5386\u5DF2\u5171\u4EAB}draft {\u8349\u7A3F\u5DF2\u5171\u4EAB}filter {\u7B5B\u9009\u5668\u5DF2\u5171\u4EAB}issue {\u4E8B\u52A1\u5DF2\u5171\u4EAB}summary {\u6458\u8981\u5DF2\u5171\u4EAB}list {\u5217\u8868\u5DF2\u5171\u4EAB}timeline {\u65F6\u95F4\u7EBF\u5DF2\u5171\u4EAB}form {\u8868\u5355\u5DF2\u5171\u4EAB}media {\u5A92\u4F53\u5DF2\u5171\u4EAB}page {\u9875\u9762\u5DF2\u5171\u4EAB}project {\u9879\u76EE\u5DF2\u5171\u4EAB}pullrequest {\u62C9\u53D6\u8BF7\u6C42\u5DF2\u5171\u4EAB}question {\u95EE\u9898\u5DF2\u5171\u4EAB}report {\u62A5\u544A\u5DF2\u5171\u4EAB}repository {\u5B58\u50A8\u5E93\u5DF2\u5171\u4EAB}request {\u8BF7\u6C42\u5DF2\u5171\u4EAB}roadmap {\u65F6\u95F4\u7EBF\u5DF2\u5171\u4EAB}site {\u7AD9\u70B9\u5DF2\u5171\u4EAB}space {\u7A7A\u95F4\u5DF2\u5171\u4EAB}other {\u94FE\u63A5\u5DF2\u5171\u4EAB}}",
    'fabric.elements.share.to.integration.button': "\u5206\u4EAB\u5230 {integrationName}",
    'fabric.elements.share.trigger.button.icon.label': "\u5171\u4EAB\u56FE\u6807",
    'fabric.elements.share.trigger.button.invite.text': "\u9080\u8BF7",
    'fabric.elements.share.trigger.button.text': "\u5171\u4EAB",
    'fabric.elements.share.trigger.button.tooltip.text': "\u5171\u4EAB"
};

});



parcelRegister("7v5Ga", function(module, exports) {

$parcel$export(module.exports, "ShareDialogWithTrigger", () => $2879aae105082725$export$c7f8df1e37e7f581);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $cb25w = parcelRequire("cb25w");

var $kOEld = parcelRequire("kOEld");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $k8nZq = parcelRequire("k8nZq");

var $k5uoT = parcelRequire("k5uoT");

var $3bDjY = parcelRequire("3bDjY");

var $idKBS = parcelRequire("idKBS");


var $b2oBK = parcelRequire("b2oBK");

var $hQWyD = parcelRequire("hQWyD");

var $65uFp = parcelRequire("65uFp");

var $KNlKW = parcelRequire("KNlKW");

var $bked4 = parcelRequire("bked4");

var $1t1FK = parcelRequire("1t1FK");

var $cnQaw = parcelRequire("cnQaw");

var $4gTjW = parcelRequire("4gTjW");
function $2879aae105082725$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2879aae105082725$var$shareButtonWrapperStyles = {
    name: "8s6ifx",
    styles: "display:inline-flex;outline:none"
};
const $2879aae105082725$export$4d9147e1bc6c176 = {
    users: [],
    comment: {
        format: 'plain_text',
        value: ''
    }
};
const $2879aae105082725$export$55abe7932f6ca981 = ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    });
class $2879aae105082725$export$e927f7ec13b9edc0 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.defaultProps = {
            isDisabled: false,
            dialogPlacement: 'bottom-end',
            shouldCloseOnEscapePress: true,
            triggerButtonAppearance: 'subtle',
            triggerButtonStyle: 'icon-only',
            triggerButtonTooltipPosition: 'top',
            dialogZIndex: (0, $k5uoT.layers).modal()
        };
    }
    componentDidMount() {
        if (this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isAutoOpenDialog !== prevProps.isAutoOpenDialog && this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentWillUnmount() {
        if (this.props.isAutoOpenDialog && this.props.onDialogClose) this.props.onDialogClose();
    }
    async generateShareError(err) {
        const errorBody = err.body ? await err.body : {};
        // We'll only try and deal with the first error, sorry
        const firstErrorFromBody = errorBody.messagesDetails?.[0];
        return {
            message: firstErrorFromBody?.message || err.message,
            errorCode: firstErrorFromBody?.errorCode,
            helpUrl: firstErrorFromBody?.helpUrl,
            retryable: firstErrorFromBody?.errorCode === undefined
        };
    }
    render() {
        const { isDialogOpen: isDialogOpen, isSharing: isSharing, shareError: shareError, defaultValue: defaultValue, showIntegrationForm: showIntegrationForm, selectedIntegration: selectedIntegration, isMenuItemSelected: isMenuItemSelected } = this.state;
        const { copyLink: copyLink, dialogPlacement: dialogPlacement, config: config, isFetchingConfig: isFetchingConfig, loadUserOptions: loadUserOptions, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, bottomMessage: bottomMessage, submitButtonLabel: submitButtonLabel, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, cloudId: cloudId, orgId: orgId, shareFieldsFooter: shareFieldsFooter, dialogZIndex: dialogZIndex, isPublicLink: isPublicLink, tabIndex: tabIndex, copyTooltipText: copyTooltipText, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const style = typeof tabIndex !== 'undefined' && tabIndex >= 0 ? {
            outline: 'none'
        } : undefined;
        const footer = (0, $4gTjW.resolveShareFooter)(integrationMode, this.state.tabIndex, customFooter);
        // for performance purposes, we may want to have a loadable content i.e. ShareForm
        return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            css: $2879aae105082725$var$shareButtonWrapperStyles,
            tabIndex: tabIndex,
            onKeyDown: this.handleKeyDown,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1I7E8.default), {
            content: ()=>/*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
                    ref: this.containerRef
                }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $KNlKW.default), {
                    Content: selectedIntegration && selectedIntegration.Content,
                    selectedIntegration: selectedIntegration,
                    copyLink: copyLink,
                    showIntegrationForm: showIntegrationForm,
                    bottomMessage: bottomMessage,
                    customHeader: (0, $VSDnB.fg)('platform_share_custom_header_prop') && customHeader,
                    customFooter: footer,
                    loadOptions: loadUserOptions,
                    isSharing: isSharing,
                    shareFormTitle: shareFormTitle,
                    showTitle: integrationMode !== 'tabs' || !shareIntegrations || !shareIntegrations.length,
                    shareFormHelperMessage: shareFormHelperMessage,
                    shareError: shareError,
                    defaultValue: defaultValue,
                    config: config,
                    isFetchingConfig: isFetchingConfig,
                    setIsLoading: this.setIsLoading,
                    submitButtonLabel: submitButtonLabel,
                    product: product,
                    productAttributes: productAttributes,
                    enableSmartUserPicker: enableSmartUserPicker,
                    loggedInAccountId: loggedInAccountId,
                    cloudId: cloudId,
                    orgId: orgId,
                    onUserSelectionChange: this.handleOnUserSelectionChange,
                    shareFieldsFooter: shareFieldsFooter,
                    isPublicLink: isPublicLink,
                    copyTooltipText: copyTooltipText,
                    integrationMode: integrationMode,
                    shareIntegrations: shareIntegrations,
                    additionalTabs: additionalTabs,
                    builtInTabContentWidth: builtInTabContentWidth,
                    isMenuItemSelected: isMenuItemSelected,
                    isSubmitShareDisabled: isSubmitShareDisabled,
                    // actions
                    onLinkCopy: this.handleCopyLink,
                    onSubmit: this.handleShareSubmit,
                    onDismiss: this.handleFormDismiss,
                    onDialogClose: this.handleCloseDialog,
                    onTabChange: this.onTabChange,
                    onMenuItemChange: this.onMenuItemChange,
                    //ref
                    selectPortalRef: this.selectPortalRef,
                    isBrowseUsersDisabled: isBrowseUsersDisabled,
                    userPickerOptions: userPickerOptions,
                    additionalUserFields: additionalUserFields,
                    isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                    CustomSubmitButton: CustomSubmitButton
                })),
            isOpen: isDialogOpen,
            onClose: this.handleCloseDialog,
            placement: dialogPlacement,
            trigger: this.renderShareTriggerButton,
            zIndex: dialogZIndex,
            label: this.props.intl.formatMessage((0, $idKBS.messages).sharePopupLabel),
            role: "dialog",
            // TODO: remove after https://hello.atlassian.net/wiki/x/SoEGzQ experiment is finished
            offset: this.calculatePopupOffset({
                isMenuItemSelected: isMenuItemSelected,
                dialogPlacement: dialogPlacement
            }),
            shouldRenderToParent: (0, $VSDnB.fg)('enable-appropriate-reading-order-in-share-dialog')
        }), /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $k8nZq.default), {
            zIndex: (0, $4gTjW.generateSelectZIndex)(dialogZIndex)
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
            ref: this.selectPortalRef
        }))));
    }
    constructor(...args){
        super(...args), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), /**
   * Because the PopUp component has a higher zIndex it causes
   * the select to be rendered within it, and add scrollbars.
   * We will render the select options the PopUp outside,
   */ this.selectPortalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.start = 0, this.state = {
            isDialogOpen: false,
            isSharing: false,
            ignoreIntermediateState: false,
            defaultValue: $2879aae105082725$export$4d9147e1bc6c176,
            isUsingSplitButton: false,
            showIntegrationForm: false,
            selectedIntegration: null,
            tabIndex: 0,
            isMenuItemSelected: false,
            isLoading: false
        }, this.closeAndResetDialog = ()=>{
            this.setState({
                defaultValue: $2879aae105082725$export$4d9147e1bc6c176,
                ignoreIntermediateState: true,
                shareError: undefined,
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                isMenuItemSelected: false
            });
            const { onUserSelectionChange: onUserSelectionChange, onDialogClose: onDialogClose } = this.props;
            if (onUserSelectionChange) onUserSelectionChange($2879aae105082725$export$4d9147e1bc6c176.users);
            if (onDialogClose) onDialogClose();
        }, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, analyticsDecorator: analyticsDecorator } = this.props;
            if (analyticsDecorator) payload = analyticsDecorator(payload);
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $b2oBK.CHANNEL_ID));
        }, this.onTabChange = (index)=>{
            let subjectId = 'shareTab';
            const { shareContentType: shareContentType } = this.props;
            if (index === 1) subjectId = 'shareToSlackTab';
            this.createAndFireEvent((0, $b2oBK.shareTabClicked)(subjectId, shareContentType));
            this.setState({
                tabIndex: index
            });
        }, this.onMenuItemChange = (menuType)=>{
            let subjectId = menuType === 'Slack' ? 'shareToSlackMenuItem' : 'shareMenuItem';
            const { shareContentType: shareContentType } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareMenuItemClicked)(subjectId, shareContentType));
            this.setState({
                isMenuItemSelected: true
            });
        }, this.getFlags = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            // The reason for providing message property is that in jira,
            // the Flag system takes only Message Descriptor as payload
            // and formatMessage is called for every flag
            // if the translation data is not provided, a translated default message
            // will be displayed
            return [
                {
                    appearance: 'success',
                    title: {
                        ...(0, $idKBS.messages).shareSuccessMessage,
                        defaultMessage: formatMessage((0, $idKBS.messages).shareSuccessMessage, {
                            object: this.props.shareContentType.toLowerCase()
                        })
                    },
                    type: (0, $dcbcc8fabc474606$export$9540ac9c843b8743)
                }
            ];
        }, this.setIsLoading = (isLoading)=>{
            this.setState({
                isLoading: isLoading
            });
        }, this.focus = ()=>{
            if (this.containerRef.current) this.containerRef.current.focus();
        }, this.handleKeyDown = (event)=>{
            const { isLoading: isLoading, isDialogOpen: isDialogOpen } = this.state;
            const { shouldCloseOnEscapePress: shouldCloseOnEscapePress } = this.props;
            if (isLoading) {
                event.stopPropagation();
                this.focus();
            }
            if (isDialogOpen) switch(event.key){
                case 'Esc':
                case 'Escape':
                    // The @atlaskit/popup will capture the event and auto-close, we
                    // need to prevent that if the dialog is set to not close on `ESC`
                    if (!shouldCloseOnEscapePress) {
                        event.preventDefault();
                        event.stopPropagation();
                        // put the focus back onto the share dialog so that
                        // the user can press the escape key again to close the dialog
                        this.focus();
                        return;
                    }
                    // The dialog will auto-close in @atlaskit/popup, we just need to fire
                    // the right events.
                    if (shouldCloseOnEscapePress) {
                        // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
                        // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
                        // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
                        (0, $65uFp.renderShareDialogExp).abort();
                        this.createAndFireEvent((0, $b2oBK.cancelShare)(this.start));
                        this.closeAndResetDialog();
                    }
            }
        }, this.handleDialogOpen = ()=>{
            this.setState((state)=>({
                    isDialogOpen: !state.isDialogOpen,
                    ignoreIntermediateState: false,
                    showIntegrationForm: false,
                    selectedIntegration: null
                }), ()=>{
                const { onDialogOpen: onDialogOpen, isPublicLink: isPublicLink } = this.props;
                const { isDialogOpen: isDialogOpen } = this.state;
                if (isDialogOpen) {
                    this.start = Date.now();
                    this.createAndFireEvent((0, $b2oBK.screenEvent)({
                        isPublicLink: isPublicLink
                    }));
                    if (onDialogOpen) onDialogOpen();
                    this.focus();
                } else this.handleCloseDialog();
            });
        }, this.onTriggerClick = ()=>{
            const { onTriggerButtonClick: onTriggerButtonClick } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareTriggerButtonClicked)());
            this.handleDialogOpen();
            if (onTriggerButtonClick) onTriggerButtonClick();
        }, this.handleCloseDialog = ()=>{
            if (this.props.onDialogClose) this.props.onDialogClose();
            // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
            // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
            // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
            (0, $65uFp.renderShareDialogExp).abort();
            this.setState({
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                tabIndex: 0,
                isMenuItemSelected: false
            });
        }, this.handleShareSubmit = (data)=>{
            const { onShareSubmit: onShareSubmit, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, formShareOrigin: formShareOrigin, showFlags: showFlags, isPublicLink: isPublicLink, createAnalyticsEvent: createAnalyticsEvent, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled } = this.props;
            if (!onShareSubmit) return;
            (0, $65uFp.shareSubmitExp).start();
            this.setState({
                isSharing: true
            });
            this.createAndFireEvent((0, $b2oBK.formShareSubmitted)({
                start: this.start,
                data: data,
                shareContentType: shareContentType,
                shareOrigin: formShareOrigin,
                isPublicLink: isPublicLink,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'shared',
                    actionSubject: 'page',
                    source: (0, $b2oBK.ANALYTICS_SOURCE),
                    attributes: {
                        contentType: shareContentType,
                        subContentType: shareContentSubType,
                        shareData: data
                    }
                }
            }).fire();
            onShareSubmit(data).then(()=>{
                this.closeAndResetDialog();
                this.setState({
                    isSharing: false
                });
                if (isExtendedShareDialogEnabled && data.users.length === 0) (0, $65uFp.shareSubmitExp).abort();
                else {
                    showFlags(this.getFlags());
                    (0, $65uFp.shareSubmitExp).success();
                }
            }).catch(async (err)=>{
                const shareError = await this.generateShareError(err).catch((errorGenFailed)=>({
                        message: err.message || errorGenFailed.message || 'Unknown error',
                        retryable: true
                    }));
                this.setState({
                    isSharing: false,
                    shareError: shareError
                });
                (0, $hQWyD.isValidFailedExperience)((0, $65uFp.shareSubmitExp), err);
            });
        }, this.handleFormDismiss = (data)=>{
            this.setState(({ ignoreIntermediateState: ignoreIntermediateState })=>ignoreIntermediateState ? null : {
                    defaultValue: data
                });
        }, this.calculatePopupOffset = ({ isMenuItemSelected: isMenuItemSelected, dialogPlacement: dialogPlacement })=>{
            if (isMenuItemSelected && dialogPlacement === 'bottom-end') return [
                -0.1,
                8
            ];
            return [
                0,
                8
            ];
        }, this.handleCopyLink = ()=>{
            const { copyLinkOrigin: copyLinkOrigin, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, isPublicLink: isPublicLink, shareAri: shareAri } = this.props;
            this.createAndFireEvent((0, $b2oBK.copyLinkButtonClicked)({
                start: this.start,
                shareContentType: shareContentType,
                shareOrigin: copyLinkOrigin,
                isPublicLink: isPublicLink,
                ari: shareAri,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
        }, this.handleIntegrationClick = (integration)=>{
            this.setState({
                isUsingSplitButton: false,
                isDialogOpen: true,
                showIntegrationForm: true,
                selectedIntegration: integration
            });
        }, this.renderShareTriggerButton = (triggerProps)=>{
            const { isDialogOpen: isDialogOpen, isUsingSplitButton: isUsingSplitButton } = this.state;
            const { intl: { formatMessage: formatMessage }, isDisabled: isDisabled, renderCustomTriggerButton: renderCustomTriggerButton, triggerButtonIcon: triggerButtonIcon, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, triggerButtonAppearance: triggerButtonAppearance, triggerButtonStyle: triggerButtonStyle, integrationMode: integrationMode, shareIntegrations: shareIntegrations, dialogZIndex: dialogZIndex, dialogPlacement: dialogPlacement } = this.props;
            let button;
            const ShareButtonIcon = triggerButtonIcon || $2879aae105082725$export$55abe7932f6ca981;
            // Render a custom or standard button.
            if (renderCustomTriggerButton) {
                const { shareError: shareError } = this.state;
                button = renderCustomTriggerButton({
                    error: shareError,
                    isDisabled: isDisabled,
                    isSelected: isDialogOpen,
                    onClick: this.onTriggerClick
                }, triggerProps);
            } else button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $bked4.default), {
                appearance: triggerButtonAppearance,
                text: triggerButtonStyle !== 'icon-only' ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), (0, $idKBS.messages).shareTriggerButtonText) : null,
                "aria-label": formatMessage((0, $idKBS.messages).shareTriggerButtonText),
                onClick: this.onTriggerClick,
                iconBefore: triggerButtonStyle !== 'text-only' ? /*#__PURE__*/ (0, $f8Sb3.jsx)(ShareButtonIcon, {
                    label: ""
                }) : undefined,
                isSelected: isDialogOpen,
                isDisabled: isDisabled,
                ref: triggerProps.ref,
                // When we autoFocus the dialog, we want to autofocus the trigger as well, that way when the dialog is closed, the trigger is focused
                autoFocus: this.props.isAutoOpenDialog
            });
            // If the button only shows the icon, wrap it in a tooltip containing the button text.
            if (triggerButtonStyle === 'icon-only') button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $3bDjY.default), {
                content: !isUsingSplitButton ? triggerButtonTooltipText || formatMessage((0, $idKBS.messages).shareTriggerButtonTooltipText) : null,
                position: triggerButtonTooltipPosition,
                hideTooltipOnClick: true
            }, button);
            // If there are any integrations, wrap the share button in a split button with integrations.
            if (integrationMode === 'split' && shareIntegrations?.length) button = /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $cnQaw.default), {
                shareButton: button,
                handleOpenSplitButton: this.handleOpenSplitButton,
                handleCloseSplitButton: this.handleCloseSplitButton,
                isUsingSplitButton: isUsingSplitButton,
                triggerButtonAppearance: triggerButtonAppearance,
                dialogZIndex: dialogZIndex,
                dialogPlacement: dialogPlacement,
                shareIntegrations: shareIntegrations,
                onIntegrationClick: this.handleIntegrationClick,
                createAndFireEvent: this.createAndFireEvent
            });
            return button;
        }, this.handleOpenSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: true
            }, ()=>this.handleCloseDialog());
            this.createAndFireEvent((0, $b2oBK.shareSplitButtonEvent)());
        }, this.handleCloseSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: false
            });
        }, this.handleOnUserSelectionChange = (value)=>{
            const { onUserSelectionChange: onUserSelectionChange } = this.props;
            this.setState({
                shareError: undefined
            });
            onUserSelectionChange?.(value);
        };
    }
}
const $2879aae105082725$export$bc20a02e9bc30e54 = (props)=>(0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $1t1FK.ShareDialogWithTriggerInternal), props) : /*#__PURE__*/ (0, $f8Sb3.jsx)($2879aae105082725$export$e927f7ec13b9edc0, props);
const $2879aae105082725$export$c7f8df1e37e7f581 = (0, $cb25w.default)()((0, $8RXs9.default)($2879aae105082725$export$bc20a02e9bc30e54));

});
const $dcbcc8fabc474606$export$9540ac9c843b8743 = 'object-shared';
const $dcbcc8fabc474606$export$57af6ad1a12df839 = 'admin-notified';

parcelRegister("KNlKW", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b9c92562d0fe90f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $eZJjh = parcelRequire("eZJjh");

var $dZbU3 = parcelRequire("dZbU3");

var $iXiUJ = parcelRequire("iXiUJ");
function $7b9c92562d0fe90f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7b9c92562d0fe90f$var$spinnerWrapperStyles = {
    name: "1frfa00",
    styles: "width:100%;height:100%;display:flex;justify-content:center;align-content:center"
};

const $7b9c92562d0fe90f$var$LazyShareFormLazy = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("lhRB1")));
const $7b9c92562d0fe90f$var$LoadingDialog = ({ shareFormTitle: shareFormTitle, showTitle: showTitle, setIsLoading: setIsLoading, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        setIsLoading(true);
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dZbU3.default), {
        shareFormTitle: shareFormTitle,
        integrationMode: integrationMode,
        isMenuItemSelected: isMenuItemSelected,
        // if `showTitle` is passed, we use it. Otherwise, we will show title for loading dialog.
        shouldShowTitle: typeof showTitle === 'boolean' ? showTitle : true,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $7b9c92562d0fe90f$var$spinnerWrapperStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $eZJjh.default), null)));
};
var $7b9c92562d0fe90f$export$2e2bcd8739ae039 = (props)=>(0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $iXiUJ.default), props) : /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $f8Sb3.jsx)($7b9c92562d0fe90f$var$LoadingDialog, {
            shareFormTitle: props.shareFormTitle,
            showTitle: props.showTitle,
            setIsLoading: props.setIsLoading,
            integrationMode: props.integrationMode,
            isMenuItemSelected: props.isMenuItemSelected,
            isExtendedShareDialogEnabled: props.isExtendedShareDialogEnabled
        })
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)($7b9c92562d0fe90f$var$LazyShareFormLazy, props));

});
parcelRegister("dZbU3", function(module, exports) {

$parcel$export(module.exports, "default", () => $018ce6039808fd6c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $VSDnB = parcelRequire("VSDnB");

var $idKBS = parcelRequire("idKBS");

var $6OqtU = parcelRequire("6OqtU");

var $10MNJ = parcelRequire("10MNJ");

var $i3XHT = parcelRequire("i3XHT");
const $018ce6039808fd6c$var$ShareFormWrapper = ({ shareFormTitle: shareFormTitle, shouldShowTitle: shouldShowTitle, children: children = null, header: header = null, footer: footer = null, integrationMode: integrationMode = 'off', isMenuItemSelected: isMenuItemSelected = false, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const ContentWrapper = (0, $VSDnB.fg)('share-compiled-migration') ? (0, $10MNJ.InlineDialogContentWrapper) : (0, $i3XHT.InlineDialogContentWrapper);
    const FormWrapper = (0, $VSDnB.fg)('share-compiled-migration') ? (0, $10MNJ.InlineDialogFormWrapper) : (0, $i3XHT.InlineDialogFormWrapper);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)(ContentWrapper, {
        label: formatMessage((0, $idKBS.messages).formTitle),
        children: [
            (0, $VSDnB.fg)('platform_share_custom_header_prop') && header,
            /*#__PURE__*/ (0, $2OMIu.jsxs)(FormWrapper, {
                integrationMode: integrationMode,
                isMenuItemSelected: isMenuItemSelected,
                isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                children: [
                    shouldShowTitle && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6OqtU.ShareHeader), {
                        title: shareFormTitle
                    }),
                    children
                ]
            }),
            footer
        ]
    });
};
var $018ce6039808fd6c$export$2e2bcd8739ae039 = $018ce6039808fd6c$var$ShareFormWrapper;

});
parcelRegister("6OqtU", function(module, exports) {

$parcel$export(module.exports, "ShareHeader", () => $b6372b3118718628$export$77192fbb468e5af8);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $idKBS = parcelRequire("idKBS");
const $b6372b3118718628$var$headerWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    marginRight: 'space.400',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'space.400'
});
const $b6372b3118718628$var$headerWrapperExtraSpaceStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});
const $b6372b3118718628$export$77192fbb468e5af8 = ({ isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, title: title })=>{
    const headingSize = isExtendedShareDialogEnabled ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: [
            $b6372b3118718628$var$headerWrapperStyles,
            isExtendedShareDialogEnabled && $b6372b3118718628$var$headerWrapperExtraSpaceStyles
        ],
        children: (0, $VSDnB.fg)('share-header-accessibility') ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
            size: headingSize,
            as: "h2",
            children: title || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $idKBS.messages).formTitle
            })
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
            size: headingSize,
            children: title || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                ...(0, $idKBS.messages).formTitle
            })
        })
    });
};

});

parcelRegister("10MNJ", function(module, exports) {

$parcel$export(module.exports, "InlineDialogFormWrapper", () => $923a8f62c8def5db$export$54db87debcabf37b);
$parcel$export(module.exports, "InlineDialogContentWrapper", () => $923a8f62c8def5db$export$a05835e82fd98f96);
/* compiled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $923a8f62c8def5db$var$styles = {
    menuNotSelectedAndMenuIntegration: "_1bsbpk3t",
    tabsIntegration: "_1bsb1wug",
    default: "_1bsb1j89",
    extendedDefault: "_1bsb1op3",
    inlineDialogContentWrapper: "_ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb"
};
const $923a8f62c8def5db$export$54db87debcabf37b = ({ children: children, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    if (!isMenuItemSelected && integrationMode === 'menu') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)($923a8f62c8def5db$var$styles.menuNotSelectedAndMenuIntegration),
        children: children
    });
    if ((0, $VSDnB.fg)('smart_links_for_plans_platform')) {
        if (integrationMode === 'tabs') return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($923a8f62c8def5db$var$styles.tabsIntegration),
            children: children
        });
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: (0, $3JT92.cx)(isExtendedShareDialogEnabled ? $923a8f62c8def5db$var$styles.extendedDefault : $923a8f62c8def5db$var$styles.default),
        children: children
    });
};
const $923a8f62c8def5db$export$a05835e82fd98f96 = ({ children: children, label: label })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        "aria-label": label,
        xcss: $923a8f62c8def5db$var$styles.inlineDialogContentWrapper,
        children: children
    });

});

parcelRegister("i3XHT", function(module, exports) {

$parcel$export(module.exports, "InlineDialogFormWrapper", () => $cd74a614dabf2b1c$export$54db87debcabf37b);
$parcel$export(module.exports, "InlineDialogContentWrapper", () => $cd74a614dabf2b1c$export$a05835e82fd98f96);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $MaS1v = parcelRequire("MaS1v");
/**
 * Set fixed width considering full form width and full menu width in order
 * to prevent dialog form from bouncing when isLoading prop is set to true.
 * Since loading container has 100% width, it adjusts accordingly.
 */ const $cd74a614dabf2b1c$var$calculateFormWrapperWidth = ({ integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    const formWidth = `${isExtendedShareDialogEnabled ? 452 : 352}px`;
    if (!isMenuItemSelected && integrationMode === 'menu') return 0, $MaS1v.menuWrapperWidth;
    if ((0, $VSDnB.fg)('smart_links_for_plans_platform')) {
        if (integrationMode === 'tabs') return 'auto';
    }
    return formWidth;
};
const $cd74a614dabf2b1c$export$54db87debcabf37b = ({ children: children, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    const styles = {
        width: $cd74a614dabf2b1c$var$calculateFormWrapperWidth({
            integrationMode: integrationMode,
            isMenuItemSelected: isMenuItemSelected,
            isExtendedShareDialogEnabled: isExtendedShareDialogEnabled
        })
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: styles
    }, children);
};
const $cd74a614dabf2b1c$var$inlineDialogContentWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`
});
const $cd74a614dabf2b1c$export$a05835e82fd98f96 = ({ children: children, label: label })=>{
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $cd74a614dabf2b1c$var$inlineDialogContentWrapperStyles,
        "aria-label": label
    }, children);
};

});
parcelRegister("MaS1v", function(module, exports) {

$parcel$export(module.exports, "ShareMenuItem", () => $604fc1c02fbeee92$export$144cc6e5e0841ff9);
$parcel$export(module.exports, "menuWrapperWidth", () => $604fc1c02fbeee92$export$1cd8104f92c0e299);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");

var $kJpBP = parcelRequire("kJpBP");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $604fc1c02fbeee92$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 'size.200',
    width: 'size.200',
    borderRadius: 'border.radius'
});
const $604fc1c02fbeee92$export$144cc6e5e0841ff9 = ({ iconName: iconName, labelId: labelId, onClickHandler: onClickHandler })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
        iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)($604fc1c02fbeee92$export$8f314e512d92575f, {
            icon: iconName
        }),
        onClick: onClickHandler,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
            ...labelId
        })
    });
const $604fc1c02fbeee92$export$8f314e512d92575f = ({ icon: icon })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        xcss: $604fc1c02fbeee92$var$iconContainerStyles,
        children: icon
    });
const $604fc1c02fbeee92$export$1cd8104f92c0e299 = '102px';

});



parcelRegister("iXiUJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $61d94c1e278a7cbd$export$2e2bcd8739ae039);
/* lazyNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");

var $eZJjh = parcelRequire("eZJjh");

var $dZbU3 = parcelRequire("dZbU3");
const $61d94c1e278a7cbd$var$styles = {
    spinnerWrapperStyles: "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _ae4v1h6o"
};

const $61d94c1e278a7cbd$var$LazyShareFormLazy = /*#__PURE__*/ (0, $5uXOq.lazy)(()=>(parcelRequire("2pN3k")));
const $61d94c1e278a7cbd$var$LoadingDialog = ({ shareFormTitle: shareFormTitle, showTitle: showTitle, setIsLoading: setIsLoading, integrationMode: integrationMode, isMenuItemSelected: isMenuItemSelected, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useEffect(()=>{
        setIsLoading(true);
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dZbU3.default), {
        shareFormTitle: shareFormTitle,
        integrationMode: integrationMode,
        isMenuItemSelected: isMenuItemSelected,
        // if `showTitle` is passed, we use it. Otherwise, we will show title for loading dialog.
        shouldShowTitle: typeof showTitle === 'boolean' ? showTitle : true,
        isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($61d94c1e278a7cbd$var$styles.spinnerWrapperStyles),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {})
        })
    });
};
var $61d94c1e278a7cbd$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)($61d94c1e278a7cbd$var$LoadingDialog, {
            shareFormTitle: props.shareFormTitle,
            showTitle: props.showTitle,
            setIsLoading: props.setIsLoading,
            integrationMode: props.integrationMode,
            isMenuItemSelected: props.isMenuItemSelected,
            isExtendedShareDialogEnabled: props.isExtendedShareDialogEnabled
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($61d94c1e278a7cbd$var$LazyShareFormLazy, {
            ...props
        })
    });

});
parcelRegister("2pN3k", function(module, exports) {

let $1c23f763c8bd0f91$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $1c23f763c8bd0f91$var$load("ffQaD"),
    $1c23f763c8bd0f91$var$load("kvRbA"),
    $1c23f763c8bd0f91$var$load("c2PGS")
]).then(()=>parcelRequire('6GxX7'));

});


parcelRegister("lhRB1", function(module, exports) {

let $f7f4c298928f54d1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f7f4c298928f54d1$var$load("ffQaD"),
    $f7f4c298928f54d1$var$load("kvRbA"),
    $f7f4c298928f54d1$var$load("3AP4i")
]).then(()=>parcelRequire('1haaP'));

});


parcelRegister("bked4", function(module, exports) {

$parcel$export(module.exports, "default", () => $c623df2911700361$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");
const $c623df2911700361$export$e980dfbc2840e8bc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(// Discard aria-haspopup
function ShareButton({ text: text, 'aria-haspopup': _ariaHasPopup, ...props }, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        id: "share-trigger-btn",
        ref: ref,
        "aria-haspopup": "dialog",
        ...props,
        children: text
    });
});
$c623df2911700361$export$e980dfbc2840e8bc.displayName = 'ShareButton';
var $c623df2911700361$export$2e2bcd8739ae039 = $c623df2911700361$export$e980dfbc2840e8bc;

});

parcelRegister("1t1FK", function(module, exports) {

$parcel$export(module.exports, "ShareDialogWithTriggerInternal", () => $38a31715b9b420dd$export$bc20a02e9bc30e54);
/* ShareDialogWithTriggerNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $cb25w = parcelRequire("cb25w");

var $3JT92 = parcelRequire("3JT92");

var $kOEld = parcelRequire("kOEld");

var $VSDnB = parcelRequire("VSDnB");

var $1I7E8 = parcelRequire("1I7E8");

var $k8nZq = parcelRequire("k8nZq");

var $MHKc7 = parcelRequire("MHKc7");

var $k5uoT = parcelRequire("k5uoT");

var $3bDjY = parcelRequire("3bDjY");

var $idKBS = parcelRequire("idKBS");


var $b2oBK = parcelRequire("b2oBK");

var $hQWyD = parcelRequire("hQWyD");

var $65uFp = parcelRequire("65uFp");

var $KNlKW = parcelRequire("KNlKW");

var $bked4 = parcelRequire("bked4");

var $cnQaw = parcelRequire("cnQaw");

var $4gTjW = parcelRequire("4gTjW");
const $38a31715b9b420dd$var$styles = {
    shareButtonWrapperStyles: "_12ji1r31 _1qu2glyw _12y31o36 _1e0c116y",
    outlineNone: "_12ji1r31 _1qu2glyw _12y31o36"
};
const $38a31715b9b420dd$export$4d9147e1bc6c176 = {
    users: [],
    comment: {
        format: 'plain_text',
        value: ''
    }
};
const $38a31715b9b420dd$export$55abe7932f6ca981 = ()=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
        spacing: "spacious",
        label: "",
        color: "currentColor"
    });
class $38a31715b9b420dd$export$bc20a02e9bc30e54 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
    static{
        this.defaultProps = {
            isDisabled: false,
            dialogPlacement: 'bottom-end',
            shouldCloseOnEscapePress: true,
            triggerButtonAppearance: 'subtle',
            triggerButtonStyle: 'icon-only',
            triggerButtonTooltipPosition: 'top',
            dialogZIndex: (0, $k5uoT.layers).modal()
        };
    }
    componentDidMount() {
        if (this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentDidUpdate(prevProps) {
        if (this.props.isAutoOpenDialog !== prevProps.isAutoOpenDialog && this.props.isAutoOpenDialog) this.handleDialogOpen();
    }
    componentWillUnmount() {
        if (this.props.isAutoOpenDialog && this.props.onDialogClose) this.props.onDialogClose();
    }
    async generateShareError(err) {
        const errorBody = err.body ? await err.body : {};
        // We'll only try and deal with the first error, sorry
        const firstErrorFromBody = errorBody.messagesDetails?.[0];
        return {
            message: firstErrorFromBody?.message || err.message,
            errorCode: firstErrorFromBody?.errorCode,
            helpUrl: firstErrorFromBody?.helpUrl,
            retryable: firstErrorFromBody?.errorCode === undefined
        };
    }
    render() {
        const { isDialogOpen: isDialogOpen, isSharing: isSharing, shareError: shareError, defaultValue: defaultValue, showIntegrationForm: showIntegrationForm, selectedIntegration: selectedIntegration, isMenuItemSelected: isMenuItemSelected } = this.state;
        const { copyLink: copyLink, dialogPlacement: dialogPlacement, config: config, isFetchingConfig: isFetchingConfig, loadUserOptions: loadUserOptions, shareFormTitle: shareFormTitle, shareFormHelperMessage: shareFormHelperMessage, bottomMessage: bottomMessage, submitButtonLabel: submitButtonLabel, product: product, productAttributes: productAttributes, customHeader: customHeader, customFooter: customFooter, enableSmartUserPicker: enableSmartUserPicker, loggedInAccountId: loggedInAccountId, cloudId: cloudId, orgId: orgId, shareFieldsFooter: shareFieldsFooter, dialogZIndex: dialogZIndex, isPublicLink: isPublicLink, tabIndex: tabIndex, copyTooltipText: copyTooltipText, integrationMode: integrationMode, shareIntegrations: shareIntegrations, additionalTabs: additionalTabs, builtInTabContentWidth: builtInTabContentWidth, isBrowseUsersDisabled: isBrowseUsersDisabled, userPickerOptions: userPickerOptions, isSubmitShareDisabled: isSubmitShareDisabled, additionalUserFields: additionalUserFields, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled, CustomSubmitButton: CustomSubmitButton } = this.props;
        const footer = (0, $4gTjW.resolveShareFooter)(integrationMode, this.state.tabIndex, customFooter);
        // for performance purposes, we may want to have a loadable content i.e. ShareForm
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
            xcss: (0, $3JT92.cx)($38a31715b9b420dd$var$styles.shareButtonWrapperStyles, typeof tabIndex !== 'undefined' && tabIndex >= 0 && $38a31715b9b420dd$var$styles.outlineNone),
            tabIndex: tabIndex,
            onKeyDown: this.handleKeyDown,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1I7E8.default), {
                    content: ()=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: this.containerRef,
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $KNlKW.default), {
                                Content: selectedIntegration && selectedIntegration.Content,
                                selectedIntegration: selectedIntegration,
                                copyLink: copyLink,
                                showIntegrationForm: showIntegrationForm,
                                bottomMessage: bottomMessage,
                                customHeader: (0, $VSDnB.fg)('platform_share_custom_header_prop') && customHeader,
                                customFooter: footer,
                                loadOptions: loadUserOptions,
                                isSharing: isSharing,
                                shareFormTitle: shareFormTitle,
                                showTitle: integrationMode !== 'tabs' || !shareIntegrations || !shareIntegrations.length,
                                shareFormHelperMessage: shareFormHelperMessage,
                                shareError: shareError,
                                defaultValue: defaultValue,
                                config: config,
                                isFetchingConfig: isFetchingConfig,
                                setIsLoading: this.setIsLoading,
                                submitButtonLabel: submitButtonLabel,
                                product: product,
                                productAttributes: productAttributes,
                                enableSmartUserPicker: enableSmartUserPicker,
                                loggedInAccountId: loggedInAccountId,
                                cloudId: cloudId,
                                orgId: orgId,
                                onUserSelectionChange: this.handleOnUserSelectionChange,
                                shareFieldsFooter: shareFieldsFooter,
                                isPublicLink: isPublicLink,
                                copyTooltipText: copyTooltipText,
                                integrationMode: integrationMode,
                                shareIntegrations: shareIntegrations,
                                additionalTabs: additionalTabs,
                                builtInTabContentWidth: builtInTabContentWidth,
                                isMenuItemSelected: isMenuItemSelected,
                                isSubmitShareDisabled: isSubmitShareDisabled,
                                // actions
                                onLinkCopy: this.handleCopyLink,
                                onSubmit: this.handleShareSubmit,
                                onDismiss: this.handleFormDismiss,
                                onDialogClose: this.handleCloseDialog,
                                onTabChange: this.onTabChange,
                                onMenuItemChange: this.onMenuItemChange,
                                //ref
                                selectPortalRef: this.selectPortalRef,
                                isBrowseUsersDisabled: isBrowseUsersDisabled,
                                userPickerOptions: userPickerOptions,
                                additionalUserFields: additionalUserFields,
                                isExtendedShareDialogEnabled: isExtendedShareDialogEnabled,
                                CustomSubmitButton: CustomSubmitButton
                            })
                        }),
                    isOpen: isDialogOpen,
                    onClose: this.handleCloseDialog,
                    placement: dialogPlacement,
                    trigger: this.renderShareTriggerButton,
                    zIndex: dialogZIndex,
                    label: this.props.intl.formatMessage((0, $idKBS.messages).sharePopupLabel),
                    role: "dialog",
                    // TODO: remove after https://hello.atlassian.net/wiki/x/SoEGzQ experiment is finished
                    offset: this.calculatePopupOffset({
                        isMenuItemSelected: isMenuItemSelected,
                        dialogPlacement: dialogPlacement
                    }),
                    shouldRenderToParent: (0, $VSDnB.fg)('enable-appropriate-reading-order-in-share-dialog')
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                    zIndex: (0, $4gTjW.generateSelectZIndex)(dialogZIndex),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        ref: this.selectPortalRef
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), /**
   * Because the PopUp component has a higher zIndex it causes
   * the select to be rendered within it, and add scrollbars.
   * We will render the select options the PopUp outside,
   */ this.selectPortalRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createRef(), this.start = 0, this.state = {
            isDialogOpen: false,
            isSharing: false,
            ignoreIntermediateState: false,
            defaultValue: $38a31715b9b420dd$export$4d9147e1bc6c176,
            isUsingSplitButton: false,
            showIntegrationForm: false,
            selectedIntegration: null,
            tabIndex: 0,
            isMenuItemSelected: false,
            isLoading: false
        }, this.closeAndResetDialog = ()=>{
            this.setState({
                defaultValue: $38a31715b9b420dd$export$4d9147e1bc6c176,
                ignoreIntermediateState: true,
                shareError: undefined,
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                isMenuItemSelected: false
            });
            const { onUserSelectionChange: onUserSelectionChange, onDialogClose: onDialogClose } = this.props;
            if (onUserSelectionChange) onUserSelectionChange($38a31715b9b420dd$export$4d9147e1bc6c176.users);
            if (onDialogClose) onDialogClose();
        }, this.createAndFireEvent = (payload)=>{
            const { createAnalyticsEvent: createAnalyticsEvent, analyticsDecorator: analyticsDecorator } = this.props;
            if (analyticsDecorator) payload = analyticsDecorator(payload);
            if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $b2oBK.CHANNEL_ID));
        }, this.onTabChange = (index)=>{
            let subjectId = 'shareTab';
            const { shareContentType: shareContentType } = this.props;
            if (index === 1) subjectId = 'shareToSlackTab';
            this.createAndFireEvent((0, $b2oBK.shareTabClicked)(subjectId, shareContentType));
            this.setState({
                tabIndex: index
            });
        }, this.onMenuItemChange = (menuType)=>{
            let subjectId = menuType === 'Slack' ? 'shareToSlackMenuItem' : 'shareMenuItem';
            const { shareContentType: shareContentType } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareMenuItemClicked)(subjectId, shareContentType));
            this.setState({
                isMenuItemSelected: true
            });
        }, this.getFlags = ()=>{
            const { intl: { formatMessage: formatMessage } } = this.props;
            // The reason for providing message property is that in jira,
            // the Flag system takes only Message Descriptor as payload
            // and formatMessage is called for every flag
            // if the translation data is not provided, a translated default message
            // will be displayed
            return [
                {
                    appearance: 'success',
                    title: {
                        ...(0, $idKBS.messages).shareSuccessMessage,
                        defaultMessage: formatMessage((0, $idKBS.messages).shareSuccessMessage, {
                            object: this.props.shareContentType.toLowerCase()
                        })
                    },
                    type: (0, $dcbcc8fabc474606$export$9540ac9c843b8743)
                }
            ];
        }, this.setIsLoading = (isLoading)=>{
            this.setState({
                isLoading: isLoading
            });
        }, this.focus = ()=>{
            if (this.containerRef.current) this.containerRef.current.focus();
        }, this.handleKeyDown = (event)=>{
            const { isLoading: isLoading, isDialogOpen: isDialogOpen } = this.state;
            const { shouldCloseOnEscapePress: shouldCloseOnEscapePress } = this.props;
            if (isLoading) {
                event.stopPropagation();
                this.focus();
            }
            if (isDialogOpen) switch(event.key){
                case 'Esc':
                case 'Escape':
                    // The @atlaskit/popup will capture the event and auto-close, we
                    // need to prevent that if the dialog is set to not close on `ESC`
                    if (!shouldCloseOnEscapePress) {
                        event.preventDefault();
                        event.stopPropagation();
                        // put the focus back onto the share dialog so that
                        // the user can press the escape key again to close the dialog
                        this.focus();
                        return;
                    }
                    // The dialog will auto-close in @atlaskit/popup, we just need to fire
                    // the right events.
                    if (shouldCloseOnEscapePress) {
                        // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
                        // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
                        // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
                        (0, $65uFp.renderShareDialogExp).abort();
                        this.createAndFireEvent((0, $b2oBK.cancelShare)(this.start));
                        this.closeAndResetDialog();
                    }
            }
        }, this.handleDialogOpen = ()=>{
            this.setState((state)=>({
                    isDialogOpen: !state.isDialogOpen,
                    ignoreIntermediateState: false,
                    showIntegrationForm: false,
                    selectedIntegration: null
                }), ()=>{
                const { onDialogOpen: onDialogOpen, isPublicLink: isPublicLink } = this.props;
                const { isDialogOpen: isDialogOpen } = this.state;
                if (isDialogOpen) {
                    this.start = Date.now();
                    this.createAndFireEvent((0, $b2oBK.screenEvent)({
                        isPublicLink: isPublicLink
                    }));
                    if (onDialogOpen) onDialogOpen();
                    this.focus();
                } else this.handleCloseDialog();
            });
        }, this.onTriggerClick = ()=>{
            const { onTriggerButtonClick: onTriggerButtonClick } = this.props;
            this.createAndFireEvent((0, $b2oBK.shareTriggerButtonClicked)());
            this.handleDialogOpen();
            if (onTriggerButtonClick) onTriggerButtonClick();
        }, this.handleCloseDialog = ()=>{
            if (this.props.onDialogClose) this.props.onDialogClose();
            // This experience should be aborted in a scenario when a user closes the dialog before the shareClient.getConfig() call is finished
            // It is a race condition between the `SUCCEEDED` case and the `ABORTED` case of this experience
            // UFO experiences can only have one FINAL state so it doesn't matter if we call .abort() after the experience has succeeded and vice versa
            (0, $65uFp.renderShareDialogExp).abort();
            this.setState({
                isDialogOpen: false,
                showIntegrationForm: false,
                selectedIntegration: null,
                tabIndex: 0,
                isMenuItemSelected: false
            });
        }, this.handleShareSubmit = (data)=>{
            const { onShareSubmit: onShareSubmit, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, formShareOrigin: formShareOrigin, showFlags: showFlags, isPublicLink: isPublicLink, isExtendedShareDialogEnabled: isExtendedShareDialogEnabled } = this.props;
            if (!onShareSubmit) return;
            (0, $65uFp.shareSubmitExp).start();
            this.setState({
                isSharing: true
            });
            this.createAndFireEvent((0, $b2oBK.formShareSubmitted)({
                start: this.start,
                data: data,
                shareContentType: shareContentType,
                shareOrigin: formShareOrigin,
                isPublicLink: isPublicLink,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
            onShareSubmit(data).then(()=>{
                this.closeAndResetDialog();
                this.setState({
                    isSharing: false
                });
                if (isExtendedShareDialogEnabled && data.users.length === 0) (0, $65uFp.shareSubmitExp).abort();
                else {
                    showFlags(this.getFlags());
                    (0, $65uFp.shareSubmitExp).success();
                }
            }).catch(async (err)=>{
                const shareError = await this.generateShareError(err).catch((errorGenFailed)=>({
                        message: err.message || errorGenFailed.message || 'Unknown error',
                        retryable: true
                    }));
                this.setState({
                    isSharing: false,
                    shareError: shareError
                });
                (0, $hQWyD.isValidFailedExperience)((0, $65uFp.shareSubmitExp), err);
            });
        }, this.handleFormDismiss = (data)=>{
            this.setState(({ ignoreIntermediateState: ignoreIntermediateState })=>ignoreIntermediateState ? null : {
                    defaultValue: data
                });
        }, this.calculatePopupOffset = ({ isMenuItemSelected: isMenuItemSelected, dialogPlacement: dialogPlacement })=>{
            if (isMenuItemSelected && dialogPlacement === 'bottom-end') return [
                -0.1,
                8
            ];
            return [
                0,
                8
            ];
        }, this.handleCopyLink = ()=>{
            const { copyLinkOrigin: copyLinkOrigin, shareContentType: shareContentType, shareContentSubType: shareContentSubType, shareContentId: shareContentId, isPublicLink: isPublicLink, shareAri: shareAri } = this.props;
            this.createAndFireEvent((0, $b2oBK.copyLinkButtonClicked)({
                start: this.start,
                shareContentType: shareContentType,
                shareOrigin: copyLinkOrigin,
                isPublicLink: isPublicLink,
                ari: shareAri,
                shareContentSubType: shareContentSubType,
                shareContentId: shareContentId
            }));
        }, this.handleIntegrationClick = (integration)=>{
            this.setState({
                isUsingSplitButton: false,
                isDialogOpen: true,
                showIntegrationForm: true,
                selectedIntegration: integration
            });
        }, this.renderShareTriggerButton = (triggerProps)=>{
            const { isDialogOpen: isDialogOpen, isUsingSplitButton: isUsingSplitButton } = this.state;
            const { intl: { formatMessage: formatMessage }, isDisabled: isDisabled, renderCustomTriggerButton: renderCustomTriggerButton, triggerButtonIcon: triggerButtonIcon, triggerButtonTooltipText: triggerButtonTooltipText, triggerButtonTooltipPosition: triggerButtonTooltipPosition, triggerButtonAppearance: triggerButtonAppearance, triggerButtonStyle: triggerButtonStyle, integrationMode: integrationMode, shareIntegrations: shareIntegrations, dialogZIndex: dialogZIndex, dialogPlacement: dialogPlacement } = this.props;
            let button;
            const ShareButtonIcon = triggerButtonIcon || $38a31715b9b420dd$export$55abe7932f6ca981;
            // Render a custom or standard button.
            if (renderCustomTriggerButton) {
                const { shareError: shareError } = this.state;
                button = renderCustomTriggerButton({
                    error: shareError,
                    isDisabled: isDisabled,
                    isSelected: isDialogOpen,
                    onClick: this.onTriggerClick
                }, triggerProps);
            } else button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bked4.default), {
                appearance: triggerButtonAppearance,
                text: triggerButtonStyle !== 'icon-only' ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ousew.default), {
                    ...(0, $idKBS.messages).shareTriggerButtonText
                }) : null,
                "aria-label": formatMessage((0, $idKBS.messages).shareTriggerButtonText),
                onClick: this.onTriggerClick,
                iconBefore: triggerButtonStyle !== 'text-only' ? /*#__PURE__*/ (0, $2OMIu.jsx)(ShareButtonIcon, {
                    label: ""
                }) : undefined,
                isSelected: isDialogOpen,
                isDisabled: isDisabled,
                ref: triggerProps.ref,
                // When we autoFocus the dialog, we want to autofocus the trigger as well, that way when the dialog is closed, the trigger is focused
                autoFocus: this.props.isAutoOpenDialog
            });
            // If the button only shows the icon, wrap it in a tooltip containing the button text.
            if (triggerButtonStyle === 'icon-only') button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
                content: !isUsingSplitButton ? triggerButtonTooltipText || formatMessage((0, $idKBS.messages).shareTriggerButtonTooltipText) : null,
                position: triggerButtonTooltipPosition,
                hideTooltipOnClick: true,
                children: button
            });
            // If there are any integrations, wrap the share button in a split button with integrations.
            if (integrationMode === 'split' && shareIntegrations?.length) button = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cnQaw.default), {
                shareButton: button,
                handleOpenSplitButton: this.handleOpenSplitButton,
                handleCloseSplitButton: this.handleCloseSplitButton,
                isUsingSplitButton: isUsingSplitButton,
                triggerButtonAppearance: triggerButtonAppearance,
                dialogZIndex: dialogZIndex,
                dialogPlacement: dialogPlacement,
                shareIntegrations: shareIntegrations,
                onIntegrationClick: this.handleIntegrationClick,
                createAndFireEvent: this.createAndFireEvent
            });
            return button;
        }, this.handleOpenSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: true
            }, ()=>this.handleCloseDialog());
            this.createAndFireEvent((0, $b2oBK.shareSplitButtonEvent)());
        }, this.handleCloseSplitButton = ()=>{
            this.setState({
                isUsingSplitButton: false
            });
        }, this.handleOnUserSelectionChange = (value)=>{
            const { onUserSelectionChange: onUserSelectionChange } = this.props;
            this.setState({
                shareError: undefined
            });
            onUserSelectionChange?.(value);
        };
    }
}
const $38a31715b9b420dd$export$c7f8df1e37e7f581 = (0, $cb25w.default)()((0, $8RXs9.default)($38a31715b9b420dd$export$bc20a02e9bc30e54));

});
parcelRegister("cnQaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $595b694e7cdc0462$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $ousew = parcelRequire("ousew");

var $42CjB = parcelRequire("42CjB");
var $7E6BG = parcelRequire("7E6BG");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $kEVMo = parcelRequire("kEVMo");

var $VSDnB = parcelRequire("VSDnB");


var $idKBS = parcelRequire("idKBS");

var $b2oBK = parcelRequire("b2oBK");

var $4kfPc = parcelRequire("4kfPc");
// span
const $595b694e7cdc0462$var$dropDownIntegrationButtonWrapperStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    ['button:hover']: {
        background: 'transparent'
    }
});
const $595b694e7cdc0462$var$integrationButtonText = (integrationName)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $ousew.default), {
        ...(0, $idKBS.messages).shareToIntegrationButtonText,
        values: {
            integrationName: integrationName
        }
    });
const $595b694e7cdc0462$var$IntegrationButtonWrapper = ({ children: children })=>// The css has no discernible effect on the button, so it is not included in the migration
    (0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, children) : /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $595b694e7cdc0462$var$dropDownIntegrationButtonWrapperStyles
    }, children);
const $595b694e7cdc0462$var$SplitButtonDropdown = (props)=>{
    const { triggerButtonAppearance: triggerButtonAppearance, isUsingSplitButton: isUsingSplitButton, handleOpenSplitButton: handleOpenSplitButton, handleCloseSplitButton: handleCloseSplitButton, shareIntegrations: shareIntegrations, onIntegrationClick: onIntegrationClick, createAndFireEvent: createAndFireEvent } = props;
    const onOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpen })=>{
        if (isOpen) handleOpenSplitButton();
        else handleCloseSplitButton();
    }, [
        handleOpenSplitButton,
        handleCloseSplitButton
    ]);
    const onIntegrationButtonClick = (0, $5uXOq.useCallback)((integration)=>{
        onIntegrationClick(integration);
        createAndFireEvent((0, $b2oBK.shareIntegrationButtonEvent)(integration.type));
    }, [
        createAndFireEvent,
        onIntegrationClick
    ]);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $BLPHT.default), {
        testId: "split-button-dropdown",
        trigger: ({ triggerRef: triggerRef, ...providedProps })=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $42CjB.default), {
                label: "",
                ...providedProps,
                ref: triggerRef,
                icon: (iconProps)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kEVMo))), {
                        ...iconProps,
                        size: "small"
                    }),
                appearance: triggerButtonAppearance
            }),
        placement: "bottom-end",
        isOpen: isUsingSplitButton,
        onOpenChange: onOpenChange,
        shouldRenderToParent: (0, $VSDnB.fg)('should-render-to-parent-should-be-true-people-and-')
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $aRoVz.default), null, shareIntegrations.map((integration)=>/*#__PURE__*/ (0, $f8Sb3.jsx)((0, $6B7KL.default), {
            key: integration.type,
            testId: `split-button-dropdownitem-${integration.type}`
        }, /*#__PURE__*/ (0, $f8Sb3.jsx)($595b694e7cdc0462$var$IntegrationButtonWrapper, null, /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $4kfPc.default), {
            textColor: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
            appearance: "subtle",
            onClick: ()=>onIntegrationButtonClick(integration),
            shouldFitContainer: true,
            text: $595b694e7cdc0462$var$integrationButtonText(integration.type),
            IntegrationIcon: integration.Icon
        }))))));
};
$595b694e7cdc0462$var$SplitButtonDropdown.displayName = 'SplitButtonDropdown';
function $595b694e7cdc0462$export$2e2bcd8739ae039({ shareButton: shareButton, handleOpenSplitButton: handleOpenSplitButton, handleCloseSplitButton: handleCloseSplitButton, isUsingSplitButton: isUsingSplitButton, shareIntegrations: shareIntegrations, onIntegrationClick: onIntegrationClick, triggerButtonAppearance: triggerButtonAppearance, createAndFireEvent: createAndFireEvent }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $7E6BG.SplitButton), {
        "data-testid": "split-button",
        appearance: triggerButtonAppearance
    }, shareButton, /*#__PURE__*/ (0, $f8Sb3.jsx)($595b694e7cdc0462$var$SplitButtonDropdown, {
        shareIntegrations: shareIntegrations,
        triggerButtonAppearance: triggerButtonAppearance,
        isUsingSplitButton: isUsingSplitButton,
        handleOpenSplitButton: handleOpenSplitButton,
        handleCloseSplitButton: handleCloseSplitButton,
        onIntegrationClick: onIntegrationClick,
        createAndFireEvent: createAndFireEvent
    }));
}

});
parcelRegister("7E6BG", function(module, exports) {

$parcel$export(module.exports, "SplitButton", () => $2f706a5180e21ed2$export$651ad66661acd392);
/* split-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $icwyz = parcelRequire("icwyz");

var $jvAlz = parcelRequire("jvAlz");
const $2f706a5180e21ed2$var$dividerStyles = {
    baseDivider: "_1bsbe4h9 _kqswh2mm _1pbykb7n",
    dividerDisabled: "_bfhkojnm _80om13gf _tzy41uwv",
    dividerDisabledRefreshed: "_bfhk9xzm _80om13gf",
    dividerOffsetRefreshed: "_195g1n1a"
};
const $2f706a5180e21ed2$var$dividerAppearanceStyles = {
    default: "_bfhk1fxt _tzy41uwv",
    primary: "_bfhk15cr _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
const $2f706a5180e21ed2$var$dividerRefreshedAppearanceStyles = {
    default: "_bfhkmuej",
    primary: "_bfhkveue _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkdud1 _tzy419lr"
};
const $2f706a5180e21ed2$var$dividerHeightStyles = {
    default: "_4t3iviql",
    compact: "_4t3i1k8s"
};
// The divider height is calculated by subtracting twice the border width from the button height.
// This ensures the divider does not intersect with the button's border, avoiding visual issues
// caused by overlapping alpha colors (color.border) at the intersection.
const $2f706a5180e21ed2$var$defaultDividerHeightStyles = {
    default: "_4t3im1ee",
    compact: "_4t3i1hvu"
};
const $2f706a5180e21ed2$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const isDefaultDivider = appearance === 'default' && !isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh');
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            $2f706a5180e21ed2$var$dividerStyles.baseDivider,
            isDefaultDivider && $2f706a5180e21ed2$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $2f706a5180e21ed2$var$dividerHeightStyles[spacing],
            isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerStyles.dividerDisabledRefreshed,
            isDisabled && !(0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerStyles.dividerDisabled,
            !isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerRefreshedAppearanceStyles[appearance],
            !isDisabled && !(0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerAppearanceStyles[appearance],
            (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$dividerStyles.dividerOffsetRefreshed
        ])
    });
};
const $2f706a5180e21ed2$var$buttonStyles = {
    splitButton: "_1e0c116y _kqswh2mm _4cvr1h6o _o5721q9c",
    primaryButton: "_traeidpf _anlpidpf _p9ykidpf _bepvidpf",
    secondaryButton: "_1j4hidpf _1553idpf _1qgbidpf _y1n3idpf",
    defaultAppearanceContainer: "_2rko1sit _12jimuej _1cwg1n1a _1qu2nqa1 _12y3t94y"
};
const $2f706a5180e21ed2$export$994ba1b4c598f7 = ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            appearance === 'default' && !isDisabled && (0, $VSDnB.fg)('platform-component-visual-refresh') && $2f706a5180e21ed2$var$buttonStyles.defaultAppearanceContainer,
            $2f706a5180e21ed2$var$buttonStyles.splitButton
        ]),
        children: children
    });
};
const $2f706a5180e21ed2$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $jvAlz.getActions)(children);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $icwyz.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.primaryButton
                    ]),
                    children: PrimaryAction
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$2e0a83ec2e27ecbb, {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.secondaryButton
                    ]),
                    children: SecondaryAction
                })
            ]
        })
    });
};
const $2f706a5180e21ed2$export$e3ca81100b492e15 = ({ primaryAction: primaryAction, secondaryAction: secondaryAction, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $icwyz.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.primaryButton
                    ]),
                    children: primaryAction
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)($2f706a5180e21ed2$export$2e0a83ec2e27ecbb, {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $2f706a5180e21ed2$var$buttonStyles.secondaryButton
                    ]),
                    children: secondaryAction
                })
            ]
        })
    });
};

});
parcelRegister("jvAlz", function(module, exports) {

$parcel$export(module.exports, "getActions", () => $425b7dc91147601e$export$fe3955935f564b31);

var $5uXOq = parcelRequire("5uXOq");

var $6cAn5 = parcelRequire("6cAn5");
const $425b7dc91147601e$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $5uXOq.Children).toArray(children);
    typeof $6cAn5;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};

});


parcelRegister("4kfPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe469c80a3193c7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $9yOBd = parcelRequire("9yOBd");

var $VSDnB = parcelRequire("VSDnB");


var $dsMCa = parcelRequire("dsMCa");
function $0fe469c80a3193c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $0fe469c80a3193c7$var$integrationButtonCopyWrapperStyle = {
    name: "16rgrc1",
    styles: "display:flex;justify-content:left"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $0fe469c80a3193c7$var$integrationIconWrapperStyle = {
    name: "mz1ewe",
    styles: "margin:var(--ds-space-025, 2px) var(--ds-space-100, 8px) var(--ds-space-0, 0px) var(--ds-space-0, 0px)"
};
const $0fe469c80a3193c7$var$IntegrationButtonInner = (props)=>{
    const { text: text, textColor: textColor, IntegrationIcon: IntegrationIcon, ...restProps } = props;
    return(// TODO: (from codemod) CustomThemeButton will be deprecated. Please consider migrating to Pressable or Anchor Primitives with custom styles.
    /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $9yOBd.default), restProps, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $0fe469c80a3193c7$var$integrationButtonCopyWrapperStyle,
        style: {
            color: textColor || `var(--ds-text, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`
        }
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: $0fe469c80a3193c7$var$integrationIconWrapperStyle
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)(IntegrationIcon, null)), /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null, text))));
};
const $0fe469c80a3193c7$var$IntegrationButton = (props)=>(0, $VSDnB.fg)('share-compiled-migration') ? /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $dsMCa.default), {
        text: props.text,
        onClick: props.onClick,
        IntegrationIcon: props.IntegrationIcon
    }) : /*#__PURE__*/ (0, $f8Sb3.jsx)($0fe469c80a3193c7$var$IntegrationButtonInner, props);
$0fe469c80a3193c7$var$IntegrationButton.displayName = 'IntegrationButton';
var $0fe469c80a3193c7$export$2e2bcd8739ae039 = $0fe469c80a3193c7$var$IntegrationButton;

});
parcelRegister("dsMCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb233873498bd3e7$export$2e2bcd8739ae039);
/* IntegrationButtonNext.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $3JT92 = parcelRequire("3JT92");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");
const $eb233873498bd3e7$var$styles = {
    integrationButtonCopyWrapperStyle: "_1e0c1txw _1bah1e5h _syaz10s3",
    integrationIconWrapperStyle: "_19pkv77o _2hwxu2gc _otyrze3t _18u0ze3t"
};
const $eb233873498bd3e7$var$IntegrationButton = (props)=>{
    const { text: text, IntegrationIcon: IntegrationIcon } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
        appearance: "subtle",
        shouldFitContainer: true,
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
            as: "span",
            xcss: (0, $3JT92.cx)($eb233873498bd3e7$var$styles.integrationButtonCopyWrapperStyle),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    as: "span",
                    xcss: (0, $3JT92.cx)($eb233873498bd3e7$var$styles.integrationIconWrapperStyle),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(IntegrationIcon, {})
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    color: "color.text",
                    children: text
                })
            ]
        })
    });
};
$eb233873498bd3e7$var$IntegrationButton.displayName = 'IntegrationButton';
var $eb233873498bd3e7$export$2e2bcd8739ae039 = $eb233873498bd3e7$var$IntegrationButton;

});



parcelRegister("4gTjW", function(module, exports) {

$parcel$export(module.exports, "generateSelectZIndex", () => $e2b0620d8e0c6274$export$eedd642610b90f47);
$parcel$export(module.exports, "getMenuPortalTargetCurrentHTML", () => $e2b0620d8e0c6274$export$e3e96376b61c8ea);
$parcel$export(module.exports, "optionDataToUsers", () => $e2b0620d8e0c6274$export$1c6fd61621efa6e2);
$parcel$export(module.exports, "allowEmails", () => $e2b0620d8e0c6274$export$e3c57815dfd9a32c);
$parcel$export(module.exports, "resolveShareFooter", () => $e2b0620d8e0c6274$export$6900a66855146901);

var $k5uoT = parcelRequire("k5uoT");
const $e2b0620d8e0c6274$export$ff1a1e5addedc4cc = 10;
const $e2b0620d8e0c6274$export$eedd642610b90f47 = (dialogZIndex)=>{
    // If user provided non-number value for zIndex, ignore and return undefined,
    // which will default to `layers.layer()` inside PopUp
    if (typeof dialogZIndex !== 'number' || !dialogZIndex) return (0, $k5uoT.layers).modal() + $e2b0620d8e0c6274$export$ff1a1e5addedc4cc;
    return dialogZIndex + $e2b0620d8e0c6274$export$ff1a1e5addedc4cc;
};
const $e2b0620d8e0c6274$export$e3e96376b61c8ea = (ref)=>{
    if (!ref) return null;
    if (!Object.prototype.hasOwnProperty.call(ref, 'current')) return null;
    // @ts-ignore ts(2339) - ref not having property current
    return ref.current;
};
const $e2b0620d8e0c6274$export$1c6fd61621efa6e2 = (optionDataArray)=>optionDataArray.map((optionData)=>{
        switch(optionData.type){
            case 'email':
                const user = {
                    type: 'user',
                    email: optionData.id
                };
                return user;
            case 'external_user':
                // When optionData.type is 'external_user', we need to convert it to 'user'
                // because 'external_user' isn't a valid type for the '/gateway/api/share' API.
                return {
                    type: 'user',
                    id: optionData.id
                };
            default:
                return {
                    type: optionData.type || 'user',
                    id: optionData.id
                };
        }
    });
const $e2b0620d8e0c6274$export$e3c57815dfd9a32c = (config)=>!(config && config.disableSharingToEmails);
const $e2b0620d8e0c6274$export$6900a66855146901 = (integrationMode, tabIndex, customFooter)=>{
    if (customFooter) {
        if (integrationMode !== 'tabs' || tabIndex === 0) return customFooter;
    }
};

});




parcelRegister("kAdLR", function(module, exports) {

$parcel$export(module.exports, "createAri", () => $63eb1b2c0e2cfff4$export$594d18a0ad2e0e57);
const $63eb1b2c0e2cfff4$var$getAriResourceOwner = (subProductId)=>{
    switch(subProductId){
        // these options aren't currently valid resource owners
        case 'jira-addon':
        case 'jira-platform':
        case 'jira-polaris':
        case 'jira-portfolio':
        case 'jira-unknown':
            return 'jira';
        // being explicit that these 3 are valid and were not forgotten
        case 'jira-core':
        case 'jira-servicedesk':
        case 'jira-software':
        default:
            return subProductId;
    }
};
const $63eb1b2c0e2cfff4$export$594d18a0ad2e0e57 = (subProductId, cloudId)=>`ari:cloud:${$63eb1b2c0e2cfff4$var$getAriResourceOwner(subProductId)}::site/${cloudId}`;

});

parcelRegister("aYuZy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea05149486244917$export$2e2bcd8739ae039);

var $2gQ83 = parcelRequire("2gQ83");

var $inlXa = parcelRequire("inlXa");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");
class $ea05149486244917$export$2e2bcd8739ae039 extends (0, $inlXa.ShareServiceClient) {
    constructor({ getShareEndpoint: getShareEndpoint, getSharePayload: getSharePayload }){
        super(), this.categorizeRecipients = (recipients)=>{
            const accumulator = {
                userIds: [],
                emails: []
            };
            return recipients.reduce((acc, recipient)=>{
                if (recipient.type === 'user') {
                    // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    if (recipient.email !== undefined) // @ts-expect-error - TS2339 - Property 'email' does not exist on type 'User'.
                    acc.emails.push(recipient.email);
                    else if (recipient.id !== undefined) // @ts-expect-error - TS2339 - Property 'id' does not exist on type 'User'.
                    acc.userIds.push(recipient.id);
                }
                return acc;
            }, accumulator);
        };
        this.getShareEndpoint = getShareEndpoint;
        this.getSharePayload = getSharePayload;
    }
    share(content, recipients, metadata, comment) {
        const categorizedRecipients = this.categorizeRecipients(recipients);
        const shareRequest = {
            usernames: categorizedRecipients.userIds,
            emails: categorizedRecipients.emails,
            message: comment?.value || '',
            atlOrigin: new (0, $2gQ83.default)({
                id: metadata.atlOriginId,
                product: 'jira'
            }).encode(),
            ...this.getSharePayload ? this.getSharePayload(content) : null
        };
        return (0, $eusud.performPostRequest)(this.getShareEndpoint(content), {
            body: JSON.stringify(shareRequest)
        }).catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                sendToPrivacyUnsafeSplunk: true,
                meta: {
                    packageName: 'jiraShareButton',
                    id: 'LegacyShareClient.share'
                },
                attributes: {
                    contentType: content.type
                }
            });
            throw error;
        });
    }
}

});

parcelRegister("kwHgU", function(module, exports) {

$parcel$export(module.exports, "loadUsers", () => $2adfecc7864678ee$export$2c3a8e05396a78be);
// @ts-expect-error - TS2305 - Module '"@atlaskit/share"' has no exported member 'OptionData'.

var $7f4tk = parcelRequire("7f4tk");
const $2adfecc7864678ee$var$USER_PICKER_LIMIT = 20;
const $2adfecc7864678ee$export$2c3a8e05396a78be = async (searchText = '')=>{
    const searchTextEncoded = encodeURIComponent(searchText);
    const url = `/rest/api/3/groupuserpicker?maxResults=${$2adfecc7864678ee$var$USER_PICKER_LIMIT}&query=${searchTextEncoded}&showAvatar=true&avatarSize=medium&excludeConnectAddons=true`;
    const groupsAndUsers = await (0, $7f4tk.default)(url);
    return groupsAndUsers.users.users.filter((user)=>user.accountType === 'atlassian').map((user)=>({
            type: 'user',
            id: user.accountId,
            name: user.displayName,
            avatarUrl: user.avatarUrl
        }));
};

});

parcelRegister("8HBuB", function(module, exports) {

$parcel$export(module.exports, "UserRole", () => $bbdf16990b710a51$export$eb3485a690c2f0b8);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $7O4UO = parcelRequire("7O4UO");
var $bUa6y = parcelRequire("bUa6y");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");
var $dS3PR = parcelRequire("dS3PR");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");
const $bbdf16990b710a51$var$styles = {
    userRoleSelect: "_16jlkb7n _i0dlidpf _1ul91obz _ca0qv47k _19pkv77o"
};
const $bbdf16990b710a51$var$messages = (0, $7VHMR.defineMessages)({
    userRoleLabel: {
        "id": "share-button.user-role.user-role-label.non-final",
        "defaultMessage": "User role"
    }
});
const $bbdf16990b710a51$var$SelectOption = ({ children: children, ...props })=>{
    const { data: data, isSelected: isSelected } = props;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $414Wj.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "medium",
        color: isSelected ? 'color.text.selected' : undefined
    }, data.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "small",
        color: "color.text.subtle"
    }, data.description)));
};
const $bbdf16990b710a51$var$getDefaultUserRole = (userRoleOptions)=>userRoleOptions.find((role)=>role.default) || userRoleOptions[0];
const $bbdf16990b710a51$export$eb3485a690c2f0b8 = ({ accessLevel: accessLevel, roles: roles, isLoading: isLoading })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formData = (0, $bUa6y.useFormState)({
        values: true
    });
    const shouldShowUserRole = (0, $5uXOq.useMemo)(()=>{
        const projectAccessLevel = formData?.values.projectAccessLevel?.value || accessLevel;
        return roles.length > 0 && projectAccessLevel && projectAccessLevel !== 'OPEN';
    }, [
        accessLevel,
        formData?.values.projectAccessLevel?.value,
        roles.length
    ]);
    const userRoleOptions = (0, $5uXOq.useMemo)(()=>roles.map((role)=>({
                label: role.name,
                value: role.id,
                description: role.description,
                default: role.default || false
            })), [
        roles
    ]);
    const [currentUserRole, setCurrentUserRole] = (0, $5uXOq.useState)($bbdf16990b710a51$var$getDefaultUserRole(userRoleOptions));
    (0, $5uXOq.useEffect)(()=>{
        if (!currentUserRole && userRoleOptions.length > 0) // If currentUserRole is not set, we set it to the default role from options.
        // This happens when the component is rendered before userRoleOptions are fetched.
        setCurrentUserRole($bbdf16990b710a51$var$getDefaultUserRole(userRoleOptions));
    }, [
        currentUserRole,
        userRoleOptions
    ]);
    if (!shouldShowUserRole) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: "userRole",
        defaultValue: currentUserRole
    }, ({ fieldProps: { onChange: onChange, value: value, ...fieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $bbdf16990b710a51$var$styles.userRoleSelect
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            ...fieldProps,
            isLoading: isLoading,
            options: userRoleOptions,
            value: currentUserRole,
            onChange: (userRoleOption)=>{
                if (!userRoleOption) return;
                onChange(userRoleOption);
                setCurrentUserRole(userRoleOption);
            },
            label: formatMessage($bbdf16990b710a51$var$messages.userRoleLabel),
            components: {
                Option: $bbdf16990b710a51$var$SelectOption
            },
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999
                    }),
                control: (base)=>({
                        ...base,
                        minHeight: '44px',
                        height: '100%',
                        width: '100%'
                    }),
                menu: (base)=>({
                        ...base,
                        width: 'fit-content',
                        position: 'absolute',
                        right: 0
                    }),
                option: (base)=>({
                        ...base,
                        width: '320px'
                    })
            },
            menuPortalTarget: globalThis.document.body
        })));
};

});

parcelRegister("b4Qrh", function(module, exports) {

$parcel$export(module.exports, "CustomShareSubmitButton", () => $0164a6f1ecd00b94$export$acf0d09f1a6f345b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bUa6y = parcelRequire("bUa6y");

var $MHKc7 = parcelRequire("MHKc7");
var $bUmQV = parcelRequire("bUmQV");

var $3bDjY = parcelRequire("3bDjY");

var $dD7Zc = parcelRequire("dD7Zc");

var $eCeGD = parcelRequire("eCeGD");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");
const $0164a6f1ecd00b94$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    formSharePublic: {
        "id": "share-button.custom-share-submit.form-share-public",
        "defaultMessage": "Share public link"
    },
    formSendPublic: {
        "id": "share-button.custom-share-submit.form-send-public",
        "defaultMessage": "Send public link"
    },
    formSave: {
        "id": "share-button.custom-share-submit.form-save",
        "defaultMessage": "Save"
    },
    formShare: {
        "id": "share-button.custom-share-submit.form-share",
        "defaultMessage": "Share"
    },
    formRetry: {
        "id": "share-button.custom-share-submit.form-retry",
        "defaultMessage": "Retry"
    },
    shareFailureMessage: {
        "id": "share-button.custom-share-submit.share-failure-message",
        "defaultMessage": "Unable to share"
    },
    shareFailureIconLabel: {
        "id": "share-button.custom-share-submit.share-failure-icon-label",
        "defaultMessage": "Error icon"
    }
});
const $0164a6f1ecd00b94$var$styles = {
    submitButtonWrapper: "_1e0c1txw _18u01wug",
    centerAlignedIconWrapper: "_1rjcze3t _18zrutpp _1e0c1txw _1wpz1h6o"
};
const $0164a6f1ecd00b94$export$acf0d09f1a6f345b = ({ isPublicLink: isPublicLink = false, shareError: shareError, isSharing: isSharing = false, isDisabled: isDisabled = false, isSubmitShareDisabled: isSubmitShareDisabled = false, integrationMode: integrationMode, submitButtonLabel: submitButtonLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formData = (0, $bUa6y.useFormState)({
        dirtyFields: true,
        values: true
    });
    const [shouldShowButton, setShouldShowButton] = (0, $5uXOq.useState)(false); // We use `useLayoutEffect` to ensure we show/hide the button before the button text is updated to avoid content flickering
    (0, $5uXOq.useLayoutEffect)(()=>{
        // If the form has not provided any state, we don't do anything
        if (!formData) return;
         /**
       * We hide the submit button based on 2 fields:
       * - User picker field
       * - Project access level field (provided by consumers)
       *
       * If both are unchanged, we hide the submit button.
       */ 
        const userPickerValues = formData?.values.users;
        if (userPickerValues?.length > 0 || formData?.dirtyFields?.projectAccessLevel) setShouldShowButton(true);
        else setShouldShowButton(false);
    }, [
        formData
    ]);
    const isRetryableError = !!shareError?.retryable;
    const isNonRetryableError = shareError && !shareError.retryable;
    const shouldShowWarning = isRetryableError && !isSharing;
    const buttonAppearance = !shouldShowWarning ? 'primary' : 'warning';
    const tabMode = integrationMode === 'tabs';
    const formPublicLabel = tabMode ? $0164a6f1ecd00b94$export$defe85febe8b728c.formSharePublic : $0164a6f1ecd00b94$export$defe85febe8b728c.formSendPublic;
    const formSendLabel = (0, $5uXOq.useMemo)(()=>{
        /**
     * We change the submit button label based on 2 fields:
     * - User picker field
     * - Project access level field (provided by consumers)
     *
     * If the project access level field is changed but the user picker field is pristine, we show a `Save` button.
     * If the user picker field is changed, we show a `Share` button.
     */ const userPickerValues = formData?.values?.users;
        if (userPickerValues && userPickerValues.length > 0) return $0164a6f1ecd00b94$export$defe85febe8b728c.formShare;
        return $0164a6f1ecd00b94$export$defe85febe8b728c.formSave;
    }, [
        formData?.values.users
    ]);
    const sendLabel = isPublicLink ? formPublicLabel : formSendLabel;
    const buttonLabel = isRetryableError ? $0164a6f1ecd00b94$export$defe85febe8b728c.formRetry : sendLabel;
    const buttonDisabled = isDisabled || isNonRetryableError || isSubmitShareDisabled;
    const ButtonLabelWrapper = buttonAppearance === 'warning' ? 'strong' : (0, $5uXOq.Fragment);
    if (!shouldShowButton) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $0164a6f1ecd00b94$var$styles.submitButtonWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $0164a6f1ecd00b94$var$styles.centerAlignedIconWrapper
    }, shouldShowWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage($0164a6f1ecd00b94$export$defe85febe8b728c.shareFailureMessage),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: formatMessage($0164a6f1ecd00b94$export$defe85febe8b728c.shareFailureIconLabel),
        color: "var(--ds-icon-danger, #C9372C)"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        appearance: buttonAppearance,
        type: "submit",
        isLoading: isSharing,
        isDisabled: buttonDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonLabelWrapper, null, submitButtonLabel || formatMessage(buttonLabel))));
};

});


parcelRegister("ckpyh", function(module, exports) {

$parcel$export(module.exports, "ProjectAccessLevelSelectContainer", () => $324557b9f7ca6aa3$export$be750a3a70b4f271);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");

var $MHKc7 = parcelRequire("MHKc7");
var $joKkQ = parcelRequire("joKkQ");
var $dS3PR = parcelRequire("dS3PR");

var $fptva = parcelRequire("fptva");

var $bwyQI = parcelRequire("bwyQI");

var $jHgVl = parcelRequire("jHgVl");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $1wbtX = parcelRequire("1wbtX");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");
const $324557b9f7ca6aa3$var$gridStyles = {
    root: "_yv0e5bpd _1lmcpt3h"
};
const $324557b9f7ca6aa3$var$FIELD_NAME = 'projectAccessLevel';
const $324557b9f7ca6aa3$var$styles = {
    iconContainer: "_nd5l2ec4 _18zr1b66 _1wpz1h6o _18u0r5cr",
    dropdownContainer: "_nd5l1ba5",
    descriptionContainer: "_nd5ltgt2 _1bsb1ns9 _18u0u2gc",
    optionDescriptionContainer: "_nd5ltgt2 _1bsb1ns9",
    field: "_1i53muej _15a5nqa1 _uwhke4h9 _19pk1ejb _otyrutpp _18u010v4 _2hwx10v4 _ca0qu2gc _19bv1ejb _u5f31ejb",
    skeleton: "_otyrutpp"
}; // `css` is used to customise the styles of the Select components, `cssMap` / `xcss` don't work here
const $324557b9f7ca6aa3$var$controlStyles = null;
const $324557b9f7ca6aa3$var$messages = (0, $7VHMR.defineMessages)({
    projectAccessLevelLabel: {
        "id": "share-dialog.fields.ProjectAccessLevelField.project-access-level-label.non-final",
        "defaultMessage": "Project access"
    }
});
const $324557b9f7ca6aa3$var$SelectControl = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Control, {
        ...props,
        appearance: "subtle",
        isCompact: true,
        className: (0, $bwpsq.default)([
            "_1bsb1ns9"
        ])
    });
};
const $324557b9f7ca6aa3$var$SelectOption = ({ children: children, ...props })=>{
    const { data: data, isSelected: isSelected } = props;
    if (!data) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $joKkQ.default), {
        xcss: $324557b9f7ca6aa3$var$gridStyles.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.iconContainer
    }, $324557b9f7ca6aa3$export$16b26cd5e98d9100(data.iconName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.dropdownContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        color: isSelected ? 'color.text.selected' : undefined
    }, data.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.optionDescriptionContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        color: "color.text.subtle",
        size: "small"
    }, data.description))));
};
const $324557b9f7ca6aa3$export$16b26cd5e98d9100 = (icon)=>{
    const localProps = {
        label: '',
        color: "var(--ds-icon-accent-gray, #758195)",
        LEGACY_size: 'medium',
        spacing: 'spacious'
    };
    switch(icon){
        case 'private':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bwyQI))), localProps);
        case 'limited':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fptva))), localProps);
        case 'open':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jHgVl))), localProps);
    }
};
const $324557b9f7ca6aa3$var$transformToSelectOption = (level)=>({
        label: level.displayName,
        value: level.value,
        iconName: level.iconName,
        description: level.description
    });
const $324557b9f7ca6aa3$export$be750a3a70b4f271 = ({ isLoading: isLoading, currentAccessLevel: currentAccessLevel, accessLevels: accessLevels, getProjectAccessLevels: getProjectAccessLevels })=>{
    (0, $5uXOq.useEffect)(()=>{
        getProjectAccessLevels(); // only used to fetch the project access levels when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!accessLevels && isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.skeleton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wbtX.Skeleton), {
        height: "20px"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($324557b9f7ca6aa3$var$ProjectAccessLevelSelect, {
        currentAccessLevel: currentAccessLevel,
        accessLevels: accessLevels,
        getProjectAccessLevels: getProjectAccessLevels
    });
};
const $324557b9f7ca6aa3$var$ProjectAccessLevelSelect = ({ currentAccessLevel: currentAccessLevel, accessLevels: accessLevels })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectContainerRef = (0, $5uXOq.useRef)(null);
    const selectOptions = (0, $5uXOq.useMemo)(()=>accessLevels?.map((level)=>$324557b9f7ca6aa3$var$transformToSelectOption(level)), [
        accessLevels
    ]);
    const defaultValue = (0, $5uXOq.useMemo)(()=>selectOptions?.find((option)=>option.value === currentAccessLevel?.value), [
        currentAccessLevel,
        selectOptions
    ]);
    const [currentValue, setCurrentValue] = (0, $5uXOq.useState)(defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        xcss: $324557b9f7ca6aa3$var$styles.field
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        name: $324557b9f7ca6aa3$var$FIELD_NAME,
        label: formatMessage($324557b9f7ca6aa3$var$messages.projectAccessLevelLabel),
        defaultValue: defaultValue
    }, ({ fieldProps: { onChange: onChange, ...fieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $joKkQ.default), {
            xcss: $324557b9f7ca6aa3$var$gridStyles.root
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $324557b9f7ca6aa3$var$styles.iconContainer,
            testId: "share-button.ui.project-access-level.box"
        }, $324557b9f7ca6aa3$export$16b26cd5e98d9100(currentValue?.iconName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $324557b9f7ca6aa3$var$styles.dropdownContainer,
            ref: selectContainerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            ...fieldProps,
            value: currentValue,
            options: selectOptions,
            onChange: (value)=>{
                if (!value) return;
                setCurrentValue(value);
                onChange(value);
            },
            isSearchable: false,
            menuPortalTarget: globalThis.document.body,
            components: {
                Control: $324557b9f7ca6aa3$var$SelectControl,
                Option: $324557b9f7ca6aa3$var$SelectOption
            },
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999,
                        width: selectContainerRef.current?.offsetWidth
                    }),
                dropdownIndicator: (base)=>({
                        ...base,
                        padding: 0,
                        marginLeft: "var(--ds-space-negative-075, -6px)"
                    })
            },
            menuPosition: "fixed",
            spacing: "compact"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            xcss: $324557b9f7ca6aa3$var$styles.descriptionContainer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            color: "color.text.subtle",
            size: "small"
        }, currentValue?.description)))));
};

});
parcelRegister("joKkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $975a473d4552aaa0$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $975a473d4552aaa0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $975a473d4552aaa0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $975a473d4552aaa0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $975a473d4552aaa0$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $975a473d4552aaa0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $975a473d4552aaa0$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $975a473d4552aaa0$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $975a473d4552aaa0$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $bwpsq.default)([
            $975a473d4552aaa0$var$baseStyles.root,
            gap && $975a473d4552aaa0$var$columnGapMap[gap],
            columnGap && $975a473d4552aaa0$var$columnGapMap[columnGap],
            gap && $975a473d4552aaa0$var$rowGapMap[gap],
            rowGap && $975a473d4552aaa0$var$rowGapMap[rowGap],
            alignItems && $975a473d4552aaa0$var$alignItemsMap[alignItems],
            alignContent && $975a473d4552aaa0$var$alignContentMap[alignContent],
            justifyContent && $975a473d4552aaa0$var$justifyContentMap[justifyContent],
            autoFlow && $975a473d4552aaa0$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$975a473d4552aaa0$var$Grid.displayName = 'Grid';
var $975a473d4552aaa0$export$2e2bcd8739ae039 = $975a473d4552aaa0$var$Grid;

});

parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("jHgVl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::25e57ba6be3183cfa1e359a1a5374e32>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e56f2934baaafa03$var$_react = $e56f2934baaafa03$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e56f2934baaafa03$var$_baseNew = $e56f2934baaafa03$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e56f2934baaafa03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockUnlocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: unlocked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e56f2934baaafa03$var$LockUnlockedIcon = (props)=>/*#__PURE__*/ $e56f2934baaafa03$var$_react.default.createElement($e56f2934baaafa03$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3H12a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2V4a4 4 0 1 1 8 0h-1.5A2.5 2.5 0 0 0 8 1.5m-4 7a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$e56f2934baaafa03$var$LockUnlockedIcon.displayName = 'LockUnlockedIcon';
var $e56f2934baaafa03$var$_default = module.exports.default = $e56f2934baaafa03$var$LockUnlockedIcon;

});

parcelRegister("1wbtX", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $39c21c8edc6f2616$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "SkeletonCompiled", () => $39c21c8edc6f2616$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $39c21c8edc6f2616$export$e477bb7d17087f28);
$parcel$export(module.exports, "Skeleton", () => $39c21c8edc6f2616$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $39c21c8edc6f2616$export$d7a54cba636a8cd6);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");
const $39c21c8edc6f2616$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $47bDC.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $39c21c8edc6f2616$var$shimmer = $39c21c8edc6f2616$export$b2b5e866b2fbf2ec();
const $39c21c8edc6f2616$export$1d2144641222f3bd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $39c21c8edc6f2616$var$shimmer,
        animationTimingFunction: 'linear',
        backgroundColor: "var(--ds-skeleton, #091E420F)",
        backgroundImage: `linear-gradient( to right, ${"var(--ds-skeleton, #091E420F)"} 10%, ${"var(--ds-skeleton-subtle, #091E4208)"} 30%, ${"var(--ds-skeleton, #091E420F)"} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $39c21c8edc6f2616$export$b1deee0d21f1be36 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $39c21c8edc6f2616$export$dc84d515085190e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height),
            "--_1gljcou": (0, $lD23V.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkn82g _1itk1kpv _12vemgnk _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $39c21c8edc6f2616$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});
const $39c21c8edc6f2616$export$8f31e4c4a37b8e9c = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('enghealth-4756-migrate-complex-styled-component'), $39c21c8edc6f2616$export$dc84d515085190e, $39c21c8edc6f2616$export$1d2144641222f3bd);
const $39c21c8edc6f2616$export$d7a54cba636a8cd6 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('enghealth-4756-migrate-complex-styled-component'), $39c21c8edc6f2616$export$e477bb7d17087f28, $39c21c8edc6f2616$export$b1deee0d21f1be36);

});



parcelRegister("8BVfN", function(module, exports) {

$parcel$export(module.exports, "shareButtonEntryPoint", () => $735d063ad5974451$export$ad8b1559c594245d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $735d063ad5974451$export$ad8b1559c594245d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("1qTOc"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "50ae946e",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("1qTOc", function(module, exports) {

let $10b38293cb9c1f72$var$load = (parcelRequire("28QjX"))(4);
module.exports = $10b38293cb9c1f72$var$load("lMH7t").then(()=>parcelRequire('8kufr'));

});



parcelRegister("bcD3e", function(module, exports) {

$parcel$export(module.exports, "INTEGRATION_TYPES", () => $b057f09e7b03d4c8$export$195813ac8b6ae6f9);
const $b057f09e7b03d4c8$export$195813ac8b6ae6f9 = {
    FILTER: 'filter',
    SEARCH: 'search'
};

});

parcelRegister("i5w7k", function(module, exports) {

$parcel$export(module.exports, "shareSearchClientConfig", () => $b84dbc261bc35c80$export$14295897acb58714);

var $bcD3e = parcelRequire("bcD3e");
const $b84dbc261bc35c80$export$14295897acb58714 = {
    getShareEndpoint: ({ link: link, type: type })=>type === (0, $bcD3e.INTEGRATION_TYPES).FILTER ? `/rest/share/1.0/filter/${new URL(link).searchParams.get('filter') || ''}` : '/rest/share/1.0/search',
    getSharePayload: ({ link: link, type: type })=>{
        const jql = new URL(link).searchParams.get('jql');
        return type === (0, $bcD3e.INTEGRATION_TYPES).SEARCH && jql !== null ? {
            jql: jql
        } : {};
    }
};

});

parcelRegister("68QXU", function(module, exports) {

$parcel$export(module.exports, "getShareSubProductId", () => $a1c93c3f1c8e701d$export$4a20278dd1d015dd);
const $a1c93c3f1c8e701d$var$subProductMap = {
    addon: 'jira-addon',
    core: 'jira-core',
    polaris: 'jira-polaris',
    portfolio: 'jira-portfolio',
    serviceDesk: 'jira-servicedesk',
    software: 'jira-software',
    platform: 'jira-platform',
    unknown: 'jira-unknown'
};
const $a1c93c3f1c8e701d$export$4a20278dd1d015dd = (subProduct)=>subProduct && $a1c93c3f1c8e701d$var$subProductMap[subProduct] || 'jira-platform';

});

parcelRegister("lYorD", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7d14c0e250c5cb9b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7d14c0e250c5cb9b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    dialogTitleFilter: {
        "id": "issue-navigator-action-share-button.dialog-title-filter",
        "defaultMessage": "Share current filter"
    },
    dialogTitleSearch: {
        "id": "issue-navigator-action-share-button.dialog-title-search",
        "defaultMessage": "Share search criteria"
    },
    filter: {
        "id": "issue-navigator-action-share-button.filter",
        "defaultMessage": "Filter"
    },
    search: {
        "id": "issue-navigator-action-share-button.search",
        "defaultMessage": "Search"
    },
    share: {
        "id": "issue-navigator-action-share-button.share",
        "defaultMessage": "Share"
    },
    shareKeyboardShortcut: {
        "id": "issue-navigator-action-share-button.share-keyboard-shortcut",
        "defaultMessage": "Open share modal"
    }
});

});


parcelRegister("78lPv", function(module, exports) {

$parcel$export(module.exports, "FilterIconButton", () => $45fbe6ec97131edd$export$2c752f0ff253a7e6);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $45fbe6ec97131edd$export$2c752f0ff253a7e6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isSelected: isSelected, onClick: onClick, testId: testId, isDisabled: isDisabled, icon: icon, label: label, customTriggerProps: customTriggerProps }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $45fbe6ec97131edd$var$iconButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        isSelected: isSelected,
        onClick: onClick,
        ref: ref,
        testId: testId,
        isDisabled: isDisabled,
        icon: icon,
        label: label,
        ...customTriggerProps
    })));
const $45fbe6ec97131edd$var$iconButtonWrapperStyles = (0, $8CUq3.xcss)({
    position: 'relative'
});

});

parcelRegister("lml1M", function(module, exports) {

$parcel$export(module.exports, "default", () => $600f1e70c70bcfbe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $aZ5rg = parcelRequire("aZ5rg");

var $edfne = parcelRequire("edfne");

var $1A6di = parcelRequire("1A6di");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $7Uevx = parcelRequire("7Uevx");

var $3bDjY = parcelRequire("3bDjY");

var $3Tty1 = parcelRequire("3Tty1");

var $6s1PB = parcelRequire("6s1PB");

var $aWse0 = parcelRequire("aWse0");

var $9Nvh7 = parcelRequire("9Nvh7");

var $5Czte = parcelRequire("5Czte");

var $761Hb = parcelRequire("761Hb");

var $qLuSt = parcelRequire("qLuSt");

var $2jDmD = parcelRequire("2jDmD");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $g5X3G = parcelRequire("g5X3G");

var $1aUn4 = parcelRequire("1aUn4");

var $dCm1o = parcelRequire("dCm1o");

var $6UAdF = parcelRequire("6UAdF");

var $eJ0Zs = parcelRequire("eJ0Zs");

var $a8lIB = parcelRequire("a8lIB");

var $7OTah = parcelRequire("7OTah");

var $ih9zY = parcelRequire("ih9zY");

var $71kvA = parcelRequire("71kvA");
const $600f1e70c70bcfbe$var$KeyboardShortcuts = ({ view: view, onToggle: onToggle, intl: { formatMessage: formatMessage } })=>{
    const isDetailView = view === (0, $6UAdF.views).detail;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: {
            t: {
                callback: ()=>{
                    const newView = isDetailView ? (0, $6UAdF.views).list : (0, $6UAdF.views).detail;
                    onToggle(newView, true);
                },
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage(isDetailView ? (0, $71kvA.default).listText : (0, $71kvA.default).detailText))
            }
        }
    });
};
const $600f1e70c70bcfbe$export$c774a1845e27fedc = ({ view: view, onToggle: onToggle, intl: intl })=>{
    const { formatMessage: formatMessage } = intl;
    const testIdPrefix = 'issue-navigator.ui.refinement-bar.view-switcher.toggle-button.';
    let listLabel = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($600f1e70c70bcfbe$var$IconLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            size: "UNSAFE_small",
            weight: "semibold"
        }, formatMessage((0, $71kvA.default).listOptionLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ5rg))), {
            label: "",
            LEGACY_size: "small"
        })), [
        formatMessage
    ]);
    let detailLabel = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($600f1e70c70bcfbe$var$IconLabel, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            as: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            size: "UNSAFE_small",
            weight: "semibold"
        }, formatMessage((0, $71kvA.default).detailOptionLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($edfne))), {
            label: "",
            LEGACY_size: "small"
        })), [
        formatMessage
    ]);
    if ((0, $3HwlS.getWillShowNav4)()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        listLabel = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                size: "UNSAFE_small",
                weight: "semibold"
            }, formatMessage((0, $71kvA.default).listOptionLabel)), [
            formatMessage
        ]); // eslint-disable-next-line react-hooks/rules-of-hooks
        detailLabel = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                size: "UNSAFE_small",
                weight: "semibold"
            }, formatMessage((0, $71kvA.default).detailOptionLabel)), [
            formatMessage
        ]);
    }
    if ((0, $dCm1o.isVisualRefreshEnabled)()) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        listLabel = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $71kvA.default).listOptionLabel)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
                paddingInline: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7Uevx))), {
                label: formatMessage((0, $71kvA.default).listOptionLabel)
            }))), [
            formatMessage
        ]); // eslint-disable-next-line react-hooks/rules-of-hooks
        detailLabel = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: formatMessage((0, $71kvA.default).detailOptionLabel)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
                paddingInline: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1A6di))), {
                label: formatMessage((0, $71kvA.default).detailOptionLabel)
            }))), [
            formatMessage
        ]);
    }
    const options = (0, $5uXOq.useMemo)(()=>[
            {
                id: (0, $6UAdF.views).list,
                label: listLabel,
                testId: `${testIdPrefix}${(0, $6UAdF.views).list}`
            },
            {
                id: (0, $6UAdF.views).detail,
                label: detailLabel,
                testId: `${testIdPrefix}${(0, $6UAdF.views).detail}`
            }
        ], [
        listLabel,
        detailLabel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($600f1e70c70bcfbe$var$KeyboardShortcuts, {
        view: view,
        onToggle: onToggle,
        intl: intl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1aUn4.default), {
        label: formatMessage((0, $71kvA.default).toggleButtonsLabel),
        isCompact: (0, $dCm1o.isVisualRefreshEnabled)(),
        options: options,
        selectedOption: view,
        onChange: (newView)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onToggle(newView, false);
        }
    }));
};
$600f1e70c70bcfbe$export$c774a1845e27fedc.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $600f1e70c70bcfbe$export$3f624639bbe23442 = ({ filterId: filterId })=>{
    (0, $a8lIB.markOnce)((0, $a8lIB.marks).PAGE_ACTIONS_VIEW_SWITCHER_START);
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $a8lIB.markOnce)((0, $a8lIB.marks).PAGE_ACTIONS_VIEW_SWITCHER_END);
    }, []);
    const selectedIssueKey = (0, $7OTah.useSelectedIssueKey)();
    const [{ view: view }, { setView: setView }] = (0, $ih9zY.useSelectedViewState)();
    const intl = (0, $aWse0.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnToggle = (0, $5uXOq.useCallback)((newView, isKeyboardShortcut)=>{
        // When toggling to detail view we want to update the issue key in the URL to match the currently selected
        // issue. When toggling to list view we want to discard the issue key from the URL.
        const newIssueKey = newView === (0, $6UAdF.views).detail ? selectedIssueKey : (0, $g5X3G.toIssueKey)('');
        let resolvedNewView = (0, $eJ0Zs.convertToIssueNavigatorId)(newView);
        if (newView === (0, $6UAdF.views).list && filterId && (0, $9Nvh7.isCustomFilter)(filterId)) resolvedNewView = (0, $eJ0Zs.convertFilterIdToIssueNavigatorId)(filterId);
        setView(resolvedNewView, newIssueKey);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'switchIssueNavigatorView', {
            keyboardShortcut: isKeyboardShortcut,
            switchToView: newView
        });
        return true;
    }, [
        selectedIssueKey,
        filterId,
        setView,
        createAnalyticsEvent
    ]);
    const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Czte.NinChangeboardingTourTarget), {
        engagementId: "nin.view-switcher"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($600f1e70c70bcfbe$export$c774a1845e27fedc, {
        view: (0, $eJ0Zs.convertToView)(view),
        onToggle: handleOnToggle,
        intl: intl
    }));
    const renderSpotlightCard = ({ onEndTour: onEndTour, onSetActiveCard: onSetActiveCard })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qLuSt.default), {
            cardKey: (0, $761Hb.cardKeys).GLOBAL_SCOPE_VIEW_SWITCHER,
            dialogWidth: 272,
            dialogPlacement: "bottom right",
            actions: view === 'detail' ? [
                {
                    onClick: ()=>{
                        onEndTour();
                    },
                    text: intl.formatMessage((0, $71kvA.default).done)
                }
            ] : [
                {
                    onClick: ()=>{
                        onSetActiveCard((0, $761Hb.cardKeys).GLOBAL_SCOPE_COLUMN_PICKER);
                    },
                    text: intl.formatMessage((0, $71kvA.default).next)
                },
                {
                    appearance: 'subtle',
                    onClick: ()=>{
                        onEndTour();
                    },
                    text: intl.formatMessage((0, $71kvA.default).skip)
                }
            ],
            heading: intl.formatMessage((0, $71kvA.default).tourHeading),
            target: "nin.spotlight.view-switcher",
            targetBgColor: "var(--ds-surface, #FFFFFF)",
            targetRadius: 3,
            messageId: "issue-navigator.ui.view-switcher.spotlight-tour-card.nin.spotlight.view-switcher.spotlight",
            messageType: "transactional"
        }, intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $71kvA.default).tourBodyIssueTermRefresh : (0, $71kvA.default).tourBody));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2jDmD.default), {
        name: "nin.spotlight.view-switcher",
        renderSpotlightCard: renderSpotlightCard
    }, children);
};
var $600f1e70c70bcfbe$export$2e2bcd8739ae039 // clean up this styled element with getWillShowNav4
 = $600f1e70c70bcfbe$export$3f624639bbe23442;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $600f1e70c70bcfbe$var$IconLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_zulp1b66" : "_10cu1b66 _2t30idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("edfne", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8fa35c2d859c6465bf7d8e74ec194e5c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a58e347f57c8d6a8$var$_react = $a58e347f57c8d6a8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a58e347f57c8d6a8$var$_panelRight = $a58e347f57c8d6a8$var$_interopRequireDefault((parcelRequire("dMdCP")));

var $a58e347f57c8d6a8$var$_detailView = $a58e347f57c8d6a8$var$_interopRequireDefault((parcelRequire("jmEdU")));
function $a58e347f57c8d6a8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PanelRightIcon.
 * This component is PanelRightIcon, with `UNSAFE_fallbackIcon` set to "DetailViewIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a58e347f57c8d6a8$var$PanelRightIcon = (props)=>/*#__PURE__*/ $a58e347f57c8d6a8$var$_react.default.createElement($a58e347f57c8d6a8$var$_panelRight.default, Object.assign({
        LEGACY_fallbackIcon: $a58e347f57c8d6a8$var$_detailView.default
    }, props));
$a58e347f57c8d6a8$var$PanelRightIcon.Name = 'PanelRightIconMigration';
var $a58e347f57c8d6a8$var$_default = module.exports.default = $a58e347f57c8d6a8$var$PanelRightIcon;

});
parcelRegister("dMdCP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8b10c2aaa76d32294bc7ed1c0a1888df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a07a53bd6f7665b8$var$_react = $a07a53bd6f7665b8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a07a53bd6f7665b8$var$_baseNew = $a07a53bd6f7665b8$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a07a53bd6f7665b8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PanelRight".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for opening a preview panel to the right of the viewport edge. Use only for left-to-right languages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a07a53bd6f7665b8$var$PanelRightIcon = (props)=>/*#__PURE__*/ $a07a53bd6f7665b8$var$_react.default.createElement($a07a53bd6f7665b8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 3a.5.5 0 0 0-.5-.5H9.5v11H14a.5.5 0 0 0 .5-.5zM13 10v1.5h-2V10zm0-3v1.5h-2V7zm0-3v1.5h-2V4zM1.5 13a.5.5 0 0 0 .5.5h6v-11H2a.5.5 0 0 0-.5.5zM16 13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2z"/>`
    }, props));
$a07a53bd6f7665b8$var$PanelRightIcon.displayName = 'PanelRightIcon';
var $a07a53bd6f7665b8$var$_default = module.exports.default = $a07a53bd6f7665b8$var$PanelRightIcon;

});

parcelRegister("jmEdU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e18f45ea4410736a$var$_react = $e18f45ea4410736a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e18f45ea4410736a$var$_panelRight = $e18f45ea4410736a$var$_interopRequireDefault((parcelRequire("dMdCP")));
function $e18f45ea4410736a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e18f45ea4410736a$var$DetailViewIcon = (props)=>/*#__PURE__*/ $e18f45ea4410736a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14 17h6V7.01C20 7 14 7 14 7zM12 5h8c1.11 0 2 .9 2 2.01V17a2 2 0 0 1-2 2h-8zM2 7h8V5H3a1 1 0 0 0-1 1zm0 4h8V9H2zm0 7c0 .55.45 1 1 1h7v-2H2zm0-3h8v-2H2z"/></svg>`
    }, props, {
        newIcon: $e18f45ea4410736a$var$_panelRight.default
    }));
$e18f45ea4410736a$var$DetailViewIcon.displayName = 'DetailViewIcon';
var $e18f45ea4410736a$var$_default = module.exports.default = $e18f45ea4410736a$var$DetailViewIcon;

});


parcelRegister("1A6di", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fe9a089e1f04f18f538500f4f4d79587>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $126df91b70991685$var$_react = $126df91b70991685$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $126df91b70991685$var$_baseNew = $126df91b70991685$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $126df91b70991685$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LayoutTwoColumnsSidebarLeft".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for 2 column layout with left sidebar option in Confluence Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $126df91b70991685$var$LayoutTwoColumnsSidebarLeftIcon = (props)=>/*#__PURE__*/ $126df91b70991685$var$_react.default.createElement($126df91b70991685$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 2.375C16 1.615 15.384 1 14.625 1h-7.75C6.115 1 5.5 1.616 5.5 2.375v11.25c0 .76.616 1.375 1.375 1.375h7.75c.76 0 1.375-.616 1.375-1.375zm-1.5.125v11H7v-11zM4 2.375C4 1.615 3.384 1 2.625 1h-1.25C.615 1 0 1.616 0 2.375v11.25C0 14.385.616 15 1.375 15h1.25C3.385 15 4 14.384 4 13.625zM2.5 2.5v11h-1v-11z" clip-rule="evenodd"/>`
    }, props));
$126df91b70991685$var$LayoutTwoColumnsSidebarLeftIcon.displayName = 'LayoutTwoColumnsSidebarLeftIcon';
var $126df91b70991685$var$_default = module.exports.default = $126df91b70991685$var$LayoutTwoColumnsSidebarLeftIcon;

});

parcelRegister("7Uevx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1fd96c5b3b13ee02dc5743b09d638d98>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c1904502a6c690c$var$_react = $5c1904502a6c690c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5c1904502a6c690c$var$_baseNew = $5c1904502a6c690c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $5c1904502a6c690c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spreadsheet".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for spreadsheets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c1904502a6c690c$var$SpreadsheetIcon = (props)=>/*#__PURE__*/ $5c1904502a6c690c$var$_react.default.createElement($5c1904502a6c690c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v3.25H5V3.5zm4.5 0v3.75h8V4a.5.5 0 0 0-.5-.5zm8 5.25h-8v3.75H14a.5.5 0 0 0 .5-.5zM5 12.5V8.75H1.5V12a.5.5 0 0 0 .5.5z" clip-rule="evenodd"/>`
    }, props));
$5c1904502a6c690c$var$SpreadsheetIcon.displayName = 'SpreadsheetIcon';
var $5c1904502a6c690c$var$_default = module.exports.default = $5c1904502a6c690c$var$SpreadsheetIcon;

});

parcelRegister("761Hb", function(module, exports) {

$parcel$export(module.exports, "cardKeys", () => $d137429970660ed4$export$79399c5778983d77);
/**
 * Collection of keys representing individual spotlight cards displayed within the issue navigator.
 */ const $d137429970660ed4$export$79399c5778983d77 = {
    GLOBAL_SCOPE_JQL_BUILDER_NL_TO_JQL: 'global-scope.jql-builder-with-ai.natural-language-to-jql',
    GLOBAL_SCOPE_VIEW_SWITCHER: 'global-scope.view-switcher',
    GLOBAL_SCOPE_COLUMN_PICKER: 'global-scope.column-picker',
    JQL_BUILDER_NL_TOGGLE: 'jql-builder-with-ai.natural-language-toggle',
    JQL_BUILDER_NL_TO_JQL: 'jql-builder-with-ai.natural-language-to-jql'
};

});

parcelRegister("qLuSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea5d5d108c2f1c20$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ea5d5d108c2f1c20$var$SpotlightTourCardAsync = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("8S2uL")), {
    ssr: false,
    moduleId: "./src/packages/issue-navigator/changeboarding/src/ui/spotlight-tour-card/main.tsx"
});
const $ea5d5d108c2f1c20$var$SpotlightTourCard = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraIssueNavigatorChangeboarding",
        id: "async-issue-navigator-changeboarding-spotlight-tour-card",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-issue-navigator-changeboarding-spotlight-tour-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ea5d5d108c2f1c20$var$SpotlightTourCardAsync, props)));
var $ea5d5d108c2f1c20$export$2e2bcd8739ae039 = $ea5d5d108c2f1c20$var$SpotlightTourCard;

});
parcelRegister("8S2uL", function(module, exports) {

let $67554d5b6e1b17ce$var$load = (parcelRequire("28QjX"))(4);
module.exports = $67554d5b6e1b17ce$var$load("gJYWW").then(()=>parcelRequire('4CMeD'));

});


parcelRegister("2jDmD", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e9c17dad5a296c3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $8QPci = parcelRequire("8QPci");
/**
 *
 * Renders a spotlight target and associated spotlight card.
 */ const $2e9c17dad5a296c3$var$SpotlightTourTarget = ({ children: children, name: name, renderSpotlightCard: renderSpotlightCard })=>{
    const { onEndTour: onEndTour, onSetActiveCard: onSetActiveCard } = (0, $8QPci.useSpotlightCoordinationActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: name
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, typeof renderSpotlightCard === 'function' ? renderSpotlightCard({
        onEndTour: onEndTour,
        onSetActiveCard: onSetActiveCard
    }) : renderSpotlightCard));
};
var $2e9c17dad5a296c3$export$2e2bcd8739ae039 = $2e9c17dad5a296c3$var$SpotlightTourTarget;

});
parcelRegister("8QPci", function(module, exports) {

$parcel$export(module.exports, "useIsActiveSpotlightCard", () => $1bf3a4be42170bcd$export$ac706a6842f43035);
$parcel$export(module.exports, "useSpotlightCoordinationActions", () => $1bf3a4be42170bcd$export$d0297e733168e478);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

const $1bf3a4be42170bcd$var$initialState = {
    cardKey: null,
    onStopCoordination: null
};
const $1bf3a4be42170bcd$var$actions = {
    onSetActiveCard: (cardKey, stop)=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            setState({
                cardKey: cardKey,
                onStopCoordination: stop ?? onStopCoordination
            });
        },
    onEndTour: ()=>({ getState: getState, setState: setState })=>{
            const { onStopCoordination: onStopCoordination } = getState();
            onStopCoordination && onStopCoordination();
            setState({
                cardKey: null,
                onStopCoordination: null
            });
        }
};
const $1bf3a4be42170bcd$var$Store = (0, $iXqE5.createStore)({
    initialState: $1bf3a4be42170bcd$var$initialState,
    actions: $1bf3a4be42170bcd$var$actions
});
const $1bf3a4be42170bcd$export$ac706a6842f43035 = (0, $3sQ5x.createHook)($1bf3a4be42170bcd$var$Store, {
    selector: (state, cardKeys)=>Array.isArray(cardKeys) ? state.cardKey !== null && cardKeys.includes(state.cardKey) : state.cardKey === cardKeys
});
const $1bf3a4be42170bcd$export$d0297e733168e478 = (0, $3sQ5x.createActionsHook)($1bf3a4be42170bcd$var$Store);

});


parcelRegister("1aUn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3938a8ce9ce3c5ba$export$2e2bcd8739ae039);

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $6maaD = parcelRequire("6maaD");

var $1AOfx = parcelRequire("1AOfx");
var $3938a8ce9ce3c5ba$export$2e2bcd8739ae039 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), (0, $6maaD.ToggleButtons), (0, $1AOfx.default));

});
parcelRegister("6maaD", function(module, exports) {

$parcel$export(module.exports, "ToggleButtons", () => $5bbd957d88c15d3d$export$34301fadafd0cd9d);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");
const $5bbd957d88c15d3d$export$34301fadafd0cd9d = ({ options: options, selectedOption: selectedOption, onChange: onChange, label: label, isCompact: isCompact, expDesignRefresh: expDesignRefresh })=>{
    const getButtonWithContext = (0, $5uXOq.useCallback)(({ option: option, isSelected: isSelected })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5ILhZ.default), {
            role: "radio",
            "aria-checked": isSelected,
            xcss: [
                expDesignRefresh ? $5bbd957d88c15d3d$var$baseStylesDesignRefresh : $5bbd957d88c15d3d$var$baseStyles,
                !isCompact && (expDesignRefresh ? $5bbd957d88c15d3d$var$wideStylesDesignRefresh : $5bbd957d88c15d3d$var$wideStyles),
                isSelected && (expDesignRefresh ? $5bbd957d88c15d3d$var$selectedStylesDesignRefresh : $5bbd957d88c15d3d$var$selectedStyles)
            ],
            onClick: (event, analyticsEvent)=>!isSelected && onChange(option.id, event, analyticsEvent),
            isDisabled: option.isDisabled,
            testId: option.testId,
            interactionName: option.interactionName,
            children: option.label
        }, option.id), [
        onChange,
        isCompact,
        expDesignRefresh
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        role: "radiogroup",
        xcss: expDesignRefresh ? $5bbd957d88c15d3d$var$containerStylesDesignRefresh : $5bbd957d88c15d3d$var$containerStyles,
        "aria-label": label,
        as: "fieldset",
        children: options.map((option)=>getButtonWithContext({
                option: option,
                isSelected: option.id === selectedOption
            }))
    });
};
const $5bbd957d88c15d3d$var$containerStyles = (0, $8CUq3.xcss)({
    borderColor: 'color.border',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: "var(--ds-border-radius-100, 4px)",
    paddingInline: 'space.025',
    gap: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    height: '2rem'
});
const $5bbd957d88c15d3d$var$containerStylesDesignRefresh = (0, $8CUq3.xcss)({
    borderColor: 'color.border',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: "var(--ds-border-radius-100, 6px)",
    padding: 'space.050',
    gap: 'space.025',
    display: 'inline-flex',
    alignItems: 'center',
    height: '2rem'
});
const $5bbd957d88c15d3d$var$baseStyles = (0, $8CUq3.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    border: '1px solid transparent',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    color: 'color.text.subtle',
    height: '26px',
    fontWeight: 'font.weight.medium',
    padding: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    },
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':disabled': {
        background: "var(--ds-background-disabled, #091E4208)",
        color: 'color.text.disabled'
    }
});
const $5bbd957d88c15d3d$var$baseStylesDesignRefresh = (0, $8CUq3.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    border: '1px solid transparent',
    borderRadius: "var(--ds-border-radius-050, 3px)",
    color: 'color.text.subtle',
    height: '24px',
    fontWeight: 'font.weight.medium',
    padding: 'space.0',
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    },
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':disabled': {
        background: "var(--ds-background-disabled, #091E4208)",
        color: 'color.text.disabled'
    }
});
const $5bbd957d88c15d3d$var$selectedStyles = (0, $8CUq3.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    border: `1px solid ${"var(--ds-border-selected, #0C66E4)"}`,
    color: 'color.text.selected',
    cursor: 'default',
    ':hover': {
        background: "var(--ds-background-selected, #E9F2FF)",
        color: 'color.text.selected'
    }
});
const $5bbd957d88c15d3d$var$selectedStylesDesignRefresh = (0, $8CUq3.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: 'color.text.selected',
    cursor: 'default',
    ':hover': {
        background: "var(--ds-background-selected, #E9F2FF)",
        color: 'color.text.selected'
    }
});
const $5bbd957d88c15d3d$var$wideStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.150',
    paddingRight: 'space.150'
});
const $5bbd957d88c15d3d$var$wideStylesDesignRefresh = (0, $8CUq3.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.100'
});

});

parcelRegister("1AOfx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3d0d9bc4668d1db$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $gwIPs = parcelRequire("gwIPs");

var $iR4uK = parcelRequire("iR4uK");

var $gmQXa = parcelRequire("gmQXa");
let $b3d0d9bc4668d1db$var$uniqueId = 0;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b3d0d9bc4668d1db$export$2e2bcd8739ae039 = ({ label: label, options: options, selectedOption: selectedOption, onChange: onChange })=>{
    (0, $gmQXa.assertPrecondition)(()=>({
            precondition: options.length > 0,
            message: `ToggleButtons requires at least one option, but received ${options.length}`
        }));
    (0, $gmQXa.assertPrecondition)(()=>({
            precondition: (0, $gmQXa.findDuplicateIds)(options) === null,
            message: `ToggleButtons requires that every option has a unique ID, but received "${(0, $gmQXa.findDuplicateIds)(options)}" multiple times`
        }));
    (0, $gmQXa.assertPrecondition)(()=>({
            precondition: options.findIndex((option)=>option.id === selectedOption) !== -1,
            message: `ToggleButtons requires that the selectedOption matches the ID of one of the passed options, but "${selectedOption}" did not`
        }));
    const [id] = (0, $5uXOq.useState)(()=>`toggle-buttons-${$b3d0d9bc4668d1db$var$uniqueId++}`);
    const fieldsetRef = (0, $5uXOq.useRef)(null);
    const selectedOptionRef = (0, $5uXOq.useRef)();
    const [selectedOptionPosition, setSelectedOptionPosition] = (0, $5uXOq.useState)();
    (0, $5uXOq.useEffect)(()=>{
        const fieldset = fieldsetRef.current;
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function, jira/jira-ssr/no-unchecked-globals-usage
        if (!fieldset || !window.ResizeObserver) return ()=>{};
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resizeObserver = new window.ResizeObserver(()=>{
            const element = selectedOptionRef.current;
            if (element) setSelectedOptionPosition({
                left: element.offsetLeft,
                top: element.offsetTop,
                width: element.offsetWidth,
                height: element.offsetHeight
            });
        });
        resizeObserver.observe(fieldset);
        return ()=>{
            resizeObserver.unobserve(fieldset);
        };
    }, [
        selectedOption
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3d0d9bc4668d1db$var$Fieldset, {
        ref: fieldsetRef,
        selectedOptionPosition: selectedOptionPosition
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", null, label), options.map((option)=>{
        const isChecked = selectedOption === option.id;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iR4uK.default), {
            key: option.id,
            name: id,
            value: option.id,
            isChecked: isChecked,
            isDisabled: !!option.isDisabled,
            onChange: onChange,
            // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown> | undefined' is not assignable to type 'Ref<OptionProps> | undefined'.
            ref: isChecked ? selectedOptionRef : undefined,
            testId: option.testId
        }, option.label);
    }));
};
// The !important rules are required so that we can use this mixin on selectors
// with arbitrary specificity
const $b3d0d9bc4668d1db$var$selectedOptionIndicator = {
    backgroundColor: `${"var(--ds-background-accent-gray-subtler, #DCDFE4)"} !important`,
    borderRadius: `${(0, $gwIPs.borderRadius)}px !important`
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3d0d9bc4668d1db$var$Fieldset = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "fieldset", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { selectedOptionPosition: selectedOptionPosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ozn9do": (0, $lD23V.default)(__cmplp.selectedOptionPosition?.left, "px"),
            "--_1ibdxcf": (0, $lD23V.default)(__cmplp.selectedOptionPosition?.top, "px"),
            "--_1ggrzjo": (0, $lD23V.default)(__cmplp.selectedOptionPosition?.width, "px"),
            "--_1797z6d": (0, $lD23V.default)(__cmplp.selectedOptionPosition?.height, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11c8dcr7 _1e0c1txw _1n261g80 _1bsb1ris _p12f1osq _kqswh2mm _bfhkm7j4 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _k48p1pd9 _1p1dangw _syaz1fxt _1qiiidpf _12o6idpf _19mbidpf _1ob8idpf _1e1midpf _p8t715vq _b4u715vq _1se6t94y _soiet94y _1jhnstnw _1r9t7mnp _kj6f1q9c _10bvh2mm _1nvfze3t _1nei1b66 _rt2pze3t _bmksze3t _fhioidpf _1kt9b3bt _1cs8stnw _rfx31wa3 _1rusksj1 _qs2z1l1k _1cg61yx9 _mlfedkwg",
            __cmplp.selectedOptionPosition ? "_cfu11ule" : "_cfu1glyw",
            __cmplp.selectedOptionPosition?.left ? "_qnecejz7" : "_qnecidpf",
            __cmplp.selectedOptionPosition?.top ? "_1auk1nuc" : "_1aukidpf",
            __cmplp.selectedOptionPosition?.width ? "_1mp412nj" : "_1mp4idpf",
            __cmplp.selectedOptionPosition?.height ? "_kfgt1d85" : "_kfgtidpf",
            !__cmplp.selectedOptionPosition && "_1ph31wa3 _15e9ksj1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iR4uK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e56adc76929ce8ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
var $e56adc76929ce8ab$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ name: name, value: value, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, children: children, testId: testId }, ref)=>{
    const id = `${name}-${value}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e56adc76929ce8ab$var$Container, {
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        type: "radio",
        id: id,
        name: name,
        value: value,
        checked: isChecked,
        disabled: isDisabled,
        "data-testid": testId,
        onChange: (event)=>onChange(value, event)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: id
    }, children));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e56adc76929ce8ab$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v69yidpf _ogxmidpf _1qtqidpf _n9z4idpf _scffidpf _1yzy15vq _bgrh15vq _5hv9t94y _pytkt94y _khufstnw _11127mnp _1ru31q9c _1ioh1l7b _15pj1ule _d7ff1b66 _1j8612x7 _1qrc1b66 _4yng12x7 _1vzltlke _1hhy73ad _1emz73ad _1efl1lh4 _7el91vm4 _15pqglyw _vrjh166n _c2fy18uv _ynfu18uv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gmQXa", function(module, exports) {

$parcel$export(module.exports, "findDuplicateIds", () => $1d35542953a1be7d$export$e5f5e25214715ca1);
$parcel$export(module.exports, "assertPrecondition", () => $1d35542953a1be7d$export$5565eefbe4b468a0);
const $1d35542953a1be7d$export$e5f5e25214715ca1 = (options)=>{
    for(let i = 0; i < options.length - 1; ++i)for(let j = i + 1; j < options.length; ++j){
        if (options[i].id === options[j].id) return options[i].id;
    }
    return null;
};
const $1d35542953a1be7d$export$5565eefbe4b468a0 = (evaluatePrecondition)=>{};

});



parcelRegister("71kvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $270ebddc9dcee8b9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $270ebddc9dcee8b9$var$messages = (0, $7VHMR.defineMessages)({
    done: {
        "id": "issue-navigator.view-switcher.done",
        "defaultMessage": "Done"
    },
    next: {
        "id": "issue-navigator.view-switcher.next",
        "defaultMessage": "Next"
    },
    skip: {
        "id": "issue-navigator.view-switcher.skip",
        "defaultMessage": "Skip"
    },
    tourHeading: {
        "id": "issue-navigator.view-switcher.tour-heading",
        "defaultMessage": "View switcher"
    },
    tourBody: {
        "id": "issue-navigator.view-switcher.tour-body",
        "defaultMessage": "Switch between these two views to easily scan through a list or view the details of the issues."
    },
    detailText: {
        "id": "issue-navigator.refinement-bar.view-switcher.detail-text",
        "defaultMessage": "Switch to detail view"
    },
    listText: {
        "id": "issue-navigator.refinement-bar.view-switcher.list-text",
        "defaultMessage": "Switch to list view"
    },
    toggleButtonsLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.toggle-buttons-label",
        "defaultMessage": "Select view"
    },
    detailOptionLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.detail-option-label",
        "defaultMessage": "Detail view"
    },
    listOptionLabel: {
        "id": "issue-navigator.refinement-bar.view-switcher.list-option-label",
        "defaultMessage": "List view"
    },
    tourBodyIssueTermRefresh: {
        "id": "issue-navigator.view-switcher.tour-body-issue-term-refresh",
        "defaultMessage": "Switch between these two views to easily scan through a list or view the details of the work item."
    }
});
var $270ebddc9dcee8b9$export$2e2bcd8739ae039 = $270ebddc9dcee8b9$var$messages;

});


parcelRegister("5xvWJ", function(module, exports) {

$parcel$export(module.exports, "useNaturalLanguageMode", () => $95fabc3a48223559$export$617c50bbd595c5ac);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $95fabc3a48223559$var$initialState = {
    isNaturalLanguageMode: false
};
const $95fabc3a48223559$export$e324594224ef24da = {
    toggleNaturalLanguageMode: ()=>({ setState: setState, getState: getState })=>{
            setState({
                isNaturalLanguageMode: !getState().isNaturalLanguageMode
            });
        },
    exitNaturalLanguageMode: ()=>({ setState: setState })=>{
            setState({
                isNaturalLanguageMode: false
            });
        }
};
const $95fabc3a48223559$var$Store = (0, $iXqE5.createStore)({
    initialState: $95fabc3a48223559$var$initialState,
    actions: $95fabc3a48223559$export$e324594224ef24da
});
const $95fabc3a48223559$export$42a852a2b6b56249 = (0, $gg7kZ.createContainer)($95fabc3a48223559$var$Store, {
    onInit: ()=>({ setState: setState })=>{
            setState({
                isNaturalLanguageMode: false
            });
        }
});
const $95fabc3a48223559$var$getNaturalLanguageMode = (state)=>state.isNaturalLanguageMode;
const $95fabc3a48223559$export$617c50bbd595c5ac = (0, $3sQ5x.createHook)($95fabc3a48223559$var$Store, {
    selector: $95fabc3a48223559$var$getNaturalLanguageMode
});
const $95fabc3a48223559$export$d99c2d47e59edc60 = (0, $3sQ5x.createActionsHook)($95fabc3a48223559$var$Store);

});

parcelRegister("jeYA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4053e3f938b09fe1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $4053e3f938b09fe1$var$messages = (0, $7VHMR.defineMessages)({
    allIssues: {
        "id": "project-issue-navigator.page-actions.all-issues",
        "defaultMessage": "Go to all issues"
    },
    exportIssuesButtonIconLabel: {
        "id": "project-issue-navigator.page-actions.export-issues-button-icon-label",
        "defaultMessage": "Open export issues dropdown"
    },
    allIssuesIssueTermRefresh: {
        "id": "project-issue-navigator.page-actions.all-issues-issue-term-refresh",
        "defaultMessage": "Go to all work items"
    },
    exportIssuesButtonIconLabelIssueTermRefresh: {
        "id": "project-issue-navigator.page-actions.export-issues-button-icon-label-issue-term-refresh",
        "defaultMessage": "Open export work items dropdown"
    }
});
var $4053e3f938b09fe1$export$2e2bcd8739ae039 = $4053e3f938b09fe1$var$messages;

});



parcelRegister("c1eQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $62e26eb1f249aaa4$export$2e2bcd8739ae039);

var $kZqgk = parcelRequire("kZqgk");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $koVbs = parcelRequire("koVbs");

var $id7K0 = parcelRequire("id7K0");

var $4R6GH = parcelRequire("4R6GH");

var $7dvmO = parcelRequire("7dvmO");
const $62e26eb1f249aaa4$var$NavigatorDocumentTitle = ({ queryReference: queryReference })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const data = (0, $8Uumt.usePreloadedQuery)((0, $kZqgk.default), queryReference);
    const projectName = data?.jira?.jiraProjectByKey?.name ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7dvmO.default).windowTitleMigrationIssueTermRefresh : (0, $7dvmO.default).windowTitleMigration, {
            projectName: projectName
        })
    });
};
var $62e26eb1f249aaa4$export$2e2bcd8739ae039 = $62e26eb1f249aaa4$var$NavigatorDocumentTitle;

});
parcelRegister("7dvmO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dc1eec03f42231a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7dc1eec03f42231a$var$messages = (0, $7VHMR.defineMessages)({
    windowTitleMigrationIssueTermRefresh: {
        "id": "project-issue-navigator.window-title-migration-issue-term-refresh",
        "defaultMessage": "{projectName} - All work"
    },
    windowTitleMigration: {
        "id": "project-issue-navigator.window-title-migration",
        "defaultMessage": "{projectName} - Issues"
    }
});
var $7dc1eec03f42231a$export$2e2bcd8739ae039 = $7dc1eec03f42231a$var$messages;

});



parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});




const $135ded4f9a1460dc$export$dcd281f501ceae1a = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.pinned-fields';
const $135ded4f9a1460dc$export$2aca0ebce9a48d61 = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.visible-fields';
const $135ded4f9a1460dc$export$fc60a8d420264e7d = 'issue-view-layout-templates-views.ui.context.visible-hidden.ui.hidden-fields';
const $135ded4f9a1460dc$export$e1184c3be46bd7cb = false;
const $135ded4f9a1460dc$export$2028cf1423b28cf8 = 'global-spotlight-target-';
const $135ded4f9a1460dc$export$988f0f6f6457039a = 'status-and-approval-spotlight';

const $c5ab1cac32219280$export$87b07f66f76af007 = 1000;
const $c5ab1cac32219280$export$7cf28317477c9e48 = 'w';

const $13918fc81534c491$export$cb17e3c17bc50301 = 'Epic';
const $13918fc81534c491$export$d29cf9c8492f955d = 'Base';
const $13918fc81534c491$export$7fbc739f2667a35e = 'Subtask';

const $05ea8866f66e1e3c$export$37b67b9fa9f77199 = 'APPLINK_MISSING';
const $05ea8866f66e1e3c$export$d1fe0e8f550fe68d = 'APPLINK_REQ_AUTH';
const $05ea8866f66e1e3c$export$a6054426471fb4c4 = 'REMOTE_SERVER';
const $05ea8866f66e1e3c$export$cdf8a4853fe35e61 = 'REMOTE_LINK_MISSING';


//# sourceMappingURL=async-project-issue-navigator-entrypoint.f6e06a6f.js.map
